<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      viewBox="0 0 620 400"
      style="enable-background: new 0 0 620 400"
      xml:space="preserve"
    >
      <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  -->
      <defs>
        <filter
          id="drop-shadow-1"
          x="342.76"
          y="120.14"
          width="7.01"
          height="18.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-2"
          x="347.35"
          y="123.38"
          width="34.05"
          height="15.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur1" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur1" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-3"
          x="379.28"
          y="123.18"
          width="14.98"
          height="9.27"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur2" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-4"
          x="391.52"
          y="129.54"
          width="28.98"
          height="14.86"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur3" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur3" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-5"
          x="418.04"
          y="141.59"
          width="23.76"
          height="30.55"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur4" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur4" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-6"
          x="438.87"
          y="169.62"
          width="9.45"
          height="26.55"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur5" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur5" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-7"
          x="424.9"
          y="192.9"
          width="24.5"
          height="47.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur6" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur6" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-8"
          x="407.79"
          y="235.55"
          width="20.01"
          height="17.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur7" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur7" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-9"
          x="398.15"
          y="250.28"
          width="12.32"
          height="12.81"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur8" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur8" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-10"
          x="390.21"
          y="261.14"
          width="11.25"
          height="23.65"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur9" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur9" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-11"
          x="379.29"
          y="282.62"
          width="14.62"
          height="14.19"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur10" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur10" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-12"
          x="372.7"
          y="271.16"
          width="9.5"
          height="23.21"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur11" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur11" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-13"
          x="353.4"
          y="255.75"
          width="22.53"
          height="17.69"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur12" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur12" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-14"
          x="325.7"
          y="248.65"
          width="29.65"
          height="10.41"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur13" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur13" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-15"
          x="306.1"
          y="248.53"
          width="21.16"
          height="6.53"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur14" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur14" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-16"
          x="286.88"
          y="251.78"
          width="21.34"
          height="12.82"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur15" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur15" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-17"
          x="280.28"
          y="261.68"
          width="9.39"
          height="14.98"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur16" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur16" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-18"
          x="250.01"
          y="273.45"
          width="32.79"
          height="34.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur17" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur17" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-19"
          x="235.21"
          y="306.55"
          width="18.17"
          height="30.7"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur18" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur18" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-20"
          x="218.53"
          y="334.42"
          width="19.11"
          height="11.08"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur19" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur19" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-21"
          x="208.06"
          y="342.82"
          width="13.11"
          height="15.37"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur20" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur20" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-22"
          x="208.07"
          y="355.19"
          width="14.81"
          height="20.37"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur21" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur21" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-23"
          x="194.95"
          y="354.4"
          width="27.16"
          height="22.18"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur22" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur22" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-24"
          x="163.56"
          y="347.39"
          width="34.34"
          height="9.46"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur23" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur23" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-25"
          x="156.96"
          y="333.17"
          width="15.53"
          height="20.62"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur24" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur24" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-26"
          x="157.08"
          y="307.24"
          width="24.65"
          height="29.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur25" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur25" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-27"
          x="166.95"
          y="300.75"
          width="14.23"
          height="8.99"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur26" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur26" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-28"
          x="166.18"
          y="287.86"
          width="4.51"
          height="15.47"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur27" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur27" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-29"
          x="167.24"
          y="255.63"
          width="18.82"
          height="33.73"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur28" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur28" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-30"
          x="176.16"
          y="237.03"
          width="11.04"
          height="21.18"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur29" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur29" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-31"
          x="175.9"
          y="223.5"
          width="16.43"
          height="16.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur30" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur30" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-32"
          x="189.26"
          y="205.4"
          width="14.06"
          height="20.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur31" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur31" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-33"
          x="200.28"
          y="204.93"
          width="20.36"
          height="7.92"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur32" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur32" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-34"
          x="218.94"
          y="191.4"
          width="30.76"
          height="20.72"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur33" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur33" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-35"
          x="225.32"
          y="162.52"
          width="24.58"
          height="31.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur34" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur34" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-36"
          x="225.99"
          y="145.43"
          width="18.11"
          height="19.82"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur35" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur35" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-37"
          x="241.4"
          y="124.66"
          width="13.33"
          height="23.29"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur36" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur36" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-38"
          x="251.31"
          y="111.31"
          width="10.84"
          height="15.52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur37" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur37" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-39"
          x="237.89"
          y="105.72"
          width="23.72"
          height="8.13"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur38" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur38" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-40"
          x="222.16"
          y="105.72"
          width="17.1"
          height="4.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur39" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur39" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-41"
          x="199.79"
          y="107.21"
          width="23.93"
          height="4.28"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur40" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur40" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-42"
          x="158.03"
          y="108.08"
          width="43.29"
          height="8.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur41" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur41" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-43"
          x="141.53"
          y="112.82"
          width="18.78"
          height="5.08"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur42" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur42" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-44"
          x="137.38"
          y="115.03"
          width="6.78"
          height="17.13"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur43" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur43" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-45"
          x="119.74"
          y="129.55"
          width="20.4"
          height="24.27"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur44" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur44" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-46"
          x="108.08"
          y="151.48"
          width="14.31"
          height="17.18"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur45" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur45" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-47"
          x="108.03"
          y="167.01"
          width="5.09"
          height="18.65"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur46" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur46" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-48"
          x="88.46"
          y="183.12"
          width="24.4"
          height="6.57"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur47" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur47" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-49"
          x="67.47"
          y="168.23"
          width="23.28"
          height="19.52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur48" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur48" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-50"
          x="386.23"
          y="124.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur49" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur49" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-51"
          x="412.99"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur50" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur50" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-52"
          x="433.83"
          y="163.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur51" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur51" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-53"
          x="419.64"
          y="232.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur52" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur52" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-54"
          x="402.75"
          y="245.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur53" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur53" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-55"
          x="393.04"
          y="255.22"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur54" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur54" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-56"
          x="385.04"
          y="276.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur55" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur55" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-57"
          x="373.69"
          y="286.86"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur56" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur56" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-58"
          x="367.58"
          y="265.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur57" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur57" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-59"
          x="347.5"
          y="250.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur58" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur58" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-60"
          x="319.78"
          y="243.65"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur59" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur59" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-61"
          x="300.52"
          y="246.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur60" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur60" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-62"
          x="281.52"
          y="256.36"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur61" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur61" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-63"
          x="275.19"
          y="268.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur62" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur62" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-64"
          x="244.97"
          y="300.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur63" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur63" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-65"
          x="229.5"
          y="329.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur64" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur64" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-66"
          x="212.8"
          y="337.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur65" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur65" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-67"
          x="202.68"
          y="349.99"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur66" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur66" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-68"
          x="214.5"
          y="367.91"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur67" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur67" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-69"
          x="189.93"
          y="348.6"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur68" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur68" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-70"
          x="158.32"
          y="345.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur69" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur69" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-71"
          x="151.24"
          y="328.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur70" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur70" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-72"
          x="173.33"
          y="301.43"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur71" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur71" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-73"
          x="161.17"
          y="295.83"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur72" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur72" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-74"
          x="162.27"
          y="281.93"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur73" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur73" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-75"
          x="178.6"
          y="250.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur74" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur74" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-76"
          x="170.27"
          y="232.02"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur75" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur75" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-77"
          x="183.91"
          y="217.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur76" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur76" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-78"
          x="194.94"
          y="199.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur77" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur77" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-79"
          x="213.04"
          y="203.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur78" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur78" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-80"
          x="241.65"
          y="186.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur79" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur79" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-81"
          x="220.26"
          y="156.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur80" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur80" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-82"
          x="235.75"
          y="139.81"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur81" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur81" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-83"
          x="246.34"
          y="118.88"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur82" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur82" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-84"
          x="253.76"
          y="105.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur83" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur83" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-85"
          x="231.75"
          y="100.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur84" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur84" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-86"
          x="216.26"
          y="102.25"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur85" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur85" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-87"
          x="193.83"
          y="103.07"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur86" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur86" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-88"
          x="152.7"
          y="108.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur87" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur87" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-89"
          x="135.88"
          y="109.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur88" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur88" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-90"
          x="132.72"
          y="124.55"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur89" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur89" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-91"
          x="114.75"
          y="146.35"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur90" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur90" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-92"
          x="103.06"
          y="161.04"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur91" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur91" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-93"
          x="104.77"
          y="177.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur92" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur92" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-94"
          x="82.81"
          y="179.49"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur93" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur93" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-95"
          x="62.18"
          y="162.94"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur94" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur94" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-96"
          x="435.86"
          y="187.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur95" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur95" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-97"
          x="373.38"
          y="118.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur96" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur96" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-98"
          x="341.46"
          y="130.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur97" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur97" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-99"
          x="67.47"
          y="168.23"
          width="23.28"
          height="19.52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur98" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur98" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-100"
          x="62.18"
          y="162.94"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur99" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur99" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-101"
          x="62.18"
          y="162.94"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur100" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur100" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-102"
          x="88.46"
          y="183.12"
          width="24.4"
          height="6.57"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur101" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur101" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-103"
          x="82.81"
          y="179.49"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur102" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur102" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-104"
          x="82.81"
          y="179.49"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur103" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur103" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-105"
          x="108.03"
          y="167.01"
          width="5.09"
          height="18.65"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur104" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur104" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-106"
          x="104.77"
          y="177.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur105" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur105" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-107"
          x="104.77"
          y="177.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur106" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur106" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-108"
          x="108.08"
          y="151.48"
          width="14.31"
          height="17.18"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur107" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur107" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-109"
          x="103.06"
          y="161.04"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur108" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur108" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-110"
          x="103.06"
          y="161.04"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur109" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur109" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-111"
          x="119.74"
          y="129.55"
          width="20.4"
          height="24.27"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur110" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur110" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-112"
          x="114.75"
          y="146.35"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur111" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur111" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-113"
          x="114.75"
          y="146.35"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur112" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur112" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-114"
          x="137.38"
          y="115.03"
          width="6.78"
          height="17.13"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur113" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur113" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-115"
          x="132.72"
          y="124.55"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur114" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur114" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-116"
          x="132.72"
          y="124.55"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur115" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur115" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-117"
          x="141.53"
          y="112.82"
          width="18.78"
          height="5.08"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur116" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur116" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-118"
          x="135.88"
          y="109.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur117" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur117" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-119"
          x="135.88"
          y="109.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur118" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur118" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-120"
          x="158.03"
          y="108.08"
          width="43.29"
          height="8.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur119" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur119" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-121"
          x="152.7"
          y="108.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur120" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur120" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-122"
          x="152.7"
          y="108.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur121" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur121" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-123"
          x="199.79"
          y="107.21"
          width="23.93"
          height="4.28"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur122" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur122" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-124"
          x="193.83"
          y="103.07"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur123" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur123" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-125"
          x="193.83"
          y="103.07"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur124" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur124" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-126"
          x="222.16"
          y="105.72"
          width="17.1"
          height="4.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur125" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur125" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-127"
          x="216.26"
          y="102.25"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur126" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur126" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-128"
          x="216.26"
          y="102.25"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur127" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur127" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-129"
          x="237.89"
          y="105.72"
          width="23.72"
          height="8.13"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur128" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur128" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-130"
          x="231.75"
          y="100.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur129" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur129" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-131"
          x="231.75"
          y="100.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur130" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur130" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-132"
          x="251.31"
          y="111.31"
          width="10.84"
          height="15.52"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur131" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur131" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-133"
          x="253.76"
          y="105.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur132" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur132" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-134"
          x="253.76"
          y="105.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur133" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur133" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-135"
          x="241.4"
          y="124.66"
          width="13.33"
          height="23.29"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur134" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur134" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-136"
          x="246.34"
          y="118.88"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur135" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur135" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-137"
          x="246.34"
          y="118.88"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur136" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur136" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-138"
          x="225.99"
          y="145.43"
          width="18.11"
          height="19.82"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur137" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur137" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-139"
          x="235.75"
          y="139.81"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur138" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur138" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-140"
          x="235.75"
          y="139.81"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur139" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur139" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-141"
          x="225.32"
          y="162.52"
          width="24.58"
          height="31.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur140" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur140" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-142"
          x="220.26"
          y="156.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur141" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur141" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-143"
          x="220.26"
          y="156.87"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur142" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur142" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-144"
          x="218.94"
          y="191.4"
          width="30.76"
          height="20.72"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur143" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur143" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-145"
          x="241.65"
          y="186.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur144" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur144" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-146"
          x="241.65"
          y="186.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur145" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur145" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-147"
          x="200.28"
          y="204.93"
          width="20.36"
          height="7.92"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur146" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur146" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-148"
          x="213.04"
          y="203.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur147" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur147" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-149"
          x="213.04"
          y="203.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur148" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur148" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-150"
          x="189.26"
          y="205.4"
          width="14.06"
          height="20.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur149" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur149" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-151"
          x="194.94"
          y="199.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur150" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur150" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-152"
          x="194.94"
          y="199.69"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur151" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur151" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-153"
          x="175.9"
          y="223.5"
          width="16.43"
          height="16.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur152" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur152" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-154"
          x="183.91"
          y="217.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur153" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur153" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-155"
          x="183.91"
          y="217.54"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur154" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur154" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-156"
          x="176.16"
          y="237.03"
          width="11.05"
          height="21.18"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur155" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur155" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-157"
          x="170.27"
          y="232.02"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur156" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur156" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-158"
          x="170.27"
          y="232.02"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur157" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur157" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-159"
          x="167.24"
          y="255.63"
          width="18.82"
          height="33.73"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur158" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur158" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-160"
          x="178.6"
          y="250.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur159" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur159" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-161"
          x="178.6"
          y="250.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur160" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur160" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-162"
          x="166.18"
          y="287.86"
          width="4.51"
          height="15.47"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur161" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur161" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-163"
          x="162.27"
          y="281.93"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur162" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur162" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-164"
          x="162.27"
          y="281.93"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur163" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur163" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-165"
          x="166.95"
          y="300.75"
          width="14.23"
          height="8.99"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur164" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur164" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-166"
          x="161.17"
          y="295.83"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur165" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur165" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-167"
          x="161.17"
          y="295.83"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur166" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur166" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-168"
          x="157.08"
          y="307.24"
          width="24.65"
          height="29.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur167" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur167" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-169"
          x="173.33"
          y="301.43"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur168" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur168" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-170"
          x="173.33"
          y="301.43"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur169" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur169" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-171"
          x="156.96"
          y="333.17"
          width="15.53"
          height="20.62"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur170" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur170" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-172"
          x="151.24"
          y="328.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur171" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur171" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-173"
          x="151.24"
          y="328.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur172" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur172" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-174"
          x="163.56"
          y="347.39"
          width="34.34"
          height="9.46"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur173" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur173" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-175"
          x="158.32"
          y="345.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur174" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur174" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-176"
          x="158.32"
          y="345.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur175" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur175" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-177"
          x="194.95"
          y="354.4"
          width="27.16"
          height="22.19"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur176" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur176" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-178"
          x="189.93"
          y="348.6"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur177" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur177" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-179"
          x="189.93"
          y="348.6"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur178" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur178" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-180"
          x="208.07"
          y="355.19"
          width="14.81"
          height="20.37"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur179" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur179" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-181"
          x="214.5"
          y="367.91"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur180" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur180" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-182"
          x="214.5"
          y="367.91"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur181" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur181" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-183"
          x="208.06"
          y="342.82"
          width="13.11"
          height="15.37"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur182" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur182" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-184"
          x="202.68"
          y="349.99"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur183" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur183" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-185"
          x="202.68"
          y="349.99"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur184" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur184" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-186"
          x="218.53"
          y="334.42"
          width="19.11"
          height="11.08"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur185" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur185" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-187"
          x="212.8"
          y="337.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur186" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur186" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-188"
          x="212.8"
          y="337.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur187" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur187" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-189"
          x="235.21"
          y="306.55"
          width="18.17"
          height="30.7"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur188" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur188" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-190"
          x="229.5"
          y="329.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur189" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur189" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-191"
          x="229.5"
          y="329.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur190" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur190" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-192"
          x="250.01"
          y="273.45"
          width="32.79"
          height="34.87"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur191" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur191" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-193"
          x="244.97"
          y="300.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur192" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur192" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-194"
          x="244.97"
          y="300.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur193" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur193" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-195"
          x="280.28"
          y="261.68"
          width="9.39"
          height="14.98"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur194" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur194" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-196"
          x="275.19"
          y="268.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur195" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur195" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-197"
          x="275.19"
          y="268.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur196" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur196" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-198"
          x="286.88"
          y="251.78"
          width="21.34"
          height="12.82"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur197" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur197" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-199"
          x="281.52"
          y="256.36"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur198" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur198" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-200"
          x="281.52"
          y="256.36"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur199" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur199" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-201"
          x="306.1"
          y="248.53"
          width="21.16"
          height="6.53"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur200" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur200" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-202"
          x="300.52"
          y="246.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur201" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur201" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-203"
          x="300.52"
          y="246.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur202" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur202" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-204"
          x="325.7"
          y="248.65"
          width="29.65"
          height="10.41"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur203" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur203" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-205"
          x="319.78"
          y="243.65"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur204" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur204" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-206"
          x="319.78"
          y="243.65"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur205" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur205" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-207"
          x="353.4"
          y="255.75"
          width="22.53"
          height="17.69"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur206" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur206" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-208"
          x="347.5"
          y="250.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur207" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur207" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-209"
          x="347.5"
          y="250.74"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur208" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur208" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-210"
          x="372.7"
          y="271.16"
          width="9.5"
          height="23.21"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur209" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur209" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-211"
          x="367.58"
          y="265.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur210" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur210" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-212"
          x="367.58"
          y="265.63"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur211" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur211" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-213"
          x="379.29"
          y="282.62"
          width="14.62"
          height="14.19"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur212" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur212" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-214"
          x="373.69"
          y="286.86"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur213" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur213" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-215"
          x="373.69"
          y="286.86"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur214" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur214" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-216"
          x="390.21"
          y="261.14"
          width="11.25"
          height="23.65"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur215" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur215" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-217"
          x="385.04"
          y="276.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur216" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur216" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-218"
          x="385.04"
          y="276.82"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur217" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur217" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-219"
          x="398.15"
          y="250.28"
          width="12.32"
          height="12.81"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur218" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur218" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-220"
          x="393.04"
          y="255.22"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur219" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur219" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-221"
          x="393.04"
          y="255.22"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur220" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur220" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-222"
          x="407.79"
          y="235.55"
          width="20.01"
          height="17.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur221" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur221" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-223"
          x="402.75"
          y="245.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur222" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur222" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-224"
          x="402.75"
          y="245.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur223" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur223" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-225"
          x="424.9"
          y="192.9"
          width="24.5"
          height="47.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur224" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur224" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-226"
          x="419.64"
          y="232.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur225" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur225" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-227"
          x="419.64"
          y="232.12"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur226" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur226" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-228"
          x="438.87"
          y="169.62"
          width="9.45"
          height="26.55"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur227" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur227" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-229"
          x="435.86"
          y="187.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur228" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur228" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-230"
          x="435.86"
          y="187.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur229" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur229" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-231"
          x="418.04"
          y="141.59"
          width="23.76"
          height="30.55"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur230" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur230" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-232"
          x="433.83"
          y="163.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur231" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur231" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-233"
          x="433.83"
          y="163.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur232" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur232" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-234"
          x="391.52"
          y="129.54"
          width="28.98"
          height="14.86"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur233" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur233" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-235"
          x="412.99"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur234" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur234" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-236"
          x="412.99"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur235" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur235" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-237"
          x="379.28"
          y="123.18"
          width="14.98"
          height="9.27"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur236" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur236" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-238"
          x="386.23"
          y="124.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur237" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur237" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-239"
          x="386.23"
          y="124.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur238" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur238" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-240"
          x="347.35"
          y="123.38"
          width="34.05"
          height="15.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur239" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur239" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-241"
          x="373.38"
          y="118.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur240" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur240" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-242"
          x="373.38"
          y="118.17"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur241" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur241" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-243"
          x="342.76"
          y="120.14"
          width="7.01"
          height="18.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur242" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur242" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-244"
          x="341.46"
          y="130.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur243" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur243" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-245"
          x="341.46"
          y="130.71"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur244" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur244" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-246"
          x="521.99"
          y="106.75"
          width="30.63"
          height="37.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur245" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur245" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-247"
          x="549.7"
          y="87.02"
          width="15.67"
          height="22.41"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur246" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur246" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-248"
          x="545.1"
          y="59.39"
          width="15.46"
          height="8.59"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur247" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur247" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-249"
          x="524.91"
          y="58.78"
          width="22.18"
          height="10.16"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur248" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur248" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-250"
          x="504.17"
          y="66.36"
          width="23.79"
          height="13.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur249" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur249" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-251"
          x="472.44"
          y="59.33"
          width="34.01"
          height="19.85"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur250" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur250" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-252"
          x="461.44"
          y="43.83"
          width="13.49"
          height="18.15"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur251" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur251" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-253"
          x="446.39"
          y="43.65"
          width="17.28"
          height="11.04"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur252" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur252" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-254"
          x="419.35"
          y="51.39"
          width="29.37"
          height="9.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur253" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur253" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-255"
          x="391.42"
          y="52.3"
          width="30.62"
          height="8.77"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur254" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur254" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-256"
          x="388.52"
          y="58.3"
          width="5.88"
          height="20.38"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur255" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur255" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-257"
          x="358.51"
          y="72.05"
          width="33.25"
          height="7.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur256" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur256" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-258"
          x="337.31"
          y="73.62"
          width="23.75"
          height="14.14"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur257" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur257" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-259"
          x="336.22"
          y="85"
          width="5.79"
          height="22.2"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur258" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur258" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-260"
          x="338.79"
          y="104.98"
          width="7.21"
          height="16.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur259" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur259" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-261"
          x="516.6"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur260" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur260" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-262"
          x="544.33"
          y="101.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur261" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur261" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-263"
          x="441.16"
          y="46.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur262" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur262" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-264"
          x="413.93"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur263" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur263" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-265"
          x="386.23"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur264" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur264" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-266"
          x="383.92"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur265" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur265" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-267"
          x="352.73"
          y="68.03"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur266" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur266" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-268"
          x="331.45"
          y="79.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur267" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur267" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-269"
          x="333.76"
          y="99.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur268" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur268" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-270"
          x="337.76"
          y="114.18"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur269" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur269" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-271"
          x="539.47"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur270" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur270" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-272"
          x="519.76"
          y="60.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur271" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur271" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-273"
          x="498.29"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur272" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur272" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-274"
          x="466.54"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur273" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur273" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-275"
          x="456.05"
          y="38.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur274" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur274" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-276"
          x="562.04"
          y="74.31"
          width="6.64"
          height="14.68"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur275" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur275" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-277"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur276" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur276" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-278"
          x="560.29"
          y="68.56"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur277" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur277" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-279"
          x="552.77"
          y="59.64"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur278" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur278" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-280"
          x="557.01"
          y="81.33"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur279" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur279" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-281"
          x="338.79"
          y="104.98"
          width="7.21"
          height="16.91"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur280" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur280" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-282"
          x="337.76"
          y="114.18"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur281" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur281" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-283"
          x="337.76"
          y="114.18"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur282" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur282" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-284"
          x="336.22"
          y="85"
          width="5.79"
          height="22.2"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur283" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur283" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-285"
          x="333.76"
          y="99.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur284" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur284" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-286"
          x="333.76"
          y="99.23"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur285" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur285" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-287"
          x="337.31"
          y="73.62"
          width="23.75"
          height="14.14"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur286" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur286" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-288"
          x="331.45"
          y="79.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur287" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur287" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-289"
          x="331.45"
          y="79.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur288" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur288" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-290"
          x="358.51"
          y="72.05"
          width="33.25"
          height="7.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur289" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur289" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-291"
          x="352.73"
          y="68.03"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur290" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur290" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-292"
          x="352.73"
          y="68.03"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur291" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur291" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-293"
          x="388.52"
          y="58.3"
          width="5.88"
          height="20.38"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur292" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur292" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-294"
          x="383.92"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur293" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur293" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-295"
          x="383.92"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur294" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur294" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-296"
          x="391.42"
          y="52.3"
          width="30.62"
          height="8.77"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur295" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur295" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-297"
          x="386.23"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur296" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur296" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-298"
          x="386.23"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur297" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur297" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-299"
          x="419.35"
          y="51.39"
          width="29.37"
          height="9.79"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur298" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur298" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-300"
          x="413.93"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur299" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur299" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-301"
          x="413.93"
          y="52.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur300" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur300" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-302"
          x="446.39"
          y="43.65"
          width="17.28"
          height="11.04"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur301" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur301" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-303"
          x="441.16"
          y="46.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur302" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur302" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-304"
          x="441.16"
          y="46.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur303" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur303" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-305"
          x="461.44"
          y="43.83"
          width="13.49"
          height="18.15"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur304" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur304" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-306"
          x="456.05"
          y="38.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur305" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur305" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-307"
          x="456.05"
          y="38.62"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur306" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur306" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-308"
          x="472.44"
          y="59.33"
          width="34.01"
          height="19.85"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur307" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur307" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-309"
          x="466.54"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur308" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur308" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-310"
          x="466.54"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur309" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur309" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-311"
          x="504.17"
          y="66.36"
          width="23.79"
          height="13.31"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur310" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur310" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-312"
          x="498.29"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur311" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur311" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-313"
          x="498.29"
          y="71.09"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur312" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur312" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-314"
          x="524.91"
          y="58.78"
          width="22.18"
          height="10.16"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur313" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur313" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-315"
          x="519.76"
          y="60.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur314" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur314" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-316"
          x="519.76"
          y="60.95"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur315" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur315" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-317"
          x="545.1"
          y="59.39"
          width="15.46"
          height="8.59"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur316" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur316" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-318"
          x="539.47"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur317" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur317" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-319"
          x="539.47"
          y="54.32"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur318" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur318" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-320"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur319" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur319" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-321"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur320" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur320" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-322"
          x="552.77"
          y="59.64"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur321" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur321" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-323"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur322" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur322" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-324"
          x="552.77"
          y="59.64"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur323" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur323" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-325"
          x="562.04"
          y="74.31"
          width="6.64"
          height="14.68"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur324" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur324" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-326"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur325" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur325" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-327"
          x="560.29"
          y="68.56"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur326" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur326" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-328"
          x="560.29"
          y="68.56"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur327" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur327" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-329"
          x="549.7"
          y="87.02"
          width="15.67"
          height="22.41"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur328" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur328" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-330"
          x="8613"
          y="8490"
          width="-32766"
          height="-32766"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur329" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur329" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-331"
          x="557.01"
          y="81.33"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur330" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur330" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-332"
          x="557.01"
          y="81.33"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur331" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur331" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-333"
          x="521.99"
          y="106.75"
          width="30.63"
          height="37.36"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur332" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur332" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-334"
          x="544.33"
          y="101.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur333" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur333" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-335"
          x="544.33"
          y="101.24"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur334" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur334" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-336"
          x="516.6"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur335" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur335" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="drop-shadow-337"
          x="516.6"
          y="135.9"
          width="13.42"
          height="13.42"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dx="1.42" dy="1.42" />
          <feGaussianBlur result="blur336" stdDeviation="0" />
          <feFlood flood-color="#1b2e60" flood-opacity=".3" />
          <feComposite in2="blur336" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="_ベースの地図" data-name="ベースの地図">
        <path class="st344" d="M542.8-448.49" />
        <path
          class="st350"
          d="M388.98,101.17c-.24,0-1.62.24-1.62.24,0,0-.18.66-.47.9-.3.24-.42.12-.59.83-.18.72.3,2.56.3,2.56,0,0,1.55.84,2.2,0,.66-.83.72-.95,1.07-1.49.36-.53-.3-.41.78-.77,1.07-.36.95-.06,1.61-.48.66-.42-.59-.6,1.08-.48,1.67.12,2.56-.06,2.5.3-.06.36-.66.6-.06.6s1.07-.12,1.07-.12c0,0,.72-.12,1.07.59.36.72-.11-.47.54.96.66,1.43.72,1.96.66,2.32-.06.36.12.83-.36,1.07-.48.24-1.02.36-1.07.72-.06.36-.06.66.3.77.36.12,1.02.06,1.02.48s.24.83,0,1.01c-.24.18-.96-.24-1.08.42-.11.65-.3.53.06.95.36.42.84.6,1.07.54.24-.06.48.65.78-.36.3-1.01.77-3.23.83-3.46.06-.24,0-.12.72-.84.71-.71.71-.89,1.01-1.49.3-.59.78-1.37.78-1.37,0,0,.18-.59.77-.59s1.37-.24,1.67-.54c.3-.3.35-.71.71-.77.36-.06-.77-.78,1.13-.12,1.92.65,2.51.65,2.51,1.07s.59.41-.06.89c-.66.48-1.02.6-1.44.72-.41.12-2.08-.24-.47.36,1.61.6,2.56.84,2.75.84s.06-.54.18,0c.12.53.12.83.42,1.43.29.6.42,2.08.84.95.42-1.13.12-2.08.3-2.44.18-.36,1.19-.54,1.37-1.31.18-.78-.24-2.09-.42-2.38-.18-.3-.3-.42-.18-.96.12-.54.6-.77.78-1.73.17-.96.12-1.92.17-2.45.06-.53.78-2.68.78-3.46s-.42-1.13-.66-1.32c-.24-.18-.59-.48-.59-.84s-.3-.72.12-1.07c.42-.36.53-.66.53-.84s-.06-1.67-.6-1.62c-.54.06-1.07.06-1.48.06s-.36-.12-1.02,0c-.65.12-1.02.3-1.49.54-.48.23-.66.17-1.08.59-.41.42-.89.89-1.07,1.02-.18.12.73.3-.41.3s-2.03-.05-2.68-.05h-1.49s-.66-.18-.96-.12c-.3.06-1.19.47-1.49.72-.29.24-1.19.59-1.55.95-.35.36-.84,1.07-.84,1.07,0,0-.59.24-1.07.42-.48.18-.83.06-1.01.36-.18.3-.54.66-.54.66,0,0-1.01.47-1.37.59-.36.12-1.25.3-1.85.3s-.84.3-1.2,0c-.35-.3-.83-.72-.83-.72,0,0-.3-.95-.78-.24s-.89,1.85-.89,1.85c0,0,.06.84.24,1.07.18.24,1.13,1.14,1.13,1.14,0,0,.48,1.19-1.07,1.25Z"
        />
        <path
          class="st350"
          d="M336.34,116.49s-.37,1.12-1.12,1.12-1.62-1.24-1.74-.49c-.13.74.25,2.49.25,2.49,0,0,.75,1.12,1.74.5,1-.62,2.5-1.62,2.5-1.62,0,0,.74-3.23-1.62-1.99Z"
        />
        <path
          class="st350"
          d="M328.62,116.49s1.25,2.62.75,3.61c-.5,1-1,1.49-1.37,1.74s-.5.62-.74,1.25c-.26.62.49,1.49-1.12.87-1.62-.61-2.12-1.49-1.49-2.73.61-1.25,1.36-2.24,1.86-2.87.49-.62,2.11-2.98,2.11-1.87Z"
        />
        <path
          class="st348"
          d="M122.63,189.07s0,1.62-.12,1.99c-.13.37,0,.62-.5,1s-.87.87-.87.87c0,0,.25,0,.12,1.12-.12,1.12.25,2.12.25,2.74s-.25.5.87,1.74c1.12,1.25,2.61,2.12,2.61,2.49v1.25s.38.87,1,.25c.62-.62-.74-.12.62-.62,1.37-.5-1.24-.38,1.37-.5,2.61-.12,2.36-.25,3.85-.12,1.49.12,1.12.49,1.49.12s.63-2.24,1.12-2.74c.5-.5.5-.99,1.37-.99s1.12-.26,1.86.12c.75.38-.25.13,1.37.5,1.62.37,2.36.13,2.98.99.63.88,2.12,1.25,1.12,1.62-1,.37-1.37.25-1.49.75-.12.49-1.49,1.24,0,1.24s3.11-.49,3.11-.49c0,0-.63-.13.5.25,1.12.37.13,1.12,1.12.37.99-.74,1.86-1.62,1.36-2.62-.5-.99-.99-1.49-.99-1.99s0-1.87.37-2.24-.49-1.37.74-1.49c1.24-.13,1.25-.13,1.75-.13s1.87.74,2.36.74.37.13,1.49-.74c1.12-.87,1.75-1.12,2.12-1.36.37-.26.37-.51,1.24-.63q.88-.12,1.62-.12c.75,0,2.49-1.62,1.99-1.75-.49-.13-2.24.25-2.86-.13s.13-.75-.5-.99c-.62-.25-2.24-1-2.98-.88-.74.13-.74-.25-1.49.5s-.62,0-.87,1.61c-.25,1.62,1.25,2.24-.62,2.24s-3.74-.25-4.24,0c-.49.26-1.24,2.12-1.74,2.5-.5.37.13,1.74-2.36,1-2.5-.74-1.99-.12-4.11-1.62-2.12-1.5-2.37-.74-2.61-1.74-.25-1-.37-1.49-.37-2.37v-1.74s1.24.25-1.37.13c-2.61-.13-2.61-.37-2.87-.75-.25-.37.26-1.86-.49-1.86h-1.99c-.62,0,0,.87-.87,1.12-.87.25-1.25-.38-1.75.12-.49.5-.12,1-.99,1.12-.88.13-2.12-.62-2.74.13Z"
        />
        <g>
          <g>
            <path
              class="st345"
              d="M388.98,101.17c-.24,0-1.62.24-1.62.24,0,0-.18.66-.47.9-.3.24-.42.12-.59.83-.18.72.3,2.56.3,2.56,0,0,1.55.84,2.2,0,.66-.83.72-.95,1.07-1.49.36-.53-.3-.41.78-.77,1.07-.36.95-.06,1.61-.48.66-.42-.59-.6,1.08-.48,1.67.12,2.56-.06,2.5.3-.06.36-.66.6-.06.6s1.07-.12,1.07-.12c0,0,.72-.12,1.07.59.36.72-.11-.47.54.96.66,1.43.72,1.96.66,2.32-.06.36.12.83-.36,1.07-.48.24-1.02.36-1.07.72-.06.36-.06.66.3.77.36.12,1.02.06,1.02.48s.24.83,0,1.01c-.24.18-.96-.24-1.08.42-.11.65-.3.53.06.95.36.42.84.6,1.07.54.24-.06.48.65.78-.36.3-1.01.77-3.23.83-3.46.06-.24,0-.12.72-.84.71-.71.71-.89,1.01-1.49.3-.59.78-1.37.78-1.37,0,0,.18-.59.77-.59s1.37-.24,1.67-.54c.3-.3.35-.71.71-.77.36-.06-.77-.78,1.13-.12,1.92.65,2.51.65,2.51,1.07s.59.41-.06.89c-.66.48-1.02.6-1.44.72-.41.12-2.08-.24-.47.36,1.61.6,2.56.84,2.75.84s.06-.54.18,0c.12.53.12.83.42,1.43.29.6.42,2.08.84.95.42-1.13.12-2.08.3-2.44.18-.36,1.19-.54,1.37-1.31.18-.78-.24-2.09-.42-2.38-.18-.3-.3-.42-.18-.96.12-.54.6-.77.78-1.73.17-.96.12-1.92.17-2.45.06-.53.78-2.68.78-3.46s-.42-1.13-.66-1.32c-.24-.18-.59-.48-.59-.84s-.3-.72.12-1.07c.42-.36.53-.66.53-.84s-.06-1.67-.6-1.62c-.54.06-1.07.06-1.48.06s-.36-.12-1.02,0c-.65.12-1.02.3-1.49.54-.48.23-.66.17-1.08.59-.41.42-.89.89-1.07,1.02-.18.12.73.3-.41.3s-2.03-.05-2.68-.05h-1.49s-.66-.18-.96-.12c-.3.06-1.19.47-1.49.72-.29.24-1.19.59-1.55.95-.35.36-.84,1.07-.84,1.07,0,0-.59.24-1.07.42-.48.18-.83.06-1.01.36-.18.3-.54.66-.54.66,0,0-1.01.47-1.37.59-.36.12-1.25.3-1.85.3s-.84.3-1.2,0c-.35-.3-.83-.72-.83-.72,0,0-.3-.95-.78-.24s-.89,1.85-.89,1.85c0,0,.06.84.24,1.07.18.24,1.13,1.14,1.13,1.14,0,0,.48,1.19-1.07,1.25Z"
            />
            <path
              class="st345"
              d="M336.34,116.49s-.37,1.12-1.12,1.12-1.62-1.24-1.74-.49c-.13.74.25,2.49.25,2.49,0,0,.75,1.12,1.74.5,1-.62,2.5-1.62,2.5-1.62,0,0,.74-3.23-1.62-1.99Z"
            />
            <path
              class="st345"
              d="M328.62,116.49s1.25,2.62.75,3.61c-.5,1-1,1.49-1.37,1.74s-.5.62-.74,1.25c-.26.62.49,1.49-1.12.87-1.62-.61-2.12-1.49-1.49-2.73.61-1.25,1.36-2.24,1.86-2.87.49-.62,2.11-2.98,2.11-1.87Z"
            />
          </g>
          <path
            class="st345"
            d="M313.1,175.66c1.6.27,3.21.27,4,.27s3.47.53,3.47.53l1.06.8,1.61,1.33h.47l.06-.8-.06.8h2.46l2.4-1.6s0-.53,1.34-1.6c1.33-1.06,2.39-1.33,2.93-2.4.54-1.07-1.06.26,1.33-2.14,2.4-2.4,4-2.93,4-2.93,0,0-.54.8,1.06,1.06,1.6.27,2.14,1.06,2.94.54.8-.54.8-4.01,1.6-4.01s4.53-.53,4.53-.53c0,0,1.07-1.07,1.87-1.07h2.14c1.06,0,1.6-.27,2.39-.79.81-.54,1.87-.81,1.87-.81l1.06-.27s.27,1.07,1.07,2.4c.79,1.33,2.39,2.13,2.39,2.13,0,0,.28,3.47,3.21,3.21,2.93-.27,4.27-2.14,4.27-2.14,0,0-1.33.54,1.6-1.6,2.94-2.14,3.47-3.47,3.47-3.47,1.6-.53,1.61-.53,2.67-.53s2.4-.27,2.4-.27h2.93c1.07,0,2.41-.8,2.41-.8,0,0,1.87-2.93,2.13-4.27.26-1.34,0-3.48,1.87-3.74,1.87-.27,1.33-.79,2.94-.79h1.6c2.94,0,3.2.53,4.8,0,1.6-.54,3.47-.27,5.34-.27s2.93-.8,3.2,0c.27.8-.27,1.06,1.34,1.06s2.66-.27,2.66-.27l1.07-.26,2.13-.54s0-.8,1.07-.27c1.06.54-.27,0,1.06.54,1.33.53,5.34,2.13,5.34,2.13,0,0,.27.53,1.87.53s1.06,1.33,1.6,0c.53-1.33.53-3.47.53-3.47v-2.13l1.33-1.61-.04-1.24c-.77-.23-.89-.56-2.78-1.23-1.9-.67-.89-.44-1.33-.78-.45-.33,0,0,0-.33s-.12-.67-.12-1.11-1.22,0-1.22,0c0,0,.22-.67.22-1.12s-.55-1.45-.55-1.45c0,0-2.12-1.45-2.45-1.34-.33.11-2.45.78-3.23.78s-1,0-1.78-.12c-.78-.11-1.67-.77-2.12-1.11-.44-.34-1.33-1.56-2.45-2.12-1.11-.55-1.78.23-1.78.23,0,0-1.11-.56-1.78-1.12-.66-.56,0,0-.22-.33-.23-.33-1.12-.78-1.12-.78,0,0-1.11.56-1.44.56s-1.23-2.45-1.34-2.79c-.11-.33-.22-.44,0-2.11.23-1.67,0,0,.45-.33.44-.34.89-.34,1.33-1.01.45-.67,0-1.12,0-1.67s-1-1.57-1.67-2.34c-.66-.78-1.11.89-1.11.89,0,0-.78,0-1.78-.33-1-.34-.44-.45-.78-1.23-.34-.78-.56-2.01-.56-2.01,0,0-1.67-.45-2.01.34-.33.78-.45,1.9-.45,1.9l-.67.45s-.67-.22-2.67-.78c-2.01-.56-1.34-1.12-1.34-1.12,0,0-.89,0-1.22-.34-.33-.34-.22-.89-.11-1.33.11-.45,0-.89.11-1.34.12-.45.22-1.22.22-1.55s-.89-.33-1.34-1.45c-.44-1.11-1.67-.56-3.23-.56s-.23,1-.23,1c0,0,.44,1.34.44,1.67s-.78.68-.78.68c0,0,.12,1.44.12,1.78s-.12,1.11-.67,1.45c-.56.33-.56-.67-.56-.67l-.23-.45s-.78-1.33-1.11-1.9c-.34-.55-1.12-.77-1.12-.77l-.33,1.22s-.12,2.45-.56,2.67c-.45.22-.66.89-.66.89,0,0-1.67-.45-1.9-.89-.22-.44-1,0-1.33,0s-1,.67-1,.67c0,0-2-.45-3.01-.67-1.01-.22-.44,0-1.23.45-.78.45,0,0-.33.12-.33.11-1.66-.12-2.22-.12s-1.56-1.11-1.78-1.56c-.22-.44-1.78-1.33-1.78-1.33l-1.77.44-.78-.23-.34-1.45-.78-.11-.89-.45-1.56-.67-.12.67s-1.44.45-1.89.56c-.45.11-2.35.11-2.46.45-.11.34-.11.89-.11,1.67s0,.89.11,1.67c.11.78,0,.89-.11,1.89-.11,1-1.23.78-1.78,1.33-.56.56-.44.45-1.11.67s-.56.12-1.34.22c-.77.11-1.67.34-3.23.22-1.56-.11,0,0,0-.33s.34-.89.34-.89c0,0,.33-.56.33-1.12s-.11-.55-.11-.55l-.78.89-.89.34-.89,1.55-.33.56s.33.45-.34,1.12c-.67.67-1.33,1.01-2.12,1.56-.78.56-.89,1-2.12,1.22-1.22.22-1.33.44-1.33.44l-.44.67c-.45.67-.66.34-1.22.67-.56.33-1.56,2.01-3.23,2.57-1.67.56,0,0-.34-.56-.33-.56,0,0-.55,0s-.11.56-.34,1.9c-.22,1.34,0,.77-.22,1.22-.23.45-1.01,1.22-1.56,1.67-.56.44-3.12,2.56-3.12,2.56,0,0-.67.11-1.67.11s-.89-.11-1.67-.45c-.78-.33-1-.44-2-.33-1.01.11-.56.45-1.45.45s-1.67,0-2.56-.12c-.9-.11-.78-.44-1.34-1.22-.56-.77-.67-.78-.89-1.34-.22-.56-1.22-.33-2.56-.66-1.33-.34-.89-.56-2.46-1.45-1.56-.89,0,0-1,.22-1.01.22,0,0,.55,1,.56,1,.34.56.34,1.23s-.23.89.89,1.67c1.11.78.78.33,1.56.55.78.23.56.23,1.45.45.89.23.33,1.01.56,1.33.22.34,1.11.68,2,1.12.89.44,1.23.33,2.01.89.78.56.67,1.23,1.01,2.12.33.89.22.78.77,1.67.56.89.12,2.22.12,3s-.12.78-.22,1.67c-.11.89,0,1.12,0,1.78s.22.89.22,1.67-.67.78-1.45,1.78c-.78,1.01-.56,1.67-.56,2.12s.89,1.45.89,1.45l-.56,4.46s-.89,3.34-1.01,4.01c-.11.67-1.45,1.23-2.56,1.33-.62.06-1.66.78-2.46,1.42.36.38.77.69,1.23.77Z"
          />
        </g>
        <path
          class="st343"
          d="M403.13,255.98c-.58-.15-1.57-.29-2-1-.44-.71-.57-.57-1.43-1.29-.86-.71-.71-.57-1.86-1-1.14-.43-1-.28-2.27-.28s-1.58,0-2.71-.44c-1.14-.43,0,0,0-.43s-.14-1-.14-2-.86-1.14-2.57-2.43c-1.71-1.28.43-1.42-.14-2.42-.58-1,0,0-.58-.15-.57-.15-1.56-1.43-2-2.71-.42-1.29.86-1,1.29-1.15.44-.14,1.43-1.43,2-2,.57-.57-.15-1.29-.15-1.85s-.43-1.15-.29-1.71c.15-.58,0-.72,0-1.43s0-1-.71-1.56c-.71-.57-2.82.08-2.82.08,0,0-1.07.54-3.21-.79-2.13-1.34-2.4-.27-2.4-.27,0,0-1.07.27-2.67.27s-2.93-1.07-2.93-1.07l.27-.8c.27-.8,0-1.33,0-2.67s0-1.07-.27-1.86c-.27-.81,0-1.34-.54-3.48-.53-2.13-.26-1.06-.26-2.93s0,0-.27-1.87c-.27-1.87,0,0-1.07-1.06-1.07-1.07-1.33-1.6-1.6-2.94-.27-1.34-1.06-2.4-1.06-2.4h-1.34s-1.6.54-2.4.54-1.6-1.07-1.6-1.07v-.8c0-.8-1.06-.8-1.06-.8,0,0-1.07,0-2.4.27-1.33.27-1.07.81-1.07.81,0,0,0,1.06-.26,2.39-.27,1.33-2.13,2.67-2.13,2.67h-3.74c-1.87,0-.79-1.34-1.06-2.14-.27-.8-1.07,0-2.41-.27-1.33-.27,0,0-1.34-.54-1.33-.54-1.06-1.33-1.06-1.33l-.54-1.6s-1.07-.79-1.87-1.6c-.8-.79-2.13,0-2.94,0s-1.07.27-2.13.27-1.87-.27-1.87-.27h-7.21c-2.66,0,0,0-.79-.79-.81-.81,0,0,0-.81s-1.6,0-2.67,0h-1.6s-2.13-2.13-4.27-2.4c-2.13-.27,0,0-.8,0s-.81-1.33-.81-1.33l.27-1.87s.02,0,.14-.06l-2.22-.26s-.96,0-1.92.96c-.97.97-1.16,2.12-1.16,2.12,0,0-.58-2.89-2.89-1.74-2.31,1.16-3.08,2.12-3.08,2.12,0,0,.19.58-1.35-.58-1.54-1.16-3.08-3.27-4.24-1.35-1.16,1.92-1.35,2.7-1.92,3.47-.58.77-.58,1.54-1.93,2.31-1.34.77-1.92,2.31-3.27,2.31s-6.35-.96-7.32-1.16c-.96-.19,0-.77-1.74-.39-1.73.39-.38-.58-1.73.39-1.35.96-1.35,1.92-2.12,1.92s-1.16-.77-2.7-.96c-1.54-.19-1.73-.96-3.08.19-1.35,1.16,1.35.58-1.35,1.16-2.69.58-2.69.38-4.43-.19-1.73-.58-4.62-2.7-5.59-1.54-.96,1.16-1.16,3.47-1.34,4.24-.19.77-.19,1.35-.58,2.12-.39.77.77,1.16-1.35,1.74-2.12.58-3.08.96-3.27,0l-.19-.96s-2.5-.39-3.66.77c-1.16,1.16-2.12,2.51-2.7,3.08-.58.58-.58.77-1.35,1.16-.77.39.77,3.27-.58,4.62-1.35,1.35-2.31,2.12-2.31,2.12,0,0-.19,1.74-.58,2.31-.38.58-1.54.77-1.73,1.35-.19.58,1.16,2.7-.19,4.24-1.35,1.54-4.24,1.74-4.24,1.74,0,0-.77-.97-1.35,1.34-.58,2.31-.58,3.85-.58,3.85,0,0,.19.39.38,1.54.19,1.16-2.12,2.5-2.12,2.5,0,0-.38.77-.77,1.54-.39.77-.77,1.92-.58,2.89.19.96,1.35,2.89,1.35,2.89l-.19,2.5s-.58.97-1.16,1.16l-.58.19s-1.54,1.93-2.12,3.27c-.58,1.35-.77,1.93-1.54,2.89-.77.96-.96,2.12-2.31,2.5-1.34.39-.96.39-2.5.58-1.54.19-.19-.58-1.54.19-1.35.77-1.54,1.16-2.7.77-1.16-.39-1.16-.58-2.12-.58h-1.92c-1.73,0-1.35-.19-3.27-.19s-2.12.38-3.47,0c-1.35-.39-1.54-.96-2.12-.96s0-.39-1.54,0c-1.54.38.77-.58-1.54.38-2.31.96-2.89,1.16-3.08,2.31-.19,1.16.96,1.93.96,1.93,0,0,1.34,2.31,1.34,3.08v3.27c0,.77-1.73,1.54.19,1.54s3.27.39,3.27.39v1.74c0,1.15-.19,1.92,1.74,3.08,1.92,1.16,1.16,0,2.69,1.35,1.54,1.34.77-.19,1.54,1.34.77,1.54.96,1.35.96,2.51s.19,1.74-.19,2.31c-.38.58,1.74-.39-.38.58-2.12.97-4.43,2.89-4.43,2.89,0,0-2.12,1.54-2.89,1.92-.77.39-2.51.39-4.04,1.35-1.54.96-1.16.39-2.7,1.73-1.54,1.35-.77.19-1.54,1.35-.77,1.16-.58.58-.77,1.92-.19,1.35-.19,3.09-.19,4.43v1.35s-.38,1.35-1.15,1.35h-2.7s-.39,0-.77.96c-.39.96.58.96-.39,2.12-.96,1.16-1.54,2.51-1.54,2.51,0,0-.58.77-1.54,1.54-.96.77-.77.77-1.74,1.92-.96,1.16.19,3.27-1.92,1.54-2.12-1.74-.58-1.35-3.27-3.09-2.7-1.73-4.04-3.08-4.04-3.08,0,0-.77-1.35-1.54-.39-.77.97-.96,1.93-.58,2.5.39.58.58.77.97,1.74.38.96-.19,1.16.38,1.73.58.58.96,1.35.96,1.35,0,0,.19,1.16,1.35,2.31.38.38.48.47.5.5,0,0,0,.01.01.02.04.03.17.17.64.64,1.35,1.35,1.74.77,2.12,1.92.39,1.16-.38,4.24-.58,4.82-.19.58-.39.77-.58,1.54-.19.77-1.16,1.16,0,1.74,1.16.58,1.54.58,1.93,1.35.38.77.58.77.58,1.73v2.51c0,.96.19,1.16.19,1.73s.19.77.19,1.54-.77,4.04-.39,4.62c.39.58.77,1.16.39,1.92l-.39.77s-.39.77-1.35,1.16c-.96.39-1.35-.19-1.73.77-.15.38-.41.69-.64.94.08,0,.18.01.26.02,1.54.19,0,0,.19.58.19.58.77.39,2.12.39s1.16-.19,2.12-.19,1.54.39,2.51.39.77.58.77.58l.58,2.31v1.73l.38,2.5-2.12-.19-.77.77c-.77.77-1.16,1.92-1.16,1.92,0,0-.77.58-2.7,1.54-1.92.96-.19,1.16-.19,1.92s0,1.16-.19,2.12c-.19.96-.77.58-1.35.96-.58.39-.58.96-.58,1.54s.96,1.92.19,2.5c-.77.58-2.5.19-2.5.19l.58,2.51-.19.77c-.19.77-.77.58-.96,1.16-.19.58,0,0,1.74.19,1.73.19.77-.19,1.16-.77.38-.58.77-1.54.77-1.54l1.92-.58c1.92-.58,1.74-.96,1.74-.96l.19-.58c.19-.58,1.16-.19,1.93-.58.77-.39,1.92.19,1.92.19,0,0,1.54,1.35,3.47,2.89,1.92,1.54,1.16,1.16,1.16,1.16,0,0,.38,1.92,1.73,3.27,1.35,1.35.77-.39,1.74-.58.96-.19,0,0,1.16.39s1.73.96,2.89.19c1.16-.77,1.16-1.16,1.16-1.16,0,0,1.54-1.54,3.27-2.89,1.73-1.35,1.35-.77,2.89-1.54,1.54-.77,0,0,1.16,0s.97.77,1.74.58c.77-.19.77-.58,1.54-1.34.77-.77.77,0,2.89.19,2.12.19,1.73.39,2.69.97.97.58.58,1.73,2.12,2.69,1.54.96,0,0,1.16.96,1.15.96,1.92,1.35,2.31,1.74.39.38,0,0-1.16,1.73-1.15,1.74.39.77,1.16.77s0,0,4.05,1.74c4.04,1.73,1.16.19,2.31,0,1.16-.19,0-.77,0-1.54s-.39-1.73-.58-2.69q-.19-.96-.38-1.93c-.19-.96-.58-1.34-.58-1.92s-2.69-1.92-4.43-3.27c-1.73-1.35,0,0-1.73-.77-1.74-.77-.96-.58-2.12-1.54-1.16-.96-.77-2.12-.19-2.69.58-.58.77-.97.77-.97,0,0,0-1.54-.19-2.89q-.19-1.35.77-2.7c.96-1.34,0,0,3.66-.19,3.66-.19.96-.19.96-.19l1.74-3.47s.19-1.74.38-3.27c.19-1.54-.19-.77-.19-1.54s-1.16-.96-1.16-.96v-1.92c0-.77-.39-1.16-.77-2.51-.38-1.35,0,0,.19-.77.19-.77.77-1.92.77-1.92l1.24-3.33s.44-2.2.77-3.63c.33-1.44.77-1.66,1.33-2.1.55-.44.99-.77,2.09-1.21,1.11-.45,1.1,0,1.88,0s1.87.22,3.53.77c1.65.56,1.21.22,1.21.22h1.1c.33,0,.22-1.21.56-1.87.33-.66.99-3.42,1.21-3.97.22-.55.12-1.33.12-1.33,0,0,.88-1.32,1.21-1.55.33-.22,1-.66,1.55-.99.55-.34.55-.66,1.1-1.33.56-.66.34-1.21.44-1.55.11-.33.66-1.32.66-1.32l2.87-4.53s1.98-2.87,2.65-3.42c.66-.55.44-.33,1.22-.55.77-.22.99-.11,1.33-.11s.21,1.1.44,2.21c.22,1.1.22.56.88.44.66-.11-.11-.77-.11-1.32s0-.77-.12-1.32c-.11-.55-.22-.78-.55-2.53-.34-1.77.22-1.11.88-1.77.66-.66,0,0,.77-.33q.78-.33,1.33-.66c.55-.33,0,0,0-.77v-1.21c0-.44.88-.44,1.21-.66.33-.22,1.33-.66,1.44-1.1.11-.44-.44-2.21-.44-2.54s-.66-.66-.66-1.54.88-.55,1.65-1.11c.77-.55,0-.88,0-1.43s-.11-.77-.11-1.22-1-.11-2.09-.55c-1.11-.44-.12-1.1-.12-1.43s-.11-1.99,1.55-3.31c1.65-1.33-.11-.44-.88-.88-.78-.45-.33-.45-.77-1-.44-.56-.99-1.65.23-2.64,1.21-1,.99-.33,1.76-1.1.78-.78.22-.78.44-1.44.22-.66.22-1.1.22-1.1,0,0-1.21-1.66-.44-2.76.77-1.11,1.54-.56,2.53-1.11,1-.56,0,0,0-.33s0-.44.33-1.21c.33-.78.45-.56,1.98-1,1.54-.44,0,0,.77.12.77.12.33.77.33.77,0,0-1.11.55.66,1.88,1.77,1.32.88,0,1.87,0h.78s.02,0,0,0c0,0,0,0,0,0v.99l.32,1.33c.32,1.33,0,0,.77-1.11.78-1.1.34-.77.34-1.87s0-1,.11-1.77c.11-.78.33-.44.66-.77.33-.34.44-.34,1.33-.44.88-.11,1.43.44,1.76.44s1.33-.44,4.09-.44,0,0,.88-.45c.88-.44,0,0,.99-.11s.66-.44.99-.66c.33-.22.45-.44,1.11-.77.66-.33.77-.22,3.31-.66,2.54-.44.32-.77.88-1.32.55-.55-.45-.99-.45-.99l-1.65.33-.88.33s-1,.44-1.55-.33c-.55-.77-.99.88-.99.88,0,0-.66.12-1.22.44-.55.33-.11.88-.22,1.33-.12.45-.88-.22-1.99-.99-1.1-.78-.44.99-.99,1.21-.55.22,0,0-.66-.22-.66-.22-.33-.56-.66-1.33-.33-.77,0,0-.77,2.21-.77,2.21-.77-.44-.77-.44,0,0-.44-1.33.66-2.32,1.1-.99,0,0,.44-.22.44-.23.55-.11,1.76-.22,1.21-.12.99,0,1.65-.22.66-.22.44-.33,1-.66.55-.32-.66-.99-.33-1.21.33-.22.88-.22,1.44-.44.55-.22,2.86.44,3.42.11.55-.33.88-.77,1.43-.99.55-.22,2.36.29,2.36.29l1.28-1.03c1.29-1.03,0,0,0-1.03s.52-1.8.52-1.8l2.56,1.03s1.04-1.03,2.06-1.54c1.03-.52,1.29-1.03,2.57-1.8,1.29-.77,2.57-1.03,4.88-1.8,2.31-.77,0,0,1.54-1.03,1.54-1.04,0,0,1.02-.52,1.03-.5.77-1.54,2.83-2.56,2.06-1.04,7.19-2.31,8.98-2.31h3.09c1.29,0,2.06,0,5.14.25,3.09.27,1.54.26,2.83,1.03,1.29.77,1.28,1.28,1.28,1.28,0,0,1.54,0,3.6.26,2.06.26,3.85,0,3.85,0,0,0,1.54,1.54,3.85,2.05,2.31.52,1.29.26,3.6.26s2.56,0,4.11.26c1.54.26,1.54.77,4.37,2.57,2.82,1.8,1.28,1.8,1.54,3.34.25,1.54,0,0,1.03,2.57,1.02,2.56,1.02,1.28,1.79,1.79.77.52,1.03.77,2.31,1.29,1.29.5,1.81.51,4.12,1.28,2.31.77,1.27,1.8,1.79,2.82.52,1.04.77,1.8,1.02,2.57.26.77,0,2.31,0,2.31,0,0,1.54.77,2.31,1.03.77.25.27,2.31.27,2.31,0,0,.5,1.54,2.56,2.56,2.06,1.04,1.54,1.03,3.33,2.31,1.8,1.29,0,0,.77,1.54.77,1.54,0,0,0,2.31s1.29,1.8,1.29,1.8h2.31c.77,0,1.54.26,2.31.77s1.03,1.28,1.54,2.05c.52.77,2.06,3.6,2.06,3.6l.51-2.06s.77-1.54,1.04-2.31c.25-.77.5-4.62.5-4.62,0,0,.27-2.31.52-3.33.26-1.04,1.54-6.94,1.54-7.97s.25-1.8.25-1.8l1.29-4.11,2.06-3.85s2.82-6.68,3.09-7.45c.25-.77,3.58-6.42,3.58-6.42l.26-1.16-1-.81s-.57-.28-1.14-.43Z"
        />
        <path
          class="st347"
          d="M465.49,207.26s-1.16,1.16-2.56,1.42c-1.41.25-.52-.39-.52-.39l-1.03-.13s-1.41,1.03-2.69,1.03-.52-.13-.64-.77c-.13-.64.64-.89,1.28-1.16.64-.26.9-.51,2.06-.64,1.16-.13.64-.77.13-1.03-.51-.26-.89-.13-.89-.13,0,0-1.29-.13-1.67-.13s-1.03.51-2.05,1.16c-1.03.64-.9-.26-2.06-.51-1.16-.26-1.8.9-1.8.9l1.16-2.31.51-1.28-.13-.39c-.13-.39-.9.51-2.31,1.16-1.42.64-.64-.77-.64-.77l.38-.26c.39-.26,1.03-.77,1.67-1.16.64-.39.51-.77.9-1.28.38-.52.77-.39,1.66-.64.9-.26.9-.9.9-.9,0,0,1.16-1.29,1.41-1.92.26-.64.26-.52,1.29-.64,1.03-.13.77-.77,1.02-1.28.26-.52-.13-.9-.51-2.7-.38-1.8-.51-.77-.51-1.54s-.39-1.03-.39-1.54-.9-.64-1.41-.77c-.51-.14-1.16-.9-2.44-1.93-1.28-1.03-.77-1.03-1.67-2.31-.89-1.29-.89-1.54-.89-2.06s-.39-.64-.89-1.28c-.51-.64-.65.26-.65.26,0,0,.13.64,0,1.41-.13.77,0,0-1.8.65-1.79.64-.64-.13-1.92-1.42-1.28-1.29-.64-.89-.77-1.41-.13-.52-2.82-2.95-2.44-3.6.38-.64.13-.77-.13-1.79-.25-1.03,0,0-.77-1.03-.77-1.03.77-2.19,2.7-2.19s1.16,0,1.54-.38c.39-.39-.13-.77-.52-1.54-.38-.77-1.16-.9-1.02-1.54.13-.64.51-.89,1.16-1.54.64-.65-.77-1.03-1.03-1.79-.26-.77.39-2.45,1.03-2.45s.51-.25.77-1.02c.26-.77.13-1.54.25-2.44.14-.9,0-1.41,1.03-2.44,1.03-1.03.13-.51.51-1.29.39-.77.9-1.16,1.54-1.67.64-.52.77-1.28.9-2.05.14-.77,0,0-.64-.64-.64-.64-.77.13-1.16.13s-.26-.52-.64-1.67c-.39-1.16.52-.77,1.29-1.54.77-.77,0-.77.39-1.41.39-.64,0-1.16,0-2.06s-.52-.39-.77-.9c-.26-.51-.52-.51-.52-.51l-.26.77.13,1.16-.38,1.02-.64.77c-.64.77-.77.64-1.67.9-.9.26-.77-.26-1.92-.9-1.16-.65.13-.64.64-1.28.52-.65.51-.65,1.66-1.16,1.16-.51.65-.9,1.42-1.67.77-.77,0-.77,0-1.67s-.77-1.03-.77-1.03l-.65.39c-.64.39-.64.25-1.28.64-.64.38-.9.52-1.8.77-.89.25-.51.26-1.16.39-.64.13-.51,1.29-.51,1.29l-.52.77.12.5-.55.89-.78-.66-.67-.44h-2.34s-2.9.11-3.46.11-2.34.11-2.34.11c0,0-.67,1-2.34,1.67-1.66.67-3.68.11-4.46-.11l.04,1.24-1.33,1.61v2.13s0,2.14-.53,3.47c-.54,1.33,0,0-1.6,0s-1.87-.53-1.87-.53c0,0-4.01-1.61-5.34-2.13-1.33-.54,0,0-1.06-.54-1.07-.54-1.07.27-1.07.27l-2.13.54-1.07.26s-1.06.27-2.66.27-1.07-.27-1.34-1.06c-.27-.8-1.33,0-3.2,0s-3.74-.27-5.34.27c-1.6.53-1.87,0-4.8,0h-1.6c-1.6,0-1.06.53-2.94.79-1.87.27-1.61,2.41-1.87,3.74-.27,1.34-2.13,4.27-2.13,4.27,0,0-1.33.8-2.41.8h-2.93s-1.34.27-2.4.27-1.07,0-2.67.53c0,0-.53,1.34-3.47,3.47-2.94,2.14-1.6,1.6-1.6,1.6,0,0-1.33,1.87-4.27,2.14-2.93.26-3.21-3.21-3.21-3.21,0,0-1.6-.8-2.39-2.13-.81-1.33-1.07-2.4-1.07-2.4l-1.06.27s-1.06.27-1.87.81c-.79.53-1.33.79-2.39.79h-2.14c-.8,0-1.87,1.07-1.87,1.07,0,0-3.73.53-4.53.53s-.8,3.47-1.6,4.01c-.8.53-1.34-.27-2.94-.54-1.6-.27-1.06-1.06-1.06-1.06,0,0-1.6.53-4,2.93-2.4,2.4-.8,1.06-1.33,2.14-.54,1.07-1.6,1.33-2.93,2.4-1.34,1.07-1.34,1.6-1.34,1.6l-2.4,1.6h-2.46l-.2,2.94s0,.8-.27,1.6c-.27.8-.27,1.34.27,2.4l.53,1.07s1.07.8,1.07,2.14.79,1.86,0,2.39l-.81.54s-1.33,1.87-.53,2.66l.8.81s-.53,1.06-1.06,1.87l-.54.8s1.33.8,0,1.34c-.74.29-1.05.41-1.19.47l1.05.13-1.05-.13c-.12.05-.14.06-.14.06l-.27,1.87s0,1.33.81,1.33-1.33-.27.8,0c2.14.27,4.27,2.4,4.27,2.4h1.6c1.07,0,2.67-.8,2.67,0s-.81,0,0,.81c.79.79-1.87.79.79.79h7.21s.8.27,1.87.27,1.33-.27,2.13-.27,2.13-.79,2.94,0c.8.81,1.87,1.6,1.87,1.6l.54,1.6s-.28.8,1.06,1.33c1.34.54,0,.27,1.34.54,1.33.27,2.14-.54,2.41.27.27.8-.81,2.14,1.06,2.14h3.74s1.87-1.34,2.13-2.67c.26-1.33.26-2.39.26-2.39,0,0-.26-.54,1.07-.81,1.34-.27,2.4-.27,2.4-.27,0,0,1.06,0,1.06.8v.8s.8,1.07,1.6,1.07,2.4-.54,2.4-.54h1.34s.8,1.06,1.06,2.4c.27,1.33.53,1.86,1.6,2.94,1.07,1.06.8-.81,1.07,1.06.27,1.87.27,0,.27,1.87s-.27.8.26,2.93c.54,2.14.27,2.67.54,3.48.27.79.27.53.27,1.86s.27,1.87,0,2.67l-.27.8s1.33,1.07,2.93,1.07,2.67-.27,2.67-.27c0,0,.27-1.07,2.4.27,2.14,1.33,3.21.79,3.21.79,0,0,2.11-.65,2.82-.08.71.57.71.85.71,1.56s.15.86,0,1.43c-.14.57.29,1.15.29,1.71s.71,1.28.15,1.85c-.58.57-1.57,1.86-2,2-.43.15-1.71-.14-1.29,1.15.44,1.28,1.43,2.56,2,2.71.58.15,0-.86.58.15.57,1-1.57,1.14.14,2.42,1.71,1.29,2.57,1.43,2.57,2.43s.14,1.57.14,2-1.14,0,0,.43c1.14.44,1.42.44,2.71.44s1.14-.15,2.27.28c1.15.43,1,.29,1.86,1,.86.72,1,.58,1.43,1.29.43.71,1.42.86,2,1,.57.15,1.14.43,1.14.43l1,.81s.39-.64,1.8-2.57c1.41-1.93.13-.9.25-1.42.14-.51,0,0,1.16-1.67,1.16-1.66,1.93-1.16,2.45-1.54.52-.39,1.28-.77,2.56-.9,1.29-.13.52-.38,1.03-.9.51-.51,1.03-2.56,1.92-3.34.89-.77,1.03-2.44,1.03-2.44,0,0,.13-1.67.25-2.18.13-.51.77-1.16.77-1.16l.9-1.03s1.41-1.29,1.79-1.42c.38-.13,1.16-1.03,1.8-1.28.64-.26.77-.26,1.54-.39.77-.13,1.28,0,2.05-.38.77-.39,1.29-.39,1.67-.65.39-.25,1.54-.77,1.92-.89.39-.13,2.44-1.16,2.44-1.16,0,0,2.06-1.41,2.95-2.31.9-.89,3.34-2.82,3.34-2.82l-.39-1.54s-1.66-1.03.52-1.54c2.19-.52,1.16,0,2.06,0s1.66-.26,2.31-.52c.64-.26.38-1.54.77-1.92.39-.39.51-1.03.51-1.03,0,0-1.16-.26-.77-1.54.39-1.29,1.16-.14,2.06,0,.9.13,1.54.13,2.31-.26.77-.38.77-1.03,1.16-1.54.39-.51,1.41-1.03,2.18-1.42.77-.39,2.06-.13,3.34-.64,1.28-.52,1.42-1.03,2.06-1.41.64-.39,2.06-1.16,2.69-1.54.64-.39,3.99-2.05,4.62-2.44.64-.39,1.67-1.03,2.06-1.67.38-.64-.9-.51-.9-.51Z"
        />
        <path
          class="st342"
          d="M77.39,384.94c-.71,0-.57-.85-.42-1.84.14-.99.14-3.25.14-3.25,0,0-.14-2.4,0-3.25.14-.85,1.42-2.82,1.42-3.68s-.86-1.55-1.28-1.55-.99,0-1.97-.14c-.99-.14-1.84-.85-2.68-.71-.84.15-2.12.28-2.54.28s-1.13-1.41-1.13-1.41c0,0-1.56-.84-2.54-.99-.99-.15-3.25.84-3.67.84s-.86.86-.86.86c0,0-.28,3.25-.84,4.09-.57.85-2.12,3.53-2.12,3.53l-.85,1.28h-1.69c-.99,0-1.28.14-2.55.57-1.27.42-1.83.14-2.25.14s-2.12-.99-2.55-1.13c-.43-.15-3.81,0-5.51,0s-2.12.99-2.12.99l-.71,1.13s-1.69.7-2.54.7-2.39-.14-3.95-.85c-1.56-.7-2.12-.99-2.55-1.7-.42-.7,0-1.41.29-2.12.28-.7.28-1.41.28-2.39s-1.26-1.42-2.12-1.98c-.84-.56,0,0-.7-.43-.71-.42-.71-.57-.71-.99s-1.13-1.13-1.84-1.7c-.7-.57-1.69.71-1.69.71,0,0-.99-.29-2.68.15-1.7.42-.85.7-.85.7,0,0-1.27,1.13-2.26,1.7-1,.57,0,0-1.84,0s-1.27.29-2.68.42c-1.41.15-1.27.29-2.39.86-1.13.57-1.28.14-2.12.14s-.43-1-.43-1.42-.14-1.13-.57-2.12c-.43-.99-.99-.71-1.41-.84-.42-.15-.99-.29-.99-.29l-.09.04s.09.11.09.11c0,0-.06-.09-.09-.11l-1.32.53-.71.29c-.71.28-1.7,0-3.53,0s-1.13,0-1.98.84c-.85.84-2.4,2.54-3.25,3.67-.85,1.13-.57,2.83-.57,3.25s.42,1.41.42,2.26,0,0-.71.99c-.7.99,0,0-.28.85-.28.85-.28,1.7-.99,2.68-.71.99-1.13.57-3.11.99-1.98.42-.86.15-1.28.71-.42.57-1.41.85-2.12,1.7-.71.84-.84,2.82-.84,2.82,0,0-.29,2.97-.57,4.24-.29,1.27-1,.14-1.56.14s-.71-.42-1.42-.99c-.71-.57-.7.42-1.13.99-.43.57-1.13,1.98-1.55,2.41-.42.42-.57,1.13-1.56,1.97-.99.85-.28,1.98-.42,2.68-.15.7.57,2.4.57,2.4,0,0,.42,2.12-.15,2.97-.57.84-1.41.57-1.41.57,0,0-.28.99-.99,1.83-.71.86-2.68-.28-3.39-.71-.7-.43-.99-.28-2.54-.28s-2.26.99-2.26.99c0,0,0,1.98-.28,2.68-.28.71-.71.99-1.13,1.28-.42.28-.57.14-1.13.56-.56.42,0,.85-.14,1.56-.14.71,0,1.26,0,1.26,0,0,0,1-.43,1.84-.42.84-.57.42-.99,1.55-.42,1.13.85,5.65.85,5.65l.29,1.98s.42,1.42.57,1.84.14,1.27.42,2.12c.28.85.85.57.85.57l.43,1.41s.56,1.13.99,2.12c.42,1,.57.29,1.41.86.86.57,1.28,0,1.98.28.71.28.14.99.29,2.12.13,1.13.42,1.55.42,1.55,0,0,.42.99.57,1.84.15.84,0,.99.29,1.97.28.99,1.12.57,1.69.99.57.42.71.42,1.55,1.97.85,1.55.15,1.42,0,2.83-.14,1.41-.56,1.27-.99,2.83-.42,1.55-1.97,2.96-2.39,3.53-.43.57-2.12-.15-2.12-.15,0,0-.86,0-1.28.15-.42.15-.28,1.41-.28,1.97s-.29.86-.71,1.98c-.42,1.12,0,1.12.57,1.69.57.57.99.43,1.83.71.85.29.57.57.99.85.42.28.14.85.57,1.56.43.71.43,1.55.43,2.82s1.13.85,2.26.99c1.13.15.99.99.99,1.84v3.24c0,1.13.43.57.57,1,.14.42-.21.87-.21.87,0,.49-1.09.73-1.09.73l-2.19.37h-2.56s-2.31-1.22-2.68-1.59c-.36-.37-2.18-1.34-2.18-1.34,0,0-2.56-.13-3.04.37-.49.48-1.09,3.4-1.09,3.4,0,0-.61.49-.98.61-.37.12-1.58,1.95-1.58,2.55s-.25.61-1.1.98c-.85.36-1.95.61-2.8.61s-2.07,0-2.44-.13c-.36-.13-2.91-1.7-2.91-1.7,0,0-1.58,0-2.8.74-1.21.73-2.07,2.18-2.43,2.67-.37.49-.49.73-.98,1.22-.49.48-1.7-.61-2.19-.86-.49-.24-1.09-.12-1.46-.12s-.73.25-1.22.61c-.49.36-.25.72-.73.97-.49.25-.86-.73-.86-.73,0,0-1.58-.12-1.94-.12h-6.45c-.48,0-1.1-.37-1.1-.37h-1.21s-.86.12-1.34.37c-.21.1-.59.31-.96.52l.17.09v1.72l-1.15,1.29s-.72.29-1.14,2.16c-.44,1.86,1,.72,1.43,1.14.43.43,2.3.14,2.86.29.58.15,1.73,2.44,1.73,2.44l2.15,1.72.87,1.72s1,.86,1.43,2.16c.44,1.29.44,3.58.44,3.58,0,0,.85.57,1.29,1.15.44.58.44.86.58,1.72.14.86,0,0,.72.58.72.57,1.29,1,2.15,1.58.87.58,2.16.72,3.59,1.29q1.44.58,3.16,1.29c1.72.72.86,1.15,1.15,1.72.29.57,1.14,2.29,1.14,2.29,0,0,1.01,2.73,1.01,3.31v2.29s0,.58-.43.87c-.44.29-.29,1.43-.29,1.43,0,0,0,1.3-.86,2.16-.87.86,0,1.14-.14,2.01-.15.85,0,1.72,0,1.72v2.15c0,.57,2.01.57,2.44.71.43.15,1.44.29,2,.29s1.16.43,1.73.87c.57.43.57,1,.57,1l.15,1.01,1.15.14s1.43,0,2.01.15c.58.15.87,0,2.01,0s1.01.15,1.87.57c.87.44.87.73.87.73v1.14l-.58.29c-.58.29-.58.44-.58.44,0,0,.73,1.14.87,1.86.14.71,1.58.43,1.58.43h2.87c.72,0,.15,1.58.15,1.58,0,0-.15.86-.43,1.87-.29,1-.44,2.44-.44,2.44l.15,1.01,1,1.14v1.15c0,.57-.15,1.01-.15,1.01v1.72l1.01,1.01s1,.72,1.43,1.58c.44.86.86,2.15,1.01,2.58.15.43,1.01.29,1.01.29,0,0,1.01-.85,1.58-1.43.57-.58.86-1.01.86-1.01,0,0,.57-.28,1.15-.28s.58.14.58.14c0,0,.57.43,1,.86.43.44,1.29.87,2.15,1.58.86.73,1.72,1.59,1.72,1.59h2.44c1.29,0,1.72-1.15,1.72-1.15,0,0,1.15-.29,1.72-.44.58-.14,0,0,1.44,1.3,1.43,1.3,1.29,2.29,1.43,3.02.15.72,0,.86.58,1.58.58.72.29.58,1.15,1.58.86,1.01,0,0,0,.72s.14,1.29.14,2.16-.57,1.29-.86,1.87c-.29.57.15,1.29.15,1.29,0,0,.28,1.72.28,2.15s.15,2.87,0,4.3c-.15,1.44-2.37,1.01-2.37,1.01-1.17.96-1.94,2.13-2.32,3.69-.19.74-.21,2.42-.17,3.96.66.25,1.3.5,1.42.58.28.19.94.19,1.78.19s2.35.1,2.35.1c0,0,1.32.47,1.32.84s-.37.28.37.84c.74.57,1.13.47,1.13.94s-.38.84.09.94c.47.1.47-.66,1.13-.19.65.47,1.32.75,1.32.75,0,0,.47.38.18,1.03-.28.66-.93-.18-.66.94.28,1.13.38,1.13.47,1.78.09.66.28,1.04.28,1.61s-.37,1.02.29,1.4c.65.38.18.47,2.06.47s2.16.09,2.91-.09c.75-.19,1.69-.38,1.69-.38,0,0,.37-1.31,1.21-.93.85.37,1.51,2.81,1.51,2.81,0,0,.09.84,1.03,1.4.94.57,1.69,1.13,1.69,1.13,0,0,1.03,1.02,1.5,0,.47-1.04,1.22-1.13.47-1.88-.75-.75-.28.09-1.13-1.13-.84-1.22-.84-.37-.84-1.22s.09-1.21.09-1.21c0,0,.38.37.47-.19.09-.56-.19-.56.19-1.22.37-.65.75-.94,1.22-1.59.46-.66,1.6-1.32,1.6-1.32,0,0,1.41-.75,1.31-2.44-.1-1.68-1.5-2.62-1.5-3.28s-.65-.94.38-1.69c1.03-.74,2.71-1.41,2.71-1.41,0,0,.19-2.44.19-2.91s-.1-1.31-.1-1.31c0,0-1.32-.19-1.32-.75s-.37-1.69.1-1.69.28.66.47,0c.19-.66.19-1.59.19-1.59,0,0-.28-.57-.1-1.22.19-.66-.09-2.16.19-2.72.28-.56,1.31-1.59,1.31-1.59,0,0,.47.09.85-.47.37-.57.85-1.04,1.12-1.6.28-.56-.28-.65.19-1.69.47-1.04.18-1.21.94-1.97.75-.75.47-1.69,1.78-1.78,1.32-.09,2.81-1.32,2.81-1.32,0,0,1.41-.84,1.41-2.25v-2.06s.47,1.12.57-.19c.1-1.31.1-2.06.1-2.72s-.85-.93-.85-.93c0,0-.65-1.69-.38-1.69.29,0,1.97-.1,1.32-.84l-.65-.74s-.37-.94-.29-1.41c.09-.47.09-.66.66-1.69.57-1.03.94-.85.94-1.6s-.37-.75,0-2.07c.37-1.31.37-1.87.37-2.16s-.28-.56.47-1.5c.75-.94.94-1.03.94-1.97s1.88.29-.19-2.06c-2.07-2.35-2.53-2.92-2.53-2.92,0,0-1.31-2.72-1.41-3.47l-.09-.75s-.19-2.35.09-4.04.57-2.53.66-2.9c.09-.38.28-1.04.28-1.04l-.15-1.2c-.1-.06-.22-.15-.42-.3-1.22-.94-1.59-1.41-1.59-1.41,0,0-.94-.65.19-.84,1.13-.18.75.1,1.5,0,.75-.1.47.46.75-.1.29-.56.29.47.29-1.31s.37-3.47.74-3.84c.37-.37,1.97-6.09,2.35-7.69.37-1.59,3.38-10.32,3.66-12,.28-1.69,1.03-5.44,1.03-5.44l1.6-5.34.57-4.32,1.97-6.75.84-1.03s.75,1.32.94.18c.19-1.12.75-6.84.85-8.16.09-1.32,1.12-5.62,1.12-5.62,0,0,2.25-5.35,3.19-6.57.94-1.22,2.53-3.85,2.81-4.79.28-.94.47-1.31.47-2.25s.09-3.38.09-4.03,1.03-1.5,1.5-1.69c.47-.19.38-.19,1.6-.19s1.31.75,2.16.1c.84-.66.37-.94,1.31-1.04.94-.09,2.53-1.12,1.6-1.12s-.38.1-1.5.1,0,.37-1.13,0c-1.12-.38-2.43-.94-1.21-1.04q1.21-.1,1.68,0c.47.1.57,1.21.84.1.29-1.13.47-1.22.29-1.6-.19-.37-.19-.28-.94,0-.75.29.18.75-1.31-1.03-1.51-1.78-.85-.75-1.51-1.78-.65-1.03-1.03-.28-.65-1.03.38-.75-.56,0,.85-1.51,1.4-1.49.93-1.78,1.87-1.78s1.5,1.04,1.5,1.5.38.65,1.22.56c.84-.09,1.4-.19,1.87-.47.47-.29.94-.75.94-.75,0,0,.47-.46.57-.74.1-.29-.19-.84.19-.84h.38s1.21.28,1.21-.19.29-.74,0-1.12c-.28-.38-.09-.57-.65-.75-.56-.18-1.03-.47-1.13-1.12-.1-.66.57-1.6-.1-1.6s0-.28-1.12.19c-1.13.47.18,1.88-1.69.66-1.88-1.22-1.97-1.22-1.88-1.88.09-.66.38-.84.38-1.78s.09-1.69.74-2.63c.66-.94,1.03-2.53,1.22-3.66.19-1.12-.56-1.03.29-1.49.84-.47,1.31.19,1.31-.66s-.47-1.32-.47-1.88.37-1.4.37-1.4c0,0,.65.94.74,1.59.1.66-.56.84.47.84h1.88s.47.47,1.31,0,.38-.47.94-.94c.57-.46.38-.47,1.22-1.31s.65-.37.84-.84.38-1.5.38-1.5l.75-1.6s1.12-.76.47-1.13c-.66-.37-.75-.09-.75-1.21v-1.97s.09-1.6,1.22-1.97c1.13-.38.94,2.25,1.5,1.41.56-.85.56-1.6,1.12-2.07.57-.47.37-.28,1.59-1.03,1.22-.75,1.5-1.13,1.5-1.13,0,0,.85-3.47,1.5-2.44.66,1.03.56,1.41.94,1.6.37.18-.29,1.03.74.28,1.04-.74,1.41.95,1.13-1.4-.29-2.35.09-3.1.09-3.1,0,0,.65-.93.65-.28s1.41,2.44,1.22.66c-.18-1.78.57-2.63,1.04-3,0,0,0-.01.02-.02-.37-.17-.76-.33-1-.33-.57,0-1.41.43-2.12.43Z"
        />
        <path
          class="st342"
          d="M108.81,353.73c-.66-1.68,0-1.88-1.41-1.88s-2.63-.1-2.63-.1c0,0-2.44-2.43-2.53-1.49-.09.93.57,1.41-.19,1.69-.75.28-1.68,1.04-2.81,1.12-1.12.09-2.25,0-1.97-1.03.28-1.04.94-2.82-.19-1.41-1.12,1.41-2.91,2.82-3,1.41-.09-1.41-.94-2.82-1.22-2.45-.28.37-.65,1.32-.65,1.32,0,0-1.41-.93-1.88-1.12-.47-.19-.84-.38-.84-.38,0,0-.85-1.4-1.51-.85-.65.56-1.59.93-1.59.38v-1.5s.57-1.41,1.03-1.88c.46-.47,1.4-.84,1.5-1.31.1-.47.74-.19,0-1.04-.75-.84,1.5-1.88-.38-1.59-1.88.28-2.53,2.25-2.53,2.25,0,0-1.04,1.12-1.49,1.21-.47.1-1.69-.18-1.69-.18,0,0-1.31.09-.19-1.03,1.13-1.13,1.6-1.22,1.6-1.22,0,0,.09-1.31.66-1.78.57-.47.84-.47,1.21-.94.38-.47.38-2.25,1.04-3.19.66-.94,1.32-1.7,1.6-1.88.29-.19,1.13-.38,1.13-.38,0,0,2.43-.28,2.53.09.09.38-.47.46.94.46s2.25-.18,2.25-.18c0,0-.18-.76.94-.94,1.13-.19.38-.19,1.13-.19s3.19.84,2.06-.47c-1.13-1.31-1.88-1.59-1.88-1.59,0,0,.37-1.04-.38-1.5-.74-.47-.65-1.6-.47-1.88.19-.28-.1-1.49-.84-.46s-.56,2.07-.74,2.44c-.19.37-.38,1.6-.38,1.6,0,0-1.68.84-1.97.66-.28-.19,0-2.45-.37-2.16-.38.28-2.25,2.16-2.25,2.16l-1.5-.85.1-3.56s-.47-1.13-.75.09c-.29,1.22.09,2.81-.56,2.91-.66.1-1.41.1-1.41.1,0,0-1.6-.75-1.5-1.31.1-.57-1.12-.37-1.12-.37l-5.25-.38s-2.53,1.5-.47-.47c2.07-1.97,1.97-1.97,2.25-2.34.29-.38-.47-1.04.66-.75,1.13.28-.37,1.4,1.13.28,1.5-1.13,1.59-2.25,1.59-2.25l1.88-.38s1.97-.37.28-.37-3.75.09-3.75.09l-.75-.56s.29-1.6-.84-.38c-1.13,1.22-2.91,1.88-3.47,1.88h-1.13c-1.69,0,.38-.47-2.34.19-2.72.65-2.63,2.52-3.57.56-.93-1.97-2.72-1.59-.93-2.81,1.78-1.22,1.03-.19,1.5-.57s1.22-1.88,1.88-3.66c.66-1.78,1.21-3.38,1.21-3.38,0,0,5.07-1.69,5.35-3.38.29-1.69.94-2.72,1.23-3.19.28-.47.46-1.41.46-1.41,0,0-.84-2.35.29-2.72,1.13-.38,1.97-.46,2.25-.93.28-.47.57-1.41.57-1.41,0,0,2.06-1.31-.19-.93-2.25.38-2.81.65-3.37,1.22-.57.57-.57.09-1.69.28-1.13.19-1.5.29-2.91.85-1.41.56-3.85,1.4-4.41,1.5-.57.09-1.13-.28-1.88-.28s-1.22-.1-1.22-.1c0,0-1.22-.66-1.6-.75-.37-.09.28-.94-1.04-.09-1.32.84-1.22,1.04-1.96.74l-.76-.28s-1.59-2.44-2.25-2.53c-.65-.1-1.22-.28-1.22-.28,0,0-.65-1.22-.94-1.22s-.94-.37-.94.37.37,1.32-.28,1.13c-.66-.18-1.13-1.41-1.13-1.41,0,0,.19-1.6-.56-1.69-.75-.09-.56-1.03-.75-.09-.18.94.1,2.35-.37,2.06-.47-.28-.57-1.31-.57-1.31,0,0-.93-.38-.84.47.1.84.29,1.5.1,1.97-.19.46-1.31.46-1.31-.1v-1.12h-.94s-.59-.11-.97,0c-.14.1-.37.22-.24.1.05-.05.15-.08.24-.1.17-.13.16-.2-1,.38-2.06,1.04-2.72,1.31-2.72,1.31,0,0-.85.94-2.63,1.23-1.78.28-.84.65-2.63.09-1.78-.56-2.35-.94-3.09-1.03-.75-.1-4.13-2.06-4.6-2.16-.47-.1-1.04,0-1.22-.76-.19-.74-.75-4.03-.75-4.03l-.75-3.47s-.65-2.91-.56-3.38c.09-.47-.38-1.78.37-2.25.75-.47,2.72-1.22,2.72-1.22,0,0,.94-1.21,2.16-.47,1.21.75.37,1.97,1.59,2.16s1.23,0,2.72.19c1.5.18,2.53.84,2.53.84,0,0,1.13.84,1.22-1.22s.18-2.63,1.21-2.81c1.04-.19,5.73-.29,5.73-1.88s-1.87-2.9-1.97-3.74c-.1-.85-1.04-2.26.28-2.45,1.32-.18,4.13.66,4.13.66,0,0,1.32,1.5,2.25,1.5s2.35-.09,2.35-.09c0,0,.37-.38.37-1.41s2.07-4.88,3.1-6.28c1.04-1.4,1.41-2.91,1.31-3.38-.09-.47.19-2.06-.09-3.09-.28-1.04-.09-2.53-.09-2.53,0,0,.65-1.78.74-2.44.1-.66,0-2.35,0-2.35,0,0-.57-4.87-.74-6.09-.19-1.22,1.31-.66-1.13-2.54-2.43-1.87-2.72-2.34-3-2.71-.29-.38-1.22-4.31-1.22-4.31,0,0-1.87-.57-1.97-1.13-.1-.56-.57-1.6-.57-1.6,0,0-1.5-2.25-2.15-2.07-.66.19-1.03.29-1.32.29s-.65-.84-.65-.84l-1.32-1.41s0,.75-.84.75-2.44-.56-2.44-.56l-.19-.37s.56-.46-.37-.56c-.94-.1-1.97-.76-1.97-.76,0,0,.1-.93-.65-.74-.75.18-1.5.28-1.69.74-.19.47.18,1.04-.19,1.5-.37.47-.94.94-.94.94,0,0-.66.47-.66-.28s.29-1.21,0-1.4c-.28-.19-.18,0-.74.28-.57.29-.47.47-.94.57l-.47.09s-1.12.57-1.59.18c-.47-.37-.57-.93-.94-.56-.38.37-.47.93-.47.93,0,0-.94.66-1.32.66h-.75s-1.03-.1-1.13.74l-.1.84c-.1.85-.37,2.16-.37,2.16,0,0-2.44-.29-2.44.47s.57,1.79.1,2.16c-.47.37-1.12,1.68-1.12,1.68,0,0,.18.94-.19,1.13-.37.19-1.04-.28-1.6.09-.56.38.48-.28-1.03,1.03-1.51,1.31-1.13,1.12-1.98,1.78-.84.66-1.03,1.13-1.03,1.13,0,0-1.13,1.03-1.69,1.4-.56.38-1.96,1.23-1.96,1.23,0,0-.84-.66-1.69-.47-.85.18,1.03-.1-1.6.28-2.62.37-2.15-.19-4.41-.57-2.25-.37-.57-.37-3.09-.47-2.54-.09-.19.28-3.1-.09s-3.28-1.13-3.56-1.31c-.29-.19-1.41-1.22-1.41-1.22l-.29-1.59s-1.21-.57-1.5-.1c-.28.47,3.2.84-.28.47-3.47-.37-3.84-.47-3.84-.47,0,0-1.22-.19-1.78-.19s-2.44-.28-2.44-.28c0,0-.71.65-1.28,2.77-.58,2.12-.19,3.47-.19,3.47,0,0,1.54,1.35,2.12,1.93.58.58.19,1.16-.77,2.69-.96,1.54,0,0-.77.58-.77.58-.39,1.16-.77,2.31-.38,1.16,0,1.34,0,1.34,0,0,0,.77-.38,1.74-.39.96-.96,0-.96,0h-4.05c-.58,0-2.51-.19-2.51-.19l-1.34-.39h-2.5s-.77.19-2.51.19h-2.51,0s-1.54-.77-2.12-1.35c-.58-.58-1.35.58-2.5.58h-3.09c-1.16,0-1.35.38-3.08,1.92-1.73,1.54-3.66,2.12-4.62,3.47-.96,1.35,0,0,0,1.54s-.77.96-1.54,1.73c-.77.77-.77.19-2.31.96-1.54.77-.96.77-1.16,1.54-.19.77-.77,1.35-.96,2.51-.19,1.16-.19,1.34-.39,2.5-.19,1.16,0,2.31-.19,3.27-.19.97,0,1.74-.58,1.93-.58.19-.77-.19-1.54,0-.77.19-1.16.96-1.16,1.73s-1.73,2.7-1.73,2.7l-.97.58.39,1.35.77.77.58,1.54s.96,1.16,1.35,1.73c.38.58,0,1.74,0,2.31s-.19,2.12-.96,3.27c-.77,1.16.58,1.35.58,1.35v1.35l-.58.39c-.58.38-1.93,0-1.93,0l-1.73.19-.19,1.16v1.74l.58.77s1.16.39,2.7,1.35c1.54.96,0,0,0,.58s-.96.58-.96.58l-.96.77-.19,1.16s.77.58,2.12,1.54c1.35.96.77.58,2.89,1.35,2.12.77,1.54,2.12,1.54,2.12l-.58,1.16c-.58,1.16,0,0-.77.38-.77.39,0,1.16,0,1.16v1.92c0,.77-.38.77-.58,1.35-.19.58-.96,2.12-1.35,2.7-.39.58-.39.96-1.73,2.31-.58.58-1.15.84-1.62.99.45.18.76.29.76.29l.14.99s3.11.71,4.67,1.27c1.55.56,2.12,1.41,2.54,1.83.42.43.42,1.55.42,1.55,0,0,1.28,1.42,2.12,1.84.86.42,1.84.42,2.68.57.85.14,1.7,0,2.68.14.99.14.43,1.55.43,1.55,0,0,.99,1.69,1.41,2.26.43.57,1.41.85,2.4.85s1.7-1.41,2.12-1.84c.42-.42,1.7-1.83,1.7-1.83v-4.52c0-.57.57-.7.57-.7,0,0,.28-1.56.28-2.82s-.84-1-1.41-1.42c-.57-.42-.42-.57-.85-.99-.43-.42-1.13-1.55-1.69-2.39-.57-.86,0,0-.57-.57-.57-.57-.99-.99-.99-1.7s0-1.27.28-2.26c.28-.99.71-2.11,1.13-3.11.42-.99.14-.99.14-.99,0,0,.7.15,1.27.29.57.14,1.13-.14,1.98-.42.85-.29,0,0,.71-.57.71-.57,1.7-1,3.1-1.27,1.42-.29,1.42,0,1.84,0s2.39.42,2.96.57c.57.14,2.68.71,4.24,1.13,1.55.42.43,1.26,1.41,2.26.99.99,1.84.56,1.84.56,0,0,3.39,3.82,3.96,5.66.57,1.83-.15.84-.29,1.41-.14.57,0,.84.29,1.27.28.43.42.85.84,1.42.42.57.57,1.7.71,2.68.14.99.57,1.55.57,1.55,0,0,1.12,0,2.11.14.99.14.71.43,1.13,1.13.43.7.57.57.85.99.28.42.84,1.7,1.27,2.68.43.99.85,3.81.85,4.24s.57.71,1.41,1.84c.86,1.13,1.55,2.96,1.55,3.67s.57.71,1.98,1.28c1.41.57,0,0-.14.84-.15.84-1.28,1.28-1.28,1.28,0,0-.42,1.13-.57,2.26-.14,1.13.71,1.41.71,1.41,0,0,.42,2.96.57,3.67.15.71,0,3.11.29,3.67.28.56,0,.71.42,1.41.42.71.7.42,1.41.99.71.57.57,1.13.99,1.84.43.7,1.42,1.13,1.84,1.27.42.14,2.26.99,2.68,1.84.39.77,1.54,2.3,1.75,2.58l.09-.04s.57.15.99.29c.43.14.99-.15,1.41.84.43.99.57,1.7.57,2.12s-.42,1.42.43,1.42.99.43,2.12-.14c1.13-.57.99-.71,2.39-.86,1.42-.13.85-.42,2.68-.42s.84.57,1.84,0c.99-.57,2.26-1.7,2.26-1.7,0,0-.85-.28.85-.7,1.69-.43,2.68-.15,2.68-.15,0,0,.99-1.28,1.69-.71.71.57,1.84,1.28,1.84,1.7s0,.57.71.99c.7.43-.15-.13.7.43.86.56,2.12.99,2.12,1.98s0,1.7-.28,2.39c-.29.71-.71,1.42-.29,2.12.43.71.99,1,2.55,1.7,1.56.71,3.1.85,3.95.85s2.54-.7,2.54-.7l.71-1.13s.42-.99,2.12-.99,5.08-.15,5.51,0c.43.14,2.12,1.13,2.55,1.13s.99.28,2.25-.14c1.27-.43,1.56-.57,2.55-.57h1.69l.85-1.28s1.55-2.67,2.12-3.53c.57-.85.84-4.09.84-4.09,0,0,.43-.86.86-.86s2.68-.99,3.67-.84c.99.15,2.54.99,2.54.99,0,0,.7,1.41,1.13,1.41s1.7-.13,2.54-.28c.84-.15,1.69.57,2.68.71.99.14,1.55.14,1.97.14s1.28.71,1.28,1.55-1.28,2.83-1.42,3.68c-.14.85,0,3.25,0,3.25,0,0,0,2.26-.14,3.25-.15.99-.29,1.84.42,1.84s1.55-.43,2.12-.43c.24,0,.63.16,1,.33.47-.38,1.29-1.2,1.01-1.66-.29-.47-.66-1.03-.66-1.03,0,0,.47-.93.57-1.69.1-.75-.66-1.31-.84-1.59-.19-.29-.29-.37-.19-.66.1-.28.38-3,1.04-1.5.66,1.5,1.68,2.26,1.68,1.5s-.37-1.13-.47-1.68c-.09-.57-1.12-.85.1-1.32,1.22-.47,1.6.85,1.6.85,0,0-.09.66.56.47.66-.19-.47-.85.66-.19,1.12.65,1.59-.75,1.59-.75,0,0,1.5-.28,1.22.56-.29.84-.75,1.5.09.84.85-.65-.47.85,1.6-1.4,2.06-2.25,1.59-2.91,2.06-2.25.47.65.85.47.75,1.21-.09.75-.46,1.69.38,1.22.84-.47.46.37.84-.47.38-.85,0-.65.56-1.32.56-.65.66-1.41,1.88-2.15,1.22-.75,1.87-.94,1.97-1.32.09-.37.57-.57-.75-1.41-1.32-.84-1.97-1.6-2.35-1.13-.37.47-.29,1.69-.29,1.69,0,0,.29,2.63-.56,1.12-.85-1.49-.94-2.72-1.22-1.69-.29,1.04-.38,2.63-.85,2.16-.46-.47-.36-.85-.46-1.87-.1-1.03-1.03-1.88-1.03-1.88,0,0,1.21-.94,1.49-1.12.29-.19,1.88-1.32,1.88-1.32,0,0,.57-.18.94-1.21.37-1.04.1-1.22,1.04-1.31.94-.1,1.78.08,1.78-.66s1.13-.85.75-1.22c-.37-.37-1.32-1.88-1.88-1.31-.56.56.29,1.31-.74,1.03-1.04-.29-1.04-1.22-1.04-1.5s.1-2.35.1-2.35c0,0-1.31-1.41-.19-1.13,1.13.29,1.04.75,1.88,1.22.85.47,1.23,1.88,1.69.94.46-.94.19-2.35.19-2.35,0,0-.38-.56.84-.93,1.22-.38,1.68-.94,1.68-.94,0,0,.57-.19.66.37s1.22.74,1.22.74c0,0,.1-1.68.94-1.68s1.41.1,1.41.1c0,0,1.5,0,1.6.56.09.56,2.26,1.97,1.6.29Z"
        />
        <path
          class="st342"
          d="M-111.35,342.16h2.25c.88,0,.59-.1,1.07-.3.49-.2,1.86-.1,3.03-.1s1.17,0,1.66-.1c.49-.1,0,0,.49-.68.48-.68-.3-.59-.3-1.27s-.58-1.08-.69-1.66c-.1-.59-.39-.49-.78-1.18-.39-.69-1.07-1.17-1.26-1.85-.2-.69.21-1.07.21-1.07.42,0,1.27-.42,1.83-.71.57-.28,1.7-1.26,1.7-1.26,0,0,1.41-.15,2.26-.43.84-.29.28-1,.57-1.55.28-.56.28-.57.99-.71.71-.15.84-.29,1.83-.99,1-.71,0,0,.29-.56.28-.57,0-.86.28-1.84.29-.99,0,0,.29-.57.28-.57.99-.71,1.69-.99.7-.29.85,0,1.83,0s1.28.42,2.12.71c.86.28.85.14,1.55-.15.71-.29.99-.15,1.42-.15h1.41l1.84.29s.42-1.42.56-1.98c.15-.57.85-2.12,1.13-2.68.29-.57.14-1.83.14-1.83,0,0,.14-1.7.57-2.69.42-.99,1.55-.42,1.55-.42l.84,1.41s.43.85.86,1.27c.42.43,1.41,0,1.97,0s2.4,0,3.1.14c.71.14.85.85.85.85,0,0,.99,1.27,2.25,1.97,1.28.71,2.68,1.7,2.68,1.7,0,0,2.26.42,3.25.42s2.26,1.41,3.39,1.98c.48.24.89.42,1.22.56.47-.15,1.04-.41,1.62-.99,1.34-1.35,1.34-1.74,1.73-2.31.39-.58,1.16-2.12,1.35-2.7.19-.58.58-.58.58-1.35v-1.92s-.77-.77,0-1.16c.77-.38.19.77.77-.38l.58-1.16s.58-1.35-1.54-2.12c-2.12-.77-1.54-.39-2.89-1.35-1.35-.96-2.12-1.54-2.12-1.54l.19-1.16.96-.77s.96,0,.96-.58,1.54.39,0-.58c-1.54-.96-2.7-1.35-2.7-1.35l-.58-.77v-1.74l.19-1.16,1.73-.19s1.35.38,1.93,0l.58-.39v-1.35s-1.35-.19-.58-1.35c.77-1.16.96-2.69.96-3.27s.38-1.73,0-2.31c-.39-.58-1.35-1.73-1.35-1.73l-.58-1.54-.77-.77-.39-1.35.97-.58s1.73-1.93,1.73-2.7.39-1.54,1.16-1.73c.77-.19.96.19,1.54,0,.58-.19.38-.96.58-1.93.19-.96,0-2.12.19-3.27.19-1.16.19-1.34.39-2.5.19-1.16.77-1.74.96-2.51.19-.77-.39-.77,1.16-1.54,1.54-.77,1.54-.19,2.31-.96.77-.77,1.54-.19,1.54-1.73s-.96-.19,0-1.54c.96-1.35,2.89-1.92,4.62-3.47,1.73-1.54,1.92-1.92,3.08-1.92h3.09c1.15,0,1.92-1.16,2.5-.58.58.58,2.12,1.35,2.12,1.35h2.5c1.74,0,2.51-.19,2.51-.19h2.5l1.34.39s1.93.19,2.51.19h4.05s.58.96.96,0c.38-.96.38-1.74.38-1.74,0,0-.38-.19,0-1.34.39-1.16,0-1.74.77-2.31.77-.58-.19.96.77-.58.96-1.54,1.35-2.12.77-2.69-.58-.58-2.12-1.93-2.12-1.93,0,0-.39-1.34.19-3.47.58-2.12,1.28-2.77,1.28-2.77,0,0-1.88-.57-2.72-.85-.85-.28-2.53-1.41-3.94-1.5-1.41-.09-1.98-.28-1.98-.28,0,0-1.12-.1-1.78-.19-.66-.09-1.21-.37-1.88-.56-.65-.18-1.22-.57-1.4-.94-.19-.37-.29-.93-.29-.93l-.74-1.13-.38-.65s-.65.84-.84-.09c-.18-.94-.28-1.04-.28-1.41s0-1.03-.28-1.22c-.29-.18-1.5-2.25-1.5-2.25l-.28-1.03s-1.03,0-1.22-.38c-.18-.37-.74-1.5-.93-2.06-.18-.57.09-.1-.65-1.6-.75-1.49-.94-1.96-.94-1.96,0,0-.37-.19-.65-.94-.29-.75-.66.09-.29-1.22l.37-1.31-1.12.19s-.95-.02-.47-.67c.37-.51,1.3-1.64,1.3-1.64,0,0,.1-1.4-.38-1.92-.48-.53-.73.19-1.11.77-.39.58-.34.19-.29-2.02.05-2.22-.05-.58-.39-1.88-.33-1.3-.77.53-1.25-.19-.48-.73.1-.24.68-.77.58-.53.24-.48.87-.91.62-.43.39-.1,2.07.1,1.69.19.15-.62-.38-1.73-.53-1.11-.87.05-1.3.29-.44.24-1.35.68-3.56,1.02-2.22.33-1.92-1.35-1.92-1.35,0,0-.68-2.84-.68-3.27s1.25-.39,2.6-.39.19-.53.62-1.3c.44-.77.63-.38,1.35-.67s.34-1.25-.1-2.46c-.43-1.2-.53-1.49-.48-2.65.05-1.16.05-.58.82-.58s.34.62,1.35,1.4c1.01.77.05-.44.24-1.59.19-1.16-.14-.53-1.3-1.45-1.16-.91-.82-.62-.68-1.25.15-.63.39-.29,1.54-.87,1.16-.58.19-.77.34-1.16.14-.38,1.06-.29,1.06-.72s-1.69-.24-.87-1.25c.82-1.01,0-.43.58-1.54.58-1.11.62-.38.96-1.11.34-.72,0-1.2.19-2.17.19-.96-1.2-.82-2.75-1.25-1.54-.44-.77.67-1.2,1.16-.43.48-.29.38-1.06.48-.77.1-.29.05-1.06.87-.77.82-.62.91-1.11,1.3-.48.39-2.17,1.97-3.23,2.07-1.06.1-1.62.4-1.62.4-.92.92.65,3.03-2.91,2.9-3.55-.13-2.64-1.58-4.88-2.24-2.24-.66-2.9-1.18-2.9-1.18l-2.37-1.33.52-1.06s.66-.39-1.32-.39h-2.9c-1.72,0-1.32-.13-2.37-.13s0-.79-1.18.52c-1.19,1.33,0,.41-1.59.66-1.58.27-2.11.79-2.11.79,0,0-1.06,1.58-1.85,1.19-.79-.39-1.19-.53-1.71-1.05-.53-.53,0-.53-1.06-.53,0,0-1.24,0-2.1,0s-1.3-.29-1.49.19c-.19.48-.63,1.54-.82,1.69-.19.15-.72.58-1.11.72-.38.15-.87-.19-1.2.63-.33.82-.58,1.63-.58,2.17s1.11.38-.05.87c-1.16.48-1.45.87-1.45.87,0,0-4.43,2.17-4.67,2.17s-4.72.68-5.49.29c-.77-.39-1.16-.44-1.16-.72s.73-1.01-.05-1.01-.67.09-2.12.09h-1.83s-.48-.72-.87-.14c-.39.58-.44,1.06-.44,1.54v.91s.39,1.2-.38,1.59c-.77.39-1.25.67-1.54,1.01-.29.34-1.01.91-1.01.91,0,0-1.45.05-2.02.1-.58.05-.92.15-.92.15l-.19,1.3s-.39,1.78-.48,2.17c-.1.39-.67,1.16-1.06,1.78-.39.63-.67,1.74-.96,1.78-.29.05-.48-.34-1.11-.19-.63.15-1.06.77-1.06,1.3s-.05,1.49-.05,1.49c0,0-.58.29.58.58,1.16.29,1.11,0,1.35.34.24.33.48.33.58,1.01.1.67.1,1.68.1,2.07s.09.33.09,1.01-.14,1.78-.52,2.55c-.39.77-1.03,1.8-1.35,1.99-.32.19-1.04.83-1.48,1.41-.45.58-.64.96-.64.96,0,0-.84.32-1.29.39-.44.06-1.1-.71-1.29.13-.19.83-.06,1.54-.31,1.86-.27.31,0,.2-.52.7-.52.52-1.16,1.48-1.54,2.06-.38.58-.52,1.02-1.16,1.21-.64.19-.71.39-1.16.58-.45.19-.71.26-1.16.38-.45.14-1.03.52.26.52s1.86.33,2.5-.13c.65-.45,1.16-.96,1.16-.96,0,0-.32-.58.19-.83.52-.26.84-.52,1.35-.64.52-.13.84-.13.84-.13,0,0,.39-.64.45.06.06.71,1.67.77.14,1.42-1.54.64-1.22.38-2.12.96-.9.58-.9.64-1.16.89-.27.26-.2-.13-.27.26-.06.38-2.31.19-.06.38,2.25.19,2.95.07,2.95.07,0,0,1.04-.64.52.06-.52.71-.06.83-.96,1.09-.9.25-1.54-.13-1.21.39.31.51.45.71.58,1.02.12.33.64.52.12.84-.5.32-.96.13-1.47.45-.52.32-.45.06-.52.77-.06.71-.06,1.21-1.21,2.12-1.16.9-1.99,1.47-2.51,1.74-.52.25.32.45-1.16,1.09-1.48.64-1.74,1.35-2.96,1.16-1.21-.19-.7-.07-1.21-.19-.52-.13-.19.26-.71.26s.06-.52-.77-.52-.96-.5-1.16.19c-.19.71-1.41,1.99-1.41,1.99,0,0-2.24,1.15-2.76,1.03-.52-.13-1.29-.52-1.67-.96-.39-.45-.71-1.1-.71-1.1,0,0-.06-.38-.7-.38s-.65.32-1.23-.06c-.58-.38-1.15-.64-.31-.84.83-.19,1.66-.19,1.66-.19,0,0,.71.84,1.04.45.31-.39.7-.84.58-1.16-.13-.32.31-.52-.9-.77-1.22-.26-2.25-.33-2.25-.33,0,0-1.15.06-1.66-.25-.52-.32-.96-.9-.96-.9,0,0,.38-.38-.07-.96q-.45-.58-.51-1.16c-.07-.58-.27-1.28.31-1.73l.58-.45.65-.32s-1.87-2.06-2.13-2.18c-.26-.13-.7-.71-.7-.71,0,0-.96-.64-1.03-.06-.07.58-.26,2.5-.26,2.5,0,0-.38,1.16-.77,1.54s-.83.71-1.28.89c-.45.19-1.03.65-1.42.65s-1.79-.14-2.05,0c-.26.13-.84-.39-1.09.45-.26.84-.19,1.21-.14,1.48.07.25.65.25.65.83s-.13,1.48-.13,1.48l-1.86,1.6-.71.71-1.73.13-1.35-.13s-.78-1.54-1.09-1.35c-.32.19-.26,1.28-.26,1.28,0,0-.39.39-.77.39s-1.35-.76-1.48.32c-.14,1.09.77,1.79.77,2.06s.06.51,0,.71c-.07.19-.07,1.09,1.09.58,1.16-.51.71-1.22,1.93-.84,1.22.39,2.18.85,2.18,1.16,0,.33-2.57.39-1.92,1.16.64.77.13.39,1.41.45,1.29.06,1.41.32,1.67.32s1.22-.64,1.54-.83c.32-.19.96-.32.96-.32,0,0,.71.58.45.96-.25.39-4.75,5.52-4.75,5.52l-3.4,2.06s-2.12.58-3.22.84c-1.09.25-2.43.96-2.76,1.16-.32.19-1.48,1.41-1.67,1.54-.19.13-.89,1.22-1.09,1.54-.02.02-.03.06-.04.09,1.57-.09,3.07-.15,3.29-.15.42,0,1.12.14,1.54.42.42.28.14.69,1.26.55,1.11-.14,1.39-.42,2.09-.84.7-.42-2.1-.28.7-.42,2.8-.15,3.78-.15,3.78-.15,0,0,.13.43.97.43h1.4s-.83-.7.7,0c1.54.7,1.96,1.53,2.94,1.12.97-.42.84-.56,1.53-1.12.7-.56-1.4-.7,1.26-.7s3.22-.15,4.19.14c.98.28,1.54.84,2.52.84s1.39-.28,1.95-.42c.56-.14,0-1.12,1.68-.14,1.67.98,2.65,1.12,3.35,1.67.7.56,1.27.7,1.27.7,0,0,1.11-.14,1.95.56.84.7,1.26,1.26,1.26,1.26,0,0,1.54,1.39,2.23,1.81.7.42-.28.14,1.53.7,1.82.55,2.23.41,3.36.83,1.12.42,1.95.7,2.51,1.54s2.23,2.65,2.79,2.79c.56.15.71.7,1.4-.42.7-1.12,1.39-2.51,2.51-3.21,1.12-.7,2.23-2.09,3.36-2.23,1.12-.14,2.51-.42,3.77-.57,1.26-.13,2.23-.7,2.93,0,.7.7,1.12.71,1.26,2.52.14,1.82.14,3.08.14,3.77v3.63c0,.7.15,2.24.15,2.24,0,0,.24,3.7-.68,4.63-.92.92-4.38,2.76-4.38,2.76,0,0-1.68-1.38-2.46-.92-.77.46-.92,1.84-.92,1.84,0,0,1.23-.15,1.08.46-.16.61-.46,1.84-1.54,2-1.07.16-2.14-.77-2.3.45-.16,1.23-.16,2.46-.16,2.46,0,0,1.24,2-1.07,1.54-2.31-.46-2.77-1.07-2.77-1.07,0,0-.45-.15-.76.76-.3.92-.76,2.15-.76,2.15,0,0,.91.92-.77.92s-2.15-1.69-2.61-.76c-.46.91.46,1.84-.61,2.46-1.07.61-1.84.61-2.46.61s.46,1.22.61,2.3c.15,1.08.62,1.69-.3,2-.93.31-2.16.61-2.16.61,0,0-.92-.16-1.38.61-.46.77-1.23,1.54-.61,2.15l.61.61.46,1.07.44.7c.06-.39.09-.56.09-.56l.18-.9s.54-1.35.64.45c.08,1.8,0-.36.18,2.52.18,2.89.44,3.43.44,3.43,0,0-1.71,1.8.18,1.45,1.9-.36,2.08-2.08,2.44-1.18.36.9,1.17.9.36,1.44-.82.54-1.27-.89-1.45.9-.18,1.8.27,1.99.27,1.99,0,0-.09.18,1.08.72,1.18.54,1.8.72,1.8.72l.36-.81s.1,1.35-.18,1.9c-.26.54-1.44.9-1.08,1.45.36.54,1.63.81,1.63.81,0,0,.64.09,1,.09s.63-.81.9-.73c.26.09.35,0,.35.63s-.89,1.27-.35,2.08c.53.81.8,2.35.8,3.15s.18,2.08-.09,3.07c-.27,1-.09,1.08-.27,1.54-.18.44-1.17.99-1.17.99,0,0,.9.82.9,1.27s-.84,1.55-.88,1.61c.67.05.83.15,1.55.15,1.08,0,1.36.1,3.32.1Z"
        />
        <path
          class="st348"
          d="M671.24-46.26c-.87-.58-4.34-.3-5.21-.59-.87-.29-.87-1.16-.87-1.16,0,0,0-1.45-.29-2.32-.29-.87-1.45-.87-2.03-2.02-.58-1.17-1.45-2.03-1.45-3.48s0,0,1.45-1.73c1.45-1.74,0-2.31,0-3.76s-.87-1.45-1.45-2.61c-.58-1.16-2.6-2.89-2.6-2.89l-.58,1.73-.29,3.18-1.16.87v1.16c0,1.16,0,0-.87,2.31-.88,2.31-1.45-.29-1.45-.29l-1.16-1.73c-1.16-1.74,0,0,0-1.17s-.29-1.45-.29-1.45c0,0-1.16,0-2.31.29-1.16.3-.29,2.61-.29,2.61l-.58,2.31-1.74-.29-1.45-.58-1.44.58c-1.45.58-1.45.87-2.61,1.74s-.29,1.74-.29,1.74l.58,3.76-.58,1.16v2.9l-.58,2.02s1.45,1.16,2.32,2.31.58,2.03.58,2.03c0,0,.87,2.9,1.74,4.92.87,2.03-1.45.87-1.45.87l-2.32.29-3.19.87-.58,4.92-1.73,1.16-3.48,2.03s-6.07,7.81-8.1,9.83c-2.03,2.03-.87,4.92,1.16,6.95,2.03,2.03,0,2.6-.29,4.05-.29,1.45-2.31,4.34-2.31,4.34,0,0-1.44,4.34-2.03,5.2-.59.88-1.45,1.16-2.61,2.61-1.16,1.45-.87,1.45-1.45,2.9-.58,1.45,0,1.45,0,3.47s0,0,2.31,2.03c0,0,.88,2.6,2.04,3.18,1.16.58,1.16-.87,1.16-.87l.29-3.18s-.29-2.03,0-3.77c.29-1.73,0,0,.87-.87.87-.87.29-1.16,1.16-2.61.87-1.45.58-2.03.58-2.03,0,0,2.03-.87,2.03-2.03s-1.17-2.31-.87-4.05c.3-1.74.29-1.16,1.45-2.32,1.16-1.16,2.32-.87,3.76-1.45,1.45-.58.87-1.16,2.32-2.03,1.45-.87,1.16,1.45,2.03.59.87-.87,2.89-.59,2.89-.59,0,0,2.03-.29,2.9-.58.87-.29,1.45-1.45.87-3.18-.58-1.74,0,0,.29-1.74.29-1.74,0,0,2.02-1.16s.29-1.45.87-2.61c.58-1.16,2.32-.58,2.32-.58l2.32-2.89,2.6-.58c2.61-.58,0,0,3.77-1.17,3.76-1.16,0,0,1.74-.87,1.73-.87,1.16-.87,3.18-1.16,2.03-.29,3.47-3.76,4.92-4.92,1.45-1.16,3.77-6.08,4.35-7.23.58-1.16.58-3.18.87-5.49.29-2.32-.58-4.35-.87-6.37-.3-2.03,0,0-.87-.58Z"
        />
        <path
          class="st342"
          d="M564.49-73.43c-1.02,1.54-1.28,2.06-1.79,3.09-.52,1.04-.52,2.31-.52,2.31,0,0,2.31-.77,2.57,2.06.26,2.83-.77,4.62-.77,4.62,0,0-.52.25-.26,1.54.26,1.29-.25,1.29,1.03,2.31l1.28,1.02s1.54,1.04,1.54,2.58-1.54,1.03,0,1.54c1.54.5,4.11-1.29,4.11.25s1.29,2.83,1.29,3.85-.26,1.54-.26,2.57.51,1.8,1.79,1.8h5.91c1.03,0,3.34.5,3.34.5,0,0-1.54.52,1.03.52h4.11s.51.51,1.28,1.02c.77.52,1.28,1.29,2.57,1.8,1.28.51,1.03.51,2.31.51s1.79-.77,2.82-.77.76-.26,2.05-.26h1.29s1.54,0,2.82-.25c.51-.11.79-.16.97-.2.19-.98.3-1.79,1.05-2.44.99-.85.85-1.99,2.13-2.41,1.28-.43,2.13-.43,2.13-.99v-2.28s.14-1.14.99-1.14h3.27s1-.29,1.29.15c.28.43,1.7,2.27,1.7,2.27,0,0,1.56.29,2.27-.15.71-.42,1.85-.86,1.85-1.56v-2.42s.71-.84,1.42-.99c.71-.15,1.57-2.71,1.57-3.42s.15-2.55.71-3.69c.57-1.14.57-2.27,1-3.13.43-.86,1.14-3.69,1.14-3.69,0,0,.29-1.99,1.43-.71,1.13,1.28,2.13,2.27,2.84,2.69.71.43,1.84,1.86,2.98,1.71,1.15-.15,2.28-.86,2.28-.86,0,0,.42-1.57,1-2.56.57-.99.57-1.56,1.85-2.41,1.28-.86.86-1.28,2.7-1.14,1.85.14,2.13.71,2.7.85.57.15.28-.29,1.14-.85.86-.57,1.14-.71,2.28-.43,1.14.29,2.13.86,1.99-.28-.15-1.14-.43-3.69-.29-4.41.14-.72.57-2.43,1.42-2.28.85.14,1.99.57,2.7.57s1.99.42,1.99.42l1.27.15s.57-.85.86-1.56c.29-.71.71-3.13.71-3.13,0,0-1.99-3.13-1.99-4.55s-1-3.84-1-3.84c0,0,0-1.27-.71-1.71-.71-.42-2.28-1.28-.29-3.13,0,0,1.14-1.7,1.43-2.28.28-.57,1.42-1.42,2.84-1.56,1.42-.14,1.71,1.14,2.98,2,1.28.86,1.85,1.28,3.13,1.42,1.28.15,2.56.57,3.69.85,1.15.29,3.42,1.56,3.7,2.28.1.25.17.58.24.92.72-.37,1.7-1.04,1.86-2.08.26-1.67-.5-2.57.39-3.59.9-1.03,2.44-2.57,2.83-3.34.38-.77,1.02-1.8.89-3.34-.13-1.54-.13-3.47-.13-3.47,0,0-.13-1.79.64-2.56.77-.77,1.42-.9,2.31-1.54.9-.64,2.95-1.8,2.95-1.8,0,0,1.42-.89,2.57-.51,1.15.39,4.1,1.54,4.1,1.54,0,0,1.93.9,3.34,1.03,1.42.13,1.93-.12,2.82,0,.9.13,1.67,0,2.44.52.77.51.9.51,1.41.89.52.39,1.16,1.67,1.16,1.67,0,0,1.29,1.41,1.8.13.51-1.29.51-4.11,2.19-4.37,1.67-.26,1.54.26,3.08.26s3.09-.64,3.09-.64c0,0-.64-1.79,1.28-2.05,1.92-.26,2.69-.39,4.88-.39s5.39,1.41,7.06,1.41,4.24-.26,5.01-.64c.77-.38,2.57-1.8,3.59-1.54,1.03.26,2.19-.76,3.08-.64.9.13,4.24,3.08,4.88,0,.64-3.09.77-3.34.77-3.72s-.51-1.67.51-2.06c1.03-.39,3.09-.9,3.09-1.79s.52-.77,0-2.19c-.51-1.41-1.28-2.44-1.16-3.34.13-.89.38-2.31-.51-3.47-.9-1.16-1.92-1.79-2.7-2.31-.77-.51-1.03-1.02-.89-1.79.13-.77-.14-2.31-.9-2.83-.77-.51-2.56-1.03-2.56-1.03,0,0-1.03-.65-1.03-1.92s-.13-2.31-1.16-3.99c-1.03-1.67-2.19-1.92-2.31-3.47,0-.13,0-.3,0-.46-.05.03-.13.08-.13.08,0,0,.07-.05.13-.08.05-1.63.8-4.29-.13-5.7-1.03-1.54-1.8-2.56-2.95-2.82-1.16-.26-2.44-.26-3.08-.39s-1.92.51-2.57-.39c-.64-.89-1.02-1.54-1.28-2.44-.26-.9.13-1.42-1.03-1.92-1.16-.52-3.08-1.29-3.08-1.29,0,0-1.54-1.92-2.69-3.21-1.16-1.28-3.21-2.31-3.21-2.31,0,0-.89-.26-1.54-.89-.65-.64-.51-1.67-1.54-1.8-1.03-.13-5.65.39-5.65.39,0,0-.64.64-1.41,0-.77-.65-1.92-1.8-2.44-.9-.51.9-2.7,2.82-3.85,2.82s-1.79.64-2.95-.26c-1.16-.89-2.57-2.95-2.57-2.95,0,0-.26-1.29-1.03-1.54-.77-.26-3.97,0-4.62,0s-2.95.38-3.33-.26c-.39-.64-1.54-1.8-2.06-2.82-.51-1.03-.77-2.31-.77-4.11s.77-2.57-.13-3.34c-.9-.77-1.8-.25-1.8-1.28s0-1.54-.77-2.19c-.77-.64-.89-1.03-2.44-1.41-1.54-.39-3.59-.52-3.98-1.8-.38-1.29-1.41-2.7-1.41-2.7l-.99-1.33c-1.14.88-3.1,1.87-3.78,2.73-.77.96-3.29,4.44-5.8,4.83-2.51.39-4.06-.19-4.83.39-.78.58-1.55-.58-1.35,1.55.19,2.12.78,1.35.78,2.9s.58,2.13-.39,2.9c-.97.77-2.7,3.48-2.7,3.48,0,0-2.52,2.51-2.9,4.06-.39,1.54-.39,2.31-.39,2.31l-5.61,5.03s-1.35,2.9-2.12,3.86c-.78.96-3.67,11.21-3.67,11.21l-3.49,4.06s-4.06.97-2.51,3.1c1.55,2.12,4.26,6.95,4.26,6.95,0,0,.58,2.13.96,3.48.39,1.35-.38,5.02-.19,5.6.19.58,4.06,3.68,4.06,3.68,0,0,2.33,1.93,4.26,4.64,1.93,2.71,4.06,5.8,4.06,5.8,0,0,1.74,2.71,1.93,3.87.2,1.16.58,2.32.39,4.06-.19,1.74.39,3.1-.39,4.06-.77.96-.97.96-1.35,2.12-.39,1.17-.77.97-.96,2.7-.2,1.75-.2,4.26-.2,4.26,0,0-.23,2.7-1.67,2.96-1.46.27-1.86.92-2.78,0-.92-.92-1.32-1.45-1.85-1.98-.53-.53-.79-1.72-.79-1.72,0,0-.14-1.45.26-1.85.4-.4.93-.4,1.33-.66.4-.26.66,1.33.4-.26-.26-1.59-.53-2.24-.53-2.24,0,0-.14.66-.14-1.19s.93-1.19,0-2.37c-.92-1.18-1.06-1.18-1.46-1.58-.39-.4-.65-1.46-.65-1.46,0,0,2.11,1.46,1.58.66-.53-.79-1.58-1.85-1.58-1.85,0,0,.52-.53-.79-.4-1.33.14-2.37.4-2.9,1.19-.53.8-.27.93-1.06,1.86-.8.92-1.45,1.18-1.45,1.18,0,0,.39-.79-1.05,0-1.46.79-1.99,1.19-1.99,1.19,0,0-.65.13-.13,1.97.52,1.86,1.32,4.23,1.58,2.51.27-1.71.53-2.91.66-2.37.14.53.92,2.51.92,2.51l.13,2.24s-.53,2.37-1.05,2.51c-.53.13-1.06.66-.13,1.85.92,1.19,1.84,1.19,2.24,1.71.4.53,1.06.66.27,1.45-.8.79-.4,1.19-1.72,1.45-1.32.27-1.85.27-2.64.53-.79.27-1.84.65-2.37,1.32-.53.66-.53,1.19-.79,1.59-.27.4,1.06,1.19-.79.66-1.85-.53-3.03-1.19-3.03-1.19l-1.45-.52s-.14-.4-.93-.13c-.79.26,0,1.45-1.58.39-1.59-1.04-1.72-1.19-1.86-1.58-.13-.4.53-.4-.79-.92-1.32-.53-1.32-1.19-1.32-1.19,0,0,.66-.52.13-.65-.53-.14-.79.39-1.72-.14-.92-.53-.13-.13-.92-.53-.79-.4-2.77,1.32-1.45,1.45,1.32.13,1.85-.92,1.85.13s-2.51.26-1.19,1.32c1.32,1.06,2.37,0,2.77,1.06.4,1.04.14-.14,0,1.71-.13,1.85.53,1.85,1.32,1.98l.79.13s.53,1.32.4,1.72c-.13.4-.66,1.45-.66,1.45,0,0,.13.53-1.45,1.18l-1.59.66-1.31-.93s-1.46-1.84-1.59,0c-.13,1.86,1.72,2.52,1.85,2.91.13.39,1.18.92,1.18,1.32s1.72.52.14,1.32c-1.58.79-1.45,1.32-2.9,1.58-1.45.27-2.24,1.06-2.77,0-.53-1.05-.79-.4-.53-1.05.27-.66-.66-1.72-.66-1.72l-1.05-1.06s-.79-2.37-.92-1.31c-.14,1.05,1.06,2.37,0,2.37s-1.86,0-2.11-1.32c-.26-1.32-1.05-1.85-1.05-1.85l-1.72-.4s-3.56-.14-3.69,1.06c-.13,1.19.66-.27-.13,1.19s-.39,1.05.53,1.72c.92.66,1.59.13,1.72,1.32.13,1.18-2.9,3.43-.13,2.64,2.77-.79,2.24-1.06,2.9-1.46.66-.4,1.59-.66,1.59-.66,0,0,1.71-.13,1.71.27s-1.06,1.85-1.06,1.85l-1.97,3.17s-2.1,1.58-3.03,1.58-1.19-.13-2.24,0c-1.05.14-2.91.27-4.22.4-1.33.14-.53.4-2.51.4s-4.35-.26-4.35-.26c0,0-3.43,1.19-2.77,0,.66-1.18.26-1.18,1.31-1.18s.79.79,1.86-.27c1.05-1.05,1.58-1.32,1.58-2.24s-.78-1.32.4-1.98c1.19-.66,1.85-1.06,1.85-1.06,0,0,2.64,1.59,2.24.14s-.4-3.04-1.58-2.64c-1.19.4-2.9.79-3.43,1.45-.53.66-.79,1.05-1.32,1.98-.53.92-1.06,1.45-1.06,1.45,0,0-3.69,0-4.09.66s.26.66-.66,1.19c-.92.53-1.05,1.06-2.77,1.32-1.71.26-2.78.26-2.78.26l-2.9-1.31s.26-.8.4-1.46c.13-.66.92-1.05.26-1.58-.66-.53-1.32.53-1.06-1.72.27-2.23,1.33-2.64.27-3.03-1.05-.4-2.1-.92-1.71.27.39,1.19.66,1.85.13,2.64-.53.79.53,1.85-.79,1.46-1.33-.4-1.85.14-1.85-.66s.52-.53,0-.79c-.53-.27-2.91.66-1.85-.92,1.06-1.59,1.19-2.25,1.19-2.25,0,0,.26.14.39-.65,0,0-.62-1.45-1.64.09Z"
        />
        <path
          class="st342"
          d="M640.77,64.38c-.42.28-.86,1.28-2.27.85-1.42-.43-1.42-.71-2.42-.71s-2.13,1.7-2.27-.29c-.15-1.99-.71-3.27-.71-3.27,0,0,.86,0-1-.57l-1.84-.57s-.44-.29-1.57.28c-1.14.58-2.13-.15-2.42-.72-.29-.57-.86-1.85-1.57-.99-.71.86-2.98,3.98-2.98,3.98,0,0-.15,1.99-1.57,2.41-1.42.43-3.13,1-3.99,1s-6.26-.57-6.26-.57c0,0-1.71-.43-2.98-1.14-1.28-.71-2.14-.99-3.13-2.56-.99-1.57-1.71-1.43-2.13-2.14-.43-.71-.57-1.28-1-1.98-.29-.5-.86-2.01-1.19-2.91-.17.09-.3.12-.3.12,0,0-2.07-1.43-2.33-.77-.26.65-.13,2.33-.13,2.33,0,0,.77,1.94,0,2.2-.78.26-.39-.9-.78.26-.39,1.17.27,0-.25,2.33-.52,2.34-.14,2.85-1.04,3.37-.91.52-1.55,1.04-1.55,1.04,0,0-.65.77-.78,2.46-.13,1.68-.13,2.72-.26,3.24-.13.52.52,1.29-.26,2.33-.77,1.04-1.29,2.33-1.29,2.33l-.39,3.5s-1.16,2.33-.52,2.97c.65.65,2.33-.38,2.46.65s1.68,1.93.65,3.11c-1.04,1.16-.78,1.94-1.43,2.46-.65.52-.52-.52-1.29,1.42-.78,1.94-.78,2.98-.78,2.98,0,0-.39.78,1.04,1.3l1.43.52s.9.27.9,1.81v4.65c0,.65.52.65.52,1.3v5.04c0,1.04-.78,2.33-1.04,3.24-.26.9-1.17,1.04-.78,2.07.39,1.04,1.3,1.04,1.17,1.94-.13.9-.13,1.69-.9,1.94-.78.27-1.55.65-1.55.65,0,0-.13.9-.78,1.3-.04.02-.1.04-.15.07.18,1,.65,3.33,1.27,4.45.81,1.46.33,3.89.33,3.89,0,0,.65.96.8,3.07.17,2.11.81,5.66.98,7.11.16,1.46,2.75-.97,2.75-.97,0,0,1.3.64,2.26,1.94.97,1.29,1.3,3.07,1.3,5.49s-.16,1.94-1.78,2.75c-1.62.81-2.43-.48-3.88-.81-1.46-.32-2.26-.16-2.26-.16,0,0-.49,0-2.42,1.14-1.94,1.14-.98,3.23-.81,4.21.16.96-.32,1.46-2.11,2.74-1.78,1.3-.48.98-.97,2.11-.49,1.13-1.94.64-1.94.64,0,0-1.62,1.14-2.59,2.59-.96,1.45-.97,2.75-1.62,3.88-.65,1.13-2.1,1.3-2.1,1.3l-1.46,1.94v2.1c0,.64.17,1.13.49,1.62.32.48,1.3.96,1.3.96l2.59.97,1.13,1.13.49,1.3.97,1.3.16,1.61v1.78c0,.49.32.8.32.8h3.08v.98s.49.97,1.78,2.59c1.3,1.62,0,3.72,0,5.02s-1.46,1.45-1.46,1.45l-1.3-.15-.48,2.74s-.17.98-.32,2.27c-.17,1.3-.98,1.3-.98,1.3l.32,1.94s1.78.16,2.59.16,0,.81,0,.81l-.16,1.62-.32,1.29,2.26-.32s.81-.16,1.46-.65c.64-.48.97-.81.97-.81l.64-1.3.49-.48s.64.16,1.13,0c.49-.16,1.13-.32,2.59-.48,1.46-.17,1.46.16,3.24.16s1.3,0,2.43.32c1.13.32,1.77.48,2.26.97.48.48,1.46.65,1.46.65,0,0,1.61-.16,3.23-.81,1.62-.65,3.08-1.94,3.08-1.94h1.13l1.89.72,3.93,1.75v.95c1.23-.72,2.98-1.88,3.25-2.88.43-1.57,1.14-3.56,1.14-3.56l.86-.28s.15-2.42.43-3.84c.29-1.42.43-.71,1.57-2.28,1.14-1.56,1.14-2.27,3.55-2.7,2.42-.43,2.13.85,4.97-1.14,2.85-1.99,2.99-3.13,3.27-3.69.29-.57,1-2.27,2.56-3.27,1.57-1,.99-1,2.84-1h3.55c.43,0,2.56,2,3.13,1,.57-1,.43-2.56.43-2.56,0,0-1.14-1-.43-2.99.71-1.98,1.14-3.26,2.27-3.13,1.14.15.85,0,0-2.42-.85-2.41-.57-3.98-.57-3.98,0,0,.29-1.14.15-1.7-.15-.57-.29-.86-.15-1.71.15-.86.71-2.42.43-4.41-.28-1.99-1.56-3.41-1.56-3.99s.57-3.84,1.85-5.12c1.28-1.28,3.27-1.57,2.56-3.99-.71-2.42-1.43-4.13-2.27-4.7-.86-.57-2.7-3.13-1.29-4.13,1.42-.99,2.41-.43,2.85-1.28.42-.85,1.13-1.27-.57-2.42-1.7-1.13-2.28-2.13-2.28-2.13,0,0-.43-3.41-1.56-5.55-1.14-2.13-2.99-2.42-2.28-3.99.71-1.56,1.99-4.55,1.99-4.55,0,0,.85-.99,2.7-1.56,1.85-.57,3.69-1.56,5.98-1.99,2.28-.43,4.56-.43,4.56-.43,0,0,1.7.43,2.41-.43.71-.86.72-2.98,1.28-4.13.57-1.13,1.57-1.84,1.57-1.84,0,0,.85-.43.28-1.14-.57-.71-1.43-.71-1.43-1.13v-1.71s1.29-2.42-.71-2.27c-1.98.15-4.12.99-4.12.99,0,0-1.14,1.71-1.42.15-.28-1.56-.99-4.27-.99-4.27,0,0-.86-1.15-1.43-1.28-.57-.14.85-.14-.57-.14s-1.13.71-2.28.86c-1.13.14-1.42,1.41-2.13.42-.71-.99-.86-2.27-1.71-2.27s-3.13-.15-3.13-.15c0,0-2.98-.29-3.41-2.13-.43-1.85-.85-4.55-.29-5.41.57-.85,2.13-2.56,2.13-2.56,0,0,.29-1.7.29-2.27s-.29-1.28-.29-1.28c0,0-.99-1.71.15-2.13l1.15-.43.85-2.13s-.99-2.98-1.57-4.55c-.57-1.56-.71-2.84-.71-3.55s-.43-1.71-1-1.99c-.47-.23-.76-.8-1.23-.63.26.22.43.35.43.35,0,0-.17-.13-.43-.35-.11.04-.21.07-.33.21-.71.71-1.29,3.4-1.71,3.69Z"
        />
        <path
          class="st342"
          d="M690.26-19.41c-.71-.29-2.7-2.42-2.7-3.69s1.43-1.86,1.85-2.99c.43-1.14,0-2.84,0-4.13s.14-1.71,1-2.56c.86-.85,1.85-6.26,1.85-6.26,0,0,.14-.85,0-1.56-.14-.72-.85-.85-1.42-2.14-.58-1.28.28-.85.71-1.13.43-.29,1.85-.71,2.99-1.57,1.14-.85.85-1.71.85-1.71l-1.56-1.57s-.71-1.14-.86-1.56c-.15-.43-.85-1.57-.99-2.7-.15-1.14.99-3.12,1.28-4.27.29-1.13-1.99-1.98-2.7-2.84-.71-.86-.71-.71-.86-1.14-.15-.43-.85-1.28-.85-1.28v-1.71l.28-1.7s.86-1.28.99-2.14c.15-.85-.85-1.85-1.84-2.13-1-.29-1-.86-1-.86,0,0,0-1.42-1-2.56-.99-1.14-1.56.99-1.98,2.14-.43,1.13-1.99.14-2.13-.72-.15-.86-.86-1-2.14-1s-1.28-1.71-1.28-1.71l.71-1.42s.15-2.27.15-3.42-.86-3.69-.86-4.41-.57-.42-.57-.42h-2.56c-1.28,0-1.28-1.57-1.28-1.57l-.71-3.42s-.06-.6-.18-1.21c-.44.22-.77.32-.77.32,0,0,.34-.1.77-.32-.07-.33-.14-.67-.24-.92-.29-.72-2.56-1.99-3.7-2.28-1.13-.29-2.41-.71-3.69-.85-1.28-.15-1.85-.57-3.13-1.42-1.28-.86-1.57-2.14-2.98-2-1.42.15-2.56,1-2.84,1.56-.29.58-1.43,2.28-1.43,2.28-1.99,1.85-.43,2.71.29,3.13.71.44.71,1.71.71,1.71,0,0,1,2.42,1,3.84s1.99,4.55,1.99,4.55c0,0-.42,2.42-.71,3.13-.29.72-.86,1.56-.86,1.56l-1.27-.15s-1.29-.42-1.99-.42-1.85-.43-2.7-.57c-.86-.15-1.28,1.57-1.42,2.28-.15.71.14,3.26.29,4.41.14,1.14-.86.57-1.99.28-1.14-.28-1.42-.14-2.28.43-.86.57-.57,1-1.14.85-.57-.15-.86-.71-2.7-.85-1.85-.15-1.42.28-2.7,1.14-1.28.86-1.28,1.43-1.85,2.41-.58,1-1,2.56-1,2.56,0,0-1.13.71-2.28.86-1.14.15-2.27-1.28-2.98-1.71-.71-.42-1.71-1.42-2.84-2.69-1.14-1.28-1.43.71-1.43.71,0,0-.71,2.84-1.14,3.69-.43.86-.43,1.99-1,3.13-.57,1.14-.71,2.98-.71,3.69s-.86,3.27-1.57,3.42c-.71.15-1.42.99-1.42.99v2.42c0,.71-1.14,1.14-1.85,1.56-.71.44-2.27.15-2.27.15,0,0-1.43-1.85-1.7-2.27-.29-.43-1.29-.15-1.29-.15h-3.27c-.85,0-.99,1.14-.99,1.14v2.28c0,.57-.86.57-2.13.99-1.28.43-1.14,1.57-2.13,2.41-.75.65-.86,1.46-1.05,2.44.28-.05.31-.07.31-.07h1.54-1.54s-.04.01-.31.07c-.06.31-.13.63-.23.98-.43,1.42,1.28.99,2.27,1.71.99.71,1.28,1.71,1.57,2.28.28.57.85.85,1.56,1.84.71,1,2.7,5.13,3.56,6.26.85,1.15,1.28-.42,1.56-.86.29-.42,1-.57,1.42.15.43.71-.99,1.71-.99,1.71,0,0-.85,2.13-1.71,4.98-.85,2.85-.57,5.41-.14,6.54.43,1.14,1.28,3.27,1.28,3.27,0,0,.28,1.56.57,3.27.29,1.71.29,2.27.29,2.27,0,0-.43,1.99-.57,3.7-.15,1.71,0,2.55-.99,4.41-1,1.85,0,2.56-.43,4.27-.43,1.7-.71,2.83-.71,2.83,0,0-1.85,1.29-1.85,2.28s1.27,1,1.71,2.42c.42,1.43,0,1.57.28,2.71.29,1.13,1.29,1.28,2,2.28.71.99,1.57,3.28,1.85,4.56.28,1.28,1.14,2.27,1.42,2.7.29.43.71,1.56.71,2.85s-.57,1.13-.57,1.13l-.28,1.42s-.15.57-.86,2c-.71,1.42-.15,1.84.43,2.56.57.72,1.7,1.14,2.56,1.71.86.57.29,1,.57,1.71.29.71,1.42-.43,1.42-.43,0,0,1.28-1,1.7-1.7.43-.71,1-.44,1-.44,0,0,1.14-.57,2.13-.57s.57,1.14.57,1.14v1.43s-.14,1.99-.14,2.7,1.13.43,1.99.43.71.42,1.14.85c.43.43.85,1.7.85,1.7,0,0,1.7-.57,2.7-.71,1-.14,1.56,0,1.71.57.14.58-.15,1.14-.15,1.14,0,0,.86.85,1.57,1,.71.14,1.42,1.28,1.71,2.41.28,1.14-1.43.72-2.27,1.71-.86,1,1.56,2.42,1.56,2.42,0,0,.04.05.04.05.8-.47,2.37-1.38,2.79-1.48.57-.15,2.7-.43,3.27-.71.58-.29,1-1.28,1-1.28,0,0,1.43-.43,1.85-.71.42-.29.28-1.14.28-1.14,0,0-.57-1.71.14-3.13l2-.43s.28-1.14.42-1.57c.15-.43.71-.57.71-.57,0,0,.71-.99,1-1.56.29-.57-.57-.85-.57-.85,0,0-1.43-.28-2.85-.43-1.42-.15-1.56-1.42-1.56-1.85s.85-1.28.85-1.28c0,0,1.43-1.14,2.14-1.28.71-.15,1.57.42,1.57.42l1.14,1.42c1.14,1.42,1.28.29,2.7.29h4.69c1.43,0,.14.57.43,1.28.28.71,0,0,1.13,1.29,1.14,1.28,3.13.85,3.56.99.43.14,3.84.85,4.41.85s2.84-.85,3.27-.99c.42-.14,1.98-1.57,1.98-1.57,0,0,2.57-1.14,2.99-1.7.43-.57,1.14-.71,1.14-.71l1.57-.57s2.42-.99,3.41-1.28c1-.29,1-1.71,1-1.71,0,0,.43-2.98.57-4.26.14-1.29,1.42-1.99,1.42-1.99l1.85-.72,1-2.27,1.85-3.98v-2.99l.28-3.84s1.28-3.12,1.57-3.55c.28-.43,1.14-4.98,1.14-4.98,0,0,0-.86.28-1.99.29-1.14.29-1.85.29-1.85,0,0,0-.57.15-1.43.14-.86-.15-1.42-.15-1.42,0,0-.57-1.14-.57-1.56s.57-1,.99-1.42c.43-.43.86-1.42,1.15-2.7.28-1.28-1-1.57-1.86-2.27-.85-.71-2.13-1.14-3.55-1.71-1.42-.57.15-1.98.15-1.98,0,0,.15-1.71.15-2.57,0-.44-.27-.95-.61-1.38l-.63.32.63-.32c-.34-.41-.75-.75-1.1-.89Z"
        />
        <path
          class="st342"
          d="M482.05-79.6c.26,1.54,1.54,2.06,2.31,3.08.77,1.03,2.31,1.54,2.83,2.31.51.77.77.26,1.54,1.54.77,1.29,1.28,3.08,1.54,3.85.26.77-1.04,1.8,1.03,1.8h4.62s.52-2.82,3.34-3.08c2.82-.26,5.65-.26,5.65-.26,0,0,.76-1.03,1.03.52.26,1.54.77,1.79.77,2.82s-.25,1.03-.25,2.06.25,5.4.77,7.45c.51,2.05.51,1.79.51,3.33s.76,4.12-.26,4.37c-1.02.25-1.28.25-2.05,1.28-.77,1.03.25,2.82-2.57,2.82s-3.59-1.03-4.37-1.54c-.77-.51-2.05-3.59-3.85-2.31-1.8,1.29-2.82,2.31-2.82,3.34s0,2.32-.26,3.34c-.26,1.02-.51.77-.77,3.59-.26,2.82-1.54,2.06.26,4.11,1.79,2.05,2.56,2.82,3.59,3.33,1.03.52,1.54.52,2.57,1.03,1.03.51,2.31,1.03,2.31,1.03,0,0,2.31-1.54,3.85,1.02,1.54,2.57-.26,1.8,1.54,2.57l1.79.77s1.8-.25,2.06.78c.25,1.02,1.02,3.59,2.31,2.31,1.28-1.29,2.31-2.31,2.31-2.31,0,0,2.31-.27,3.59-.27s3.34.27,3.34.27c0,0,3.34-1.54,3.34.25s-.25,3.08-.25,3.08c0,0-1.81,2.31-.52,2.31s2.06-.52,2.83.77c.77,1.29,2.31,1.03,1.54,3.09-.77,2.06-.26,3.59.77,4.87,1.03,1.29,2.82,2.83,3.34,1.54.52-1.27,1.54-2.31,1.54-2.31l2.83-.5,3.85.5s.51.26.51,1.54-2.57,2.58.26,2.83c2.82.25,3.59,0,4.37,0s.25-.25,2.05.77c1.8,1.03,3.6,1.03,3.6,1.03l1.79,1.8s2.06-1.29,1.8.51c-.26,1.8-.52,3.35-.26,4.12.26.77-.51-1.03.26.77.77,1.79,0,3.34,0,3.34,0,0-2.32.77-2.57,1.79-.24.96-.47,1.9-.5,2.01.24.21.5.55.75,1.07,1.03,2.06.77.52,1.03,2.06.26,1.54-.52,2.31.26,3.08.77.77,4.11.77,4.11.77l3.34-.25h2.57s1.8.76,2.57,1.28c.77.52,1.8,1.29,1.8,1.29,0,0,.25.51,0,1.79-.26,1.29-.52,4.89-.52,4.89,0,0-.67,2.33.91,2.07,1.59-.27,2.65-2.38,2.65-.8s.79,2.65.79,2.65l1.06,1.06s0,.79,1.59.79h2.65c1.06,0-.53,1.86,1.06,0l1.59-1.85s.52.53-.79-1.06c-1.33-1.59-1.86-2.38-1.06-3.17.79-.79.26,2.02.79-.79.12-.63-.22.48,1.07.13,1.67-.45.9-1.55,2.32-1.55s2.46-.13,2.59.65c.14.78.39,1.17.27,2.07-.13.9-.27,1.81-.27,1.81l-1.04.52s-1.94.64-.64,1.16c1.29.52,1.68-.25,2.59-.38.91-.14,1.68-.78,2.33-.14.65.65.13-.25.65.65.52.9,0-.26.52.9.52,1.17.64,1.81.64,1.81,0,0-.91.78.13,1.04,1.04.26,1.04-.26,2.07.52,1.04.78,1.68.26,1.68,1.3s-.39,1.68.26,2.2c.64.52.77-.13,1.16,1.04.39,1.17.65.39.65,1.68v2.33c0,.39.78.65.78.65l1.55.64s.13,1.16.91,2.33c.77,1.17,1.04.9,2.2,2.07,1.16,1.17,1.43,1.93,1.43,1.93,0,0,.77.91,0,1.69-.78.77-.78.77-1.3,1.42-.52.65-.38.9-.64,1.29-.13.19-.31.32-.47.4.33.9.9,2.41,1.19,2.91.44.71.57,1.27,1,1.98.42.71,1.14.57,2.13,2.14,1,1.57,1.86,1.85,3.13,2.56,1.27.71,2.98,1.14,2.98,1.14,0,0,5.41.57,6.26.57s2.56-.57,3.99-1c1.42-.42,1.57-2.41,1.57-2.41,0,0,2.27-3.13,2.98-3.98.71-.86,1.28.43,1.57.99.29.57,1.28,1.29,2.42.72,1.13-.57,1.57-.28,1.57-.28l1.84.57c1.86.57,1,.57,1,.57,0,0,.57,1.28.71,3.27.15,1.99,1.28.29,2.27.29s1,.28,2.42.71c1.42.43,1.85-.57,2.27-.85.42-.29,1-2.99,1.71-3.69.13-.14.23-.17.33-.21-.75-.62-2.3-2.01-2.61-3.07-.43-1.42-.29-2.13-.29-2.84,0-.67-.97-1.8-1.09-1.94-.29.17-.49.29-.49.29,0,0,.2-.12.49-.29,0,0-.04-.05-.04-.05,0,0-2.42-1.42-1.56-2.42.85-.99,2.55-.57,2.27-1.71-.29-1.14-1-2.27-1.71-2.41-.71-.15-1.57-1-1.57-1,0,0,.29-.57.15-1.14-.15-.57-.71-.71-1.71-.57-1,.15-2.7.71-2.7.71,0,0-.43-1.28-.85-1.7-.43-.43-.29-.85-1.14-.85s-1.99.29-1.99-.43.14-2.7.14-2.7v-1.43s.43-1.14-.57-1.14-2.13.57-2.13.57c0,0-.57-.28-1,.44-.42.71-1.7,1.7-1.7,1.7,0,0-1.14,1.14-1.42.43-.28-.71.29-1.14-.57-1.71-.86-.57-1.99-.99-2.56-1.71-.57-.72-1.14-1.14-.43-2.56.71-1.43.86-2,.86-2l.28-1.42s.57.14.57-1.13-.43-2.42-.71-2.85c-.29-.43-1.14-1.42-1.42-2.7-.29-1.28-1.14-3.57-1.85-4.56-.71-1-1.71-1.15-2-2.28-.28-1.14.15-1.28-.28-2.71-.44-1.42-1.71-1.42-1.71-2.42s1.85-2.28,1.85-2.28c0,0,.28-1.13.71-2.83.43-1.7-.57-2.41.43-4.27.99-1.86.85-2.7.99-4.41.15-1.71.57-3.7.57-3.7,0,0,0-.57-.29-2.27-.29-1.71-.57-3.27-.57-3.27,0,0-.86-2.14-1.28-3.27-.43-1.14-.71-3.69.14-6.54.86-2.85,1.71-4.98,1.71-4.98,0,0,1.42-1,.99-1.71-.43-.71-1.14-.57-1.42-.15-.28.44-.71,2-1.56.86-.86-1.13-2.85-5.26-3.56-6.26-.71-1-1.28-1.28-1.56-1.84-.29-.57-.58-1.57-1.57-2.28-.99-.72-2.7-.29-2.27-1.71.1-.35.16-.67.23-.98-.18.04-.46.09-.97.2-1.28.25-2.82.25-2.82.25h-1.29c-1.29,0-1.02.26-2.05.26s-1.54.77-2.82.77-1.03,0-2.31-.51c-1.29-.52-1.8-1.29-2.57-1.8-.77-.51-1.28-1.02-1.28-1.02h-4.11c-2.57,0-1.03-.52-1.03-.52,0,0-2.31-.5-3.34-.5h-5.91c-1.29,0-1.79-.77-1.79-1.8s.26-1.54.26-2.57-1.29-2.31-1.29-3.85-2.57.25-4.11-.25c-1.54-.52,0,0,0-1.54s-1.54-2.58-1.54-2.58l-1.28-1.02c-1.28-1.03-.77-1.03-1.03-2.31-.26-1.29.26-1.54.26-1.54,0,0,1.03-1.79.77-4.62-.26-2.83-2.57-2.06-2.57-2.06,0,0,0-1.28.52-2.31.51-1.03.77-1.54,1.79-3.09,1.03-1.54,1.64-.09,1.64-.09.13-.79-2.24-2.38-2.24-2.38,0,0-1.45.66-1.58-.79-.14-1.45-.27-2.9.39-3.69.66-.79.4-1.58-.53-.79-.92.79-1.98-.14-2.37,1.04-.4,1.19.53,2.51-.79,3.56-1.32,1.06-1.46.53-1.99,1.06-.52.53-2.24,2.11-3.3,2.11s-1.45-1.45-2.64-.13c-1.18,1.32-1.59,1.98-2.37,1.58-.79-.4-2.64-1.72-2.51.14.14,1.84,1.59,3.83,1.59,3.83,0,0-.53.78-.14,1.97.4,1.19.53,1.32.93,1.85.4.53.26.66,0,1.59-.27.92,0,1.45-1.06,1.85-1.05.4-.91-.26-1.58,1.05-.66,1.32-.93,3.83-1.59,3.03-.66-.79-1.45-1.31-.53-2.37.92-1.06,1.46-.4,1.46-1.85s.13-2.37.13-2.37c0,0,1.05.13.79-1.45-.26-1.59-.79-2.91-.79-2.91,0,0,0-1.58-.92-.26-.93,1.32.13,2.64-2.24,1.58-2.38-1.05-3.3-2.24-4.1-2.9-.79-.66-.66-.92-2.24-1.19-1.59-.26-2.38-.13-2.77-1.05-.39-.93-1.19-1.59-.14-2.25,1.05-.66,2.38-.66,2.38-.66,0,0-.66.66.4.53,1.05-.13,1.84.79,2.11-.53q.26-1.32-.66-1.59c-.92-.27-1.59,0-1.84-.53-.27-.53-.53-1.05-.27-1.58.27-.53,1.84-2.12.53-1.99-1.33.13-1.19,1.46-1.59,1.59-.4.14-1.18-.26-1.58.14-.4.4.26.92-.4,1.71-.66.8-1.33.93-1.72,1.46-.39.53,0,1.05-.39,1.98-.4.92-.66,2.12-1.58,1.85-.93-.27-1.72-.53-1.98-1.19-.26-.66-.79-1.59-.79-1.59,0,0-.27-.14-1.85-.26-1.58-.13-3.03-1.19-.79-2.25,2.24-1.05,3.56-1.71,4.22-2.37.66-.66,2.5-.27,3.04-1.58.53-1.32,1.19-1.85,2.64-2.65,1.45-.79,1.97-.92,1.97-1.84s.4-3.04,1.72-5.02c1.32-1.97,1.97-4.21,2.77-3.42.79.79-.14,2.37.92,1.85,1.05-.53,1.32-.4,1.32-1.85s.53-.92,0-3.17c-.53-2.24-.79-2.1-.92-3.55-.13-1.45-.14-1.72-1.18-2.38-1.06-.66-2.64-1.97-2.64-1.97,0,0-2.38-2.25-2.38-2.64s-2.51-2.64-2.51-2.64c0,0-1.05,1.19-2.24,1.32-1.19.13-3.96,1.05-3.96,1.05,0,0-3.56,1.19-4.36,1.19s-1.18-1.19-2.24-.27c-1.06.93-4.75,1.85-5.41,2.51-.65.66-1.71,1.98-2.11,2.78-.4.79-3.96,3.3-3.96,3.3,0,0-.52-.13-1.72.79-1.19.92-1.72,1.32-3.03,1.32s-2.24-1.06-3.43,0c-1.19,1.06-1.98,1.32-2.9,2.37-.93,1.05-2.38,3.03-3.17,3.69-.79.66-2.5,1.19-3.03,1.19s-3.83.13-3.83.13l-1.19-1.46s.26-.53-.53-.53c-.66,0-.98-.16-1.68-.06.07,1.15.17,3.05.17,5.24,0,3.59-1.55,4.1-1.29,5.64Z"
        />
        <path
          class="st342"
          d="M260.68-71.89l-.77,1.03c-.77,1.03,0,2.06,0,2.06l.51,1.8c.51,1.79.26,2.31.26,2.31l3.09,4.36c3.08,4.36,3.33,2.31,3.33,2.31l2.31,1.28c2.31,1.28,1.54.77,2.83,1.8,1.28,1.03,1.03,1.03,2.05,1.8,1.03.77.77,2.31.77,3.59v2.57c0,1.28.26,1.28,0,2.56-.26,1.28-1.03,1.03-3.08,3.6-2.06,2.56-.51,5.39-.51,6.67s1.28,1.8,1.02,3.09c-.25,1.28.77,1.54.77,3.34s-1.54,2.06-1.54,2.06h-4.62c-2.56,0-2.05,1.54-2.05,1.54,0,0-1.28.51-3.08,1.8-1.8,1.28-2.57.51-5.4,1.79-2.82,1.29-3.34,2.57-3.85,3.6-.51,1.02,1.8.51,1.8.51l2.56.51.26,1.54.77,1.29s.51,1.28-.26,4.62c-.77,3.34,0,0-2.05.77q-2.05.77-3.85,2.31c-1.8,1.54-.77,2.82-.77,6.68,0,2.35-.03,3.76-.06,4.51.62.32,1.21.49,2.04.19,1.47-.56.55,0,2.19,0s3.83.18,4.74,0c.91-.18.73,0,1.82.18,1.1.18-.18-1.83,2.37-1.1,2.56.73,3.47.37,3.47,1.83,0,.31.02.56.06.8.87.25,2.7.61,2.89-.76.26-1.8.77-4.62.77-4.62,0,0,.77-2.31,3.59-.52,0,0-.51.26,2.05-1.02,2.57-1.29,3.6-1.54,5.91-2.06,2.31-.52,3.34.25,3.85-1.29.51-1.54.51-2.56-.52-5.39-1.03-2.82-1.03-5.9,1.03-4.36,2.05,1.54,1.54,2.3,3.34,2.05,1.79-.26,2.06.27,4.37-1.03,2.31-1.29,2.3-1.29,4.36-1.54,2.06-.26,3.08,2.05,3.34-.52.26-2.57,0-3.85-.51-4.88-.52-1.02-.27.77-.52-1.02-.25-1.81-.51-1.29,1.29-2.06,1.79-.77,2.57-.52,3.59-1.54,1.03-1.03,1.79-1.29,2.06-2.83.26-1.54,2.31-8.99,2.57-10.02.26-1.03,2.06-2.57,3.34-2.82,1.28-.27,4.87.25,4.87.25,0,0,1.54,2.83,4.11,2.83s4.11-.26,4.11-.26c0,0,3.08,1.04,4.87,1.8,1.8.77,3.09,1.28,4.11,2.05,1.03.77,2.82.77,3.59,2.83.77,2.06,2.31,4.87,2.31,4.87,0,0,.77,1.81,2.83-.25,2.06-2.06,2.82-4.11,2.82-4.11,0,0-.52-1.29,1.28-2.06,1.8-.77,2.83-1.02,3.6-1.54.77-.52,1.29-1.29,2.82-1.29s1.03-.51,1.8-2.05c.77-1.54-.77-.52.77-1.54,1.54-1.04,2.56-1.81,2.56-1.81l3.34-1.02s3.33-1.79,3.59,0c.26,1.79-.26,2.56-.26,3.33s-2.83,2.83-.77,3.09c2.05.26,5.9,1.8,5.9,1.8l3.59-.52s1.28-1.54,3.08.25c1.8,1.8,3.85,3.08,3.85,3.08,0,0,2.06-1.79,2.06.52s1.03,4.11,1.03,4.11c0,0,0,.52-.25,1.54-.26,1.04-1.54,1.29.77,2.06,2.31.77,1.79,1.29,1.54,2.83-.26,1.54-1.04,2.06-.52,3.85.52,1.79,1.54,4.87,2.83,3.33,1.28-1.54,1.79-3.6,1.79-3.6h2.83s.77.52,2.31-.5c1.54-1.04,2.57-3.6,3.85-2.06,1.28,1.54,1.02,1.54,2.56,1.54s4.37-.52,4.37-.52l4.62-2.82,1.79-1.54s1.8-2.31,3.34-3.09c1.31-.66,2-.5,1.72.64l3.93,1.92s2.05,1.03,3.59-.77c1.54-1.8,2.56-3.6,3.59-4.11,1.03-.51,1.54.26,2.83-1.28,1.28-1.54,1.79-3.08,1.79-3.08,0,0-.51-3.08-.51-4.62s-.51-1.79,0-3.85c.51-2.06-.26-2.83-1.8-4.37-1.54-1.54-2.31-.77-2.56-2.31-.26-1.54-.26-4.11-.26-4.11,0,0,.77-.77,0-2.57-.77-1.8-1.54-2.31-2.31-2.82s-2.05-1.03-2.05-1.03c0,0-.77-3.08-.77-4.88s.51-2.31,0-3.34c-.52-1.03.76.51-.52-1.03-1.28-1.54-2.82-2.57-2.82-2.57,0,0,0-2.31.26-3.08.25-.77.25-2.56.25-2.56v-2.31s-.77-3.34-1.79-4.37c-1.03-1.03-2.06-1.54-2.06-1.54l-1.44-1.33c-1.44.53-3.24,1.29-4.61,2.09-2.24,1.32-5.93,3.29-6.73,3.56-.79.26-1.32-.26-1.71.79-.4,1.06-2.25,1.85-4.88,3.16-2.64,1.33-11.75,3.7-14.65,3.96-2.9.27-8.04,1.19-11.47,1.19s-7.66-.4-9.37,0c-1.72.39-2.51.53-3.83.92-1.32.39-4.75,2.24-6.47,2.24h-6.99c-2.64,0,1.85,0-6.47,0s-15.05-.4-18.74-1.19c-3.69-.79-8.84-2.77-10.16-3.03-1.33-.27-2.64-.4-3.69-.14-1.06.27-6.34,2.11-7.92,2.64-1.58.53-2.37,1.98-4.35,2.64s-4.75,3.55-5.28,3.82c-.53.27-.14.66-1.45,1.06-1.32.4-2.25.66-2.25.66,0,0-5.93.92-9.63-.66-3.69-1.58-9.76-5.28-9.76-5.28,0,0-1.58-1.05-1.58-3.43v-3.16s.66-.13,1.32-1.18c.66-1.06,1.06-1.72,1.06-1.72,0,0-1.86-.27.65-.4,2.51-.14,5.02-.26,5.02-.26,0,0,1.98.39,1.98-.53s0-1.46-1.05-1.59c-1.06-.13-2.77-.26-3.96-.52-1.19-.27-1.72-.27-3.43-.27s.93.27-2.37,0c-.71-.05-1.25-.09-1.71-.12-.43,1-.87,2.03-.98,2.5-.26,1.02-1.29,2.82-1.29,2.82Z"
        />
        <path
          class="st342"
          d="M737.84,9.28c-.16-.6-.16-2.71-.76-4.22-.6-1.5-2.86-3.62-2.86-3.62l-1.51-.45-1.65-.75-.45-1.05c-.45-1.06-2.11-2.11-2.11-2.11l-.74-.3c-.76-.3-1.2-1.06-1.2-1.06,0,0-.27-.31-.61-.76-.28,1.19-.59,1.36-.59,1.36,0,0,.31-.17.59-1.36-.52-.69-1.23-1.67-1.5-2.4-.45-1.2-1.35-1.5-1.35-1.5,0,0-.6,1.5-1.05,2.11-.45.6-.6.45-1.8.45s-.91-.9-1.21-1.5c-.3-.6-1.04-1.8-1.04-1.8,0,0-.9-1.5-1.2-2.11-.3-.6-1.2-1.06-1.96-1.66-.76-.6-.9-.45-1.05-1.05-.15-.6-1.5-1.36-1.5-1.36l-1.05-.15s-.45-.6-.15-1.2c.3-.6-.75-1.35-.75-2.26s-.9-1.06-.9-1.5-1.2-1.8-1.2-2.71-1.8-.46-1.8-.46l-1.36.6s-.3.9-.45,1.36c-.15.44-.75.6-.75.6,0,0-2.26,0-3.01.3-.75.3-2.1.3-2.86,1.04-.74.76-.9,1.06-1.35,1.96-.45.9-1.81-.3-1.81-.3l-1.2-.9-.9.3-1.31.66c.35.44.61.95.61,1.38,0,.86-.15,2.57-.15,2.57,0,0-1.57,1.41-.15,1.98,1.42.57,2.7,1,3.55,1.71.86.71,2.13.99,1.86,2.27-.29,1.28-.72,2.27-1.15,2.7-.42.43-.99,1-.99,1.42s.57,1.56.57,1.56c0,0,.29.57.15,1.42-.15.86-.15,1.43-.15,1.43,0,0,0,.71-.29,1.85-.28,1.14-.28,1.99-.28,1.99,0,0-.86,4.55-1.14,4.98-.29.43-1.57,3.55-1.57,3.55l-.28,3.84v2.99l-1.85,3.98-1,2.27-1.85.72s-1.28.71-1.42,1.99c-.14,1.28-.57,4.26-.57,4.26,0,0,0,1.42-1,1.71-.99.29-3.41,1.28-3.41,1.28l-1.57.57s-.71.14-1.14.71c-.43.57-2.99,1.7-2.99,1.7,0,0-1.56,1.43-1.98,1.57-.44.14-2.71.99-3.27.99s-3.99-.71-4.41-.85c-.43-.14-2.42.29-3.56-.99-1.13-1.29-.86-.58-1.13-1.29-.29-.71,1-1.28-.43-1.28h-4.69c-1.43,0-1.57,1.13-2.7-.29l-1.14-1.42s-.86-.57-1.57-.42c-.71.14-2.14,1.28-2.14,1.28,0,0-.85.85-.85,1.28s.14,1.7,1.56,1.85c1.43.15,2.85.43,2.85.43,0,0,.86.29.57.85-.29.57-1,1.56-1,1.56,0,0-.57.15-.71.57-.14.43-.42,1.57-.42,1.57l-2,.43c-.71,1.42-.14,3.13-.14,3.13,0,0,.14.85-.28,1.14-.43.28-1.85.71-1.85.71,0,0-.42.99-1,1.28-.57.28-2.7.57-3.27.71-.42.11-1.98,1.01-2.79,1.48.12.14,1.09,1.27,1.09,1.94,0,.71-.14,1.42.29,2.84.31,1.06,1.86,2.44,2.61,3.07.47-.17.76.4,1.23.63.57.28,1,1.28,1,1.99s.14,1.99.71,3.55c.58,1.57,1.57,4.55,1.57,4.55l-.85,2.13-1.15.43c-1.13.42-.15,2.13-.15,2.13,0,0,.29.71.29,1.28s-.29,2.27-.29,2.27c0,0-1.56,1.71-2.13,2.56-.57.86-.15,3.56.29,5.41.43,1.85,3.41,2.13,3.41,2.13,0,0,2.28.15,3.13.15s1,1.28,1.71,2.27c.71.99,1-.29,2.13-.42,1.15-.15.86-.86,2.28-.86s0,0,.57.14c.57.14,1.43,1.28,1.43,1.28,0,0,.71,2.7.99,4.27.29,1.57,1.42-.15,1.42-.15,0,0,2.14-.85,4.12-.99,2-.15.71,2.27.71,2.27v1.71c0,.42.86.42,1.43,1.13.57.71-.28,1.14-.28,1.14,0,0-1,.71-1.57,1.84-.57,1.15-.57,3.27-1.28,4.13-.71.86-2.41.43-2.41.43,0,0-2.28,0-4.56.43-2.28.43-4.13,1.42-5.98,1.99-1.85.57-2.7,1.56-2.7,1.56,0,0-1.28,2.99-1.99,4.55-.71,1.57,1.14,1.85,2.28,3.99,1.14,2.14,1.56,5.55,1.56,5.55,0,0,.58,1,2.28,2.13,1.7,1.15.99,1.57.57,2.42-.44.86-1.43.29-2.85,1.28-1.42,1,.43,3.56,1.29,4.13.85.57,1.56,2.27,2.27,4.7.71,2.42-1.28,2.7-2.56,3.99-1.28,1.28-1.85,4.55-1.85,5.12s1.28,1.99,1.56,3.99c.29,1.98-.28,3.55-.43,4.41-.15.85,0,1.14.15,1.71.15.57-.15,1.7-.15,1.7,0,0-.29,1.57.57,3.98.86,2.42,1.14,2.56,0,2.42-1.14-.14-1.56,1.15-2.27,3.13-.71,1.99.43,2.99.43,2.99,0,0,.15,1.56-.43,2.56-.58,1-2.7-1-3.13-1h-3.55c-1.85,0-1.28,0-2.84,1-1.56,1-2.27,2.7-2.56,3.27-.29.57-.42,1.7-3.27,3.69-2.84,1.99-2.55.71-4.97,1.14-2.42.43-2.42,1.14-3.55,2.7-1.14,1.57-1.28.86-1.57,2.28-.28,1.42-.43,3.84-.43,3.84l-.86.28s-.71,1.99-1.14,3.56c-.27,1-2.02,2.16-3.25,2.88v2.98l-.44,2.65c-.18.91,0,2.18,0,2.18,0,0,.18,1.82.91,3.27.72,1.46,0,0,.72.36.73.37,2.55,1.82,2.55,1.82,0,0,1.45,2,2,3.64.54,1.63,1.27,1.27,1.82,2.18.54.91,1.63.55,2.72,1.45,1.09.92.36,1.28.91,2.73.54,1.45,1.63,1.82,3.64,2.36,2,.54,1.63-.36,2.36-.54.73-.18.91-.37.91-.37l1.27.18h.91c.55-2.66,1.65-8.01,2.27-8.63.77-.77,5.14-10.02,5.14-10.02,0,0,5.39-8.73,6.16-8.73s2.57-.51,2.57-.51l2.31-3.6,2.31-.25,1.54.25,2.31-2.82,1.8,1.03s1.54-1.8,1.54-2.83-.26-1.28-.26-2.56,1.54-3.6,1.54-3.6l2.31,2.06,2.06.51s.25.26.25-1.03-.25-4.36-.25-4.36c0,0,1.79-.26,1.79-1.28s-2.06-3.08-3.08-4.62c-1.02-1.54-1.28-3.08-1.28-3.08,0,0-3.34-.26-4.62-.77-1.28-.52-2.31-2.57-1.54-2.57s2.05.51,2.82-.26c.77-.77.51-1.03.77-2.31.26-1.28-2.57-1.79,1.54-2.06,4.11-.26,5.91.51,5.91.51l1.29-2.05-1.54-3.85,1.03-3.34s4.62-2.57,5.39-3.08c.77-.51,3.59-4.36,3.59-4.36l2.05.77,5.14-3.08s-.52-.51,1.28,0c1.8.51,4.37-1.54,4.37-1.54l1.8-2.05s.51-.26,1.54-.26,2.57-.26,2.57-.26l2.31-2.05,3.08-1.8h1.54l3.33-1.28,2.83-.77.25,1.28,1.03.52s.26.51,1.28,0c1.03-.52,3.6-1.29,3.6-1.29l1.54-2.31s1.03-.25,1.54-1.03c.51-.77-.26-2.31.51-3.08.77-.77-.77-1.29,1.54-2.06,2.31-.77,3.59-1.02,3.59-1.02,0,0,1.8.25,1.8,1.02s0,1.29-.51,2.06c-.52.77-1.03,1.03-1.29,2.05-.25,1.03-.51,3.09-.51,3.09l3.09-.26,2.82-.25h2.83v-2.06s2.31-.77,2.31,0,.51,1.8,1.28,1.8h.77s1.28-2.57,1.54-3.34c.26-.77-.25-1.79,1.8-1.79s3.34,3.59,3.34,3.59l1.29.77,1.54,1.28s-.52,0-1.8.52l-1.28.51-.26,1.28.77,1.29s-.25.26-1.28.51c-1.03.26-4.11.26-4.11.26l1.28,1.02,4.11.26,2.57-1.8,2.82-1.03,1.28-2.06s1.29,1.29.52-2.05c-.77-3.34-.77-7.45-.77-7.45l1.54-2.57-3.08.26-1.03,1.54-.26-2.31-.77-1.8,2.31-2.57h1.8l.51,3.08,1.03.26,1.03-3.59.51-3.34.51-1.8.26-3.09s-2.82,1.03-3.34-.25c-.51-1.29-2.05-3.6-2.05-3.6,0,0-.51-.26-.51-1.03v-.77l-4.62-2.57s-1.29-1.03-2.06-1.03-3.08.51-4.87,0c-1.8-.51-3.85-1.29-4.88-2.06-1.03-.77-3.08-3.59-3.08-3.59,0,0-2.31.51-3.09-.26-.77-.77-1.8-2.82-1.8-2.82,0,0-2.31-1.29-3.08-2.06-.77-.77-3.08-2.05-3.08-2.05l-2.06-2.31-8.22-2.31-1.03-.51c-1.03-.52-3.59-.52-3.59-.52l-.77-2.31.77-1.02v-2.57c0-1.03.25-3.34.25-3.34l-1.79-1.54s-1.29-1.03-1.29-1.79.52-10.53,1.54-10.78c1.03-.26,6.17-10.53,6.17-10.53,0,0,5.39-6.68,5.65-7.45.26-.77,2.06-5.14,2.06-5.14l.77-3.85s.26-2.31.26-3.08-.26-2.31,0-3.34c.26-1.03,1.54-2.31,2.31-3.85.77-1.54,3.08-3.34,3.08-3.34l1.03-1.54,2.31-1.03s-.52-1.28,1.02-1.54c1.54-.26,3.86-.26,5.14-.26,1.17,0,1.5.22,2.13.45l-1.03-2.23s-.46-1.2-.6-1.8Z"
        />
        <path
          class="st342"
          d="M55.5,72.98c.37.73.55,1.47.73,2.56.19,1.1,0,.91.18,2.19.18,1.28,0,1.64.19,2.74.18,1.1,2.56,1.28,2.56,1.28,0,0,.54,1.28.54,3.11s.55,1.64.55,3.29-1.46,1.09-2.37,2c-.91.91,0,1.82-.91,3.83-.91,2.01-2.56,2.92-3.29,3.65-.73.73.73,2.37.91,4.38.18,2.01.91.36,2.01,1.28,1.09.92,0,.92,0,2.19v4.02c0,2,1.82,1.28,3.28,1.46,1.47.18,2.19-.56,2.19-.56,0,0,1.47-.36,2.93-.72,1.46-.37,1.1.18,2.01.18s1.63,0,2.55,1.28c.91,1.28-.92,2.74-1.64,4.38-.73,1.64-1.82,2.73-2.19,4.01-.37,1.29.55,1.83,1.46,3.28.91,1.46,0,2.01.73,4.2.73,2.19,1.28,1.09,1.28,1.09,0,0,3.46,2.19,3.83,2.73.37.56,3.29.19,3.29.19,0,0,2.19.55,3.65.55s.91-1.28,1.46-2.92c.56-1.64,1.83.73,1.83.73,0,0,.73,0,1.46-.55.73-.55,1.28-1.82,2.01-2.19.73-.37,2.55.91,2.55.91,0,0,1.1,1.64,2.37,3.47,1.28,1.82,1.28-2.56,1.83-3.66.55-1.09,1.82-2.37,1.82-2.37,0,0,0-1.46.55-2.37.55-.91,1.28-.91,2.37-1.63,1.09-.74.37-1.1.55-2.56.18-1.46-.91-1.1-1.64-2.19-.72-1.1-.91-2.01-.73-3.83.18-1.83,1.82-2.55,3.28-3.65,1.47-1.1.55-2.37.55-2.37l1.1-1.28s.73-.37,2.19-.37c1.38,0,1.48,0,2.58.16l-.58-1.62s-.36-1.46-.55-2.37c-.18-.91-1.63-.73-1.63-1.82s-.19-1.64.36-2.56c.55-.91.18-1.28,1.82-2.01,1.64-.73,2.2-.9,2.92-1.27.74-.37,1.64-1.83,3.11-3.83,1.46-2.01,2.19-1.64,2.37-3.11.18-1.46.36-1.1.18-2.19-.18-1.09-.18-1.46-.18-2.19s-.18-1.64.36-2.38c.56-.72.74-1.63.74-2.19s-1.09-.55.18-1.64c1.27-1.1,1.27-1.46,1.64-2.01.37-.54,1.1-2.01,1.47-3.1.36-1.1,1.09-1.47-.37-2.01-1.47-.55-2.92-1.83-1.82-3.1,1.09-1.28,3.83-3.11,4.38-3.65.54-.55,2.91-.73,3.47-1.46.54-.73,1.09-1.47,1.63-1.64.56-.18,1.83-.91,1.83-.91l.54-2.01s-.18,0,.55-.91c.73-.91,1.64-2.37,1.64-2.37v-2.56s1.09-1.08,2.01-.54c.91.54,1.64-.36,2.19,1.46.55,1.83.73,3.11,1.82,3.28,1.1.18,1.47,0,2.01-1.46.55-1.46,1.28-3.28,2.19-2.01.91,1.27.19,1.83,2.01,1.09,1.82-.74,1.46-1.46,3.28-1.46s3.1-.91,3.1.54-.18,2.93,1.28,2.56c1.46-.37,2.19-1.1,2.19-1.1,0,0,1.46-1.1,1.64-2.37.18-1.28.37-3.28,2.37-2.19,2.01,1.09,2.74,2.37,3.83,2.37h6.39s2.55-.37,3.1.37c.55.73,1.64.36,1.64.36,0,0-.19-1.28,1.27-1.46,1.47-.18,2.01-.55,3.29-1.64,1.28-1.1,2.37-2.38,3.47-2.92,1.09-.55,0-1.46,2.56-1.28,2.55.18,3.83.18,4.38.73.54.55.91,1.82,1.46.91.55-.91.91-1.64,1.46-2.37.56-.73.19-1.83,1.65-.73,1.46,1.09,3.1,1.64,2.55,0-.55-1.64-.56-2.74-1.83-3.47-1.28-.73-.54-.74-1.82-1.46-1.28-.73-1.1-1.64-2.01-2.19l-.91-.54s-2.73,0-2.73-1.29,2-2.92,3.47-4.01c1.46-1.09,1.63-1.46,1.82-2.37.18-.91-.18-.91,1.65-.91s2.18.91,3.46,0c1.28-.91,1.1-1.64,1.64-1.64s1.28.36,1.65-.37c.36-.73-1.46-1.82.36-2.37,1.82-.55,2.37.73,2.55-.73.19-1.46-1.63-2.01.37-2.74,2.01-.73,2.74-.37,2.92-1.46.18-1.1-.91-1.09.55-2.01,1.47-.91,1.82-.73,2.01-1.82.18-1.09-1.64-1.28.37-1.83,2-.54,2.73-.91,2.73-.91,0,0-1.1-.37-.36-2.19.73-1.82.73-2.01,2.55-3.84,1.83-1.82,2.37-3.65,3.83-3.29,1.46.37,2.37-.54,3.1,1.1.73,1.64.37,2.19,2.37,2.37,2.01.19.19.19,2.01.19s1.82.18,2.92,0c1.1-.19,1.47-.19,2.56-.73,1.1-.55-.37-1.65,2.19-.74,2.55.92,3.47,1.47,4.2,1.83.73.36.18.18,1.46.36,1.28.18,2.73.18,2.73.18,0,0,2.19-.54,3.65-1.1,1.47-.54,1.09-1.64,3.28-.73,2.19.91,2.01.73,3.47,1.46.64.32,1.13.66,1.62.9.03-.75.06-2.16.06-4.51,0-3.85-1.03-5.14.77-6.68q1.8-1.54,3.85-2.31c2.05-.77,1.28,2.57,2.05-.77.77-3.34.26-4.62.26-4.62l-.77-1.29-.26-1.54-2.56-.51s-2.31.51-1.8-.51c.51-1.03,1.03-2.32,3.85-3.6,2.82-1.28,3.59-.51,5.4-1.79,1.8-1.29,3.08-1.8,3.08-1.8,0,0-.51-1.54,2.05-1.54h4.62s1.54-.26,1.54-2.06-1.03-2.06-.77-3.34c.26-1.28-1.02-1.8-1.02-3.09s-1.54-4.11.51-6.67c2.05-2.57,2.82-2.32,3.08-3.6.26-1.28,0-1.28,0-2.56v-2.57c0-1.28.26-2.82-.77-3.59-1.03-.77-.77-.77-2.05-1.8-1.29-1.03-.52-.52-2.83-1.8l-2.31-1.28s-.25,2.05-3.33-2.31l-3.09-4.36s.26-.52-.26-2.31l-.51-1.8s-.77-1.03,0-2.06l.77-1.03s1.03-1.8,1.29-2.82c.11-.46.55-1.5.98-2.5-1.72-.1-2.08-.01-2.91-.01-1.05,0-1.45-1.59-1.97-.53-.53,1.05,1.18,2.37-.27,2.51-1.46.13-1.59,0-2.38-.13-.79-.14.53-2.77-1.19-1.45-1.71,1.32-1.72,2.91-3.16,1.58-1.46-1.33-.93-1.58-1.85-2.37-.92-.8-.79-.27-1.45-.93-.66-.66-.8-1.45-.8-1.45,0,0-2.51-3.3-2.51-1.45s.14,2.64.14,3.03,1.84,0,0,.4c-1.85.4-3.3.26-3.3.26,0,0-3.3-.92-2.65.53.66,1.45.53,2.77.53,2.77,0,0-1.18-.4-2.11.14-.93.52-.79,1.31-1.06,2.24-.26.92,1.06,1.97-.79,1.32-1.85-.65-2.24-1.32-3.03-1.32s-3.56.13-3.56.13c0,0-1.05.66-.52,1.85.52,1.18,1.44,1.72.52,2.11-.92.4-2.11.52-3.56.52s-2.64.79-4.36.79-2.24-.4-4.49.14c-2.24.53-2.9,0-4.48.53-1.59.53-5.02,1.85-5.02,1.85l-1.97,2.25-6.47,1.45s-2.51.26-1.46,1.05c1.06.8,2.37,1.45,2.37,1.85s1.19,1.06,0,1.45c-1.19.4-.39.93-3.03.8-2.64-.14-3.96-.4-4.35-.4s-.66-.66-1.72-.14c-1.05.53-.65,1.05-2.24.79-1.58-.26-3.69.79-3.69.79l-2.1.92s-1.85-.92-.8.93c1.05,1.85,2.64,1.72,3.3,2.11.66.39.8.14,1.32.92.52.79.65,1.33.65,1.33,0,0,.53,1.58.53,2.9s1.32,3.3.13,5.93c-1.18,2.64-3.16,7.52-3.16,7.52,0,0-1.45,1.45-2.24,1.98-.8.53-6.86,3.43-6.86,3.43,0,0-2.64,1.98-4.23,2.64-1.58.66-2.24,1.19-2.77,1.86-.53.65-.92,1.31-.92,1.31,0,0-1.05-.79-1.85.13-.79.93-1.33.4-2.77.93-1.46.53-3.04.4-3.04,1.58s-.79,1.85-1.59,2.51c-.79.66-1.32,1.19-1.97,1.71-.66.53-1.06,1.33-1.86,1.59-.79.27-.65-.13-1.44.79-.8.92-.8,1.72-1.33,2.51-.53.79-1.32,3.04-1.84,3.7-.53.65-1.85,2.5-2.51,3.16-.66.66-1.19,1.45-1.19,1.45,0,0-.27.27-1.59,1.19-1.31.93-2.1,1.59-2.1,1.59,0,0,.13-1.72-.66.92-.79,2.64-2.24,5.02-2.9,5.81-.66.79-2.64,1.85-2.64,1.85,0,0-1.85.14-3.56.4-1.72.27-1.32-.26-2.37.53-1.06.79-1.46.53-2.12,1.32-.65.8.4.53-1.05,1.72-1.45,1.18-2.24,2.11-2.64,2.64-.4.53-1.71,3.43-3.83,4.1-2.11.65-3.17,1.05-3.83,1.71-.66.66-.92,1.58-1.85,1.98-.92.4-1.04.39-1.45.65-.4.27-.53.66-.79,1.33-.27.66-.66,1.18-.66,1.18h-2.24s-.79-.92-1.19.79c-.4,1.72-.14,2.25-.79,2.91s-2.11,1.59-2.11,1.59c0,0,.79-.27,1.06.92.27,1.18,1.58-.53.27,1.18-1.33,1.72-1.06.53-1.33,1.72-.27,1.19-3.17,1.58-3.17,1.58,0,0-.53-.78-1.06-.26-.53.52-1.71.52-1.58,1.32.14.8.91,1.33.52,1.85-.39.52-2.64,2.24-2.64,2.24l-2.24,2.5s-.79.26-1.32.53c-.53.27-.92-.79-1.72.66-.79,1.45-1.72,3.57-2.11,3.83-.39.26-1.32,1.05-1.32,1.05,0,0-.65.13-1.32.53-.66.4-1.32,1.46-1.72,1.71-.4.26-1.19,0-1.58.26-.4.27-.53,1.06-.53,1.06,0,0,0,1.18-.65,1.45-.66.27-.4-.92-1.59.27-1.19,1.18-.53.13-1.32,3.16-.79,3.04-1.19,3.17-2.11,3.83-.92.65-4.09,3.29-4.74,3.42-.66.13-5.42.67-6.86,1.59-1.46.92-1.98,1.71-3.03,1.58-1.06-.13-1.33-.27-3.56-.27s-2.37.14-3.83-.13c-.36-.07-.71-.16-1.02-.26v.07s.36,1.1.73,1.82Z"
        />
        <path
          class="st353"
          d="M410.92,56.52c1.02-1.79,0-1.79-1.54-3.08-1.54-1.29-.26-1.79-.26-1.79l-2.57-4.37s-2.56-1.03-3.34-1.03-1.29-4.12-1.29-4.12l.77-4.87s1.29-2.31,2.57-4.11c1.28-1.8-1.03-3.35-1.8-3.6-.77-.26-2.56-1.79-2.06-4.11.51-2.31,1.54-2.06,2.31-3.09.77-1.03.26-2.82-.26-4.12-.52-1.28,0,0-1.03-1.54-1.03-1.54.77-1.54,1.54-3.59.77-2.06,1.79-2.06,2.56-2.31.77-.26,2.57-1.29,2.83-2.58.25-1.28.25-2.05,1.79-3.59s2.83-2.06,3.08-2.83c.25-.77,1.29-3.85,1.54-4.62.25-.77.26-1.79,1.03-3.34.77-1.54,2.82-.52,3.85-.52s.51-1.54.77-2.56c.26-1.03.26-3.08,0-3.85-.26-.77-2.31-1.29-2.31-1.29,0,0-.51-2.56-.51-4.11s.51-1.54,1.28-3.35c.11-.27.13-.43.18-.64l-.42-.2.42.2c.28-1.14-.41-1.3-1.72-.64-1.54.77-3.34,3.09-3.34,3.09l-1.79,1.54-4.62,2.82s-2.83.52-4.37.52-1.28,0-2.56-1.54c-1.29-1.54-2.31,1.03-3.85,2.06-1.54,1.02-2.31.5-2.31.5h-2.83s-.51,2.06-1.79,3.6c-1.29,1.54-2.31-1.54-2.83-3.33-.52-1.8.26-2.31.52-3.85.25-1.54.77-2.06-1.54-2.83-2.31-.77-1.03-1.02-.77-2.06.25-1.03.25-1.54.25-1.54,0,0-1.03-1.79-1.03-4.11s-2.06-.52-2.06-.52c0,0-2.06-1.28-3.85-3.08-1.8-1.79-3.08-.25-3.08-.25l-3.59.52s-3.85-1.54-5.9-1.8c-2.06-.26.77-2.31.77-3.09s.51-1.54.26-3.33c-.26-1.79-3.59,0-3.59,0l-3.34,1.02s-1.03.77-2.56,1.81c-1.54,1.02,0,0-.77,1.54-.77,1.54-.26,2.05-1.8,2.05s-2.05.77-2.82,1.29c-.77.52-1.8.77-3.6,1.54-1.8.77-1.28,2.06-1.28,2.06,0,0-.77,2.05-2.82,4.11-2.06,2.06-2.83.25-2.83.25,0,0-1.54-2.81-2.31-4.87-.77-2.06-2.56-2.06-3.59-2.83-1.03-.77-2.31-1.28-4.11-2.05-1.8-.77-4.87-1.8-4.87-1.8,0,0-1.54.26-4.11.26s-4.11-2.83-4.11-2.83c0,0-3.59-.52-4.87-.25-1.29.25-3.08,1.79-3.34,2.82-.26,1.03-2.31,8.47-2.57,10.02-.26,1.54-1.03,1.8-2.06,2.83-1.03,1.02-1.8.77-3.59,1.54-1.8.77-1.54.25-1.29,2.06.25,1.79,0,0,.52,1.02.51,1.03.77,2.31.51,4.88-.26,2.57-1.28.26-3.34.52-2.06.25-2.05.25-4.36,1.54-2.31,1.29-2.57.77-4.37,1.03-1.8.26-1.29-.51-3.34-2.05-2.06-1.54-2.06,1.54-1.03,4.36,1.03,2.83,1.03,3.85.52,5.39-.51,1.54-1.54.77-3.85,1.29-2.31.52-3.34.77-5.91,2.06-2.56,1.28-2.05,1.02-2.05,1.02-2.82-1.79-3.59.52-3.59.52,0,0-.52,2.82-.77,4.62-.19,1.37-2.02,1.01-2.89.76.12.89.46,1.4,1.04,2.11.73.91-.36.91,1.28,1.83,1.64.91,2.37,1.09,2.56,2.19.18,1.09,2.37,2.01,2.37,2.73s0,2.19-.74,3.47c-.73,1.27-1.28,1.65-1.28,3.1s.55,4.38.55,5.29-.55,2.37-.91,3.28c-.37.91-1.28,1.82-.37,3.66.91,1.82,1.27,2.36,1.64,3.28.36.91,2,3.1,2.73,4.75.74,1.64.74,2.37,1.65,2.73.91.37,2.55.37,3.28,2.01.73,1.64.92,2,.92,3.83s-1.29,4.02-1.29,4.02c0,0-.72.91-.72,1.63s1.09,1.1.72,2.19c-.36,1.1-.72,1.83-.36,2.37.36.55.73,3.1,1.28,5.12.55,2.01.91,2.19,1.83,3.1.91.91,2.55,0,2,1.63-.55,1.65-1.09,4.02-1.09,4.02,0,0-.55.36-.19,3.1.38,2.74,0,4.38,1.47,5.11,1.46.73,2.37.36,2.92,2.01.56,1.64-.18,1.64,1.1,2.73,1.28,1.1.55-.37,1.28,1.1.73,1.46.91,1.65.91,2.56s.18,1.46.18,2.37.19.91.19,2.19v2.19s-.19.91-.19,1.65c0,.33.04,1.05.09,1.73l1.28.43,2.5,2.69s1.34,1.16,2.5.96c1.16-.19,4.24-.77,4.24-.77,0,0,.96-1.16,1.73-1.35.77-.19,2.89-1.54,3.66-1.35.77.19,3.85.58,3.85.58v-3.08s.19-.39,1.92-.58c1.74-.19,2.51-.19,3.28-.38.77-.19.96,0,1.73-.77.77-.77,2.31-2.12,2.31-2.12h3.85c.58,0,2.12,2.7,2.12,2.7,0,0-.19.58-.19,1.34s1.16,1.74,1.16,1.74l2.31.19.77-2.12s.96-.19,1.35.77c.38.96,1.16.96,1.54,1.92.39.96.58,1.54.96,2.12.39.58-.38.96.97,1.74,1.34.77,3.66,1.73,3.66,1.73l.39-2.12,3.08-2.69,3.85.19s3.66,1.74,4.43,1.74h5.59l1.16-.19s-.58-4.62,0-4.82c.58-.19,2.89-1.54,2.89-1.54l2.7-5.01,1.35.77.58-2.89,3.66-3.08s.77.19,1.16-.58c.38-.77.58-1.92.58-1.92l-.19-2.89h-4.04c-1.54,0-3.85.19-3.85.19,0,0-1.54.38-1.92,1.16-.39.77-2.31,3.85-2.31,3.85l-1.54,1.35-1.74-3.27v-1.35c0-.77.19-1.73.77-1.73s2.7.19,2.7.19c0,0-.19.39.77-.19.96-.58,2.12-2.12,2.12-2.12,0,0,1.54-.58,2.12-.58s.58-.39,2.12,0c1.54.39,6.93,1.73,6.93,1.73l.39,2.12h3.27s.39.19.96.19,3.27-.77,3.85-.96c.58-.19,3.27-1.54,3.27-1.54,0,0-.19-1.54,1.35-1.74l1.54-.19s1.54.19,1.74-.38c.19-.58.96-2.31.96-2.31,0,0-.58-1.54-.19-2.5.39-.96-.96-2.12.58-2.12s1.54.39,2.69-.39c1.16-.77,1.16-1.92,1.92-3.08.77-1.16.39-.77,1.54-1.54l1.16-.77.58-1.92s-.96-1.35-.19-1.54c.77-.19.96-.19,1.73-.38.77-.19,1.73-.39,1.73-.39l1.74-1.16s.96-.58,2.12-.77c1.16-.19,2.7-.77,2.7-.77h1.33c-.2-.68-.37-1.4-.37-1.92,0-1.29,0-1.04,1.03-2.83Z"
        />
        <g>
          <path
            class="st343"
            d="M122.63,189.07s0,1.62-.12,1.99c-.13.37,0,.62-.5,1s-.87.87-.87.87c0,0,.25,0,.12,1.12-.12,1.12.25,2.12.25,2.74s-.25.5.87,1.74c1.12,1.25,2.61,2.12,2.61,2.49v1.25s.38.87,1,.25c.62-.62-.74-.12.62-.62,1.37-.5-1.24-.38,1.37-.5,2.61-.12,2.36-.25,3.85-.12,1.49.12,1.12.49,1.49.12s.63-2.24,1.12-2.74c.5-.5.5-.99,1.37-.99s1.12-.26,1.86.12c.75.38-.25.13,1.37.5,1.62.37,2.36.13,2.98.99.63.88,2.12,1.25,1.12,1.62-1,.37-1.37.25-1.49.75-.12.49-1.49,1.24,0,1.24s3.11-.49,3.11-.49c0,0-.63-.13.5.25,1.12.37.13,1.12,1.12.37.99-.74,1.86-1.62,1.36-2.62-.5-.99-.99-1.49-.99-1.99s0-1.87.37-2.24-.49-1.37.74-1.49c1.24-.13,1.25-.13,1.75-.13s1.87.74,2.36.74.37.13,1.49-.74c1.12-.87,1.75-1.12,2.12-1.36.37-.26.37-.51,1.24-.63q.88-.12,1.62-.12c.75,0,2.49-1.62,1.99-1.75-.49-.13-2.24.25-2.86-.13s.13-.75-.5-.99c-.62-.25-2.24-1-2.98-.88-.74.13-.74-.25-1.49.5s-.62,0-.87,1.61c-.25,1.62,1.25,2.24-.62,2.24s-3.74-.25-4.24,0c-.49.26-1.24,2.12-1.74,2.5-.5.37.13,1.74-2.36,1-2.5-.74-1.99-.12-4.11-1.62-2.12-1.5-2.37-.74-2.61-1.74-.25-1-.37-1.49-.37-2.37v-1.74s1.24.25-1.37.13c-2.61-.13-2.61-.37-2.87-.75-.25-.37.26-1.86-.49-1.86h-1.99c-.62,0,0,.87-.87,1.12-.87.25-1.25-.38-1.75.12-.49.5-.12,1-.99,1.12-.88.13-2.12-.62-2.74.13Z"
          />
          <path
            class="st343"
            d="M123.95,147.44l.36-2.01s1.1-1.09,0-1.09-2.37-.36-3.1-.36-1.46-.37-1.46-.37c0,0-.36-1.46-1.64-2-1.28-.56-1.83-1.65-1.83-1.65,0,0,.19-.54-.18-2.01-.37-1.46,1.28-.55-.37-2.74-1.64-2.19-2.19-1.09-2.01-2.92.18-1.83.73-3.28.73-3.28,0,0,1.82-1.65.18-2.01-1.64-.37-2.37.9-3.28-.37-.91-1.28-1.65-2.74-1.65-2.74l-2-1.63s-.19-.91-.19-2.74.37-3.11,0-4.57c-.36-1.46-.36-2.37-.36-4.74s.18-3.28-.18-3.83c-.37-.56.55-1.28-.74-1.47-.06,0-.1,0-.15-.02l.44,1.25-.44-1.25c-1.1-.15-1.2-.16-2.58-.16-1.46,0-2.19.37-2.19.37l-1.1,1.28s.92,1.27-.55,2.37c-1.46,1.09-3.1,1.82-3.28,3.65-.19,1.83,0,2.74.73,3.83.73,1.09,1.82.73,1.64,2.19-.18,1.46.55,1.82-.55,2.56-1.1.72-1.82.72-2.37,1.63-.55.92-.55,2.37-.55,2.37,0,0-1.28,1.28-1.82,2.37-.55,1.1-.55,5.48-1.83,3.66-1.28-1.82-2.37-3.47-2.37-3.47,0,0-1.82-1.28-2.55-.91-.74.36-1.28,1.63-2.01,2.19-.73.55-1.46.55-1.46.55,0,0-1.28-2.37-1.83-.73-.54,1.64,0,2.92-1.46,2.92s-3.65-.55-3.65-.55c0,0-2.92.37-3.29-.19-.37-.54-3.83-2.73-3.83-2.73,0,0-.55,1.1-1.28-1.09-.73-2.2.18-2.74-.73-4.2-.91-1.46-1.83-2-1.46-3.28.37-1.28,1.46-2.37,2.19-4.01.73-1.64,2.56-3.1,1.64-4.38-.92-1.28-1.64-1.28-2.55-1.28s-.56-.55-2.01-.18c-1.46.36-2.93.72-2.93.72,0,0-.73.73-2.19.56-1.46-.18-3.28.54-3.28-1.46v-4.02c0-1.27,1.09-1.27,0-2.19-1.1-.91-1.82.73-2.01-1.28-.18-2.01-1.64-3.65-.91-4.38.73-.73,2.37-1.63,3.29-3.65.91-2.01,0-2.93.91-3.83.91-.91,2.37-.37,2.37-2s-.55-1.47-.55-3.29-.54-3.11-.54-3.11c0,0-2.37-.18-2.56-1.28-.19-1.09,0-1.46-.19-2.74-.18-1.28,0-1.09-.18-2.19-.18-1.09-.36-1.83-.73-2.56-.37-.73-.73-1.82-.73-1.82v-.07c-.96-.3-1.65-.57-1.75.13-.14.92.79,1.72-.66,2.65-1.45.92-1.98.26-2.11,1.31-.13,1.06-1.05,1.19-1.05,1.19,0,0,.53-1.06,0-1.71-.53-.66-.53-.93-1.58-1.05-1.05-.13-1.72-.79-2.51-.4-.79.4-.93.92-1.45,2.24-.52,1.33-1.72,1.85-.79,2.37.92.53,1.71.4.79,1.05-.92.66-1.58.8-1.98.66-.4-.13-.27-.13-.92-.13s.39-.8-1.19.13c-1.59.93-1.46.27-1.72,1.45-.26,1.18-.92,3.17-.92,3.17,0,0-.4.79-.14,1.32.27.53.79.8.4,1.85-.4,1.05-1.32,2.38-1.98,2.65-.66.27-1.84-.14-2.9.92-1.06,1.05-1.85,2.38-2.9,3.3-1.06.92-1.19,1.72-1.85,2.24-.66.53-.66.53-1.32,1.71-.66,1.19-.26,1.46-1.06,2.64-.79,1.19-1.05,1.85-1.05,1.85,0,0-.8.14-1.45.8-.66.65-.4.65-1.06,1.71-.66,1.06-.79,1.86-1.58,2.51-.79.66-1.32,0-2.51.66-1.18.66-.79,1.06-1.05,1.85-.27.79.39,0-1.06,1.58-1.45,1.59-1.85,2.11-1.85,2.11,0,0-.26.39-1.32.79-1.06.4-.27,1.85-2.11.4-1.85-1.44-2.38-1.44-2.38-1.44l-.91.13s0,.92-.53,1.98c-.53,1.06-.4,1.46-1.06,2.11-.66.66-.66.92-1.32,1.19-.65.27-.52.8-1.58.27-1.06-.53-.66-1.45-1.98-1.45H-1.99s-1.05.66-1.58.66-.4-1.05-1.72-.79c-1.32.26-.66-.53-1.84.65l-1.19,1.19s-1.05.27-1.05-1.46v-2.37s-2.37,1.19-.39-.79c1.97-1.97,1.97-2.37,2.64-2.24s.93-.13,2.37-.27c1.46-.13,3.43-.13,2.51-.79-.92-.66-.66-1.58-2.11-1.05-1.45.53-2.37.79-3.03.92-.66.14-1.06.14-2.77.14s-2.9-.52-2.9-.52c0,0-.66-1.98-.8-.14-.13,1.85,0,3.69-.13,4.35-.13.66,0,2.9,0,3.56s2.24,1.19-.4,1.19-3.3.26-3.96-1.06c-.66-1.32-.53-1.85-.66-2.77-.13-.93.93-1.46-.39-1.59-1.32-.13-1.98.79-2.78-.26-.79-1.05.93-1.32-.92-1.59-1.85-.26-2.51-.26-3.03-.26s-.92-.53-.92-.53c0,0-.53,1.06-2.64,1.59-2.11.52-4.75,2.1-5.68.52-.92-1.58-.65-2.38-1.31-2.65-.66-.26-2.51-1.05-2.51-1.05,0,0-1.06-1.59-1.32-.79-.26.79,0,1.44-.66,1.58-.66.13-1.84.13-1.97,1.06-.13.92,0,1.05-.4,1.58-.4.53-1.33,1.05-1.33,1.05,0,0-1.58-1.32-1.45.66.14,1.98.53,2.77.92,2.77s1.33,1.72,1.59.93c.27-.79.27-2.37.27-2.37,0,0-.27-1.59,1.05-1.59h1.32s-1.19.79,1.19.79h3.03l1.05-.53s.66.92,1.45,1.58c.79.66-.53,0,.79.66l1.32.66s.65,1.19-.14,1.32c-.79.13.27-.4-1.85.13-2.11.52-3.43,1.05-3.43,1.05,0,0-1.32,0-1.98.92-.65.93.26,1.32-2.51,1.72-2.77.4-3.43.39-3.95.92-.53.53,1.45,1.72-.53.53-1.98-1.19-2.37-1.71-2.37-1.71,0,0-.8-2.24-1.32-.92-.53,1.32,0,1.44-1.06,2.1-1.05.66-1.32.8-1.32,1.72s.26,3.03.26,3.03l.53,1.72s.53-.39-.39.79c-.92,1.19-3.56,1.72-2.65,2.64.93.93,2.51,1.72,2.65,2.51.13.79-.4.41.52,2.25.93,1.84.53,1.71,1.46,2.37.92.66.13.14,1.58,1.06l1.46.92s-1.06,1.32-.53,2.65c.53,1.32,1.19,1.32,1.19,1.32v1.98c0,1.05.14,1.31-.13,2.5-.27,1.19-.66,2.37-.66,2.37,0,0-.93.79-1.33,1.46-.39.66-.78.92-.91,1.84-.13.93-.53,1.46-.53,1.46,0,0-1.33.27-2.11.27s-1.32-1.72-1.85,0c-.53,1.71-.93,2.9-.8,3.56.14.65,0,.66.53,1.84.53,1.19.93,2.11.93,2.11,0,0,1.18,2.25,1.18,3.04s.79,1.05,1.32.13c.53-.92,1.19-.66,1.19.52s-.27,1.06,0,2.38c.26,1.32.79,2.38.79,2.38,0,0-.13.92.13,2.1.26,1.19.66.53.52,1.99-.13,1.45-1.71-.27-1.19,1.71.53,1.98.66,2.9.66,3.7s-.79,3.56-.79,3.56c0,0-.27.8-.93.93-.66.13-2.24-1.99-2.5-.66-.27,1.32.26,2.5,1.31,3.17,1.06.66.53.13,1.06.66,0,0,.89.25,1.91-.58,1.02-.83,1.66-1.66,1.66-1.66,0,0-.65-.75.56-.93,1.2-.18,1.48-.1,2.22-.65.74-.56.65-.46,1.48-1.2.83-.74,2.59-2.04,3.06-2.31.46-.28,1.11-.47,1.48-1.2.37-.73.56-2.13.65-2.68.09-.56.37-1.01.37-1.01l2.22-3.42,2.04-3.7s.55-1.76,1.29-1.2c.74.56,1.85,1.48,2.13,1.67.28.19,1.3.56,1.58.74.28.18,1.29.65,1.66.65s.47-.74,1.3,0c.83.73,2.31,1.39,2.68,2.04.37.64.46.93,1.11,1.48.64.56,2.22,1.48,2.22,1.48,0,0-.65.36.56,1.2,1.2.84,2.13,1.11,2.41,1.3.28.18,1.02.65,1.11,1.11.09.46.47.56.09,1.2-.37.65-.65,2.68-.65,2.68,0,0-.46.65.1,1.48.55.83,1.48,2.5,1.85,2.68.37.18.56.83,1.3.56.74-.28.65-.74,1.3-1.02.65-.28,1.39-.46,1.66-.92.28-.47.83-1.77,1.11-1.95.28-.18.1-1.02,1.58-.18s1.11.46,1.94,1.38c.84.93.65,1.39,1.76,1.94,1.12.56,1.3.74,2.04.93.74.19.74.28,1.76-.37,1.03-.65,2.13-1.67,2.13-1.67,0,0,3.88-3.42,5.27-4.16,1.39-.74,1.76-.84,2.22-1.39.46-.56,1.94-2.68,2.4-3.98.47-1.3.74-1.76,1.2-2.13.47-.38.93-1.57,2.59-1.2,1.67.37,0-.36,2.5,1.11,2.5,1.47,1.94,2.5,2.31,2.87.37.36,1.48.82,2.5.36,1.02-.45.92-1.47,1.39-1.84.45-.37.45-1.58.64-2.32s-.64-2.87.46-2.5c1.11.37,2.04.74,2.04.74,0,0,2.68.84,2.96,1.29.28.46,1.38,1.2,1.02,1.58-.37.36-1.48.37-.28.83,1.2.46,1.2.64,2.12.83.93.19.74.46,1.86.19,1.11-.28,1.66-.09,2.4-.74.73-.65.18.37,1.47.09,1.3-.28,2.4-.83,2.5-1.39.1-.56,0-1.67.1-2.04.09-.37.28-1.11,1.11-1.11s1.01-.09.92.56c-.09.65-.65,1.11,0,1.11s1.48-.56,1.76-.93c.28-.37.45-.92,1.11-1.29.65-.38,1.2-.93,2.31-.93s.1.46,1.58.18c1.48-.28,4.25-1.39,4.53-1.48.28-.09.1-.18.65,0,.56.19,3.52-1.11,4.54-1.19,1.01-.1,1.11-.93,2.86-.1,1.76.83.19,1.3,1.02,1.2.83-.1,2.78-.38,3.43-.46.64-.09,2.5.09,2.68.46.18.37.64,1.85.83,2.31.18.46,1.49.83,1.76,1.2.28.38.93.56.45,1.02-.45.46-.28.46-1.29.83-1.02.36-1.39.46-1.85.74-.46.28-.74.28-1.02.74-.28.46-.09.28-.46,1.02-.38.74-.83.93-.93,1.38-.09.47,0,1.67,0,1.67,0,0-.28.36-.65.46-.36.1-2.31.1-2.4.46-.09.37.09.56.74.56h1.48c.28,0,.46-.19,1.2,0,.74.18,1.48-.1,1.66.18.18.28-.18.37.74.55.92.19.64,1.03.92.19.28-.84.65-1.67.28-1.67s-.65.1-1.11-.09c-.46-.19-1.12.18-1.2-.46-.09-.65-.19-1.3.37-1.48.55-.18.84-.1,1.2-.28.37-.18.55-.28,1.58-.92,1.01-.65,1.85-1.48,2.49-1.57.65-.09,2.13-.56,2.5-.37.37.18,1.19.74,1.29,1.11.1.37.1.65.19,1.3.09.64,1.01,1.84,1.29,2.31.28.45-.92.28,1.86,1.29,2.77,1.03,2.86.37,3.51,1.2.65.84,1.01,1.4,1.57,2.22.56.83.46.92,1.11,1.2.65.28,1.66-.92,2.59.46.92,1.38,1.76,1.94,1.94,2.31.18.37-.29.65.74,1.02,1.02.37.83.09,2.41.83,1.56.73,2.12,1.11,2.59,1.38.45.28,1.2.74,1.2.74l.94.24c.52-.13,2.37-.92,2.76-.79.4.13,3.02,1.58,3.02,1.58,0,0,1.71,1.58,2.51,1.97.78.39,2.1,1.05,2.49,1.32.4.26,1.32.65,1.32.65,0,0-.26.93-.39,1.32-.14.39.26,1.58.26,1.58v1.45c0,.66-.13,1.18-.13,1.58s0,.66.65.79c.66.13.66.13,1.32-.13.66-.26,1.45-1.71,1.97-2.23.53-.53.66-1.97.66-1.97,0,0-.79-1.32-.79-1.84s.92-.66-.13-1.05c-1.05-.39-.92-.66-1.45-1.18-.52-.52-1.05-1.71-1.05-2.1s.13-.79.13-1.71-.92-2.5-.92-3.55-.92-1.84,0-2.5c.92-.66,1.05-.66,1.71-.92.65-.26.13-.13,1.58-.26,1.45-.13,2.63-.13,2.63-.13,0,0,2.89-.53,3.15-.93.26-.39,1.32-2.23,1.32-2.23,0,0,.14-1.44.39-1.97.27-.53.14-.79.53-1.32.4-.52,2.1-3.55,1.71-5.78-.4-2.24-1.06-5-1.19-5.39-.13-.4-.13-1.58-.13-1.98s-.53-3.82-.53-3.82l-1.71-3.68s2.37-1.45,2.76-1.58c.39-.14,1.32-1.58,1.32-1.58,0,0,.91.66,1.58.66s1.18.52,1.18,0,.92-3.55.66-3.94c-.27-.4-1.06-.92-1.19-1.58-.13-.66-.13-1.84-.13-2.51s-.52-2.89-.52-2.89l-.49-1.05c-.51.25-1.13.49-1.73.49-1.28,0-2.73,1.64-2.73,0Z"
          />
        </g>
        <path
          class="st347"
          d="M514.55,131.35v2.72c0,.52.64.91,1.55,1.82.91.9,1.94,1.04,3.37.52,1.42-.52,0,0,.64-.65.64-.65.52,0,1.16,0s1.55.14,1.55.14c0,0,.65,0,1.43-.39.78-.39.52-.39,1.55-.91s0,0,2.46-.13c2.46-.13.64-1.17.64-1.17,0,0,.39-.65,1.04-1.17.65-.52,1.04,0,2.07-.13,1.03-.13,1.55-.77,1.55-.77,0,0,.13-.52,2.33-1.55,2.21-1.03.65.52.65.52l1.16-.13h1.43c.91,0,0,.65,1.04,1.94,1.03,1.3.91-.13,1.68-1.04l.78-.9c.77-.9,1.04-.26,1.68-.52.64-.26,1.55-1.81,2.2-2.33.65-.52,0,0,.39.13.39.14,2.07.39,3.24.39s2.2-.39,2.2-.39c0,0,1.17-.25,2.72-.64,1.55-.39,1.42-.26,2.71-.91,1.3-.64.78-.52,1.3-1.04.51-.52,1.42-.39,1.42-.39,0,0,.78-.26,3.63-.26s1.04-.39,1.04-.39c0,0,.65-1.04,1.81-1.29,1.16-.27.78,1.42.78,1.42,0,0,.77,1.17,1.81,1.81s.78-.64,1.17-.78c.39-.13,1.94-1.04,2.85-1.29.9-.26,2.71-1.16,3.75-1.94,1.04-.77,1.3-1.03,1.94-1.29.64-.26,2.58-.9,2.58-.9,0,0,1.55-.39,2.33-.39h3.1s1.12-.13,1.79-.45c-.06-.3-.09-.5-.09-.5,0,0,.03.2.09.5.05-.02.11-.04.15-.07.65-.39.78-1.3.78-1.3,0,0,.77-.38,1.55-.65.77-.25.77-1.04.9-1.94.13-.9-.77-.9-1.17-1.94-.39-1.04.52-1.17.78-2.07.26-.91,1.04-2.2,1.04-3.24v-5.04c0-.65-.52-.65-.52-1.3v-4.65c0-1.55-.9-1.81-.9-1.81l-1.43-.52c-1.42-.52-1.04-1.3-1.04-1.3,0,0,0-1.04.78-2.98.77-1.93.64-.9,1.29-1.42.65-.52.39-1.3,1.43-2.46,1.03-1.17-.52-2.07-.65-3.11s-1.81,0-2.46-.65c-.64-.65.52-2.97.52-2.97l.39-3.5s.52-1.29,1.29-2.33c.78-1.04.13-1.81.26-2.33.13-.52.13-1.55.26-3.24.13-1.69.78-2.46.78-2.46,0,0,.64-.52,1.55-1.04.9-.52.52-1.04,1.04-3.37.52-2.33-.14-1.16.25-2.33.39-1.17,0,0,.78-.26.77-.26,0-2.2,0-2.2,0,0-.14-1.68.13-2.33.26-.65,2.33.77,2.33.77,0,0,.13-.03.3-.12-.15-.4-.25-.69-.25-.69,0,0,.1.29.25.69.16-.08.35-.21.47-.4.26-.39.13-.64.64-1.29.52-.65.52-.65,1.3-1.42.77-.78,0-1.69,0-1.69,0,0-.27-.77-1.43-1.93-1.16-1.17-1.43-.9-2.2-2.07-.78-1.17-.91-2.33-.91-2.33l-1.55-.64s-.78-.27-.78-.65v-2.33c0-1.3-.26-.52-.65-1.68-.39-1.17-.52-.52-1.16-1.04-.65-.52-.26-1.17-.26-2.2s-.65-.52-1.68-1.3c-1.04-.77-1.04-.26-2.07-.52-1.04-.26-.13-1.04-.13-1.04,0,0-.13-.64-.64-1.81-.52-1.16,0,0-.52-.9-.52-.9,0,0-.65-.65-.65-.64-1.42,0-2.33.14-.91.13-1.3.9-2.59.38-1.3-.52.64-1.16.64-1.16l1.04-.52s.14-.91.27-1.81c.13-.9-.13-1.3-.27-2.07-.13-.77-1.16-.65-2.59-.65s-.65,1.11-2.32,1.55c-1.29.35-.96-.76-1.07-.13-.53,2.81,0,0-.79.79-.8.79-.27,1.58,1.06,3.17,1.32,1.59.79,1.06.79,1.06l-1.59,1.85c-1.59,1.86,0,0-1.06,0h-2.65c-1.59,0-1.59-.79-1.59-.79l-1.06-1.06s-.79-1.06-.79-2.65-1.06.53-2.65.8c-1.59.26-.91-2.07-.91-2.07,0,0,.26-3.6.52-4.89.25-1.28,0-1.79,0-1.79,0,0-1.03-.77-1.8-1.29-.77-.51-2.57-1.28-2.57-1.28h-2.57l-3.34.25s-3.34,0-4.11-.77c-.77-.77,0-1.54-.26-3.08-.26-1.54,0,0-1.03-2.06-.26-.52-.52-.86-.75-1.07,0,0-.01.04-.01.04,0,0-1.28.77-2.31,1.29-1.03.5-2.06.25-1.8,1.79.26,1.54,2.31,2.31,2.06,2.83-.26.5.25,3.85,0,5.64-.26,1.79-1.55,3.85.25,4.37,1.8.5,3.34-.27,4.62.5l1.29.77,2.06.52,3.08,1.02,2.31.77s1.28,1.81,0,1.81-2.57-.78-3.08.5c-.51,1.29.51,3.35.51,4.37s-.25,2.56-.25,2.56c0,0-.77.77-1.03,2.31-.26,1.54-.26,4.37-.26,4.37,0,0-2.06,2.31-.51,4.1,1.54,1.81,2.57,2.83,2.57,2.83,0,0,1.28,1.29,1.54,2.83.25,1.54.51,3.09.51,4.88s-.51,2.82-.51,2.82c0,0,.25,2.06-1.54,2.31-1.8.26-1.8-.52-2.83.77-1.02,1.28-1.09,3.27-1.09,3.27l2.5,1.34,3.08,2.12s1.35,2.31,1.35,2.89-.19,3.85-.19,4.62-.19,3.85-.19,3.85l-.58,2.7s-1.54,6.35-2.12,6.55c-.58.19-3.09,3.47-3.85,3.85-.77.39-4.62,4.43-4.62,4.43,0,0-2.12,7.32-3.47,7.9-1.34.58-8.28,6.17-8.28,6.17l-5.59,5.2s-3.85,3.27-4.62,3.85c-.77.58-5.2,4.62-5.97,4.62s-2.5.19-3.08.19-2.51-.77-2.51-.77l-3.87,1.77c.03.14.07.28.09.38.26,1.17,0,.91,0,.91Z"
        />
        <path
          class="st345"
          d="M635.29,224.96s-.18.19-.91.37c-.73.18-.36,1.08-2.36.54-2.01-.54-3.1-.91-3.64-2.36-.56-1.46.18-1.81-.91-2.73-1.09-.9-2.18-.54-2.72-1.45-.55-.91-1.28-.55-1.82-2.18-.55-1.64-2-3.64-2-3.64,0,0-1.81-1.45-2.55-1.82-.72-.36,0,1.1-.72-.36-.73-1.46-.91-3.27-.91-3.27,0,0-.18-1.27,0-2.18l.44-2.65v-2.98c-.71.41-1.25.68-1.25.68,0,0,.54-.27,1.25-.68v-.95l-3.93-1.75-1.89-.72h-1.13s-1.46,1.29-3.08,1.94c-1.62.65-3.23.81-3.23.81,0,0-.98-.16-1.46-.65-.49-.49-1.13-.65-2.26-.97-1.13-.32-.65-.32-2.43-.32s-1.77-.33-3.24-.16c-1.46.16-2.1.32-2.59.48-.49.16-1.13,0-1.13,0l-.49.48-.64,1.3s-.32.32-.97.81c-.65.48-1.46.65-1.46.65l-2.26.32.32-1.29.16-1.62s.81-.81,0-.81-2.59-.16-2.59-.16l-.32-1.94s.81,0,.98-1.3c.16-1.29.32-2.27.32-2.27l.48-2.74,1.3.15s1.46-.15,1.46-1.45,1.3-3.39,0-5.02c-1.29-1.62-1.78-2.59-1.78-2.59v-.98h-3.08s-.32-.31-.32-.8v-1.78l-.16-1.61-.97-1.3-.49-1.3-1.13-1.13-2.59-.97s-.98-.48-1.3-.96c-.32-.49-.49-.98-.49-1.62v-2.1l1.46-1.94s1.46-.16,2.1-1.3c.64-1.13.65-2.43,1.62-3.88.97-1.45,2.59-2.59,2.59-2.59,0,0,1.46.49,1.94-.64.49-1.13-.81-.81.97-2.11,1.78-1.29,2.26-1.78,2.11-2.74-.17-.98-1.13-3.07.81-4.21,1.93-1.14,2.42-1.14,2.42-1.14,0,0,.81-.16,2.26.16,1.46.33,2.27,1.62,3.88.81,1.62-.81,1.78-.32,1.78-2.75s-.32-4.21-1.3-5.49c-.97-1.3-2.26-1.94-2.26-1.94,0,0-2.59,2.43-2.75.97-.17-1.46-.81-5.01-.98-7.11-.16-2.1-.8-3.07-.8-3.07,0,0,.48-2.43-.33-3.89-.62-1.12-1.09-3.45-1.27-4.45-.68.32-1.79.45-1.79.45h-3.1c-.78,0-2.33.39-2.33.39,0,0-1.94.64-2.58.9-.65.26-.91.52-1.94,1.29-1.04.78-2.85,1.68-3.75,1.94-.91.26-2.46,1.16-2.85,1.29-.39.14-.13,1.42-1.17.78s-1.81-1.81-1.81-1.81c0,0,.38-1.68-.78-1.42-1.16.25-1.81,1.29-1.81,1.29,0,0,1.81.39-1.04.39s-3.63.26-3.63.26c0,0-.91-.13-1.42.39-.52.52,0,.39-1.3,1.04-1.3.65-1.16.52-2.71.91-1.55.39-2.72.64-2.72.64,0,0-1.04.39-2.2.39s-2.84-.26-3.24-.39c-.39-.13.26-.64-.39-.13-.64.52-1.55,2.07-2.2,2.33-.64.26-.91-.39-1.68.52l-.78.9c-.77.91-.64,2.34-1.68,1.04-1.04-1.29-.13-1.94-1.04-1.94h-1.43l-1.16.13s1.55-1.55-.65-.52c-2.2,1.04-2.33,1.55-2.33,1.55,0,0-.52.64-1.55.77-1.04.13-1.43-.39-2.07.13-.64.52-1.04,1.17-1.04,1.17,0,0,1.81,1.04-.64,1.17-2.46.13-1.43-.39-2.46.13s-.77.52-1.55.91c-.77.39-1.43.39-1.43.39,0,0-.9-.14-1.55-.14s-.52-.65-1.16,0c-.64.65.77.14-.64.65-1.43.52-2.46.38-3.37-.52-.9-.91-1.55-1.3-1.55-1.82v-2.72s.26.26,0-.91c-.02-.11-.06-.25-.09-.38l-.37.16-1.54,1.16-1.54,1.16v3.09l-1.73,1.16.19,1.92s1.74-.19,2.51,0c.77.19,3.85.96,4.43,1.54.58.58,1.92,1.74,1.92,1.74,0,0,.58.77-.38.77s-2.51-.58-2.51-.58l.39,1.16s.19.19,2.5,1.34,3.09,4.05,3.09,4.05l-.19.96s-.39.58,1.73,1.54c2.12.96,2.89.96,2.89,1.73s.58,3.08.58,3.08c0,0-.39,2.12-1.35,2.31-.96.19-1.73.19-3.08.19s-3.08.39-3.08.39l-.58,1.16.19,1.54s.77.58,0,.77c-.74.18-1.83.73-1.9.75.03,0,.07.11-.22.98-.39,1.16-.58,2.12-.58,2.12,0,0-.77.96-1.35,1.16-.58.19-1.16,1.54-1.16,1.54,0,0,.77.58,1.92.77,1.16.19,1.92.58,1.92.58,0,0,1.54.97,2.7,1.74,1.16.77,1.92.39,2.51,1.35.58.96.77,1.54.77,2.12s-.39,1.35-1.16,1.73l-.77.39-.77,1.92s-1.54,1.54-3.66,1.92c-2.12.39-2.7,0-3.47.77-.77.77-.96,1.16-.96,1.73s.58-.96,0,.58c-.58,1.54-.96,2.89-.96,2.89,0,0-.77.19,1.16.19h1.92s.96-.96.38.77c-.58,1.74-2.12,2.31-2.12,2.31l-1.54.77s-.96.19-.77.97c.19.77,1.54.38,1.54,1.34v.96l-2.12.97v1.34c0,.77-.19.97,0,1.54.19.58-1.16.39.19.58,1.35.19,1.54.19,3.85.19s2.12-.19,3.27-.19,1.54-.96,3.27.39c1.74,1.35,1.74,1.74,2.31,2.89.58,1.16,2.89,5.77,2.89,5.77l2.12,1.93,4.11,3.01,1.03,2.31,2.31.77,7.2,2.57h1.54s1.54,1.28,1.79,2.31c.25,1.03,1.02,2.05,1.02,2.05,0,0,4.62-.76,4.62.52s-1.28-1.29,0,1.28c1.29,2.57,2.32,2.82,1.8,4.37-.52,1.54,0,2.57-1.29,2.83-1.29.25-2.06.25-2.83.51-.77.26-1.03.77-1.54,1.54l-.5.77s-.27,1.29,1.02,1.8c1.29.51,2.57.77,3.34,1.29.77.51,2.06,1.03,2.58,2.05.5,1.03.25,2.32.5,3.6.27,1.28-.5,3.34.52,3.85,1.03.51,3.34,2.05,4.62,2.56,1.29.52-1.03.77,2.56,1.8,3.6,1.03,5.14,1.54,5.14,1.54,0,0,4.87,4.37,5.65,4.88.77.51,4.11,2.83,6.93,3.08,2.83.26,3.34.26,5.4.26s4.12-.26,4.88.26c.77.51,2.82,2.06,4.87,2.57,2.06.51,2.06.52,4.62.77,2.56.25,5.14,1.02,5.14,1.02l1.79,1.03s.26-2.82,1.29-3.08c1.03-.26,1.54-.51,2.56-1.54,1.03-1.03,2.06-2.82,3.6-2.82s2.05-.77,5.64-2.83c3.6-2.06,5.14-3.85,5.91-4.62.77-.77,2.57-1.79,2.57-1.79,0,0,.77-1.03.25-2.83-.51-1.79-1.28-2.56-1.54-3.59-.25-1.03-.77-.77.77-3.08,1.54-2.31,2.83-1.8,3.85-3.34,1.03-1.54,1.55-1.03,1.8-2.56.26-1.54,0-1.8.26-2.83.25-1.03.77-1.54,1.79-2.82,1.04-1.28,1.54-2.05,1.8-3.08.05-.2.16-.74.3-1.4h-.91s-1.27-.17-1.27-.17Z"
        />
        <g>
          <path
            class="st343"
            d="M457.78,129.81l-1.37,1.86-.62,1.37s-.25.12-.25.61.62.62.49,1.24c-.13.62-.13,1.49-.13,1.49,0,0,1.99.74,1.99,1.12s.37,2.73.37,2.73c0,0-.49.62.87.74,1.37.13,3.11-.37,3.11-.37,0,0,.73-1.99.87-1.62.12.37.74.37.49,1.12-.25.74.13,1.36-.37,1.49-.49.12-1.49.74-1.49.74,0,0-.62,1.61-.62,2.11s-.99-.13,0,.49c.99.62.74.25,1.86.75,1.11.49,1.48.62,1.61.99.13.37.12-.25.25,1.12.13,1.36.25,2.11.25,2.11,0,0,4.46-.99,4.84-.99h2.35c1.24,0,1.62.25,2.11-.13.49-.37,1.24-.87,1.98-1.48.74-.62,2.48-2.36,3.23-2.61.74-.24.49-.61,2.36-1.48,1.86-.87,3.97-1.87,4.34-2.24.37-.37,1.49-.99,2.36-1.24.87-.25,2.61-.49,3.72-.87,1.12-.37,1.61-.25,2.11-.62.5-.37,1.11-.99.87-1.61-.25-.62-1.62-2.97-1.74-3.47-.12-.5-2.85-3.47-2.85-3.47,0,0-.24.74-.49-1-.25-1.73.13-.99-.25-1.73-.37-.75-2.23-1.99-2.23-1.99,0,0-.13-5.45,0-5.95.13-.5.25-6.21.25-6.21,0,0,.86-1.74.99-2.11.13-.37.49-1.36.62-1.73s.5-1.12.5-1.12c0,0,2.48-3.47,2.85-3.47s3.35-2.48,4.1-2.97c.74-.5,2.6-2.11,2.85-2.85.24-.75.37-2.24.49-2.85.12-.63,1.12-4.59,1.61-4.84.49-.25,2.23-1.61,2.23-2.36s-.25-2.72-.49-3.59c-.25-.87-.99-2.85-.99-2.85,0,0-.87.13-1.49,0s-1.12-.37-1.86.25c-.74.62-.5.87-1.74,1.74-1.24.87-.74.5-1.36,2.24-.62,1.73,0,1.85-.87,2.6-.87.75-3.72,3.23-3.72,3.23,0,0-2.73,1.12-3.48,1.74-.74.62-1.86,1.36-2.97,2.1-1.12.75-1.86,1.87-1.86,1.87l-2.73,4.84s-.25,1.61-.62,1.85c-.37.26-.37,1.12-1.36,1.12s-1.86-.37-1.86,0-1.61,2.1-1.61,2.1l-1.24,1.62-1.11,1.86s.37,1.61-.5,2.98c-.87,1.36-3.59,4.09-3.59,4.09,0,0-.26.99-.87,1.99-.62.99-2.98,6.2-2.98,6.2l-.74,1.98s-.74.24-1.48.24-1.86-.49-2.23-.49-1.37-.25-1.37-.25c0,0,.5.74,0,.99s-1.36.87-1.36.87Z"
          />
          <path
            class="st343"
            d="M560.38,64.74c1.79-.26,1.54-2.31,1.54-2.31,0,0,.51-1.03.51-2.82s-.26-3.34-.51-4.88c-.26-1.54-1.54-2.83-1.54-2.83,0,0-1.03-1.02-2.57-2.83-1.54-1.79.51-4.1.51-4.1,0,0,0-2.83.26-4.37.26-1.54,1.03-2.31,1.03-2.31,0,0,.25-1.54.25-2.56s-1.02-3.08-.51-4.37c.51-1.28,1.8-.5,3.08-.5s0-1.81,0-1.81l-2.31-.77-3.08-1.02-2.06-.52-1.29-.77c-1.29-.77-2.82,0-4.62-.5-1.8-.52-.51-2.58-.25-4.37.25-1.79-.26-5.14,0-5.64.25-.52-1.8-1.29-2.06-2.83-.26-1.54.77-1.29,1.8-1.79,1.03-.52,2.31-1.29,2.31-1.29,0,0,0-.03.01-.04-.73-.64-1.3-.21-1.3-.21,0,0,.57-.43,1.3.21.03-.12.26-1.05.5-2.01.25-1.03,2.57-1.79,2.57-1.79,0,0,.77-1.54,0-3.34-.77-1.8,0,0-.26-.77-.26-.77,0-2.31.26-4.12.26-1.79-1.8-.51-1.8-.51l-1.79-1.8s-1.8,0-3.6-1.03c-1.8-1.02-1.28-.77-2.05-.77s-1.54.25-4.37,0c-2.83-.25-.26-1.54-.26-2.83s-.51-1.54-.51-1.54l-3.85-.5-2.83.5s-1.03,1.04-1.54,2.31c-.52,1.29-2.31-.25-3.34-1.54-1.03-1.28-1.54-2.82-.77-4.87.77-2.06-.77-1.79-1.54-3.09-.77-1.29-1.54-.77-2.83-.77s.52-2.31.52-2.31c0,0,.25-1.29.25-3.08s-3.34-.25-3.34-.25c0,0-2.06-.27-3.34-.27s-3.59.27-3.59.27c0,0-1.03,1.02-2.31,2.31-1.29,1.28-2.06-1.29-2.31-2.31-.26-1.03-2.06-.78-2.06-.78l-1.79-.77c-1.8-.77,0,0-1.54-2.57-1.54-2.56-3.85-1.02-3.85-1.02,0,0-1.29-.52-2.31-1.03-1.03-.51-1.54-.51-2.57-1.03-1.03-.51-1.8-1.28-3.59-3.33-1.8-2.06-.52-1.29-.26-4.11.26-2.82.51-2.57.77-3.59.26-1.03.26-2.31.26-3.34s1.03-2.06,2.82-3.34c1.8-1.28,3.08,1.8,3.85,2.31.77.52,1.54,1.54,4.37,1.54s1.8-1.79,2.57-2.82c.77-1.03,1.03-1.03,2.05-1.28,1.03-.26.26-2.83.26-4.37s0-1.28-.51-3.33c-.52-2.06-.77-6.42-.77-7.45s.25-1.03.25-2.06-.51-1.28-.77-2.82c-.26-1.54-1.03-.52-1.03-.52,0,0-2.83,0-5.65.26-2.82.26-3.34,3.08-3.34,3.08h-4.62c-2.06,0-.77-1.03-1.03-1.8-.26-.77-.77-2.56-1.54-3.85-.77-1.28-1.03-.77-1.54-1.54-.52-.77-2.06-1.28-2.83-2.31-.77-1.02-2.05-1.54-2.31-3.08-.26-1.54,1.29-2.05,1.29-5.64,0-2.19-.1-4.09-.17-5.24-.14,0-.26.02-.42.06-1.06.27-1.85.66-1.85.66h-3.43s.4-1.84-1.98-1.84-3.7.4-4.62.53c-.92.13-3.56.52-4.35.65-.79.14-3.43.26-4.36.39-.92.14-5.54-.52-6.07-.52s-1.06,0-3.03.52c-1.98.53-.92,2.64-2.9,2.12-1.98-.53-4.09-2.24-5.15-2.24s-3.96.53-4.22,0c-.26-.53.79-2.51-1.58-1.85-2.37.66-5.54,1.84-6.33,2.11-.79.27-3.03,1.59-3.03,1.59l-2.51,1.98s2.24,0-1.05,1.32-5.68,1.58-6.73,1.84c-.42.11-1.19.35-2.11.69l1.44,1.33s1.03.52,2.06,1.54c1.02,1.03,1.79,4.37,1.79,4.37v2.31s0,1.79-.25,2.56c-.26.77-.26,3.08-.26,3.08,0,0,1.54,1.03,2.82,2.57,1.28,1.54,0,0,.52,1.03.51,1.03,0,1.54,0,3.34s.77,4.88.77,4.88c0,0,1.28.51,2.05,1.03s1.54,1.02,2.31,2.82c.77,1.8,0,2.57,0,2.57,0,0,0,2.56.26,4.11.25,1.54,1.02.77,2.56,2.31,1.54,1.54,2.31,2.31,1.8,4.37-.51,2.06,0,2.31,0,3.85s.51,4.62.51,4.62c0,0-.51,1.54-1.79,3.08-1.29,1.54-1.8.77-2.83,1.28-1.03.51-2.06,2.31-3.59,4.11-1.54,1.8-3.59.77-3.59.77l-3.93-1.92c-.05.21-.07.37-.18.64-.77,1.81-1.28,1.81-1.28,3.35s.51,4.11.51,4.11c0,0,2.06.52,2.31,1.29.26.77.26,2.82,0,3.85-.26,1.02.26,2.56-.77,2.56s-3.08-1.03-3.85.52c-.77,1.54-.78,2.56-1.03,3.34-.26.77-1.29,3.85-1.54,4.62-.25.77-1.54,1.29-3.08,2.83s-1.54,2.31-1.79,3.59c-.26,1.29-2.06,2.32-2.83,2.58-.77.25-1.79.25-2.56,2.31-.77,2.05-2.57,2.05-1.54,3.59,1.03,1.54.51.26,1.03,1.54.52,1.29,1.03,3.09.26,4.12-.77,1.03-1.8.77-2.31,3.09-.51,2.31,1.28,3.85,2.06,4.11.77.25,3.08,1.8,1.8,3.6-1.28,1.79-2.57,4.11-2.57,4.11l-.77,4.87s.52,4.12,1.29,4.12,3.34,1.03,3.34,1.03l2.57,4.37s-1.28.51.26,1.79c1.54,1.29,2.56,1.29,1.54,3.08-1.03,1.79-1.03,1.54-1.03,2.83,0,.52.17,1.24.37,1.92h.6c.96,0,.77.58,2.31-.19,1.54-.77,2.69-1.15,2.69-1.15l1.16.38s.58.39,1.35.39h4.62c.96,0,1.54.19,1.73-.58.19-.77,0-1.34.19-1.92.19-.58.96-1.35,1.74-1.73.77-.39,4.04-.58,4.04-.58,0,0,1.35-.19,3.27-.58,1.92-.39,6.74-.58,6.74-.58l5.01,1.35s4.81-.96,5.59-1.16c.77-.19,3.46-.58,3.46-.58l4.05.38,3.47.77s3.47.58,5.01.97c1.54.38,4.05,1.34,4.82,2.12.77.77,2.69,1.54,3.08,2.12.39.58,1.35,1.16,1.35,1.73s-.39.39.39,1.35c.77.96.96,1.73,2.69,2.51,1.74.77,1.35.77,2.89,1.35,1.54.58,2.12.96,2.69.96s.58-.77,1.35,0c.77.77.58.58,1.92,1.54,1.35.96.77,1.35,2.31,2.12,1.54.77,1.54.97,3.08,1.35,1.54.39-.19-.19,4.05.77,4.24.96,6.16,1.15,6.93,1.73.77.58,1.54,1.92,2.7,2.31,1.16.39,2.5.58,3.66.58s3.08-.38,5.2-.96c2.12-.58,3.47-1.92,3.47-1.92,0,0,1.35-1.35,2.31-1.54.96-.19.58-.38,2.12-.38h1.54s.38-1.54,1.16-2.51l.77-.96,5.2-2.89s1.93-.96,3.08-1.16c1.16-.19,4.05-.77,5.4-.96,1.34-.19,4.81-.19,4.81-.19,0,0,1.16-.19,1.74,0,.58.19,4.62,2.89,4.62,2.89l3.85.39s.07-1.99,1.09-3.27c1.03-1.29,1.03-.52,2.83-.77Z"
          />
        </g>
        <g>
          <path
            class="st342"
            d="M-121.13,476.86c.43.44.43,1.29,1.01,2.16.57.85.86,1.29,1.29,2.01.43.72,1.15.86,1.86,1.87.73,1,2.01.71,3.02.71s3.16,0,4.74-.15c1.58-.15,1.14-1.29,1.58-1.58.43-.29-.58-1,.43-1.43,1-.43.86,0,1.58,0h2.44c1.01,0,2.16.15,3.02.15s1.01-1.44,2.01-2.16c1-.72,1.14-.57,1.14-.57h2.44c1.01,0,1.01-.15,1.29-.86.29-.73.29-1.01.58-1.43.29-.44.86-1.44.86-1.44l.14-1.58s.58,0,1.16.15c.57.15,1,.43,1,.43l.73,1.72s0,1.01.43,1.87c.43.86,1.73.72,2.29.86.58.15,1.59.57,2.01.86.44.29.29,1.3.29,1.3l.87,1.15s2.43,1.58,2.86,1.87c.44.29,1.01,1,1.01,1l.86,1.58,1.3.43,1.55.78c.37-.21.75-.43.96-.52.48-.25,1.34-.37,1.34-.37h1.21s.61.37,1.1.37h6.45c.37,0,1.94.12,1.94.12,0,0,.36.97.86.73.48-.25.24-.6.73-.97.49-.37.85-.61,1.22-.61s.97-.12,1.46.12c.48.25,1.7,1.34,2.19.86.49-.49.61-.73.98-1.22.36-.49,1.21-1.94,2.43-2.67,1.22-.74,2.8-.74,2.8-.74,0,0,2.55,1.58,2.91,1.7.38.13,1.59.13,2.44.13s1.94-.25,2.8-.61c.85-.36,1.1-.36,1.1-.98s1.21-2.43,1.58-2.55c.37-.12.98-.61.98-.61,0,0,.6-2.92,1.09-3.4.48-.49,3.04-.37,3.04-.37,0,0,1.82.97,2.18,1.34.37.37,2.68,1.59,2.68,1.59h2.56l2.19-.37s1.09-.24,1.09-.73c0,0,.34-.44.21-.87-.14-.43-.57.13-.57-1v-3.24c0-.86.15-1.7-.99-1.84-1.13-.14-2.26.28-2.26-.99s0-2.12-.43-2.82c-.43-.71-.15-1.28-.57-1.56-.43-.28-.14-.56-.99-.85-.85-.28-1.27-.15-1.83-.71-.57-.57-.99-.57-.57-1.69.42-1.13.71-1.42.71-1.98s-.15-1.83.28-1.97c.42-.15,1.28-.15,1.28-.15,0,0,1.69.71,2.12.15.42-.57,1.97-1.97,2.39-3.53.43-1.56.85-1.42.99-2.83.15-1.41.85-1.28,0-2.83-.84-1.55-.99-1.55-1.55-1.97-.57-.43-1.41,0-1.69-.99-.29-.99-.14-1.13-.29-1.97-.15-.86-.57-1.84-.57-1.84,0,0-.29-.42-.42-1.55-.15-1.13.42-1.84-.29-2.12-.7-.28-1.12.29-1.98-.28-.84-.57-.99.14-1.41-.86-.43-.99-.99-2.12-.99-2.12l-.43-1.41s-.57.28-.85-.57c-.29-.85-.28-1.7-.42-2.12s-.57-1.84-.57-1.84l-.29-1.98s-1.27-4.52-.85-5.65c.42-1.13.57-.71.99-1.55.43-.85.43-1.84.43-1.84,0,0-.14-.56,0-1.26.14-.71-.42-1.14.14-1.56.57-.43.71-.29,1.13-.56.42-.29.85-.57,1.13-1.28.28-.71.28-2.68.28-2.68,0,0,.71-.99,2.26-.99s1.84-.15,2.54.28c.71.43,2.68,1.56,3.39.71.71-.84.99-1.83.99-1.83,0,0,.84.28,1.41-.57.57-.86.15-2.97.15-2.97,0,0-.71-1.7-.57-2.4.15-.71-.57-1.83.42-2.68,1-.85,1.14-1.55,1.56-1.97.42-.43,1.13-1.84,1.55-2.41.43-.57.42-1.55,1.13-.99.71.57.85.99,1.42.99s1.27,1.13,1.56-.14c.28-1.27.57-4.24.57-4.24,0,0,.13-1.98.84-2.82.71-.85,1.7-1.13,2.12-1.7.42-.57-.71-.29,1.28-.71,1.97-.42,2.39,0,3.11-.99.71-.99.71-1.84.99-2.68.28-.85-.43.15.28-.85.71-.99.71-.14.71-.99s-.42-1.84-.42-2.26-.28-2.12.57-3.25c.84-1.13,2.39-2.83,3.25-3.67.85-.84.14-.84,1.98-.84s2.82.28,3.53,0l.71-.29,1.32-.53c-.21-.28-1.36-1.81-1.75-2.58-.43-.85-2.26-1.7-2.68-1.84-.42-.14-1.41-.57-1.84-1.27-.42-.71-.28-1.28-.99-1.84-.71-.57-.99-.28-1.41-.99-.42-.71-.14-.85-.42-1.41-.29-.57-.14-2.96-.29-3.67-.15-.71-.57-3.67-.57-3.67,0,0-.85-.28-.71-1.41.15-1.13.57-2.26.57-2.26,0,0,1.13-.44,1.28-1.28.14-.84,1.55-.28.14-.84-1.42-.57-1.98-.58-1.98-1.28s-.7-2.54-1.55-3.67c-.84-1.13-1.41-1.41-1.41-1.84s-.42-3.25-.85-4.24c-.43-.99-.99-2.26-1.27-2.68-.29-.42-.42-.29-.85-.99-.43-.71-.14-1-1.13-1.13-.99-.14-2.11-.14-2.11-.14,0,0-.43-.57-.57-1.55-.15-.99-.29-2.12-.71-2.68-.42-.57-.57-.99-.84-1.42-.29-.43-.43-.7-.29-1.27.15-.57.86.43.29-1.41-.57-1.84-3.96-5.66-3.96-5.66,0,0-.85.43-1.84-.56-.99-1,.14-1.84-1.41-2.26-1.56-.43-3.68-.99-4.24-1.13-.57-.15-2.54-.57-2.96-.57s-.43-.29-1.84,0c-1.41.28-2.39.71-3.1,1.27-.71.57.15.28-.71.57-.85.28-1.41.56-1.98.42-.57-.14-1.27-.29-1.27-.29,0,0,.28,0-.14.99-.43,1-.86,2.12-1.13,3.11-.28.99-.28,1.55-.28,2.26s.42,1.13.99,1.7c.57.57,0-.29.57.57.56.84,1.27,1.97,1.69,2.39.43.43.29.57.85.99.57.42,1.41.14,1.41,1.42s-.28,2.82-.28,2.82c0,0-.57.14-.57.7v4.52s-1.28,1.41-1.7,1.83c-.42.43-1.13,1.84-2.12,1.84s-1.98-.28-2.4-.85c-.43-.57-1.41-2.26-1.41-2.26,0,0,.57-1.42-.43-1.55-.99-.14-1.84,0-2.68-.14-.84-.15-1.83-.15-2.68-.57-.84-.43-2.12-1.84-2.12-1.84,0,0,0-1.12-.42-1.55-.42-.42-.99-1.28-2.54-1.83-1.55-.56-4.67-1.27-4.67-1.27l-.14-.99s-.3-.11-.76-.29c-.62.19-1.08.16-1.08.16,0,0,.46.03,1.08-.16-.33-.15-.74-.32-1.22-.56-1.13-.57-2.4-1.98-3.39-1.98s-3.25-.42-3.25-.42c0,0-1.41-.99-2.68-1.7-1.26-.71-2.25-1.97-2.25-1.97,0,0-.15-.71-.85-.85-.71-.14-2.54-.14-3.1-.14s-1.55.43-1.97,0c-.43-.42-.86-1.27-.86-1.27l-.84-1.41s-1.13-.57-1.55.42c-.43.99-.57,2.69-.57,2.69,0,0,.14,1.27-.14,1.83-.28.57-.99,2.12-1.13,2.68-.14.57-.56,1.98-.56,1.98l-1.84-.29h-1.41c-.43,0-.71-.14-1.42.15-.7.28-.7.42-1.55.15-.84-.29-1.13-.71-2.12-.71s-1.13-.29-1.83,0c-.71.28-1.42.42-1.69.99-.29.57,0-.42-.29.57-.28.99,0,1.28-.28,1.84-.29.56.71-.15-.29.56-.99.7-1.12.85-1.83.99-.71.14-.71.15-.99.71-.29.56.28,1.27-.57,1.55-.85.28-2.26.43-2.26.43,0,0-1.13.99-1.7,1.26-.56.29-1.41.71-1.83.71,0,0-.42.39-.21,1.07.19.69.88,1.17,1.26,1.85.4.69.69.59.78,1.18.1.58.69.98.69,1.66s.78.59.3,1.27c-.49.68,0,.58-.49.68-.49.1-.49.1-1.66.1s-2.54-.1-3.03.1c-.49.2-.19.3-1.07.3h-2.25c-1.96,0-2.24-.1-3.32-.1-.72,0-.88-.09-1.55-.15h-.01s-2.35.11-1.62.65c.73.53,2.07.8,2.07.8,0,0,.18.18.54.27.36.09-.45-.18.9.18,1.35.36,1.18,2.07,1.35,2.89.18.81.09,4.33.09,4.33l.63,2.35s-.09.54-.09.9-.18,1-.18,1c0,0,.27.63.63.99.36.36-.63.36.36.36s1.45-.09,1.72-.09,1.08.36,1.08.36c0,0-1.81.9-.54,1.17,1.26.28,2.35.28,2.35.28,0,0,.18.09,1.35,1.17,1.18,1.08,1.35,1.62,2.17,1.8.81.18-.27,2.44,1.72.18,1.98-2.25,2.43-2.71,2.43-2.71,0,0,.64-.9.54-.26-.09.62-.36.99-.73,1.53-.36.54-.08.64-.72,1.54-.63.9-.99,1.45-.99,1.45l-.36,2.43s-1.9.72.09,1.08c1.98.36,2.17.45,2.71.54.54.09,1.18.36,1.8.45.64.09.64,2.34,1.18.27.54-2.07.62-2.52.62-2.52,0,0,.54-.36.54.54s.36,2.52.36,2.52c0,0,.72.73,1.35,1.35.63.63.72.9.81,1.63.09.73,0,1.9.45,2.35.45.45.63.09,1,.9.36.82,1.99,1,1.9,1.36-.09.36-2.08,1.8-2.17,2.35-.09.54-.45,1.53-.18,2.25.27.73.36,1.62.36,1.62,0,0,.36,1.08.36,1.91v2.7s-1,.27.09.9c1.09.63,1.72.54,1.45.81-.27.27-.72.45-.72.45,0,0-.54-.09-1,.09-.45.18-2.88,1-2.88,1l-1.9.9s-1.71,1.63-1.99,2.98c-.26,1.35.27,3.65-.62,2.35-.1-.14-4.13.24-4.7.71-.56.47-2.53,1.21-2.53,1.21l-1.88,1.31-2.91,1.78s-.56.57-1.13,1.04c-.57.47.47.57-.94.84-1.41.28-1.41.66-1.88,1.04-.47.37-1.78.28-1.78.28,0,0-.84.94-1.31,1.6-.47.66.1.09-.74,1.4-.85,1.32-2.45,1.33-.85,1.79l1.6.46.66.38s.65.94.47,1.6c-.19.66.38.57-.29,1.68-.65,1.13.94,1.13,1.32,1.13s1.04,0,1.88.18c.84.19,1.31.94,1.68.38.38-.56.38-1.22.38-1.22,0,0-.19-1.78.18-1.03.37.75.57,1.12.57,1.12,0,0,.75.85,1.59.75.85-.09,1.13.28,1.13-.56v-2.63c0-.56.28-.84.09-1.12-.19-.29.93-1.78-.47-1.04-1.4.75-1.78.94-1.78.94,0,0-1.78-.1-1.69-.57.1-.46,0,.19.1-.46.1-.66.94-.09-.1-1.03-1.03-.94-2.25-.47-1.03-1.78,1.22-1.32,1.13-1.5,1.79-1.5s-.47-.66,1.03,0c1.5.65.85.18,1.5.65.66.47.37-.56.66.47.28,1.03,1.32.94,1.32,1.69s-.1,1.21-.1,1.21c0,0-.66.66-.1.94.57.28,1.78-.85,1.98-1.51.18-.65.37-1.02.47-1.31.09-.28.28-.28.18-1.03-.09-.75-.57-.75-.28-1.12.28-.38-1.32-.47.94-.57,2.25-.09,2.44.09,2.53-.18.09-.29,1.32-.66,1.97-.85.65-.19.65-.09,2.06-.09h2.35c.66,0,.38.1,1.13-.1.74-.19,1.68,0,2.62-.75.94-.75-.19-.66,1.41-.93,1.59-.29,2.06-.19,2.81-.29.75-.09,1.22-1.12,1.6-.56s.37,1.03.37,1.03c0,0-.19,1.13,0,1.78l.19.66s-1.7-1.5-1.98-1.31c-.28.18-.56.19-1.59.37-1.03.19-1.69,1.22-1.69,1.22l2.54,1.78s.84.47.84.85,0,.56-.37.56-.29-.28-.94-.1c-.66.19-.57.37-1.22.57-.65.19-.28-.57-1.69.57-1.41,1.12-.1-.47-1.41,1.12-1.31,1.6.29,2.07.29,2.07,0,0,1.59-.1.37.28-1.22.37-1.6.19-2.35.37l-.74.19s2.15,1.22,1.5,1.31c-.66.1-2.53.57-2.53.57,0,0,.28,1.69-.85,1.78-1.12.09-1.31-.38-2.25.09-.94.47-1.41.38-1.69,1.22-.29.84-.47,1.5.56,1.78l1.03.28,1.68,1.41,2.45.84s-.1.19-.1.94.66,1.03-.37.94c-1.04-.1-1.6-.66-2.63-.66s-1.69.28-1.69.28c0,0-.56,2.72-.09,2.82.47.09-.1.09,1.12.18,1.22.1-1.4,1.5,1.6,0l3-1.5s.94.09.66.38c-.29.28-.75.56-.75.56,0,0-1.5.46-2.06,1.22-.57.74-1.12-.38-.47,1.78l.66,2.15-.94,3.1s-1.78,1.22-2.44,1.88l-2.07,2.07-4.79,4.78s-.84,1.03-.74,1.41c.09.37,1.31.74,1.59.74s1.04-.28.47.47c-.56.74-.28.94-1.12,1.41-.85.47-1.5.75-1.69,1.03-.19.29,0,1.13,0,1.13,0,0,.94,1.31-.19,1.5-1.13.18-1.5-.28-1.6.37-.09.66-.09,3.29-.09,3.29,0,0,.46.28.85.28s.57-.19.94,0c.37.19,1.87.38.74.84-1.13.47-1.5.57-1.5.57,0,0-.09-.18-1.4.66-1.31.84-.84-.29-1.31.84-.47,1.13-1.22,2.63-1.22,2.63,0,0-1.5-.29-1.68.28-.19.57,0,.28-.19,1.6-.18,1.32-.47,2.16-.47,2.16,0,0-1.59,1.5-1.96,1.68-.38.19-1.22.38-1.6.38s-.1-1.87-.84,0c-.75,1.88-1.22,2.81-1.22,2.81l-1.41,1.88s-.57,1.13-.57,1.41v1.5s-.1-.66-.84.18c-.75.84-.94,2.07-.94,2.07h0s.82.19.82.19c0,0,.86.29,1.29.72Z"
          />
          <g>
            <path
              class="st342"
              d="M-115.69,439.12s-.68.34-.82.91c-.14.58-.48,1.06-.14,1.25.34.19.58.29.87.29s.53.15.53.15v.53s-.48.39-.38.87c.09.48.43.58.82.19.38-.38.48-.43.67-.72s.1-.77.1-.77c0,0-.62-.29-.67-.87-.05-.58-.58-2.02-.96-1.83Z"
            />
            <path
              class="st342"
              d="M-140.63,455.44s-.29.82-.82.87c-.53.05-.96.15-1.06.72-.1.58-.05,1.2-.1,1.59-.05.38.1.62-.1,1.11-.19.48-.48,1.25-.48,1.25,0,0-.53,1.59.39,1.16.91-.43,1.49-1.11,1.49-1.11,0,0-.19-.19.29.1.48.29.53,1.2.96.39.44-.82.15-1.06.58-1.2.43-.15.58.1.91-.39.34-.48.67-1.06.91-1.39l.24-.34s.19-.19.53-.19.67.91.77,0,.1-1.68,0-2.07-1.01-1.16-1.01-1.16l-1.92-.1s-1.35-.05-1.59.77Z"
            />
            <path
              class="st342"
              d="M-123.25,447.26s1.49-.87,1.49-.24-.39,1.45-.39,1.45c0,0-.43,0-.72.58-.29.58-1.01,2.41-1.45,2.84-.43.43-.24,1.01-1.2.91-.96-.1-.91-.15-1.16.15-.24.29-1.44.62-1.78.67-.34.05-3.23.19-2.17-.39,1.06-.58,1.4-.96,1.4-.96,0,0,.05-.15,1.16-.43,1.11-.29,1.34-1.69,1.34-1.69,0,0-.53-.15-.38-.62.15-.48.19-1.01.53-1.2.34-.19.53-.48.53-.48,0,0,.15-.67.43-.82.29-.15.77-.48,1.11-.48s1.06.82,1.25.73Z"
            />
          </g>
        </g>
        <g>
          <path
            class="st353"
            d="M187.62,352.11c.96-.38,1.35-1.16,1.35-1.16l.39-.77c.38-.77,0-1.35-.39-1.92-.39-.58.39-3.85.39-4.62s-.19-.96-.19-1.54-.19-.77-.19-1.73v-2.51c0-.96-.19-.96-.58-1.73-.39-.77-.77-.77-1.93-1.35-1.16-.58-.19-.96,0-1.74.19-.77.39-.96.58-1.54.19-.58.96-3.66.58-4.82-.38-1.16-.77-.58-2.12-1.92-.46-.46-.6-.6-.64-.64,0,0-.01-.02-.01-.02-.02-.02-.12-.12-.5-.5-1.16-1.16-1.35-2.31-1.35-2.31,0,0-.38-.77-.96-1.35-.58-.58,0-.77-.38-1.73-.39-.97-.58-1.16-.97-1.74-.38-.58-.19-1.54.58-2.5.77-.96,1.54.39,1.54.39,0,0,1.34,1.35,4.04,3.08,2.7,1.74,1.16,1.35,3.27,3.09,2.12,1.73.96-.39,1.92-1.54.96-1.16.77-1.16,1.74-1.92.96-.77,1.54-1.54,1.54-1.54,0,0,.58-1.35,1.54-2.51.96-1.16,0-1.16.39-2.12.38-.96.77-.96.77-.96h2.7c.77,0,1.15-1.35,1.15-1.35v-1.35c0-1.34,0-3.08.19-4.43.19-1.34,0-.77.77-1.92.77-1.16,0,0,1.54-1.35,1.54-1.34,1.16-.77,2.7-1.73,1.54-.96,3.27-.96,4.04-1.35.77-.38,2.89-1.92,2.89-1.92,0,0,2.31-1.92,4.43-2.89,2.12-.96,0,0,.38-.58.39-.58.19-1.16.19-2.31s-.19-.96-.96-2.51c-.77-1.54,0,0-1.54-1.34-1.54-1.35-.77-.19-2.69-1.35-1.93-1.16-1.74-1.93-1.74-3.08v-1.74s-1.34-.39-3.27-.39-.19-.77-.19-1.54v-3.27c0-.77-1.34-3.08-1.34-3.08,0,0-1.16-.77-.96-1.93.19-1.16.77-1.35,3.08-2.31,2.31-.96,0,0,1.54-.38,1.54-.39.96,0,1.54,0s.77.58,2.12.96c1.35.38,1.54,0,3.47,0s1.54.19,3.27.19h1.92c.96,0,.96.19,2.12.58,1.16.39,1.35,0,2.7-.77,1.35-.77,0,0,1.54-.19,1.54-.19,1.16-.19,2.5-.58,1.35-.38,1.54-1.54,2.31-2.5.77-.96.96-1.54,1.54-2.89.58-1.34,2.12-3.27,2.12-3.27l.58-.19c.58-.19,1.16-1.16,1.16-1.16l.19-2.5s-1.16-1.93-1.35-2.89c-.19-.96.19-2.12.58-2.89.39-.77.77-1.54.77-1.54,0,0,2.31-1.34,2.12-2.5-.19-1.16-.38-1.54-.38-1.54,0,0,0-1.54.58-3.85.58-2.31,1.35-1.34,1.35-1.34,0,0,2.89-.19,4.24-1.74,1.35-1.54,0-3.66.19-4.24.19-.58,1.35-.77,1.73-1.35.39-.58.58-2.31.58-2.31,0,0,.96-.77,2.31-2.12,1.35-1.35-.19-4.24.58-4.62.77-.38.77-.58,1.35-1.16.58-.58,1.54-1.92,2.7-3.08,1.16-1.16,3.66-.77,3.66-.77l.19.96c.19.96,1.16.58,3.27,0,2.12-.58.96-.96,1.35-1.74.39-.77.39-1.34.58-2.12.19-.77.38-3.08,1.34-4.24.96-1.16,3.85.96,5.59,1.54,1.74.58,1.74.77,4.43.19,2.7-.58,0,0,1.35-1.16,1.35-1.16,1.54-.39,3.08-.19,1.54.19,1.93.96,2.7.96s.77-.96,2.12-1.92c1.35-.96,0,0,1.73-.39,1.74-.39.77.19,1.74.39.96.19,5.97,1.16,7.32,1.16s1.93-1.54,3.27-2.31c1.35-.77,1.35-1.54,1.93-2.31.58-.77.77-1.54,1.92-3.47,1.16-1.92,2.7.19,4.24,1.35,1.54,1.16,1.35.58,1.35.58,0,0,.77-.96,3.08-2.12,2.31-1.16,2.89,1.74,2.89,1.74,0,0,.19-1.16,1.16-2.12.96-.96,1.92-.96,1.92-.96l2.22.26c.15-.06.46-.18,1.19-.47,1.33-.54,0-1.34,0-1.34l.54-.8c.53-.8,1.06-1.87,1.06-1.87l-.8-.81c-.8-.79.53-2.66.53-2.66l.81-.54c.79-.53,0-1.06,0-2.39s-1.07-2.14-1.07-2.14l-.53-1.07c-.54-1.07-.54-1.6-.27-2.4.27-.8.27-1.6.27-1.6l.2-2.94h-.47l-1.61-1.33-1.06-.8s-2.67-.53-3.47-.53-2.4,0-4-.27c-.45-.08-.87-.39-1.23-.77-.62.49-1.11.92-1.11.92,0,0-2.22,3.34-2.67,3.56-.44.22-1.9,3.24-3.01,3.79-1.11.56-.56.23-1.45.89-.89.68-1.44,1.57-1.44,1.57,0,0-1.01.22-2.79.44-1.78.22-1.45-.34-2.34-.78s-2.67-.78-3.45-1c-.78-.23-2.34,0-3.78,0s-3.12-1.01-3.12-1.01c0,0-2.11.11-2.79.33-.66.23-3.12.68-3.12.68,0,0-1.56-.89-4.01-1.57-2.45-.66-.89,0-1.22.23-.34.22-.67.56-1,1.11-.34.56-1.57.34-3.79.68-2.23.33-2.56.22-3.67.33-1.12.12-.78.44-1.34.89-.56.44-.56.78-1.23,1.67-.67.9-.56,1.01-.56,1.01,0,0-1.01.33-4.57.66-3.56.34-1.11,1.23-1.45,1.78-.33.56-1.33.11-3.9.23-2.56.11-.56,1-.78,1.67-.22.67-.45.56-1.89,1.22-1.46.67-.78,0-1.45-.44-.67-.45-.33-.56-.56-.89-.22-.33-1.34-1.55-1.34-1.55,0,0-1.34-.56-2-.68-.67-.11-1.56-.77-2.11-1.33-.56-.55-1.67-2.22-1.78-2.78-.12-.56,0-1.34.21-1.67.23-.34-2.89-3.12-3.11-3.45-.22-.34-1.55-2.34-1.55-2.78s-.56-2.23-.56-2.23c0,0-1.33-3.01-1.78-3.9-.45-.89-.22-.56-1.45-1.78-1.22-1.23-1-.67-1.67-1.56-.66-.89-.11-.67-.21-1.23-.12-.56.33-2-2.46-3.56-2.78-1.55-1-.66-2.67-1.67-1.67-1,0,0-.89-1.22-.89-1.22-.34-1.11-.55-2.22-.23-1.11-.12-.56-1.01-.78-.89-.23-.45.56-.56.89-.11.33-.66.89-1,1.11-.33.23-1.23.89-2.01.89h-1.22c-.75,0-.86-.08-.84-.15-.16.18-.81,1.01-.61,1.71.23.78,1.01.11,1.67.22.67.12.67,0,1.56.12q.89.11,1.45.22c.56.11.22,1.56,0,2.22-.23.68-1,1.01-1,1.01l-.12,2.23-1.22,1.45s-2,.45-2.56.45-1.34.78-2.35,1.33c-1,.56-1.78.89-3.34,1.33-1.56.45-1.56,1.23-2.56,1.78-1.01.55-5.24,4.68-5.24,4.68h-1s-.89.11-1.34.44c-.45.33-.56,1-.56,1l.89.78s-1.22,6.57-1.34,6.91c-.11.33-1.11,3.56-1.44,4.57-.34,1.01-.11.67-.44,1.67-.34,1,0,0-.56.55-.56.56-.34,0-2.01.68-1.67.66-.55.11-2.56-.23-2-.33,0,0-1,0s-.11.56-.11.89-.45.67-.89,1.22c-.45.56-.33,1.23-.22,1.9.11.67,0,0,.45,1.34.44,1.34-.11,1.45-.34,2.22-.22.78,0,0-.44.22-.45.22,0,1.56,0,1.56l-.78,1.9-.22,1.67s.34.77.34,1.33-.12.66-.12.66c0,0-.22.45-.67.89-.45.45,0,1.45.34,1.9.33.44.55.44,1.55,1.45,1.01,1,.34,1.23.45,2.12.12.89-.33,1.45-.77,2.34-.44.89-.67,1.01-1.01,1.67s-1.22,2.01-1.78,2.9c-.55.89-.66,1.11-1.22,2-.56.89-.56,1.67-1.01,2.12s-2.56,2.23-4.23,3.46c-1.67,1.23-12.25,7.79-12.25,7.79l-5.35,1.9-1.89,1.89s-3.46,3.24-4.01,3.56c-.56.34-3.34,3.56-3.34,3.56,0,0-.22.67-.44,1.33-.22.68-.9,1.45-1.34,2.23-.44.78-.89,1.45-1.33,1.78-.45.34-.89.12-1.22.34-.33.22-1.66.67-2.11.89-.45.23-1.79.78-2.23,1.33-.44.56-2.34,2.01-2.34,2.01l-3.01.55s-.55,1.34-.89,1.45c-.33.12-4.01,2.01-4.56,2.23-.56.22-1.34,1.01-2.12,1.33-.78.33-.67.78-1,1.01-.34.22,0,1.89-.12,2.34-.11.45-1,0-1,0,0,0-1.56-1-1.89-1s-.56.22-.56.22l-1.33.45-.12,2.34-.66.11-.89-.67s-1.34-.56-2.01-.56l-.89,1.01s-.78-.22-1.11-.44c-.33-.22-1.22.12-1.22.12l.11,2.33-1.45-1-.89-.23s-.78.33-.78.67.33.66.33.66l.67.23c.68.22.89,1,.89,1.33s-.22.45-.78.89c-.56.44-.78.67-.78.67l-.44-.45-1.01-.44c-1-.45-1,0-1,0v1.33c0,.33-.44.12-1,0-.56-.12,0,0,.11-.78.11-.78,0-.56-.11-1.12-.11-.56-.78-.22-1.34-.22s-.56,1.11-1.57,1.56c-1.01.45-.89.78-1.56,1.33-.67.56-1.11.68-1.11.68,0,0-4.69,4.34-5.58,4.68-.89.33-1.34,1.01-1.89,1.22-.55.23-.78,1-1.22,1.45-.45.45-.22.89-.22.89,0,0,.45,0,1.11-.12.67-.11.56-.45,1.01-.66.44-.23.56-.89.89-1.33.33-.45.11-.68.44-1.01.33-.33.77-.78.77-.78,0,0,2.9-.78,3.9-1.33,1.01-.56.12-.45.56-1.12.45-.67,2.23-.22,2.23-.22,0,0,1.11.11,1.67.11s0,.56-.12,1.23c-.11.67,0,1.22,0,1.22l-1.44.11s-.23.66.22,1.11c.45.45,0,0,1.67,0s.67-.11,1.22-.33c.56-.22.89-.67,1.56-.89.67-.22,1.11-1.34,1.34-1.67.22-.34,0-.67.22-1.11.22-.45.78-.89,1.23-1.23.45-.33,2.34-2.23,2.67-2.78.33-.56.55-.22,1.23-.22s1.55-.33,2.67-.9c1.12-.55.34-.44.89-.66.56-.23,1.78-.23,2.67-.33.89-.11.55-.89,1.56-1.67,1.01-.78.9-1.11,1.79-1.45.89-.34,1-.34,1.67-.45.67-.11.67-.34,1.45-1.9.77-1.56.77-1.01,1.44-1.56.68-.55.68,0,1.67.34,1,.33,0,0,.56.33.56.33.34.77.34.77,0,0,.45-.22.89-.66.45-.45.33-.78.78-1.12.45-.33.45,0,1.55,0s.45-.44.67-.89c.22-.44.34-.66.67-.66s.45,0,1.45.33c1,.33.89.89,1.33,1.34.45.44.56,1.01,1,1.45.44.45.44-.23.56-.67.11-.45.11-1.33.67-1.55.56-.23,1.11.33,1.11.33,0,0,1.01.89,1.22,1.22.23.34-.66.23-1,.34-.33.11-.22.55-.22.55,0,0,1.9-.11,3,0,1.12.12,0,.56,0,1.34s-.22.44-.45.77c-.22.34-.33.45-.33.45,0,0,1.01,0,1.45.12.44.12-.78,1.22-1.12,1.67-.33.45-1.11.78-1.67.89-.56.12-.44.23-.89.44-.44.23-.67.56-1.11,1.01-.44.44.78,1.23.78,1.23v2c0,.34.32.45-.57,1.11-.89.67-.56.12-.89.78-.33.67,0,0,0,.45s1,1.9,1.45,2.35c.45.45.45-.11,1-.33.56-.22.22-.56.78-1,.56-.45.78-.34,1.22-.34s0,.89,0,1.34,0,.45-.45,1.34c-.44.89-.78.89-.78.89l1.67.44s-.67.22-1.01.56c-.33.34-.77.89-.77.89,0,0-.45.12-1.23.22-.78.11-1.01.22-1.45.56-.44.34-.33,1.01-.44,1.33-.11.34-1.11,1.34-1.11,1.34,0,0,1.66,1.23,2,1.45.33.22,1.9.56,1.9.89s.45.78.45.78c0,0,.56.56,1.45.89.89.33.67,0,1.23-.33.55-.34,1-1.23,1.34-2.01.33-.78.44-.33.44-.33,0,0,.66.44,1.11.78.45.33.56.56,1.22.67.67.11.44,0,.78-.12.34-.11.89-.67,1.45-1.01.56-.33.56-.44,1-.67.45-.22,1.45-.11,2.01.22.57.34,0,0,1.12.67,1.11.67,0,0,.78-.33.77-.34.77-.23,1.78-.23s.56,1.34.56,1.34c0,0-.23.67-.89,1.01-.68.33-1.01-.11-1.57-.11s-1.22,1.11-1.22,1.11c0,0-2.23,2.23-2.57,2.67-.33.45-.44.78-.67,1.23-.22.44-.11.56-.11,1.34s.22,1.33.89,1c.66-.33,0-.77.22-1.45.23-.67.34-.67,1.01-.78.67-.12,0,0,.56.11.56.12.56.22.56.22,0,0,2.34,1.67,2.79,2.01.45.33.45,1.11.45,1.11l-.56.22s-.78,2.01-.78,2.56.22.56,1.45.89c1.22.33.22-.78.33-1.23.12-.45.12-1.01.33-1.45.23-.44,1.23.56,2.12,1.01.89.44,1.23,1.56,1.12,2-.11.44-1.12.44-1.12.44,0,0-.44,1.23-2,1.23s-.78,0-1.45.11c-.66.12-.33.68-.33.68,0,0-.44,1.34-.89,1.78-.44.45-.78,1.23-.78,1.23,0,0,1.55,2.11,1.45,2.67-.11.55-.55.45-1.34.66-.78.23-.78.44-1.45.89-.67.44-.57,0-1.79-.33-1.22-.33,0-.44.22-2.34.23-1.89-.55.34-.55.34l-1.9-.67c-1.9-.67-.44-.33-.89-1.45-.44-1.11-.33-1.11-.33-1.89s-1.46.22-2.01,0c-.56-.23,0,0-1-.67-1.01-.66-.78-.89-.78-.89l-2.56,1.01c-2.56,1.01,0,0-.56,0s-.33.22-.67.44c-.33.22-.33.78-.33,1.12s.56,1.56,1.56,1.9c1.01.33,0,0,1.12-.56,1.11-.56-.11-.78-.11-.78,0,0-1.11-.56-.33-1.34.78-.78,0,0,.78-.45.77-.44,1.33,0,1.33,0,0,0,.89,1.56,1.01,1.9.11.34,1.56.89,1.56.89,0,0,.22.89.67,1,.45.11.78,1,1.89,1.89,1.12.89-.44.11-.77.11s-.78-.11-2.34-.11,0,0-.56.89c-.56.89,0,0-1.01.67-1.01.66.56,1.45.56,1.45l.56.12s.67,1.66,1.45,2.79c.78,1.11.67-.12,1.45-1.01s0,0,.66-.22c.68-.22.68,0,2.46.11,1.78.12,1.11.34,2.01.78.89.44,0,1.33,0,2.23s-.56.11-.89.22c-.33.11-.78,0-2.45-.22-1.67-.22,0,0-.68-.34-.66-.33-.77.67-.77.67l.44.78.45,1.78s.56.66,1.22,1.78c.67,1.11-.22.44-.78.77-.56.33,0,0,.12.89.11.89,0,0,.33-.12.33-.11,0,.57.67,1.12.67.56-.78,2.45-.78,2.45l-.66.33h-2.67c-1.56,0-.34.56-.89.68-.56.11-.67-.44-.67-.44l-.89-.56s-.78-.22-2.56-1.01c-1.78-.77,0,0-.33,0s-.44.78-.78,1.45c-.34.67-.23.67-.23,1.22s-.11,1.34-.11,1.34c0,0-.56.67-.67,1.12q-.11.44-.45.78c-.33.33-.22.56-1.22,1-1.01.44.44.55,1.12.89.67.34.44-.22,1-.67.56-.45.34-.33.57-1.67.22-1.34.22-.56.56-.89.33-.34.11-.78.11-2.01s.44-.55.78-.55,1,.22,1,.22l.45.11c.44.12.23.89.89,1.22.67.34,1.23.12,2.12.12s1.01-.56,1.67-.89c.67-.33,1.56.45,1.56.45l1.08-.24.58,2.5.96,2.69c.96,2.7,0,0,1.73,1.74,1.74,1.73,0,.77,0,.77,0,0,0,.96.39,1.73.39.77,1.35,2.12,1.35,2.12,0,0,.77.39,1.73.58.96.19.77.19,3.27,1.54,2.51,1.35,1.35,1.16,1.35,1.16,0,0-.77.19-1.73.19s-.97-.58-1.35-1.16c-.39-.58,0,0-2.7-.96-2.69-.96-.96,0-1.73,0s0,0-1.16-.19c-1.16-.19,0,0,0-1.73s0,0-.39-.77c-.38-.77,0,0-.77.19-.77.19,0,0-.96.77-.96.77-.77.96-.77.96,0,0,.19.96.97,1.54.77.58.96.58.96.58l1.16.39s-.96,1.16-2.12,2.31c-1.16,1.16,0,0-.97.19-.96.19,0,0-1.34-.58,0,0,.19,1.35.38,2.5.19,1.16,0,0-.19.77-.19.77.39,1.16,1.74,2.89,1.35,1.74.77.19,1.92.19s1.54-.38,1.54-.38l.19-.97c.19-.96,0,0-1.16-.19-1.16-.19.19-.77.58-1.74.39-.96,0,0,.58-1.16.58-1.16,0,0-.77-.77-.77-.77-.19-.96-.19-.96l.58-.96c.58-.97,1.16,0,2.89,0s.77.19,1.35.38c.58.19,1.54,1.16,2.31,1.54.77.39.96.39,1.54.39h.77s.96.77,2.51,1.73c1.31.82.81,1.21.63,1.32.29-.16,2.88-1.53,3.61-1.9.73-.36,2.49-.38,3.98-.21.24-.25.49-.56.64-.94.38-.97.77-.39,1.73-.77Z"
          />
          <path
            class="st353"
            d="M249.47,146.99c0-.88-.26-.75-.88-1.12-.62-.37-1.12-.37-2.11-1.12-.99-.75-.13-.75-.62-1.87-.51-1.12-.75.49-1.12.49s-.5,0-3.49-.12c-2.98-.12-.74.25-1.98,0-1.25-.25,0,0-.37-.88-.38-.87,0-.62,1.12-2.11l-.66-1.79c-.2-.11-.51-.32-1.33-.59-1.62-.49-.87-.99-1.49-2.36-.62-1.36,0-1-.38-1.86-.37-.88,0,0-3.48-.88-3.49-.87-2.74.13-5.11.25-2.37.12-.87,0-1.75.25-.33.1-.51.16-.69.27l.79.83c.31.05.63.28,1.02.28.74,0,.88.13,2,.25,1.12.13.12,1.12.12,1.12l-.74.88s-1,.87-1.12,1.5c-.12.62.74.12,2.74.12s.37.5.62,1c.25.49.38,1.12.75,1.62.38.5,0,1.99-.25,2.49-.25.5-1.25,1-1.74,1.12-.5.12,0,0-1.12,0s-1.13.12-1.75.49c-.62.37-1.49,1.12-1.99,2.12-.5.99-.13,1.87-.13,1.87,0,0,1.37.62,2.86.87,1.49.25.74-.13,2.36-.87,1.62-.75,2.49-1.99,3.36-2.36.87-.37.62.12,3.11.25,2.49.13.74-.13,1.49-.37.74-.25.87.13,1.99.25,1.12.12,0,0,2.24.62,2.24.62,0,0,0,.49s-.13,1-.51,1.37c-.37.37-.74.37-1.24.37h-1.25c-.5,0-2.49.12-3.36.37-.87.25-.49,1.99-.49,1.99l1.75.88c1.74.87.25.74.25,1.12s0,1.62-.5,2.49c-.5.88-.62-.37-1.12-1.12-.49-.75-.63.5-.75,1.12-.12.62-.5.88-.87,1.25s0,.87.5,1.75c.5.87-.25,1.24-.5,1.98-.25.75,0,1.12,1.13,1.87,1.12.75,1.24-.25,2.24-.74.99-.49,1.12-.25,1.98-.49.88-.25.5-1.25,1.12-2.12.62-.88,1-1.99,1-1.99l2.12-2.24s.99-.13,1.61-.13,0,0,.5,0,1-.25,1.12-2.61c.13-2.37-2.61,0-3.98-1.12-1.37-1.12,0-.87.24-1.87.25-1,1.25-1.49,2.49-1.49s2.24,0,4.11-.26c1.87-.24.14-.62.14-1.49Z"
          />
          <path
            class="st353"
            d="M261.53,134.66c-.99-.74-.99-.13-2.74-.88h0l-3.73.82c-.1.44-.31.88-.37,1.05-.12.37-1.25.63-1.75.5-.49-.13-.74-.38-.74-.38,0,0-.38,0-1.12.25-.74.26-.49.75-.74,5.23-.26,4.48.62,0,1.37-.13.75-.12,1.49-1.12,1.49-1.12,0,0,0-.99.37-2.12.37-1.12,1.74,1,1.74,1,0,0,.75-.87.87-1.49.12-.62,1-1.49,1.62-1.75.62-.25.75,1.37,2.74,2.12,1.98.75,0,0,.87-.12.88-.13.87-1,1.25-1.74.37-.75-.14-.5-1.13-1.25Z"
          />
          <path
            class="st353"
            d="M214.11,150.34s.25,2,1.5,1.75c1.24-.25,1.99-1.37,1.99-1.37,0,0-3.12-1.49-3.49-.37Z"
          />
        </g>
        <g>
          <path
            class="st347"
            d="M292.76,99.45v-2.19c0-1.28-.19-1.28-.19-2.19s-.18-1.46-.18-2.37-.18-1.1-.91-2.56c-.73-1.47,0,0-1.28-1.1-1.28-1.09-.54-1.09-1.1-2.73-.54-1.65-1.46-1.28-2.92-2.01-1.47-.73-1.09-2.37-1.47-5.11-.36-2.74.19-3.1.19-3.1,0,0,.55-2.37,1.09-4.02.55-1.63-1.09-.73-2-1.63-.91-.91-1.28-1.1-1.83-3.1-.55-2.01-.92-4.57-1.28-5.12-.36-.54,0-1.28.36-2.37.37-1.09-.72-1.46-.72-2.19s.72-1.63.72-1.63c0,0,1.29-2.19,1.29-4.02s-.19-2.18-.92-3.83c-.73-1.64-2.37-1.64-3.28-2.01-.91-.36-.91-1.09-1.65-2.73-.73-1.65-2.37-3.83-2.73-4.75-.37-.91-.74-1.46-1.64-3.28-.91-1.83,0-2.75.37-3.66.36-.91.91-2.37.91-3.28s-.55-3.83-.55-5.29.55-1.83,1.28-3.1c.74-1.28.74-2.74.74-3.47s-2.2-1.64-2.37-2.73c-.18-1.1-.91-1.28-2.56-2.19-1.64-.92-.55-.92-1.28-1.83-.57-.71-.91-1.23-1.04-2.11-.27-.08-.45-.15-.45-.15,0,0,.18.07.45.15-.03-.24-.06-.49-.06-.8,0-1.47-.91-1.1-3.47-1.83-2.55-.73-1.28,1.28-2.37,1.1-1.09-.18-.91-.36-1.82-.18-.91.18-3.1,0-4.74,0s-.73-.56-2.19,0c-.82.3-1.41.13-2.04-.19-.01.49-.03.7-.03.7,0,0,.02-.21.03-.7-.48-.25-.98-.59-1.62-.9-1.46-.73-1.28-.55-3.47-1.46-2.19-.91-1.82.18-3.28.73-1.46.56-3.65,1.1-3.65,1.1,0,0-1.46,0-2.73-.18-1.28-.18-.74,0-1.46-.36-.73-.37-1.64-.91-4.2-1.83-2.56-.91-1.09.18-2.19.74-1.09.54-1.46.54-2.56.73-1.09.18-1.09,0-2.92,0s0,0-2.01-.19c-2-.18-1.64-.73-2.37-2.37-.73-1.64-1.64-.73-3.1-1.1-1.47-.36-2.01,1.47-3.83,3.29-1.83,1.82-1.82,2.01-2.55,3.84-.74,1.82.36,2.19.36,2.19,0,0-.73.37-2.73.91-2.01.55-.19.73-.37,1.83-.18,1.1-.54.91-2.01,1.82-1.46.91-.37.91-.55,2.01-.18,1.09-.91.73-2.92,1.46-2,.73-.18,1.28-.37,2.74-.18,1.46-.73.18-2.55.73-1.82.55,0,1.64-.36,2.37-.37.73-1.1.37-1.65.37s-.36.73-1.64,1.64c-1.28.91-1.65,0-3.46,0s-1.47,0-1.65.91c-.18.91-.36,1.28-1.82,2.37-1.47,1.1-3.47,2.74-3.47,4.01s2.73,1.29,2.73,1.29l.91.54c.91.55.73,1.46,2.01,2.19,1.28.73.54.73,1.82,1.46,1.27.73,1.28,1.82,1.83,3.47.55,1.64-1.1,1.09-2.55,0-1.46-1.1-1.09,0-1.65.73-.54.73-.91,1.46-1.46,2.37-.55.91-.91-.36-1.46-.91-.55-.55-1.83-.55-4.38-.73-2.56-.18-1.47.73-2.56,1.28-1.1.54-2.19,1.82-3.47,2.92-1.28,1.09-1.82,1.46-3.29,1.64-1.46.18-1.27,1.46-1.27,1.46,0,0-1.1.37-1.64-.36-.55-.74-3.1-.37-3.1-.37h-6.39c-1.1,0-1.82-1.28-3.83-2.37-2-1.1-2.19.91-2.37,2.19-.18,1.28-1.64,2.37-1.64,2.37,0,0-.73.73-2.19,1.1-1.46.37-1.28-1.1-1.28-2.56s-1.28-.54-3.1-.54-1.46.72-3.28,1.46c-1.82.73-1.1.18-2.01-1.09-.91-1.28-1.64.55-2.19,2.01-.54,1.46-.91,1.64-2.01,1.46-1.09-.18-1.27-1.46-1.82-3.28-.55-1.82-1.28-.91-2.19-1.46-.91-.54-2.01.54-2.01.54v2.56s-.91,1.46-1.64,2.37c-.73.91-.55.91-.55.91l-.54,2.01s-1.28.73-1.83.91c-.54.18-1.09.91-1.63,1.64-.56.73-2.93.91-3.47,1.46-.56.54-3.29,2.37-4.38,3.65-1.1,1.28.36,2.55,1.82,3.1,1.46.54.73.91.37,2.01-.37,1.09-1.1,2.56-1.47,3.1-.37.55-.37.91-1.64,2.01-1.28,1.09-.18,1.09-.18,1.64s-.18,1.47-.74,2.19c-.54.73-.36,1.65-.36,2.38s0,1.09.18,2.19c.18,1.09,0,.73-.18,2.19-.18,1.46-.91,1.09-2.37,3.11-1.47,2.01-2.37,3.47-3.11,3.83-.72.37-1.28.55-2.92,1.27-1.64.73-1.27,1.1-1.82,2.01-.55.91-.36,1.46-.36,2.56s1.46.91,1.63,1.82c.18.91.55,2.37.55,2.37l.58,1.62c.05,0,.09.01.15.02,1.28.19.37.91.74,1.47.36.54.18,1.46.18,3.83s0,3.29.36,4.74c.37,1.46,0,2.74,0,4.57s.19,2.74.19,2.74l2,1.63s.74,1.47,1.65,2.74c.91,1.27,1.64,0,3.28.37,1.64.36-.18,2.01-.18,2.01,0,0-.55,1.46-.73,3.28-.18,1.82.36.73,2.01,2.92,1.64,2.19,0,1.28.37,2.74.37,1.47.18,2.01.18,2.01,0,0,.55,1.09,1.83,1.65,1.28.54,1.64,2,1.64,2,0,0,.73.37,1.46.37s2.01.36,3.1.36,0,1.09,0,1.09l-.36,2.01c0,1.64,1.46,0,2.73,0,.6,0,1.22-.24,1.73-.49l-.31-.66s.8-.53.8-.92-.4-.66-.8-1.32c-.39-.65-1.04-.78-1.04-1.44s-1.05-1.05.52-2.11c1.58-1.05,2.37-1.31,3.42-2.11,1.05-.78,2.63-1.58,3.16-2.36.52-.79,5.26-6.71,5.52-7.5.26-.79.27-1.98,1.45-2.37,1.18-.39,4.07-2.9,4.46-3.03.4-.13,2.77-.13,3.69-.52.92-.39,2.63-.65,3.15-.65s.66.13,2.24.39c1.58.27-.4-.26,3.15.39,3.55.66,5.79,1.32,5.79,1.32,0,0,.91.79.91,1.45s.27,2.49.27,3.02-.14,1.05,0,1.44c.13.4.4,2.5.79,3.16.39.66.65,1.46.78,2.1.13.66.79,1.72,1.19,2.64.39.91,1.05,1.7,1.58,1.84.52.13,2.23.92,2.23.92,0,0,.92.66,1.71.66s2.51.52,2.51.52c0,0,2.1.93,2.63,1.32.52.39,1.71,1.31,2.1,1.97.4.66.4,1.06,1.05,1.19.66.13,1.7.78,2.1.78s.93.13,1.59.13,1.32-1.58,2.23-1.58h2.51s2.1-1.44,2.49-1.71c.4-.27.4-.53.93-1.31.52-.8,4.08-.93,4.47-.93s2.76-1.18,2.76-1.18l.65-1.97-1.58-.39s.66-.27.14-.79c-.53-.53-1.71-1.58-1.71-1.58,0,0-1.44-.8.53-.53,1.97.27,2.36.53,2.89.53s1.58.26,1.58.26c0,0,0-.79.4-1.45.4-.65,1.58-2.23,1.58-2.23l1.97-2.37,4.21.27.79,1.71,2.1-.4s.39-.4.65-1.04c.27-.66,0-1.18.79-1.31.78-.14,1.71-1.45,2.63-1.45s.53-.39,2.37,0,2.63.52,2.63.52l1.71-1.45s.66-.27,1.71,0c1.05.27,2.63.79,3.03.79s1.31-.52,1.84-.65c.52-.14,1.58-.27,1.58-.27,0,0,.39.53,1.04.53s4.08-.92,4.08-.92c0,0,.39-1.18,1.18-1.18s1.32.13,1.71,0c.4-.14,1.04.66,1.71-1.58.66-2.24.53-1.18.66-2.24.13-1.05.13-1.71.13-1.71,0,0-.53-.78-.53-1.31s.53-1.84.53-1.84c0,0,.78-.13,1.84-.13s2.76,1.71,2.76,1.71c0,0,1.98-.27,2.89-.27h2.9l2.94-1.58s1.16-.39,2.12-.96c.96-.58,2.5-1.74,2.89-2.31.38-.58,2.12-2.31,2.12-2.31l2.12-.19s2.89.77,3.08,1.35c.19.58-.58,3.66-.58,3.66l-.19.96,3.08.77s.77-.19,1.35.58c.58.77-2.5.38.58.77,3.09.39,4.43.39,4.43.39l1.16.77s1.16.39,1.74,0c.58-.39,1.54-.96,1.54-.96l.19-4.43s.96-.96,1.92-1.74c.97-.77,4.43-2.69,4.43-2.69,0,0,1.16.38,1.74-.39.58-.77,1.73-2.89,1.73-2.89v-3.85l.45.15c-.04-.68-.09-1.4-.09-1.73,0-.73.19-1.65.19-1.65Z"
          />
          <g>
            <path
              class="st347"
              d="M143.29,131.93s.88,1.87.25,3.24c-.62,1.37-1.62,2.49-2.36,2.87-.74.37-1.49.87-2.11,1.62-.62.75-1,1.74-1.37,1.99-.37.25-1.12,1.49-1.86,1.74-.75.25-1.99-.87-1.99-1.49s-.38-.5,0-1.36c.37-.88.87-1.99,1.36-2.87.51-.87,0-1.74,1.75-2.74,1.75-.99,2.37-.87,3.11-1.49.75-.62,2.24-3.11,3.24-1.5Z"
            />
            <path
              class="st347"
              d="M171.92,142.63c.37.08,2.62.62,3.74.87,1.12.25,1.87-.49,1.87,1s2.61,1.87-.13,2.61c-2.73.74-2.61.25-3.98.99-1.36.75-2.49,1.12-2.86,1.74-.38.62,1.61-.25.61,1.49-1,1.75-.24,1.25-1.99,2.62-1.75,1.37-3.24,1.99-2.12,2.37,1.12.37-.12,1,2.12,1s.87-1.25,2.98.37c2.12,1.62,3.36,3.48,3.36,3.48,0,0,.88.63.62,1.49-.25.87-1.49.62-1.75,1.12-.25.5-1.36,3.24-1.36,3.24,0,0,.13,2.24-.74,1.87-.88-.37-.13-2.98-1.62-3.24-1.49-.24-1.37-1.12-2.5-.74-1.12.37-.99,1.37-1.36,1.25-.37-.14-.62-2.49-1.25-1.87-.62.62,1.12,1.36-.74,1.62-1.87.25-2.49.62-3.24.62s-1.36,1.12-2.36.62c-1-.5-1.87.13-1.49-1.74.37-1.88-1-1.87.62-2.37,1.62-.49,1.49-.62,2.86-.99,1.37-.37,2.49-1.25,2.99-1.87.5-.62,1.5-1.25,1.12-1.74-.38-.5.49-1.5-1.12-1.5s-.61.13-1.99.5c-1.37.37-1.87.12-3.36.62-1.49.5-2.24,2.24-2.86.99-.63-1.24-.37-1.87,0-2.61s.74-1.24.74-1.74.12-2.24.12-2.24c0,0,.25-2.36-.37-2.49-.62-.13-.12-.13-.74.74l-.62.88s-.87-.88-.87-1.37.37-.87-.49-1.61c-.88-.75-2.75-2.75-3.12-3.24-.37-.49-.99-1.49-1.12-2.24-.12-.74-.25-1.87-.25-1.87,0,0,0-1.49.87-1.62.87-.13,1.62-.74,2.12,0,.49.75,1.49,1.49,2.11,1.99.62.49,1.13.49,1.62,1.24.49.74-1.12.87,1,1.49l2.11.63s1.37.87,1.87.74c.5-.12.75-2.61.75-2.61,0,0,.25-1.62-.5-1.99-.74-.37-1.87-2.74-2.61-2.11-.74.62-1.36,3.11-1.87,1.74-.5-1.37-.5-1.87-.25-2.24.25-.37.74-.61.37-1.24-.37-.62-.87-1.12-.87-1.49s-.99-1.62.62-1.12c1.62.49,1.12.87,2.73.62,1.62-.25.75-.87,2.24,0,1.49.88,1.49,1.13,2.12,1.62.63.49.5-.13.63.49.12.63.74.51.12,2.37-.63,1.86-.75,2.49-1,3.48-.25,1-.12,2.24-.25,3.12-.13.87.13,1.36-.25,1.74s-.25-.25-1,.75c-.75.99-1.24.99-1,2.11.25,1.12.62,1.24,1.49,2.12s.87,1.61,2.11,0c1.25-1.62,1.87-2.37,2.62-2.87.74-.49.74-.37,1.49-.99.74-.62,1.62-1.49,1.62-2.11s-1.12-1.49-.63-1.87c.5-.37,1.62-2.74,2.24-2.62Z"
            />
            <path
              class="st347"
              d="M187.48,148.98s-1.99.37-2.24.99c-.26.62-.38.75-.63,1.62-.25.87-1.87,1.49-.25,1.49s1.87,0,2.62-.38c.75-.37,1.49-.37,1.49-1s.13-.87.13-1.62-1.12-1.12-1.12-1.12Z"
            />
            <path
              class="st347"
              d="M192.21,148.35l-1.75.75s-.12,0-.37,1.12c-.25,1.12-2.87,2,.12,2h3.74s-1.25.75.25.75,1.37-.75,2.37,0c.99.74-.37,1.12,1.62,1.12s1.61-1.12,1.61-1.12l-.87-1.62s.62-.25.37-.62c-.25-.37-.62-.74-1.87-.87-1.24-.12-5.22-1.49-5.22-1.49Z"
            />
            <path
              class="st347"
              d="M203.16,151.22s-1.74.99-1.74,1.61-.13,2.24.74,1.75c.87-.49,1.87-1,1.99-1.49.13-.49.13-1.24.13-1.24l-1.12-.62Z"
            />
            <path
              class="st347"
              d="M210.38,149.97l-2.73,1.25s-.75.99-1.25,1.61c-.49.63-.49,1.12-.49,1.62s-.25.99.37,1.12c.63.12,3.61.25,4.48-.25.88-.49,2-1.62,2.5-1.99.49-.37.62.25.49-.37-.12-.63-.87-1.75-.87-1.75,0,0-1-1.99-2.49-1.25Z"
            />
            <path
              class="st347"
              d="M224.07,137.52c.25-.99.37-1.24.99-2.49.05-.1.09-.11.14-.18l-1.11-.61c-.19.13-.36.24-.64.43-1.75,1.12-1.49.99-2.37,1.99-.87,1-1.99,2.49-2.86,3.36-.88.87,0,0-1.12,0s0,0-.99-.62c-1-.62-.74.37-1.12.62-.37.25-.74.63-1.37,1-.63.37-1.75.37-2.24.49-.51.13-.75,1.12.12,1.62.88.5,0,.5-.25,1.5-.25.99-.13,1.36,1.49,2.73,1.62,1.36,1,0,3.11,0s1.12-.37,2.12-.75c.99-.37,1.98-.37,2.49-1,.5-.62.25-1.12.25-1.62s.25-1.37.5-1.87c.25-.5.99-1.12,2.24-1.99,1.24-.87.38-1.62.62-2.62Z"
            />
            <g>
              <path
                class="st347"
                d="M267.36,119.31c-.24.47-.64,1.53.13,2.18.77.65,1.8-.13,1.8-.13l.64-1.28s-1.92-2.06-2.57-.77Z"
              />
              <path
                class="st347"
                d="M263.28,115.74l-1.74-.13c-1.62-.5-3.49,1.37-4.11,1.74s-1.25.75-1.25.75c0,0-.49.13-1.49.62-1,.5-.75,0-.75,0,0,0-.37.26-1.37.63-.99.37,2.12.87,2.12.87h1.12l-.37,1.62s-2.24,1.74-2.49,2.11c-.24.37-.49.5-1.24,1.5-.74.99-.62,1.36-.62,1.86s.5.88.5.88c0,0,1.37,1.74,1.49,2.36.13.62-.5.5-1.62.74-1.12.25-.62-.37-1.24-1.61-.63-1.24,0,0-.88.25-.87.25-1.24.5-1.74.75-.5.25-1.24,0-2.37,0s-.62-.25-.87-.62c-.25-.37-.62-.5-1.12-1.12-.5-.62-.26-.5-.51-1.24-.25-.75-.74.37-1.49,1.86-.74,1.49,0,2.25,0,2.25l1.25.62c1.24.62.37.62.37.62,0,0-.5,1.49-.74,1.99l.05,4.22c1.07-.22,2.81-.36,3.18-.36.5,0,.75-.37,2.11-1.37,1.37-.99.37-.49,1.12-1.24.74-.75.25-.88.88-1.49.62-.62.99-.13,2.61-.37,1.61-.25,0,0,.62-1,.62-1,.74,0,1.87.13.27.03.41.15.49.32l2.62-.52.38-.16c-.21-.6.77-1.27.86-2.01.13-1,.37-.87.37-.87,0,0,.37-1,.37-1.5s-.74-1.12-1.12-1.99c-.38-.87-.75-.99-1.62-1.49-.88-.5-.63-.38-1.12-.63-.49-.25-.37-.99-.25-1.36.13-.37,1.12-.51,1.12-.51l.37.26c.37.25.5,0,1.37,0s1.49.25,2.37.25.5-1,.87-1.5.12-1.25.49-2.24q.37-.99,1.25-1.62c.87-.62-.13-2.24-.13-2.24Z"
              />
            </g>
          </g>
        </g>
      </g>
      <template v-if="isSecondGoalEnabled">
        <g id="_第二のルート_x5F_青緑" data-name="第二のルート_x5F_青緑">
          <path
            class="st332"
            d="M347.46,136.71c-2.75-5.63-3.39-9.28-3.69-16.52"
          />
          <path
            class="st331"
            d="M379.38,124.17c-13.49,10.28-27.93,12.95-31.93,12.53"
          />
          <path
            class="st333"
            d="M392.23,130.24c-6.78-5.22-8.85-5.65-12.85-6.07"
          />
          <path
            class="st339"
            d="M418.99,141.9c-12.43,1.06-23.45-8.27-26.76-11.66"
          />
          <path
            class="st335"
            d="M439.83,169.9c-6.31-4.18-18.46-20.54-20.84-28"
          />
          <path class="st338" d="M441.86,193.9c9.24-5.8,0-17.08-2.04-24" />
          <path
            class="st336"
            d="M425.64,238.12c31.08-34.08,20.22-43.81,16.22-44.22"
          />
          <path
            class="st337"
            d="M425.77,238.15c-9.17-7.06-16.58,11.44-17.02,13.08"
          />
          <path
            class="st334"
            d="M408.75,251.23c-5.26,1.64-7.7,5.99-9.71,9.99"
          />
          <path class="st129" d="M391.04,282.82c4-6.06,7.51-14.9,8-21.61" />
          <path
            class="st128"
            d="M379.69,292.86c11.89,5.18,12.62-4,11.35-10.04"
          />
          <path
            class="st130"
            d="M379.69,292.86c.58-6.04-1.75-13.1-6.11-21.23"
          />
          <path
            class="st135"
            d="M373.58,271.63c-3.38-8.2-16.08-14.48-20.08-14.89"
          />
          <path
            class="st132"
            d="M353.5,256.74c-8.89-4.31-19.89-6.48-27.72-7.09"
          />
          <path class="st139" d="M325.78,249.65c-8.62-.5-13.9.56-19.26,3.09" />
          <path class="st131" d="M306.52,252.74c-9.47,2.8-14.16,5.62-19,9.67" />
          <path class="st127" d="M287.52,262.36c-4,4.23-4.75,9.01-6.33,12.46" />
          <path
            class="st134"
            d="M250.97,306.63c1.86-6.82,9.41-35.81,30.22-31.81"
          />
          <path
            class="st133"
            d="M235.5,334.87c8.16-2.44,13.72-7.89,15.47-28.24"
          />
          <path class="st113" d="M218.8,343.12c7.31-2.08,11.36-2.52,16.7-8" />
          <path
            class="st116"
            d="M208.68,355.99c5.6-4.36,8.15-6.43,10.12-12.87"
          />
          <path
            class="st122"
            d="M220.5,373.91c-1.7-7.32-3.11-11.32-11.82-17.93"
          />
          <path
            class="st117"
            d="M220.5,373.91c-10.06,2.07-22.45-9.09-24.56-19.32"
          />
          <path
            class="st114"
            d="M195.93,354.6c-13.83-9.12-28.71-6.45-31.61-2.97"
          />
          <path
            class="st111"
            d="M164.32,351.62c12.23-10.97,2.56-19.75-7.08-16.92"
          />
          <path
            class="st115"
            d="M157.24,334.71c13.93-2.28,19.31-12.5,22.09-27.28"
          />
          <line class="st124" x1="179.33" y1="307.43" x2="167.39" y2="301.65" />
          <line class="st126" x1="167.17" y1="301.83" x2="168.27" y2="287.93" />
          <path
            class="st125"
            d="M168.27,287.93c-.27-21.4.95-30.78,16.34-31.3"
          />
          <path
            class="st136"
            d="M184.6,256.63c1.31-8.03-4.34-18.19-8.34-18.61"
          />
          <path
            class="st138"
            d="M176.27,238.02c6.82-2.7,13.28-5.43,13.64-14.48"
          />
          <path
            class="st137"
            d="M189.91,223.54c5.86-5.05,8.37-8.93,11.03-17.85"
          />
          <path class="st112" d="M219.04,209.69c-12.16,2.3-14.83-1.15-18.1-4" />
          <path
            class="st119"
            d="M247.65,192.17c-14.19,11.75-24.6,17.93-28.6,17.52"
          />
          <path
            class="st118"
            d="M247.94,192.17c-14.82-9.56-18.61-21.07-21.68-29.3"
          />
          <path
            class="st110"
            d="M226.26,162.87c7.18-2.05,11.24-6.72,15.49-17.06"
          />
          <path
            class="st121"
            d="M241.75,145.59c3.67-1.38,7.8-8.56,10.58-20.72"
          />
          <path
            class="st120"
            d="M252.16,124.88c2.84-4.56,5.89-5.99,7.6-13.34"
          />
          <path
            class="st123"
            d="M259.76,111.54c-7.42-3.61-17.76-4.41-21.76-4.82"
          />
          <line class="st109" x1="237.75" y1="106.71" x2="222.26" y2="108.21" />
          <line class="st108" x1="222.26" y1="108.21" x2="199.83" y2="109.07" />
          <path
            class="st105"
            d="M199.83,109.07c-27.83,2.13-35.4.42-41.12,5.64"
          />
          <path
            class="st103"
            d="M158.7,114.71c-7.48-1.45-11.54-1.12-16.83.82"
          />
          <path
            class="st104"
            d="M138.72,130.55c-.84-4.34-.23-9.18,3.16-15.02"
          />
          <path
            class="st107"
            d="M120.75,152.35c-.49-9.59,11.52-21.8,17.97-21.8"
          />
          <path
            class="st106"
            d="M109.06,167.04c1.22-5.78,7.05-13.11,11.6-14.61"
          />
          <path
            class="st100"
            d="M110.77,183.87c-.96-2.38-1.94-10.16-1.71-16.83"
          />
          <path
            class="st102"
            d="M88.81,185.49c6.13,2.32,16.85,2.94,21.96-1.62"
          />
          <path
            class="st101"
            d="M88.81,185.49c-11.65-7.28-14.15-10.03-20.63-16.55"
          />
          <circle class="st239" cx="392.23" cy="130.24" r="4" />
          <circle class="st235" cx="418.99" cy="141.9" r="4" />
          <circle class="st236" cx="439.83" cy="169.9" r="4" />
          <circle class="st238" cx="425.64" cy="238.12" r="4" />
          <circle class="st237" cx="408.75" cy="251.23" r="4" />
          <circle class="st234" cx="399.04" cy="261.22" r="4" />
          <circle class="st241" cx="391.04" cy="282.82" r="4" />
          <circle class="st243" cx="379.69" cy="292.86" r="4" />
          <circle class="st242" cx="373.58" cy="271.63" r="4" />
          <circle class="st240" cx="353.5" cy="256.74" r="4" />
          <circle class="st230" cx="325.78" cy="249.65" r="4" />
          <circle class="st200" cx="306.52" cy="252.74" r="4" />
          <circle class="st196" cx="287.52" cy="262.36" r="4" />
          <circle class="st195" cx="281.19" cy="274.82" r="4" />
          <circle class="st221" cx="250.97" cy="306.63" r="4" />
          <circle class="st229" cx="235.5" cy="335.12" r="4" />
          <circle class="st199" cx="218.8" cy="343.12" r="4" />
          <circle class="st201" cx="208.68" cy="355.99" r="4" />
          <circle class="st213" cx="220.5" cy="373.91" r="4" />
          <circle class="st218" cx="195.93" cy="354.6" r="4" />
          <circle class="st228" cx="164.32" cy="351.62" r="4" />
          <circle class="st226" cx="157.24" cy="334.71" r="4" />
          <circle class="st224" cx="179.33" cy="307.43" r="4" />
          <circle class="st222" cx="167.17" cy="301.83" r="4" />
          <circle class="st198" cx="168.27" cy="287.93" r="4" />
          <circle class="st197" cx="184.6" cy="256.63" r="4" />
          <circle class="st225" cx="176.27" cy="238.02" r="4" />
          <circle class="st223" cx="189.91" cy="223.54" r="4" />
          <circle class="st202" cx="200.94" cy="205.69" r="4" />
          <circle class="st227" cx="219.04" cy="209.69" r="4" />
          <circle class="st203" cx="247.65" cy="192.17" r="4" />
          <circle class="st210" cx="226.26" cy="162.87" r="4" />
          <circle class="st217" cx="241.75" cy="145.81" r="4" />
          <circle class="st204" cx="252.34" cy="124.88" r="4" />
          <circle class="st209" cx="259.76" cy="111.54" r="4" />
          <circle class="st233" cx="237.75" cy="106.71" r="4" />
          <circle class="st207" cx="222.26" cy="108.25" r="4" />
          <circle class="st231" cx="199.83" cy="109.07" r="4" />
          <circle class="st232" cx="158.7" cy="114.71" r="4" />
          <circle class="st208" cx="141.88" cy="115.54" r="4" />
          <circle class="st214" cx="138.72" cy="130.55" r="4" />
          <circle class="st212" cx="120.75" cy="152.35" r="4" />
          <circle class="st215" cx="109.06" cy="167.04" r="4" />
          <circle class="st211" cx="110.77" cy="183.87" r="4" />
          <circle class="st220" cx="88.81" cy="185.49" r="4" />
          <circle class="st216" cx="68.18" cy="168.94" r="4" />
          <circle class="st219" cx="441.86" cy="193.9" r="4" />
          <circle class="st206" cx="379.38" cy="124.17" r="4" />
          <circle class="st205" cx="347.46" cy="136.71" r="4" />
        </g>
        <g id="_x36_7周南_xFF1A_橙" v-if="this.arrivedPointIdList.includes(67)">
          <path
            class="st50"
            d="M88.81,185.49c-11.65-7.28-14.15-10.03-20.63-16.55"
          />
          <circle class="st21" cx="68.18" cy="168.94" r="4" />
          <g>
            <g>
              <g>
                <path
                  class="st348"
                  d="M128.06,79.67c-1.34,2.32-4.27,3.13-6.55,1.82-.17-.1.16.12,0,0-7.15,4.91-24.2,10.94-24.2,10.94l-.48-4.28c3.19-1.79,17.9-7.78,22.35-10.22-.12-1,.07-2.06.62-3.01,1.33-2.32,4.27-3.14,6.55-1.83,2.28,1.31,3.05,4.25,1.72,6.57Z"
                />
                <path
                  class="st346"
                  d="M97.05,92.95s-.03-.02-.04-.03c-.15-.09-.25-.25-.26-.42l-.48-4.28c-.03-.23.09-.45.29-.56,1.53-.86,5.63-2.65,9.97-4.55,4.72-2.07,9.6-4.2,12.05-5.5-.05-1.04.2-2.05.72-2.96,1.49-2.59,4.78-3.51,7.33-2.04,1.24.71,2.12,1.87,2.48,3.26.36,1.39.16,2.84-.55,4.09h0c-1.43,2.48-4.51,3.42-7.01,2.21-7.27,4.85-23.36,10.57-24.05,10.82-.15.05-.31.04-.45-.03ZM97.45,88.47l.36,3.18c3.2-1.17,16.87-6.26,23.17-10.48,0,0,0,0,0,0,.15-.25.52-.32.78-.19.02,0,.03.01.04.02,2.04,1.15,4.59.42,5.76-1.61h0c.57-.99.72-2.14.44-3.23-.28-1.09-.98-2-1.94-2.55-2-1.14-4.59-.43-5.77,1.61-.46.81-.65,1.73-.54,2.65.03.23-.09.46-.29.57-2.37,1.3-7.51,3.55-12.47,5.72-4.03,1.76-7.84,3.43-9.54,4.32ZM128.06,79.67h0s0,0,0,0Z"
                />
              </g>
              <g>
                <path
                  class="st348"
                  d="M65.42,60.51c-.23,2.66,1.72,4.96,4.35,5.16.2.02-.2.01,0,0,3.07,8.03,13.67,22.53,13.67,22.53l2.85-3.26c-1.6-3.26-10.29-16.4-12.55-20.9.67-.76,1.12-1.73,1.22-2.82.23-2.65-1.72-4.97-4.35-5.16-2.63-.19-4.95,1.8-5.19,4.46Z"
                />
                <path
                  class="st346"
                  d="M83.18,88.7c-.08-.04-.15-.1-.2-.17-.43-.59-10.4-14.27-13.61-22.33-1.28-.18-2.43-.81-3.26-1.8-.93-1.09-1.38-2.49-1.25-3.94.26-2.96,2.86-5.19,5.8-4.98,1.42.1,2.71.76,3.63,1.84.93,1.09,1.38,2.49,1.25,3.94-.09,1.04-.47,2.02-1.11,2.84,1.28,2.45,4.08,6.93,6.79,11.28,2.48,3.98,4.83,7.74,5.6,9.3.1.21.07.46-.08.63l-2.85,3.26c-.11.13-.28.2-.46.19-.08,0-.16-.02-.23-.06ZM70.4,65.7c2.77,7,11.11,18.82,13.08,21.57l2.12-2.43c-.89-1.68-3.07-5.17-5.37-8.86-2.85-4.57-5.8-9.3-7.01-11.7-.11-.21-.07-.46.08-.64.62-.7,1-1.57,1.08-2.49.1-1.14-.25-2.24-.98-3.1-.72-.85-1.73-1.36-2.84-1.44-2.32-.17-4.37,1.6-4.57,3.94h0c-.1,1.14.25,2.24.98,3.1.72.84,1.73,1.36,2.84,1.44.02,0,.03,0,.05,0,.3.04.56.31.54.6,0,0,0,0,0,0Z"
                />
              </g>
              <g>
                <path
                  class="st346"
                  d="M88.85,127.93c-4.4-2.24-3.66-9.71-3.55-10.61.15-1.26,1.29-2.15,2.54-2.01,1.25.15,2.15,1.28,2.01,2.54-.26,2.28.12,5.76,1.28,6.07.62.16,2.09-.25,5.09-4.75.37-.56.58-.87.84-1.13.9-.89,2.35-.88,3.24.02.85.87.88,2.24.08,3.13-.08.11-.2.29-.34.51-1.57,2.36-5.24,7.88-10.03,6.65-.42-.11-.8-.25-1.15-.43ZM100.35,121.22s-.05.05-.08.08c.02-.02.05-.05.08-.08Z"
                />
                <path
                  class="st348"
                  d="M89.45,126.84c-3.75-1.91-2.96-9.05-2.92-9.38.07-.58.59-.99,1.17-.92.58.07.99.59.92,1.17-.2,1.73-.24,6.79,2.2,7.41,2.5.64,5.35-3.65,6.42-5.27.36-.54.51-.77.68-.93.41-.41,1.08-.4,1.49.01.41.41.4,1.08-.01,1.49-.04.05-.23.34-.4.6-1.42,2.14-4.75,7.15-8.7,6.14-.31-.08-.59-.19-.85-.32Z"
                />
              </g>
              <g>
                <path
                  class="st348"
                  d="M73.19,116.51l-.31,13.08s-2.34.26-2.14,1.04c.21.78,3.91,1.32,4.41.96.5-.37,3.24-13.56,3.24-13.56l-5.2-1.52Z"
                />
                <path
                  class="st346"
                  d="M70.95,131.57c-.43-.22-.67-.47-.75-.78-.07-.27-.02-.55.14-.78.37-.53,1.31-.79,1.99-.91l.3-12.6c0-.18.09-.34.23-.45.14-.11.33-.14.5-.09l5.2,1.52c.28.08.46.37.4.67-2.78,13.4-3.25,13.76-3.46,13.91-.7.51-3.16.04-4.05-.28-.19-.07-.35-.13-.49-.21ZM71.44,130.55c.63.35,2.68.7,3.33.59.43-1.07,1.8-7.11,2.96-12.69l-3.98-1.16-.29,12.34c0,.29-.22.52-.51.56-.58.06-1.21.23-1.51.38ZM74.71,131.25h0Z"
                />
              </g>
              <g>
                <path
                  class="st348"
                  d="M91.5,122.12l-7.25,10.96s1.78,1.52,1.16,2.05c-.62.53-3.98-1.09-4.19-1.67-.2-.59,5.12-12.99,5.12-12.99l5.16,1.65Z"
                />
                <path
                  class="st346"
                  d="M82.29,134.93c-.77-.39-1.46-.87-1.61-1.28-.08-.24-.27-.8,5.13-13.4.12-.27.42-.41.7-.32l5.16,1.65c.17.06.31.19.37.36.06.17.04.36-.06.51l-6.98,10.55c.49.48,1.12,1.21,1.12,1.85,0,.29-.12.54-.33.73-.33.29-.86.32-1.65.1-.47-.13-1.18-.4-1.84-.74ZM81.81,133.32c.41.4,2.33,1.29,3.09,1.35-.16-.29-.59-.78-1.03-1.15-.22-.19-.26-.51-.1-.75l6.84-10.33-3.94-1.26c-2.26,5.29-4.62,11.07-4.85,12.14ZM85.1,134.65h0Z"
                />
              </g>
              <g>
                <path
                  class="st348"
                  d="M83.56,79.91s-12.71,27.27-12.68,32.7c.04,5.43,6.46,7.79,10.99,9.17,4.53,1.39,12.42,2.17,14.19-4.28,1.77-6.45,6.75-34.97,6.75-34.97l-19.24-2.62Z"
                />
                <path
                  class="st346"
                  d="M76.14,120.21c-3-1.53-5.82-3.89-5.84-7.6-.04-5.5,12.21-31.82,12.73-32.94.11-.23.35-.36.6-.33l19.24,2.62c.16.02.29.1.39.23.09.13.13.28.1.44-.2,1.17-5,28.63-6.76,35.03-.56,2.02-1.71,3.53-3.45,4.48-4.01,2.21-9.79.71-11.46.19-1.38-.42-3.51-1.07-5.55-2.12ZM83.9,80.53c-1.54,3.32-12.48,27.17-12.45,32.07.03,4.76,5.37,7.04,10.58,8.63,1.57.48,6.96,1.89,10.58-.1,1.45-.8,2.42-2.07,2.89-3.78,1.6-5.84,5.91-30.23,6.63-34.33l-18.24-2.48Z"
                />
              </g>
              <g>
                <path
                  class="st351"
                  d="M81.91,79.4s.96,5.98,9.2,8.5c8.24,2.52,14.09-3.14,14.09-3.14l-23.28-5.62"
                />
                <path
                  class="st346"
                  d="M87.96,87.12c-5.67-2.89-6.46-7.43-6.5-7.65-.01-.08,0-.15.02-.22-.02-.07-.02-.14,0-.21.06-.24.3-.39.54-.33l23.27,5.62c.16.04.28.16.33.32.04.16,0,.33-.12.44-.06.06-6.13,5.81-14.53,3.24-1.13-.35-2.13-.76-3.01-1.2ZM82.44,79.73c.37,1.35,2.07,5.69,8.8,7.74,6.34,1.94,11.27-1.17,12.99-2.48l-21.79-5.26Z"
                />
              </g>
              <g>
                <polygon
                  class="st348"
                  points="92.65 55.52 87.81 46.07 83.08 57.62 92.65 55.52"
                />
                <path
                  class="st346"
                  d="M82.82,58.13c-.07-.03-.13-.08-.18-.14-.14-.16-.17-.39-.09-.59l4.73-11.55c.08-.21.28-.35.51-.35.22,0,.43.11.53.31l4.84,9.45c.08.16.08.34,0,.51-.08.16-.22.28-.4.31l-9.57,2.1c-.13.03-.27.01-.38-.05ZM87.87,47.44l-3.85,9.38,7.77-1.71-3.93-7.68Z"
                />
              </g>
              <g>
                <polygon
                  class="st348"
                  points="109.19 60.58 118.61 55.49 115.88 67.65 109.19 60.58"
                />
                <path
                  class="st346"
                  d="M115.62,68.16c-.06-.03-.11-.07-.16-.12l-6.68-7.07c-.12-.13-.18-.31-.15-.48.03-.18.14-.33.29-.41l9.41-5.09c.2-.11.44-.09.62.05.18.14.26.36.21.58l-2.73,12.16c-.05.21-.2.37-.41.43-.14.04-.29.02-.41-.04ZM110.12,60.73l5.43,5.75,2.22-9.88-7.65,4.14Z"
                />
              </g>
              <g>
                <path
                  class="st348"
                  d="M102.1,55.01c-13.07-4-23.11,2.27-25.6,10.19-4.05,12.87,10.02,18.21,17.32,20.45,7.3,2.23,19.85,2.55,24.09-10.91,2.36-7.51-4.38-16.23-15.8-19.72Z"
                />
                <path
                  class="st346"
                  d="M85.37,82.96c-4.3-2.19-7.2-4.77-8.79-7.79-1.58-3.01-1.8-6.42-.63-10.13,1.33-4.23,4.66-7.85,9.14-9.92,3.51-1.62,9.34-3.05,17.18-.65,6.97,2.13,12.48,6.23,15.11,11.23,1.63,3.09,1.99,6.27,1.07,9.21-1.94,6.17-5.74,10.12-11.28,11.72-5.62,1.63-11.33.24-13.52-.43-3.18-.97-5.93-2.05-8.27-3.24ZM101.94,55.56c-9.78-2.99-21.76-.14-24.89,9.82-1.07,3.41-.89,6.52.55,9.26,2.31,4.38,7.67,7.8,16.39,10.47,3.05.93,18.54,4.82,23.38-10.54.83-2.64.49-5.52-.99-8.33-2.46-4.67-7.85-8.66-14.43-10.67h0ZM102.1,55.01h0s0,0,0,0Z"
                />
              </g>
              <g>
                <path
                  class="st346"
                  d="M94.97,69.42c-.22.73.2,1.49.91,1.69l1.78.51c.72.21,1.48-.22,1.69-.95h0c.21-.73-.2-1.48-.92-1.69l-1.78-.51c-.72-.2-1.48.22-1.69.95h0Z"
                />
                <path
                  class="st346"
                  d="M95.44,71.42c-.32-.16-.58-.41-.75-.73-.23-.43-.29-.92-.15-1.39h0c.28-.96,1.29-1.52,2.24-1.25l1.78.51c.46.13.84.44,1.08.86.23.43.29.92.15,1.39-.28.96-1.29,1.52-2.25,1.25l-1.78-.51c-.11-.03-.22-.07-.32-.13ZM98.48,69.47c-.05-.03-.11-.05-.16-.06l-1.78-.51c-.48-.14-.99.15-1.14.64h0c-.07.24-.04.49.08.71.12.21.31.36.54.43l1.78.51c.49.14,1-.15,1.14-.64.07-.24.04-.49-.08-.71-.09-.16-.22-.28-.38-.37Z"
                />
              </g>
              <g>
                <path
                  class="st346"
                  d="M91.67,66.12c-.39,1.25-1.37,2.06-2.18,1.81-.81-.25-1.15-1.46-.76-2.71.39-1.25,1.37-2.07,2.18-1.82.81.25,1.15,1.47.76,2.72Z"
                />
                <path
                  class="st346"
                  d="M89.12,68.26c-.29-.15-.54-.4-.71-.73-.34-.65-.38-1.57-.11-2.45.48-1.51,1.68-2.44,2.74-2.11.4.12.73.41.95.83.34.65.38,1.57.1,2.45h0c-.47,1.51-1.68,2.43-2.74,2.11-.08-.03-.16-.06-.24-.1ZM90.87,63.87s-.06-.03-.09-.04c-.49-.15-1.28.44-1.63,1.52-.2.65-.19,1.33.04,1.77.11.2.25.34.42.39.5.15,1.29-.44,1.63-1.52.2-.65.19-1.33-.04-1.77-.09-.17-.2-.29-.33-.35Z"
                />
              </g>
              <path
                class="st346"
                d="M91.66,74.32c-.72-.37-1.18-.87-1.35-1.49-.34-1.2.56-2.36.59-2.41.15-.19.43-.22.62-.08.19.15.23.43.08.63,0,0-.65.85-.44,1.62.13.46.57.83,1.3,1.1.61.23,1.15.22,1.66-.03,1.26-.62,1.84-2.46,1.85-2.48.07-.23.31-.36.54-.3.23.06.37.3.32.53,0,.03-.56,2.6,1.24,3.9,1.74,1.26,3.29-.15,3.36-.21.18-.17.46-.16.63.02.17.18.16.46-.02.63-.74.69-2.62,1.64-4.49.28-1.07-.78-1.5-1.87-1.64-2.81-.35.48-.81.95-1.4,1.24-.73.36-1.53.38-2.37.07-.18-.07-.34-.14-.49-.22Z"
              />
              <path
                class="st346"
                d="M93.93,79.52c-2.08-1.06-1.95-4.99-1.94-5.17,0-.25.22-.44.46-.43.25,0,.44.22.43.46,0,.04-.11,4.3,2.01,4.5,2.26.21,3.55-2.51,3.56-2.54.1-.22.37-.32.59-.22.22.08.32.37.22.59-.06.14-1.58,3.33-4.46,3.05-.33-.03-.62-.12-.87-.25Z"
              />
              <path
                class="st346"
                d="M106.77,72.06c-.08-.04-.15-.11-.2-.2-.24-.5-2.1-1.4-3.67-1.95-.18-.06-.3-.24-.3-.43s.14-.36.32-.42l4.51-1.27c.24-.07.48.07.55.31s-.07.48-.31.55l-3.22.91c1.12.47,2.57,1.2,2.92,1.91.11.22.02.49-.2.6-.13.06-.28.06-.4,0Z"
              />
              <path
                class="st346"
                d="M104.82,64.25c-.06-.03-.11-.07-.15-.12-.15-.19-.12-.47.07-.63.06-.05,1.58-1.24,3.08-.79.91.27,1.59,1.06,2.02,2.34.08.23-.05.49-.28.56-.23.08-.49-.05-.56-.28-.33-.99-.81-1.59-1.42-1.77-1.06-.32-2.26.62-2.28.63-.14.11-.33.12-.48.05Z"
              />
              <path
                class="st346"
                d="M89.25,59.49c-.06-.03-.11-.07-.15-.12-.15-.19-.12-.47.07-.63.06-.05,1.58-1.24,3.08-.79.91.27,1.59,1.06,2.02,2.34.08.23-.05.49-.28.56-.23.08-.49-.05-.56-.28-.33-.99-.81-1.59-1.43-1.77-1.05-.31-2.26.62-2.27.63-.14.11-.33.13-.48.05Z"
              />
              <g>
                <g>
                  <path
                    class="st352"
                    d="M94.31,90.88c-.59,1.88-2.57,2.93-4.43,2.37-1.85-.57-2.88-2.55-2.29-4.42.59-1.88,2.57-2.94,4.42-2.37,1.85.57,2.88,2.55,2.29,4.42Z"
                  />
                  <path
                    class="st346"
                    d="M89.12,93.42c-.71-.36-1.3-.94-1.68-1.66-.5-.95-.59-2.03-.27-3.06.66-2.11,2.89-3.3,4.98-2.66,1,.31,1.82.99,2.31,1.92.5.95.6,2.04.27,3.06h0c-.66,2.1-2.9,3.3-4.98,2.66-.22-.07-.43-.15-.64-.26ZM92.38,87.09c-.16-.08-.32-.15-.49-.2-1.62-.49-3.35.44-3.87,2.08-.25.8-.18,1.64.21,2.38.38.72,1.01,1.24,1.78,1.48,1.62.49,3.35-.44,3.87-2.08.25-.8.18-1.65-.21-2.38-.29-.56-.74-1-1.29-1.28Z"
                  />
                </g>
                <g>
                  <path
                    class="st352"
                    d="M95.38,90.96c-.14.44-.61.69-1.05.56l-7.11-2.18c-.44-.13-.68-.6-.54-1.04h0c.14-.45.61-.7,1.05-.56l7.11,2.17c.44.13.68.6.54,1.05h0Z"
                  />
                  <path
                    class="st346"
                    d="M86.88,89.69c-.23-.12-.42-.3-.54-.54-.16-.3-.19-.66-.09-.99.21-.68.93-1.06,1.6-.86l7.11,2.18c.33.1.59.32.75.62.16.31.19.66.09.99-.21.68-.93,1.06-1.6.85l-7.11-2.18c-.07-.02-.14-.05-.21-.08ZM94.76,90.37s-.04-.02-.06-.02l-7.11-2.18c-.2-.06-.42.06-.49.27-.03.1-.02.21.03.3.05.09.13.15.22.18l7.11,2.18c.21.06.43-.06.49-.27,0,0,0,0,0,0,.03-.1.02-.21-.03-.3-.04-.07-.09-.13-.16-.16Z"
                  />
                </g>
                <g>
                  <path
                    class="st346"
                    d="M91.09,92.59c-.16.51-.69.79-1.19.64-.5-.15-.78-.69-.62-1.19.16-.51.69-.79,1.2-.64.5.15.78.69.62,1.19Z"
                  />
                  <path
                    class="st346"
                    d="M89.54,93.56c-.25-.13-.46-.33-.6-.59-.17-.33-.21-.71-.09-1.07.23-.74,1.02-1.16,1.75-.93.36.11.65.35.82.68.17.33.21.71.09,1.08-.23.74-1.02,1.16-1.75.93-.08-.02-.15-.05-.22-.09ZM90.42,91.85s-.05-.02-.08-.03c-.27-.08-.55.08-.64.35-.04.13-.03.27.03.39.06.12.16.2.29.24.27.08.55-.07.64-.34h0c.04-.13.03-.27-.03-.4-.05-.09-.12-.16-.21-.21Z"
                  />
                </g>
              </g>
            </g>
            <polygon
              class="st341"
              points="50.12 98.53 33.77 124.68 47.08 146.86 112.66 152.62 122.87 120.48 99.19 94.15 50.12 98.53"
            />
            <g>
              <path
                class="st348"
                d="M60.35,130.25c.09-.38.04-.73-.14-1-.19-.28-.49-.45-.92-.52-1.03-.16-5.49.11-7.17.5-.58.14-1.01.5-1.16.98-.11.36-.03.72.2.96.15.15.48.38,1.09.23,2.05-.51,4.16-.78,5.47-.83-.96,1.36-3.33,4.01-5.95,4.36-1.19.16-2.13-.01-2.79-.52-.72-.55-.97-1.38-1.05-1.98-.28-2.18.54-4.54,2.25-6.49,1.89-2.15,4.51-3.38,7.21-3.38.27,0,.62.05.79.31.16.24.14.63-.05,1.11-.15.37-.1.75.14,1.04.25.3.67.45,1.06.37.46-.09.82-.46.99-1.02.1-.33.16-.73.15-1.12-.01-.82-.3-1.46-.83-1.83-.66-.48-1.6-.72-2.72-.7-.66.01-1.38.11-2.08.3-5.62,1.5-9.2,5.81-9.12,10.98,0,.38.03.77.07,1.14.18,1.4,1.13,2.86,2.85,3.49.57.21,1.23.32,1.98.31.37,0,.77-.05,1.19-.13,2.71-.49,4.7-2.17,5.97-3.63-.29.7-.61,1.39-.95,2.12-.27.57-.12.93,0,1.09.19.26.54.4.91.37.45-.05.84-.33,1.02-.74.56-1.3,1.25-4.28,1.55-5.55l.06-.24Z"
              />
              <path
                class="st348"
                d="M77.25,125.89c-.05-3.17-1.94-5.08-5.16-5.24-.18-.02-.34-.01-.53-.01h-.06c-5.69.09-9.58,5.39-9.51,10.1,0,.53.06,1.02.15,1.47.15.83.81,3.14,3.38,4.07.72.26,1.59.42,2.65.4,3.65-.06,7.35-3.3,8.59-7.55.34-1.16.5-2.25.49-3.24ZM68.12,134.76c-2.28.14-3.74-1.23-4.01-3.77-.21-2.1.62-4.43,2.18-6.09,1.5-1.6,3.51-2.43,5.66-2.34,1.23.05,2.13.47,2.67,1.25.75,1.08.79,2.83.11,4.94-1.02,3.18-3.98,5.87-6.61,6.01Z"
              />
              <path
                class="st348"
                d="M91.89,135.11v-.08c-.21-2.81-2.47-12.04-3.37-14.13-.17-.41-.61-.67-1.11-.66-.3,0-.87.11-1.39.79-2.24,2.91-7.31,10.93-8.93,13.96-.13.23-.2.46-.19.67,0,.39.24.7.61.84.03.01.07.02.1.03.49.13,1.19-.06,1.59-.76.35-.66.73-1.29,1.17-2.02.22-.36.45-.75.7-1.17,2.81-.5,6.52-.68,8.04-.65.2,1.24.34,2.36.42,3.34.08.84.63,1.15,1.17,1.17.58,0,1.19-.51,1.18-1.31,0,0,0,0,0,0ZM88.74,129.83c-1.35,0-4.14.18-6.5.5.25-.39.5-.8.76-1.22,1.38-2.2,2.93-4.68,4.05-6.23.56,1.72,1.21,4.41,1.69,6.95Z"
              />
              <path
                class="st348"
                d="M104.25,133.4c-1.88,0-5.85.27-8.51.56.49-3.58,2.03-10.39,2.8-12.7.15-.46.03-.75-.09-.92-.18-.24-.48-.37-.83-.37-.47,0-1.03.3-1.21.94-.54,1.86-2.16,10.13-2.75,13.31-.68.15-.99.61-.98,1.03,0,.38.23.77.61.91.1.04.21.05.32.05,0,0,0,0,0,0,.04,0,.06,0,.19-.02,2.71-.49,8.03-.82,10.3-.8.4,0,.76-.13,1-.37.2-.2.3-.45.3-.71,0-.46-.36-.91-1.14-.9Z"
              />
              <path
                class="st348"
                d="M111.08,134.31c-.07-.16-.5-.89-.69-1.15-.38-.49-.97-.67-1.55-.47-.54.19-.9.67-.89,1.2,0,.17.05.43.24.71l.08.11c.13.2.48.73.54.85.16.3.4.52.69.62.14.05.3.08.46.08.44,0,.86-.23,1.09-.59.24-.38.25-.87.03-1.37Z"
              />
              <path
                class="st348"
                d="M109.49,131.63c.25.09.53.09.8-.01.42-.16.71-.55.79-1.05.53-3.59,1.3-5.79,2.84-9.38.04-.1.08-.2.09-.28.03-.09.03-.17.03-.23,0-.28-.12-.53-.34-.7-.19-.15-.45-.23-.72-.23-.54,0-1.02.35-1.27.88-.67,1.49-2.03,5.2-2.86,9.71h0c-.08.45.04.86.34,1.11.09.08.2.14.31.18Z"
              />
            </g>
            <path
              class="st348"
              d="M68.32,114.58c0-.19.11-.4.38-.53,1.21-.59,2.75-1.43,3.92-2.22-.88.16-1.61.3-2.49.47-.95.19-1.12-.66-.87-1.17.18-.37.37-.71.58-1.14-.12-.24.07-.66.42-.72.97-.16,2.47-.33,3.89-.48.12-.47.24-.89.32-1.2-1.01.12-2.07.28-3.09.47-.74.14-.66-.89.02-1,.36-.06.76-.11,1.18-.18l-.02-.07c-.06-.26-.15-.7-.3-1.08l-.02-.07c-.43.05-.89.13-1.4.2-.2.47-.43.96-.7,1.37-.44.66-1.26.11-.8-.56.46-.66.75-1.33,1.02-2.04.26-.7,1.11-.39.88.19l-.07.16c1.33-.19,2.5-.33,3.28-.35.67-.01.54.85-.07.86-.42,0-.84.04-1.29.08.14.33.27.73.32.96.02.09.01.18,0,.25,1.43-.17,2.98-.3,4.05-.35v-.06c.02-.26.08-.71.04-1.06-.48.06-.98.14-1.51.23-.1.21-.21.41-.32.62-.4.74-1.29.24-.79-.48.33-.48.43-.7.7-1.41.11-.29.3-.4.5-.41.27,0,.53.25.39.6-.02.06-.04.13-.08.18,1.41-.22,2.83-.36,3.63-.37.31,0,.45.17.45.37,0,.23-.19.48-.52.49-.49,0-1.01.04-1.59.09.04.4.05.9.02,1.16,0,.01,0,.02-.01.06.38.12.54.56.46.93-.08.33-.45,1.19-.67,1.72-.2.47-.73.48-.91.26-.59.03-1.45.1-2.38.21-.1.39-.19.8-.29,1.21,1.67-.21,3.18-.36,3.77-.34.54.01.76.41.69.97-.13,1.01-.47,2.4-.72,3.09-.1.29-.37.45-.7.46-.07,0-.14,0-.21-.02-.38-.06-1.24-.23-1.61-.37-.65-.25-.35-1.15.35-.88.46.17,1.01.3,1.43.38.26-.9.47-2.06.56-2.76-.7.02-2.13.17-3.76.35-.27,1.19-.49,2.29-.57,2.87-.08.58-1.11.56-.98-.09.12-.58.28-1.34.47-2.14-1.29.92-2.75,1.88-4.08,2.65-.5.29-.89,0-.9-.36ZM73.62,110.9c.1-.41.2-.84.3-1.22-1.08.12-2.21.26-3.11.41-.24.44-.54.95-.71,1.3,1-.14,2.26-.32,3.52-.49ZM75.37,107.48l-.31,1.21c1-.09,1.89-.18,2.43-.22.19-.42.35-.9.45-1.17-.71.01-1.6.07-2.56.18Z"
            />
            <polygon
              class="st341"
              points="81.15 148.04 67.63 162.12 69.85 147.22 81.15 148.04"
            />
            <path
              class="st348"
              d="M83.32,114.44c-.44,0-.73-.34-.73-.65v-.04c.01-.22.14-.41.42-.5.29-.1,1.06-.36,1.81-.82,2.46-1.49,6.86-4.34,6.78-5.97-.04-.72-1-1.08-2.23-.96-1.48.14-2.59.91-3.33,1.8-.71.85-1.67-.13-.84-.98.78-.8,2.22-1.75,4.02-1.92.19-.01.37-.02.55-.02,1.21,0,2.23.37,2.73,1.02.24.31.35.66.35,1.03,0,.72-.4,1.5-1.02,2.19-1.25,1.39-4.22,3.3-6.57,4.64.89-.12,4.49-.59,6.38-.55.97.02.83,1.24-.07,1.2-2.06-.07-5.6.17-8.11.52-.07.01-.1.01-.13.01Z"
            />
          </g>
        </g>
        <g id="_x36_7周南_xFF1A_紫" v-if="this.clickedPointId === 67">
          <circle class="st71" cx="68.18" cy="168.94" r="4" />
        </g>
        <g id="_x36_6光_xFF1A_橙" v-if="this.arrivedPointIdList.includes(66)">
          <path
            class="st267"
            d="M88.81,185.49c6.13,2.32,16.85,2.94,21.96-1.62"
          />
          <circle class="st19" cx="88.81" cy="185.49" r="4" />
        </g>
        <g id="_x36_6光_xFF1A_紫" v-if="this.clickedPointId === 66">
          <circle class="st70" cx="88.81" cy="185.49" r="4" />
        </g>
        <g
          id="_x36_5柳井_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(65)"
        >
          <path
            class="st268"
            d="M110.77,183.87c-.96-2.38-1.94-10.16-1.71-16.83"
          />
          <circle class="st20" cx="110.77" cy="183.87" r="4" />
        </g>
        <g id="_x36_5柳井_xFF1A_紫" v-if="this.clickedPointId === 65">
          <circle class="st69" cx="110.77" cy="183.87" r="4" />
        </g>
        <g
          id="_x36_4岩国2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(64)"
        >
          <path
            class="st265"
            d="M109.06,167.04c1.22-5.78,7.05-13.11,11.6-14.61"
          />
          <circle class="st24" cx="109.06" cy="167.04" r="4" />
        </g>
        <g id="_x36_4岩国2_xFF1A_紫" v-if="this.clickedPointId === 64">
          <circle class="st67" cx="109.06" cy="167.04" r="4" />
        </g>
        <g
          id="_x36_3岩国1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(63)"
        >
          <path
            class="st264"
            d="M120.75,152.35c-.49-9.59,11.52-21.8,17.97-21.8"
          />
          <circle class="st17" cx="120.75" cy="152.35" r="4" />
        </g>
        <g id="_x36_3岩国1_xFF1A_紫" v-if="this.clickedPointId === 63">
          <circle class="st68" cx="120.75" cy="152.35" r="4" />
        </g>
        <g
          id="_x36_2廿日市_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(62)"
        >
          <path
            class="st260"
            d="M138.72,130.55c-.84-4.34-.23-9.18,3.16-15.02"
          />
          <circle class="st31" cx="138.72" cy="130.55" r="4" />
        </g>
        <g id="_x36_2廿日市_xFF1A_紫" v-if="this.clickedPointId === 62">
          <circle class="st72" cx="138.72" cy="130.55" r="4" />
        </g>
        <g
          id="_x36_1広島2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(61)"
        >
          <path
            class="st262"
            d="M158.7,114.71c-7.48-1.45-11.54-1.12-16.83.82"
          />
          <circle class="st32" cx="141.88" cy="115.54" r="4" />
        </g>
        <g id="_x36_1広島2_xFF1A_紫" v-if="this.clickedPointId === 61">
          <circle class="st73" cx="141.88" cy="115.54" r="4" />
        </g>
        <g
          id="_x36_0広島1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(60)"
        >
          <path
            class="st258"
            d="M199.83,109.07c-27.83,2.13-35.4.42-41.12,5.64"
          />
          <circle class="st30" cx="158.7" cy="114.71" r="4" />
        </g>
        <g id="_x36_0広島1_xFF1A_紫" v-if="this.clickedPointId === 60">
          <circle class="st74" cx="158.7" cy="114.71" r="4" />
        </g>
        <g id="_x35_9西条_xFF1A_橙" v-if="this.arrivedPointIdList.includes(59)">
          <line class="st261" x1="222.26" y1="108.21" x2="199.83" y2="109.07" />
          <circle class="st28" cx="199.83" cy="109.07" r="4" />
        </g>
        <g id="_x35_9西条_xFF1A_紫" v-if="this.clickedPointId === 59">
          <circle class="st75" cx="199.83" cy="109.07" r="4" />
        </g>
        <g id="_x35_8三原_xFF1A_橙" v-if="this.arrivedPointIdList.includes(58)">
          <line class="st263" x1="237.75" y1="106.71" x2="222.26" y2="108.21" />
          <circle class="st29" cx="222.26" cy="108.25" r="4" />
        </g>
        <g id="_x35_8三原_xFF1A_紫" v-if="this.clickedPointId === 58">
          <circle class="st76" cx="222.26" cy="108.25" r="4" />
        </g>
        <g id="_x35_7三原_xFF1A_橙" v-if="this.arrivedPointIdList.includes(57)">
          <path
            class="st259"
            d="M259.76,111.54c-7.42-3.61-17.76-4.41-21.76-4.82"
          />
          <circle class="st15" cx="237.75" cy="106.71" r="4" />
        </g>
        <g id="_x35_7三原_xFF1A_紫" v-if="this.clickedPointId === 57">
          <circle class="st93" cx="237.75" cy="106.71" r="4" />
        </g>
        <g id="_x35_6尾道_xFF1A_橙" v-if="this.arrivedPointIdList.includes(56)">
          <path
            class="st270"
            d="M252.16,124.88c2.84-4.56,5.89-5.99,7.6-13.34"
          />
          <circle class="st12" cx="259.76" cy="111.54" r="4" />
        </g>
        <g id="_x35_6尾道_xFF1A_紫" v-if="this.clickedPointId === 56">
          <circle class="st99" cx="259.76" cy="111.54" r="4" />
        </g>
        <g id="_x35_5因島_xFF1A_橙" v-if="this.arrivedPointIdList.includes(55)">
          <path
            class="st275"
            d="M241.75,145.59c3.67-1.38,7.8-8.56,10.58-20.72"
          />
          <circle class="st13" cx="252.34" cy="124.88" r="4" />
        </g>
        <g id="_x35_5因島_xFF1A_紫" v-if="this.clickedPointId === 55">
          <circle class="st94" cx="252.34" cy="124.88" r="4" />
        </g>
        <g
          id="_x35_4今治2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(54)"
        >
          <path
            class="st269"
            d="M226.26,162.87c7.18-2.05,11.24-6.72,15.49-17.06"
          />
          <circle class="st14" cx="241.75" cy="145.81" r="4" />
        </g>
        <g id="_x35_4今治2_xFF1A_紫" v-if="this.clickedPointId === 54">
          <circle class="st78" cx="241.75" cy="145.81" r="4" />
        </g>
        <g
          id="_x35_3今治1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(53)"
        >
          <path
            class="st273"
            d="M247.94,192.17c-14.82-9.56-18.61-21.07-21.68-29.3"
          />
          <circle class="st22" cx="226.26" cy="162.87" r="4" />
        </g>
        <g id="_x35_3今治1_xFF1A_紫" v-if="this.clickedPointId === 53">
          <circle class="st80" cx="226.26" cy="162.87" r="4" />
        </g>
        <g id="_x35_2西条_xFF1A_橙" v-if="this.arrivedPointIdList.includes(52)">
          <path
            class="st274"
            d="M247.65,192.17c-14.19,11.75-24.6,17.93-28.6,17.52"
          />
          <circle class="st26" cx="247.65" cy="192.17" r="4" />
        </g>
        <g id="_x35_2西条_xFF1A_紫" v-if="this.clickedPointId === 52">
          <circle class="st79" cx="247.65" cy="192.17" r="4" />
        </g>
        <g
          id="_x35_1東温山_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(51)"
        >
          <path class="st276" d="M219.04,209.69c-12.16,2.3-14.83-1.15-18.1-4" />
          <circle class="st23" cx="219.04" cy="209.69" r="4" />
        </g>
        <g id="_x35_1東温山_xFF1A_紫" v-if="this.clickedPointId === 51">
          <circle class="st81" cx="219.04" cy="209.69" r="4" />
        </g>
        <g id="_x35_0松山_xFF1A_橙" v-if="this.arrivedPointIdList.includes(50)">
          <path
            class="st245"
            d="M189.91,223.54c5.86-5.05,8.37-8.93,11.03-17.85"
          />
          <circle class="st2" cx="200.94" cy="205.69" r="4" />
        </g>
        <g id="_x35_0松山_xFF1A_紫" v-if="this.clickedPointId === 50">
          <circle class="st90" cx="200.94" cy="205.69" r="4" />
        </g>
        <g
          id="_x34_9伊予2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(49)"
        >
          <path
            class="st244"
            d="M176.27,238.02c6.82-2.7,13.28-5.43,13.64-14.48"
          />
          <circle class="st1" cx="189.91" cy="223.54" r="4" />
        </g>
        <g id="_x34_9伊予2_xFF1A_紫" v-if="this.clickedPointId === 49">
          <circle class="st92" cx="189.91" cy="223.54" r="4" />
        </g>
        <g
          id="_x34_8伊予1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(48)"
        >
          <path
            class="st246"
            d="M184.6,256.63c1.31-8.03-4.34-18.19-8.34-18.61"
          />
          <circle class="st0" cx="176.27" cy="238.02" r="4" />
        </g>
        <g id="_x34_8伊予1_xFF1A_紫" v-if="this.clickedPointId === 48">
          <circle class="st91" cx="176.27" cy="238.02" r="4" />
        </g>
        <g id="_x34_7喜多_xFF1A_橙" v-if="this.arrivedPointIdList.includes(47)">
          <path
            class="st250"
            d="M168.27,287.93c-.27-21.4.95-30.78,16.34-31.3"
          />
          <circle class="st7" cx="184.6" cy="256.63" r="4" />
        </g>
        <g id="_x34_7喜多_xFF1A_紫" v-if="this.clickedPointId === 47">
          <circle class="st89" cx="184.6" cy="256.63" r="4" />
        </g>
        <g
          id="_x34_6南伊予_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(46)"
        >
          <line class="st248" x1="167.17" y1="301.83" x2="168.27" y2="287.93" />
          <circle class="st4" cx="168.27" cy="287.93" r="4" />
        </g>
        <g id="_x34_6南伊予_xFF1A_紫" v-if="this.clickedPointId === 46">
          <circle class="st88" cx="168.27" cy="287.93" r="4" />
        </g>
        <g
          id="_x34_5宇和島2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(45)"
        >
          <line class="st249" x1="179.33" y1="307.43" x2="167.39" y2="301.65" />
          <circle class="st8" cx="167.17" cy="301.83" r="4" />
        </g>
        <g id="_x34_5宇和島2_xFF1A_紫" v-if="this.clickedPointId === 45">
          <circle class="st87" cx="167.17" cy="301.83" r="4" />
        </g>
        <g
          id="_x34_4宇和島1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(44)"
        >
          <path
            class="st247"
            d="M157.24,334.71c13.93-2.28,19.31-12.5,22.09-27.28"
          />
          <circle class="st6" cx="179.33" cy="307.43" r="4" />
        </g>
        <g id="_x34_4宇和島1_xFF1A_紫" v-if="this.clickedPointId === 44">
          <circle class="st86" cx="179.33" cy="307.43" r="4" />
        </g>
        <g
          id="_x34_3南宇和2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(43)"
        >
          <path
            class="st257"
            d="M164.32,351.62c12.23-10.97,2.56-19.75-7.08-16.92"
          />
          <circle class="st9" cx="157.24" cy="334.71" r="4" />
        </g>
        <g id="_x34_3南宇和2_xFF1A_紫" v-if="this.clickedPointId === 43">
          <circle class="st98" cx="157.24" cy="334.71" r="4" />
        </g>
        <g
          id="_x34_2南宇和1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(42)"
        >
          <path
            class="st256"
            d="M195.93,354.6c-13.83-9.12-28.71-6.45-31.61-2.97"
          />
          <circle class="st16" cx="164.32" cy="351.62" r="4" />
        </g>
        <g id="_x34_2南宇和1_xFF1A_紫" v-if="this.clickedPointId === 42">
          <circle class="st85" cx="164.32" cy="351.62" r="4" />
        </g>
        <g id="_x34_1宿毛_xFF1A_橙" v-if="this.arrivedPointIdList.includes(41)">
          <path
            class="st255"
            d="M220.5,373.91c-10.06,2.07-22.45-9.09-24.56-19.32"
          />
          <circle class="st5" cx="195.93" cy="354.6" r="4" />
        </g>
        <g id="_x34_1宿毛_xFF1A_紫" v-if="this.clickedPointId === 41">
          <circle class="st97" cx="195.93" cy="354.6" r="4" />
        </g>
        <g id="_x34_0愛南_xFF1A_橙" v-if="this.arrivedPointIdList.includes(40)">
          <path
            class="st254"
            d="M220.5,373.91c-1.7-7.32-3.11-11.32-11.82-17.93"
          />
          <circle class="st10" cx="220.5" cy="373.91" r="4" />
        </g>
        <g id="_x34_0愛南_xFF1A_紫" v-if="this.clickedPointId === 40">
          <circle class="st83" cx="220.5" cy="373.91" r="4" />
        </g>
        <g id="_x33_9三原_xFF1A_橙" v-if="this.arrivedPointIdList.includes(39)">
          <path
            class="st253"
            d="M208.68,355.99c5.6-4.36,8.15-6.43,10.12-12.87"
          />
          <circle class="st3" cx="208.68" cy="355.99" r="4" />
        </g>
        <g id="_x33_9三原_xFF1A_紫" v-if="this.clickedPointId === 39">
          <circle class="st82" cx="208.68" cy="355.99" r="4" />
        </g>
        <g
          id="_x33_8四万十_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(38)"
        >
          <path class="st252" d="M218.8,343.12c7.31-2.08,11.36-2.52,16.7-8" />
          <circle class="st11" cx="218.8" cy="343.12" r="4" />
        </g>
        <g id="_x33_8四万十_xFF1A_紫" v-if="this.clickedPointId === 38">
          <circle class="st84" cx="218.8" cy="343.12" r="4" />
        </g>
        <g id="_x33_7黒潮_xFF1A_橙" v-if="this.arrivedPointIdList.includes(37)">
          <path
            class="st251"
            d="M235.5,334.87c8.16-2.44,13.72-7.89,15.47-28.24"
          />
          <circle class="st33" cx="235.5" cy="335.12" r="4" />
        </g>
        <g id="_x33_7黒潮_xFF1A_紫" v-if="this.clickedPointId === 37">
          <circle class="st95" cx="235.5" cy="335.12" r="4" />
        </g>
        <g id="_x33_6高岡_xFF1A_橙" v-if="this.arrivedPointIdList.includes(36)">
          <path
            class="st272"
            d="M250.97,306.63c1.86-6.82,9.41-35.81,30.22-31.81"
          />
          <circle class="st27" cx="250.97" cy="306.63" r="4" />
        </g>
        <g id="_x33_6高岡_xFF1A_紫" v-if="this.clickedPointId === 36">
          <circle class="st96" cx="250.97" cy="306.63" r="4" />
        </g>
        <g id="_x33_5須崎_xFF1A_橙" v-if="this.arrivedPointIdList.includes(35)">
          <path class="st271" d="M287.52,262.36c-4,4.23-4.75,9.01-6.33,12.46" />
          <circle class="st25" cx="281.19" cy="274.82" r="4" />
        </g>
        <g id="_x33_5須崎_xFF1A_紫" v-if="this.clickedPointId === 35">
          <circle class="st77" cx="281.19" cy="274.82" r="4" />
        </g>
        <g id="_x33_4土佐_xFF1A_橙" v-if="this.arrivedPointIdList.includes(34)">
          <path class="st266" d="M306.52,252.74c-9.47,2.8-14.16,5.62-19,9.67" />
          <circle class="st18" cx="287.52" cy="262.36" r="4" />
        </g>
        <g id="_x33_4土佐_xFF1A_紫" v-if="this.clickedPointId === 34">
          <circle class="st57" cx="287.52" cy="262.36" r="4" />
        </g>
        <g id="_x33_3高知_xFF1A_橙" v-if="this.arrivedPointIdList.includes(33)">
          <path class="st291" d="M325.78,249.65c-8.62-.5-13.9.56-19.26,3.09" />
          <circle class="st45" cx="306.52" cy="252.74" r="4" />
        </g>
        <g id="_x33_3高知_xFF1A_紫" v-if="this.clickedPointId === 33">
          <circle class="st60" cx="306.52" cy="252.74" r="4" />
        </g>
        <g id="_x33_2香南_xFF1A_橙" v-if="this.arrivedPointIdList.includes(32)">
          <path
            class="st278"
            d="M353.5,256.74c-8.89-4.31-19.89-6.48-27.72-7.09"
          />
          <circle class="st47" cx="325.78" cy="249.65" r="4" />
        </g>
        <g id="_x33_2香南_xFF1A_紫" v-if="this.clickedPointId === 32">
          <circle class="st58" cx="325.78" cy="249.65" r="4" />
        </g>
        <g id="_x33_1安芸_xFF1A_橙" v-if="this.arrivedPointIdList.includes(31)">
          <path
            class="st290"
            d="M373.58,271.63c-3.38-8.2-16.08-14.48-20.08-14.89"
          />
          <circle class="st46" cx="353.5" cy="256.74" r="4" />
        </g>
        <g id="_x33_1安芸_xFF1A_紫" v-if="this.clickedPointId === 31">
          <circle class="st59" cx="353.5" cy="256.74" r="4" />
        </g>
        <g id="_x33_0北川_xFF1A_橙" v-if="this.arrivedPointIdList.includes(30)">
          <path
            class="st277"
            d="M379.69,292.86c.58-6.04-1.75-13.1-6.11-21.23"
          />
          <circle class="st48" cx="373.58" cy="271.63" r="4" />
        </g>
        <g id="_x33_0北川_xFF1A_紫" v-if="this.clickedPointId === 30">
          <circle class="st54" cx="373.58" cy="271.63" r="4" />
        </g>
        <g
          id="_x32_9室戸2_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(29)"
        >
          <path
            class="st279"
            d="M379.69,292.86c11.89,5.18,12.62-4,11.35-10.04"
          />
          <circle class="st40" cx="379.69" cy="292.86" r="4" />
        </g>
        <g id="_x32_9室戸2_xFF1A_紫" v-if="this.clickedPointId === 29">
          <circle class="st53" cx="379.69" cy="292.86" r="4" />
        </g>
        <g
          id="_x32_8室戸1_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(28)"
        >
          <path class="st283" d="M391.04,282.82c4-6.06,7.51-14.9,8-21.61" />
          <circle class="st39" cx="391.04" cy="282.82" r="4" />
        </g>
        <g id="_x32_8室戸1_xFF1A_紫" v-if="this.clickedPointId === 28">
          <circle class="st55" cx="391.04" cy="282.82" r="4" />
        </g>
        <g id="_x32_7東洋_xFF1A_橙" v-if="this.arrivedPointIdList.includes(27)">
          <path
            class="st280"
            d="M408.75,251.23c-5.26,1.64-7.7,5.99-9.71,9.99"
          />
          <circle class="st41" cx="399.04" cy="261.22" r="4" />
        </g>
        <g id="_x32_7東洋_xFF1A_紫" v-if="this.clickedPointId === 27">
          <circle class="st52" cx="399.04" cy="261.22" r="4" />
        </g>
        <g id="_x32_6海陽_xFF1A_橙" v-if="this.arrivedPointIdList.includes(26)">
          <path
            class="st284"
            d="M425.77,238.15c-9.17-7.06-16.58,11.44-17.02,13.08"
          />
          <circle class="st42" cx="408.75" cy="251.23" r="4" />
        </g>
        <g id="_x32_6海陽_xFF1A_紫" v-if="this.clickedPointId === 26">
          <circle class="st51" cx="408.75" cy="251.23" r="4" />
        </g>
        <g id="_x32_5牟岐_xFF1A_橙" v-if="this.arrivedPointIdList.includes(25)">
          <path
            class="st282"
            d="M425.64,238.12c31.08-34.08,20.22-43.81,16.22-44.22"
          />
          <circle class="st44" cx="425.64" cy="238.12" r="4" />
        </g>
        <g id="_x32_5牟岐_xFF1A_紫" v-if="this.clickedPointId === 25">
          <circle class="st56" cx="425.64" cy="238.12" r="4" />
        </g>
        <g id="_x32_4阿南_xFF1A_橙" v-if="this.arrivedPointIdList.includes(24)">
          <path class="st281" d="M441.86,193.9c9.24-5.8,0-17.08-2.04-24" />
          <circle class="st43" cx="441.86" cy="193.9" r="4" />
        </g>
        <g id="_x32_4阿南_xFF1A_紫" v-if="this.clickedPointId === 24">
          <circle class="st62" cx="441.86" cy="193.9" r="4" />
        </g>
        <g id="_x32_3徳島_xFF1A_橙" v-if="this.arrivedPointIdList.includes(23)">
          <path
            class="st289"
            d="M439.83,169.9c-6.31-4.18-18.46-20.54-20.84-28"
          />
          <circle class="st36" cx="439.83" cy="169.9" r="4" />
        </g>
        <g id="_x32_3徳島_xFF1A_紫" v-if="this.clickedPointId === 23">
          <circle class="st63" cx="439.83" cy="169.9" r="4" />
        </g>
        <g
          id="_x32_2東かがわ_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(22)"
        >
          <path
            class="st288"
            d="M418.99,141.9c-12.43,1.06-23.45-8.27-26.76-11.66"
          />
          <circle class="st37" cx="418.99" cy="141.9" r="4" />
        </g>
        <g id="_x32_2東かがわ_xFF1A_紫" v-if="this.clickedPointId === 22">
          <circle class="st64" cx="418.99" cy="141.9" r="4" />
        </g>
        <g
          id="_x32_1さぬき_xFF1A_橙"
          v-if="this.arrivedPointIdList.includes(21)"
        >
          <path
            class="st287"
            d="M392.23,130.24c-6.78-5.22-8.85-5.65-12.85-6.07"
          />
          <circle class="st38" cx="392.23" cy="130.24" r="4" />
        </g>
        <g id="_x32_1さぬき_xFF1A_紫" v-if="this.clickedPointId === 21">
          <circle class="st61" cx="392.23" cy="130.24" r="4" />
        </g>
        <g id="_x32_0高松_xFF1A_橙" v-if="this.arrivedPointIdList.includes(20)">
          <path
            class="st285"
            d="M379.38,124.17c-13.49,10.28-27.93,12.95-31.93,12.53"
          />
          <circle class="st34" cx="379.38" cy="124.17" r="4" />
        </g>
        <g id="_x32_0高松_xFF1A_紫" v-if="this.clickedPointId === 20">
          <circle class="st65" cx="379.38" cy="124.17" r="4" />
        </g>
        <g id="_x31_9丸亀_xFF1A_橙" v-if="this.arrivedPointIdList.includes(19)">
          <path
            class="st286"
            d="M347.46,136.71c-2.75-5.63-3.39-9.28-3.69-16.52"
          />
          <circle class="st35" cx="347.46" cy="136.71" r="4" />
        </g>
        <g id="_x31_9丸亀_xFF1A_紫" v-if="this.clickedPointId === 19">
          <circle class="st66" cx="347.46" cy="136.71" r="4" />
        </g>
      </template>
      <g id="_第一のルート_x5F_緑" data-name="第一のルート_x5F_緑">
        <path
          class="st294"
          d="M522.6,141.9c6.25-4.73,15.11-11.84,27.73-34.66"
        />
        <path
          class="st296"
          d="M550.33,107.24c6.57-5.33,8.89-8.17,12.68-19.91"
        />
        <line class="st295" x1="558.77" y1="65.64" x2="545.47" y2="60.32" />
        <path class="st293" d="M545.47,60.32c-9.11-1.9-16.13,1.35-19.74,6.63" />
        <path
          class="st310"
          d="M525.74,66.95c-5.78,8.01-13.49,11.08-21.45,10.14"
        />
        <path
          class="st306"
          d="M504.29,77.09c-14.16-15.85-27.75-16.35-31.75-16.77"
        />
        <path class="st304" d="M472.54,60.32c-1.35-5.37-5.97-12.24-10.5-15.7" />
        <path class="st301" d="M462.05,44.62c-5.48,1.19-12.4,5.05-14.89,8" />
        <path
          class="st303"
          d="M447.16,52.62c-8.77-1.29-22.69,3.07-27.23,6.33"
        />
        <path class="st307" d="M419.96,58.9c-12.88-11.38-26.05-2.28-27.73.05" />
        <path class="st309" d="M389.92,77.09c-.9-5.12-.29-15.1,2.31-18.14" />
        <path
          class="st305"
          d="M389.92,77.09c-10.25-4.89-24.49-4.56-31.18-3.06"
        />
        <path
          class="st308"
          d="M358.73,74.03c-4.18,9.19-12.88,12.27-21.28,11.06"
        />
        <path
          class="st302"
          d="M339.76,105.23c-1.96-2.91-3.04-12.34-2.31-20.13"
        />
        <path
          class="st311"
          d="M343.69,120.02c-1.71-3.42-2.25-8.27-3.93-14.79"
        />
        <circle class="st179" cx="522.6" cy="141.9" r="4" />
        <circle class="st177" cx="550.33" cy="107.24" r="4" />
        <circle class="st184" cx="447.16" cy="52.62" r="4" />
        <circle class="st178" cx="419.93" cy="58.95" r="4" />
        <circle class="st181" cx="392.23" cy="58.95" r="4" />
        <circle class="st180" cx="389.92" cy="77.09" r="4" />
        <circle class="st185" cx="358.73" cy="74.03" r="4" />
        <circle class="st182" cx="337.45" cy="85.09" r="4" />
        <circle class="st183" cx="339.76" cy="105.23" r="4" />
        <circle class="st191" cx="343.76" cy="120.18" r="4" />
        <circle class="st194" cx="545.47" cy="60.32" r="4" />
        <circle class="st190" cx="525.76" cy="66.95" r="4" />
        <circle class="st189" cx="504.29" cy="77.09" r="4" />
        <circle class="st188" cx="472.54" cy="60.32" r="4" />
        <circle class="st192" cx="462.05" cy="44.62" r="4" />
        <line class="st312" x1="566.29" y1="74.56" x2="563.01" y2="87.33" />
        <path class="st313" d="M558.77,65.64" />
        <g>
          <line class="st292" x1="559.01" y1="65.94" x2="560.29" y2="67.48" />
          <line class="st340" x1="560.99" y1="68.33" x2="561" y2="68.34" />
          <line class="st49" x1="561" y1="68.34" x2="564.57" y2="72.65" />
          <line class="st292" x1="564.57" y1="72.65" x2="565.85" y2="74.19" />
        </g>
        <circle class="st187" cx="566.29" cy="74.56" r="4" />
        <circle class="st186" cx="558.77" cy="65.64" r="4" />
        <circle class="st193" cx="563.01" cy="87.33" r="4" />
      </g>
      <g id="_第一ゴール" data-name="第一ゴール" v-if="this.arrivedPointIdList.includes(18)">
        <g>
          <g>
            <path
              class="st348"
              d="M327.79,94.1c-.47,2.63-2.94,4.4-5.53,3.95-.2-.03.19.06,0,0-5.05,7.05-19.02,18.54-19.02,18.54l-1.91-3.86c2.39-2.77,14.17-13.42,17.52-17.23-.45-.9-.63-1.96-.45-3.04.46-2.63,2.94-4.4,5.53-3.95,2.59.45,4.31,2.96,3.85,5.59Z"
            />
            <path
              class="st346"
              d="M303.17,117.16s-.03,0-.05,0c-.17-.04-.32-.15-.39-.31l-1.91-3.86c-.1-.21-.07-.45.08-.63,1.15-1.33,4.39-4.41,7.82-7.68,3.73-3.55,7.59-7.22,9.46-9.28-.4-.96-.51-2-.33-3.03.52-2.94,3.3-4.92,6.2-4.41,1.41.25,2.63,1.03,3.44,2.22.81,1.18,1.12,2.61.87,4.04h0c-.5,2.82-3.07,4.75-5.84,4.46-5.18,7.04-18.35,17.9-18.92,18.37-.12.1-.28.15-.43.13ZM302.01,112.82l1.42,2.87c2.61-2.19,13.73-11.64,18.21-17.76,0,0,0,0,0,0,.06-.29.38-.48.67-.45.02,0,.03,0,.05,0,2.31.39,4.46-1.17,4.87-3.48h0c.2-1.13-.05-2.26-.69-3.19-.64-.93-1.6-1.55-2.7-1.74-2.27-.39-4.46,1.17-4.87,3.48-.16.92-.03,1.85.39,2.68.1.21.07.46-.08.63-1.79,2.03-5.85,5.89-9.77,9.63-3.18,3.03-6.2,5.9-7.5,7.32ZM327.79,94.1h0s0,0,0,0Z"
            />
          </g>
          <g>
            <path
              class="st348"
              d="M262.37,97.44c.69,2.58,3.31,4.08,5.85,3.37.19-.05-.18.08,0,0,5.63,6.5,20.53,16.52,20.53,16.52l1.57-4.04c-2.62-2.52-15.26-11.91-18.93-15.37.37-.94.46-2.01.18-3.07-.69-2.57-3.31-4.08-5.85-3.37-2.54.72-4.04,3.38-3.36,5.96Z"
            />
            <path
              class="st346"
              d="M288.68,117.9c-.09-.01-.17-.04-.25-.09-.6-.41-14.64-9.87-20.41-16.35-1.27.26-2.56.06-3.68-.58-1.25-.71-2.14-1.87-2.52-3.28-.77-2.87.92-5.86,3.75-6.66,1.37-.39,2.8-.21,4.04.49,1.25.71,2.14,1.88,2.52,3.28.27,1.01.24,2.06-.07,3.05,2.04,1.86,6.2,5.13,10.23,8.29,3.69,2.89,7.18,5.63,8.43,6.83.17.16.22.4.14.62l-1.57,4.04c-.06.16-.2.29-.36.34-.08.02-.16.03-.24.02ZM268.82,100.63c4.99,5.64,16.86,13.91,19.65,15.82l1.17-3.01c-1.41-1.28-4.65-3.82-8.07-6.5-4.24-3.32-8.62-6.76-10.58-8.61-.17-.16-.23-.41-.14-.63.35-.87.4-1.81.16-2.71-.29-1.1-1-2.02-1.98-2.58-.97-.55-2.09-.69-3.16-.38-2.24.63-3.56,2.99-2.96,5.26h0c.29,1.1,1,2.02,1.98,2.58.96.55,2.09.69,3.16.39.02,0,.03,0,.05-.01.29-.06.63.1.72.38,0,0,0,0,0,0Z"
            />
          </g>
          <g>
            <path
              class="st346"
              d="M307.38,152.84c-4.9-.61-6.75-7.88-6.96-8.77-.29-1.23.48-2.46,1.71-2.75,1.23-.29,2.46.47,2.75,1.7.53,2.23,2.08,5.38,3.27,5.27.63-.06,1.88-.95,3.16-6.2.16-.65.25-1.01.4-1.35.54-1.14,1.91-1.63,3.05-1.08,1.1.52,1.59,1.81,1.14,2.92-.04.13-.09.34-.15.59-.67,2.75-2.24,9.19-7.16,9.68-.43.04-.83.04-1.22-.01ZM315.9,142.61s-.03.07-.04.1c.01-.03.03-.06.04-.1Z"
            />
            <path
              class="st348"
              d="M307.57,151.61c-4.18-.52-5.87-7.5-5.94-7.82-.13-.57.22-1.13.78-1.26.57-.13,1.13.22,1.27.78.4,1.69,2.09,6.47,4.6,6.22,2.56-.25,3.78-5.26,4.24-7.14.15-.63.22-.9.32-1.11.25-.53.88-.75,1.4-.5.52.25.75.88.5,1.4-.02.06-.1.4-.18.7-.61,2.5-2.03,8.34-6.08,8.74-.32.03-.62.03-.91,0Z"
            />
          </g>
          <g>
            <path
              class="st348"
              d="M288.77,147.45l4.17,12.4s-2.11,1.05-1.65,1.71c.46.66,4.12-.09,4.47-.6.35-.52-1.58-13.85-1.58-13.85l-5.41.34Z"
            />
            <path
              class="st346"
              d="M291.8,162.36c-.48-.06-.79-.22-.98-.48-.16-.23-.21-.51-.14-.78.16-.63.96-1.19,1.56-1.53l-4.02-11.94c-.06-.17-.03-.35.07-.5.1-.15.26-.24.44-.25l5.41-.34c.29-.02.56.19.6.49,1.96,13.55,1.63,14.04,1.49,14.25-.49.72-2.96,1.11-3.91,1.12-.2,0-.37,0-.53-.03ZM291.91,161.24c.71.12,2.75-.26,3.33-.58.04-1.15-.73-7.3-1.54-12.94l-4.14.26,3.93,11.7c.09.27-.03.57-.29.7-.52.26-1.06.63-1.29.87ZM295.22,160.78h0Z"
            />
          </g>
          <g>
            <path
              class="st348"
              d="M307.9,146.47l-3.08,12.77s2.19.83,1.79,1.53c-.4.71-4.12.33-4.51-.14-.39-.48.38-13.95.38-13.95l5.41-.21Z"
            />
            <path
              class="st346"
              d="M303.6,161.65c-.86-.11-1.67-.32-1.95-.66-.16-.2-.53-.65.26-14.35.02-.29.25-.53.55-.54l5.41-.21c.18,0,.35.07.47.21.11.14.16.32.11.5l-2.97,12.3c.62.28,1.46.76,1.68,1.36.1.27.08.55-.06.8-.22.38-.7.59-1.52.66-.49.04-1.25.03-1.98-.06ZM302.6,160.3c.52.24,2.63.42,3.37.21-.25-.22-.82-.53-1.36-.74-.27-.1-.42-.39-.35-.67l2.91-12.04-4.14.16c-.32,5.74-.57,11.98-.42,13.07ZM306.15,160.43h0Z"
            />
          </g>
          <g>
            <path
              class="st348"
              d="M286.03,109.5s-2.66,29.97-.77,35.06c1.89,5.09,8.72,5.12,13.46,4.88,4.73-.24,12.41-2.2,11.88-8.86-.53-6.67-5.58-35.18-5.58-35.18l-18.99,4.1Z"
            />
            <path
              class="st346"
              d="M292.8,149.91c-3.34-.41-6.79-1.68-8.08-5.16-1.91-5.16.63-34.08.74-35.31.02-.25.2-.46.45-.51l18.99-4.1c.15-.03.31,0,.44.08.13.09.22.22.24.38.21,1.17,5.06,28.61,5.59,35.23.17,2.09-.41,3.9-1.71,5.39-3.02,3.44-8.96,4-10.71,4.09-1.44.07-3.66.19-5.94-.1ZM286.57,109.97c-.31,3.65-2.47,29.8-.77,34.39,1.65,4.47,7.45,4.78,12.89,4.5,1.64-.08,7.19-.6,9.91-3.7,1.09-1.24,1.57-2.77,1.43-4.54-.48-6.03-4.75-30.43-5.47-34.54l-17.99,3.88Z"
            />
          </g>
          <g>
            <path
              class="st351"
              d="M284.31,109.58s2.94,5.29,11.55,4.85c8.61-.44,12.17-7.75,12.17-7.75l-23.8,2.66"
            />
            <path
              class="st346"
              d="M292.64,114.78c-6.31-.78-8.61-4.78-8.72-4.97-.04-.07-.06-.14-.06-.22-.04-.06-.06-.12-.07-.2-.03-.24.15-.47.39-.49l23.8-2.66c.16-.02.32.05.41.19.09.13.11.31.04.45-.04.08-3.78,7.55-12.55,8-1.18.06-2.26.02-3.24-.11ZM284.92,109.71c.81,1.14,3.89,4.64,10.91,4.28,6.62-.34,10.2-4.94,11.37-6.76l-22.28,2.49Z"
            />
          </g>
          <g>
            <polygon
              class="st348"
              points="286.27 83.47 278.5 76.24 277.99 88.71 286.27 83.47"
            />
            <path
              class="st346"
              d="M277.92,89.28c-.07,0-.15-.03-.22-.07-.18-.11-.29-.31-.29-.52l.51-12.47c0-.22.15-.42.35-.51.21-.08.44-.04.61.11l7.77,7.23c.13.12.2.3.18.47-.02.18-.11.34-.26.43l-8.28,5.24c-.11.07-.25.1-.38.08ZM279.02,77.51l-.41,10.13,6.73-4.26-6.31-5.88Z"
            />
          </g>
          <g>
            <polygon
              class="st348"
              points="303.54 82.59 310.66 74.59 312.24 86.96 303.54 82.59"
            />
            <path
              class="st346"
              d="M312.17,87.52c-.06,0-.13-.03-.19-.06l-8.69-4.37c-.16-.08-.27-.23-.31-.4-.03-.18.02-.36.13-.49l7.11-7.99c.15-.17.38-.23.6-.17.21.07.37.25.4.47l1.58,12.36c.03.21-.06.42-.24.54-.12.08-.26.12-.4.1ZM304.47,82.41l7.07,3.55-1.29-10.05-5.78,6.5Z"
            />
          </g>
          <g>
            <path
              class="st348"
              d="M294.98,79.77c-13.65.7-20.95,10.01-20.59,18.31.58,13.48,15.63,13.71,23.25,13.32,7.62-.39,19.53-4.37,18.92-18.47-.34-7.86-9.65-13.77-21.58-13.15Z"
            />
            <path
              class="st346"
              d="M288.78,111.75c-4.79-.59-8.4-2.03-10.92-4.32-2.52-2.29-3.88-5.42-4.04-9.31-.19-4.43,1.71-8.97,5.21-12.44,2.75-2.72,7.74-6.05,15.92-6.47,7.28-.37,13.85,1.6,18.04,5.41,2.58,2.35,4.01,5.22,4.15,8.29.28,6.47-1.95,11.47-6.61,14.87-4.73,3.44-10.57,4.09-12.86,4.2-3.32.17-6.28.1-8.88-.23ZM295.01,80.34c-10.21.52-20.5,7.29-20.05,17.72.15,3.57,1.39,6.44,3.67,8.51,3.66,3.33,9.87,4.72,18.98,4.25,3.19-.16,19.07-1.79,18.38-17.88-.12-2.77-1.42-5.36-3.77-7.5-3.9-3.55-10.34-5.46-17.21-5.11h0ZM294.98,79.77h0s0,0,0,0Z"
            />
          </g>
          <g>
            <path
              class="st346"
              d="M293.19,95.75c.05.76.69,1.33,1.44,1.28l1.84-.13c.75-.05,1.32-.71,1.27-1.47h0c-.05-.76-.69-1.33-1.44-1.28l-1.84.13c-.74.05-1.31.71-1.27,1.47h0Z"
            />
            <path
              class="st346"
              d="M294.31,97.46c-.35-.04-.68-.19-.96-.43-.37-.32-.58-.77-.61-1.25h0c-.06-1,.69-1.87,1.68-1.94l1.84-.13c.48-.03.94.12,1.3.44.37.32.58.76.61,1.25.06,1-.69,1.87-1.68,1.94l-1.84.13c-.12,0-.23,0-.34,0ZM296.5,94.6c-.06,0-.12,0-.18,0l-1.84.13c-.5.04-.88.48-.85.99h0c.02.25.13.48.31.64.18.16.41.24.65.22l1.84-.13c.5-.04.89-.48.86-1-.02-.25-.13-.48-.31-.64-.14-.12-.3-.19-.48-.22Z"
            />
          </g>
          <g>
            <path
              class="st346"
              d="M288.96,93.77c.06,1.31-.59,2.41-1.44,2.45-.85.04-1.58-.98-1.64-2.29-.06-1.31.58-2.41,1.43-2.45.85-.04,1.58.98,1.64,2.29Z"
            />
            <path
              class="st346"
              d="M287.29,96.65c-.33-.04-.64-.19-.91-.44-.55-.5-.9-1.34-.93-2.27-.07-1.58.75-2.86,1.86-2.92.42-.02.82.14,1.17.45.54.5.89,1.34.93,2.27h0c.07,1.58-.75,2.86-1.86,2.91-.09,0-.17,0-.26,0ZM287.44,91.92s-.07,0-.1,0c-.52.03-1.06.85-1.01,1.99.03.68.28,1.31.64,1.64.17.16.35.23.53.22.52-.03,1.06-.85,1.01-1.98-.03-.68-.28-1.31-.64-1.64-.14-.13-.28-.2-.43-.22Z"
            />
          </g>
          <path
            class="st346"
            d="M291.75,101.48c-.8-.1-1.4-.41-1.77-.94-.73-1.02-.28-2.41-.26-2.47.08-.23.33-.36.56-.28.23.08.36.33.29.56,0,.01-.32,1.03.14,1.67.28.39.82.59,1.59.6.65,0,1.16-.19,1.55-.6.97-1.01.89-2.94.89-2.96-.01-.24.17-.44.41-.46.24-.02.45.15.48.39,0,.03.36,2.63,2.5,3.25,2.06.59,3.04-1.26,3.08-1.34.11-.22.38-.31.6-.2.22.11.31.38.2.6-.46.9-1.9,2.43-4.13,1.8-1.28-.37-2.04-1.25-2.5-2.09-.17.57-.44,1.17-.89,1.64-.57.59-1.31.88-2.2.87-.19,0-.37-.01-.54-.03Z"
          />
          <path
            class="st346"
            d="M295.65,105.6c-2.32-.29-3.53-4.02-3.59-4.2-.07-.23.05-.49.29-.56.24-.08.49.05.56.29.01.04,1.36,4.08,3.42,3.54,2.2-.57,2.48-3.57,2.48-3.61.02-.25.24-.43.48-.41.23,0,.43.24.41.48-.01.15-.35,3.67-3.15,4.39-.32.08-.62.1-.91.06Z"
          />
          <path
            class="st346"
            d="M305.18,94.21c-.09-.01-.18-.05-.25-.12-.4-.38-2.45-.6-4.12-.58-.19,0-.37-.12-.43-.31s0-.39.16-.5l3.81-2.74c.2-.14.48-.1.62.1s.1.48-.1.62l-2.72,1.95c1.21.06,2.82.25,3.39.8.18.17.18.45.01.63-.1.11-.24.15-.38.13Z"
          />
          <path
            class="st346"
            d="M300.68,87.53c-.06,0-.12-.03-.18-.06-.21-.13-.27-.4-.15-.61.04-.07,1.06-1.7,2.63-1.79.95-.06,1.86.45,2.7,1.51.15.19.12.47-.07.63-.19.15-.47.12-.63-.07-.65-.82-1.3-1.22-1.94-1.18-1.1.06-1.91,1.36-1.92,1.37-.09.15-.27.23-.43.21Z"
          />
          <path
            class="st346"
            d="M284.43,88.36c-.06,0-.12-.03-.18-.06-.21-.13-.28-.4-.15-.61.04-.07,1.06-1.7,2.63-1.79.95-.06,1.86.45,2.7,1.51.15.19.12.47-.07.63-.19.15-.47.12-.63-.07-.65-.82-1.3-1.22-1.94-1.18-1.09.06-1.91,1.36-1.92,1.37-.09.15-.27.23-.44.21Z"
          />
          <g>
            <g>
              <path
                class="st352"
                d="M299.89,116.15c.08,1.96-1.42,3.64-3.35,3.73-1.93.1-3.57-1.41-3.66-3.38-.09-1.96,1.42-3.64,3.35-3.74,1.93-.1,3.57,1.41,3.66,3.38Z"
              />
              <path
                class="st346"
                d="M295.87,120.31c-.79-.1-1.54-.44-2.14-.99-.79-.72-1.25-1.71-1.3-2.79-.1-2.2,1.6-4.09,3.77-4.2,1.05-.05,2.05.31,2.83,1.01.79.72,1.25,1.71,1.3,2.79h0c.09,2.2-1.6,4.09-3.78,4.2-.23.01-.46,0-.69-.02ZM296.78,113.24c-.17-.02-.35-.03-.53-.02-1.69.09-3,1.55-2.93,3.27.04.84.39,1.61,1.01,2.17.6.55,1.38.82,2.18.78,1.69-.09,3-1.55,2.93-3.27-.04-.84-.4-1.61-1.01-2.17-.47-.43-1.04-.69-1.65-.76Z"
              />
            </g>
            <g>
              <path
                class="st352"
                d="M300.91,115.86c.02.47-.34.86-.79.89l-7.43.38c-.46.02-.84-.33-.86-.8h0c-.02-.47.33-.86.79-.89l7.43-.38c.46-.02.85.34.87.8h0Z"
              />
              <path
                class="st346"
                d="M292.49,117.56c-.26-.03-.5-.14-.69-.32-.25-.23-.4-.55-.42-.9-.03-.71.51-1.31,1.21-1.35l7.43-.38c.34-.02.67.1.92.33.25.23.4.55.42.9.03.71-.52,1.31-1.22,1.35l-7.43.38c-.07,0-.15,0-.22,0ZM300.13,115.51s-.04,0-.06,0l-7.43.38c-.21.01-.38.2-.37.42,0,.11.05.21.13.28.07.07.17.1.27.1l7.43-.38c.21-.01.38-.2.37-.42,0,0,0,0,0,0,0-.11-.05-.2-.13-.27-.06-.05-.13-.09-.21-.1Z"
              />
            </g>
            <g>
              <path
                class="st346"
                d="M297.44,118.85c.02.53-.38.98-.91,1.01-.52.03-.96-.38-.99-.91-.02-.53.38-.98.91-1.01.52-.03.96.38.99.91Z"
              />
              <path
                class="st346"
                d="M296.31,120.3c-.28-.04-.55-.16-.76-.35-.28-.25-.44-.6-.45-.98-.03-.77.56-1.43,1.33-1.47.38-.02.73.11,1,.36.28.25.44.6.45.98.03.77-.56,1.43-1.33,1.47-.08,0-.16,0-.24,0ZM296.56,118.39s-.06,0-.09,0c-.28.02-.49.26-.48.55,0,.14.06.26.16.35.1.09.22.14.36.13.28-.01.49-.26.48-.54h0c0-.14-.06-.27-.17-.36-.08-.07-.17-.11-.27-.12Z"
              />
            </g>
          </g>
        </g>
        <polygon
          class="st349"
          points="260.95 138.41 254.5 168.56 274.57 184.88 338.19 167.93 336.83 134.24 305.59 117.56 260.95 138.41"
        />
        <g>
          <path
            class="st348"
            d="M281.38,164.73c-.05-.39-.21-.7-.47-.89-.27-.2-.62-.26-1.04-.17-1.03.2-5.13,1.98-6.57,2.91-.5.33-.78.82-.75,1.32.02.37.21.69.52.84.19.09.58.2,1.1-.15,1.75-1.18,3.65-2.15,4.86-2.64-.44,1.6-1.76,4.9-4.1,6.13-1.06.56-2.01.72-2.8.47-.86-.27-1.38-.97-1.66-1.5-1.01-1.95-1.05-4.45-.1-6.87,1.04-2.66,3.09-4.71,5.62-5.63.25-.09.6-.16.85.02.23.17.35.55.33,1.06-.02.4.16.74.48.93.34.2.78.19,1.12-.02.4-.24.61-.72.58-1.3-.02-.34-.1-.74-.24-1.11-.29-.77-.78-1.27-1.41-1.43-.78-.22-1.75-.13-2.79.26-.62.23-1.26.58-1.85.99-4.77,3.32-6.67,8.6-4.83,13.44.13.35.29.71.46,1.05.64,1.25,2.04,2.31,3.87,2.31.61,0,1.27-.12,1.96-.38.35-.13.71-.31,1.07-.52,2.38-1.38,3.68-3.64,4.37-5.45-.04.75-.1,1.52-.17,2.32-.06.63.21.92.37,1.03.26.19.64.2.98.03.41-.2.68-.6.71-1.05.08-1.42-.28-4.45-.43-5.74l-.03-.25Z"
          />
          <path
            class="st348"
            d="M295.78,154.88c-1.13-2.96-3.55-4.12-6.64-3.16-.18.05-.33.1-.5.17l-.05.02c-5.32,2.02-7.16,8.34-5.49,12.74.19.49.4.94.64,1.33.43.73,1.83,2.67,4.57,2.67.77,0,1.64-.15,2.62-.53,3.41-1.3,5.78-5.61,5.5-10.03-.08-1.2-.3-2.28-.65-3.21ZM290.22,166.33c-2.09.91-3.94.12-5.06-2.17-.91-1.9-.92-4.38-.03-6.46.87-2.01,2.47-3.48,4.52-4.13,1.18-.37,2.17-.29,2.94.26,1.07.76,1.71,2.39,1.79,4.6.13,3.33-1.74,6.88-4.16,7.91Z"
          />
          <path
            class="st348"
            d="M312.69,158.55l-.03-.08c-1.15-2.57-6.42-10.47-7.98-12.14-.29-.33-.8-.42-1.27-.25-.28.11-.78.4-1.03,1.21-1.11,3.5-3.14,12.77-3.63,16.17-.04.26-.03.5.05.7.14.36.46.58.86.58.04,0,.07,0,.11,0,.5-.05,1.1-.46,1.24-1.26.11-.74.25-1.47.41-2.3.08-.42.17-.86.26-1.34,2.47-1.43,5.89-2.86,7.33-3.36.61,1.09,1.13,2.1,1.54,2.99.36.76.99.87,1.49.7.54-.2.95-.89.66-1.63,0,0,0,0,0,0ZM307.93,154.67c-1.27.47-3.83,1.58-5.94,2.69.1-.45.2-.92.3-1.4.54-2.54,1.15-5.4,1.68-7.24,1.11,1.42,2.64,3.73,3.96,5.96Z"
          />
          <path
            class="st348"
            d="M323.73,152.73c-1.76.65-5.4,2.25-7.81,3.43-.76-3.53-1.63-10.46-1.7-12.9-.02-.48-.23-.72-.4-.84-.25-.17-.58-.19-.91-.06-.44.17-.87.63-.82,1.3.13,1.94,1.43,10.26,1.95,13.45-.59.38-.72.91-.57,1.3.14.36.48.64.88.64.1,0,.21-.02.32-.06,0,0,0,0,0,0,.04-.02.06-.02.17-.09,2.38-1.38,7.27-3.51,9.41-4.26.38-.13.67-.38.81-.69.12-.25.13-.52.04-.77-.16-.43-.65-.74-1.38-.46Z"
          />
          <path
            class="st348"
            d="M330.46,151.25c-.13-.13-.77-.67-1.04-.85-.53-.33-1.14-.3-1.61.09-.44.36-.61.94-.43,1.43.06.16.19.39.47.59l.11.08c.19.14.7.52.8.62.25.23.55.35.86.35.15,0,.31-.03.46-.09.41-.16.73-.51.82-.92.1-.44-.06-.9-.44-1.29Z"
          />
          <path
            class="st348"
            d="M328.05,149.27c.26,0,.53-.1.74-.28.34-.3.48-.76.38-1.26-.73-3.55-.75-5.89-.53-9.79,0-.11,0-.22-.01-.29,0-.09-.03-.16-.05-.22-.1-.26-.3-.45-.56-.54-.23-.08-.5-.06-.75.03-.5.19-.84.67-.89,1.26-.12,1.63-.13,5.58.62,10.1h0c.08.46.33.79.7.93.11.04.23.06.35.06Z"
          />
        </g>
        <g>
          <path
            class="st348"
            d="M283.53,147.29c-.07-.18-.03-.41.18-.63.94-.97,2.1-2.29,2.93-3.42-.77.45-1.42.83-2.18,1.29-.83.5-1.27-.24-1.22-.8.04-.41.1-.79.15-1.27-.19-.18-.16-.65.15-.82.85-.48,2.21-1.16,3.5-1.78-.05-.48-.08-.92-.11-1.24-.91.46-1.85.97-2.75,1.5-.65.38-.93-.61-.32-.95.32-.18.68-.37,1.05-.57l-.04-.06c-.15-.22-.38-.61-.65-.91l-.05-.06c-.39.2-.79.42-1.25.67-.03.51-.08,1.05-.19,1.52-.19.77-1.15.53-.94-.25.21-.77.25-1.51.26-2.27,0-.75.91-.75.89-.12v.17c1.18-.63,2.23-1.17,2.96-1.44.63-.24.79.61.23.83-.39.15-.78.32-1.18.51.25.26.5.59.63.8.05.08.08.17.08.24,1.29-.65,2.7-1.3,3.69-1.71l-.02-.05c-.07-.25-.17-.69-.32-1.01-.43.22-.87.46-1.34.73-.02.23-.06.46-.09.69-.12.83-1.13.66-.91-.18.15-.57.17-.81.17-1.57,0-.31.15-.48.33-.55.26-.1.58.06.57.43,0,.06,0,.13,0,.2,1.25-.68,2.54-1.31,3.29-1.59.29-.11.48.01.55.19.08.21-.01.52-.32.63-.46.17-.94.38-1.47.63.17.36.35.83.41,1.09,0,.01,0,.02,0,.06.4-.02.7.34.75.72.04.34-.02,1.27-.04,1.85-.03.51-.53.7-.76.56-.55.23-1.33.59-2.17,1.01.04.4.09.82.14,1.24,1.5-.77,2.86-1.42,3.43-1.61.51-.17.85.13.98.68.22.99.38,2.42.38,3.15,0,.3-.19.55-.5.67-.06.02-.13.04-.2.05-.38.07-1.24.2-1.64.2-.7-.01-.72-.96.03-.95.49,0,1.05-.06,1.47-.13-.06-.94-.26-2.1-.41-2.78-.65.26-1.94.89-3.41,1.61.16,1.21.32,2.32.44,2.89.12.58-.85.91-.95.25-.09-.59-.2-1.35-.29-2.17-.9,1.3-1.95,2.7-2.93,3.88-.37.45-.84.29-.97-.04ZM287.26,142.02c-.05-.42-.09-.85-.13-1.25-.98.48-1.99,1-2.78,1.45-.08.49-.19,1.08-.22,1.46.89-.47,2.02-1.07,3.14-1.66ZM287.74,138.21l.12,1.25c.91-.43,1.72-.81,2.21-1.03.03-.46.02-.96.02-1.25-.66.25-1.48.61-2.35,1.04Z"
          />
          <path
            class="st348"
            d="M298.26,141.78c-.26.1-.49-.04-.57-.26v-.02c-.07-.22.02-.5.4-.69.46-.24,1.48-.72,2.5-1.19-.4-2.95-.66-6.68-.66-7.73-.32.58-2.11,2.91-2.77,3.55-.53.52-1.38-.18-.64-.93.79-.8,1.76-1.97,2.43-2.91.33-.45.69-1.08.95-1.3.07-.05.13-.1.21-.13.29-.11.63,0,.78.39l.02.06c.03.12.05.26.05.43,0,1.61.13,4.81.62,8.11.63-.29,1.19-.53,1.48-.65.74-.3.9.67.23.93-.76.28-3.92,1.69-4.93,2.29-.05.03-.07.04-.09.05Z"
          />
        </g>
        <polygon
          class="st349"
          points="318.63 127.69 337.22 121.74 328.18 133.79 318.63 127.69"
        />
      </g>
      <g
        id="_x31_8坂出_xFF1A_赤ゴールのコピー"
        v-if="this.arrivedPointIdList.includes(18)"
      >
        <path
          class="st329"
          d="M343.69,120.02c-1.71-3.42-2.25-8.27-3.93-14.79"
        />
        <circle class="st165" cx="343.76" cy="120.18" r="4" />
      </g>
      <g id="_x31_8坂出_xFF1A_青" v-if="this.clickedPointId === 18">
        <circle class="st140" cx="343.76" cy="120.18" r="4" />
      </g>
      <g id="_x31_7児島_xFF1A_赤" v-if="this.arrivedPointIdList.includes(17)">
        <path
          class="st326"
          d="M339.76,105.23c-1.96-2.91-3.04-12.34-2.31-20.13"
        />
        <circle class="st166" cx="339.76" cy="105.23" r="4" />
      </g>
      <g id="_x31_7児島_xFF1A_青" v-if="this.clickedPointId === 17">
        <circle class="st142" cx="339.76" cy="105.23" r="4" />
      </g>
      <g id="_x31_6倉敷_xFF1A_赤" v-if="this.arrivedPointIdList.includes(16)">
        <path
          class="st330"
          d="M358.73,74.03c-4.18,9.19-12.88,12.27-21.28,11.06"
        />
        <circle class="st167" cx="337.45" cy="85.09" r="4" />
      </g>
      <g id="_x31_6倉敷_xFF1A_青" v-if="this.clickedPointId === 16">
        <circle class="st143" cx="337.45" cy="85.09" r="4" />
      </g>
      <g id="_x31_5岡山_xFF1A_赤" v-if="this.arrivedPointIdList.includes(15)">
        <path
          class="st325"
          d="M389.92,77.09c-10.25-4.89-24.49-4.56-31.18-3.06"
        />
        <circle class="st170" cx="358.73" cy="74.03" r="4" />
      </g>
      <g id="_x31_5岡山_xFF1A_青" v-if="this.clickedPointId === 15">
        <circle class="st154" cx="358.73" cy="74.03" r="4" />
      </g>
      <g id="_x31_4瀬戸内_xFF1A_赤" v-if="this.arrivedPointIdList.includes(14)">
        <path class="st324" d="M389.92,77.09c-.9-5.12-.29-15.1,2.31-18.14" />
        <circle class="st169" cx="389.92" cy="77.09" r="4" />
      </g>
      <g id="_x31_4瀬戸内_xFF1A_青" v-if="this.clickedPointId === 14">
        <circle class="st153" cx="389.92" cy="77.09" r="4" />
      </g>
      <g id="_x31_3備前_xFF1A_赤" v-if="this.arrivedPointIdList.includes(13)">
        <path class="st327" d="M419.96,58.9c-12.88-11.38-26.05-2.28-27.73.05" />
        <circle class="st168" cx="392.23" cy="58.95" r="4" />
      </g>
      <g id="_x31_3備前_xFF1A_青" v-if="this.clickedPointId === 13">
        <circle class="st141" cx="392.23" cy="58.95" r="4" />
      </g>
      <g id="_x31_2赤穂_xFF1A_赤" v-if="this.arrivedPointIdList.includes(12)">
        <path
          class="st328"
          d="M447.16,52.62c-8.77-1.29-22.69,3.07-27.23,6.33"
        />
        <circle class="st163" cx="419.93" cy="58.95" r="4" />
      </g>
      <g id="_x31_2赤穂_xFF1A_青" v-if="this.clickedPointId === 12">
        <circle class="st145" cx="419.93" cy="58.95" r="4" />
      </g>
      <g id="_x31_1姫路2_xFF1A_赤" v-if="this.arrivedPointIdList.includes(11)">
        <path class="st316" d="M462.05,44.62c-5.48,1.19-12.4,5.05-14.89,8" />
        <circle class="st164" cx="447.16" cy="52.62" r="4" />
      </g>
      <g id="_x31_1姫路2_xFF1A_青" v-if="this.clickedPointId === 11">
        <circle class="st146" cx="447.16" cy="52.62" r="4" />
      </g>
      <g id="_x31_0姫路1_xFF1A_赤" v-if="this.arrivedPointIdList.includes(10)">
        <path class="st315" d="M472.54,60.32c-1.35-5.37-5.97-12.24-10.5-15.7" />
        <circle class="st162" cx="462.05" cy="44.62" r="4" />
      </g>
      <g id="_x31_0姫路1_xFF1A_青" v-if="this.clickedPointId === 10">
        <circle class="st144" cx="462.05" cy="44.62" r="4" />
      </g>
      <g id="_x30_9高砂_xFF1A_赤" v-if="this.arrivedPointIdList.includes(9)">
        <path
          class="st320"
          d="M504.29,77.09c-14.16-15.85-27.75-16.35-31.75-16.77"
        />
        <circle class="st175" cx="472.54" cy="60.32" r="4" />
      </g>
      <g id="_x30_9高砂_xFF1A_青" v-if="this.clickedPointId === 9">
        <circle class="st149" cx="472.54" cy="60.32" r="4" />
      </g>
      <g id="_x30_8明石_xFF1A_赤" v-if="this.arrivedPointIdList.includes(8)">
        <path
          class="st321"
          d="M525.74,66.95c-5.78,8.01-13.49,11.08-21.45,10.14"
        />
        <circle class="st174" cx="504.29" cy="77.09" r="4" />
      </g>
      <g id="_x30_8明石_xFF1A_青" v-if="this.clickedPointId === 8">
        <circle class="st148" cx="504.29" cy="77.09" r="4" />
      </g>
      <g id="_x30_7三宮_xFF1A_赤" v-if="this.arrivedPointIdList.includes(7)">
        <path class="st318" d="M545.47,60.32c-9.11-1.9-16.13,1.35-19.74,6.63" />
        <circle class="st172" cx="525.76" cy="66.95" r="4" />
      </g>
      <g id="_x30_7三宮_xFF1A_青" v-if="this.clickedPointId === 7">
        <circle class="st147" cx="525.76" cy="66.95" r="4" />
      </g>
      <g id="_x30_6尼崎_xFF1A_赤" v-if="this.arrivedPointIdList.includes(6)">
        <line class="st319" x1="558.77" y1="65.64" x2="545.47" y2="60.32" />
        <circle class="st173" cx="545.47" cy="60.32" r="4" />
      </g>
      <g id="_x30_6尼崎_xFF1A_青" v-if="this.clickedPointId === 6">
        <circle class="st151" cx="545.47" cy="60.32" r="4" />
        <path class="st297" d="M558.77,65.64" />
      </g>
      <g id="_x30_5大阪2_xFF1A_赤" v-if="this.arrivedPointIdList.includes(5)">
        <line class="st158" x1="559.01" y1="65.94" x2="565.85" y2="74.19" />
        <path class="st299" d="M558.77,65.64" />
        <circle class="st171" cx="558.77" cy="65.64" r="4" />
      </g>
      <g id="_x30_5大阪2_xFF1A_青" v-if="this.clickedPointId === 5">
        <path class="st298" d="M558.77,65.64" />
        <circle class="st152" cx="558.77" cy="65.64" r="4" />
      </g>
      <g id="_x30_4大阪1_xFF1A_赤" v-if="this.arrivedPointIdList.includes(4)">
        <line class="st317" x1="566.29" y1="74.56" x2="563.01" y2="87.33" />
        <path class="st300" d="M558.77,65.64" />
        <circle class="st176" cx="566.29" cy="74.56" r="4" />
      </g>
      <g id="_x30_4大阪1_xFF1A_青" v-if="this.clickedPointId === 4">
        <circle class="st150" cx="566.29" cy="74.56" r="4" />
      </g>
      <g id="_x30_3堺_xFF1A_赤" v-if="this.arrivedPointIdList.includes(3)">
        <path
          class="st322"
          d="M550.33,107.24c6.57-5.33,8.89-8.17,12.68-19.91"
        />
        <path class="st314" d="M558.77,65.64" />
        <circle class="st160" cx="563.01" cy="87.33" r="4" />
      </g>
      <g id="_x30_3堺_xFF1A_青" v-if="this.clickedPointId === 3">
        <circle class="st157" cx="563.01" cy="87.33" r="4" />
      </g>
      <g id="_x30_2岸和田_xFF1A_赤" v-if="this.arrivedPointIdList.includes(2)">
        <path
          class="st323"
          d="M522.6,141.9c6.25-4.73,15.11-11.84,27.73-34.66"
        />
        <circle class="st159" cx="550.33" cy="107.24" r="4" />
      </g>
      <g id="_x30_2岸和田_xFF1A_青" v-if="this.clickedPointId === 2">
        <circle class="st155" cx="550.33" cy="107.24" r="4" />
      </g>
      <g id="_x30_1和歌山_xFF1A_赤" v-if="this.arrivedPointIdList.includes(1)">
        <circle class="st161" cx="522.6" cy="141.9" r="4" />
      </g>
      <g id="_x30_1和歌山_xFF1A_青" v-if="this.clickedPointId === 1">
        <circle class="st156" cx="522.6" cy="141.9" r="4" />
      </g>
    </svg>

    <span v-if="isDetail">これまでの到達地点をクリックすると、各地点のトピックを見ることができます。</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 608 868.3"
      style="enable-background: new 0 0 608 868.3"
      xml:space="preserve"
      v-if="isDetail"
    >
      <template v-if="isSecondGoalEnabled">
        <g id="_x36_7周南_xFF1A_橙">
          <a @click="sendPointId(67)">
            <g>
              <path
                class="pn_st67"
                d="M399.5,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M399.5,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M406.6,773.7c2.3,0,3.2.8,3.2,3.2v16.2c0,2.8-1.4,2.8-3.6,2.8s-1.8,0-2-.1c-.5-.2-.6-.7-.6-1,0-1,.6-1,1-1s1.8,0,2,0c.7,0,1.2-.3,1.2-1.1v-15.6c0-.9-.3-1.5-1.5-1.5h-12.9c-1.1,0-1.5.6-1.5,1.5v7.9c0,4.5-.7,7.1-1.4,9-.6,1.6-1,1.9-1.6,1.9s-1.1-.5-1.1-1,0-.3.8-2c1-2.2,1.2-5.3,1.2-7.9v-8c0-2.4.8-3.2,3.2-3.2h13.5ZM398.8,777c0-.3,0-.9,1-.9s1,.6,1,.9v1.3h4.9c.2,0,.9,0,.9.8s-.7.9-1,.9h-4.8v2.6h5.1c.3,0,.9,0,.9.9s-.6.9-.9.9h-12c-.3,0-1,0-1-.9s.5-.9,1-.9h4.9v-2.6h-4.7c-.3,0-1,0-1-.8s.6-.9,1-.9h4.7v-1.3ZM405.3,790.9c0,1.7-.6,2.3-2.3,2.3h-6.7c-1.7,0-2.3-.6-2.3-2.3v-2.2c0-1.8.7-2.3,2.3-2.3h6.7c1.5,0,2.3.5,2.3,2.3v2.2ZM403.3,788.9c0-.5-.2-.9-.8-.9h-5.7c-.7,0-.9.4-.9.9v1.8c0,.6.2.9.9.9h5.7c.6,0,.8-.3.8-.9v-1.8Z"
                />
                <path
                  d="M406.9,834.3c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM401.2,839.7c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_7周南_xFF1A_紫" v-if="this.clickedPointId === 67">
          <rect
            class="pn_st61"
            x="382.5"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M406.6,773.7c2.3,0,3.2.8,3.2,3.2v16.2c0,2.8-1.4,2.8-3.6,2.8s-1.8,0-2-.1c-.5-.2-.6-.7-.6-1,0-1,.6-1,1-1s1.8,0,2,0c.7,0,1.2-.3,1.2-1.1v-15.6c0-.9-.3-1.5-1.5-1.5h-12.9c-1.1,0-1.5.6-1.5,1.5v7.9c0,4.5-.7,7.1-1.4,9-.6,1.6-1,1.9-1.6,1.9s-1.1-.5-1.1-1,0-.3.8-2c1-2.2,1.2-5.3,1.2-7.9v-8c0-2.4.8-3.2,3.2-3.2h13.5ZM398.8,777c0-.3,0-.9,1-.9s1,.6,1,.9v1.3h4.9c.2,0,.9,0,.9.8s-.7.9-1,.9h-4.8v2.6h5.1c.3,0,.9,0,.9.9s-.6.9-.9.9h-12c-.3,0-1,0-1-.9s.5-.9,1-.9h4.9v-2.6h-4.7c-.3,0-1,0-1-.8s.6-.9,1-.9h4.7v-1.3ZM405.3,790.9c0,1.7-.6,2.3-2.3,2.3h-6.7c-1.7,0-2.3-.6-2.3-2.3v-2.2c0-1.8.7-2.3,2.3-2.3h6.7c1.5,0,2.3.5,2.3,2.3v2.2ZM403.3,788.9c0-.5-.2-.9-.8-.9h-5.7c-.7,0-.9.4-.9.9v1.8c0,.6.2.9.9.9h5.7c.6,0,.8-.3.8-.9v-1.8Z"
              />
              <path
                class="pn_st63"
                d="M406.9,834.3c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM401.2,839.7c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_7周南_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(67)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M399.5,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M399.5,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M406.6,773.7c2.3,0,3.2.8,3.2,3.2v16.2c0,2.8-1.4,2.8-3.6,2.8s-1.8,0-2-.1c-.5-.2-.6-.7-.6-1,0-1,.6-1,1-1s1.8,0,2,0c.7,0,1.2-.3,1.2-1.1v-15.6c0-.9-.3-1.5-1.5-1.5h-12.9c-1.1,0-1.5.6-1.5,1.5v7.9c0,4.5-.7,7.1-1.4,9-.6,1.6-1,1.9-1.6,1.9s-1.1-.5-1.1-1,0-.3.8-2c1-2.2,1.2-5.3,1.2-7.9v-8c0-2.4.8-3.2,3.2-3.2h13.5ZM398.8,777c0-.3,0-.9,1-.9s1,.6,1,.9v1.3h4.9c.2,0,.9,0,.9.8s-.7.9-1,.9h-4.8v2.6h5.1c.3,0,.9,0,.9.9s-.6.9-.9.9h-12c-.3,0-1,0-1-.9s.5-.9,1-.9h4.9v-2.6h-4.7c-.3,0-1,0-1-.8s.6-.9,1-.9h4.7v-1.3ZM405.3,790.9c0,1.7-.6,2.3-2.3,2.3h-6.7c-1.7,0-2.3-.6-2.3-2.3v-2.2c0-1.8.7-2.3,2.3-2.3h6.7c1.5,0,2.3.5,2.3,2.3v2.2ZM403.3,788.9c0-.5-.2-.9-.8-.9h-5.7c-.7,0-.9.4-.9.9v1.8c0,.6.2.9.9.9h5.7c.6,0,.8-.3.8-.9v-1.8Z"
              />
              <path
                d="M406.9,834.3c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM401.2,839.7c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_6光_xFF1A_橙">
          <a @click="sendPointId(66)">
            <g>
              <path
                class="pn_st67"
                d="M335.9,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M335.9,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="353" y1="813.3" x2="353" y2="813.3" />
              <g>
                <line class="pn_st13" x1="353" y1="813.3" x2="355.5" y2="813.3" />
                <line class="pn_st3" x1="357.6" y1="813.3" x2="357.6" y2="813.3" />
                <line
                  class="pn_st38"
                  x1="357.6"
                  y1="813.3"
                  x2="380.1"
                  y2="813.3"
                />
                <line
                  class="pn_st13"
                  x1="380.1"
                  y1="813.3"
                  x2="382.6"
                  y2="813.3"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M357.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M377.8,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM370.1,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M362.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M376.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M339.5,820c0,1.1.8,1.1,1.4,1.1h2.6c1.4,0,1.5-.4,1.8-3,.1-1,.2-1.4,1-1.4s1.2.3,1.2,1-.2,3.2-.8,4.2c-.6,1.2-1.4,1.2-4.5,1.2s-2.1,0-2.6,0c-2-.1-2.2-1.6-2.2-2.8v-9.2h-3.3c0,1.7-.2,5.9-2.8,8.9-2.1,2.3-5.2,3.4-5.8,3.4s-1.1-.7-1.1-1.3.2-.7,1.5-1.1c4.5-1.6,6-4.4,6.1-9.8h-6.8c-.3,0-1,0-1-1s.7-1,1-1h9.6v-7.9c0-.3,0-1,1-1s1.1.7,1.1,1v7.9h9.7c.3,0,1,0,1,1s-.6,1-1,1h-7.2v8.8ZM329.1,806.7c-.4-.8-1.4-2.3-1.7-2.8-.7-1-.8-1.2-.8-1.5,0-.6.7-1,1.2-1s.7.2,1.5,1.3c1.1,1.6,1.8,2.8,2,3.2.2.3.3.7.3,1,0,.6-.7,1-1.2,1s-.8-.3-1.3-1.3ZM340.3,807.2c0-.4.2-.7.9-1.7.5-.7,1.2-2,2-3.3.2-.4.5-.8,1-.8s1.2.4,1.2,1-1.4,2.8-2,3.5c-.6.9-1.2,1.7-1.5,2-.2.1-.4.2-.7.2s-1-.3-1-.9Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_6光_xFF1A_紫" v-if="this.clickedPointId === 66">
          <rect
            class="pn_st61"
            x="318.9"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="353" y1="813.3" x2="353" y2="813.3" />
            <g>
              <line class="pn_st2" x1="353" y1="813.3" x2="355.5" y2="813.3" />
              <line class="pn_st28" x1="357.6" y1="813.3" x2="357.6" y2="813.3" />
              <line class="pn_st34" x1="357.6" y1="813.3" x2="380.1" y2="813.3" />
              <line class="pn_st2" x1="380.1" y1="813.3" x2="382.6" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M357.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M377.8,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM370.1,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M339.5,820c0,1.1.8,1.1,1.4,1.1h2.6c1.4,0,1.5-.4,1.8-3,.1-1,.2-1.4,1-1.4s1.2.3,1.2,1-.2,3.2-.8,4.2c-.6,1.2-1.4,1.2-4.5,1.2s-2.1,0-2.6,0c-2-.1-2.2-1.6-2.2-2.8v-9.2h-3.3c0,1.7-.2,5.9-2.8,8.9-2.1,2.3-5.2,3.4-5.8,3.4s-1.1-.7-1.1-1.3.2-.7,1.5-1.1c4.5-1.6,6-4.4,6.1-9.8h-6.8c-.3,0-1,0-1-1s.7-1,1-1h9.6v-7.9c0-.3,0-1,1-1s1.1.7,1.1,1v7.9h9.7c.3,0,1,0,1,1s-.6,1-1,1h-7.2v8.8ZM329.1,806.7c-.4-.8-1.4-2.3-1.7-2.8-.7-1-.8-1.2-.8-1.5,0-.6.7-1,1.2-1s.7.2,1.5,1.3c1.1,1.6,1.8,2.8,2,3.2.2.3.3.7.3,1,0,.6-.7,1-1.2,1s-.8-.3-1.3-1.3ZM340.3,807.2c0-.4.2-.7.9-1.7.5-.7,1.2-2,2-3.3.2-.4.5-.8,1-.8s1.2.4,1.2,1-1.4,2.8-2,3.5c-.6.9-1.2,1.7-1.5,2-.2.1-.4.2-.7.2s-1-.3-1-.9Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_6光_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(66)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M335.9,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M335.9,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="813.3" x2="353" y2="813.3" />
            <g>
              <line class="pn_st2" x1="353" y1="813.3" x2="355.5" y2="813.3" />
              <line class="pn_st28" x1="357.6" y1="813.3" x2="357.6" y2="813.3" />
              <line class="pn_st34" x1="357.6" y1="813.3" x2="380.1" y2="813.3" />
              <line class="pn_st2" x1="380.1" y1="813.3" x2="382.6" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M357.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M377.8,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM370.1,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M339.5,820c0,1.1.8,1.1,1.4,1.1h2.6c1.4,0,1.5-.4,1.8-3,.1-1,.2-1.4,1-1.4s1.2.3,1.2,1-.2,3.2-.8,4.2c-.6,1.2-1.4,1.2-4.5,1.2s-2.1,0-2.6,0c-2-.1-2.2-1.6-2.2-2.8v-9.2h-3.3c0,1.7-.2,5.9-2.8,8.9-2.1,2.3-5.2,3.4-5.8,3.4s-1.1-.7-1.1-1.3.2-.7,1.5-1.1c4.5-1.6,6-4.4,6.1-9.8h-6.8c-.3,0-1,0-1-1s.7-1,1-1h9.6v-7.9c0-.3,0-1,1-1s1.1.7,1.1,1v7.9h9.7c.3,0,1,0,1,1s-.6,1-1,1h-7.2v8.8ZM329.1,806.7c-.4-.8-1.4-2.3-1.7-2.8-.7-1-.8-1.2-.8-1.5,0-.6.7-1,1.2-1s.7.2,1.5,1.3c1.1,1.6,1.8,2.8,2,3.2.2.3.3.7.3,1,0,.6-.7,1-1.2,1s-.8-.3-1.3-1.3ZM340.3,807.2c0-.4.2-.7.9-1.7.5-.7,1.2-2,2-3.3.2-.4.5-.8,1-.8s1.2.4,1.2,1-1.4,2.8-2,3.5c-.6.9-1.2,1.7-1.5,2-.2.1-.4.2-.7.2s-1-.3-1-.9Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_5柳井_xFF1A_橙">
          <a @click="sendPointId(65)">
            <g>
              <path
                class="pn_st67"
                d="M272.2,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M272.2,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="289.3" y1="813.3" x2="289.3" y2="813.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="289.3"
                  y1="813.3"
                  x2="291.8"
                  y2="813.3"
                />
                <line class="pn_st3" x1="293.9" y1="813.3" x2="294" y2="813.3" />
                <line class="pn_st38" x1="294" y1="813.3" x2="316.4" y2="813.3" />
                <line
                  class="pn_st13"
                  x1="316.4"
                  y1="813.3"
                  x2="318.9"
                  y2="813.3"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M293.5,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M313.9,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M298.9,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M312.3,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M265.7,795.2c0,.2,0,1-.9,1s-.9-.8-.9-1v-10.7c-.5,1.4-.9,2.9-1.8,4.6-.2.3-.3.6-.8.6s-1-.7-1-1.1,0-.4.9-1.8c.8-1.3,1.9-3.6,2.6-7h-2.3c-.4,0-1,0-1-.9s.4-1,1-1h2.3v-4.1c0-.2,0-1,.9-1s.9.8.9,1v4.1h1.8c.2,0,.9,0,.9.9s-.2,1-.9,1h-1.8v.5c.4.9.8,1.9,1.9,3.6.8,1.2.9,1.3.9,1.6,0,.6-.6,1-1,1s-.6-.3-1.1-1.2c-.6-1.1-.8-1.5-.8-1.8v11.7ZM274.9,785.9c0,2.9-.7,5.8-2.6,8.2-.5.6-1.8,2-2.5,2s-1.1-.5-1.1-1.1.1-.5.5-.8c1.6-1.4,2.4-2.2,3.2-4.6-1.8.7-4.1,1.4-4.6,1.4s-.9-.5-.9-1,.2-.7,1.9-1.2v-12.3c0-.8,0-1.6.9-2,.3-.1,2-.6,2.4-.7.3,0,2-.8,2.4-.8.7,0,.9.7.9,1,0,.6-.4.7-.7.8-.9.4-1.9.7-2.9.9-1.2.2-1.3.3-1.3,1.1v11.4c.5-.2,1.9-.6,2.2-.7,0-.5.1-1,.1-1.7v-8.4c0-.7.3-1,1-1s.9.7.9,1v8.5ZM278.5,795.3c0,.3,0,1-.9,1s-.9-.7-.9-1v-18.8c0-1.8.5-2.4,2.3-2.4h1.6c1.8,0,2.3.5,2.3,2.4v14.5c0,1.2-.3,1.9-1.8,1.9s-2.3,0-2.3-1.2.5-.9,1.2-.9,1,0,1-.6v-13.2c0-.5-.2-.8-.8-.8h-1c-.6,0-.8.3-.8.8v18.4Z"
                />
                <path
                  d="M261.5,843.3c-.3,0-1,0-1-1s.6-1,1-1h4.7c0-1.1.1-2.4.1-2.7v-4h-4.4c-.3,0-1,0-1-1s.6-1,1-1h4.4v-3.7c0-.3,0-1.1,1-1.1s1.1.4,1.1,1.1v3.7h7.5v-3.7c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v3.7h4.3c.3,0,1,0,1,1s-.7,1-1,1h-4.3v6.6h4.7c.3,0,1,0,1,1s-.7,1-1,1h-4.7v6.8c0,.3,0,1.1-1.1,1.1s-1.1-.3-1.1-1.1v-6.8h-8c-.4,1.6-1.1,4.2-3.9,6.5-.6.5-1.6,1.2-2.2,1.2s-1.1-.6-1.1-1.1.3-.7.6-.9c2.2-1.5,3.6-2.9,4.4-5.7h-4.3ZM268.5,838.6c0,.6,0,1.4-.1,2.7h7.7v-6.6h-7.5v4Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_5柳井_xFF1A_紫" v-if="this.clickedPointId === 65">
          <rect
            class="pn_st61"
            x="255.2"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="289.3" y1="813.3" x2="289.3" y2="813.3" />
            <g>
              <line class="pn_st2" x1="289.3" y1="813.3" x2="291.8" y2="813.3" />
              <line class="pn_st28" x1="293.9" y1="813.3" x2="294" y2="813.3" />
              <line class="pn_st34" x1="294" y1="813.3" x2="316.4" y2="813.3" />
              <line class="pn_st2" x1="316.4" y1="813.3" x2="318.9" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.5,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M313.9,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M265.7,795.2c0,.2,0,1-.9,1s-.9-.8-.9-1v-10.7c-.5,1.4-.9,2.9-1.8,4.6-.2.3-.3.6-.8.6s-1-.7-1-1.1,0-.4.9-1.8c.8-1.3,1.9-3.6,2.6-7h-2.3c-.4,0-1,0-1-.9s.4-1,1-1h2.3v-4.1c0-.2,0-1,.9-1s.9.8.9,1v4.1h1.8c.2,0,.9,0,.9.9s-.2,1-.9,1h-1.8v.5c.4.9.8,1.9,1.9,3.6.8,1.2.9,1.3.9,1.6,0,.6-.6,1-1,1s-.6-.3-1.1-1.2c-.6-1.1-.8-1.5-.8-1.8v11.7ZM274.9,785.9c0,2.9-.7,5.8-2.6,8.2-.5.6-1.8,2-2.5,2s-1.1-.5-1.1-1.1.1-.5.5-.8c1.6-1.4,2.4-2.2,3.2-4.6-1.8.7-4.1,1.4-4.6,1.4s-.9-.5-.9-1,.2-.7,1.9-1.2v-12.3c0-.8,0-1.6.9-2,.3-.1,2-.6,2.4-.7.3,0,2-.8,2.4-.8.7,0,.9.7.9,1,0,.6-.4.7-.7.8-.9.4-1.9.7-2.9.9-1.2.2-1.3.3-1.3,1.1v11.4c.5-.2,1.9-.6,2.2-.7,0-.5.1-1,.1-1.7v-8.4c0-.7.3-1,1-1s.9.7.9,1v8.5ZM278.5,795.3c0,.3,0,1-.9,1s-.9-.7-.9-1v-18.8c0-1.8.5-2.4,2.3-2.4h1.6c1.8,0,2.3.5,2.3,2.4v14.5c0,1.2-.3,1.9-1.8,1.9s-2.3,0-2.3-1.2.5-.9,1.2-.9,1,0,1-.6v-13.2c0-.5-.2-.8-.8-.8h-1c-.6,0-.8.3-.8.8v18.4Z"
              />
              <path
                class="pn_st63"
                d="M261.5,843.3c-.3,0-1,0-1-1s.6-1,1-1h4.7c0-1.1.1-2.4.1-2.7v-4h-4.4c-.3,0-1,0-1-1s.6-1,1-1h4.4v-3.7c0-.3,0-1.1,1-1.1s1.1.4,1.1,1.1v3.7h7.5v-3.7c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v3.7h4.3c.3,0,1,0,1,1s-.7,1-1,1h-4.3v6.6h4.7c.3,0,1,0,1,1s-.7,1-1,1h-4.7v6.8c0,.3,0,1.1-1.1,1.1s-1.1-.3-1.1-1.1v-6.8h-8c-.4,1.6-1.1,4.2-3.9,6.5-.6.5-1.6,1.2-2.2,1.2s-1.1-.6-1.1-1.1.3-.7.6-.9c2.2-1.5,3.6-2.9,4.4-5.7h-4.3ZM268.5,838.6c0,.6,0,1.4-.1,2.7h7.7v-6.6h-7.5v4Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_5柳井_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(65)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M272.2,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M272.2,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="289.3" y1="813.3" x2="289.3" y2="813.3" />
            <g>
              <line class="pn_st2" x1="289.3" y1="813.3" x2="291.8" y2="813.3" />
              <line class="pn_st28" x1="293.9" y1="813.3" x2="294" y2="813.3" />
              <line class="pn_st34" x1="294" y1="813.3" x2="316.4" y2="813.3" />
              <line class="pn_st2" x1="316.4" y1="813.3" x2="318.9" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.5,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M313.9,784c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,784c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M265.7,795.2c0,.2,0,1-.9,1s-.9-.8-.9-1v-10.7c-.5,1.4-.9,2.9-1.8,4.6-.2.3-.3.6-.8.6s-1-.7-1-1.1,0-.4.9-1.8c.8-1.3,1.9-3.6,2.6-7h-2.3c-.4,0-1,0-1-.9s.4-1,1-1h2.3v-4.1c0-.2,0-1,.9-1s.9.8.9,1v4.1h1.8c.2,0,.9,0,.9.9s-.2,1-.9,1h-1.8v.5c.4.9.8,1.9,1.9,3.6.8,1.2.9,1.3.9,1.6,0,.6-.6,1-1,1s-.6-.3-1.1-1.2c-.6-1.1-.8-1.5-.8-1.8v11.7ZM274.9,785.9c0,2.9-.7,5.8-2.6,8.2-.5.6-1.8,2-2.5,2s-1.1-.5-1.1-1.1.1-.5.5-.8c1.6-1.4,2.4-2.2,3.2-4.6-1.8.7-4.1,1.4-4.6,1.4s-.9-.5-.9-1,.2-.7,1.9-1.2v-12.3c0-.8,0-1.6.9-2,.3-.1,2-.6,2.4-.7.3,0,2-.8,2.4-.8.7,0,.9.7.9,1,0,.6-.4.7-.7.8-.9.4-1.9.7-2.9.9-1.2.2-1.3.3-1.3,1.1v11.4c.5-.2,1.9-.6,2.2-.7,0-.5.1-1,.1-1.7v-8.4c0-.7.3-1,1-1s.9.7.9,1v8.5ZM278.5,795.3c0,.3,0,1-.9,1s-.9-.7-.9-1v-18.8c0-1.8.5-2.4,2.3-2.4h1.6c1.8,0,2.3.5,2.3,2.4v14.5c0,1.2-.3,1.9-1.8,1.9s-2.3,0-2.3-1.2.5-.9,1.2-.9,1,0,1-.6v-13.2c0-.5-.2-.8-.8-.8h-1c-.6,0-.8.3-.8.8v18.4Z"
              />
              <path
                d="M261.5,843.3c-.3,0-1,0-1-1s.6-1,1-1h4.7c0-1.1.1-2.4.1-2.7v-4h-4.4c-.3,0-1,0-1-1s.6-1,1-1h4.4v-3.7c0-.3,0-1.1,1-1.1s1.1.4,1.1,1.1v3.7h7.5v-3.7c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v3.7h4.3c.3,0,1,0,1,1s-.7,1-1,1h-4.3v6.6h4.7c.3,0,1,0,1,1s-.7,1-1,1h-4.7v6.8c0,.3,0,1.1-1.1,1.1s-1.1-.3-1.1-1.1v-6.8h-8c-.4,1.6-1.1,4.2-3.9,6.5-.6.5-1.6,1.2-2.2,1.2s-1.1-.6-1.1-1.1.3-.7.6-.9c2.2-1.5,3.6-2.9,4.4-5.7h-4.3ZM268.5,838.6c0,.6,0,1.4-.1,2.7h7.7v-6.6h-7.5v4Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_4岩国2_xFF1A_橙">
          <a @click="sendPointId(64)">
            <g>
              <path
                class="pn_st67"
                d="M208.5,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M208.5,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="225.6" y1="813.3" x2="225.6" y2="813.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="225.6"
                  y1="813.3"
                  x2="228.1"
                  y2="813.3"
                />
                <line class="pn_st3" x1="230.2" y1="813.3" x2="230.2" y2="813.3" />
                <line
                  class="pn_st38"
                  x1="230.2"
                  y1="813.3"
                  x2="252.6"
                  y2="813.3"
                />
                <line
                  class="pn_st13"
                  x1="252.6"
                  y1="813.3"
                  x2="255.1"
                  y2="813.3"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M230.6,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M241.1,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M235.2,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M248.5,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M215.3,786.6c1.8,0,2.6.6,2.6,2.6v3.8c0,1.9-.7,2.6-2.6,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1,0-1-.9s.6-.9,1-.9h21.2c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM215.4,777.5c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM215.8,789.6c0-.8-.4-1.1-1.1-1.1h-10.1c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.1c.7,0,1.1-.3,1.1-1.1v-3.1Z"
                />
                <path
                  d="M219.1,819.9c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM217.1,804.7c0-1.1-.5-1.5-1.5-1.5h-14.3c-1,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c1,0,1.5-.5,1.5-1.5v-14.9ZM209.2,810.9h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.6-.9,1-.9h12.6c.5,0,1,.2,1,.9s-.6.9-1,.9h-5.6v4ZM212.9,814.4c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-1,.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.2-1.7,0,0-.1-.2-.1-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
                />
                <path
                  d="M220.3,839.5c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,839.5c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM212.5,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_4岩国2_xFF1A_紫" v-if="this.clickedPointId === 64">
          <rect
            class="pn_st61"
            x="191.5"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="225.6" y1="813.3" x2="225.6" y2="813.3" />
            <g>
              <line class="pn_st2" x1="225.6" y1="813.3" x2="228.1" y2="813.3" />
              <line class="pn_st28" x1="230.2" y1="813.3" x2="230.2" y2="813.3" />
              <line class="pn_st34" x1="230.2" y1="813.3" x2="252.6" y2="813.3" />
              <line class="pn_st2" x1="252.6" y1="813.3" x2="255.1" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.6,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M241.1,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M215.3,786.6c1.8,0,2.6.6,2.6,2.6v3.8c0,1.9-.7,2.6-2.6,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1,0-1-.9s.6-.9,1-.9h21.2c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM215.4,777.5c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM215.8,789.6c0-.8-.4-1.1-1.1-1.1h-10.1c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.1c.7,0,1.1-.3,1.1-1.1v-3.1Z"
              />
              <path
                class="pn_st63"
                d="M219.1,819.9c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM217.1,804.7c0-1.1-.5-1.5-1.5-1.5h-14.3c-1,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c1,0,1.5-.5,1.5-1.5v-14.9ZM209.2,810.9h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.6-.9,1-.9h12.6c.5,0,1,.2,1,.9s-.6.9-1,.9h-5.6v4ZM212.9,814.4c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-1,.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.2-1.7,0,0-.1-.2-.1-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
              />
              <path
                class="pn_st63"
                d="M220.3,839.5c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,839.5c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM212.5,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_4岩国2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(64)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M208.5,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M208.5,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="813.3" x2="225.6" y2="813.3" />
            <g>
              <line class="pn_st2" x1="225.6" y1="813.3" x2="228.1" y2="813.3" />
              <line class="pn_st28" x1="230.2" y1="813.3" x2="230.2" y2="813.3" />
              <line class="pn_st34" x1="230.2" y1="813.3" x2="252.6" y2="813.3" />
              <line class="pn_st2" x1="252.6" y1="813.3" x2="255.1" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.6,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M241.1,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M215.3,786.6c1.8,0,2.6.6,2.6,2.6v3.8c0,1.9-.7,2.6-2.6,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1,0-1-.9s.6-.9,1-.9h21.2c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM215.4,777.5c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM215.8,789.6c0-.8-.4-1.1-1.1-1.1h-10.1c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.1c.7,0,1.1-.3,1.1-1.1v-3.1Z"
              />
              <path
                d="M219.1,819.9c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM217.1,804.7c0-1.1-.5-1.5-1.5-1.5h-14.3c-1,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c1,0,1.5-.5,1.5-1.5v-14.9ZM209.2,810.9h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.6-.9,1-.9h12.6c.5,0,1,.2,1,.9s-.6.9-1,.9h-5.6v4ZM212.9,814.4c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-1,.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.2-1.7,0,0-.1-.2-.1-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
              />
              <path
                d="M220.3,839.5c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,839.5c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM212.5,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_3岩国1_xFF1A_橙">
          <a @click="sendPointId(63)">
            <g>
              <path
                class="pn_st67"
                d="M144.7,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M144.7,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="161.9" y1="813.3" x2="161.9" y2="813.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="161.9"
                  y1="813.3"
                  x2="164.4"
                  y2="813.3"
                />
                <line class="pn_st3" x1="166.5" y1="813.3" x2="166.5" y2="813.3" />
                <line
                  class="pn_st38"
                  x1="166.5"
                  y1="813.3"
                  x2="188.9"
                  y2="813.3"
                />
                <line
                  class="pn_st13"
                  x1="188.9"
                  y1="813.3"
                  x2="191.4"
                  y2="813.3"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M166.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M177.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M171.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M184.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M151.6,786.9c1.8,0,2.7.6,2.7,2.6v3.8c0,1.9-.7,2.6-2.7,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1.1,0-1.1-.9s.6-.9,1.1-.9h21.1c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM151.7,777.7c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM152.1,789.8c0-.8-.4-1.1-1.1-1.1h-10.2c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.2c.7,0,1.1-.3,1.1-1.1v-3.1Z"
                />
                <path
                  d="M155.4,820.1c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM153.3,805c0-1.1-.5-1.5-1.5-1.5h-14.3c-.9,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c.9,0,1.5-.5,1.5-1.5v-14.9ZM145.5,811.2h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.7-.9,1-.9h12.7c.5,0,1,.2,1,.9s-.7.9-1,.9h-5.6v4ZM149.1,814.6c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-.9.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.1-1.7,0,0-.2-.2-.2-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
                />
                <path
                  d="M156.6,839.8c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM133.7,839.8c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM142.7,836c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_3岩国1_xFF1A_紫" v-if="this.clickedPointId === 63">
          <rect
            class="pn_st61"
            x="127.7"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="161.9" y1="813.3" x2="161.9" y2="813.3" />
            <g>
              <line class="pn_st2" x1="161.9" y1="813.3" x2="164.4" y2="813.3" />
              <line class="pn_st28" x1="166.5" y1="813.3" x2="166.5" y2="813.3" />
              <line class="pn_st34" x1="166.5" y1="813.3" x2="188.9" y2="813.3" />
              <line class="pn_st2" x1="188.9" y1="813.3" x2="191.4" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M177.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M151.6,786.9c1.8,0,2.7.6,2.7,2.6v3.8c0,1.9-.7,2.6-2.7,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1.1,0-1.1-.9s.6-.9,1.1-.9h21.1c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM151.7,777.7c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM152.1,789.8c0-.8-.4-1.1-1.1-1.1h-10.2c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.2c.7,0,1.1-.3,1.1-1.1v-3.1Z"
              />
              <path
                class="pn_st63"
                d="M155.4,820.1c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM153.3,805c0-1.1-.5-1.5-1.5-1.5h-14.3c-.9,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c.9,0,1.5-.5,1.5-1.5v-14.9ZM145.5,811.2h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.7-.9,1-.9h12.7c.5,0,1,.2,1,.9s-.7.9-1,.9h-5.6v4ZM149.1,814.6c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-.9.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.1-1.7,0,0-.2-.2-.2-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
              />
              <path
                class="pn_st63"
                d="M156.6,839.8c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM133.7,839.8c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM142.7,836c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_3岩国1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(63)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M144.7,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M144.7,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,758.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="813.3" x2="161.9" y2="813.3" />
            <g>
              <line class="pn_st2" x1="161.9" y1="813.3" x2="164.4" y2="813.3" />
              <line class="pn_st28" x1="166.5" y1="813.3" x2="166.5" y2="813.3" />
              <line class="pn_st34" x1="166.5" y1="813.3" x2="188.9" y2="813.3" />
              <line class="pn_st2" x1="188.9" y1="813.3" x2="191.4" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M177.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M151.6,786.9c1.8,0,2.7.6,2.7,2.6v3.8c0,1.9-.7,2.6-2.7,2.6h-11.3c-1.9,0-2.7-.6-2.7-2.6v-3.2c-1.3,1.2-2.7,2.4-3.5,2.4s-1.1-.7-1.1-1.3.3-.7.6-.9c.8-.5,2.8-1.8,4.8-4,.8-.9,1.2-1.7,1.8-2.7h-6c-.3,0-1.1,0-1.1-.9s.6-.9,1.1-.9h21.1c.3,0,1,0,1,.9s-.7.9-1,.9h-12.8c-.2.5-.8,1.7-2,3.3h11ZM151.7,777.7c.8,0,1.1-.4,1.1-1.1v-1.9c0-.3,0-1,1-1s1.1.2,1.1,1v2.2c0,2-.7,2.6-2.7,2.6h-15c-1.9,0-2.7-.6-2.7-2.6v-2.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.9c0,.7.3,1.1,1.1,1.1h5.9v-3.8c0-.3,0-1,1-1s1.1.2,1.1,1v3.8h6ZM152.1,789.8c0-.8-.4-1.1-1.1-1.1h-10.2c-.7,0-1.1.3-1.1,1.1v3.1c0,.8.4,1.1,1.1,1.1h10.2c.7,0,1.1-.3,1.1-1.1v-3.1Z"
              />
              <path
                d="M155.4,820.1c0,2.5-.9,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM153.3,805c0-1.1-.5-1.5-1.5-1.5h-14.3c-.9,0-1.5.5-1.5,1.5v14.9c0,.9.4,1.5,1.5,1.5h14.3c.9,0,1.5-.5,1.5-1.5v-14.9ZM145.5,811.2h5.2c.2,0,1,0,1,.8s-.4.9-1,.9h-5.2v4.9h5.9c.3,0,1,0,1,.9s-.7.9-1,.9h-13.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.5v-4.9h-4.7c-.3,0-1,0-1-.8s.3-.9,1-.9h4.7v-4h-5c-.3,0-1,0-1-.9s.7-.9,1-.9h12.7c.5,0,1,.2,1,.9s-.7.9-1,.9h-5.6v4ZM149.1,814.6c1.1,1.4,1.1,1.7,1.1,1.8,0,.5-.6.8-.9.8s-.5,0-1-.9c-.3-.5-.8-1.2-1.1-1.7,0,0-.2-.2-.2-.4,0-.5.6-.7.8-.7.4,0,.5,0,1.3,1.1Z"
              />
              <path
                d="M156.6,839.8c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM133.7,839.8c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM142.7,836c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_2廿日市_xFF1A_橙">
          <a @click="sendPointId(62)">
            <g>
              <path
                class="pn_st67"
                d="M81,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M81,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="98.2" y1="813.3" x2="98.2" y2="813.3" />
              <g>
                <line class="pn_st13" x1="98.2" y1="813.3" x2="100.7" y2="813.3" />
                <line class="pn_st3" x1="102.8" y1="813.3" x2="102.8" y2="813.3" />
                <line
                  class="pn_st38"
                  x1="102.8"
                  y1="813.3"
                  x2="125.2"
                  y2="813.3"
                />
                <line
                  class="pn_st13"
                  x1="125.2"
                  y1="813.3"
                  x2="127.7"
                  y2="813.3"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M102.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M118.6,781.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.2,786.7c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M107.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M121.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M88,792.9c0,2.1-.8,2.8-2.8,2.8h-8.5c-1.9,0-2.8-.7-2.8-2.8v-11.7h-3.7c-.2,0-1,0-1-1s.4-1.1,1-1.1h3.7v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h9.8v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h3.7c.3,0,1,0,1,1s-.7,1-1,1h-3.7v11.7ZM85.9,781.2h-9.8v11.3c0,.8.3,1.1,1.1,1.1h7.5c.8,0,1.2-.4,1.2-1.1v-11.3Z"
                />
                <path
                  d="M90.2,819.5c0,2.4-.9,3.2-3.2,3.2h-11.9c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h11.9c2.3,0,3.2.8,3.2,3.2v15ZM88,810.9v-6.1c0-.9-.4-1.5-1.5-1.5h-11c-.8,0-1.5.3-1.5,1.5v6.1h14ZM74,812.8v6.4c0,1.2.6,1.5,1.5,1.5h11c1,0,1.5-.5,1.5-1.5v-6.4h-14Z"
                />
                <path
                  d="M82.1,850.2c0,.4,0,1.1-1,1.1s-1.1-.3-1.1-1v-12.5h-5c-.8,0-1.1.4-1.1,1.1v9.6c0,.4,0,1-1.1,1s-1.1-.5-1.1-1v-10c0-2.1.8-2.8,2.8-2.8h5.6v-3h-9.5c-.2,0-1,0-1-1s.6-1,1-1h9.5v-2c0-.4.1-1,1-1s1.2.2,1.2,1v2h9.5c.3,0,1,0,1,1s-.3,1-1,1h-9.5v3h5.7c1.9,0,2.8.6,2.8,2.8v8c0,2.7-1.3,2.7-3.7,2.7s-1.6,0-1.9-.2c-.4-.2-.4-.7-.4-1,0-.9.6-.9,1.2-.9s1.4,0,1.6,0c.8,0,1-.5,1-1.2v-7c0-.8-.4-1.1-1.1-1.1h-5.1v12.5Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_2廿日市_xFF1A_紫" v-if="this.clickedPointId === 62">
          <rect
            class="pn_st61"
            x="64"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="98.2" y1="813.3" x2="98.2" y2="813.3" />
            <g>
              <line class="pn_st2" x1="98.2" y1="813.3" x2="100.7" y2="813.3" />
              <line class="pn_st28" x1="102.8" y1="813.3" x2="102.8" y2="813.3" />
              <line class="pn_st34" x1="102.8" y1="813.3" x2="125.2" y2="813.3" />
              <line class="pn_st2" x1="125.2" y1="813.3" x2="127.7" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M102.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M118.6,781.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.2,786.7c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M88,792.9c0,2.1-.8,2.8-2.8,2.8h-8.5c-1.9,0-2.8-.7-2.8-2.8v-11.7h-3.7c-.2,0-1,0-1-1s.4-1.1,1-1.1h3.7v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h9.8v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h3.7c.3,0,1,0,1,1s-.7,1-1,1h-3.7v11.7ZM85.9,781.2h-9.8v11.3c0,.8.3,1.1,1.1,1.1h7.5c.8,0,1.2-.4,1.2-1.1v-11.3Z"
              />
              <path
                class="pn_st63"
                d="M90.2,819.5c0,2.4-.9,3.2-3.2,3.2h-11.9c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h11.9c2.3,0,3.2.8,3.2,3.2v15ZM88,810.9v-6.1c0-.9-.4-1.5-1.5-1.5h-11c-.8,0-1.5.3-1.5,1.5v6.1h14ZM74,812.8v6.4c0,1.2.6,1.5,1.5,1.5h11c1,0,1.5-.5,1.5-1.5v-6.4h-14Z"
              />
              <path
                class="pn_st63"
                d="M82.1,850.2c0,.4,0,1.1-1,1.1s-1.1-.3-1.1-1v-12.5h-5c-.8,0-1.1.4-1.1,1.1v9.6c0,.4,0,1-1.1,1s-1.1-.5-1.1-1v-10c0-2.1.8-2.8,2.8-2.8h5.6v-3h-9.5c-.2,0-1,0-1-1s.6-1,1-1h9.5v-2c0-.4.1-1,1-1s1.2.2,1.2,1v2h9.5c.3,0,1,0,1,1s-.3,1-1,1h-9.5v3h5.7c1.9,0,2.8.6,2.8,2.8v8c0,2.7-1.3,2.7-3.7,2.7s-1.6,0-1.9-.2c-.4-.2-.4-.7-.4-1,0-.9.6-.9,1.2-.9s1.4,0,1.6,0c.8,0,1-.5,1-1.2v-7c0-.8-.4-1.1-1.1-1.1h-5.1v12.5Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_2廿日市_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(62)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M81,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="98.2" y1="813.3" x2="98.2" y2="813.3" />
            <g>
              <line class="pn_st2" x1="98.2" y1="813.3" x2="100.7" y2="813.3" />
              <line class="pn_st28" x1="102.8" y1="813.3" x2="102.8" y2="813.3" />
              <line class="pn_st34" x1="102.8" y1="813.3" x2="125.2" y2="813.3" />
              <line class="pn_st2" x1="125.2" y1="813.3" x2="127.7" y2="813.3" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M102.4,791.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M118.6,781.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.2,786.7c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M88,792.9c0,2.1-.8,2.8-2.8,2.8h-8.5c-1.9,0-2.8-.7-2.8-2.8v-11.7h-3.7c-.2,0-1,0-1-1s.4-1.1,1-1.1h3.7v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h9.8v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h3.7c.3,0,1,0,1,1s-.7,1-1,1h-3.7v11.7ZM85.9,781.2h-9.8v11.3c0,.8.3,1.1,1.1,1.1h7.5c.8,0,1.2-.4,1.2-1.1v-11.3Z"
              />
              <path
                d="M90.2,819.5c0,2.4-.9,3.2-3.2,3.2h-11.9c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h11.9c2.3,0,3.2.8,3.2,3.2v15ZM88,810.9v-6.1c0-.9-.4-1.5-1.5-1.5h-11c-.8,0-1.5.3-1.5,1.5v6.1h14ZM74,812.8v6.4c0,1.2.6,1.5,1.5,1.5h11c1,0,1.5-.5,1.5-1.5v-6.4h-14Z"
              />
              <path
                d="M82.1,850.2c0,.4,0,1.1-1,1.1s-1.1-.3-1.1-1v-12.5h-5c-.8,0-1.1.4-1.1,1.1v9.6c0,.4,0,1-1.1,1s-1.1-.5-1.1-1v-10c0-2.1.8-2.8,2.8-2.8h5.6v-3h-9.5c-.2,0-1,0-1-1s.6-1,1-1h9.5v-2c0-.4.1-1,1-1s1.2.2,1.2,1v2h9.5c.3,0,1,0,1,1s-.3,1-1,1h-9.5v3h5.7c1.9,0,2.8.6,2.8,2.8v8c0,2.7-1.3,2.7-3.7,2.7s-1.6,0-1.9-.2c-.4-.2-.4-.7-.4-1,0-.9.6-.9,1.2-.9s1.4,0,1.6,0c.8,0,1-.5,1-1.2v-7c0-.8-.4-1.1-1.1-1.1h-5.1v12.5Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_1広島2_xFF1A_橙">
          <a @click="sendPointId(61)">
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M39.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st57"
                d="M50.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M44.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M57.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="63.9" y1="813.3" x2="63.9" y2="813.3" />
              <g>
                <line class="pn_st13" x1="63.9" y1="813.3" x2="61.4" y2="813.3" />
                <line class="pn_st17" x1="59.3" y1="813.3" x2="59.2" y2="813.3" />
                <line class="pn_st22" x1="59.2" y1="813.3" x2="36.8" y2="813.3" />
                <line class="pn_st13" x1="36.8" y1="813.3" x2="34.3" y2="813.3" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M17.3,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M16.5,773.8c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.2c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.4,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,794.2c-.5,0-10,.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.5-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-2.9-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
                />
                <path
                  d="M12.3,820.6v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.4,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1.1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.8,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1.1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,805.7h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM24.1,807h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
                />
                <path
                  d="M29.2,839.5c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM6.3,839.5c0,6.1,4.9,11,11,11s11.1-5,11.1-11-5-11-11.1-11-11,4.9-11,11ZM21.4,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_1広島2_xFF1A_紫" v-if="this.clickedPointId === 61">
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M39.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M50.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="813.3" x2="63.9" y2="813.3" />
            <g>
              <line class="pn_st2" x1="63.9" y1="813.3" x2="61.4" y2="813.3" />
              <line class="pn_st31" x1="59.3" y1="813.3" x2="59.2" y2="813.3" />
              <line class="pn_st43" x1="59.2" y1="813.3" x2="36.8" y2="813.3" />
              <line class="pn_st2" x1="36.8" y1="813.3" x2="34.3" y2="813.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M16.5,773.8c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.2c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.4,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,794.2c-.5,0-10,.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.5-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-2.9-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
              />
              <path
                class="pn_st63"
                d="M12.3,820.6v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.4,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1.1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.8,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1.1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,805.7h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM24.1,807h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
              <path
                class="pn_st63"
                d="M29.2,839.5c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM6.3,839.5c0,6.1,4.9,11,11,11s11.1-5,11.1-11-5-11-11.1-11-11,4.9-11,11ZM21.4,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_1広島2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(61)"
          class="cursor_not_allowed"
        >
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M39.9,780.8c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M50.4,778.4c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,795.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,802.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="813.3" x2="63.9" y2="813.3" />
            <g>
              <line class="pn_st2" x1="63.9" y1="813.3" x2="61.4" y2="813.3" />
              <line class="pn_st31" x1="59.3" y1="813.3" x2="59.2" y2="813.3" />
              <line class="pn_st43" x1="59.2" y1="813.3" x2="36.8" y2="813.3" />
              <line class="pn_st2" x1="36.8" y1="813.3" x2="34.3" y2="813.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M17.3,866.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,761.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,758.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M16.5,773.8c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.2c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.4,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,794.2c-.5,0-10,.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.5-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-2.9-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
              />
              <path
                d="M12.3,820.6v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.4,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1.1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.8,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1.1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,805.7h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM24.1,807h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
              <path
                d="M29.2,839.5c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM6.3,839.5c0,6.1,4.9,11,11,11s11.1-5,11.1-11-5-11-11.1-11-11,4.9-11,11ZM21.4,844.6c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x36_0広島1_xFF1A_橙">
          <a @click="sendPointId(60)">
            <g>
              <path
                class="pn_st67"
                d="M17.3,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="17.3" y1="758" x2="17.3" y2="758" />
              <g>
                <line class="pn_st13" x1="17.3" y1="758" x2="17.3" y2="755.5" />
                <line class="pn_st6" x1="17.3" y1="752.8" x2="17.3" y2="752.8" />
                <line class="pn_st27" x1="17.3" y1="752.8" x2="17.3" y2="743.5" />
                <line class="pn_st13" x1="17.3" y1="743.5" x2="17.3" y2="741" />
              </g>
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M26.8,746.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st57"
                d="M40.4,749.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M53.8,749.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M67.2,756.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M16.5,647.4c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.1c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.5,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,667.9c-.5,0-9.9.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.4-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-3-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
                />
                <path
                  d="M12.3,694.2v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,679.3h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM24.1,680.6h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
                />
                <path
                  d="M29.2,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM6.3,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM15.3,709.3c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x36_0広島1_xFF1A_紫" v-if="this.clickedPointId === 60">
          <g>
            <line class="pn_st0" x1="17.3" y1="758" x2="17.3" y2="758" />
            <g>
              <line class="pn_st2" x1="17.3" y1="758" x2="17.3" y2="755.5" />
              <line class="pn_st51" x1="17.3" y1="752.8" x2="17.3" y2="752.8" />
              <line class="pn_st52" x1="17.3" y1="752.8" x2="17.3" y2="743.5" />
              <line class="pn_st2" x1="17.3" y1="743.5" x2="17.3" y2="741" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M26.8,746.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M40.4,749.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M53.8,749.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M67.2,756.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M16.5,647.4c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.1c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.5,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,667.9c-.5,0-9.9.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.4-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-3-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
              />
              <path
                class="pn_st63"
                d="M12.3,694.2v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,679.3h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM24.1,680.6h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
              <path
                class="pn_st63"
                d="M29.2,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM6.3,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM15.3,709.3c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x36_0広島1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(60)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M17.3,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="758" x2="17.3" y2="758" />
            <g>
              <line class="pn_st2" x1="17.3" y1="758" x2="17.3" y2="755.5" />
              <line class="pn_st51" x1="17.3" y1="752.8" x2="17.3" y2="752.8" />
              <line class="pn_st52" x1="17.3" y1="752.8" x2="17.3" y2="743.5" />
              <line class="pn_st2" x1="17.3" y1="743.5" x2="17.3" y2="741" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M26.8,746.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M40.4,749.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M53.8,749.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M67.2,756.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M16.5,647.4c0-.3,0-1,1-1s1.1,0,1.1,1v1.6h9.1c.3,0,1,0,1,.9s-.3,1-1,1H11.2c-.9,0-1.5.4-1.5,1.5v5.7c0,1.6,0,5.5-1.8,9.7-.5,1.1-.7,1.5-1.3,1.5s-1.2-.3-1.2-1.1,0-.3.2-.8c1.2-2.5,2-4.3,2-9.4v-5.9c0-2.4.9-3.2,3.2-3.2h5.6v-1.6ZM20.7,667.9c-.5,0-9.9.9-10.4.9s-1-.1-1-1,.2-.8.6-.9c.2,0,1.4-.1,2.2-.2,1.7-4.2,2.9-8.5,4-12.8.3-1.2.4-1.6,1.2-1.6s1.2,0,1.2.9,0,.5,0,.6c-.2,1-.3,1-1.9,6.3-.5,1.8-1.4,4.3-2.3,6.4,4.6-.3,8.3-.5,10.5-.8-1.1-2.4-2.3-4.5-3-5.6-.2-.4-.2-.5-.2-.7,0-.6.6-1,1.1-1s.6.2.8.5c.4.7,1,1.6,2.1,3.7.5.8,2.6,5.1,2.6,6s-.7,1-1.1,1-.7-.1-1.6-2.2c-1.6.2-3.2.4-4.8.5Z"
              />
              <path
                d="M12.3,694.2v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8H10.2v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM10.2,679.3h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM24.1,680.6h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
              <path
                d="M29.2,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.8,5.2,11.8,11.8ZM6.3,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM15.3,709.3c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.4-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_9西条_xFF1A_橙">
          <a @click="sendPointId(59)">
            <g>
              <line class="pn_st0" x1="34.4" y1="686.9" x2="34.4" y2="686.9" />
              <g>
                <line class="pn_st13" x1="34.4" y1="686.9" x2="36.9" y2="686.9" />
                <line class="pn_st3" x1="39" y1="686.9" x2="39" y2="686.9" />
                <line class="pn_st38" x1="39" y1="686.9" x2="61.5" y2="686.9" />
                <line class="pn_st13" x1="61.5" y1="686.9" x2="64" y2="686.9" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M81,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M81,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M70.4,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM76.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM82,649.3h-3.7v3.6h3.7v-3.6Z"
                />
                <path
                  d="M83.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM86.1,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM77.6,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M39.3,661.4c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,659.9v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
                />
                <path
                  class="pn_st57"
                  d="M59.5,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM51.8,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M44.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M57.8,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_9西条_xFF1A_紫" v-if="this.clickedPointId === 59">
          <g>
            <line class="pn_st0" x1="34.4" y1="686.9" x2="34.4" y2="686.9" />
            <g>
              <line class="pn_st2" x1="34.4" y1="686.9" x2="36.9" y2="686.9" />
              <line class="pn_st28" x1="39" y1="686.9" x2="39" y2="686.9" />
              <line class="pn_st34" x1="39" y1="686.9" x2="61.5" y2="686.9" />
              <line class="pn_st2" x1="61.5" y1="686.9" x2="64" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="64"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M70.4,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM76.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM82,649.3h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                class="pn_st63"
                d="M83.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM86.1,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM77.6,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.3,661.4c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,659.9v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M59.5,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM51.8,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_9西条_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(59)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="34.4" y1="686.9" x2="34.4" y2="686.9" />
            <g>
              <line class="pn_st2" x1="34.4" y1="686.9" x2="36.9" y2="686.9" />
              <line class="pn_st28" x1="39" y1="686.9" x2="39" y2="686.9" />
              <line class="pn_st34" x1="39" y1="686.9" x2="61.5" y2="686.9" />
              <line class="pn_st2" x1="61.5" y1="686.9" x2="64" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M81,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M70.4,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM76.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM82,649.3h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                d="M83.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM86.1,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM77.6,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.3,661.4c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,659.9v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M59.5,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM51.8,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_8三原2_xFF1A_橙">
          <a @click="sendPointId(58)">
            <g>
              <line class="pn_st0" x1="98.1" y1="686.9" x2="98.1" y2="686.9" />
              <g>
                <line class="pn_st13" x1="98.1" y1="686.9" x2="100.6" y2="686.9" />
                <line class="pn_st3" x1="102.7" y1="686.9" x2="102.7" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="102.7"
                  y1="686.9"
                  x2="125.1"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="125.1"
                  y1="686.9"
                  x2="127.6"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M144.7,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M144.7,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M155.2,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM154.1,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM152.8,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
                />
                <path
                  d="M151.5,678.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM142.5,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM141.1,682.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM141.1,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM152.8,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
                />
                <path
                  d="M156.6,712.9c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM133.7,712.9c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM148.8,718c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M103,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M121.7,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M108.2,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M121.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_8三原2_xFF1A_紫" v-if="this.clickedPointId === 58">
          <g>
            <line class="pn_st0" x1="98.1" y1="686.9" x2="98.1" y2="686.9" />
            <g>
              <line class="pn_st2" x1="98.1" y1="686.9" x2="100.6" y2="686.9" />
              <line class="pn_st28" x1="102.7" y1="686.9" x2="102.7" y2="686.9" />
              <line class="pn_st34" x1="102.7" y1="686.9" x2="125.1" y2="686.9" />
              <line class="pn_st2" x1="125.1" y1="686.9" x2="127.6" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="127.7"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M155.2,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM154.1,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM152.8,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                class="pn_st63"
                d="M151.5,678.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM142.5,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM141.1,682.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM141.1,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM152.8,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
              <path
                class="pn_st63"
                d="M156.6,712.9c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM133.7,712.9c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM148.8,718c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M103,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M121.7,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M108.2,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_8三原2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(58)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="98.1" y1="686.9" x2="98.1" y2="686.9" />
            <g>
              <line class="pn_st2" x1="98.1" y1="686.9" x2="100.6" y2="686.9" />
              <line class="pn_st28" x1="102.7" y1="686.9" x2="102.7" y2="686.9" />
              <line class="pn_st34" x1="102.7" y1="686.9" x2="125.1" y2="686.9" />
              <line class="pn_st2" x1="125.1" y1="686.9" x2="127.6" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M144.7,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M144.7,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M103,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M121.7,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M108.2,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M155.2,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM154.1,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM152.8,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                d="M151.5,678.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM142.5,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM141.1,682.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM141.1,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM152.8,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
              <path
                d="M156.6,712.9c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM133.7,712.9c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM148.8,718c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_7三原1_xFF1A_橙">
          <a @click="sendPointId(57)">
            <g>
              <line class="pn_st0" x1="161.8" y1="686.9" x2="161.8" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="161.8"
                  y1="686.9"
                  x2="164.3"
                  y2="686.9"
                />
                <line class="pn_st3" x1="166.4" y1="686.9" x2="166.4" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="166.4"
                  y1="686.9"
                  x2="188.8"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="188.8"
                  y1="686.9"
                  x2="191.3"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M208.5,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M208.5,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M167.6,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M177.8,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M171.9,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M185.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M219,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM217.9,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM216.6,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
                />
                <path
                  d="M215.2,678.9c1.5,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.9v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.5,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.2-.9,1.2,0,1.6,0,1.8-.1.4-.1.5-.4.5-1v-5.2h-4c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.6-2.4h-7c-1,0-1.4.5-1.4,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.9-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM206.3,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.2-.5-1.2-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM204.9,682.9h10.7v-1.6c0-.4,0-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM204.9,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM216.5,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.5,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
                />
                <path
                  d="M220.3,712.9c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM197.4,712.9c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,709.1c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_7三原1_xFF1A_紫" v-if="this.clickedPointId === 57">
          <g>
            <line class="pn_st0" x1="161.8" y1="686.9" x2="161.8" y2="686.9" />
            <g>
              <line class="pn_st2" x1="161.8" y1="686.9" x2="164.3" y2="686.9" />
              <line class="pn_st28" x1="166.4" y1="686.9" x2="166.4" y2="686.9" />
              <line class="pn_st34" x1="166.4" y1="686.9" x2="188.8" y2="686.9" />
              <line class="pn_st2" x1="188.8" y1="686.9" x2="191.3" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="191.5"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M167.6,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M177.8,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.9,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M185.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M219,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM217.9,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM216.6,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                class="pn_st63"
                d="M215.2,678.9c1.5,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.9v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.5,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.2-.9,1.2,0,1.6,0,1.8-.1.4-.1.5-.4.5-1v-5.2h-4c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.6-2.4h-7c-1,0-1.4.5-1.4,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.9-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM206.3,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.2-.5-1.2-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM204.9,682.9h10.7v-1.6c0-.4,0-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM204.9,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM216.5,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.5,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
              <path
                class="pn_st63"
                d="M220.3,712.9c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM197.4,712.9c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,709.1c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_7三原1_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(57)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="161.8" y1="686.9" x2="161.8" y2="686.9" />
            <g>
              <line class="pn_st2" x1="161.8" y1="686.9" x2="164.3" y2="686.9" />
              <line class="pn_st28" x1="166.4" y1="686.9" x2="166.4" y2="686.9" />
              <line class="pn_st34" x1="166.4" y1="686.9" x2="188.8" y2="686.9" />
              <line class="pn_st2" x1="188.8" y1="686.9" x2="191.3" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M208.5,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M208.5,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M167.6,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M177.8,654.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.9,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M185.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M219,666c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM217.9,648.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM216.6,656.8c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                d="M215.2,678.9c1.5,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.9v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.5,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.2-.9,1.2,0,1.6,0,1.8-.1.4-.1.5-.4.5-1v-5.2h-4c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.6-2.4h-7c-1,0-1.4.5-1.4,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.9-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM206.3,690.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.2-.5-1.2-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM204.9,682.9h10.7v-1.6c0-.4,0-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM204.9,684.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM216.5,691.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.5,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
              <path
                d="M220.3,712.9c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM197.4,712.9c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,709.1c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_6尾道_xFF1A_橙">
          <a @click="sendPointId(56)">
            <g>
              <line class="pn_st0" x1="225.5" y1="686.9" x2="225.5" y2="686.9" />
              <g>
                <line class="pn_st13" x1="225.5" y1="686.9" x2="228" y2="686.9" />
                <line class="pn_st3" x1="230.1" y1="686.9" x2="230.1" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="230.1"
                  y1="686.9"
                  x2="252.5"
                  y2="686.9"
                />
                <line class="pn_st13" x1="252.5" y1="686.9" x2="255" y2="686.9" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M272.2,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M272.2,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M233.3,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st57"
                  d="M242.3,652.1c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M235.6,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M249,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M264.6,657.6c0,2.1,0,6-1.5,9.9-.5,1.5-.9,1.8-1.4,1.8s-1.2-.3-1.2-1.1,0-.5.2-.9c1.2-2.6,1.9-4.9,1.9-9.8v-7.8c0-1.7.5-2.3,2.3-2.3h15.4c1.8,0,2.3.5,2.3,2.3v1.2c0,1.7-.5,2.2-2.3,2.2h-15.7v4.6ZM264.6,651.3h15.2c.4,0,.6-.2.6-.6v-1.1c0-.4-.1-.6-.6-.6h-14.4c-.6,0-.8.3-.8.8v1.5ZM274.1,658.6l7.4-.5c.5,0,1,.1,1,.8s-.4.8-.9.8l-7.5.5v2l8.5-.6c.5,0,1,0,1,.9s-.2.8-.9.8l-8.7.6v2.3c0,1.1.6,1.1,1.4,1.1h3.8c2.2,0,2.2,0,2.4-.7,0-.3.1-1.6.2-1.9.1-.4.6-.4.8-.4.4,0,1.1.1,1.1,1.1s-.2,2.3-.5,2.8c-.5.8-1.5.9-2.9.9h-5.3c-1.9,0-3-.2-3-2.7v-2.5l-6.2.4c-.3,0-1,0-1-.9s.3-.8.9-.8l6.3-.4v-2l-5.4.4c-.3,0-1,0-1-.9s.5-.8.9-.8l5.5-.4v-2c-3,.3-5.2.3-5.4.3-.4,0-1.1,0-1.1-.9s.6-.8,1.2-.8c3.9,0,8.5-.6,10.9-1,.5,0,2.7-.6,3-.6.5,0,.8.5.8,1s-.4.7-1.6,1c-1,.2-3,.5-5.9.8v2.1Z"
                />
                <path
                  d="M282.9,722.3c.7,0,1,.4,1,.9,0,1-.7,1-1.1,1h-10.8c-2.7,0-5.5-.6-7-2.8-.7,1-1.5,1.9-2.5,2.7-.5.4-.7.4-.9.4-.6,0-1.1-.6-1.1-1.2s.1-.5.5-.8c1.6-1.4,1.8-1.5,2.5-2.3v-6.2c0-.3,0-.9-.8-.9h-1.1c-.6,0-1-.3-1-1s.6-1,1.1-1h1.5c1.8,0,2.3.5,2.3,2.3v4.7c0,.6.2,2.3,2.4,3.3,1.2.6,2.6.7,3.9.7h11ZM264,703.3c.4.4,1.2,1.2,1.8,1.9.3.3.3.5.3.7,0,.6-.5,1.2-1.1,1.2s-.5-.1-1.4-1.1c-.4-.4-1.3-1.3-2.2-2.2-.3-.3-.3-.4-.3-.7,0-.4.3-1.1,1.1-1.1s.8.3,1.8,1.3ZM279.7,708c1.6,0,2.3.6,2.3,2.3v7.8c0,1.7-.6,2.3-2.3,2.3h-9.1c-1.6,0-2.3-.6-2.3-2.3v-7.8c0-1.7.6-2.3,2.3-2.3h2.4c.4-1.1.5-1.5.6-1.8h-6.1c-.3,0-1,0-1-.9s.6-.9,1-.9h3.4c-.3-.5-.4-.6-.9-1.5-.2-.2-.2-.4-.2-.6,0-.4.3-.8,1.1-.8s.7.2.9.6c.5.8,1,1.7,1.3,2.3h3.7c.4-.7.8-1.5,1-2.2.1-.3.3-.8,1-.8s1.1.3,1.1.8-.1.6-.2.7c-.2.3-.3.7-.8,1.4h3.8c.2,0,1,0,1,.9s-.7.9-1,.9h-7c-.3.8-.4,1.2-.7,1.8h4.6ZM280,711.7v-1.3c0-.6-.3-.8-.8-.8h-8c-.5,0-.8.2-.8.8v1.3h9.6ZM280,713.2h-9.6v2h9.6v-2ZM280,716.6h-9.6v1.4c0,.5.2.8.8.8h8c.5,0,.8-.2.8-.8v-1.4Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_6尾道_xFF1A_紫" v-if="this.clickedPointId === 56">
          <g>
            <line class="pn_st0" x1="225.5" y1="686.9" x2="225.5" y2="686.9" />
            <g>
              <line class="pn_st2" x1="225.5" y1="686.9" x2="228" y2="686.9" />
              <line class="pn_st28" x1="230.1" y1="686.9" x2="230.1" y2="686.9" />
              <line class="pn_st34" x1="230.1" y1="686.9" x2="252.5" y2="686.9" />
              <line class="pn_st2" x1="252.5" y1="686.9" x2="255" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="255.2"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M233.3,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M242.3,652.1c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.6,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M249,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M264.6,657.6c0,2.1,0,6-1.5,9.9-.5,1.5-.9,1.8-1.4,1.8s-1.2-.3-1.2-1.1,0-.5.2-.9c1.2-2.6,1.9-4.9,1.9-9.8v-7.8c0-1.7.5-2.3,2.3-2.3h15.4c1.8,0,2.3.5,2.3,2.3v1.2c0,1.7-.5,2.2-2.3,2.2h-15.7v4.6ZM264.6,651.3h15.2c.4,0,.6-.2.6-.6v-1.1c0-.4-.1-.6-.6-.6h-14.4c-.6,0-.8.3-.8.8v1.5ZM274.1,658.6l7.4-.5c.5,0,1,.1,1,.8s-.4.8-.9.8l-7.5.5v2l8.5-.6c.5,0,1,0,1,.9s-.2.8-.9.8l-8.7.6v2.3c0,1.1.6,1.1,1.4,1.1h3.8c2.2,0,2.2,0,2.4-.7,0-.3.1-1.6.2-1.9.1-.4.6-.4.8-.4.4,0,1.1.1,1.1,1.1s-.2,2.3-.5,2.8c-.5.8-1.5.9-2.9.9h-5.3c-1.9,0-3-.2-3-2.7v-2.5l-6.2.4c-.3,0-1,0-1-.9s.3-.8.9-.8l6.3-.4v-2l-5.4.4c-.3,0-1,0-1-.9s.5-.8.9-.8l5.5-.4v-2c-3,.3-5.2.3-5.4.3-.4,0-1.1,0-1.1-.9s.6-.8,1.2-.8c3.9,0,8.5-.6,10.9-1,.5,0,2.7-.6,3-.6.5,0,.8.5.8,1s-.4.7-1.6,1c-1,.2-3,.5-5.9.8v2.1Z"
              />
              <path
                class="pn_st63"
                d="M282.9,722.3c.7,0,1,.4,1,.9,0,1-.7,1-1.1,1h-10.8c-2.7,0-5.5-.6-7-2.8-.7,1-1.5,1.9-2.5,2.7-.5.4-.7.4-.9.4-.6,0-1.1-.6-1.1-1.2s.1-.5.5-.8c1.6-1.4,1.8-1.5,2.5-2.3v-6.2c0-.3,0-.9-.8-.9h-1.1c-.6,0-1-.3-1-1s.6-1,1.1-1h1.5c1.8,0,2.3.5,2.3,2.3v4.7c0,.6.2,2.3,2.4,3.3,1.2.6,2.6.7,3.9.7h11ZM264,703.3c.4.4,1.2,1.2,1.8,1.9.3.3.3.5.3.7,0,.6-.5,1.2-1.1,1.2s-.5-.1-1.4-1.1c-.4-.4-1.3-1.3-2.2-2.2-.3-.3-.3-.4-.3-.7,0-.4.3-1.1,1.1-1.1s.8.3,1.8,1.3ZM279.7,708c1.6,0,2.3.6,2.3,2.3v7.8c0,1.7-.6,2.3-2.3,2.3h-9.1c-1.6,0-2.3-.6-2.3-2.3v-7.8c0-1.7.6-2.3,2.3-2.3h2.4c.4-1.1.5-1.5.6-1.8h-6.1c-.3,0-1,0-1-.9s.6-.9,1-.9h3.4c-.3-.5-.4-.6-.9-1.5-.2-.2-.2-.4-.2-.6,0-.4.3-.8,1.1-.8s.7.2.9.6c.5.8,1,1.7,1.3,2.3h3.7c.4-.7.8-1.5,1-2.2.1-.3.3-.8,1-.8s1.1.3,1.1.8-.1.6-.2.7c-.2.3-.3.7-.8,1.4h3.8c.2,0,1,0,1,.9s-.7.9-1,.9h-7c-.3.8-.4,1.2-.7,1.8h4.6ZM280,711.7v-1.3c0-.6-.3-.8-.8-.8h-8c-.5,0-.8.2-.8.8v1.3h9.6ZM280,713.2h-9.6v2h9.6v-2ZM280,716.6h-9.6v1.4c0,.5.2.8.8.8h8c.5,0,.8-.2.8-.8v-1.4Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_6尾道_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(56)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="225.5" y1="686.9" x2="225.5" y2="686.9" />
            <g>
              <line class="pn_st2" x1="225.5" y1="686.9" x2="228" y2="686.9" />
              <line class="pn_st28" x1="230.1" y1="686.9" x2="230.1" y2="686.9" />
              <line class="pn_st34" x1="230.1" y1="686.9" x2="252.5" y2="686.9" />
              <line class="pn_st2" x1="252.5" y1="686.9" x2="255" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M272.2,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M272.2,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M233.3,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M242.3,652.1c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.6,669.3c.1,0,.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.9,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="spn_t60">
              <path
                d="M264.6,657.6c0,2.1,0,6-1.5,9.9-.5,1.5-.9,1.8-1.4,1.8s-1.2-.3-1.2-1.1,0-.5.2-.9c1.2-2.6,1.9-4.9,1.9-9.8v-7.8c0-1.7.5-2.3,2.3-2.3h15.4c1.8,0,2.3.5,2.3,2.3v1.2c0,1.7-.5,2.2-2.3,2.2h-15.7v4.6ZM264.6,651.3h15.2c.4,0,.6-.2.6-.6v-1.1c0-.4-.1-.6-.6-.6h-14.4c-.6,0-.8.3-.8.8v1.5ZM274.1,658.6l7.4-.5c.5,0,1,.1,1,.8s-.4.8-.9.8l-7.5.5v2l8.5-.6c.5,0,1,0,1,.9s-.2.8-.9.8l-8.7.6v2.3c0,1.1.6,1.1,1.4,1.1h3.8c2.2,0,2.2,0,2.4-.7,0-.3.1-1.6.2-1.9.1-.4.6-.4.8-.4.4,0,1.1.1,1.1,1.1s-.2,2.3-.5,2.8c-.5.8-1.5.9-2.9.9h-5.3c-1.9,0-3-.2-3-2.7v-2.5l-6.2.4c-.3,0-1,0-1-.9s.3-.8.9-.8l6.3-.4v-2l-5.4.4c-.3,0-1,0-1-.9s.5-.8.9-.8l5.5-.4v-2c-3,.3-5.2.3-5.4.3-.4,0-1.1,0-1.1-.9s.6-.8,1.2-.8c3.9,0,8.5-.6,10.9-1,.5,0,2.7-.6,3-.6.5,0,.8.5.8,1s-.4.7-1.6,1c-1,.2-3,.5-5.9.8v2.1Z"
              />
              <path
                d="M282.9,722.3c.7,0,1,.4,1,.9,0,1-.7,1-1.1,1h-10.8c-2.7,0-5.5-.6-7-2.8-.7,1-1.5,1.9-2.5,2.7-.5.4-.7.4-.9.4-.6,0-1.1-.6-1.1-1.2s.1-.5.5-.8c1.6-1.4,1.8-1.5,2.5-2.3v-6.2c0-.3,0-.9-.8-.9h-1.1c-.6,0-1-.3-1-1s.6-1,1.1-1h1.5c1.8,0,2.3.5,2.3,2.3v4.7c0,.6.2,2.3,2.4,3.3,1.2.6,2.6.7,3.9.7h11ZM264,703.3c.4.4,1.2,1.2,1.8,1.9.3.3.3.5.3.7,0,.6-.5,1.2-1.1,1.2s-.5-.1-1.4-1.1c-.4-.4-1.3-1.3-2.2-2.2-.3-.3-.3-.4-.3-.7,0-.4.3-1.1,1.1-1.1s.8.3,1.8,1.3ZM279.7,708c1.6,0,2.3.6,2.3,2.3v7.8c0,1.7-.6,2.3-2.3,2.3h-9.1c-1.6,0-2.3-.6-2.3-2.3v-7.8c0-1.7.6-2.3,2.3-2.3h2.4c.4-1.1.5-1.5.6-1.8h-6.1c-.3,0-1,0-1-.9s.6-.9,1-.9h3.4c-.3-.5-.4-.6-.9-1.5-.2-.2-.2-.4-.2-.6,0-.4.3-.8,1.1-.8s.7.2.9.6c.5.8,1,1.7,1.3,2.3h3.7c.4-.7.8-1.5,1-2.2.1-.3.3-.8,1-.8s1.1.3,1.1.8-.1.6-.2.7c-.2.3-.3.7-.8,1.4h3.8c.2,0,1,0,1,.9s-.7.9-1,.9h-7c-.3.8-.4,1.2-.7,1.8h4.6ZM280,711.7v-1.3c0-.6-.3-.8-.8-.8h-8c-.5,0-.8.2-.8.8v1.3h9.6ZM280,713.2h-9.6v2h9.6v-2ZM280,716.6h-9.6v1.4c0,.5.2.8.8.8h8c.5,0,.8-.2.8-.8v-1.4Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_5因島_xFF1A_橙">
          <a @click="sendPointId(55)">
            <g>
              <line class="pn_st0" x1="289.2" y1="686.9" x2="289.2" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="289.2"
                  y1="686.9"
                  x2="291.7"
                  y2="686.9"
                />
                <line class="pn_st3" x1="293.8" y1="686.9" x2="293.8" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="293.8"
                  y1="686.9"
                  x2="316.2"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="316.2"
                  y1="686.9"
                  x2="318.7"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M335.8,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M335.8,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M346.5,667.2c0,2.4-.8,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM344.4,652.1c0-.9-.4-1.5-1.5-1.5h-14.2c-1.1,0-1.5.6-1.5,1.5v15c0,1,.5,1.5,1.5,1.5h14.2c1.1,0,1.5-.5,1.5-1.5v-15ZM329,657.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.9v-3c0-.2,0-1,1-1s1.1.7,1.1,1v2.1c0,.4,0,.7,0,.8h5.8c.3,0,1,0,1,.9s-.6.9-1,.9h-5.7c.2,1,.6,3.1,3.3,5.7.4.3.6.5,2.7,1.9.5.3.5.7.5.8,0,.5-.4,1.2-1.1,1.2s-.9-.3-1.8-1c-2.1-1.6-3.9-3.6-4.8-6.1-.4,1-1.4,3.5-4.7,6-.5.4-1.5,1.2-2,1.2s-1.1-.7-1.1-1.2.3-.6.6-.8c2.5-1.7,5.1-3.4,5.9-7.6h-5.6Z"
                />
                <path
                  d="M330.8,723v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.9.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.8,0,2.2,0s1.3,0,1.6-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.4ZM328.7,708.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM342.6,709.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M293.9,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M314.3,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.6,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M299.3,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M312.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_5因島_xFF1A_紫" v-if="this.clickedPointId === 55">
          <g>
            <line class="pn_st0" x1="289.2" y1="686.9" x2="289.2" y2="686.9" />
            <g>
              <line class="pn_st2" x1="289.2" y1="686.9" x2="291.7" y2="686.9" />
              <line class="pn_st28" x1="293.8" y1="686.9" x2="293.8" y2="686.9" />
              <line class="pn_st34" x1="293.8" y1="686.9" x2="316.2" y2="686.9" />
              <line class="pn_st2" x1="316.2" y1="686.9" x2="318.7" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="318.8"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M346.5,667.2c0,2.4-.8,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM344.4,652.1c0-.9-.4-1.5-1.5-1.5h-14.2c-1.1,0-1.5.6-1.5,1.5v15c0,1,.5,1.5,1.5,1.5h14.2c1.1,0,1.5-.5,1.5-1.5v-15ZM329,657.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.9v-3c0-.2,0-1,1-1s1.1.7,1.1,1v2.1c0,.4,0,.7,0,.8h5.8c.3,0,1,0,1,.9s-.6.9-1,.9h-5.7c.2,1,.6,3.1,3.3,5.7.4.3.6.5,2.7,1.9.5.3.5.7.5.8,0,.5-.4,1.2-1.1,1.2s-.9-.3-1.8-1c-2.1-1.6-3.9-3.6-4.8-6.1-.4,1-1.4,3.5-4.7,6-.5.4-1.5,1.2-2,1.2s-1.1-.7-1.1-1.2.3-.6.6-.8c2.5-1.7,5.1-3.4,5.9-7.6h-5.6Z"
              />
              <path
                class="pn_st63"
                d="M330.8,723v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.9.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.8,0,2.2,0s1.3,0,1.6-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.4ZM328.7,708.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM342.6,709.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.9,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M314.3,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.6,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M299.3,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_5因島_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(55)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="289.2" y1="686.9" x2="289.2" y2="686.9" />
            <g>
              <line class="pn_st2" x1="289.2" y1="686.9" x2="291.7" y2="686.9" />
              <line class="pn_st28" x1="293.8" y1="686.9" x2="293.8" y2="686.9" />
              <line class="pn_st34" x1="293.8" y1="686.9" x2="316.2" y2="686.9" />
              <line class="pn_st2" x1="316.2" y1="686.9" x2="318.7" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M335.8,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M335.8,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M346.5,667.2c0,2.4-.8,3.2-3.2,3.2h-14.8c-2.3,0-3.2-.8-3.2-3.2v-15.3c0-2.5.9-3.2,3.2-3.2h14.8c2.3,0,3.2.8,3.2,3.2v15.3ZM344.4,652.1c0-.9-.4-1.5-1.5-1.5h-14.2c-1.1,0-1.5.6-1.5,1.5v15c0,1,.5,1.5,1.5,1.5h14.2c1.1,0,1.5-.5,1.5-1.5v-15ZM329,657.4c-.3,0-1,0-1-.9s.7-.9,1-.9h5.9v-3c0-.2,0-1,1-1s1.1.7,1.1,1v2.1c0,.4,0,.7,0,.8h5.8c.3,0,1,0,1,.9s-.6.9-1,.9h-5.7c.2,1,.6,3.1,3.3,5.7.4.3.6.5,2.7,1.9.5.3.5.7.5.8,0,.5-.4,1.2-1.1,1.2s-.9-.3-1.8-1c-2.1-1.6-3.9-3.6-4.8-6.1-.4,1-1.4,3.5-4.7,6-.5.4-1.5,1.2-2,1.2s-1.1-.7-1.1-1.2.3-.6.6-.8c2.5-1.7,5.1-3.4,5.9-7.6h-5.6Z"
              />
              <path
                d="M330.8,723v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.3c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.9.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.8,0,2.2,0s1.3,0,1.6-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.4ZM328.7,708.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.6,0-.8.3-.8.8v.9ZM342.6,709.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.9,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M314.3,657.6c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.6,657.6c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M299.3,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.6,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_4今治2_xFF1A_橙">
          <a @click="sendPointId(54)">
            <g>
              <line class="pn_st0" x1="352.8" y1="686.9" x2="352.8" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="352.8"
                  y1="686.9"
                  x2="355.3"
                  y2="686.9"
                />
                <line class="pn_st3" x1="357.4" y1="686.9" x2="357.4" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="357.4"
                  y1="686.9"
                  x2="379.8"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="379.8"
                  y1="686.9"
                  x2="382.3"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M399.5,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M399.5,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M360.7,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st57"
                  d="M372.9,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M363,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M376.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M398.8,649.2c-1.5,1.9-3.5,3.5-5.5,4.8-.5.3-3.5,2.3-4.5,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8-5.5.3-.3,1.5-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.5,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM390.7,659.7c-.2,0-1.1,0-1.1-1s.8-1,1.1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.1-.6h-14.1ZM394.6,655.4c-.3,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
                />
                <path
                  d="M390.7,681.6c.5.3,1.4.9,1.9,1.3.4.3.4.5.4.8,0,.6-.6,1.2-1.1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM393.5,689.9c-1,2.5-2.3,4.8-3.1,6-.5.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM392.3,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.1-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM399.2,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.6.2.7.3c.4.3,1.2,1.5,1.9,2.5.7.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.4.2-2.2.1-6.6.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM409.4,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.9-2.7,2.7-2.7h8.2c1.8,0,2.7.6,2.7,2.7v4.9ZM407.2,689.5c0-.7-.4-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.4,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
                />
                <path
                  d="M411.4,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM388.5,713.1c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM403.6,718.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_4今治2_xFF1A_紫" v-if="this.clickedPointId === 54">
          <g>
            <line class="pn_st0" x1="352.8" y1="686.9" x2="352.8" y2="686.9" />
            <g>
              <line class="pn_st2" x1="352.8" y1="686.9" x2="355.3" y2="686.9" />
              <line class="pn_st28" x1="357.4" y1="686.9" x2="357.4" y2="686.9" />
              <line class="pn_st34" x1="357.4" y1="686.9" x2="379.8" y2="686.9" />
              <line class="pn_st2" x1="379.8" y1="686.9" x2="382.3" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="382.5"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M360.7,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M372.9,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M363,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M398.8,649.2c-1.5,1.9-3.5,3.5-5.5,4.8-.5.3-3.5,2.3-4.5,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8-5.5.3-.3,1.5-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.5,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM390.7,659.7c-.2,0-1.1,0-1.1-1s.8-1,1.1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.1-.6h-14.1ZM394.6,655.4c-.3,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
              />
              <path
                class="pn_st63"
                d="M390.7,681.6c.5.3,1.4.9,1.9,1.3.4.3.4.5.4.8,0,.6-.6,1.2-1.1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM393.5,689.9c-1,2.5-2.3,4.8-3.1,6-.5.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM392.3,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.1-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM399.2,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.6.2.7.3c.4.3,1.2,1.5,1.9,2.5.7.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.4.2-2.2.1-6.6.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM409.4,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.9-2.7,2.7-2.7h8.2c1.8,0,2.7.6,2.7,2.7v4.9ZM407.2,689.5c0-.7-.4-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.4,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
              />
              <path
                class="pn_st63"
                d="M411.4,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM388.5,713.1c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM403.6,718.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_4今治2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(54)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="352.8" y1="686.9" x2="352.8" y2="686.9" />
            <g>
              <line class="pn_st2" x1="352.8" y1="686.9" x2="355.3" y2="686.9" />
              <line class="pn_st28" x1="357.4" y1="686.9" x2="357.4" y2="686.9" />
              <line class="pn_st34" x1="357.4" y1="686.9" x2="379.8" y2="686.9" />
              <line class="pn_st2" x1="379.8" y1="686.9" x2="382.3" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M399.5,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M399.5,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M360.7,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M372.9,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M363,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.3,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M398.8,649.2c-1.5,1.9-3.5,3.5-5.5,4.8-.5.3-3.5,2.3-4.5,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8-5.5.3-.3,1.5-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.5,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM390.7,659.7c-.2,0-1.1,0-1.1-1s.8-1,1.1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.1-.6h-14.1ZM394.6,655.4c-.3,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
              />
              <path
                d="M390.7,681.6c.5.3,1.4.9,1.9,1.3.4.3.4.5.4.8,0,.6-.6,1.2-1.1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM393.5,689.9c-1,2.5-2.3,4.8-3.1,6-.5.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM392.3,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.1-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM399.2,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.6.2.7.3c.4.3,1.2,1.5,1.9,2.5.7.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.4.2-2.2.1-6.6.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM409.4,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.9-2.7,2.7-2.7h8.2c1.8,0,2.7.6,2.7,2.7v4.9ZM407.2,689.5c0-.7-.4-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.4,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
              />
              <path
                d="M411.4,713.1c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM388.5,713.1c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM403.6,718.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_3今治1_xFF1A_橙">
          <a @click="sendPointId(53)">
            <g>
              <line class="pn_st0" x1="416.6" y1="686.9" x2="416.6" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="416.6"
                  y1="686.9"
                  x2="419.1"
                  y2="686.9"
                />
                <line class="pn_st3" x1="421.2" y1="686.9" x2="421.2" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="421.2"
                  y1="686.9"
                  x2="443.6"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="443.6"
                  y1="686.9"
                  x2="446.1"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M463.2,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M463.2,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M421.4,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M436.5,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M426.7,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M440,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M462.5,649.2c-1.5,1.9-3.4,3.5-5.5,4.8-.4.3-3.5,2.3-4.4,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8.1-5.5.3-.3,1.4-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.6,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM454.4,659.7c-.2,0-1,0-1-1s.8-1,1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.2-.6h-14.1ZM458.3,655.4c-.4,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
                />
                <path
                  d="M454.4,681.6c.5.3,1.4.9,1.9,1.3.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM457.2,689.9c-1,2.5-2.3,4.8-3.1,6-.6.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM456,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.2-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM462.9,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.5.2.7.3c.4.3,1.2,1.5,1.9,2.5.6.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.3.2-2.2.1-6.7.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM473.1,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.8-2.7,2.7-2.7h8.2c1.9,0,2.7.6,2.7,2.7v4.9ZM470.9,689.5c0-.7-.3-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.3,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
                />
                <path
                  d="M475.1,713.1c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM452.2,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,709.3c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_3今治1_xFF1A_紫" v-if="this.clickedPointId === 53">
          <g>
            <line class="pn_st0" x1="416.6" y1="686.9" x2="416.6" y2="686.9" />
            <g>
              <line class="pn_st2" x1="416.6" y1="686.9" x2="419.1" y2="686.9" />
              <line class="pn_st28" x1="421.2" y1="686.9" x2="421.2" y2="686.9" />
              <line class="pn_st34" x1="421.2" y1="686.9" x2="443.6" y2="686.9" />
              <line class="pn_st2" x1="443.6" y1="686.9" x2="446.1" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="446.2"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M421.4,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M436.5,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426.7,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M440,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M462.5,649.2c-1.5,1.9-3.4,3.5-5.5,4.8-.4.3-3.5,2.3-4.4,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8.1-5.5.3-.3,1.4-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.6,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM454.4,659.7c-.2,0-1,0-1-1s.8-1,1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.2-.6h-14.1ZM458.3,655.4c-.4,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
              />
              <path
                class="pn_st63"
                d="M454.4,681.6c.5.3,1.4.9,1.9,1.3.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM457.2,689.9c-1,2.5-2.3,4.8-3.1,6-.6.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM456,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.2-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM462.9,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.5.2.7.3c.4.3,1.2,1.5,1.9,2.5.6.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.3.2-2.2.1-6.7.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM473.1,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.8-2.7,2.7-2.7h8.2c1.9,0,2.7.6,2.7,2.7v4.9ZM470.9,689.5c0-.7-.3-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.3,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
              />
              <path
                class="pn_st63"
                d="M475.1,713.1c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM452.2,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,709.3c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_3今治1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(53)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="416.6" y1="686.9" x2="416.6" y2="686.9" />
            <g>
              <line class="pn_st2" x1="416.6" y1="686.9" x2="419.1" y2="686.9" />
              <line class="pn_st28" x1="421.2" y1="686.9" x2="421.2" y2="686.9" />
              <line class="pn_st34" x1="421.2" y1="686.9" x2="443.6" y2="686.9" />
              <line class="pn_st2" x1="443.6" y1="686.9" x2="446.1" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M463.2,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M463.2,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,631.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M421.4,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M436.5,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426.7,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M440,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M462.5,649.2c-1.5,1.9-3.4,3.5-5.5,4.8-.4.3-3.5,2.3-4.4,2.3s-1.1-.7-1.1-1.3.4-.8.9-1c2.2-.9,5.6-2.8,8.1-5.5.3-.3,1.4-1.7,1.8-1.9.3-.2.6-.3,1.1-.3.8,0,1.1.3,1.6.9,1.5,1.7,3.6,4.2,8.2,6.4.2.1,1.3.6,1.5.7.3.2.4.5.4.8,0,.5-.2,1.3-1.1,1.3s-4.7-2-7.9-5c-1-1-1.4-1.4-2.3-2.5-.2-.3-.3-.3-.5-.3s-.2,0-.8.7ZM454.4,659.7c-.2,0-1,0-1-1s.8-1,1-1h15.2c1.2,0,2.8,0,2.8,1.8s-2.4,5.2-5.1,7.3c-2.1,1.7-5,3-6,3s-1.1-.6-1.1-1.2.3-.8.9-1c1.4-.5,4.8-1.8,7.4-5.2.5-.6,1.1-1.7,1.1-2.2s-.5-.6-1.2-.6h-14.1ZM458.3,655.4c-.4,0-1,0-1-1s.5-1,1-1h9.7c.3,0,1,0,1,1s-.5,1-1,1h-9.7Z"
              />
              <path
                d="M454.4,681.6c.5.3,1.4.9,1.9,1.3.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.8c-.3-.2-1.7-1.2-2.3-1.5-.3-.2-.5-.5-.5-.8,0-.6.5-1.1,1-1.1s.4,0,1.8.9ZM457.2,689.9c-1,2.5-2.3,4.8-3.1,6-.6.9-.8,1.2-1.3,1.2s-1.1-.5-1.1-1.1,0-.4,1.2-2.1c.6-.9,1.9-3.3,2.9-5.8.2-.4.3-.8.9-.8s1,.6,1,.9c0,.4,0,.5-.6,1.8ZM456,675.5c2.1,1.3,2.1,1.5,2.1,1.9,0,.6-.5,1.2-1,1.2s-.4,0-1.3-.7c-.8-.6-1.2-.8-2.4-1.5-.4-.2-.7-.4-.7-.9s.5-1,.9-1,1.8.8,2.4,1.1ZM462.9,676.4c.9-2.4.9-2.4,1.6-2.4s1.2.3,1.2.9-1.3,3.9-3.1,7.3c3.2,0,6.1-.1,8.5-.3-.7-1.2-.8-1.3-2.1-3-.1-.2-.3-.4-.3-.8,0-.5.6-.9,1.1-.9s.5.2.7.3c.4.3,1.2,1.5,1.9,2.5.6.9,2.3,3.5,2.3,4.3s-.6,1-1.2,1-.5,0-.8-.3c-.1-.2-.5-1.2-.7-1.4-1.7.1-2.9.2-4.3.2-2.2.1-6.7.2-8.8.2s-1.1,0-1.1-1,0-.7.5-.9c.2,0,1.3,0,1.9,0,1.4-2.8,2.4-5.2,2.6-5.8ZM473.1,694.1c0,2-.8,2.7-2.7,2.7h-8.2c-1.9,0-2.7-.6-2.7-2.7v-4.9c0-2.1.8-2.7,2.7-2.7h8.2c1.9,0,2.7.6,2.7,2.7v4.9ZM470.9,689.5c0-.7-.3-1.1-1.1-1.1h-7.1c-.8,0-1.1.4-1.1,1.1v4.3c0,.8.3,1.1,1.1,1.1h7.1c.8,0,1.1-.3,1.1-1.1v-4.3Z"
              />
              <path
                d="M475.1,713.1c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM452.2,713.1c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,709.3c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_2西条_xFF1A_橙">
          <a @click="sendPointId(52)">
            <g>
              <line class="pn_st0" x1="480.3" y1="686.9" x2="480.3" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="480.3"
                  y1="686.9"
                  x2="482.8"
                  y2="686.9"
                />
                <line class="pn_st3" x1="484.9" y1="686.9" x2="484.9" y2="686.9" />
                <line
                  class="pn_st38"
                  x1="484.9"
                  y1="686.9"
                  x2="507.3"
                  y2="686.9"
                />
                <line
                  class="pn_st13"
                  x1="507.3"
                  y1="686.9"
                  x2="509.8"
                  y2="686.9"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M527,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M527,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M485.1,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M503.8,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M490.4,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M503.7,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M516.3,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM522.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM528,649.3h-3.7v3.6h3.7v-3.6Z"
                />
                <path
                  d="M529.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM532,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM523.5,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_2西条_xFF1A_紫" v-if="this.clickedPointId === 52">
          <g>
            <line class="pn_st0" x1="480.3" y1="686.9" x2="480.3" y2="686.9" />
            <g>
              <line class="pn_st2" x1="480.3" y1="686.9" x2="482.8" y2="686.9" />
              <line class="pn_st28" x1="484.9" y1="686.9" x2="484.9" y2="686.9" />
              <line class="pn_st34" x1="484.9" y1="686.9" x2="507.3" y2="686.9" />
              <line class="pn_st2" x1="507.3" y1="686.9" x2="509.8" y2="686.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="510"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.1,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M503.8,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490.4,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.7,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M516.3,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM522.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM528,649.3h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                class="pn_st63"
                d="M529.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM532,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM523.5,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x35_2西条_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(52)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="480.3" y1="686.9" x2="480.3" y2="686.9" />
            <g>
              <line class="pn_st2" x1="480.3" y1="686.9" x2="482.8" y2="686.9" />
              <line class="pn_st28" x1="484.9" y1="686.9" x2="484.9" y2="686.9" />
              <line class="pn_st34" x1="484.9" y1="686.9" x2="507.3" y2="686.9" />
              <line class="pn_st2" x1="507.3" y1="686.9" x2="509.8" y2="686.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M527,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M527,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.1,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M503.8,650.4c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490.4,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.7,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M516.3,649.3c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM522.4,654.7h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM528,649.3h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                d="M529.4,716.1c3,3.3,5.9,4.8,8.2,5.7.4.2.8.3.8.8s-.4,1.3-1.1,1.3-2.3-1-2.9-1.4c-2.4-1.4-4.5-3.2-6.3-5.4v6.8c0,.8-.3,1-1.1,1s-1-.7-1-1v-6.7c-.7.8-2.2,2.6-4.9,4.4-1.5,1-3.8,2.3-4.3,2.3s-1.1-.7-1.1-1.3.3-.7.7-.9c4.7-1.9,7-4.3,8.3-5.7h-8.3c-.3,0-1,0-1-.9s.7-.9,1-.9h9.6v-1.5c0-.8.4-.9,1.1-.9s1,.6,1,.9v1.5h9.6c.3,0,1,0,1,.9s-.7.9-1,.9h-8.2ZM532,703.2c.8,0,2.1,0,2.1,1.5s-3.3,3.9-4.7,4.6c3.3,1.1,5.8,1.3,7.8,1.5.6,0,1.1.1,1.1.9s0,1.2-1,1.2-5.4-.4-10.2-2.5c-1.4.5-2.9,1.1-5.9,1.8-2.2.5-4.2.7-4.7.7-.9,0-1-.9-1-1.1,0-.9.6-.9,1.1-1,2.8-.2,5.5-.7,8.1-1.6-1.2-.8-2.2-1.4-3.6-2.7-1.9,1.2-3.7,2-4.4,2s-.9-.7-.9-1.1.4-.7.8-.9c1.4-.5,4.6-2.2,6-3.6.2-.2,1.5-1.4,1.6-1.5.1-.1.4-.2.8-.2.7,0,1.1.4,1.1.8s-.2.5-.8,1.2h6.7ZM523.5,704.9c-.3.2-.5.4-.8.6,1.4,1.2,2.7,2.1,4.4,2.8,2.8-1.2,4.2-2.7,4.2-3.1s-.3-.4-.8-.4h-7Z"
              />
            </g>
          </g>
        </g>
        <g id="_x35_1東温山_xFF1A_橙">
          <a @click="sendPointId(51)">
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M552.4,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st57"
                d="M561.3,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M554.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M568.1,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <path
                class="pn_st67"
                d="M590.7,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M590.7,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M598.2,652.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM589.5,656.1v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM589.5,657.7h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM591.6,656.1h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM591.6,657.7v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
                />
                <path
                  d="M585,688.3c0,.7-1.5,4.1-3,6.6-1.3,2-1.5,2-1.9,2s-1.1-.5-1.1-1.1.1-.5,1.3-2.2c.4-.6,1.7-2.7,2.8-5.5.2-.6.4-.9.9-.9s1.1.4,1.1,1ZM580,680.8c.5,0,2,1.1,2.6,1.5,1.2.9,1.5,1.1,1.5,1.5s-.5,1.2-1.1,1.2-.4,0-1.2-.8c-.5-.4-1.3-.9-2.1-1.5-.3-.2-.6-.4-.6-.8,0-.6.4-1.2,1-1.2ZM581.1,674.3c.6,0,2.5,1.2,3.2,1.7.9.6,1.1.8,1.1,1.2,0,.7-.6,1.2-1,1.2s-.4-.1-1.7-1c-.4-.3-1.9-1.2-2.2-1.4-.2-.2-.3-.3-.3-.7s.3-1,1-1ZM586.4,694.8v-6.1c0-1.7.7-2.3,2.3-2.3h10.1c1.7,0,2.3.6,2.3,2.3v6.1c.6,0,1.2,0,1.2.9s-.7.9-1,.9h-16c-.2,0-1,0-1-.9s.8-.9,1-.9h1ZM600.5,682c0,1.7-.6,2.3-2.3,2.3h-9c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.6-2.3,2.3-2.3h9c1.7,0,2.3.6,2.3,2.3v5ZM590.7,694.8v-6.7h-1.7c-.7,0-.8.4-.8.8v5.9h2.6ZM588.9,678.8h9.7v-1.5c0-.4-.1-.8-.8-.8h-8c-.7,0-.8.5-.8.8v1.5ZM588.9,680.3v1.6c0,.4.1.8.8.8h8c0,0,.4,0,.5,0,.3-.2.3-.6.3-.7v-1.5h-9.7ZM594.9,694.8v-6.7h-2.5v6.7h2.5ZM599.3,694.8v-5.9c0-.4-.1-.8-.8-.8h-1.9v6.7h2.7Z"
                />
                <path
                  d="M589.6,702.4c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
                />
              </g>
            </g>
            <g>
              <line class="pn_st0" x1="573.7" y1="686.9" x2="573.7" y2="686.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="573.7"
                  y1="686.9"
                  x2="571.2"
                  y2="686.9"
                />
                <line class="pn_st4" x1="569" y1="686.9" x2="569" y2="686.9" />
                <line class="pn_st53" x1="569" y1="686.9" x2="546.4" y2="686.9" />
                <line
                  class="pn_st13"
                  x1="546.4"
                  y1="686.9"
                  x2="543.9"
                  y2="686.9"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_1東温山_xFF1A_紫" v-if="this.clickedPointId === 51">
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M552.4,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st71"
              d="M561.3,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M554.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M568.1,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <rect
            class="pn_st61"
            x="573.7"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M598.2,652.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM589.5,656.1v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM589.5,657.7h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM591.6,656.1h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM591.6,657.7v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
              />
              <path
                class="pn_st63"
                d="M585,688.3c0,.7-1.5,4.1-3,6.6-1.3,2-1.5,2-1.9,2s-1.1-.5-1.1-1.1.1-.5,1.3-2.2c.4-.6,1.7-2.7,2.8-5.5.2-.6.4-.9.9-.9s1.1.4,1.1,1ZM580,680.8c.5,0,2,1.1,2.6,1.5,1.2.9,1.5,1.1,1.5,1.5s-.5,1.2-1.1,1.2-.4,0-1.2-.8c-.5-.4-1.3-.9-2.1-1.5-.3-.2-.6-.4-.6-.8,0-.6.4-1.2,1-1.2ZM581.1,674.3c.6,0,2.5,1.2,3.2,1.7.9.6,1.1.8,1.1,1.2,0,.7-.6,1.2-1,1.2s-.4-.1-1.7-1c-.4-.3-1.9-1.2-2.2-1.4-.2-.2-.3-.3-.3-.7s.3-1,1-1ZM586.4,694.8v-6.1c0-1.7.7-2.3,2.3-2.3h10.1c1.7,0,2.3.6,2.3,2.3v6.1c.6,0,1.2,0,1.2.9s-.7.9-1,.9h-16c-.2,0-1,0-1-.9s.8-.9,1-.9h1ZM600.5,682c0,1.7-.6,2.3-2.3,2.3h-9c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.6-2.3,2.3-2.3h9c1.7,0,2.3.6,2.3,2.3v5ZM590.7,694.8v-6.7h-1.7c-.7,0-.8.4-.8.8v5.9h2.6ZM588.9,678.8h9.7v-1.5c0-.4-.1-.8-.8-.8h-8c-.7,0-.8.5-.8.8v1.5ZM588.9,680.3v1.6c0,.4.1.8.8.8h8c0,0,.4,0,.5,0,.3-.2.3-.6.3-.7v-1.5h-9.7ZM594.9,694.8v-6.7h-2.5v6.7h2.5ZM599.3,694.8v-5.9c0-.4-.1-.8-.8-.8h-1.9v6.7h2.7Z"
              />
              <path
                class="pn_st63"
                d="M589.6,702.4c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="686.9" x2="573.7" y2="686.9" />
            <g>
              <line class="pn_st2" x1="573.7" y1="686.9" x2="571.2" y2="686.9" />
              <line class="pn_st12" x1="569" y1="686.9" x2="569" y2="686.9" />
              <line class="pn_st5" x1="569" y1="686.9" x2="546.4" y2="686.9" />
              <line class="pn_st2" x1="546.4" y1="686.9" x2="543.9" y2="686.9" />
            </g>
          </g>
        </g>
        <g
          id="_x35_1東温山_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(51)"
          class="cursor_not_allowed"
        >
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M552.4,658c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st71"
              d="M561.3,664.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M554.5,669.3c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M568.1,676.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <path
              class="pn_st63"
              d="M590.7,740.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M590.7,634.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,631.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M598.2,652.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM589.5,656.1v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM589.5,657.7h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM591.6,656.1h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM591.6,657.7v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
              />
              <path
                d="M585,688.3c0,.7-1.5,4.1-3,6.6-1.3,2-1.5,2-1.9,2s-1.1-.5-1.1-1.1.1-.5,1.3-2.2c.4-.6,1.7-2.7,2.8-5.5.2-.6.4-.9.9-.9s1.1.4,1.1,1ZM580,680.8c.5,0,2,1.1,2.6,1.5,1.2.9,1.5,1.1,1.5,1.5s-.5,1.2-1.1,1.2-.4,0-1.2-.8c-.5-.4-1.3-.9-2.1-1.5-.3-.2-.6-.4-.6-.8,0-.6.4-1.2,1-1.2ZM581.1,674.3c.6,0,2.5,1.2,3.2,1.7.9.6,1.1.8,1.1,1.2,0,.7-.6,1.2-1,1.2s-.4-.1-1.7-1c-.4-.3-1.9-1.2-2.2-1.4-.2-.2-.3-.3-.3-.7s.3-1,1-1ZM586.4,694.8v-6.1c0-1.7.7-2.3,2.3-2.3h10.1c1.7,0,2.3.6,2.3,2.3v6.1c.6,0,1.2,0,1.2.9s-.7.9-1,.9h-16c-.2,0-1,0-1-.9s.8-.9,1-.9h1ZM600.5,682c0,1.7-.6,2.3-2.3,2.3h-9c-1.7,0-2.3-.6-2.3-2.3v-5c0-1.7.6-2.3,2.3-2.3h9c1.7,0,2.3.6,2.3,2.3v5ZM590.7,694.8v-6.7h-1.7c-.7,0-.8.4-.8.8v5.9h2.6ZM588.9,678.8h9.7v-1.5c0-.4-.1-.8-.8-.8h-8c-.7,0-.8.5-.8.8v1.5ZM588.9,680.3v1.6c0,.4.1.8.8.8h8c0,0,.4,0,.5,0,.3-.2.3-.6.3-.7v-1.5h-9.7ZM594.9,694.8v-6.7h-2.5v6.7h2.5ZM599.3,694.8v-5.9c0-.4-.1-.8-.8-.8h-1.9v6.7h2.7Z"
              />
              <path
                d="M589.6,702.4c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="686.9" x2="573.7" y2="686.9" />
            <g>
              <line class="pn_st2" x1="573.7" y1="686.9" x2="571.2" y2="686.9" />
              <line class="pn_st12" x1="569" y1="686.9" x2="569" y2="686.9" />
              <line class="pn_st5" x1="569" y1="686.9" x2="546.4" y2="686.9" />
              <line class="pn_st2" x1="546.4" y1="686.9" x2="543.9" y2="686.9" />
            </g>
          </g>
        </g>
        <g id="_x35_0松山_xFF1A_橙">
          <a @click="sendPointId(50)">
            <g>
              <path
                class="pn_st67"
                d="M590.7,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M590.7,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M585.2,542.7c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.6,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c2-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM593,529.9c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.6-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-.9-1.8-.9-2.2,0-.6.6-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.6,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM588.7,531.9c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9.9-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM596.5,521.3c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.5-.3-4.5-8.3-4.5-10.8Z"
                />
                <path
                  d="M589.6,576.3c0-.3,0-1,1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.2,1.1h6.2v-19.8Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M542.7,620.3c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st57"
                d="M557.5,621.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM554.1,626.2c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M570.7,623.2c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M584.1,630.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="590.7" y1="615.5" x2="590.7" y2="615.5" />
              <g>
                <line class="pn_st13" x1="590.7" y1="615.5" x2="590.7" y2="618" />
                <line
                  class="pn_st56"
                  x1="590.7"
                  y1="620.6"
                  x2="590.7"
                  y2="620.6"
                />
                <line class="pn_st7" x1="590.7" y1="620.6" x2="590.7" y2="629.9" />
                <line
                  class="pn_st13"
                  x1="590.7"
                  y1="629.9"
                  x2="590.7"
                  y2="632.4"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x35_0松山_xFF1A_紫" v-if="this.clickedPointId === 50">
          <rect
            class="pn_st61"
            x="573.7"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M585.2,542.7c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.6,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c2-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM593,529.9c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.6-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-.9-1.8-.9-2.2,0-.6.6-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.6,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM588.7,531.9c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9.9-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM596.5,521.3c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.5-.3-4.5-8.3-4.5-10.8Z"
              />
              <path
                class="pn_st63"
                d="M589.6,576.3c0-.3,0-1,1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.2,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M542.7,620.3c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M557.5,621.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM554.1,626.2c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M570.7,623.2c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M584.1,630.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="615.5" x2="590.7" y2="615.5" />
            <g>
              <line class="pn_st2" x1="590.7" y1="615.5" x2="590.7" y2="618" />
              <line class="pn_st25" x1="590.7" y1="620.6" x2="590.7" y2="620.6" />
              <line class="pn_st36" x1="590.7" y1="620.6" x2="590.7" y2="629.9" />
              <line class="pn_st2" x1="590.7" y1="629.9" x2="590.7" y2="632.4" />
            </g>
          </g>
        </g>
        <g
          id="_x35_0松山_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(50)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M590.7,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M590.7,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M585.2,542.7c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.6,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c2-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM593,529.9c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.6-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-.9-1.8-.9-2.2,0-.6.6-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.6,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM588.7,531.9c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9.9-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM596.5,521.3c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.5-.3-4.5-8.3-4.5-10.8Z"
              />
              <path
                d="M589.6,576.3c0-.3,0-1,1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.2,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M542.7,620.3c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M557.5,621.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM554.1,626.2c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M570.7,623.2c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M584.1,630.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="615.5" x2="590.7" y2="615.5" />
            <g>
              <line class="pn_st2" x1="590.7" y1="615.5" x2="590.7" y2="618" />
              <line class="pn_st25" x1="590.7" y1="620.6" x2="590.7" y2="620.6" />
              <line class="pn_st36" x1="590.7" y1="620.6" x2="590.7" y2="629.9" />
              <line class="pn_st2" x1="590.7" y1="629.9" x2="590.7" y2="632.4" />
            </g>
          </g>
        </g>
        <g id="_x34_9伊予2_xFF1A_橙">
          <a @click="sendPointId(49)">
            <g>
              <path
                class="pn_st67"
                d="M527,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M527,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="544" y1="560.7" x2="544" y2="560.7" />
              <g>
                <line class="pn_st13" x1="544" y1="560.7" x2="546.5" y2="560.7" />
                <line class="pn_st3" x1="548.6" y1="560.7" x2="548.7" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="548.7"
                  y1="560.7"
                  x2="571.1"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="571.1"
                  y1="560.7"
                  x2="573.6"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M549.6,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M560.1,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M554.1,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M567.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M520,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM529.9,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM530.3,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM530.3,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
                />
                <path
                  d="M528.2,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
                />
                <path
                  d="M538.8,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,592c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_91伊予2_xFF1A_紫" v-if="this.clickedPointId === 49">
          <rect
            class="pn_st61"
            x="510"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="544" y1="560.7" x2="544" y2="560.7" />
            <g>
              <line class="pn_st2" x1="544" y1="560.7" x2="546.5" y2="560.7" />
              <line class="pn_st28" x1="548.6" y1="560.7" x2="548.7" y2="560.7" />
              <line class="pn_st34" x1="548.7" y1="560.7" x2="571.1" y2="560.7" />
              <line class="pn_st2" x1="571.1" y1="560.7" x2="573.6" y2="560.7" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M520,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM529.9,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM530.3,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM530.3,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                class="pn_st63"
                d="M528.2,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
              <path
                class="pn_st63"
                d="M538.8,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,592c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M549.6,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M560.1,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M554.1,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M567.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_9伊予2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(49)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M527,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M527,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="544" y1="560.7" x2="544" y2="560.7" />
            <g>
              <line class="pn_st2" x1="544" y1="560.7" x2="546.5" y2="560.7" />
              <line class="pn_st28" x1="548.6" y1="560.7" x2="548.7" y2="560.7" />
              <line class="pn_st34" x1="548.7" y1="560.7" x2="571.1" y2="560.7" />
              <line class="pn_st2" x1="571.1" y1="560.7" x2="573.6" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M549.6,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M560.1,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M554.1,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M567.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M520,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM529.9,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM530.3,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM530.3,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                d="M528.2,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
              <path
                d="M538.8,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,592c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_8伊予1_xFF1A_橙">
          <a @click="sendPointId(48)">
            <g>
              <path
                class="pn_st67"
                d="M463.2,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M463.2,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="480.4" y1="560.7" x2="480.4" y2="560.7" />
              <g>
                <line
                  class="pn_st13"
                  x1="480.4"
                  y1="560.7"
                  x2="482.9"
                  y2="560.7"
                />
                <line class="pn_st3" x1="485" y1="560.7" x2="485" y2="560.7" />
                <line class="pn_st38" x1="485" y1="560.7" x2="507.4" y2="560.7" />
                <line
                  class="pn_st13"
                  x1="507.4"
                  y1="560.7"
                  x2="509.9"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M485.4,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M500.2,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M490,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M503.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M456.3,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM466.2,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM466.6,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM466.6,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
                />
                <path
                  d="M464.5,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
                />
                <path
                  d="M475.1,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,583.2c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_8伊予1_xFF1A_紫" v-if="this.clickedPointId === 48">
          <rect
            class="pn_st61"
            x="446.2"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="480.4" y1="560.7" x2="480.4" y2="560.7" />
            <g>
              <line class="pn_st2" x1="480.4" y1="560.7" x2="482.9" y2="560.7" />
              <line class="pn_st28" x1="485" y1="560.7" x2="485" y2="560.7" />
              <line class="pn_st34" x1="485" y1="560.7" x2="507.4" y2="560.7" />
              <line class="pn_st2" x1="507.4" y1="560.7" x2="509.9" y2="560.7" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M456.3,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM466.2,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM466.6,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM466.6,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                class="pn_st63"
                d="M464.5,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
              <path
                class="pn_st63"
                d="M475.1,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,583.2c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.4,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M500.2,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_8伊予1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(48)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M463.2,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M463.2,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="480.4" y1="560.7" x2="480.4" y2="560.7" />
            <g>
              <line class="pn_st2" x1="480.4" y1="560.7" x2="482.9" y2="560.7" />
              <line class="pn_st28" x1="485" y1="560.7" x2="485" y2="560.7" />
              <line class="pn_st34" x1="485" y1="560.7" x2="507.4" y2="560.7" />
              <line class="pn_st2" x1="507.4" y1="560.7" x2="509.9" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.4,528.2c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M500.2,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M456.3,542.7c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM466.2,535.2c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM466.6,528.9v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM466.6,523v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                d="M464.5,556.8c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
              <path
                d="M475.1,587c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,587c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,583.2c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_7喜多_xFF1A_橙">
          <a @click="sendPointId(47)">
            <g>
              <path
                class="pn_st67"
                d="M399.5,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M399.5,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="416.7" y1="560.7" x2="416.7" y2="560.7" />
              <g>
                <line
                  class="pn_st13"
                  x1="416.7"
                  y1="560.7"
                  x2="419.2"
                  y2="560.7"
                />
                <line class="pn_st3" x1="421.3" y1="560.7" x2="421.3" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="421.3"
                  y1="560.7"
                  x2="443.8"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="443.8"
                  y1="560.7"
                  x2="446.3"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M420.8,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M432.5,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M426,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M439.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M410.2,534.4c.6,0,.9.2.9.8s-.3.8-.9.8h-21.4c-.4,0-1,0-1-.8s.4-.8,1-.8h5.6c-.2-.6-.6-1.5-.7-1.7h-1c-1.6,0-2.1-.3-2.1-2v-.8c0-1.6.4-2,2.1-2h13.6c1.6,0,2.1.4,2.1,2v.8c0,1.6-.4,2-2.1,2h-.9c-.1.4-.3.8-.7,1.7h5.5ZM410.2,521.8c.5,0,1,.2,1,.8s-.3.8-1,.8h-9.6v1.6h8.3c.4,0,.9.1.9.8s-.4.8-.9.8h-18.7c-.3,0-.9,0-.9-.8s.3-.8.9-.8h8.2v-1.6h-9.5c-.7,0-1-.3-1-.8s.2-.8,1-.8h9.5v-.8c0-.2,0-.8,1-.8s1.1.5,1.1.8v.8h9.6ZM408.8,541c0,1.8-.8,2.2-2.3,2.2h-13.8c-1.5,0-2.3-.2-2.3-2.2v-1.6c0-1.9.8-2.2,2.3-2.2h13.8c1.5,0,2.3.3,2.3,2.2v1.6ZM406.7,539.7c0-.6-.3-.8-.8-.8h-12.7c-.5,0-.8.2-.8.8v1.1c0,.5.2.8.8.8h12.7c.5,0,.8-.2.8-.8v-1.1ZM406.4,529.9c0-.4-.2-.6-.6-.6h-12.5c-.4,0-.6.2-.6.6v.7c0,.4.2.6.6.6h12.5c.4,0,.6-.2.6-.6v-.7ZM402.5,534.4c.3-.6.7-1.2.8-1.7h-7.4c.2.4.5,1.2.6,1.7h6Z"
                />
                <path
                  d="M404.6,577c.9,0,2.1,0,2.1,1.4s-2.1,3.3-3.7,4.5c-2.7,2.1-5.8,3.8-9,4.8-2.2.7-4.1.9-4.4.9-.9,0-1-.8-1-1.1,0-.8.6-.8,1-.9,2.5-.2,5-1,7.4-2.1-1-1.3-2.2-2.6-3.4-3.6-1,.6-2.9,1.5-3.6,1.5s-.9-.6-.9-1.1.3-.7.7-.8c3.6-1.4,5.6-3.1,6.3-3.8,1.4-1.3,1.6-1.6,2.1-1.6s1.1.2,1.1.8-.2.5-.6,1h6ZM408.3,586c.9,0,2.2,0,2.2,1.6s-3.4,6.5-10.2,9c-4.6,1.7-8.8,1.9-9,1.9-1.1,0-1.1-1-1.1-1.2,0-.9.6-.9,1.3-1,3.1-.2,6.2-.9,9.1-2-.8-1.4-2-2.9-3.1-4-2.4,1.2-4.6,2-5.3,2s-1-.7-1-1.1c0-.7.5-.8.9-1,2.9-.8,6.8-2.5,9.6-5.3.2-.2,1.1-1.1,1.4-1.3.2-.2.4-.2.6-.2.6,0,1.1.4,1.1.9s-.2.5-.3.6c-.3.4-.8.9-1,1h4.8ZM396.6,578.8c-.5.4-.8.7-1.5,1.2,1.2,1,2.9,2.8,3.6,3.6,3.6-2.1,5.2-4,5.2-4.4s-.3-.4-.7-.4h-6.6ZM401.4,587.7c-1.1.9-1.8,1.3-2.2,1.5,1.3,1.4,2.9,3.5,3.3,4.1,3-1.5,5.6-4.2,5.6-5.2s-.3-.4-.9-.4h-5.8Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_7喜多_xFF1A_紫" v-if="this.clickedPointId === 47">
          <rect
            class="pn_st61"
            x="382.5"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="416.7" y1="560.7" x2="416.7" y2="560.7" />
            <g>
              <line class="pn_st2" x1="416.7" y1="560.7" x2="419.2" y2="560.7" />
              <line class="pn_st28" x1="421.3" y1="560.7" x2="421.3" y2="560.7" />
              <line class="pn_st34" x1="421.3" y1="560.7" x2="443.8" y2="560.7" />
              <line class="pn_st2" x1="443.8" y1="560.7" x2="446.3" y2="560.7" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M410.2,534.4c.6,0,.9.2.9.8s-.3.8-.9.8h-21.4c-.4,0-1,0-1-.8s.4-.8,1-.8h5.6c-.2-.6-.6-1.5-.7-1.7h-1c-1.6,0-2.1-.3-2.1-2v-.8c0-1.6.4-2,2.1-2h13.6c1.6,0,2.1.4,2.1,2v.8c0,1.6-.4,2-2.1,2h-.9c-.1.4-.3.8-.7,1.7h5.5ZM410.2,521.8c.5,0,1,.2,1,.8s-.3.8-1,.8h-9.6v1.6h8.3c.4,0,.9.1.9.8s-.4.8-.9.8h-18.7c-.3,0-.9,0-.9-.8s.3-.8.9-.8h8.2v-1.6h-9.5c-.7,0-1-.3-1-.8s.2-.8,1-.8h9.5v-.8c0-.2,0-.8,1-.8s1.1.5,1.1.8v.8h9.6ZM408.8,541c0,1.8-.8,2.2-2.3,2.2h-13.8c-1.5,0-2.3-.2-2.3-2.2v-1.6c0-1.9.8-2.2,2.3-2.2h13.8c1.5,0,2.3.3,2.3,2.2v1.6ZM406.7,539.7c0-.6-.3-.8-.8-.8h-12.7c-.5,0-.8.2-.8.8v1.1c0,.5.2.8.8.8h12.7c.5,0,.8-.2.8-.8v-1.1ZM406.4,529.9c0-.4-.2-.6-.6-.6h-12.5c-.4,0-.6.2-.6.6v.7c0,.4.2.6.6.6h12.5c.4,0,.6-.2.6-.6v-.7ZM402.5,534.4c.3-.6.7-1.2.8-1.7h-7.4c.2.4.5,1.2.6,1.7h6Z"
              />
              <path
                class="pn_st63"
                d="M404.6,577c.9,0,2.1,0,2.1,1.4s-2.1,3.3-3.7,4.5c-2.7,2.1-5.8,3.8-9,4.8-2.2.7-4.1.9-4.4.9-.9,0-1-.8-1-1.1,0-.8.6-.8,1-.9,2.5-.2,5-1,7.4-2.1-1-1.3-2.2-2.6-3.4-3.6-1,.6-2.9,1.5-3.6,1.5s-.9-.6-.9-1.1.3-.7.7-.8c3.6-1.4,5.6-3.1,6.3-3.8,1.4-1.3,1.6-1.6,2.1-1.6s1.1.2,1.1.8-.2.5-.6,1h6ZM408.3,586c.9,0,2.2,0,2.2,1.6s-3.4,6.5-10.2,9c-4.6,1.7-8.8,1.9-9,1.9-1.1,0-1.1-1-1.1-1.2,0-.9.6-.9,1.3-1,3.1-.2,6.2-.9,9.1-2-.8-1.4-2-2.9-3.1-4-2.4,1.2-4.6,2-5.3,2s-1-.7-1-1.1c0-.7.5-.8.9-1,2.9-.8,6.8-2.5,9.6-5.3.2-.2,1.1-1.1,1.4-1.3.2-.2.4-.2.6-.2.6,0,1.1.4,1.1.9s-.2.5-.3.6c-.3.4-.8.9-1,1h4.8ZM396.6,578.8c-.5.4-.8.7-1.5,1.2,1.2,1,2.9,2.8,3.6,3.6,3.6-2.1,5.2-4,5.2-4.4s-.3-.4-.7-.4h-6.6ZM401.4,587.7c-1.1.9-1.8,1.3-2.2,1.5,1.3,1.4,2.9,3.5,3.3,4.1,3-1.5,5.6-4.2,5.6-5.2s-.3-.4-.9-.4h-5.8Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M420.8,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M432.5,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M439.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_7喜多_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(47)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M399.5,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M399.5,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="416.7" y1="560.7" x2="416.7" y2="560.7" />
            <g>
              <line class="pn_st2" x1="416.7" y1="560.7" x2="419.2" y2="560.7" />
              <line class="pn_st28" x1="421.3" y1="560.7" x2="421.3" y2="560.7" />
              <line class="pn_st34" x1="421.3" y1="560.7" x2="443.8" y2="560.7" />
              <line class="pn_st2" x1="443.8" y1="560.7" x2="446.3" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M420.8,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M432.5,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M439.4,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M410.2,534.4c.6,0,.9.2.9.8s-.3.8-.9.8h-21.4c-.4,0-1,0-1-.8s.4-.8,1-.8h5.6c-.2-.6-.6-1.5-.7-1.7h-1c-1.6,0-2.1-.3-2.1-2v-.8c0-1.6.4-2,2.1-2h13.6c1.6,0,2.1.4,2.1,2v.8c0,1.6-.4,2-2.1,2h-.9c-.1.4-.3.8-.7,1.7h5.5ZM410.2,521.8c.5,0,1,.2,1,.8s-.3.8-1,.8h-9.6v1.6h8.3c.4,0,.9.1.9.8s-.4.8-.9.8h-18.7c-.3,0-.9,0-.9-.8s.3-.8.9-.8h8.2v-1.6h-9.5c-.7,0-1-.3-1-.8s.2-.8,1-.8h9.5v-.8c0-.2,0-.8,1-.8s1.1.5,1.1.8v.8h9.6ZM408.8,541c0,1.8-.8,2.2-2.3,2.2h-13.8c-1.5,0-2.3-.2-2.3-2.2v-1.6c0-1.9.8-2.2,2.3-2.2h13.8c1.5,0,2.3.3,2.3,2.2v1.6ZM406.7,539.7c0-.6-.3-.8-.8-.8h-12.7c-.5,0-.8.2-.8.8v1.1c0,.5.2.8.8.8h12.7c.5,0,.8-.2.8-.8v-1.1ZM406.4,529.9c0-.4-.2-.6-.6-.6h-12.5c-.4,0-.6.2-.6.6v.7c0,.4.2.6.6.6h12.5c.4,0,.6-.2.6-.6v-.7ZM402.5,534.4c.3-.6.7-1.2.8-1.7h-7.4c.2.4.5,1.2.6,1.7h6Z"
              />
              <path
                d="M404.6,577c.9,0,2.1,0,2.1,1.4s-2.1,3.3-3.7,4.5c-2.7,2.1-5.8,3.8-9,4.8-2.2.7-4.1.9-4.4.9-.9,0-1-.8-1-1.1,0-.8.6-.8,1-.9,2.5-.2,5-1,7.4-2.1-1-1.3-2.2-2.6-3.4-3.6-1,.6-2.9,1.5-3.6,1.5s-.9-.6-.9-1.1.3-.7.7-.8c3.6-1.4,5.6-3.1,6.3-3.8,1.4-1.3,1.6-1.6,2.1-1.6s1.1.2,1.1.8-.2.5-.6,1h6ZM408.3,586c.9,0,2.2,0,2.2,1.6s-3.4,6.5-10.2,9c-4.6,1.7-8.8,1.9-9,1.9-1.1,0-1.1-1-1.1-1.2,0-.9.6-.9,1.3-1,3.1-.2,6.2-.9,9.1-2-.8-1.4-2-2.9-3.1-4-2.4,1.2-4.6,2-5.3,2s-1-.7-1-1.1c0-.7.5-.8.9-1,2.9-.8,6.8-2.5,9.6-5.3.2-.2,1.1-1.1,1.4-1.3.2-.2.4-.2.6-.2.6,0,1.1.4,1.1.9s-.2.5-.3.6c-.3.4-.8.9-1,1h4.8ZM396.6,578.8c-.5.4-.8.7-1.5,1.2,1.2,1,2.9,2.8,3.6,3.6,3.6-2.1,5.2-4,5.2-4.4s-.3-.4-.7-.4h-6.6ZM401.4,587.7c-1.1.9-1.8,1.3-2.2,1.5,1.3,1.4,2.9,3.5,3.3,4.1,3-1.5,5.6-4.2,5.6-5.2s-.3-.4-.9-.4h-5.8Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_6西伊予_xFF1A_橙">
          <a @click="sendPointId(46)">
            <g>
              <path
                class="pn_st67"
                d="M335.9,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M335.9,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="353" y1="560.7" x2="353" y2="560.7" />
              <g>
                <line class="pn_st13" x1="353" y1="560.7" x2="355.5" y2="560.7" />
                <line class="pn_st3" x1="357.6" y1="560.7" x2="357.6" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="357.6"
                  y1="560.7"
                  x2="380.1"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="380.1"
                  y1="560.7"
                  x2="382.6"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M360.4,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st57"
                  d="M373.7,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM370.4,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M362.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M376.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M325.3,523.1c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM331.3,528.6h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM336.9,523.1h-3.7v3.6h3.7v-3.6Z"
                />
                <path
                  d="M329,570.2c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM338.9,562.7c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM339.3,556.4v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM339.3,550.5v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
                />
                <path
                  d="M337.2,584.3c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_6西伊予_xFF1A_紫" v-if="this.clickedPointId === 46">
          <rect
            class="pn_st61"
            x="318.9"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="353" y1="560.7" x2="353" y2="560.7" />
            <g>
              <line class="pn_st2" x1="353" y1="560.7" x2="355.5" y2="560.7" />
              <line class="pn_st28" x1="357.6" y1="560.7" x2="357.6" y2="560.7" />
              <line class="pn_st34" x1="357.6" y1="560.7" x2="380.1" y2="560.7" />
              <line class="pn_st2" x1="380.1" y1="560.7" x2="382.6" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M360.4,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M373.7,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM370.4,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M325.3,523.1c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM331.3,528.6h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM336.9,523.1h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                class="pn_st63"
                d="M329,570.2c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM338.9,562.7c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM339.3,556.4v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM339.3,550.5v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                class="pn_st63"
                d="M337.2,584.3c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_6西伊予_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(46)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M335.9,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M335.9,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="560.7" x2="353" y2="560.7" />
            <g>
              <line class="pn_st2" x1="353" y1="560.7" x2="355.5" y2="560.7" />
              <line class="pn_st28" x1="357.6" y1="560.7" x2="357.6" y2="560.7" />
              <line class="pn_st34" x1="357.6" y1="560.7" x2="380.1" y2="560.7" />
              <line class="pn_st2" x1="380.1" y1="560.7" x2="382.6" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M360.4,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M373.7,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM370.4,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M325.3,523.1c-.2,0-1,0-1-1s.7-.9,1-.9h21.4c.3,0,1,0,1,.9s-.2,1-1,1h-7.9v3.6h5.1c1.9,0,2.8.6,2.8,2.7v10.5c0,2.1-.8,2.7-2.8,2.7h-15.8c-1.9,0-2.7-.6-2.7-2.7v-10.5c0-2.1.8-2.7,2.7-2.7h3.3v-3.6h-6ZM331.3,528.6h-3c-.8,0-1.1.4-1.1,1.1v10c0,.8.4,1.1,1.1,1.1h15.1c.7,0,1.1-.3,1.1-1.1v-10c0-.7-.4-1.1-1.1-1.1h-4.7v5.8c0,.9.5.9,1.1.9s1.4,0,1.5,0c.5-.1.5-.6.6-1.8,0-.9.1-1.3.8-1.3s1,.6,1,1,0,2.2-.5,3c-.5.8-1.1.8-4.1.8s-2.3-.6-2.3-2.3v-6.2h-3.7v.8c0,3.1-.9,4.9-1.3,5.8-.7,1.4-1.9,3-2.7,3s-1.1-.6-1.1-1.2.2-.5.4-.7c1-.9,2.9-2.6,2.9-6.9v-.8ZM336.9,523.1h-3.7v3.6h3.7v-3.6Z"
              />
              <path
                d="M329,570.2c0,.3,0,1-1,1s-1-.6-1-1v-12.2c-1,1.7-1.3,1.8-1.8,1.8s-1.1-.6-1.1-1.2.2-.7.5-1.1c2.3-3.2,3.1-6.5,3.7-8.9,0-.4.2-.8.9-.8s1.1.2,1.1.8-.5,2.6-1.3,4.9v16.6ZM338.9,562.7c-.4,1.8-1.1,4.1-3.3,6.4-.3.3-2.1,2-2.9,2s-1.2-.6-1.2-1.2.2-.6.6-.9c2-1.4,3.8-2.7,4.8-6.4h-4.5c-.4,0-1,0-1-1s.8-1,1-1h4.8c0-.6.1-1.2.1-1.8v-2.5h-6.1c-.5,0-1-.1-1-.9s.8-.9,1-.9h6.1v-4.1h-4.7c-.5,0-1,0-1-1s.8-.9,1-.9h10.6c1.8,0,2.7.6,2.7,2.7v3.3h.8c.4,0,.9.1.9.9s-.6.9-.9.9h-.8v3.6c0,2-.8,2.7-2.7,2.7h-4.3ZM339.3,556.4v2.5c0,.5,0,1-.1,1.8h3.5c.7,0,1.1-.3,1.1-1.1v-3.2h-4.5ZM339.3,550.5v4.1h4.5v-3c0-.8-.4-1.1-1.1-1.1h-3.4Z"
              />
              <path
                d="M337.2,584.3c-2-1.9-3.4-2.7-5.4-3.9-.3-.2-.5-.3-.5-.6,0-.5.3-1.1,1-1.1,1,0,4,2.2,4.3,2.4.8-.4,2-.9,3.4-1.9.3-.2,1.1-.8,1.1-1s-.3-.4-.8-.4h-12.9c-.4,0-1.1,0-1.1-1s.8-.9,1.1-.9h14.6c.7,0,1.2,0,1.7.3.5.3.6.9.6,1.3,0,.6-.2,1.3-1.5,2.1-1.5,1-3.3,2-4.6,2.6,1.1,1,1.2,1.2,1.2,1.5s0,.2,0,.4h5.2c.9,0,2.4,0,2.3,1.7,0,.6-.2,1.1-.5,1.6-.7,1-2.4,3-4.2,4.4-.9.7-1,.8-1.3.8-.6,0-1.2-.6-1.2-1.2s0-.4,1.6-1.6c1.4-1,3-2.9,3-3.4s-.4-.3-.8-.3h-6.4v9.4c0,.8,0,1.8-.9,2.4-.6.4-1.2.4-3.8.4s-1.5,0-1.7,0c-.6-.1-.8-.8-.8-1.1,0-1,.8-1,1.3-1s2.2,0,2.4,0c.8,0,1.3-.2,1.3-1.2v-8.8h-9.5c-.2,0-1.1,0-1.1-1s.8-.9,1.1-.9h11.8Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_5宇和島2_xFF1A_橙">
          <a @click="sendPointId(45)">
            <g>
              <path
                class="pn_st67"
                d="M272.2,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M272.2,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="289.3" y1="560.7" x2="289.3" y2="560.7" />
              <g>
                <line
                  class="pn_st13"
                  x1="289.3"
                  y1="560.7"
                  x2="291.8"
                  y2="560.7"
                />
                <line class="pn_st3" x1="293.9" y1="560.7" x2="294" y2="560.7" />
                <line class="pn_st38" x1="294" y1="560.7" x2="316.4" y2="560.7" />
                <line
                  class="pn_st13"
                  x1="316.4"
                  y1="560.7"
                  x2="318.9"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M293.6,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M308.7,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M298.9,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M312.3,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M273.3,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM280.6,519.1c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
                />
                <path
                  d="M267.4,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.2-.4-1.2-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.4-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM282.8,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM280.8,542.9c0-.7-.5-.9-1.1-.9h-4.2c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.2c.7,0,1.1-.2,1.1-.9v-12Z"
                />
                <path
                  d="M267.2,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.1.2,1.1.6-.2.7-.5,1.1h6.4c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.8.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8.9-.8.3,0,1.9,0,2.2,0s1.3,0,1.7-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1.1.6,1.1.8v1.4c0,.4.2.6.8.6h3.3ZM265.1,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.5,0-.8.2-.8.6v.7ZM279,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
                />
                <path
                  d="M284,592.5c0,5.2-5.3,9.5-11.9,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.9,4.2,11.9,9.5ZM261.1,592.5c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM276.3,596.5c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.8c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.6-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_5宇和島2_xFF1A_紫" v-if="this.clickedPointId === 45">
          <rect
            class="pn_st61"
            x="255.2"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="289.3" y1="560.7" x2="289.3" y2="560.7" />
            <g>
              <line class="pn_st2" x1="289.3" y1="560.7" x2="291.8" y2="560.7" />
              <line class="pn_st28" x1="293.9" y1="560.7" x2="294" y2="560.7" />
              <line class="pn_st34" x1="294" y1="560.7" x2="316.4" y2="560.7" />
              <line class="pn_st2" x1="316.4" y1="560.7" x2="318.9" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.6,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M308.7,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M273.3,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM280.6,519.1c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                class="pn_st63"
                d="M267.4,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.2-.4-1.2-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.4-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM282.8,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM280.8,542.9c0-.7-.5-.9-1.1-.9h-4.2c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.2c.7,0,1.1-.2,1.1-.9v-12Z"
              />
              <path
                class="pn_st63"
                d="M267.2,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.1.2,1.1.6-.2.7-.5,1.1h6.4c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.8.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8.9-.8.3,0,1.9,0,2.2,0s1.3,0,1.7-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1.1.6,1.1.8v1.4c0,.4.2.6.8.6h3.3ZM265.1,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.5,0-.8.2-.8.6v.7ZM279,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
              />
              <path
                class="pn_st63"
                d="M284,592.5c0,5.2-5.3,9.5-11.9,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.9,4.2,11.9,9.5ZM261.1,592.5c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM276.3,596.5c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.8c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.6-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_5宇和島2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(45)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M272.2,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M272.2,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="289.3" y1="560.7" x2="289.3" y2="560.7" />
            <g>
              <line class="pn_st2" x1="289.3" y1="560.7" x2="291.8" y2="560.7" />
              <line class="pn_st28" x1="293.9" y1="560.7" x2="294" y2="560.7" />
              <line class="pn_st34" x1="294" y1="560.7" x2="316.4" y2="560.7" />
              <line class="pn_st2" x1="316.4" y1="560.7" x2="318.9" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.6,538.6c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M308.7,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M273.3,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM280.6,519.1c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                d="M267.4,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.2-.4-1.2-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.4-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM282.8,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM280.8,542.9c0-.7-.5-.9-1.1-.9h-4.2c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.2c.7,0,1.1-.2,1.1-.9v-12Z"
              />
              <path
                d="M267.2,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.1.2,1.1.6-.2.7-.5,1.1h6.4c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.8.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8.9-.8.3,0,1.9,0,2.2,0s1.3,0,1.7-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1.1.6,1.1.8v1.4c0,.4.2.6.8.6h3.3ZM265.1,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.5,0-.8.2-.8.6v.7ZM279,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
              />
              <path
                d="M284,592.5c0,5.2-5.3,9.5-11.9,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.9,4.2,11.9,9.5ZM261.1,592.5c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM276.3,596.5c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.8c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.6-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_4宇和島1_xFF1A_橙">
          <a @click="sendPointId(44)">
            <g>
              <path
                class="pn_st67"
                d="M208.5,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M208.5,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="225.6" y1="560.7" x2="225.6" y2="560.7" />
              <g>
                <line
                  class="pn_st13"
                  x1="225.6"
                  y1="560.7"
                  x2="228.1"
                  y2="560.7"
                />
                <line class="pn_st3" x1="230.2" y1="560.7" x2="230.2" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="230.2"
                  y1="560.7"
                  x2="252.6"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="252.6"
                  y1="560.7"
                  x2="255.1"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M239.9,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM236.6,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M235.2,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M248.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M209.5,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM216.8,519.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
                />
                <path
                  d="M203.7,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM219.1,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM217.1,542.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
                />
                <path
                  d="M203.5,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.2.2,1.2.6-.2.7-.5,1.1h6.3c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.9.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8,1-.8.3,0,1.8,0,2.2,0s1.3,0,1.6-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1,.6,1,.8v1.4c0,.4.2.6.8.6h3.4ZM201.4,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.6,0-.8.2-.8.6v.7ZM215.2,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
                />
                <path
                  d="M220.3,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM197.4,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM206.4,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_4宇和島1_xFF1A_紫" v-if="this.clickedPointId === 44">
          <rect
            class="pn_st61"
            x="191.5"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="225.6" y1="560.7" x2="225.6" y2="560.7" />
            <g>
              <line class="pn_st2" x1="225.6" y1="560.7" x2="228.1" y2="560.7" />
              <line class="pn_st28" x1="230.2" y1="560.7" x2="230.2" y2="560.7" />
              <line class="pn_st34" x1="230.2" y1="560.7" x2="252.6" y2="560.7" />
              <line class="pn_st2" x1="252.6" y1="560.7" x2="255.1" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M239.9,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM236.6,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M209.5,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM216.8,519.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                class="pn_st63"
                d="M203.7,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM219.1,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM217.1,542.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                class="pn_st63"
                d="M203.5,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.2.2,1.2.6-.2.7-.5,1.1h6.3c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.9.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8,1-.8.3,0,1.8,0,2.2,0s1.3,0,1.6-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1,.6,1,.8v1.4c0,.4.2.6.8.6h3.4ZM201.4,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.6,0-.8.2-.8.6v.7ZM215.2,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
              />
              <path
                class="pn_st63"
                d="M220.3,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM197.4,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM206.4,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_4宇和島1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(44)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M208.5,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M208.5,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="560.7" x2="225.6" y2="560.7" />
            <g>
              <line class="pn_st2" x1="225.6" y1="560.7" x2="228.1" y2="560.7" />
              <line class="pn_st28" x1="230.2" y1="560.7" x2="230.2" y2="560.7" />
              <line class="pn_st34" x1="230.2" y1="560.7" x2="252.6" y2="560.7" />
              <line class="pn_st2" x1="252.6" y1="560.7" x2="255.1" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M239.9,529.3c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM236.6,534.1c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M209.5,527.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM216.8,519.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                d="M203.7,544.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM219.1,555.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM217.1,542.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                d="M203.5,577.3v-3.3h-1.9c-1.7,0-2.3-.5-2.3-1.8v-7.6c0-1.4.7-1.8,2.3-1.8h4.9c0-.2.4-1.1.5-1.2,0-.2.2-.4.9-.4s1.2.2,1.2.6-.2.7-.5,1.1h6.3c1.6,0,2.3.4,2.3,1.8v2.6c0,1.4-.7,1.8-2.3,1.8h-13.6v1.2h17.9c.6,0,.9.2.9.6s-.5.6-.9.6h-17.9v.6c0,.4.2.7.8.7h14.3c1.5,0,2.8,0,2.8,1.6s-.2,1.6-.3,2.2c-.3,1.3-.6,1.9-1,2.3-.9.7-1.5.7-3.6.7s-1.5,0-1.8,0c-.5,0-.6-.5-.6-.8,0-.8.7-.8,1-.8.3,0,1.8,0,2.2,0s1.3,0,1.6-.8c.3-.7.5-2.2.5-2.4,0-.7-.4-.7-1.2-.7h-10.6v3.3h3.3c.5,0,.8-.2.8-.6v-1.4c0-.5.3-.8,1.1-.8s1,.6,1,.8v1.5c0,1.5-.9,1.8-2.3,1.8h-9.8c-1.6,0-2.3-.4-2.3-1.8v-1.6c0-.3,0-.8,1-.8s1,.6,1,.8v1.4c0,.4.2.6.8.6h3.4ZM201.4,565.4h13.9v-.7c0-.4-.2-.6-.8-.6h-12.3c-.6,0-.8.2-.8.6v.7ZM215.2,566.5h-13.9v1.4h13.1c.5,0,.8-.2.8-.7v-.7Z"
              />
              <path
                d="M220.3,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM197.4,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM206.4,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_3南宇和2_xFF1A_橙">
          <a @click="sendPointId(43)">
            <g>
              <path
                class="pn_st67"
                d="M144.7,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M144.7,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="161.9" y1="560.7" x2="161.9" y2="560.7" />
              <g>
                <line
                  class="pn_st13"
                  x1="161.9"
                  y1="560.7"
                  x2="164.4"
                  y2="560.7"
                />
                <line class="pn_st3" x1="166.5" y1="560.7" x2="166.5" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="166.5"
                  y1="560.7"
                  x2="188.9"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="188.9"
                  y1="560.7"
                  x2="191.4"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M169.2,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st57"
                  d="M178.2,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M171.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M184.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M152.1,522.6c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1,0-1-.8s.5-.8,1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM146.3,526.9c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.7.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-.9,0-.9-.7s.6-.7.9-.7h4.8v-1.8h-4.8c-.3,0-.9,0-.9-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.7-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
                />
                <path
                  d="M145.8,549.7h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM153.1,541.3c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1.1.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
                />
                <path
                  d="M140,566.7h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.6-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1.1,0-1.1-.7s.6-.8,1.1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM155.4,577.3c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM153.3,565.1c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
                />
                <path
                  d="M156.6,592.7c0,5.2-5.3,9.5-11.8,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.8,4.2,11.8,9.5ZM133.7,592.7c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM148.8,596.8c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.9c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.7-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_3南宇和2_xFF1A_紫" v-if="this.clickedPointId === 43">
          <rect
            class="pn_st61"
            x="127.7"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="161.9" y1="560.7" x2="161.9" y2="560.7" />
            <g>
              <line class="pn_st2" x1="161.9" y1="560.7" x2="164.4" y2="560.7" />
              <line class="pn_st28" x1="166.5" y1="560.7" x2="166.5" y2="560.7" />
              <line class="pn_st34" x1="166.5" y1="560.7" x2="188.9" y2="560.7" />
              <line class="pn_st2" x1="188.9" y1="560.7" x2="191.4" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M169.2,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M178.2,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M152.1,522.6c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1,0-1-.8s.5-.8,1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM146.3,526.9c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.7.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-.9,0-.9-.7s.6-.7.9-.7h4.8v-1.8h-4.8c-.3,0-.9,0-.9-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.7-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
              />
              <path
                class="pn_st63"
                d="M145.8,549.7h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM153.1,541.3c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1.1.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                class="pn_st63"
                d="M140,566.7h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.6-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1.1,0-1.1-.7s.6-.8,1.1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM155.4,577.3c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM153.3,565.1c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                class="pn_st63"
                d="M156.6,592.7c0,5.2-5.3,9.5-11.8,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.8,4.2,11.8,9.5ZM133.7,592.7c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM148.8,596.8c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.9c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.7-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_3南宇和2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(43)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M144.7,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M144.7,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,505.7c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="560.7" x2="161.9" y2="560.7" />
            <g>
              <line class="pn_st2" x1="161.9" y1="560.7" x2="164.4" y2="560.7" />
              <line class="pn_st28" x1="166.5" y1="560.7" x2="166.5" y2="560.7" />
              <line class="pn_st34" x1="166.5" y1="560.7" x2="188.9" y2="560.7" />
              <line class="pn_st2" x1="188.9" y1="560.7" x2="191.4" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M169.2,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M178.2,525.9c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M152.1,522.6c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1,0-1-.8s.5-.8,1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM146.3,526.9c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.7.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-.9,0-.9-.7s.6-.7.9-.7h4.8v-1.8h-4.8c-.3,0-.9,0-.9-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.7-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
              />
              <path
                d="M145.8,549.7h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-1,0-1-.8s.6-.8,1-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM153.1,541.3c1.9,0,2.7.5,2.7,2.1v2.1c0,.3,0,.8-1.1.8s-1.1-.5-1.1-.8v-1.9c0-.6-.4-.9-1.1-.9h-15.6c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                d="M140,566.7h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.6-.6-1.1-1.3-1.7-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.5.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.8c-.2,0-1.1,0-1.1-.7s.6-.8,1.1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.4,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM155.4,577.3c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM153.3,565.1c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                d="M156.6,592.7c0,5.2-5.3,9.5-11.8,9.5s-11.8-4.2-11.8-9.5,5.3-9.5,11.8-9.5,11.8,4.2,11.8,9.5ZM133.7,592.7c0,4.9,5,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM148.8,596.8c.8,0,.8.5.8.7,0,.4-.3.7-.8.7h-6.9c-1.1,0-2.1,0-2.1-1s.2-.6,1.7-1.6c5.5-3.7,5.5-4.6,5.5-5.3s-.8-1.9-2.4-1.9-2.2.6-2.6.9c-.4.3-.5.4-.8.4-.5,0-.8-.3-.8-.7s1.7-1.9,4.2-1.9,4.2,1.2,4.2,3.1-1.9,3.3-6.7,6.7h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_2南宇和1_xFF1A_橙">
          <a @click="sendPointId(42)">
            <g>
              <path
                class="pn_st67"
                d="M81,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M81,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="98.2" y1="560.7" x2="98.2" y2="560.7" />
              <g>
                <line class="pn_st13" x1="98.2" y1="560.7" x2="100.7" y2="560.7" />
                <line class="pn_st3" x1="102.8" y1="560.7" x2="102.8" y2="560.7" />
                <line
                  class="pn_st38"
                  x1="102.8"
                  y1="560.7"
                  x2="125.2"
                  y2="560.7"
                />
                <line
                  class="pn_st13"
                  x1="125.2"
                  y1="560.7"
                  x2="127.7"
                  y2="560.7"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M105.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st57"
                  d="M114,527.7c0-2.4,1.9-3.8,4.2-3.8s4.2,1.4,4.2,3.9-.8,2.4-1.9,3c1.5.7,2.4,1.8,2.4,3.8s-1.9,4.4-4.7,4.4-4.7-1.8-4.7-4.4,1.4-3.3,2.5-3.8c-1.3-.6-2-1.5-2-3ZM115.2,534.5c0,2.7,2.3,3,3,3s3-.3,3-3-1.7-2.9-3-2.9-3,.6-3,2.9ZM115.7,527.8c0,1.4,1,2.4,2.5,2.4s2.5-1,2.5-2.4-1.1-2.4-2.5-2.4-2.5.7-2.5,2.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M107.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M121.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M88.4,522.3c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1.1,0-1.1-.8s.5-.8,1.1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM82.6,526.6c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.6.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-1,0-1-.7s.6-.7,1-.7h4.8v-1.8h-4.8c-.3,0-1,0-1-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.6-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
                />
                <path
                  d="M82.1,549.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM89.4,541.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
                />
                <path
                  d="M76.3,566.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM91.7,577.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM89.6,564.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
                />
                <path
                  d="M92.9,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM70,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM79,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_2南宇和1_xFF1A_紫" v-if="this.clickedPointId === 42">
          <rect
            class="pn_st61"
            x="64"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="98.2" y1="560.7" x2="98.2" y2="560.7" />
            <g>
              <line class="pn_st2" x1="98.2" y1="560.7" x2="100.7" y2="560.7" />
              <line class="pn_st28" x1="102.8" y1="560.7" x2="102.8" y2="560.7" />
              <line class="pn_st34" x1="102.8" y1="560.7" x2="125.2" y2="560.7" />
              <line class="pn_st2" x1="125.2" y1="560.7" x2="127.7" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M105.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M114,527.7c0-2.4,1.9-3.8,4.2-3.8s4.2,1.4,4.2,3.9-.8,2.4-1.9,3c1.5.7,2.4,1.8,2.4,3.8s-1.9,4.4-4.7,4.4-4.7-1.8-4.7-4.4,1.4-3.3,2.5-3.8c-1.3-.6-2-1.5-2-3ZM115.2,534.5c0,2.7,2.3,3,3,3s3-.3,3-3-1.7-2.9-3-2.9-3,.6-3,2.9ZM115.7,527.8c0,1.4,1,2.4,2.5,2.4s2.5-1,2.5-2.4-1.1-2.4-2.5-2.4-2.5.7-2.5,2.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M88.4,522.3c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1.1,0-1.1-.8s.5-.8,1.1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM82.6,526.6c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.6.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-1,0-1-.7s.6-.7,1-.7h4.8v-1.8h-4.8c-.3,0-1,0-1-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.6-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
              />
              <path
                class="pn_st63"
                d="M82.1,549.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM89.4,541.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                class="pn_st63"
                d="M76.3,566.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM91.7,577.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM89.6,564.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                class="pn_st63"
                d="M92.9,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM70,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM79,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_2南宇和1_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(42)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M81,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="98.2" y1="560.7" x2="98.2" y2="560.7" />
            <g>
              <line class="pn_st2" x1="98.2" y1="560.7" x2="100.7" y2="560.7" />
              <line class="pn_st28" x1="102.8" y1="560.7" x2="102.8" y2="560.7" />
              <line class="pn_st34" x1="102.8" y1="560.7" x2="125.2" y2="560.7" />
              <line class="pn_st2" x1="125.2" y1="560.7" x2="127.7" y2="560.7" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M105.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M114,527.7c0-2.4,1.9-3.8,4.2-3.8s4.2,1.4,4.2,3.9-.8,2.4-1.9,3c1.5.7,2.4,1.8,2.4,3.8s-1.9,4.4-4.7,4.4-4.7-1.8-4.7-4.4,1.4-3.3,2.5-3.8c-1.3-.6-2-1.5-2-3ZM115.2,534.5c0,2.7,2.3,3,3,3s3-.3,3-3-1.7-2.9-3-2.9-3,.6-3,2.9ZM115.7,527.8c0,1.4,1,2.4,2.5,2.4s2.5-1,2.5-2.4-1.1-2.4-2.5-2.4-2.5.7-2.5,2.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M88.4,522.3c1.9,0,2.7.5,2.7,2.1v9c0,.9-.2,1.8-1.5,2-.4,0-.7.1-3.4.1s-1.4,0-1.4-.9.7-.7,1.2-.7,1.7,0,1.8,0c.8,0,1.2-.2,1.2-.9v-8.5c0-.6-.4-.9-1.1-.9h-13.7c-.8,0-1.1.3-1.1.9v10.4c0,.3,0,.8-1,.8s-1.1-.3-1.1-.8v-10.6c0-1.6.7-2.1,2.7-2.1h6.2v-1.7h-9.5c-.4,0-1.1,0-1.1-.8s.5-.8,1.1-.8h9.5v-1.2c0-.4.2-.7,1-.7s1.1.2,1.1.7v1.2h9.5c.3,0,1,0,1,.8s-.6.8-1,.8h-9.5v1.7h6.3ZM82.6,526.6c.3-.4.6-1,1-1.9.1-.2.2-.5.9-.5s1.1,0,1.1.6-.9,1.8-.9,1.9h2.2c.4,0,.9,0,.9.7s-.6.7-1,.7h-4.8v1.8h4.8c.3,0,1,0,1,.7s-.6.7-1,.7h-4.8v3.3c0,.2,0,.8-.9.8s-1.1-.2-1.1-.8v-3.3h-4.8c-.2,0-1,0-1-.7s.6-.7,1-.7h4.8v-1.8h-4.8c-.3,0-1,0-1-.7s.3-.7.9-.7h2.1c-.1-.3-.6-1.2-.7-1.3-.1-.2-.2-.4-.2-.6,0-.5.6-.6,1.1-.6s.7.2.9.5c.2.4.7,1.2,1,2h3.2Z"
              />
              <path
                d="M82.1,549.5h9.7c.2,0,1,0,1,.8s-.5.8-1,.8h-9.7v4.5c0,.5,0,1.4-.9,1.8-.6.3-1.1.3-3.7.3s-1.6,0-1.8-.2c-.4-.2-.4-.6-.4-.8,0-.8.8-.8,1.1-.8s2.3,0,2.4,0c.4,0,1.2,0,1.2-.9v-4h-9.6c-.3,0-1,0-1-.8s.4-.8,1-.8h9.6v-3.3h-6.3c-.3,0-.9,0-.9-.8s.6-.8.9-.8h14.7c.2,0,1,0,1,.8s-.6.8-1,.8h-6.3v3.3ZM89.4,541.1c1.9,0,2.6.5,2.6,2.1v2.1c0,.3,0,.8-1,.8s-1.1-.5-1.1-.8v-1.9c0-.6-.3-.9-1.1-.9h-15.7c-.8,0-1.1.3-1.1.9v1.9c0,.3,0,.8-1,.8s-1.1-.2-1.1-.8v-2.1c0-1.6.8-2.1,2.7-2.1h7.3v-1.1c0-.4.2-.8,1-.8s1.2.1,1.2.8v1.1h7.3Z"
              />
              <path
                d="M76.3,566.4h3.1c.2,0,1,0,1,.8s-.8.8-1,.8h-3.1v.3c.5.7,1.7,2.5,3.5,3.9.3.2.4.4.4.6,0,.5-.5,1-1,1s-.5,0-1.3-.9c-.5-.6-1.1-1.3-1.6-2.2v8.5c0,.2,0,.8-1,.8s-1-.4-1-.8v-8.1c-.8,1.4-1.6,2.7-2.7,3.9-.6.6-.8.8-1.2.8s-1.1-.4-1.1-.9.2-.5.5-.8c2.1-1.9,3.5-3.8,4.5-6.1h-3.9c-.2,0-1,0-1-.7s.5-.8,1-.8h3.9v-2.9c-1,0-2.8.3-3.8.3s-1,0-1-.8.6-.7.9-.7c2.5-.1,4.2-.2,6.3-.6.3,0,1.9-.4,2.2-.4.6,0,.8.5.8.8s0,.7-3.5,1.2v3.1ZM91.7,577.1c0,1.7-.9,2.2-2.8,2.2h-4.9c-1.9,0-2.8-.5-2.8-2.2v-12.5c0-1.7.8-2.2,2.8-2.2h4.9c2,0,2.8.5,2.8,2.2v12.5ZM89.6,564.9c0-.7-.5-.9-1.2-.9h-4.1c-.8,0-1.1.3-1.1.9v12c0,.6.3.9,1.1.9h4.1c.7,0,1.2-.2,1.2-.9v-12Z"
              />
              <path
                d="M92.9,592.5c0,5.2-5.3,9.5-11.8,9.5s-11.9-4.2-11.9-9.5,5.4-9.5,11.9-9.5,11.8,4.2,11.8,9.5ZM70,592.5c0,4.9,4.9,8.8,11,8.8s11-4,11-8.8-5-8.8-11-8.8-11,3.9-11,8.8ZM79,589.5c-.1,0-.3.2-.5.2-.5,0-.8-.3-.8-.7s.2-.4.5-.5l2.4-1.3c.3-.2.6-.3,1-.3.9,0,.9.6.9.9v9.8c0,.5-.3.7-.9.7s-.9-.2-.9-.7v-8.9l-1.6.9Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_1宿毛_xFF1A_橙">
          <a @click="sendPointId(41)">
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M42.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st57"
                d="M57.9,524.3c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M44.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M57.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="63.9" y1="560.7" x2="63.9" y2="560.7" />
              <g>
                <line class="pn_st13" x1="63.9" y1="560.7" x2="61.4" y2="560.7" />
                <line class="pn_st17" x1="59.3" y1="560.7" x2="59.2" y2="560.7" />
                <line class="pn_st22" x1="59.2" y1="560.7" x2="36.8" y2="560.7" />
                <line class="pn_st13" x1="36.8" y1="560.7" x2="34.3" y2="560.7" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M17.3,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M9,533c-.3.4-.7.9-1.5,1.7-.3.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1.2s0-.5,1.4-1.9c2.3-2.5,3.4-5.1,3.9-6.1.1-.4.3-.7.8-.7s1.2.3,1.2,1-1.2,2.7-1.7,3.6v12.7c0,.7-.3,1-1.1,1s-1-.7-1-1v-9.7ZM21.3,528.1c-.2.6-.7,2.4-.8,2.8h3.9c1.8,0,2.7.6,2.7,2.7v7c0,2-.8,2.6-2.7,2.6h-7.7c-1.9,0-2.7-.6-2.7-2.6v-7c0-2,.8-2.7,2.7-2.7h1.6c.2-.4.7-2.4.8-2.8h-4.7c-.3,0-1,0-1-.9s.7-.9,1-.9h11.2c.3,0,.4,0,.5,0v-.9c0-.8-.4-1.1-1.1-1.1h-15.5c-.7,0-1.1.3-1.1,1.1v1.3c0,.3,0,1-1,1s-1-.6-1-1v-1.5c0-2,.8-2.7,2.7-2.7h7.1v-1.4c0-.3,0-.9,1.1-.9s1.2.2,1.2.9v1.4h7.2c1.9,0,2.7.6,2.7,2.7v1.6c0,.4,0,1-1,1s-.5,0-.8-.2c-.2.4-.6.4-.8.4h-4.4ZM16.1,536.1h9v-2.5c0-.8-.4-1.1-1.1-1.1h-6.8c-.8,0-1.1.4-1.1,1.1v2.5ZM25,537.7h-9v2.7c0,.6.2,1.1,1.1,1.1h6.8c.7,0,1.1-.3,1.1-1.1v-2.7Z"
                />
                <path
                  d="M17.7,582.5l9-.5c.5,0,1.1,0,1.1,1s-.4,1-1,1l-9.1.5v3.9l10.2-.5c.2,0,1.1,0,1.1,1s-.7,1-1,1l-10.4.5v4.6c0,1,.5,1.1,1.3,1.1s5.9,0,6.5,0c.8,0,1-.2,1.2-2.3,0-1,.1-1.6.9-1.6,1.2,0,1.2.8,1.2,1.2,0,.6-.1,2.2-.4,3.1-.4,1.6-1.8,1.6-3.2,1.6s-7,0-7.4,0c-1.5,0-2.3-.6-2.3-2.6v-5l-8.8.5c-.3,0-1.1,0-1.1-1s.2-.9.9-1l8.9-.5v-3.9l-7.4.4c-.2,0-1.1,0-1.1-1s.5-1,1-1l7.5-.4v-3.6c-.7,0-4.4.3-6.6.3s-1.8,0-1.8-1.1.6-.9,1.1-.9c4,0,8.4-.2,14.3-1.1.6,0,3.6-.7,3.9-.7.6,0,.8.6.8,1.1s-.3.8-.9,1c-2.4.6-6.1,1-8.8,1.2v3.7Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_1宿毛_xFF1A_紫" v-if="this.clickedPointId === 41">
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M42.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st71"
              d="M57.9,524.3c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="560.7" x2="63.9" y2="560.7" />
            <g>
              <line class="pn_st2" x1="63.9" y1="560.7" x2="61.4" y2="560.7" />
              <line class="pn_st31" x1="59.3" y1="560.7" x2="59.2" y2="560.7" />
              <line class="pn_st43" x1="59.2" y1="560.7" x2="36.8" y2="560.7" />
              <line class="pn_st2" x1="36.8" y1="560.7" x2="34.3" y2="560.7" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M9,533c-.3.4-.7.9-1.5,1.7-.3.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1.2s0-.5,1.4-1.9c2.3-2.5,3.4-5.1,3.9-6.1.1-.4.3-.7.8-.7s1.2.3,1.2,1-1.2,2.7-1.7,3.6v12.7c0,.7-.3,1-1.1,1s-1-.7-1-1v-9.7ZM21.3,528.1c-.2.6-.7,2.4-.8,2.8h3.9c1.8,0,2.7.6,2.7,2.7v7c0,2-.8,2.6-2.7,2.6h-7.7c-1.9,0-2.7-.6-2.7-2.6v-7c0-2,.8-2.7,2.7-2.7h1.6c.2-.4.7-2.4.8-2.8h-4.7c-.3,0-1,0-1-.9s.7-.9,1-.9h11.2c.3,0,.4,0,.5,0v-.9c0-.8-.4-1.1-1.1-1.1h-15.5c-.7,0-1.1.3-1.1,1.1v1.3c0,.3,0,1-1,1s-1-.6-1-1v-1.5c0-2,.8-2.7,2.7-2.7h7.1v-1.4c0-.3,0-.9,1.1-.9s1.2.2,1.2.9v1.4h7.2c1.9,0,2.7.6,2.7,2.7v1.6c0,.4,0,1-1,1s-.5,0-.8-.2c-.2.4-.6.4-.8.4h-4.4ZM16.1,536.1h9v-2.5c0-.8-.4-1.1-1.1-1.1h-6.8c-.8,0-1.1.4-1.1,1.1v2.5ZM25,537.7h-9v2.7c0,.6.2,1.1,1.1,1.1h6.8c.7,0,1.1-.3,1.1-1.1v-2.7Z"
              />
              <path
                class="pn_st63"
                d="M17.7,582.5l9-.5c.5,0,1.1,0,1.1,1s-.4,1-1,1l-9.1.5v3.9l10.2-.5c.2,0,1.1,0,1.1,1s-.7,1-1,1l-10.4.5v4.6c0,1,.5,1.1,1.3,1.1s5.9,0,6.5,0c.8,0,1-.2,1.2-2.3,0-1,.1-1.6.9-1.6,1.2,0,1.2.8,1.2,1.2,0,.6-.1,2.2-.4,3.1-.4,1.6-1.8,1.6-3.2,1.6s-7,0-7.4,0c-1.5,0-2.3-.6-2.3-2.6v-5l-8.8.5c-.3,0-1.1,0-1.1-1s.2-.9.9-1l8.9-.5v-3.9l-7.4.4c-.2,0-1.1,0-1.1-1s.5-1,1-1l7.5-.4v-3.6c-.7,0-4.4.3-6.6.3s-1.8,0-1.8-1.1.6-.9,1.1-.9c4,0,8.4-.2,14.3-1.1.6,0,3.6-.7,3.9-.7.6,0,.8.6.8,1.1s-.3.8-.9,1c-2.4.6-6.1,1-8.8,1.2v3.7Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_1宿毛_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(41)"
          class="cursor_not_allowed"
        >
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M42.5,531.8c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st71"
              d="M57.9,524.3c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,543.1c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,550.3c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="560.7" x2="63.9" y2="560.7" />
            <g>
              <line class="pn_st2" x1="63.9" y1="560.7" x2="61.4" y2="560.7" />
              <line class="pn_st31" x1="59.3" y1="560.7" x2="59.2" y2="560.7" />
              <line class="pn_st43" x1="59.2" y1="560.7" x2="36.8" y2="560.7" />
              <line class="pn_st2" x1="36.8" y1="560.7" x2="34.3" y2="560.7" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M17.3,614.2c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,508.7c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,505.7h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M9,533c-.3.4-.7.9-1.5,1.7-.3.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1.2s0-.5,1.4-1.9c2.3-2.5,3.4-5.1,3.9-6.1.1-.4.3-.7.8-.7s1.2.3,1.2,1-1.2,2.7-1.7,3.6v12.7c0,.7-.3,1-1.1,1s-1-.7-1-1v-9.7ZM21.3,528.1c-.2.6-.7,2.4-.8,2.8h3.9c1.8,0,2.7.6,2.7,2.7v7c0,2-.8,2.6-2.7,2.6h-7.7c-1.9,0-2.7-.6-2.7-2.6v-7c0-2,.8-2.7,2.7-2.7h1.6c.2-.4.7-2.4.8-2.8h-4.7c-.3,0-1,0-1-.9s.7-.9,1-.9h11.2c.3,0,.4,0,.5,0v-.9c0-.8-.4-1.1-1.1-1.1h-15.5c-.7,0-1.1.3-1.1,1.1v1.3c0,.3,0,1-1,1s-1-.6-1-1v-1.5c0-2,.8-2.7,2.7-2.7h7.1v-1.4c0-.3,0-.9,1.1-.9s1.2.2,1.2.9v1.4h7.2c1.9,0,2.7.6,2.7,2.7v1.6c0,.4,0,1-1,1s-.5,0-.8-.2c-.2.4-.6.4-.8.4h-4.4ZM16.1,536.1h9v-2.5c0-.8-.4-1.1-1.1-1.1h-6.8c-.8,0-1.1.4-1.1,1.1v2.5ZM25,537.7h-9v2.7c0,.6.2,1.1,1.1,1.1h6.8c.7,0,1.1-.3,1.1-1.1v-2.7Z"
              />
              <path
                d="M17.7,582.5l9-.5c.5,0,1.1,0,1.1,1s-.4,1-1,1l-9.1.5v3.9l10.2-.5c.2,0,1.1,0,1.1,1s-.7,1-1,1l-10.4.5v4.6c0,1,.5,1.1,1.3,1.1s5.9,0,6.5,0c.8,0,1-.2,1.2-2.3,0-1,.1-1.6.9-1.6,1.2,0,1.2.8,1.2,1.2,0,.6-.1,2.2-.4,3.1-.4,1.6-1.8,1.6-3.2,1.6s-7,0-7.4,0c-1.5,0-2.3-.6-2.3-2.6v-5l-8.8.5c-.3,0-1.1,0-1.1-1s.2-.9.9-1l8.9-.5v-3.9l-7.4.4c-.2,0-1.1,0-1.1-1s.5-1,1-1l7.5-.4v-3.6c-.7,0-4.4.3-6.6.3s-1.8,0-1.8-1.1.6-.9,1.1-.9c4,0,8.4-.2,14.3-1.1.6,0,3.6-.7,3.9-.7.6,0,.8.6.8,1.1s-.3.8-.9,1c-2.4.6-6.1,1-8.8,1.2v3.7Z"
              />
            </g>
          </g>
        </g>
        <g id="_x34_0愛南_xFF1A_橙">
          <a @click="sendPointId(40)">
            <g>
              <path
                class="pn_st67"
                d="M17.3,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="17.3" y1="505.5" x2="17.3" y2="505.5" />
              <g>
                <line class="pn_st13" x1="17.3" y1="505.5" x2="17.3" y2="503" />
                <line class="pn_st6" x1="17.3" y1="500.3" x2="17.3" y2="500.3" />
                <line class="pn_st27" x1="17.3" y1="500.3" x2="17.3" y2="491" />
                <line class="pn_st13" x1="17.3" y1="491" x2="17.3" y2="488.5" />
              </g>
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M26.6,493.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st57"
                d="M41.4,494.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM38.1,499.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M53.8,496.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M67.2,503.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M21.9,408.3c.8,0,2,0,2,1.3s-.6,1.3-1.2,1.8c-.7.6-1.9,1.5-3.1,2.1,3.1,1,5.5,1.2,8.2,1.5.4,0,1,0,1,.9s0,1.1-1.1,1.1-2,0-4.2-.5c-3-.6-5-1.4-6.1-1.9-1,.4-2.5,1-4.8,1.5-2.9.7-5.4.9-5.7.9-1,0-1-1-1-1.1,0-.9.6-.9,1.5-.9,4-.2,6.8-1.1,7.8-1.5-1.3-.8-2.3-1.3-3.6-2.6-1.9,1.1-4,1.8-4.5,1.8s-.9-.6-.9-1,.5-.8.8-.8c1.8-.6,4.7-1.6,7.4-4.1-.6,0-1.9-.1-1.9-2v-1.6c0-.7.2-1,1-1s.9.6.9,1v1.3c0,.6.2.8.7.9h4.7c.7,0,.7-.3.9-1.1,0-.5.3-.7.8-.7s1,.2,1,.8-.2,1-.3,1.4c-.3.8-.8,1-1.5,1.1-.4,0-3.1,0-3.8,0-.3.4-.7.8-1.4,1.5h6.5ZM25.3,399.4c1.9,0,3,.1,3,2.6v1.5c0,.6-.3,1-1,1s-1.1-.3-1.1-1v-1.5c0-.7-.3-1.1-1-1.1h-15.6c-.7,0-1,.3-1,1.1v1.5c0,.7-.4,1-1,1s-1.1-.2-1.1-1v-1.4c0-2.5.9-2.7,3-2.7h1.2c-.1-.1-.2-.2-.4-.7-.2-.5-.2-.6-.4-.9-.2-.3-.2-.4-.2-.5,0-.2,0-.3,0-.3-.7,0-2,0-2.2,0-.5-.1-.5-.6-.5-.9,0-.9.6-.9,1.4-.9,3.8,0,8.3,0,13.6-.6.6,0,3.9-.6,4-.6.9,0,1,.7,1,1,0,.7-.3.8-2.4,1.1.4.1.8.4.8.8s-1.1,2-1.5,2.6h1.4ZM11.6,403.2c0,.9-2.9,4.8-4,4.8s-1-.5-1-1,0-.3,1.2-1.4c.8-.8,1.4-1.7,2-2.8.3-.4.5-.5.8-.5s.9.3.9.9ZM16.8,399.4c-.2-.2-.2-.2-.4-.7,0-.2-.7-1.3-.7-1.6s0-.3.1-.4c-1.1,0-3.5.2-4.3.2.3.4.9,1.5.9,1.9s-.2.5-.3.6h4.7ZM13.3,409.9h0c1.4,1.2,2.2,1.8,4.1,2.7,1.9-.9,3.5-2.2,3.5-2.5s-.3-.2-.5-.2h-7.1ZM18.6,404c-.2,0-.3,0-1.1-.5-.3-.2-1.8-.8-2.1-.9-.2,0-.5-.3-.5-.7s.3-.9.8-.9,1.8.6,2.3.8c1.2.5,1.5.7,1.5,1.2s-.5,1-.9,1ZM21.5,399.4c.8-1.2,1.4-2.2,1.5-2.4.4-.7.4-.8.6-.9-1.8.2-4.6.4-6.1.5.4.4,1.1,1.6,1.1,2.2s-.2.5-.3.6h3.3ZM26.8,407.6c-.5,0-.5-.1-1.3-1.2-.7-1-1.3-1.6-2.3-2.6-.1,0-.3-.3-.3-.6,0-.4.5-.9,1-.9s.6,0,1.5,1.1c1,1,1.7,1.9,2,2.3.3.4.5.7.5,1s-.5,1-1,1Z"
                />
                <path
                  d="M24.7,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2H6.8c-.4,0-1,0-1-1s.5-1,1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM19,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.7.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-.9,0-.9-.9s.6-.9.9-.9h4.8v-2.2h-4.8c-.3,0-.9,0-.9-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.7-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x34_0愛南_xFF1A_紫" v-if="this.clickedPointId === 40">
          <g>
            <line class="pn_st0" x1="17.3" y1="505.5" x2="17.3" y2="505.5" />
            <g>
              <line class="pn_st2" x1="17.3" y1="505.5" x2="17.3" y2="503" />
              <line class="pn_st51" x1="17.3" y1="500.3" x2="17.3" y2="500.3" />
              <line class="pn_st52" x1="17.3" y1="500.3" x2="17.3" y2="491" />
              <line class="pn_st2" x1="17.3" y1="491" x2="17.3" y2="488.5" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M26.6,493.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M41.4,494.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM38.1,499.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M53.8,496.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M67.2,503.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M21.9,408.3c.8,0,2,0,2,1.3s-.6,1.3-1.2,1.8c-.7.6-1.9,1.5-3.1,2.1,3.1,1,5.5,1.2,8.2,1.5.4,0,1,0,1,.9s0,1.1-1.1,1.1-2,0-4.2-.5c-3-.6-5-1.4-6.1-1.9-1,.4-2.5,1-4.8,1.5-2.9.7-5.4.9-5.7.9-1,0-1-1-1-1.1,0-.9.6-.9,1.5-.9,4-.2,6.8-1.1,7.8-1.5-1.3-.8-2.3-1.3-3.6-2.6-1.9,1.1-4,1.8-4.5,1.8s-.9-.6-.9-1,.5-.8.8-.8c1.8-.6,4.7-1.6,7.4-4.1-.6,0-1.9-.1-1.9-2v-1.6c0-.7.2-1,1-1s.9.6.9,1v1.3c0,.6.2.8.7.9h4.7c.7,0,.7-.3.9-1.1,0-.5.3-.7.8-.7s1,.2,1,.8-.2,1-.3,1.4c-.3.8-.8,1-1.5,1.1-.4,0-3.1,0-3.8,0-.3.4-.7.8-1.4,1.5h6.5ZM25.3,399.4c1.9,0,3,.1,3,2.6v1.5c0,.6-.3,1-1,1s-1.1-.3-1.1-1v-1.5c0-.7-.3-1.1-1-1.1h-15.6c-.7,0-1,.3-1,1.1v1.5c0,.7-.4,1-1,1s-1.1-.2-1.1-1v-1.4c0-2.5.9-2.7,3-2.7h1.2c-.1-.1-.2-.2-.4-.7-.2-.5-.2-.6-.4-.9-.2-.3-.2-.4-.2-.5,0-.2,0-.3,0-.3-.7,0-2,0-2.2,0-.5-.1-.5-.6-.5-.9,0-.9.6-.9,1.4-.9,3.8,0,8.3,0,13.6-.6.6,0,3.9-.6,4-.6.9,0,1,.7,1,1,0,.7-.3.8-2.4,1.1.4.1.8.4.8.8s-1.1,2-1.5,2.6h1.4ZM11.6,403.2c0,.9-2.9,4.8-4,4.8s-1-.5-1-1,0-.3,1.2-1.4c.8-.8,1.4-1.7,2-2.8.3-.4.5-.5.8-.5s.9.3.9.9ZM16.8,399.4c-.2-.2-.2-.2-.4-.7,0-.2-.7-1.3-.7-1.6s0-.3.1-.4c-1.1,0-3.5.2-4.3.2.3.4.9,1.5.9,1.9s-.2.5-.3.6h4.7ZM13.3,409.9h0c1.4,1.2,2.2,1.8,4.1,2.7,1.9-.9,3.5-2.2,3.5-2.5s-.3-.2-.5-.2h-7.1ZM18.6,404c-.2,0-.3,0-1.1-.5-.3-.2-1.8-.8-2.1-.9-.2,0-.5-.3-.5-.7s.3-.9.8-.9,1.8.6,2.3.8c1.2.5,1.5.7,1.5,1.2s-.5,1-.9,1ZM21.5,399.4c.8-1.2,1.4-2.2,1.5-2.4.4-.7.4-.8.6-.9-1.8.2-4.6.4-6.1.5.4.4,1.1,1.6,1.1,2.2s-.2.5-.3.6h3.3ZM26.8,407.6c-.5,0-.5-.1-1.3-1.2-.7-1-1.3-1.6-2.3-2.6-.1,0-.3-.3-.3-.6,0-.4.5-.9,1-.9s.6,0,1.5,1.1c1,1,1.7,1.9,2,2.3.3.4.5.7.5,1s-.5,1-1,1Z"
              />
              <path
                class="pn_st63"
                d="M24.7,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2H6.8c-.4,0-1,0-1-1s.5-1,1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM19,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.7.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-.9,0-.9-.9s.6-.9.9-.9h4.8v-2.2h-4.8c-.3,0-.9,0-.9-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.7-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x34_0愛南_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(40)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M17.3,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="505.5" x2="17.3" y2="505.5" />
            <g>
              <line class="pn_st2" x1="17.3" y1="505.5" x2="17.3" y2="503" />
              <line class="pn_st51" x1="17.3" y1="500.3" x2="17.3" y2="500.3" />
              <line class="pn_st52" x1="17.3" y1="500.3" x2="17.3" y2="491" />
              <line class="pn_st2" x1="17.3" y1="491" x2="17.3" y2="488.5" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M26.6,493.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st71"
              d="M41.4,494.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM38.1,499.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M53.8,496.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M67.2,503.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M21.9,408.3c.8,0,2,0,2,1.3s-.6,1.3-1.2,1.8c-.7.6-1.9,1.5-3.1,2.1,3.1,1,5.5,1.2,8.2,1.5.4,0,1,0,1,.9s0,1.1-1.1,1.1-2,0-4.2-.5c-3-.6-5-1.4-6.1-1.9-1,.4-2.5,1-4.8,1.5-2.9.7-5.4.9-5.7.9-1,0-1-1-1-1.1,0-.9.6-.9,1.5-.9,4-.2,6.8-1.1,7.8-1.5-1.3-.8-2.3-1.3-3.6-2.6-1.9,1.1-4,1.8-4.5,1.8s-.9-.6-.9-1,.5-.8.8-.8c1.8-.6,4.7-1.6,7.4-4.1-.6,0-1.9-.1-1.9-2v-1.6c0-.7.2-1,1-1s.9.6.9,1v1.3c0,.6.2.8.7.9h4.7c.7,0,.7-.3.9-1.1,0-.5.3-.7.8-.7s1,.2,1,.8-.2,1-.3,1.4c-.3.8-.8,1-1.5,1.1-.4,0-3.1,0-3.8,0-.3.4-.7.8-1.4,1.5h6.5ZM25.3,399.4c1.9,0,3,.1,3,2.6v1.5c0,.6-.3,1-1,1s-1.1-.3-1.1-1v-1.5c0-.7-.3-1.1-1-1.1h-15.6c-.7,0-1,.3-1,1.1v1.5c0,.7-.4,1-1,1s-1.1-.2-1.1-1v-1.4c0-2.5.9-2.7,3-2.7h1.2c-.1-.1-.2-.2-.4-.7-.2-.5-.2-.6-.4-.9-.2-.3-.2-.4-.2-.5,0-.2,0-.3,0-.3-.7,0-2,0-2.2,0-.5-.1-.5-.6-.5-.9,0-.9.6-.9,1.4-.9,3.8,0,8.3,0,13.6-.6.6,0,3.9-.6,4-.6.9,0,1,.7,1,1,0,.7-.3.8-2.4,1.1.4.1.8.4.8.8s-1.1,2-1.5,2.6h1.4ZM11.6,403.2c0,.9-2.9,4.8-4,4.8s-1-.5-1-1,0-.3,1.2-1.4c.8-.8,1.4-1.7,2-2.8.3-.4.5-.5.8-.5s.9.3.9.9ZM16.8,399.4c-.2-.2-.2-.2-.4-.7,0-.2-.7-1.3-.7-1.6s0-.3.1-.4c-1.1,0-3.5.2-4.3.2.3.4.9,1.5.9,1.9s-.2.5-.3.6h4.7ZM13.3,409.9h0c1.4,1.2,2.2,1.8,4.1,2.7,1.9-.9,3.5-2.2,3.5-2.5s-.3-.2-.5-.2h-7.1ZM18.6,404c-.2,0-.3,0-1.1-.5-.3-.2-1.8-.8-2.1-.9-.2,0-.5-.3-.5-.7s.3-.9.8-.9,1.8.6,2.3.8c1.2.5,1.5.7,1.5,1.2s-.5,1-.9,1ZM21.5,399.4c.8-1.2,1.4-2.2,1.5-2.4.4-.7.4-.8.6-.9-1.8.2-4.6.4-6.1.5.4.4,1.1,1.6,1.1,2.2s-.2.5-.3.6h3.3ZM26.8,407.6c-.5,0-.5-.1-1.3-1.2-.7-1-1.3-1.6-2.3-2.6-.1,0-.3-.3-.3-.6,0-.4.5-.9,1-.9s.6,0,1.5,1.1c1,1,1.7,1.9,2,2.3.3.4.5.7.5,1s-.5,1-1,1Z"
              />
              <path
                d="M24.7,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2H6.8c-.4,0-1,0-1-1s.5-1,1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM19,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.7.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-.9,0-.9-.9s.6-.9.9-.9h4.8v-2.2h-4.8c-.3,0-.9,0-.9-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.7-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_9三原_xFF1A_橙">
          <a @click="sendPointId(39)">
            <g>
              <line class="pn_st0" x1="34.4" y1="434.3" x2="34.4" y2="434.3" />
              <g>
                <line class="pn_st13" x1="34.4" y1="434.3" x2="36.9" y2="434.3" />
                <line class="pn_st3" x1="39" y1="434.3" x2="39" y2="434.3" />
                <line class="pn_st38" x1="39" y1="434.3" x2="61.5" y2="434.3" />
                <line class="pn_st13" x1="61.5" y1="434.3" x2="64" y2="434.3" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M81,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M81,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M91.5,413.4c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM90.4,395.7c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM89.1,404.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
                />
                <path
                  d="M87.8,453.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM78.8,465.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM77.4,457.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM77.4,459.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM89.1,466.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M39.2,408.9c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,407.4v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
                />
                <path
                  class="pn_st57"
                  d="M54.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M44.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M57.8,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_9三原_xFF1A_紫" v-if="this.clickedPointId === 39">
          <g>
            <line class="pn_st0" x1="34.4" y1="434.3" x2="34.4" y2="434.3" />
            <g>
              <line class="pn_st2" x1="34.4" y1="434.3" x2="36.9" y2="434.3" />
              <line class="pn_st28" x1="39" y1="434.3" x2="39" y2="434.3" />
              <line class="pn_st34" x1="39" y1="434.3" x2="61.5" y2="434.3" />
              <line class="pn_st2" x1="61.5" y1="434.3" x2="64" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="64"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M91.5,413.4c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM90.4,395.7c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM89.1,404.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                class="pn_st63"
                d="M87.8,453.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM78.8,465.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM77.4,457.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM77.4,459.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM89.1,466.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.2,408.9c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,407.4v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M54.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_9三原_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(39)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="34.4" y1="434.3" x2="34.4" y2="434.3" />
            <g>
              <line class="pn_st2" x1="34.4" y1="434.3" x2="36.9" y2="434.3" />
              <line class="pn_st28" x1="39" y1="434.3" x2="39" y2="434.3" />
              <line class="pn_st34" x1="39" y1="434.3" x2="61.5" y2="434.3" />
              <line class="pn_st2" x1="61.5" y1="434.3" x2="64" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M81,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M91.5,413.4c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM90.4,395.7c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM89.1,404.2c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                d="M87.8,453.9c1.6,0,2.3.5,2.3,2.3v5c0,1.7-.7,2.3-2.3,2.3h-3.8v5.6c0,2.5-1,2.7-3.1,2.7h-.6c-.4,0-1.2,0-1.3,0-.4,0-.6-.6-.6-1,0-.9.6-.9,1.1-.9,1.2,0,1.6,0,1.8-.1.3-.1.5-.4.5-1v-5.2h-4c-1.6,0-2.3-.6-2.3-2.3v-5c0-1.7.7-2.3,2.3-2.3h3.3c.2-.6.5-1.4.7-2.4h-7c-1,0-1.5.5-1.5,1.5v7.2c0,3.3-.3,6.6-1.5,9.7-.5,1.3-.7,1.5-1.2,1.5s-1.3-.3-1.3-1.1.8-2.2.8-2.5c.4-1.2,1-3.8,1-7.6v-7.3c0-2.5,1-3.2,3.2-3.2h16.9c.3,0,1,0,1,.9s-.6.9-1,.9h-7.4c0,.2-.4,1.5-.7,2.4h4.6ZM78.8,465.5c0,.7-1.7,3.1-2.7,4.3-1,1.2-1.3,1.3-1.6,1.3-.6,0-1.1-.5-1.1-1s.2-.7,1.1-1.5c1.1-1.2,1.9-2.5,2.5-3.6.2-.3.4-.4.6-.4,1,0,1.3.6,1.3.9ZM77.4,457.9h10.7v-1.6c0-.4-.1-.8-.8-.8h-9c-.6,0-.8.3-.8.8v1.6ZM77.4,459.5v1.6c0,.6.2.8.8.8h9c.7,0,.8-.4.8-.8v-1.6h-10.7ZM89.1,466.1c.5.7,1.3,1.7,2,2.4.8.7,1.1,1.1,1.1,1.5s-.4,1-1.1,1-.8-.1-2.5-2.1c0,0-1.6-2-2-2.9,0-.2,0-.3,0-.4,0-.5.5-.9,1-1,.5,0,.5,0,1.5,1.5Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.2,408.9c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM43.9,407.4v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M54.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_8四万十_xFF1A_橙">
          <a @click="sendPointId(38)">
            <g>
              <line class="pn_st0" x1="98.1" y1="434.3" x2="98.1" y2="434.3" />
              <g>
                <line class="pn_st13" x1="98.1" y1="434.3" x2="100.6" y2="434.3" />
                <line class="pn_st3" x1="102.7" y1="434.3" x2="102.7" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="102.7"
                  y1="434.3"
                  x2="125.1"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="125.1"
                  y1="434.3"
                  x2="127.6"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M144.7,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M144.7,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M155.4,412.8c0,2.4-.9,3.2-3.2,3.2h-14.9c-2.3,0-3.2-.8-3.2-3.2v-14.4c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v14.4ZM140.4,397.1h-2.8c-.9,0-1.5.4-1.5,1.5v14c0,1,.5,1.5,1.5,1.5h14.3c1.1,0,1.5-.5,1.5-1.5v-14c0-1-.4-1.5-1.5-1.5h-4v10c0,.6.2.8.7.8.1,0,1,0,1.7,0s.8,0,.8-1.2c0-1.2,0-1.7.8-1.7s.9.7.9,1.1,0,3-1.4,3.5c-.3.2-1.5.2-2.7.2-1.9,0-2.8,0-2.8-2.4v-10.4h-3.7v5.5c0,1-.1,3.6-1.6,6-.6,1-2.1,2.5-2.9,2.5s-1.1-.5-1.1-1.1,0-.4,1.2-1.3c.8-.6,2.5-2.1,2.5-6.2v-5.3Z"
                />
                <path
                  d="M142.6,424.5v3.5c0,.1,0,.6,0,1.4h8c1.7,0,3.3.1,3.3,2.7s-.3,7.6-1.4,10.2c-.8,2.1-2.5,2.3-4.9,2.3h-2c-.8,0-1.1-.7-1.1-1.2,0-1,.7-1,1.3-1s2.1,0,2.4,0c1.6,0,2.2-.7,2.6-2.1.5-2.1.8-6.5.8-7.6s0-1.4-1.5-1.4h-7.7c-.6,5.1-2.3,8.2-4.3,10.4-.8.8-2.9,2.8-3.7,2.8s-1.1-.6-1.1-1.2.3-.8.7-1c4.8-3.1,6.5-7.8,6.5-14.4v-3.4h-6.5c-.3,0-1.1,0-1.1-1s.5-1,1.1-1h21.4c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-12.8Z"
                />
                <path
                  d="M155.4,456.5c.5,0,1.1.1,1.1,1s-.3,1-1.1,1h-9.7v12.6c0,.7-.3,1-1,1s-1.1-.1-1.1-1v-12.6h-9.6c-.8,0-1-.5-1-1s.1-1.1,1-1.1h9.6v-6.5c0-.5.2-1.1,1.1-1.1s1.1.2,1.1,1.1v6.5h9.7Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M115.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M108.2,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M121.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_8四万十_xFF1A_紫" v-if="this.clickedPointId === 38">
          <g>
            <line class="pn_st0" x1="98.1" y1="434.3" x2="98.1" y2="434.3" />
            <g>
              <line class="pn_st2" x1="98.1" y1="434.3" x2="100.6" y2="434.3" />
              <line class="pn_st28" x1="102.7" y1="434.3" x2="102.7" y2="434.3" />
              <line class="pn_st34" x1="102.7" y1="434.3" x2="125.1" y2="434.3" />
              <line class="pn_st2" x1="125.1" y1="434.3" x2="127.6" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="127.7"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M155.4,412.8c0,2.4-.9,3.2-3.2,3.2h-14.9c-2.3,0-3.2-.8-3.2-3.2v-14.4c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v14.4ZM140.4,397.1h-2.8c-.9,0-1.5.4-1.5,1.5v14c0,1,.5,1.5,1.5,1.5h14.3c1.1,0,1.5-.5,1.5-1.5v-14c0-1-.4-1.5-1.5-1.5h-4v10c0,.6.2.8.7.8.1,0,1,0,1.7,0s.8,0,.8-1.2c0-1.2,0-1.7.8-1.7s.9.7.9,1.1,0,3-1.4,3.5c-.3.2-1.5.2-2.7.2-1.9,0-2.8,0-2.8-2.4v-10.4h-3.7v5.5c0,1-.1,3.6-1.6,6-.6,1-2.1,2.5-2.9,2.5s-1.1-.5-1.1-1.1,0-.4,1.2-1.3c.8-.6,2.5-2.1,2.5-6.2v-5.3Z"
              />
              <path
                class="pn_st63"
                d="M142.6,424.5v3.5c0,.1,0,.6,0,1.4h8c1.7,0,3.3.1,3.3,2.7s-.3,7.6-1.4,10.2c-.8,2.1-2.5,2.3-4.9,2.3h-2c-.8,0-1.1-.7-1.1-1.2,0-1,.7-1,1.3-1s2.1,0,2.4,0c1.6,0,2.2-.7,2.6-2.1.5-2.1.8-6.5.8-7.6s0-1.4-1.5-1.4h-7.7c-.6,5.1-2.3,8.2-4.3,10.4-.8.8-2.9,2.8-3.7,2.8s-1.1-.6-1.1-1.2.3-.8.7-1c4.8-3.1,6.5-7.8,6.5-14.4v-3.4h-6.5c-.3,0-1.1,0-1.1-1s.5-1,1.1-1h21.4c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-12.8Z"
              />
              <path
                class="pn_st63"
                d="M155.4,456.5c.5,0,1.1.1,1.1,1s-.3,1-1.1,1h-9.7v12.6c0,.7-.3,1-1,1s-1.1-.1-1.1-1v-12.6h-9.6c-.8,0-1-.5-1-1s.1-1.1,1-1.1h9.6v-6.5c0-.5.2-1.1,1.1-1.1s1.1.2,1.1,1.1v6.5h9.7Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M115.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M108.2,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_8四万十_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(38)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="98.1" y1="434.3" x2="98.1" y2="434.3" />
            <g>
              <line class="pn_st2" x1="98.1" y1="434.3" x2="100.6" y2="434.3" />
              <line class="pn_st28" x1="102.7" y1="434.3" x2="102.7" y2="434.3" />
              <line class="pn_st34" x1="102.7" y1="434.3" x2="125.1" y2="434.3" />
              <line class="pn_st2" x1="125.1" y1="434.3" x2="127.6" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M144.7,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M144.7,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M115.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M108.2,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M155.4,412.8c0,2.4-.9,3.2-3.2,3.2h-14.9c-2.3,0-3.2-.8-3.2-3.2v-14.4c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v14.4ZM140.4,397.1h-2.8c-.9,0-1.5.4-1.5,1.5v14c0,1,.5,1.5,1.5,1.5h14.3c1.1,0,1.5-.5,1.5-1.5v-14c0-1-.4-1.5-1.5-1.5h-4v10c0,.6.2.8.7.8.1,0,1,0,1.7,0s.8,0,.8-1.2c0-1.2,0-1.7.8-1.7s.9.7.9,1.1,0,3-1.4,3.5c-.3.2-1.5.2-2.7.2-1.9,0-2.8,0-2.8-2.4v-10.4h-3.7v5.5c0,1-.1,3.6-1.6,6-.6,1-2.1,2.5-2.9,2.5s-1.1-.5-1.1-1.1,0-.4,1.2-1.3c.8-.6,2.5-2.1,2.5-6.2v-5.3Z"
              />
              <path
                d="M142.6,424.5v3.5c0,.1,0,.6,0,1.4h8c1.7,0,3.3.1,3.3,2.7s-.3,7.6-1.4,10.2c-.8,2.1-2.5,2.3-4.9,2.3h-2c-.8,0-1.1-.7-1.1-1.2,0-1,.7-1,1.3-1s2.1,0,2.4,0c1.6,0,2.2-.7,2.6-2.1.5-2.1.8-6.5.8-7.6s0-1.4-1.5-1.4h-7.7c-.6,5.1-2.3,8.2-4.3,10.4-.8.8-2.9,2.8-3.7,2.8s-1.1-.6-1.1-1.2.3-.8.7-1c4.8-3.1,6.5-7.8,6.5-14.4v-3.4h-6.5c-.3,0-1.1,0-1.1-1s.5-1,1.1-1h21.4c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-12.8Z"
              />
              <path
                d="M155.4,456.5c.5,0,1.1.1,1.1,1s-.3,1-1.1,1h-9.7v12.6c0,.7-.3,1-1,1s-1.1-.1-1.1-1v-12.6h-9.6c-.8,0-1-.5-1-1s.1-1.1,1-1.1h9.6v-6.5c0-.5.2-1.1,1.1-1.1s1.1.2,1.1,1.1v6.5h9.7Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_7黒潮_xFF1A_橙">
          <a @click="sendPointId(37)">
            <g>
              <line class="pn_st0" x1="161.8" y1="434.3" x2="161.8" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="161.8"
                  y1="434.3"
                  x2="164.3"
                  y2="434.3"
                />
                <line class="pn_st3" x1="166.4" y1="434.3" x2="166.4" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="166.4"
                  y1="434.3"
                  x2="188.8"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="188.8"
                  y1="434.3"
                  x2="191.3"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M208.5,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M208.5,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M166.7,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M178.4,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M171.9,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M185.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M209.4,405.6h8.3c.2,0,1,0,1,.8s-.7.8-1,.8h-8.3v1.9h9.6c.2,0,1,0,1,.9s-.8.8-1,.8h-21.2c-.2,0-1,0-1-.8s.6-.9,1-.9h9.5v-1.9h-8.3c-.2,0-1,0-1-.8s.7-.9,1-.9h8.3v-2h-6.1c-1.8,0-2.3-.5-2.3-2.3v-4.5c0-1.8.5-2.3,2.3-2.3h14.3c1.8,0,2.3.5,2.3,2.3v4.5c0,1.8-.5,2.3-2.3,2.3h-6.2v2ZM201.2,412.4c0,.6-1.1,2.5-1.4,2.9-1,1.7-1.4,1.8-1.8,1.8s-1.2-.5-1.2-1,0-.3.9-1.5c.7-.9,1-1.6,1.6-2.7.2-.5.4-.5.8-.5s1,.3,1,.9ZM201,398.3h6.4v-2.2h-5.6c-.7,0-.8.4-.8.8v1.4ZM201,399.8v1.4c0,.5.2.8.8.8h5.6v-2.2h-6.4ZM206.1,412.9c.2,1,.6,2.7.6,3.2,0,.9-1,.9-1.1.9-.9,0-1-.7-1-1,0-1,0-1.3-.2-2.1,0-.2-.2-1.3-.2-1.4,0-.8.7-.8.8-.8.9,0,1,.3,1.2,1.1ZM215.9,398.3v-1.4c0-.5-.2-.8-.8-.8h-5.7v2.2h6.5ZM215.9,399.8h-6.5v2.2h5.7c.6,0,.8-.3.8-.8v-1.4ZM212.3,413.5c.2.6.8,2,.8,2.5s-.7.8-1.1.8c-.7,0-.7-.2-1.1-1.5-.2-.8-.3-1.1-.8-2.3-.1-.3-.2-.5-.2-.7,0-.5.5-.8,1-.8s.8.5,1.4,1.8ZM218,413.1c.6.7,1.8,2.3,1.8,2.9s-.6,1-1.2,1-.5,0-1.3-1.3c-.5-.8-1.2-1.6-1.9-2.5-.2-.2-.4-.5-.4-.8s.1-.9,1.1-.9.5,0,1.8,1.6Z"
                />
                <path
                  d="M200.5,457.6c.8.6,1,.8,1,1.2s-.5,1.1-1,1.1-.4,0-1.2-.7c-.3-.2-1.8-1.2-2.1-1.5-.3-.2-.4-.4-.4-.7,0-.5.4-1,.9-1.1.2,0,.5,0,2.9,1.6ZM197.7,469c1.1-2.1,2.1-5.1,2.1-5.1.1-.4.2-.8.9-.8s1.1.4,1.1.9c0,1-1.7,4.7-2.2,5.9-.8,1.7-1.1,2-1.6,2s-1.1-.2-1.1-1.1c0-.3,0-.4.8-1.8ZM198.5,449.3c.3,0,.4,0,2.5,1.3,1.1.7,1.2.8,1.2,1.2,0,.5-.5,1.2-1.1,1.2s-.2,0-1.1-.6c-.4-.2-2-1.2-2.2-1.4,0,0-.3-.3-.2-.7,0-.4.4-.9,1-.9ZM206,454.9v-2h-2.8c-.3,0-.9,0-.9-.9s.7-.9.9-.9h2.8v-1.3c0-.8.4-.9.9-.9.7,0,.8.5.8.9v1.3h2.8c.3,0,1,0,1,.9s-.7.9-1,.9h-2.8v2h.9c1.7,0,2.2.5,2.2,2.3v4.2c0,1.9-.5,2.3-2.2,2.3h-.9v2.1h2.9c.4,0,.9.1.9.9s-.6.9-.9.9h-2.9v3.6c0,.8-.3,1-.9,1s-.8-.7-.8-1v-3.6h-3.2c-.3,0-1,0-1-.9s.7-.9,1-.9h3.2v-2.1h-1c-1.7,0-2.2-.5-2.2-2.3v-4.2c0-1.9.5-2.3,2.2-2.3h1ZM204.6,458.6h4.6v-1.3c0-.5-.2-.8-.8-.8h-3c-.6,0-.8.3-.8.8v1.3ZM204.6,460v1.3c0,.5.2.8.8.8h3c.6,0,.8-.3.8-.8v-1.3h-4.6ZM217.6,464h-3.5c0,1.5-.3,4.4-1.6,6.8-.7,1.3-.8,1.4-1.3,1.4s-1.1-.3-1.1-.9,0-.5.3-.8c.9-1.6,2-3.6,2-7.7v-10.8c0-1.9.5-2.3,2.3-2.3h2.4c1.8,0,2.3.5,2.3,2.3v17.7c0,2.3-.9,2.3-3.1,2.3s-1.6,0-1.6-1.1.2-.9.8-.9c.2,0,1.1,0,1.3,0,.5,0,.8-.2.8-.9v-5.1ZM214.2,455.8h3.5v-3.5c0-.5-.2-.8-.8-.8h-1.9c-.5,0-.8.2-.8.8v3.5ZM217.6,457.7h-3.5v4.5h3.5v-4.5Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_7黒潮_xFF1A_紫" v-if="this.clickedPointId === 37">
          <g>
            <line class="pn_st0" x1="161.8" y1="434.3" x2="161.8" y2="434.3" />
            <g>
              <line class="pn_st2" x1="161.8" y1="434.3" x2="164.3" y2="434.3" />
              <line class="pn_st28" x1="166.4" y1="434.3" x2="166.4" y2="434.3" />
              <line class="pn_st34" x1="166.4" y1="434.3" x2="188.8" y2="434.3" />
              <line class="pn_st2" x1="188.8" y1="434.3" x2="191.3" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="191.5"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.7,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M178.4,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.9,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M185.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M209.4,405.6h8.3c.2,0,1,0,1,.8s-.7.8-1,.8h-8.3v1.9h9.6c.2,0,1,0,1,.9s-.8.8-1,.8h-21.2c-.2,0-1,0-1-.8s.6-.9,1-.9h9.5v-1.9h-8.3c-.2,0-1,0-1-.8s.7-.9,1-.9h8.3v-2h-6.1c-1.8,0-2.3-.5-2.3-2.3v-4.5c0-1.8.5-2.3,2.3-2.3h14.3c1.8,0,2.3.5,2.3,2.3v4.5c0,1.8-.5,2.3-2.3,2.3h-6.2v2ZM201.2,412.4c0,.6-1.1,2.5-1.4,2.9-1,1.7-1.4,1.8-1.8,1.8s-1.2-.5-1.2-1,0-.3.9-1.5c.7-.9,1-1.6,1.6-2.7.2-.5.4-.5.8-.5s1,.3,1,.9ZM201,398.3h6.4v-2.2h-5.6c-.7,0-.8.4-.8.8v1.4ZM201,399.8v1.4c0,.5.2.8.8.8h5.6v-2.2h-6.4ZM206.1,412.9c.2,1,.6,2.7.6,3.2,0,.9-1,.9-1.1.9-.9,0-1-.7-1-1,0-1,0-1.3-.2-2.1,0-.2-.2-1.3-.2-1.4,0-.8.7-.8.8-.8.9,0,1,.3,1.2,1.1ZM215.9,398.3v-1.4c0-.5-.2-.8-.8-.8h-5.7v2.2h6.5ZM215.9,399.8h-6.5v2.2h5.7c.6,0,.8-.3.8-.8v-1.4ZM212.3,413.5c.2.6.8,2,.8,2.5s-.7.8-1.1.8c-.7,0-.7-.2-1.1-1.5-.2-.8-.3-1.1-.8-2.3-.1-.3-.2-.5-.2-.7,0-.5.5-.8,1-.8s.8.5,1.4,1.8ZM218,413.1c.6.7,1.8,2.3,1.8,2.9s-.6,1-1.2,1-.5,0-1.3-1.3c-.5-.8-1.2-1.6-1.9-2.5-.2-.2-.4-.5-.4-.8s.1-.9,1.1-.9.5,0,1.8,1.6Z"
              />
              <path
                class="pn_st63"
                d="M200.5,457.6c.8.6,1,.8,1,1.2s-.5,1.1-1,1.1-.4,0-1.2-.7c-.3-.2-1.8-1.2-2.1-1.5-.3-.2-.4-.4-.4-.7,0-.5.4-1,.9-1.1.2,0,.5,0,2.9,1.6ZM197.7,469c1.1-2.1,2.1-5.1,2.1-5.1.1-.4.2-.8.9-.8s1.1.4,1.1.9c0,1-1.7,4.7-2.2,5.9-.8,1.7-1.1,2-1.6,2s-1.1-.2-1.1-1.1c0-.3,0-.4.8-1.8ZM198.5,449.3c.3,0,.4,0,2.5,1.3,1.1.7,1.2.8,1.2,1.2,0,.5-.5,1.2-1.1,1.2s-.2,0-1.1-.6c-.4-.2-2-1.2-2.2-1.4,0,0-.3-.3-.2-.7,0-.4.4-.9,1-.9ZM206,454.9v-2h-2.8c-.3,0-.9,0-.9-.9s.7-.9.9-.9h2.8v-1.3c0-.8.4-.9.9-.9.7,0,.8.5.8.9v1.3h2.8c.3,0,1,0,1,.9s-.7.9-1,.9h-2.8v2h.9c1.7,0,2.2.5,2.2,2.3v4.2c0,1.9-.5,2.3-2.2,2.3h-.9v2.1h2.9c.4,0,.9.1.9.9s-.6.9-.9.9h-2.9v3.6c0,.8-.3,1-.9,1s-.8-.7-.8-1v-3.6h-3.2c-.3,0-1,0-1-.9s.7-.9,1-.9h3.2v-2.1h-1c-1.7,0-2.2-.5-2.2-2.3v-4.2c0-1.9.5-2.3,2.2-2.3h1ZM204.6,458.6h4.6v-1.3c0-.5-.2-.8-.8-.8h-3c-.6,0-.8.3-.8.8v1.3ZM204.6,460v1.3c0,.5.2.8.8.8h3c.6,0,.8-.3.8-.8v-1.3h-4.6ZM217.6,464h-3.5c0,1.5-.3,4.4-1.6,6.8-.7,1.3-.8,1.4-1.3,1.4s-1.1-.3-1.1-.9,0-.5.3-.8c.9-1.6,2-3.6,2-7.7v-10.8c0-1.9.5-2.3,2.3-2.3h2.4c1.8,0,2.3.5,2.3,2.3v17.7c0,2.3-.9,2.3-3.1,2.3s-1.6,0-1.6-1.1.2-.9.8-.9c.2,0,1.1,0,1.3,0,.5,0,.8-.2.8-.9v-5.1ZM214.2,455.8h3.5v-3.5c0-.5-.2-.8-.8-.8h-1.9c-.5,0-.8.2-.8.8v3.5ZM217.6,457.7h-3.5v4.5h3.5v-4.5Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_7黒潮_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(37)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="161.8" y1="434.3" x2="161.8" y2="434.3" />
            <g>
              <line class="pn_st2" x1="161.8" y1="434.3" x2="164.3" y2="434.3" />
              <line class="pn_st28" x1="166.4" y1="434.3" x2="166.4" y2="434.3" />
              <line class="pn_st34" x1="166.4" y1="434.3" x2="188.8" y2="434.3" />
              <line class="pn_st2" x1="188.8" y1="434.3" x2="191.3" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M208.5,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M208.5,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.7,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M178.4,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.9,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M185.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M209.4,405.6h8.3c.2,0,1,0,1,.8s-.7.8-1,.8h-8.3v1.9h9.6c.2,0,1,0,1,.9s-.8.8-1,.8h-21.2c-.2,0-1,0-1-.8s.6-.9,1-.9h9.5v-1.9h-8.3c-.2,0-1,0-1-.8s.7-.9,1-.9h8.3v-2h-6.1c-1.8,0-2.3-.5-2.3-2.3v-4.5c0-1.8.5-2.3,2.3-2.3h14.3c1.8,0,2.3.5,2.3,2.3v4.5c0,1.8-.5,2.3-2.3,2.3h-6.2v2ZM201.2,412.4c0,.6-1.1,2.5-1.4,2.9-1,1.7-1.4,1.8-1.8,1.8s-1.2-.5-1.2-1,0-.3.9-1.5c.7-.9,1-1.6,1.6-2.7.2-.5.4-.5.8-.5s1,.3,1,.9ZM201,398.3h6.4v-2.2h-5.6c-.7,0-.8.4-.8.8v1.4ZM201,399.8v1.4c0,.5.2.8.8.8h5.6v-2.2h-6.4ZM206.1,412.9c.2,1,.6,2.7.6,3.2,0,.9-1,.9-1.1.9-.9,0-1-.7-1-1,0-1,0-1.3-.2-2.1,0-.2-.2-1.3-.2-1.4,0-.8.7-.8.8-.8.9,0,1,.3,1.2,1.1ZM215.9,398.3v-1.4c0-.5-.2-.8-.8-.8h-5.7v2.2h6.5ZM215.9,399.8h-6.5v2.2h5.7c.6,0,.8-.3.8-.8v-1.4ZM212.3,413.5c.2.6.8,2,.8,2.5s-.7.8-1.1.8c-.7,0-.7-.2-1.1-1.5-.2-.8-.3-1.1-.8-2.3-.1-.3-.2-.5-.2-.7,0-.5.5-.8,1-.8s.8.5,1.4,1.8ZM218,413.1c.6.7,1.8,2.3,1.8,2.9s-.6,1-1.2,1-.5,0-1.3-1.3c-.5-.8-1.2-1.6-1.9-2.5-.2-.2-.4-.5-.4-.8s.1-.9,1.1-.9.5,0,1.8,1.6Z"
              />
              <path
                d="M200.5,457.6c.8.6,1,.8,1,1.2s-.5,1.1-1,1.1-.4,0-1.2-.7c-.3-.2-1.8-1.2-2.1-1.5-.3-.2-.4-.4-.4-.7,0-.5.4-1,.9-1.1.2,0,.5,0,2.9,1.6ZM197.7,469c1.1-2.1,2.1-5.1,2.1-5.1.1-.4.2-.8.9-.8s1.1.4,1.1.9c0,1-1.7,4.7-2.2,5.9-.8,1.7-1.1,2-1.6,2s-1.1-.2-1.1-1.1c0-.3,0-.4.8-1.8ZM198.5,449.3c.3,0,.4,0,2.5,1.3,1.1.7,1.2.8,1.2,1.2,0,.5-.5,1.2-1.1,1.2s-.2,0-1.1-.6c-.4-.2-2-1.2-2.2-1.4,0,0-.3-.3-.2-.7,0-.4.4-.9,1-.9ZM206,454.9v-2h-2.8c-.3,0-.9,0-.9-.9s.7-.9.9-.9h2.8v-1.3c0-.8.4-.9.9-.9.7,0,.8.5.8.9v1.3h2.8c.3,0,1,0,1,.9s-.7.9-1,.9h-2.8v2h.9c1.7,0,2.2.5,2.2,2.3v4.2c0,1.9-.5,2.3-2.2,2.3h-.9v2.1h2.9c.4,0,.9.1.9.9s-.6.9-.9.9h-2.9v3.6c0,.8-.3,1-.9,1s-.8-.7-.8-1v-3.6h-3.2c-.3,0-1,0-1-.9s.7-.9,1-.9h3.2v-2.1h-1c-1.7,0-2.2-.5-2.2-2.3v-4.2c0-1.9.5-2.3,2.2-2.3h1ZM204.6,458.6h4.6v-1.3c0-.5-.2-.8-.8-.8h-3c-.6,0-.8.3-.8.8v1.3ZM204.6,460v1.3c0,.5.2.8.8.8h3c.6,0,.8-.3.8-.8v-1.3h-4.6ZM217.6,464h-3.5c0,1.5-.3,4.4-1.6,6.8-.7,1.3-.8,1.4-1.3,1.4s-1.1-.3-1.1-.9,0-.5.3-.8c.9-1.6,2-3.6,2-7.7v-10.8c0-1.9.5-2.3,2.3-2.3h2.4c1.8,0,2.3.5,2.3,2.3v17.7c0,2.3-.9,2.3-3.1,2.3s-1.6,0-1.6-1.1.2-.9.8-.9c.2,0,1.1,0,1.3,0,.5,0,.8-.2.8-.9v-5.1ZM214.2,455.8h3.5v-3.5c0-.5-.2-.8-.8-.8h-1.9c-.5,0-.8.2-.8.8v3.5ZM217.6,457.7h-3.5v4.5h3.5v-4.5Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_6高岡_xFF1A_橙">
          <a @click="sendPointId(36)">
            <g>
              <line class="pn_st0" x1="225.5" y1="434.3" x2="225.5" y2="434.3" />
              <g>
                <line class="pn_st13" x1="225.5" y1="434.3" x2="228" y2="434.3" />
                <line class="pn_st3" x1="230.1" y1="434.3" x2="230.1" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="230.1"
                  y1="434.3"
                  x2="252.5"
                  y2="434.3"
                />
                <line class="pn_st13" x1="252.5" y1="434.3" x2="255" y2="434.3" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M272.2,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M272.2,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M230.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M245.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M235.6,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M249,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M282.7,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM264.9,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM280,402.2c0,1.5-.5,2.1-2.1,2.1h-11.3c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.3c1.6,0,2.1.6,2.1,2.1v1.1ZM277.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM277.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM275.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
                />
                <path
                  d="M263.5,471.1c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1c-.1,0-.6-.3-.6-1,0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM273.1,466.6h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1.1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.9.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.2,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_6高岡_xFF1A_紫" v-if="this.clickedPointId === 36">
          <g>
            <line class="pn_st0" x1="225.5" y1="434.3" x2="225.5" y2="434.3" />
            <g>
              <line class="pn_st2" x1="225.5" y1="434.3" x2="228" y2="434.3" />
              <line class="pn_st28" x1="230.1" y1="434.3" x2="230.1" y2="434.3" />
              <line class="pn_st34" x1="230.1" y1="434.3" x2="252.5" y2="434.3" />
              <line class="pn_st2" x1="252.5" y1="434.3" x2="255" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="255.2"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M245.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.6,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M249,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M282.7,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM264.9,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM280,402.2c0,1.5-.5,2.1-2.1,2.1h-11.3c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.3c1.6,0,2.1.6,2.1,2.1v1.1ZM277.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM277.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM275.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                class="pn_st63"
                d="M263.5,471.1c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1c-.1,0-.6-.3-.6-1,0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM273.1,466.6h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1.1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.9.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.2,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_6高岡_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(36)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="225.5" y1="434.3" x2="225.5" y2="434.3" />
            <g>
              <line class="pn_st2" x1="225.5" y1="434.3" x2="228" y2="434.3" />
              <line class="pn_st28" x1="230.1" y1="434.3" x2="230.1" y2="434.3" />
              <line class="pn_st34" x1="230.1" y1="434.3" x2="252.5" y2="434.3" />
              <line class="pn_st2" x1="252.5" y1="434.3" x2="255" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M272.2,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M272.2,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M245.4,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.6,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.9,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M282.7,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM264.9,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM280,402.2c0,1.5-.5,2.1-2.1,2.1h-11.3c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.3c1.6,0,2.1.6,2.1,2.1v1.1ZM277.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM277.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM275.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                d="M263.5,471.1c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1c-.1,0-.6-.3-.6-1,0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM273.1,466.6h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1.1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.9.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.2,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_5須崎_xFF1A_橙">
          <a @click="sendPointId(35)">
            <g>
              <line class="pn_st0" x1="289.2" y1="434.3" x2="289.2" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="289.2"
                  y1="434.3"
                  x2="291.7"
                  y2="434.3"
                />
                <line class="pn_st3" x1="293.8" y1="434.3" x2="293.8" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="293.8"
                  y1="434.3"
                  x2="316.2"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="316.2"
                  y1="434.3"
                  x2="318.7"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M335.8,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M335.8,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M332.8,410.2c0,.7-1.7,2.7-2.4,3.5-1.7,2-4.4,4.4-5.2,4.4s-1.1-.7-1.1-1.2.2-.6.5-.8c3.3-2.4,4.6-4.2,6.2-6.4.3-.4.5-.5.8-.5.5,0,1.1.5,1.1,1ZM331.1,396.3c0,.5-.9,1.4-1.4,1.9-1.9,2-3.8,3.3-4.5,3.3s-1-.7-1-1.1.2-.5,1.5-1.5c1.4-1,2.4-2,3.7-3.3.3-.3.5-.3.7-.3.4,0,1,.3,1,1ZM332.2,402.6c0,1.2-5.7,6.2-6.8,6.2s-1.1-.6-1.1-1.1.2-.6.5-.8c3.5-2.4,3.7-2.7,5.6-4.9.2-.3.5-.4.7-.4.5,0,1,.5,1,1ZM337.8,414.7c0,.5-.4.8-1.5,1.5-1.1.9-3.3,2.2-4.2,2.2s-1-.7-1-1.2.1-.5,1.8-1.3c1.2-.6,2.4-1.5,3.1-2,.3-.2.5-.2.7-.2.5,0,1,.5,1,1ZM337.8,399.6c.3-.9.5-1.2.7-2h-5.3c-.3,0-1,0-1-.9s.7-.9,1-.9h13.3c.4,0,1,0,1,.9s-.6.9-1,.9h-5.8c-.2.6-.4,1.1-.8,2h4.1c1.9,0,2.4.5,2.4,2.3v8.9c0,1.8-.5,2.3-2.4,2.3h-8.1c-1.8,0-2.3-.5-2.3-2.3v-8.9c0-1.8.5-2.3,2.3-2.3h1.9ZM344.3,403.6v-1.6c0-.5-.2-.8-.8-.8h-7.1c-.5,0-.8.2-.8.8v1.6h8.8ZM344.3,405.2h-8.8v2.3h8.8v-2.3ZM344.3,409.1h-8.8v1.7c0,.6.3.8.8.8h7.1c.5,0,.8-.2.8-.8v-1.7ZM343.7,414.7c.3.2,1.2.8,3.2,1.8.2.1.6.3.6.8s-.4,1.2-1,1.2-3.2-1.5-4.2-2.2c-1.2-.9-1.4-1.1-1.4-1.5s.5-1,1-1,.4,0,1.8,1Z"
                />
                <path
                  d="M328,451.1c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.3,471.1c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,452.2c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.1,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.2,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.2-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,.9.6.9,1s0,.7-.1,1.2h5.1ZM341.6,467.8c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,465.8c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.6,0,.8-.3.8-.8v-1.9Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M293.8,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
                <path
                  class="pn_st57"
                  d="M306,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M299.3,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M312.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_5須崎_xFF1A_紫" v-if="this.clickedPointId === 35">
          <g>
            <line class="pn_st0" x1="289.2" y1="434.3" x2="289.2" y2="434.3" />
            <g>
              <line class="pn_st2" x1="289.2" y1="434.3" x2="291.7" y2="434.3" />
              <line class="pn_st28" x1="293.8" y1="434.3" x2="293.8" y2="434.3" />
              <line class="pn_st34" x1="293.8" y1="434.3" x2="316.2" y2="434.3" />
              <line class="pn_st2" x1="316.2" y1="434.3" x2="318.7" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="318.8"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M332.8,410.2c0,.7-1.7,2.7-2.4,3.5-1.7,2-4.4,4.4-5.2,4.4s-1.1-.7-1.1-1.2.2-.6.5-.8c3.3-2.4,4.6-4.2,6.2-6.4.3-.4.5-.5.8-.5.5,0,1.1.5,1.1,1ZM331.1,396.3c0,.5-.9,1.4-1.4,1.9-1.9,2-3.8,3.3-4.5,3.3s-1-.7-1-1.1.2-.5,1.5-1.5c1.4-1,2.4-2,3.7-3.3.3-.3.5-.3.7-.3.4,0,1,.3,1,1ZM332.2,402.6c0,1.2-5.7,6.2-6.8,6.2s-1.1-.6-1.1-1.1.2-.6.5-.8c3.5-2.4,3.7-2.7,5.6-4.9.2-.3.5-.4.7-.4.5,0,1,.5,1,1ZM337.8,414.7c0,.5-.4.8-1.5,1.5-1.1.9-3.3,2.2-4.2,2.2s-1-.7-1-1.2.1-.5,1.8-1.3c1.2-.6,2.4-1.5,3.1-2,.3-.2.5-.2.7-.2.5,0,1,.5,1,1ZM337.8,399.6c.3-.9.5-1.2.7-2h-5.3c-.3,0-1,0-1-.9s.7-.9,1-.9h13.3c.4,0,1,0,1,.9s-.6.9-1,.9h-5.8c-.2.6-.4,1.1-.8,2h4.1c1.9,0,2.4.5,2.4,2.3v8.9c0,1.8-.5,2.3-2.4,2.3h-8.1c-1.8,0-2.3-.5-2.3-2.3v-8.9c0-1.8.5-2.3,2.3-2.3h1.9ZM344.3,403.6v-1.6c0-.5-.2-.8-.8-.8h-7.1c-.5,0-.8.2-.8.8v1.6h8.8ZM344.3,405.2h-8.8v2.3h8.8v-2.3ZM344.3,409.1h-8.8v1.7c0,.6.3.8.8.8h7.1c.5,0,.8-.2.8-.8v-1.7ZM343.7,414.7c.3.2,1.2.8,3.2,1.8.2.1.6.3.6.8s-.4,1.2-1,1.2-3.2-1.5-4.2-2.2c-1.2-.9-1.4-1.1-1.4-1.5s.5-1,1-1,.4,0,1.8,1Z"
              />
              <path
                class="pn_st63"
                d="M328,451.1c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.3,471.1c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,452.2c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.1,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.2,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.2-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,.9.6.9,1s0,.7-.1,1.2h5.1ZM341.6,467.8c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,465.8c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.6,0,.8-.3.8-.8v-1.9Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.8,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
              <path
                class="pn_st71"
                d="M306,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M299.3,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_5須崎_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(35)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="289.2" y1="434.3" x2="289.2" y2="434.3" />
            <g>
              <line class="pn_st2" x1="289.2" y1="434.3" x2="291.7" y2="434.3" />
              <line class="pn_st28" x1="293.8" y1="434.3" x2="293.8" y2="434.3" />
              <line class="pn_st34" x1="293.8" y1="434.3" x2="316.2" y2="434.3" />
              <line class="pn_st2" x1="316.2" y1="434.3" x2="318.7" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M335.8,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M335.8,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M332.8,410.2c0,.7-1.7,2.7-2.4,3.5-1.7,2-4.4,4.4-5.2,4.4s-1.1-.7-1.1-1.2.2-.6.5-.8c3.3-2.4,4.6-4.2,6.2-6.4.3-.4.5-.5.8-.5.5,0,1.1.5,1.1,1ZM331.1,396.3c0,.5-.9,1.4-1.4,1.9-1.9,2-3.8,3.3-4.5,3.3s-1-.7-1-1.1.2-.5,1.5-1.5c1.4-1,2.4-2,3.7-3.3.3-.3.5-.3.7-.3.4,0,1,.3,1,1ZM332.2,402.6c0,1.2-5.7,6.2-6.8,6.2s-1.1-.6-1.1-1.1.2-.6.5-.8c3.5-2.4,3.7-2.7,5.6-4.9.2-.3.5-.4.7-.4.5,0,1,.5,1,1ZM337.8,414.7c0,.5-.4.8-1.5,1.5-1.1.9-3.3,2.2-4.2,2.2s-1-.7-1-1.2.1-.5,1.8-1.3c1.2-.6,2.4-1.5,3.1-2,.3-.2.5-.2.7-.2.5,0,1,.5,1,1ZM337.8,399.6c.3-.9.5-1.2.7-2h-5.3c-.3,0-1,0-1-.9s.7-.9,1-.9h13.3c.4,0,1,0,1,.9s-.6.9-1,.9h-5.8c-.2.6-.4,1.1-.8,2h4.1c1.9,0,2.4.5,2.4,2.3v8.9c0,1.8-.5,2.3-2.4,2.3h-8.1c-1.8,0-2.3-.5-2.3-2.3v-8.9c0-1.8.5-2.3,2.3-2.3h1.9ZM344.3,403.6v-1.6c0-.5-.2-.8-.8-.8h-7.1c-.5,0-.8.2-.8.8v1.6h8.8ZM344.3,405.2h-8.8v2.3h8.8v-2.3ZM344.3,409.1h-8.8v1.7c0,.6.3.8.8.8h7.1c.5,0,.8-.2.8-.8v-1.7ZM343.7,414.7c.3.2,1.2.8,3.2,1.8.2.1.6.3.6.8s-.4,1.2-1,1.2-3.2-1.5-4.2-2.2c-1.2-.9-1.4-1.1-1.4-1.5s.5-1,1-1,.4,0,1.8,1Z"
              />
              <path
                d="M328,451.1c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.3,471.1c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,452.2c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.1,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.2,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.2-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,.9.6.9,1s0,.7-.1,1.2h5.1ZM341.6,467.8c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,465.8c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.6,0,.8-.3.8-.8v-1.9Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.8,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
              <path
                class="pn_st71"
                d="M306,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M299.3,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.6,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_4土佐_xFF1A_橙">
          <a @click="sendPointId(34)">
            <g>
              <line class="pn_st0" x1="352.8" y1="434.3" x2="352.8" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="352.8"
                  y1="434.3"
                  x2="355.3"
                  y2="434.3"
                />
                <line class="pn_st3" x1="357.4" y1="434.3" x2="357.4" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="357.4"
                  y1="434.3"
                  x2="379.8"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="379.8"
                  y1="434.3"
                  x2="382.3"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M399.5,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M399.5,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M358.6,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M375.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M363,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M376.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M408.8,401.1c.2,0,1,0,1,1s-.8,1-1,1h-8.1v11.2h9.4c.3,0,1,0,1,1s-.7,1-1,1h-21.1c-.3,0-1,0-1-1s.7-1,1-1h9.5v-11.2h-8c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h8v-6.2c0-.2,0-1,1.1-1s1.1.2,1.1,1v6.2h8.1Z"
                />
                <path
                  d="M392.9,471.3c0,.3,0,1-1,1s-1-.3-1-1v-12.2c-1.4,2-1.6,2.1-2.1,2.1s-1.1-.8-1.1-1.3.1-.5.5-1c1.4-1.8,3.3-4.3,4.8-9.1.1-.5.3-.9,1-.9s1,.3,1,.8c0,.9-1.5,4.4-2.2,5.8v15.7ZM395.5,454.6c-.3,0-1,0-1-1s.6-1,1-1h4.3c0-.5.2-2.9.3-2.9,0-.2.1-.8,1-.8s1,.7,1,1,0,1-.2,2.7h7.8c.3,0,1,0,1,1s-.4,1-1,1h-8.1c-.4,2.1-.8,3.6-1.3,5.1h8.8c.4,0,1,0,1,1s-.7,1-1,1h-4.4v7.9h5.3c.3,0,1,0,1,1s-.7,1-1,1h-13.1c-.2,0-1,0-1-1s.3-1,1-1h5.7v-7.9h-3.1c-.8,2-2,4-3.4,5.7-1.2,1.4-1.3,1.4-1.7,1.4-.5,0-1.1-.5-1.1-1.2s.2-.6.4-.9c1-1.1,3.1-3.2,4.7-7.8.5-1.4.8-2.8,1.1-4.2h-4Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_4土佐_xFF1A_紫" v-if="this.clickedPointId === 34">
          <g>
            <line class="pn_st0" x1="352.8" y1="434.3" x2="352.8" y2="434.3" />
            <g>
              <line class="pn_st2" x1="352.8" y1="434.3" x2="355.3" y2="434.3" />
              <line class="pn_st28" x1="357.4" y1="434.3" x2="357.4" y2="434.3" />
              <line class="pn_st34" x1="357.4" y1="434.3" x2="379.8" y2="434.3" />
              <line class="pn_st2" x1="379.8" y1="434.3" x2="382.3" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="382.5"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M358.6,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M375.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M363,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M408.8,401.1c.2,0,1,0,1,1s-.8,1-1,1h-8.1v11.2h9.4c.3,0,1,0,1,1s-.7,1-1,1h-21.1c-.3,0-1,0-1-1s.7-1,1-1h9.5v-11.2h-8c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h8v-6.2c0-.2,0-1,1.1-1s1.1.2,1.1,1v6.2h8.1Z"
              />
              <path
                class="pn_st63"
                d="M392.9,471.3c0,.3,0,1-1,1s-1-.3-1-1v-12.2c-1.4,2-1.6,2.1-2.1,2.1s-1.1-.8-1.1-1.3.1-.5.5-1c1.4-1.8,3.3-4.3,4.8-9.1.1-.5.3-.9,1-.9s1,.3,1,.8c0,.9-1.5,4.4-2.2,5.8v15.7ZM395.5,454.6c-.3,0-1,0-1-1s.6-1,1-1h4.3c0-.5.2-2.9.3-2.9,0-.2.1-.8,1-.8s1,.7,1,1,0,1-.2,2.7h7.8c.3,0,1,0,1,1s-.4,1-1,1h-8.1c-.4,2.1-.8,3.6-1.3,5.1h8.8c.4,0,1,0,1,1s-.7,1-1,1h-4.4v7.9h5.3c.3,0,1,0,1,1s-.7,1-1,1h-13.1c-.2,0-1,0-1-1s.3-1,1-1h5.7v-7.9h-3.1c-.8,2-2,4-3.4,5.7-1.2,1.4-1.3,1.4-1.7,1.4-.5,0-1.1-.5-1.1-1.2s.2-.6.4-.9c1-1.1,3.1-3.2,4.7-7.8.5-1.4.8-2.8,1.1-4.2h-4Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_4土佐_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(34)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="352.8" y1="434.3" x2="352.8" y2="434.3" />
            <g>
              <line class="pn_st2" x1="352.8" y1="434.3" x2="355.3" y2="434.3" />
              <line class="pn_st28" x1="357.4" y1="434.3" x2="357.4" y2="434.3" />
              <line class="pn_st34" x1="357.4" y1="434.3" x2="379.8" y2="434.3" />
              <line class="pn_st2" x1="379.8" y1="434.3" x2="382.3" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M399.5,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M399.5,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M358.6,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M375.8,397.9c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M363,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.3,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M408.8,401.1c.2,0,1,0,1,1s-.8,1-1,1h-8.1v11.2h9.4c.3,0,1,0,1,1s-.7,1-1,1h-21.1c-.3,0-1,0-1-1s.7-1,1-1h9.5v-11.2h-8c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h8v-6.2c0-.2,0-1,1.1-1s1.1.2,1.1,1v6.2h8.1Z"
              />
              <path
                d="M392.9,471.3c0,.3,0,1-1,1s-1-.3-1-1v-12.2c-1.4,2-1.6,2.1-2.1,2.1s-1.1-.8-1.1-1.3.1-.5.5-1c1.4-1.8,3.3-4.3,4.8-9.1.1-.5.3-.9,1-.9s1,.3,1,.8c0,.9-1.5,4.4-2.2,5.8v15.7ZM395.5,454.6c-.3,0-1,0-1-1s.6-1,1-1h4.3c0-.5.2-2.9.3-2.9,0-.2.1-.8,1-.8s1,.7,1,1,0,1-.2,2.7h7.8c.3,0,1,0,1,1s-.4,1-1,1h-8.1c-.4,2.1-.8,3.6-1.3,5.1h8.8c.4,0,1,0,1,1s-.7,1-1,1h-4.4v7.9h5.3c.3,0,1,0,1,1s-.7,1-1,1h-13.1c-.2,0-1,0-1-1s.3-1,1-1h5.7v-7.9h-3.1c-.8,2-2,4-3.4,5.7-1.2,1.4-1.3,1.4-1.7,1.4-.5,0-1.1-.5-1.1-1.2s.2-.6.4-.9c1-1.1,3.1-3.2,4.7-7.8.5-1.4.8-2.8,1.1-4.2h-4Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_3高知_xFF1A_橙">
          <a @click="sendPointId(33)">
            <g>
              <line class="pn_st0" x1="416.6" y1="434.3" x2="416.6" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="416.6"
                  y1="434.3"
                  x2="419.1"
                  y2="434.3"
                />
                <line class="pn_st3" x1="421.2" y1="434.3" x2="421.2" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="421.2"
                  y1="434.3"
                  x2="443.6"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="443.6"
                  y1="434.3"
                  x2="446.1"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M463.2,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M463.2,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M421.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M433.5,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M426.7,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M440,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M473.8,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM456,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM471,402.2c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM468.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM468.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM466.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
                />
                <path
                  d="M462.5,452.3c.2,0,1,0,1,.9s-.3,1-1,1h-3v5.2h3.5c.3,0,1,0,1,1s-.7,1-1,1h-3.6c0,.5-.1.9-.2,1.2,1,2.3,2.6,4.3,3.2,4.8,1.4,1.4,1.6,1.6,1.6,2,0,.6-.5,1.1-1.1,1.1-.9,0-3.2-3.2-4.3-5.2-.6,1.5-1.6,3.7-3.8,5.6-.5.5-1.7,1.4-2.2,1.4s-1.1-.7-1.1-1.2.3-.7.6-.9c2-1.4,4.6-3.3,5.2-8.8h-4.9c-.3,0-1,0-1-1s.5-1,1-1h5.1v-5.2h-2.1c-.5,1-1.1,2.1-1.9,3.1-.2.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1s.2-.5.3-.8c1.7-2.3,1.9-2.8,3.2-6.3.2-.5.4-.7.9-.7s1.2.4,1.2.9-.3,1.1-.9,2.5h6.1ZM474,469c0,2-.8,2.6-2.7,2.6h-4.2c-1.9,0-2.7-.6-2.7-2.6v-16.2c0-2.1.8-2.7,2.7-2.7h4.2c1.9,0,2.7.6,2.7,2.7v16.2ZM472,453.3c0-.8-.3-1.1-1.1-1.1h-3.2c-.8,0-1.1.4-1.1,1.1v15.3c0,.8.4,1.1,1.1,1.1h3.2c.8,0,1.1-.3,1.1-1.1v-15.3Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_3高知_xFF1A_紫" v-if="this.clickedPointId === 33">
          <g>
            <line class="pn_st0" x1="416.6" y1="434.3" x2="416.6" y2="434.3" />
            <g>
              <line class="pn_st2" x1="416.6" y1="434.3" x2="419.1" y2="434.3" />
              <line class="pn_st28" x1="421.2" y1="434.3" x2="421.2" y2="434.3" />
              <line class="pn_st34" x1="421.2" y1="434.3" x2="443.6" y2="434.3" />
              <line class="pn_st2" x1="443.6" y1="434.3" x2="446.1" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="446.2"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M421.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M433.5,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426.7,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M440,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M473.8,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM456,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM471,402.2c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM468.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM468.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM466.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                class="pn_st63"
                d="M462.5,452.3c.2,0,1,0,1,.9s-.3,1-1,1h-3v5.2h3.5c.3,0,1,0,1,1s-.7,1-1,1h-3.6c0,.5-.1.9-.2,1.2,1,2.3,2.6,4.3,3.2,4.8,1.4,1.4,1.6,1.6,1.6,2,0,.6-.5,1.1-1.1,1.1-.9,0-3.2-3.2-4.3-5.2-.6,1.5-1.6,3.7-3.8,5.6-.5.5-1.7,1.4-2.2,1.4s-1.1-.7-1.1-1.2.3-.7.6-.9c2-1.4,4.6-3.3,5.2-8.8h-4.9c-.3,0-1,0-1-1s.5-1,1-1h5.1v-5.2h-2.1c-.5,1-1.1,2.1-1.9,3.1-.2.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1s.2-.5.3-.8c1.7-2.3,1.9-2.8,3.2-6.3.2-.5.4-.7.9-.7s1.2.4,1.2.9-.3,1.1-.9,2.5h6.1ZM474,469c0,2-.8,2.6-2.7,2.6h-4.2c-1.9,0-2.7-.6-2.7-2.6v-16.2c0-2.1.8-2.7,2.7-2.7h4.2c1.9,0,2.7.6,2.7,2.7v16.2ZM472,453.3c0-.8-.3-1.1-1.1-1.1h-3.2c-.8,0-1.1.4-1.1,1.1v15.3c0,.8.4,1.1,1.1,1.1h3.2c.8,0,1.1-.3,1.1-1.1v-15.3Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_3高知_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(33)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="416.6" y1="434.3" x2="416.6" y2="434.3" />
            <g>
              <line class="pn_st2" x1="416.6" y1="434.3" x2="419.1" y2="434.3" />
              <line class="pn_st28" x1="421.2" y1="434.3" x2="421.2" y2="434.3" />
              <line class="pn_st34" x1="421.2" y1="434.3" x2="443.6" y2="434.3" />
              <line class="pn_st2" x1="443.6" y1="434.3" x2="446.1" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M463.2,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M463.2,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,379.3h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M421.3,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M433.5,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426.7,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M440,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M473.8,395.8c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM456,407.4c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM471,402.2c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM468.9,401.1c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM468.8,412.1c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM466.8,411c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                d="M462.5,452.3c.2,0,1,0,1,.9s-.3,1-1,1h-3v5.2h3.5c.3,0,1,0,1,1s-.7,1-1,1h-3.6c0,.5-.1.9-.2,1.2,1,2.3,2.6,4.3,3.2,4.8,1.4,1.4,1.6,1.6,1.6,2,0,.6-.5,1.1-1.1,1.1-.9,0-3.2-3.2-4.3-5.2-.6,1.5-1.6,3.7-3.8,5.6-.5.5-1.7,1.4-2.2,1.4s-1.1-.7-1.1-1.2.3-.7.6-.9c2-1.4,4.6-3.3,5.2-8.8h-4.9c-.3,0-1,0-1-1s.5-1,1-1h5.1v-5.2h-2.1c-.5,1-1.1,2.1-1.9,3.1-.2.3-.5.5-.8.5-.5,0-1.1-.5-1.1-1s.2-.5.3-.8c1.7-2.3,1.9-2.8,3.2-6.3.2-.5.4-.7.9-.7s1.2.4,1.2.9-.3,1.1-.9,2.5h6.1ZM474,469c0,2-.8,2.6-2.7,2.6h-4.2c-1.9,0-2.7-.6-2.7-2.6v-16.2c0-2.1.8-2.7,2.7-2.7h4.2c1.9,0,2.7.6,2.7,2.7v16.2ZM472,453.3c0-.8-.3-1.1-1.1-1.1h-3.2c-.8,0-1.1.4-1.1,1.1v15.3c0,.8.4,1.1,1.1,1.1h3.2c.8,0,1.1-.3,1.1-1.1v-15.3Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_2香南_xFF1A_橙">
          <a @click="sendPointId(32)">
            <g>
              <line class="pn_st0" x1="480.3" y1="434.3" x2="480.3" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="480.3"
                  y1="434.3"
                  x2="482.8"
                  y2="434.3"
                />
                <line class="pn_st3" x1="484.9" y1="434.3" x2="484.9" y2="434.3" />
                <line
                  class="pn_st38"
                  x1="484.9"
                  y1="434.3"
                  x2="507.3"
                  y2="434.3"
                />
                <line
                  class="pn_st13"
                  x1="507.3"
                  y1="434.3"
                  x2="509.8"
                  y2="434.3"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M527,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M527,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M485.9,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M499.5,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M490.4,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M503.7,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M532.6,406.1c1.7,0,2.4.6,2.4,2.4v5.8c0,1.8-.7,2.4-2.4,2.4h-11.4c-1.6,0-2.4-.5-2.4-2.4v-5.8c0-1.8.7-2.4,2.4-2.4h4.7v-5.3c-.8,1-3,3.5-6.6,5.6-.5.3-2.5,1.4-2.9,1.4s-1-.6-1-1.2.3-.7.7-.9c2.7-1.2,3.8-1.7,5.7-3.2.9-.7,1.7-1.4,2.4-2.2h-7.8c-.2,0-1,0-1-.9s.7-.9,1-.9h9.7v-2.1c-1.8.1-4.4.2-5.9.2s-2.1,0-2.4-.1c-.4-.1-.5-.6-.5-.8,0-.9.6-.9.9-.9h3.3c4.8,0,7.8-.3,10-.5.5,0,3.2-.5,3.4-.5.5,0,.9.5.9.9,0,.8-.7.9-1,.9-2.7.4-3.1.4-6.8.7v2.2h9.7c.3,0,1,0,1,.9s-.7.9-1,.9h-7.7c1.7,1.9,4.5,3.7,6,4.4l1.9.9c.3.2.7.4.7.9s-.3,1.2-1,1.2-6.4-2.8-9.5-7.1v5.4h4.7ZM533,410.4v-1.8c0-.6-.3-.8-.8-.8h-10.4c-.5,0-.8.2-.8.8v1.8h12ZM533,412.1h-12v2.1c0,.5.3.8.8.8h10.4c.5,0,.8-.3.8-.8v-2.1Z"
                />
                <path
                  d="M534.3,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM528.6,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_2香南_xFF1A_紫" v-if="this.clickedPointId === 32">
          <g>
            <line class="pn_st0" x1="480.3" y1="434.3" x2="480.3" y2="434.3" />
            <g>
              <line class="pn_st2" x1="480.3" y1="434.3" x2="482.8" y2="434.3" />
              <line class="pn_st28" x1="484.9" y1="434.3" x2="484.9" y2="434.3" />
              <line class="pn_st34" x1="484.9" y1="434.3" x2="507.3" y2="434.3" />
              <line class="pn_st2" x1="507.3" y1="434.3" x2="509.8" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="510"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.9,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M499.5,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490.4,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.7,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M532.6,406.1c1.7,0,2.4.6,2.4,2.4v5.8c0,1.8-.7,2.4-2.4,2.4h-11.4c-1.6,0-2.4-.5-2.4-2.4v-5.8c0-1.8.7-2.4,2.4-2.4h4.7v-5.3c-.8,1-3,3.5-6.6,5.6-.5.3-2.5,1.4-2.9,1.4s-1-.6-1-1.2.3-.7.7-.9c2.7-1.2,3.8-1.7,5.7-3.2.9-.7,1.7-1.4,2.4-2.2h-7.8c-.2,0-1,0-1-.9s.7-.9,1-.9h9.7v-2.1c-1.8.1-4.4.2-5.9.2s-2.1,0-2.4-.1c-.4-.1-.5-.6-.5-.8,0-.9.6-.9.9-.9h3.3c4.8,0,7.8-.3,10-.5.5,0,3.2-.5,3.4-.5.5,0,.9.5.9.9,0,.8-.7.9-1,.9-2.7.4-3.1.4-6.8.7v2.2h9.7c.3,0,1,0,1,.9s-.7.9-1,.9h-7.7c1.7,1.9,4.5,3.7,6,4.4l1.9.9c.3.2.7.4.7.9s-.3,1.2-1,1.2-6.4-2.8-9.5-7.1v5.4h4.7ZM533,410.4v-1.8c0-.6-.3-.8-.8-.8h-10.4c-.5,0-.8.2-.8.8v1.8h12ZM533,412.1h-12v2.1c0,.5.3.8.8.8h10.4c.5,0,.8-.3.8-.8v-2.1Z"
              />
              <path
                class="pn_st63"
                d="M534.3,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM528.6,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x33_2香南_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(32)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="480.3" y1="434.3" x2="480.3" y2="434.3" />
            <g>
              <line class="pn_st2" x1="480.3" y1="434.3" x2="482.8" y2="434.3" />
              <line class="pn_st28" x1="484.9" y1="434.3" x2="484.9" y2="434.3" />
              <line class="pn_st34" x1="484.9" y1="434.3" x2="507.3" y2="434.3" />
              <line class="pn_st2" x1="507.3" y1="434.3" x2="509.8" y2="434.3" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M527,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M527,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.9,401.9c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M499.5,405.4c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490.4,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.7,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M532.6,406.1c1.7,0,2.4.6,2.4,2.4v5.8c0,1.8-.7,2.4-2.4,2.4h-11.4c-1.6,0-2.4-.5-2.4-2.4v-5.8c0-1.8.7-2.4,2.4-2.4h4.7v-5.3c-.8,1-3,3.5-6.6,5.6-.5.3-2.5,1.4-2.9,1.4s-1-.6-1-1.2.3-.7.7-.9c2.7-1.2,3.8-1.7,5.7-3.2.9-.7,1.7-1.4,2.4-2.2h-7.8c-.2,0-1,0-1-.9s.7-.9,1-.9h9.7v-2.1c-1.8.1-4.4.2-5.9.2s-2.1,0-2.4-.1c-.4-.1-.5-.6-.5-.8,0-.9.6-.9.9-.9h3.3c4.8,0,7.8-.3,10-.5.5,0,3.2-.5,3.4-.5.5,0,.9.5.9.9,0,.8-.7.9-1,.9-2.7.4-3.1.4-6.8.7v2.2h9.7c.3,0,1,0,1,.9s-.7.9-1,.9h-7.7c1.7,1.9,4.5,3.7,6,4.4l1.9.9c.3.2.7.4.7.9s-.3,1.2-1,1.2-6.4-2.8-9.5-7.1v5.4h4.7ZM533,410.4v-1.8c0-.6-.3-.8-.8-.8h-10.4c-.5,0-.8.2-.8.8v1.8h12ZM533,412.1h-12v2.1c0,.5.3.8.8.8h10.4c.5,0,.8-.3.8-.8v-2.1Z"
              />
              <path
                d="M534.3,455.4c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM528.6,460.8c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g id="_x33_1安芸_xFF1A_橙">
          <a @click="sendPointId(31)">
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M549.4,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st57"
                d="M561.1,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M554.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M568.1,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <path
                class="pn_st67"
                d="M590.7,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M590.7,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M580.1,404.8c-.2,0-1.1,0-1.1-1s.5-1,1.1-1h6.1c.4-.9.9-1.8,1.3-3,.2-.5.4-.9,1.1-.9s1.3.3,1.3,1-.9,2.3-1.2,2.9h12.5c.2,0,1.1,0,1.1,1s-.7,1-1.1,1h-3.2c-.8,2.3-1.8,4.5-3.9,6.8,2.7,1.2,4,1.9,6,3.1.4.2.7.5.7,1s-.6,1.2-1.2,1.2-.5,0-1-.4c-1.9-1.2-3-2-6.1-3.4-1.8,1.3-3.5,2.3-6.6,3.1-2.5.6-4.6.8-4.9.8-1.1,0-1.1-1-1.1-1.2,0-.9.6-1,1.1-1,2-.2,5.7-.6,9.2-2.6-1.5-.6-3.9-1.4-5.2-1.8-.8-.2-1.8-.6-1.8-1.7s.2-.9.6-1.5c.2-.3,1.2-1.9,1.5-2.4h-5.1ZM598.9,396c1.9,0,2.7.6,2.7,2.7v1.9c0,.4,0,1.1-1,1.1s-1.2-.2-1.2-1v-1.7c0-.6-.2-1.1-1-1.1h-15.5c-.7,0-1,.4-1,1.1v1.7c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2,.7-2.7,2.7-2.7h7.2v-1.2c0-.7.4-.9,1-.9s1.1.2,1.1.9v1.2h7.2ZM587.7,404.8c-.7,1.2-1,1.7-1.7,2.7-.2.3-.3.5-.3.7,0,.5.4.6.8.7.8.2,3.1.9,5.5,1.8,2.1-2,3-4.3,3.6-5.9h-7.9Z"
                />
                <path
                  d="M579.9,463.2c-.2,0-1.1,0-1.1-.9s.8-1,1.1-1h21.4c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-12.7c-.9,2.1-1.7,3.7-3.2,6.4,4,0,8.3-.3,11.7-.6-.7-.7-1.6-1.5-2.4-2.2-.5-.4-.7-.7-.7-1s.6-1,1.1-1,1.2.6,1.9,1.2c1.1,1,2.6,2.3,3.8,3.7.7.8.8,1,.8,1.3,0,.5-.5,1-1,1s-.5,0-1.7-1.4c-2.7.2-5,.5-9,.7-3.4.2-8.5.3-9,.3s-1.1,0-1.1-1,.6-.9.9-.9c.2,0,2.1,0,2.4,0,1.3-2.1,2.4-4.2,3.3-6.4h-6.3ZM585.4,449.8c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.2h6.3v-1.2c0-.4,0-.9,1-.9s1,.2,1,.9v1.2h5.5c.4,0,1,0,1,.9s-.5,1-1,1h-5.5v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-6.3v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-5.5c-.4,0-1,0-1-.9s.5-1,1-1h5.5v-1.2ZM582,458c-.3,0-1.1,0-1.1-.9s.7-1,1.1-1h17.4c.3,0,1,0,1,.9s-.7.9-1,.9h-17.4Z"
                />
              </g>
            </g>
            <g>
              <line class="pn_st0" x1="573.7" y1="434.3" x2="573.7" y2="434.3" />
              <g>
                <line
                  class="pn_st13"
                  x1="573.7"
                  y1="434.3"
                  x2="571.2"
                  y2="434.3"
                />
                <line class="pn_st4" x1="569" y1="434.3" x2="569" y2="434.3" />
                <line class="pn_st53" x1="569" y1="434.3" x2="546.4" y2="434.3" />
                <line
                  class="pn_st13"
                  x1="546.4"
                  y1="434.3"
                  x2="543.9"
                  y2="434.3"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_1安芸_xFF1A_紫" v-if="this.clickedPointId === 31">
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M549.4,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M561.1,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M554.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M568.1,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <rect
            class="pn_st61"
            x="573.7"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M580.1,404.8c-.2,0-1.1,0-1.1-1s.5-1,1.1-1h6.1c.4-.9.9-1.8,1.3-3,.2-.5.4-.9,1.1-.9s1.3.3,1.3,1-.9,2.3-1.2,2.9h12.5c.2,0,1.1,0,1.1,1s-.7,1-1.1,1h-3.2c-.8,2.3-1.8,4.5-3.9,6.8,2.7,1.2,4,1.9,6,3.1.4.2.7.5.7,1s-.6,1.2-1.2,1.2-.5,0-1-.4c-1.9-1.2-3-2-6.1-3.4-1.8,1.3-3.5,2.3-6.6,3.1-2.5.6-4.6.8-4.9.8-1.1,0-1.1-1-1.1-1.2,0-.9.6-1,1.1-1,2-.2,5.7-.6,9.2-2.6-1.5-.6-3.9-1.4-5.2-1.8-.8-.2-1.8-.6-1.8-1.7s.2-.9.6-1.5c.2-.3,1.2-1.9,1.5-2.4h-5.1ZM598.9,396c1.9,0,2.7.6,2.7,2.7v1.9c0,.4,0,1.1-1,1.1s-1.2-.2-1.2-1v-1.7c0-.6-.2-1.1-1-1.1h-15.5c-.7,0-1,.4-1,1.1v1.7c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2,.7-2.7,2.7-2.7h7.2v-1.2c0-.7.4-.9,1-.9s1.1.2,1.1.9v1.2h7.2ZM587.7,404.8c-.7,1.2-1,1.7-1.7,2.7-.2.3-.3.5-.3.7,0,.5.4.6.8.7.8.2,3.1.9,5.5,1.8,2.1-2,3-4.3,3.6-5.9h-7.9Z"
              />
              <path
                class="pn_st63"
                d="M579.9,463.2c-.2,0-1.1,0-1.1-.9s.8-1,1.1-1h21.4c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-12.7c-.9,2.1-1.7,3.7-3.2,6.4,4,0,8.3-.3,11.7-.6-.7-.7-1.6-1.5-2.4-2.2-.5-.4-.7-.7-.7-1s.6-1,1.1-1,1.2.6,1.9,1.2c1.1,1,2.6,2.3,3.8,3.7.7.8.8,1,.8,1.3,0,.5-.5,1-1,1s-.5,0-1.7-1.4c-2.7.2-5,.5-9,.7-3.4.2-8.5.3-9,.3s-1.1,0-1.1-1,.6-.9.9-.9c.2,0,2.1,0,2.4,0,1.3-2.1,2.4-4.2,3.3-6.4h-6.3ZM585.4,449.8c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.2h6.3v-1.2c0-.4,0-.9,1-.9s1,.2,1,.9v1.2h5.5c.4,0,1,0,1,.9s-.5,1-1,1h-5.5v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-6.3v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-5.5c-.4,0-1,0-1-.9s.5-1,1-1h5.5v-1.2ZM582,458c-.3,0-1.1,0-1.1-.9s.7-1,1.1-1h17.4c.3,0,1,0,1,.9s-.7.9-1,.9h-17.4Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="434.3" x2="573.7" y2="434.3" />
            <g>
              <line class="pn_st2" x1="573.7" y1="434.3" x2="571.2" y2="434.3" />
              <line class="pn_st12" x1="569" y1="434.3" x2="569" y2="434.3" />
              <line class="pn_st5" x1="569" y1="434.3" x2="546.4" y2="434.3" />
              <line class="pn_st2" x1="546.4" y1="434.3" x2="543.9" y2="434.3" />
            </g>
          </g>
        </g>
        <g
          id="_x33_1安芸_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(31)"
          class="cursor_not_allowed"
        >
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M549.4,412.2c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M561.1,399.5c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M554.5,416.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M568.1,423.9c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <path
              class="pn_st63"
              d="M590.7,487.8c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M590.7,382.3c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,379.3c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M580.1,404.8c-.2,0-1.1,0-1.1-1s.5-1,1.1-1h6.1c.4-.9.9-1.8,1.3-3,.2-.5.4-.9,1.1-.9s1.3.3,1.3,1-.9,2.3-1.2,2.9h12.5c.2,0,1.1,0,1.1,1s-.7,1-1.1,1h-3.2c-.8,2.3-1.8,4.5-3.9,6.8,2.7,1.2,4,1.9,6,3.1.4.2.7.5.7,1s-.6,1.2-1.2,1.2-.5,0-1-.4c-1.9-1.2-3-2-6.1-3.4-1.8,1.3-3.5,2.3-6.6,3.1-2.5.6-4.6.8-4.9.8-1.1,0-1.1-1-1.1-1.2,0-.9.6-1,1.1-1,2-.2,5.7-.6,9.2-2.6-1.5-.6-3.9-1.4-5.2-1.8-.8-.2-1.8-.6-1.8-1.7s.2-.9.6-1.5c.2-.3,1.2-1.9,1.5-2.4h-5.1ZM598.9,396c1.9,0,2.7.6,2.7,2.7v1.9c0,.4,0,1.1-1,1.1s-1.2-.2-1.2-1v-1.7c0-.6-.2-1.1-1-1.1h-15.5c-.7,0-1,.4-1,1.1v1.7c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2,.7-2.7,2.7-2.7h7.2v-1.2c0-.7.4-.9,1-.9s1.1.2,1.1.9v1.2h7.2ZM587.7,404.8c-.7,1.2-1,1.7-1.7,2.7-.2.3-.3.5-.3.7,0,.5.4.6.8.7.8.2,3.1.9,5.5,1.8,2.1-2,3-4.3,3.6-5.9h-7.9Z"
              />
              <path
                d="M579.9,463.2c-.2,0-1.1,0-1.1-.9s.8-1,1.1-1h21.4c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-12.7c-.9,2.1-1.7,3.7-3.2,6.4,4,0,8.3-.3,11.7-.6-.7-.7-1.6-1.5-2.4-2.2-.5-.4-.7-.7-.7-1s.6-1,1.1-1,1.2.6,1.9,1.2c1.1,1,2.6,2.3,3.8,3.7.7.8.8,1,.8,1.3,0,.5-.5,1-1,1s-.5,0-1.7-1.4c-2.7.2-5,.5-9,.7-3.4.2-8.5.3-9,.3s-1.1,0-1.1-1,.6-.9.9-.9c.2,0,2.1,0,2.4,0,1.3-2.1,2.4-4.2,3.3-6.4h-6.3ZM585.4,449.8c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.2h6.3v-1.2c0-.4,0-.9,1-.9s1,.2,1,.9v1.2h5.5c.4,0,1,0,1,.9s-.5,1-1,1h-5.5v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-6.3v1.8c0,.3,0,.9-1,.9s-1.1-.3-1.1-.9v-1.8h-5.5c-.4,0-1,0-1-.9s.5-1,1-1h5.5v-1.2ZM582,458c-.3,0-1.1,0-1.1-.9s.7-1,1.1-1h17.4c.3,0,1,0,1,.9s-.7.9-1,.9h-17.4Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="434.3" x2="573.7" y2="434.3" />
            <g>
              <line class="pn_st2" x1="573.7" y1="434.3" x2="571.2" y2="434.3" />
              <line class="pn_st12" x1="569" y1="434.3" x2="569" y2="434.3" />
              <line class="pn_st5" x1="569" y1="434.3" x2="546.4" y2="434.3" />
              <line class="pn_st2" x1="546.4" y1="434.3" x2="543.9" y2="434.3" />
            </g>
          </g>
        </g>
        <g id="_x33_0北川_xFF1A_橙">
          <a @click="sendPointId(30)">
            <g>
              <path
                class="pn_st67"
                d="M590.7,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M590.7,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M586.2,275.9h-6.1c-.3,0-1,0-1-1s.6-1,1-1h6.1v-5.3c0-.4,0-1.1,1-1.1s1.2.2,1.2,1.1v21.2c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2.7c-1.4.5-5.7,2-6.2,2s-.9-.8-.9-1.3.3-.8,1.6-1.2c1.9-.5,3.8-1,5.6-1.7v-9.1ZM593.9,287.2c0,.5.1.9.6,1,.3.1,1.5.1,2.2.1h.8c1.9,0,2.1,0,2.2-1.8,0-.5.1-2.4.2-2.8.2-.4.7-.5.9-.5,1.1,0,1.1.9,1.1,1.2,0,.5-.2,3.8-.6,4.6-.5,1.2-1.2,1.2-3.6,1.2-3.6,0-3.8,0-4.2,0-1.9-.2-1.9-1.8-1.9-2.6v-19.1c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v7.1c2.7-1.4,4.4-2.7,4.9-3.1,1.4-1.2,1.5-1.2,1.8-1.2.7,0,1.1.7,1.1,1.3s0,.6-1.7,1.8c-2.8,2-5.2,3.2-6.1,3.6v9.1Z"
                />
                <path
                  d="M583.8,332.9c0,2.5-.2,7.6-2,11-.8,1.6-1.2,1.8-1.7,1.8-.6,0-1.2-.5-1.2-1.2s.2-.6.4-1c.6-1,1.5-2.4,2-5.8.3-1.9.3-3.9.3-4.7v-9.1c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v9.1ZM592,343.1c0,.3,0,1-1,1s-1.2-.3-1.2-1v-18.5c0-.3,0-1,1-1s1.2.2,1.2,1v18.5ZM600.7,344.7c0,.3,0,1.1-1,1.1s-1.2-.2-1.2-1.1v-20.9c0-.3,0-1,1-1s1.2.2,1.2,1v20.9Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M542.1,378.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st57"
                d="M554,367.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st57"
                d="M570.7,370.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st57"
                d="M584.1,377.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="590.7" y1="362.9" x2="590.7" y2="362.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="590.7"
                  y1="362.9"
                  x2="590.7"
                  y2="365.4"
                />
                <line
                  class="pn_st56"
                  x1="590.7"
                  y1="368.1"
                  x2="590.7"
                  y2="368.1"
                />
                <line class="pn_st7" x1="590.7" y1="368.1" x2="590.7" y2="377.4" />
                <line
                  class="pn_st13"
                  x1="590.7"
                  y1="377.4"
                  x2="590.7"
                  y2="379.9"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x33_0北川_xFF1A_紫" v-if="this.clickedPointId === 30">
          <rect
            class="pn_st61"
            x="573.7"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M586.2,275.9h-6.1c-.3,0-1,0-1-1s.6-1,1-1h6.1v-5.3c0-.4,0-1.1,1-1.1s1.2.2,1.2,1.1v21.2c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2.7c-1.4.5-5.7,2-6.2,2s-.9-.8-.9-1.3.3-.8,1.6-1.2c1.9-.5,3.8-1,5.6-1.7v-9.1ZM593.9,287.2c0,.5.1.9.6,1,.3.1,1.5.1,2.2.1h.8c1.9,0,2.1,0,2.2-1.8,0-.5.1-2.4.2-2.8.2-.4.7-.5.9-.5,1.1,0,1.1.9,1.1,1.2,0,.5-.2,3.8-.6,4.6-.5,1.2-1.2,1.2-3.6,1.2-3.6,0-3.8,0-4.2,0-1.9-.2-1.9-1.8-1.9-2.6v-19.1c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v7.1c2.7-1.4,4.4-2.7,4.9-3.1,1.4-1.2,1.5-1.2,1.8-1.2.7,0,1.1.7,1.1,1.3s0,.6-1.7,1.8c-2.8,2-5.2,3.2-6.1,3.6v9.1Z"
              />
              <path
                class="pn_st63"
                d="M583.8,332.9c0,2.5-.2,7.6-2,11-.8,1.6-1.2,1.8-1.7,1.8-.6,0-1.2-.5-1.2-1.2s.2-.6.4-1c.6-1,1.5-2.4,2-5.8.3-1.9.3-3.9.3-4.7v-9.1c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v9.1ZM592,343.1c0,.3,0,1-1,1s-1.2-.3-1.2-1v-18.5c0-.3,0-1,1-1s1.2.2,1.2,1v18.5ZM600.7,344.7c0,.3,0,1.1-1,1.1s-1.2-.2-1.2-1.1v-20.9c0-.3,0-1,1-1s1.2.2,1.2,1v20.9Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M542.1,378.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M554,367.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M570.7,370.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M584.1,377.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="362.9" x2="590.7" y2="362.9" />
            <g>
              <line class="pn_st2" x1="590.7" y1="362.9" x2="590.7" y2="365.4" />
              <line class="pn_st25" x1="590.7" y1="368.1" x2="590.7" y2="368.1" />
              <line class="pn_st36" x1="590.7" y1="368.1" x2="590.7" y2="377.4" />
              <line class="pn_st2" x1="590.7" y1="377.4" x2="590.7" y2="379.9" />
            </g>
          </g>
        </g>
        <g
          id="_x33_0北川_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(30)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M590.7,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M590.7,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M586.2,275.9h-6.1c-.3,0-1,0-1-1s.6-1,1-1h6.1v-5.3c0-.4,0-1.1,1-1.1s1.2.2,1.2,1.1v21.2c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2.7c-1.4.5-5.7,2-6.2,2s-.9-.8-.9-1.3.3-.8,1.6-1.2c1.9-.5,3.8-1,5.6-1.7v-9.1ZM593.9,287.2c0,.5.1.9.6,1,.3.1,1.5.1,2.2.1h.8c1.9,0,2.1,0,2.2-1.8,0-.5.1-2.4.2-2.8.2-.4.7-.5.9-.5,1.1,0,1.1.9,1.1,1.2,0,.5-.2,3.8-.6,4.6-.5,1.2-1.2,1.2-3.6,1.2-3.6,0-3.8,0-4.2,0-1.9-.2-1.9-1.8-1.9-2.6v-19.1c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v7.1c2.7-1.4,4.4-2.7,4.9-3.1,1.4-1.2,1.5-1.2,1.8-1.2.7,0,1.1.7,1.1,1.3s0,.6-1.7,1.8c-2.8,2-5.2,3.2-6.1,3.6v9.1Z"
              />
              <path
                d="M583.8,332.9c0,2.5-.2,7.6-2,11-.8,1.6-1.2,1.8-1.7,1.8-.6,0-1.2-.5-1.2-1.2s.2-.6.4-1c.6-1,1.5-2.4,2-5.8.3-1.9.3-3.9.3-4.7v-9.1c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v9.1ZM592,343.1c0,.3,0,1-1,1s-1.2-.3-1.2-1v-18.5c0-.3,0-1,1-1s1.2.2,1.2,1v18.5ZM600.7,344.7c0,.3,0,1.1-1,1.1s-1.2-.2-1.2-1.1v-20.9c0-.3,0-1,1-1s1.2.2,1.2,1v20.9Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M542.1,378.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M554,367.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M570.7,370.7c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M584.1,377.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="362.9" x2="590.7" y2="362.9" />
            <g>
              <line class="pn_st2" x1="590.7" y1="362.9" x2="590.7" y2="365.4" />
              <line class="pn_st25" x1="590.7" y1="368.1" x2="590.7" y2="368.1" />
              <line class="pn_st36" x1="590.7" y1="368.1" x2="590.7" y2="377.4" />
              <line class="pn_st2" x1="590.7" y1="377.4" x2="590.7" y2="379.9" />
            </g>
          </g>
        </g>
        <g id="_x32_9室戸2_xFF1A_橙">
          <a @click="sendPointId(29)">
            <g>
              <path
                class="pn_st67"
                d="M527,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M527,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="544" y1="307.9" x2="544" y2="307.9" />
              <g>
                <line class="pn_st13" x1="544" y1="307.9" x2="546.5" y2="307.9" />
                <line class="pn_st3" x1="548.6" y1="307.9" x2="548.7" y2="307.9" />
                <line
                  class="pn_st38"
                  x1="548.7"
                  y1="307.9"
                  x2="571.1"
                  y2="307.9"
                />
                <line
                  class="pn_st13"
                  x1="571.1"
                  y1="307.9"
                  x2="573.6"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M548.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M569.1,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM561.5,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M554.1,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M567.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M525.9,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM535.2,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
                />
                <path
                  d="M517.7,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM537.7,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM519.9,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
                />
                <path
                  d="M538.8,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,339.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_9室戸2_xFF1A_紫" v-if="this.clickedPointId === 29">
          <rect
            class="pn_st61"
            x="510"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="544" y1="307.9" x2="544" y2="307.9" />
            <g>
              <line class="pn_st2" x1="544" y1="307.9" x2="546.5" y2="307.9" />
              <line class="pn_st28" x1="548.6" y1="307.9" x2="548.7" y2="307.9" />
              <line class="pn_st34" x1="548.7" y1="307.9" x2="571.1" y2="307.9" />
              <line class="pn_st2" x1="571.1" y1="307.9" x2="573.6" y2="307.9" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M525.9,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM535.2,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
              />
              <path
                class="pn_st63"
                d="M517.7,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM537.7,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM519.9,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
              />
              <path
                class="pn_st63"
                d="M538.8,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,339.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M548.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M569.1,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM561.5,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M554.1,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M567.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_9室戸2_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(29)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M527,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M527,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="544" y1="307.9" x2="544" y2="307.9" />
            <g>
              <line class="pn_st2" x1="544" y1="307.9" x2="546.5" y2="307.9" />
              <line class="pn_st28" x1="548.6" y1="307.9" x2="548.7" y2="307.9" />
              <line class="pn_st34" x1="548.7" y1="307.9" x2="571.1" y2="307.9" />
              <line class="pn_st2" x1="571.1" y1="307.9" x2="573.6" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st64"
                d="M548.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st64"
                d="M569.1,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM561.5,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st64"
                d="M554.1,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st64"
                d="M567.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M525.9,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM535.2,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
              />
              <path
                d="M517.7,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM537.7,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM519.9,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
              />
              <path
                d="M538.8,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM515.9,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM531,339.2c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_8室戸1_xFF1A_橙">
          <a @click="sendPointId(28)">
            <g>
              <path
                class="pn_st67"
                d="M463.2,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M463.2,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="480.4" y1="307.9" x2="480.4" y2="307.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="480.4"
                  y1="307.9"
                  x2="482.9"
                  y2="307.9"
                />
                <line class="pn_st3" x1="485" y1="307.9" x2="485" y2="307.9" />
                <line class="pn_st38" x1="485" y1="307.9" x2="507.4" y2="307.9" />
                <line
                  class="pn_st13"
                  x1="507.4"
                  y1="307.9"
                  x2="509.9"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M485.4,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
                <path
                  class="pn_st57"
                  d="M500.2,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M490,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M503.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M462.1,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM471.5,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
                />
                <path
                  d="M453.9,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM473.9,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM456.1,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
                />
                <path
                  d="M475.1,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,330.4c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_8室戸1_xFF1A_紫" v-if="this.clickedPointId === 28">
          <rect
            class="pn_st61"
            x="446.2"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="480.4" y1="307.9" x2="480.4" y2="307.9" />
            <g>
              <line class="pn_st2" x1="480.4" y1="307.9" x2="482.9" y2="307.9" />
              <line class="pn_st28" x1="485" y1="307.9" x2="485" y2="307.9" />
              <line class="pn_st34" x1="485" y1="307.9" x2="507.4" y2="307.9" />
              <line class="pn_st2" x1="507.4" y1="307.9" x2="509.9" y2="307.9" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M462.1,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM471.5,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
              />
              <path
                class="pn_st63"
                d="M453.9,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM473.9,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM456.1,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
              />
              <path
                class="pn_st63"
                d="M475.1,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,330.4c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.4,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M500.2,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_8室戸1_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(28)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M463.2,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M463.2,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="480.4" y1="307.9" x2="480.4" y2="307.9" />
            <g>
              <line class="pn_st2" x1="480.4" y1="307.9" x2="482.9" y2="307.9" />
              <line class="pn_st28" x1="485" y1="307.9" x2="485" y2="307.9" />
              <line class="pn_st34" x1="485" y1="307.9" x2="507.4" y2="307.9" />
              <line class="pn_st2" x1="507.4" y1="307.9" x2="509.9" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M485.4,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st71"
                d="M500.2,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM496.8,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M490,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M503.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M462.1,280.5c-2.9.2-7.4.3-7.7.3s-1.1,0-1.1-1,.3-.8.6-.8c.2,0,2.8,0,3.3,0,.5-.7,1.1-1.6,2.1-3.5h-3.5c-.3,0-1,0-1-.9s.7-.8,1-.8h14.9c.5,0,1,0,1,.8s-.7.9-1,.9h-9.1c-1.3,2.4-1.5,2.7-2,3.4,4-.1,4.2-.1,8.8-.4-.2-.1-1-.9-1.2-1.1-.2-.2-.3-.3-.3-.7,0-.5.4-1,1-1s.6.2.7.3c.7.5,2.5,2,3.3,2.9,1.1,1.1,1.2,1.2,1.2,1.6,0,.5-.6,1.1-1.1,1.1s-.5-.1-.7-.3c0,0-1-1.1-1.2-1.3-1.5.1-2.2.2-5.8.4v2.9h7.6c.4,0,1,0,1,.9s-.7.9-1,.9h-7.6v3h9.6c.3,0,1,0,1,1s-.8,1-1,1h-21.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h9.4v-3h-7.5c-.2,0-1,0-1-.9s.8-.9,1-.9h7.5v-2.7ZM471.5,269.6c2.1,0,2.7.5,2.7,2.7v2c0,.3,0,1-1,1s-1.1-.2-1.1-1v-1.8c0-.8-.3-1.1-1.1-1.1h-15.6c-.7,0-1,.4-1,1.1v1.9c0,.3,0,1-1,1s-1.1-.3-1.1-1v-2c0-2.1.6-2.7,2.7-2.7h7.2v-1.2c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.2h7.2Z"
              />
              <path
                d="M453.9,303.4c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM473.9,296c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM456.1,307.8h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
              />
              <path
                d="M475.1,334.2c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM452.2,334.2c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM461.2,330.4c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_7東洋_xFF1A_橙">
          <a @click="sendPointId(27)">
            <g>
              <path
                class="pn_st67"
                d="M399.5,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M399.5,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="416.7" y1="307.9" x2="416.7" y2="307.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="416.7"
                  y1="307.9"
                  x2="419.2"
                  y2="307.9"
                />
                <line class="pn_st3" x1="421.3" y1="307.9" x2="421.3" y2="307.9" />
                <line
                  class="pn_st38"
                  x1="421.3"
                  y1="307.9"
                  x2="443.8"
                  y2="307.9"
                />
                <line
                  class="pn_st13"
                  x1="443.8"
                  y1="307.9"
                  x2="446.3"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M420.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M432.7,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M426,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M439.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M407,273.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM398.4,277.2v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM398.4,278.8h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM400.5,277.2h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM400.5,278.8v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
                />
                <path
                  d="M390.2,329.9c.8.5,1.8,1.2,2.3,1.6.3.3.4.6.4.8,0,.5-.4,1.2-1,1.2s-.3,0-1.5-.9c-.3-.2-2.2-1.5-2.2-1.5-.3-.2-.3-.6-.3-.7,0-.4.4-1,.9-1,.3,0,.5,0,1.5.6ZM394,336.8c0,.7-2,5-3.6,7.5-.7,1.1-.9,1.2-1.3,1.2s-1.1-.5-1.1-1,0-.4,1.2-2.2c1.2-1.8,2.3-4.5,2.9-5.9.2-.5.5-.7.9-.7s1,.4,1,1ZM392.9,324.5c1.2.8,1.3,1,1.3,1.5,0,.8-.6,1.1-1,1.1s-.4,0-1.5-.9c-.4-.3-2.4-1.6-2.5-1.6-.2-.2-.3-.4-.3-.7s.3-1,1-1,2,1,3,1.6ZM404.6,326.9c.5-1,.7-1.7,1.4-3.6.1-.4.3-.8,1-.8s1.1.2,1.1.9-.1.6-.7,1.8c-.4.8-.5,1.1-.9,1.8h2.9c.2,0,1,0,1,.9s-.8,1-1,1h-5.7v3.8h5.2c.2,0,1,0,1,.9s-.8.9-1,.9h-5.2v3.9h6.3c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-6.3v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-6.3c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h6.3v-3.9h-5.2c-.2,0-1,0-1-.9s.8-.9,1-.9h5.2v-3.8h-5.7c-.3,0-1,0-1-1s.2-1,1-1h2.8c-.2-.6-.6-1.4-.9-2-.6-1.2-.6-1.2-.6-1.5,0-.6.7-.9,1.1-.9.6,0,.8.4,1.2,1.3.8,1.8,1,2.6,1.2,3.1h4Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_7東洋_xFF1A_紫" v-if="this.clickedPointId === 27">
          <rect
            class="pn_st61"
            x="382.5"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="416.7" y1="307.9" x2="416.7" y2="307.9" />
            <g>
              <line class="pn_st2" x1="416.7" y1="307.9" x2="419.2" y2="307.9" />
              <line class="pn_st28" x1="421.3" y1="307.9" x2="421.3" y2="307.9" />
              <line class="pn_st34" x1="421.3" y1="307.9" x2="443.8" y2="307.9" />
              <line class="pn_st2" x1="443.8" y1="307.9" x2="446.3" y2="307.9" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M407,273.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM398.4,277.2v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM398.4,278.8h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM400.5,277.2h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM400.5,278.8v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
              />
              <path
                class="pn_st63"
                d="M390.2,329.9c.8.5,1.8,1.2,2.3,1.6.3.3.4.6.4.8,0,.5-.4,1.2-1,1.2s-.3,0-1.5-.9c-.3-.2-2.2-1.5-2.2-1.5-.3-.2-.3-.6-.3-.7,0-.4.4-1,.9-1,.3,0,.5,0,1.5.6ZM394,336.8c0,.7-2,5-3.6,7.5-.7,1.1-.9,1.2-1.3,1.2s-1.1-.5-1.1-1,0-.4,1.2-2.2c1.2-1.8,2.3-4.5,2.9-5.9.2-.5.5-.7.9-.7s1,.4,1,1ZM392.9,324.5c1.2.8,1.3,1,1.3,1.5,0,.8-.6,1.1-1,1.1s-.4,0-1.5-.9c-.4-.3-2.4-1.6-2.5-1.6-.2-.2-.3-.4-.3-.7s.3-1,1-1,2,1,3,1.6ZM404.6,326.9c.5-1,.7-1.7,1.4-3.6.1-.4.3-.8,1-.8s1.1.2,1.1.9-.1.6-.7,1.8c-.4.8-.5,1.1-.9,1.8h2.9c.2,0,1,0,1,.9s-.8,1-1,1h-5.7v3.8h5.2c.2,0,1,0,1,.9s-.8.9-1,.9h-5.2v3.9h6.3c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-6.3v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-6.3c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h6.3v-3.9h-5.2c-.2,0-1,0-1-.9s.8-.9,1-.9h5.2v-3.8h-5.7c-.3,0-1,0-1-1s.2-1,1-1h2.8c-.2-.6-.6-1.4-.9-2-.6-1.2-.6-1.2-.6-1.5,0-.6.7-.9,1.1-.9.6,0,.8.4,1.2,1.3.8,1.8,1,2.6,1.2,3.1h4Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M420.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M432.7,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M439.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_7東洋_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(27)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M399.5,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M399.5,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="416.7" y1="307.9" x2="416.7" y2="307.9" />
            <g>
              <line class="pn_st2" x1="416.7" y1="307.9" x2="419.2" y2="307.9" />
              <line class="pn_st28" x1="421.3" y1="307.9" x2="421.3" y2="307.9" />
              <line class="pn_st34" x1="421.3" y1="307.9" x2="443.8" y2="307.9" />
              <line class="pn_st2" x1="443.8" y1="307.9" x2="446.3" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M420.8,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M432.7,275.4c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M426,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M439.4,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M407,273.3c1.6,0,2.3.6,2.3,2.3v4.8c0,1.8-.8,2.3-2.3,2.3h-4.9c3.1,3.1,5.2,4,8.2,5.3.4.2.6.4.6.8s-.3,1.3-1.1,1.3-6.6-2.8-9.5-6.6v6.3c0,.3,0,1-1,1s-1.1-.3-1.1-1v-6.3c-3,3.9-8.7,6.5-9.4,6.5s-1.1-.7-1.1-1.2.2-.7.6-.8c2.5-1.1,4.1-1.8,6.3-3.6.9-.7,1.5-1.3,1.8-1.7h-4.7c-1.6,0-2.3-.5-2.3-2.3v-4.8c0-1.7.7-2.3,2.3-2.3h6.4v-1.6h-9.6c-.4,0-1,0-1-.9s.2-1,1-1h9.6v-1.4c0-.3,0-.9,1-.9s1.1.2,1.1.9v1.4h9.8c.3,0,1,0,1,.9s-.2,1-1,1h-9.8v1.6h6.5ZM398.4,277.2v-2.2h-6c-.6,0-.8.3-.8.8v1.4h6.8ZM398.4,278.8h-6.8v1.4c0,.5.2.8.8.8h6v-2.2ZM400.5,277.2h6.9v-1.4c0-.4-.1-.8-.8-.8h-6.1v2.2ZM400.5,278.8v2.2h6.1c.7,0,.8-.5.8-.8v-1.4h-6.9Z"
              />
              <path
                d="M390.2,329.9c.8.5,1.8,1.2,2.3,1.6.3.3.4.6.4.8,0,.5-.4,1.2-1,1.2s-.3,0-1.5-.9c-.3-.2-2.2-1.5-2.2-1.5-.3-.2-.3-.6-.3-.7,0-.4.4-1,.9-1,.3,0,.5,0,1.5.6ZM394,336.8c0,.7-2,5-3.6,7.5-.7,1.1-.9,1.2-1.3,1.2s-1.1-.5-1.1-1,0-.4,1.2-2.2c1.2-1.8,2.3-4.5,2.9-5.9.2-.5.5-.7.9-.7s1,.4,1,1ZM392.9,324.5c1.2.8,1.3,1,1.3,1.5,0,.8-.6,1.1-1,1.1s-.4,0-1.5-.9c-.4-.3-2.4-1.6-2.5-1.6-.2-.2-.3-.4-.3-.7s.3-1,1-1,2,1,3,1.6ZM404.6,326.9c.5-1,.7-1.7,1.4-3.6.1-.4.3-.8,1-.8s1.1.2,1.1.9-.1.6-.7,1.8c-.4.8-.5,1.1-.9,1.8h2.9c.2,0,1,0,1,.9s-.8,1-1,1h-5.7v3.8h5.2c.2,0,1,0,1,.9s-.8.9-1,.9h-5.2v3.9h6.3c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-6.3v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-6.3c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h6.3v-3.9h-5.2c-.2,0-1,0-1-.9s.8-.9,1-.9h5.2v-3.8h-5.7c-.3,0-1,0-1-1s.2-1,1-1h2.8c-.2-.6-.6-1.4-.9-2-.6-1.2-.6-1.2-.6-1.5,0-.6.7-.9,1.1-.9.6,0,.8.4,1.2,1.3.8,1.8,1,2.6,1.2,3.1h4Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_6海陽_xFF1A_橙">
          <a @click="sendPointId(26)">
            <g>
              <path
                class="pn_st67"
                d="M335.9,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M335.9,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="353" y1="307.9" x2="353" y2="307.9" />
              <g>
                <line class="pn_st13" x1="353" y1="307.9" x2="355.5" y2="307.9" />
                <line class="pn_st3" x1="357.6" y1="307.9" x2="357.6" y2="307.9" />
                <line
                  class="pn_st38"
                  x1="357.6"
                  y1="307.9"
                  x2="380.1"
                  y2="307.9"
                />
                <line
                  class="pn_st13"
                  x1="380.1"
                  y1="307.9"
                  x2="382.6"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M367.5,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM364.2,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M362.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M376.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M327.2,275.5c.5.3,1.3.9,1.7,1.3.3.3.3.5.3.7,0,.5-.4,1.2-1,1.2s-.6-.2-1.2-.7c-.4-.3-1.8-1.3-2-1.4-.3-.2-.6-.5-.6-.9s.6-1.1,1-1.1.9.3,1.9.9ZM330,282.6c0,.7-1.4,3.7-2.6,5.8-1,1.8-1.3,2-1.8,2s-1.2-.5-1.2-1.1.1-.5.4-.9c1.4-2.1,1.7-2.5,3.2-6,.1-.3.3-.7.8-.7.6,0,1.1.4,1.1,1ZM328.1,268.6c.6.4,1.2.8,1.8,1.2.3.2.4.5.4.7,0,.4-.3,1.1-1,1.1s-.4,0-1.2-.7c-.4-.2-2-1.2-2.2-1.4-.2-.1-.4-.3-.4-.7,0-.6.5-1,.9-1s.5,0,1.8.8ZM334.6,271.5c-.4.6-1.1,1.8-2.3,3-.8.8-1,.9-1.3.9-.5,0-1.1-.5-1.1-1s0-.3,1-1.4c1.1-1.2,2-2.7,2.7-4,.7-1.4.7-1.5,1.3-1.5s1.1.3,1.1.9,0,.6-.4,1.2h10.8c.5,0,1,.1,1,.9s-.8.9-1,.9h-11.8ZM331.1,281.3c-.3,0-1,0-1-.9s.6-.9,1-.9h1.2c0-.7.4-4.2.4-4.4.2-1.2,1.1-1.3,2-1.3h8.5c1.9,0,2.5.4,2.5,2.5s0,1.5,0,3.1h.7c.3,0,1,0,1,.9s-.7.9-1,.9h-.8c0,1.2-.2,4-.2,4.2h.5c.2,0,.9,0,.9.9s-.7.9-.9.9h-.7c-.2,1.3-.6,2.5-1.5,3-.6.3-1.1.3-4,.3s-2.2,0-2.5,0c-.4-.2-.5-.6-.5-.8,0-.9.6-.9,1.1-.9s3,0,3.6,0,1.5,0,1.8-1.6h-9.7c-1.2,0-2-.4-2-1.6s0-.4.2-2c.1-.9.2-1.5.3-2.4h-1ZM334.1,281.3c-.1,1.3-.3,2.3-.3,2.7,0,.7,0,.7,0,.9,0,.3,0,.6.9.6h2.8c.2-1.4.4-2.6.5-4.2h-3.8ZM338,279.5c.1-1.7.2-2.2.3-3.9h-2.5c-.9,0-1.2,0-1.2,1,0,.6-.1,1.8-.2,2.9h3.7ZM339.7,281.3c-.2,2.7-.3,3.1-.4,4.2h4.1c.2-2.3.2-4,.2-4.2h-4ZM343.8,279.5c0-.5,0-1.9,0-2.8s0-1.1-1-1.1h-2.7c-.1,2.1-.1,2.5-.2,3.9h3.9Z"
                />
                <path
                  d="M327,344.9c0,.3,0,1-.9,1s-1-.3-1-1v-19.3c0-1.8.5-2.3,2.3-2.3h2.4c.8,0,2.1,0,2.1,1.6s-.2,1.5-1.6,4.4c-.2.3-.7,1.4-.7,1.6s0,.3.6,1.1c1.1,1.6,1.9,3.5,1.9,5.5,0,3.5-2.4,3.5-3.4,3.5s-1.4,0-1.4-1.2.6-.9.9-.9c1.2,0,2,0,2-1.8s-1-3.4-2-4.9c0-.1-.4-.7-.4-1.1s.2-.9,1-2.6c.8-1.6,1-2.5,1-2.7,0-.5-.5-.5-.8-.5h-1.3c-.6,0-.8.3-.8.8v19ZM343.4,338c-.3,1.1-1.1,3.3-2.7,5.3-.5.7-2.2,2.5-3.1,2.5s-1-.4-1-.9.2-.5.5-.7c1.2-.9,3.1-2.4,4.4-6.1h-2c-.5,1-1.4,3.1-4.1,5.4-.6.5-1.7,1.4-2.3,1.4s-.9-.5-.9-1,.3-.6.6-.8c1.7-1,3.5-2.5,4.8-5h-1.8c-.9,1.3-2.5,3-3.4,3s-.9-.5-.9-1,0-.4.4-.6c1.4-1.1,2.3-1.8,3.7-4.7h-2.6c-.3,0-1,0-1-.9s.7-.8,1-.8h13.5c.2,0,1,0,1,.9s-.7.8-1,.8h-8.9c-.3.7-.5,1.2-.8,1.7h7.1c1.5,0,2.5.2,2.5,2.2s-.2,4.8-.7,5.8c-.5,1-1.4,1.1-2.7,1.1-1.6,0-2.2,0-2.2-1s.4-.8.9-.8,1.2,0,1.4,0c.9,0,1-.2,1.2-1.1.2-.9.3-2.8.3-3.8s-.4-.9-.9-.9h-.4ZM345.8,329.1c0,1.7-.4,2.3-2.3,2.3h-7.5c-1.9,0-2.3-.5-2.3-2.3v-3.6c0-1.8.5-2.3,2.3-2.3h7.5c1.8,0,2.3.5,2.3,2.3v3.6ZM335.6,326.6h8.3v-1c0-.4-.1-.8-.8-.8h-6.7c-.6,0-.8.3-.8.8v1ZM335.6,328v1.1c0,.5.2.8.8.8h6.7c.6,0,.8-.3.8-.8v-1.1h-8.3Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_6海陽_xFF1A_紫" v-if="this.clickedPointId === 26">
          <rect
            class="pn_st61"
            x="318.9"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="353" y1="307.9" x2="353" y2="307.9" />
            <g>
              <line class="pn_st2" x1="353" y1="307.9" x2="355.5" y2="307.9" />
              <line class="pn_st28" x1="357.6" y1="307.9" x2="357.6" y2="307.9" />
              <line class="pn_st34" x1="357.6" y1="307.9" x2="380.1" y2="307.9" />
              <line class="pn_st2" x1="380.1" y1="307.9" x2="382.6" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M367.5,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM364.2,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M327.2,275.5c.5.3,1.3.9,1.7,1.3.3.3.3.5.3.7,0,.5-.4,1.2-1,1.2s-.6-.2-1.2-.7c-.4-.3-1.8-1.3-2-1.4-.3-.2-.6-.5-.6-.9s.6-1.1,1-1.1.9.3,1.9.9ZM330,282.6c0,.7-1.4,3.7-2.6,5.8-1,1.8-1.3,2-1.8,2s-1.2-.5-1.2-1.1.1-.5.4-.9c1.4-2.1,1.7-2.5,3.2-6,.1-.3.3-.7.8-.7.6,0,1.1.4,1.1,1ZM328.1,268.6c.6.4,1.2.8,1.8,1.2.3.2.4.5.4.7,0,.4-.3,1.1-1,1.1s-.4,0-1.2-.7c-.4-.2-2-1.2-2.2-1.4-.2-.1-.4-.3-.4-.7,0-.6.5-1,.9-1s.5,0,1.8.8ZM334.6,271.5c-.4.6-1.1,1.8-2.3,3-.8.8-1,.9-1.3.9-.5,0-1.1-.5-1.1-1s0-.3,1-1.4c1.1-1.2,2-2.7,2.7-4,.7-1.4.7-1.5,1.3-1.5s1.1.3,1.1.9,0,.6-.4,1.2h10.8c.5,0,1,.1,1,.9s-.8.9-1,.9h-11.8ZM331.1,281.3c-.3,0-1,0-1-.9s.6-.9,1-.9h1.2c0-.7.4-4.2.4-4.4.2-1.2,1.1-1.3,2-1.3h8.5c1.9,0,2.5.4,2.5,2.5s0,1.5,0,3.1h.7c.3,0,1,0,1,.9s-.7.9-1,.9h-.8c0,1.2-.2,4-.2,4.2h.5c.2,0,.9,0,.9.9s-.7.9-.9.9h-.7c-.2,1.3-.6,2.5-1.5,3-.6.3-1.1.3-4,.3s-2.2,0-2.5,0c-.4-.2-.5-.6-.5-.8,0-.9.6-.9,1.1-.9s3,0,3.6,0,1.5,0,1.8-1.6h-9.7c-1.2,0-2-.4-2-1.6s0-.4.2-2c.1-.9.2-1.5.3-2.4h-1ZM334.1,281.3c-.1,1.3-.3,2.3-.3,2.7,0,.7,0,.7,0,.9,0,.3,0,.6.9.6h2.8c.2-1.4.4-2.6.5-4.2h-3.8ZM338,279.5c.1-1.7.2-2.2.3-3.9h-2.5c-.9,0-1.2,0-1.2,1,0,.6-.1,1.8-.2,2.9h3.7ZM339.7,281.3c-.2,2.7-.3,3.1-.4,4.2h4.1c.2-2.3.2-4,.2-4.2h-4ZM343.8,279.5c0-.5,0-1.9,0-2.8s0-1.1-1-1.1h-2.7c-.1,2.1-.1,2.5-.2,3.9h3.9Z"
              />
              <path
                class="pn_st63"
                d="M327,344.9c0,.3,0,1-.9,1s-1-.3-1-1v-19.3c0-1.8.5-2.3,2.3-2.3h2.4c.8,0,2.1,0,2.1,1.6s-.2,1.5-1.6,4.4c-.2.3-.7,1.4-.7,1.6s0,.3.6,1.1c1.1,1.6,1.9,3.5,1.9,5.5,0,3.5-2.4,3.5-3.4,3.5s-1.4,0-1.4-1.2.6-.9.9-.9c1.2,0,2,0,2-1.8s-1-3.4-2-4.9c0-.1-.4-.7-.4-1.1s.2-.9,1-2.6c.8-1.6,1-2.5,1-2.7,0-.5-.5-.5-.8-.5h-1.3c-.6,0-.8.3-.8.8v19ZM343.4,338c-.3,1.1-1.1,3.3-2.7,5.3-.5.7-2.2,2.5-3.1,2.5s-1-.4-1-.9.2-.5.5-.7c1.2-.9,3.1-2.4,4.4-6.1h-2c-.5,1-1.4,3.1-4.1,5.4-.6.5-1.7,1.4-2.3,1.4s-.9-.5-.9-1,.3-.6.6-.8c1.7-1,3.5-2.5,4.8-5h-1.8c-.9,1.3-2.5,3-3.4,3s-.9-.5-.9-1,0-.4.4-.6c1.4-1.1,2.3-1.8,3.7-4.7h-2.6c-.3,0-1,0-1-.9s.7-.8,1-.8h13.5c.2,0,1,0,1,.9s-.7.8-1,.8h-8.9c-.3.7-.5,1.2-.8,1.7h7.1c1.5,0,2.5.2,2.5,2.2s-.2,4.8-.7,5.8c-.5,1-1.4,1.1-2.7,1.1-1.6,0-2.2,0-2.2-1s.4-.8.9-.8,1.2,0,1.4,0c.9,0,1-.2,1.2-1.1.2-.9.3-2.8.3-3.8s-.4-.9-.9-.9h-.4ZM345.8,329.1c0,1.7-.4,2.3-2.3,2.3h-7.5c-1.9,0-2.3-.5-2.3-2.3v-3.6c0-1.8.5-2.3,2.3-2.3h7.5c1.8,0,2.3.5,2.3,2.3v3.6ZM335.6,326.6h8.3v-1c0-.4-.1-.8-.8-.8h-6.7c-.6,0-.8.3-.8.8v1ZM335.6,328v1.1c0,.5.2.8.8.8h6.7c.6,0,.8-.3.8-.8v-1.1h-8.3Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_6海陽_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(26)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M335.9,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M335.9,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.9,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="307.9" x2="353" y2="307.9" />
            <g>
              <line class="pn_st2" x1="353" y1="307.9" x2="355.5" y2="307.9" />
              <line class="pn_st28" x1="357.6" y1="307.9" x2="357.6" y2="307.9" />
              <line class="pn_st34" x1="357.6" y1="307.9" x2="380.1" y2="307.9" />
              <line class="pn_st2" x1="380.1" y1="307.9" x2="382.6" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M367.5,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM364.2,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M362.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M376.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M327.2,275.5c.5.3,1.3.9,1.7,1.3.3.3.3.5.3.7,0,.5-.4,1.2-1,1.2s-.6-.2-1.2-.7c-.4-.3-1.8-1.3-2-1.4-.3-.2-.6-.5-.6-.9s.6-1.1,1-1.1.9.3,1.9.9ZM330,282.6c0,.7-1.4,3.7-2.6,5.8-1,1.8-1.3,2-1.8,2s-1.2-.5-1.2-1.1.1-.5.4-.9c1.4-2.1,1.7-2.5,3.2-6,.1-.3.3-.7.8-.7.6,0,1.1.4,1.1,1ZM328.1,268.6c.6.4,1.2.8,1.8,1.2.3.2.4.5.4.7,0,.4-.3,1.1-1,1.1s-.4,0-1.2-.7c-.4-.2-2-1.2-2.2-1.4-.2-.1-.4-.3-.4-.7,0-.6.5-1,.9-1s.5,0,1.8.8ZM334.6,271.5c-.4.6-1.1,1.8-2.3,3-.8.8-1,.9-1.3.9-.5,0-1.1-.5-1.1-1s0-.3,1-1.4c1.1-1.2,2-2.7,2.7-4,.7-1.4.7-1.5,1.3-1.5s1.1.3,1.1.9,0,.6-.4,1.2h10.8c.5,0,1,.1,1,.9s-.8.9-1,.9h-11.8ZM331.1,281.3c-.3,0-1,0-1-.9s.6-.9,1-.9h1.2c0-.7.4-4.2.4-4.4.2-1.2,1.1-1.3,2-1.3h8.5c1.9,0,2.5.4,2.5,2.5s0,1.5,0,3.1h.7c.3,0,1,0,1,.9s-.7.9-1,.9h-.8c0,1.2-.2,4-.2,4.2h.5c.2,0,.9,0,.9.9s-.7.9-.9.9h-.7c-.2,1.3-.6,2.5-1.5,3-.6.3-1.1.3-4,.3s-2.2,0-2.5,0c-.4-.2-.5-.6-.5-.8,0-.9.6-.9,1.1-.9s3,0,3.6,0,1.5,0,1.8-1.6h-9.7c-1.2,0-2-.4-2-1.6s0-.4.2-2c.1-.9.2-1.5.3-2.4h-1ZM334.1,281.3c-.1,1.3-.3,2.3-.3,2.7,0,.7,0,.7,0,.9,0,.3,0,.6.9.6h2.8c.2-1.4.4-2.6.5-4.2h-3.8ZM338,279.5c.1-1.7.2-2.2.3-3.9h-2.5c-.9,0-1.2,0-1.2,1,0,.6-.1,1.8-.2,2.9h3.7ZM339.7,281.3c-.2,2.7-.3,3.1-.4,4.2h4.1c.2-2.3.2-4,.2-4.2h-4ZM343.8,279.5c0-.5,0-1.9,0-2.8s0-1.1-1-1.1h-2.7c-.1,2.1-.1,2.5-.2,3.9h3.9Z"
              />
              <path
                d="M327,344.9c0,.3,0,1-.9,1s-1-.3-1-1v-19.3c0-1.8.5-2.3,2.3-2.3h2.4c.8,0,2.1,0,2.1,1.6s-.2,1.5-1.6,4.4c-.2.3-.7,1.4-.7,1.6s0,.3.6,1.1c1.1,1.6,1.9,3.5,1.9,5.5,0,3.5-2.4,3.5-3.4,3.5s-1.4,0-1.4-1.2.6-.9.9-.9c1.2,0,2,0,2-1.8s-1-3.4-2-4.9c0-.1-.4-.7-.4-1.1s.2-.9,1-2.6c.8-1.6,1-2.5,1-2.7,0-.5-.5-.5-.8-.5h-1.3c-.6,0-.8.3-.8.8v19ZM343.4,338c-.3,1.1-1.1,3.3-2.7,5.3-.5.7-2.2,2.5-3.1,2.5s-1-.4-1-.9.2-.5.5-.7c1.2-.9,3.1-2.4,4.4-6.1h-2c-.5,1-1.4,3.1-4.1,5.4-.6.5-1.7,1.4-2.3,1.4s-.9-.5-.9-1,.3-.6.6-.8c1.7-1,3.5-2.5,4.8-5h-1.8c-.9,1.3-2.5,3-3.4,3s-.9-.5-.9-1,0-.4.4-.6c1.4-1.1,2.3-1.8,3.7-4.7h-2.6c-.3,0-1,0-1-.9s.7-.8,1-.8h13.5c.2,0,1,0,1,.9s-.7.8-1,.8h-8.9c-.3.7-.5,1.2-.8,1.7h7.1c1.5,0,2.5.2,2.5,2.2s-.2,4.8-.7,5.8c-.5,1-1.4,1.1-2.7,1.1-1.6,0-2.2,0-2.2-1s.4-.8.9-.8,1.2,0,1.4,0c.9,0,1-.2,1.2-1.1.2-.9.3-2.8.3-3.8s-.4-.9-.9-.9h-.4ZM345.8,329.1c0,1.7-.4,2.3-2.3,2.3h-7.5c-1.9,0-2.3-.5-2.3-2.3v-3.6c0-1.8.5-2.3,2.3-2.3h7.5c1.8,0,2.3.5,2.3,2.3v3.6ZM335.6,326.6h8.3v-1c0-.4-.1-.8-.8-.8h-6.7c-.6,0-.8.3-.8.8v1ZM335.6,328v1.1c0,.5.2.8.8.8h6.7c.6,0,.8-.3.8-.8v-1.1h-8.3Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_5牟岐_xFF1A_橙">
          <a @click="sendPointId(25)">
            <g>
              <path
                class="pn_st67"
                d="M272.2,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M272.2,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="289.3" y1="307.9" x2="289.3" y2="307.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="289.3"
                  y1="307.9"
                  x2="291.8"
                  y2="307.9"
                />
                <line class="pn_st3" x1="293.9" y1="307.9" x2="294" y2="307.9" />
                <line class="pn_st38" x1="294" y1="307.9" x2="316.4" y2="307.9" />
                <line
                  class="pn_st13"
                  x1="316.4"
                  y1="307.9"
                  x2="318.9"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M293.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M313.9,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M298.9,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M312.3,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M271.1,277.8v-1.9c0-.6.3-1,1-1s1.1.1,1.1,1v1.9h7.9c.4,0,1,0,1,1s-.5.9-1,.9h-7.9v3.8h9.7c.3,0,1,0,1,.9s-.7,1-1,1h-9.7v4.5c0,.4,0,1-1,1s-1.1-.3-1.1-1v-4.5h-9.6c-.3,0-1,0-1-.9s.2-1,1-1h9.6v-3.8h-5.7c-.3.5-1.3,2-2.2,2.8-.2.2-.5.3-.8.3-.7,0-1-.6-1-1s.1-.5,1.2-1.8c1-1.1,1.5-2,2.6-4.2.3-.5.5-.7.9-.7s1.1.2,1.1.9-.5,1.3-.7,1.7h4.6ZM267.8,268.5c.5-.8.6-1,1.2-1s1.2.3,1.2.8-.2.7-.4,1c-.1.2-1.4,2.1-2.4,3.3,3.8,0,7.5-.1,11.2-.3-.3-.3-2-1.8-2.4-2.1-.2-.2-.5-.5-.5-.8,0-.5.5-.9,1-.9s.5.1,1.1.5,2.5,2,4,3.5c1.6,1.7,1.6,1.8,1.6,2.2,0,.6-.6,1-1.1,1s-.5-.1-.7-.3c-.8-.9-.9-1-1.4-1.5-9.1.6-18,.8-18.1.8-.4,0-1.2,0-1.2-1s.7-1,.9-1c.8,0,2.2,0,3.1,0,1.2-1.8,1.6-2.2,2.8-4.2Z"
                />
                <path
                  d="M264.4,323.4c0-.3,0-1,.9-1s.9.5.9,1v18.7h.8c.6,0,.8-.3.8-.8v-14.4c0-.2,0-.9.8-.9s.9.3.9.9v14.8c0,1.8-.5,2.3-2.3,2.3h-3.5c-1.8,0-2.3-.5-2.3-2.3v-14.8c0-.4,0-.9.8-.9s.9.4.9.9v14.4c0,.6.3.8.8.8h.7v-18.7ZM271.4,333.4c-.3,0-1,0-1-.9s.3-1,1-1h4.2v-3.8h-4.7c-.4,0-1.1,0-1.1-1s.6-1,1.1-1h4.7v-2.2c0-.3,0-1,1-1s1.1.3,1.1,1v2.2h5c.3,0,1,0,1,1s-.8,1-1,1h-5v3.8h2c1,0,2.5,0,2.5,1.9s-.9,4.4-4.1,7.7c1.6,1.3,2.4,1.6,4.7,2.6.4.2.9.4.9,1s-.2,1.2-1,1.2-3.4-1.1-6.1-3.4c-2.5,2-5.7,3.3-6.5,3.3s-1-.8-1-1.2.3-.8.9-1c1.5-.6,3.1-1.2,5.1-2.7-2-2.4-3.4-5.5-3.4-6s.6-.9,1.1-.9.8.4,1.2,1.4c.5,1.2,1.6,3,2.6,4.2,2.8-2.8,3.4-5.3,3.4-5.7s-.5-.6-.8-.6h-7.9Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_5牟岐_xFF1A_紫" v-if="this.clickedPointId === 25">
          <rect
            class="pn_st61"
            x="255.2"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="289.3" y1="307.9" x2="289.3" y2="307.9" />
            <g>
              <line class="pn_st2" x1="289.3" y1="307.9" x2="291.8" y2="307.9" />
              <line class="pn_st28" x1="293.9" y1="307.9" x2="294" y2="307.9" />
              <line class="pn_st34" x1="294" y1="307.9" x2="316.4" y2="307.9" />
              <line class="pn_st2" x1="316.4" y1="307.9" x2="318.9" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M313.9,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M271.1,277.8v-1.9c0-.6.3-1,1-1s1.1.1,1.1,1v1.9h7.9c.4,0,1,0,1,1s-.5.9-1,.9h-7.9v3.8h9.7c.3,0,1,0,1,.9s-.7,1-1,1h-9.7v4.5c0,.4,0,1-1,1s-1.1-.3-1.1-1v-4.5h-9.6c-.3,0-1,0-1-.9s.2-1,1-1h9.6v-3.8h-5.7c-.3.5-1.3,2-2.2,2.8-.2.2-.5.3-.8.3-.7,0-1-.6-1-1s.1-.5,1.2-1.8c1-1.1,1.5-2,2.6-4.2.3-.5.5-.7.9-.7s1.1.2,1.1.9-.5,1.3-.7,1.7h4.6ZM267.8,268.5c.5-.8.6-1,1.2-1s1.2.3,1.2.8-.2.7-.4,1c-.1.2-1.4,2.1-2.4,3.3,3.8,0,7.5-.1,11.2-.3-.3-.3-2-1.8-2.4-2.1-.2-.2-.5-.5-.5-.8,0-.5.5-.9,1-.9s.5.1,1.1.5,2.5,2,4,3.5c1.6,1.7,1.6,1.8,1.6,2.2,0,.6-.6,1-1.1,1s-.5-.1-.7-.3c-.8-.9-.9-1-1.4-1.5-9.1.6-18,.8-18.1.8-.4,0-1.2,0-1.2-1s.7-1,.9-1c.8,0,2.2,0,3.1,0,1.2-1.8,1.6-2.2,2.8-4.2Z"
              />
              <path
                class="pn_st63"
                d="M264.4,323.4c0-.3,0-1,.9-1s.9.5.9,1v18.7h.8c.6,0,.8-.3.8-.8v-14.4c0-.2,0-.9.8-.9s.9.3.9.9v14.8c0,1.8-.5,2.3-2.3,2.3h-3.5c-1.8,0-2.3-.5-2.3-2.3v-14.8c0-.4,0-.9.8-.9s.9.4.9.9v14.4c0,.6.3.8.8.8h.7v-18.7ZM271.4,333.4c-.3,0-1,0-1-.9s.3-1,1-1h4.2v-3.8h-4.7c-.4,0-1.1,0-1.1-1s.6-1,1.1-1h4.7v-2.2c0-.3,0-1,1-1s1.1.3,1.1,1v2.2h5c.3,0,1,0,1,1s-.8,1-1,1h-5v3.8h2c1,0,2.5,0,2.5,1.9s-.9,4.4-4.1,7.7c1.6,1.3,2.4,1.6,4.7,2.6.4.2.9.4.9,1s-.2,1.2-1,1.2-3.4-1.1-6.1-3.4c-2.5,2-5.7,3.3-6.5,3.3s-1-.8-1-1.2.3-.8.9-1c1.5-.6,3.1-1.2,5.1-2.7-2-2.4-3.4-5.5-3.4-6s.6-.9,1.1-.9.8.4,1.2,1.4c.5,1.2,1.6,3,2.6,4.2,2.8-2.8,3.4-5.3,3.4-5.7s-.5-.6-.8-.6h-7.9Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_5牟岐_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(25)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M272.2,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M272.2,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="289.3" y1="307.9" x2="289.3" y2="307.9" />
            <g>
              <line class="pn_st2" x1="289.3" y1="307.9" x2="291.8" y2="307.9" />
              <line class="pn_st28" x1="293.9" y1="307.9" x2="294" y2="307.9" />
              <line class="pn_st34" x1="294" y1="307.9" x2="316.4" y2="307.9" />
              <line class="pn_st2" x1="316.4" y1="307.9" x2="318.9" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M293.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M313.9,278.7c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306.2,278.7c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M298.9,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M312.3,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M271.1,277.8v-1.9c0-.6.3-1,1-1s1.1.1,1.1,1v1.9h7.9c.4,0,1,0,1,1s-.5.9-1,.9h-7.9v3.8h9.7c.3,0,1,0,1,.9s-.7,1-1,1h-9.7v4.5c0,.4,0,1-1,1s-1.1-.3-1.1-1v-4.5h-9.6c-.3,0-1,0-1-.9s.2-1,1-1h9.6v-3.8h-5.7c-.3.5-1.3,2-2.2,2.8-.2.2-.5.3-.8.3-.7,0-1-.6-1-1s.1-.5,1.2-1.8c1-1.1,1.5-2,2.6-4.2.3-.5.5-.7.9-.7s1.1.2,1.1.9-.5,1.3-.7,1.7h4.6ZM267.8,268.5c.5-.8.6-1,1.2-1s1.2.3,1.2.8-.2.7-.4,1c-.1.2-1.4,2.1-2.4,3.3,3.8,0,7.5-.1,11.2-.3-.3-.3-2-1.8-2.4-2.1-.2-.2-.5-.5-.5-.8,0-.5.5-.9,1-.9s.5.1,1.1.5,2.5,2,4,3.5c1.6,1.7,1.6,1.8,1.6,2.2,0,.6-.6,1-1.1,1s-.5-.1-.7-.3c-.8-.9-.9-1-1.4-1.5-9.1.6-18,.8-18.1.8-.4,0-1.2,0-1.2-1s.7-1,.9-1c.8,0,2.2,0,3.1,0,1.2-1.8,1.6-2.2,2.8-4.2Z"
              />
              <path
                d="M264.4,323.4c0-.3,0-1,.9-1s.9.5.9,1v18.7h.8c.6,0,.8-.3.8-.8v-14.4c0-.2,0-.9.8-.9s.9.3.9.9v14.8c0,1.8-.5,2.3-2.3,2.3h-3.5c-1.8,0-2.3-.5-2.3-2.3v-14.8c0-.4,0-.9.8-.9s.9.4.9.9v14.4c0,.6.3.8.8.8h.7v-18.7ZM271.4,333.4c-.3,0-1,0-1-.9s.3-1,1-1h4.2v-3.8h-4.7c-.4,0-1.1,0-1.1-1s.6-1,1.1-1h4.7v-2.2c0-.3,0-1,1-1s1.1.3,1.1,1v2.2h5c.3,0,1,0,1,1s-.8,1-1,1h-5v3.8h2c1,0,2.5,0,2.5,1.9s-.9,4.4-4.1,7.7c1.6,1.3,2.4,1.6,4.7,2.6.4.2.9.4.9,1s-.2,1.2-1,1.2-3.4-1.1-6.1-3.4c-2.5,2-5.7,3.3-6.5,3.3s-1-.8-1-1.2.3-.8.9-1c1.5-.6,3.1-1.2,5.1-2.7-2-2.4-3.4-5.5-3.4-6s.6-.9,1.1-.9.8.4,1.2,1.4c.5,1.2,1.6,3,2.6,4.2,2.8-2.8,3.4-5.3,3.4-5.7s-.5-.6-.8-.6h-7.9Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_4阿南_xFF1A_橙">
          <a @click="sendPointId(24)">
            <g>
              <path
                class="pn_st67"
                d="M208.5,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M208.5,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="225.6" y1="307.9" x2="225.6" y2="307.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="225.6"
                  y1="307.9"
                  x2="228.1"
                  y2="307.9"
                />
                <line class="pn_st3" x1="230.2" y1="307.9" x2="230.2" y2="307.9" />
                <line
                  class="pn_st38"
                  x1="230.2"
                  y1="307.9"
                  x2="252.6"
                  y2="307.9"
                />
                <line
                  class="pn_st13"
                  x1="252.6"
                  y1="307.9"
                  x2="255.1"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M230.4,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM235,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
                />
                <path
                  class="pn_st57"
                  d="M248.4,271.5c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M235.2,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M248.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M199.6,289.9c0,.3,0,1-.9,1s-1-.7-1-1v-19.4c0-1.9.5-2.4,2.3-2.4h2.4c1.1,0,2.2,0,2.2,1.6s-.9,3.1-1.5,4.4c-.2.5-.7,1.5-.7,1.7s0,.3.7,1.1c.8,1,2,2.8,2,5.3s-.3,2.5-1.6,3.2c-.5.3-1.2.4-2.1.4s-1.4,0-1.4-1.1.3-.9.8-.9c1.1,0,1.2,0,1.6-.1.6-.2.8-.9.8-1.8,0-2.1-1.3-3.8-1.8-4.3-.6-.8-.8-1-.8-1.5s0-.6.9-2.4c.7-1.4,1.2-2.8,1.2-3.1s0-.5-.6-.5h-1.7c-.6,0-.8.3-.8.8v19.1ZM206.3,270.2c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h12.8c.3,0,1,0,1,1s-.2,1-.9,1h-1.1v17.7c0,.8,0,2.3-1.8,2.6-.5,0-2.8.1-3.5.1-1.3,0-2,0-2-1.1s.7-1,1.1-1c.7,0,2.4,0,2.7,0s1.4,0,1.4-1.2v-17.1h-9.8ZM213.7,282c0,1.8-.5,2.3-2.3,2.3h-2.8c-1.8,0-2.3-.5-2.3-2.3v-6.4c0-1.8.5-2.3,2.3-2.3h2.8c1.8,0,2.3.5,2.3,2.3v6.4ZM211.9,276c0-.4-.1-.8-.8-.8h-2.3c-.6,0-.8.3-.8.8v5.7c0,.5.2.8.8.8h2.3c.7,0,.8-.5.8-.8v-5.7Z"
                />
                <path
                  d="M215.8,329c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM210.1,334.4c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_4阿南_xFF1A_紫" v-if="this.clickedPointId === 24">
          <rect
            class="pn_st61"
            x="191.5"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="225.6" y1="307.9" x2="225.6" y2="307.9" />
            <g>
              <line class="pn_st2" x1="225.6" y1="307.9" x2="228.1" y2="307.9" />
              <line class="pn_st28" x1="230.2" y1="307.9" x2="230.2" y2="307.9" />
              <line class="pn_st34" x1="230.2" y1="307.9" x2="252.6" y2="307.9" />
              <line class="pn_st2" x1="252.6" y1="307.9" x2="255.1" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.4,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM235,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M248.4,271.5c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M199.6,289.9c0,.3,0,1-.9,1s-1-.7-1-1v-19.4c0-1.9.5-2.4,2.3-2.4h2.4c1.1,0,2.2,0,2.2,1.6s-.9,3.1-1.5,4.4c-.2.5-.7,1.5-.7,1.7s0,.3.7,1.1c.8,1,2,2.8,2,5.3s-.3,2.5-1.6,3.2c-.5.3-1.2.4-2.1.4s-1.4,0-1.4-1.1.3-.9.8-.9c1.1,0,1.2,0,1.6-.1.6-.2.8-.9.8-1.8,0-2.1-1.3-3.8-1.8-4.3-.6-.8-.8-1-.8-1.5s0-.6.9-2.4c.7-1.4,1.2-2.8,1.2-3.1s0-.5-.6-.5h-1.7c-.6,0-.8.3-.8.8v19.1ZM206.3,270.2c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h12.8c.3,0,1,0,1,1s-.2,1-.9,1h-1.1v17.7c0,.8,0,2.3-1.8,2.6-.5,0-2.8.1-3.5.1-1.3,0-2,0-2-1.1s.7-1,1.1-1c.7,0,2.4,0,2.7,0s1.4,0,1.4-1.2v-17.1h-9.8ZM213.7,282c0,1.8-.5,2.3-2.3,2.3h-2.8c-1.8,0-2.3-.5-2.3-2.3v-6.4c0-1.8.5-2.3,2.3-2.3h2.8c1.8,0,2.3.5,2.3,2.3v6.4ZM211.9,276c0-.4-.1-.8-.8-.8h-2.3c-.6,0-.8.3-.8.8v5.7c0,.5.2.8.8.8h2.3c.7,0,.8-.5.8-.8v-5.7Z"
              />
              <path
                class="pn_st63"
                d="M215.8,329c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM210.1,334.4c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_4阿南_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(24)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M208.5,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M208.5,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="307.9" x2="225.6" y2="307.9" />
            <g>
              <line class="pn_st2" x1="225.6" y1="307.9" x2="228.1" y2="307.9" />
              <line class="pn_st28" x1="230.2" y1="307.9" x2="230.2" y2="307.9" />
              <line class="pn_st34" x1="230.2" y1="307.9" x2="252.6" y2="307.9" />
              <line class="pn_st2" x1="252.6" y1="307.9" x2="255.1" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M230.4,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM235,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
              <path
                class="pn_st71"
                d="M248.4,271.5c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M235.2,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M248.5,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M199.6,289.9c0,.3,0,1-.9,1s-1-.7-1-1v-19.4c0-1.9.5-2.4,2.3-2.4h2.4c1.1,0,2.2,0,2.2,1.6s-.9,3.1-1.5,4.4c-.2.5-.7,1.5-.7,1.7s0,.3.7,1.1c.8,1,2,2.8,2,5.3s-.3,2.5-1.6,3.2c-.5.3-1.2.4-2.1.4s-1.4,0-1.4-1.1.3-.9.8-.9c1.1,0,1.2,0,1.6-.1.6-.2.8-.9.8-1.8,0-2.1-1.3-3.8-1.8-4.3-.6-.8-.8-1-.8-1.5s0-.6.9-2.4c.7-1.4,1.2-2.8,1.2-3.1s0-.5-.6-.5h-1.7c-.6,0-.8.3-.8.8v19.1ZM206.3,270.2c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h12.8c.3,0,1,0,1,1s-.2,1-.9,1h-1.1v17.7c0,.8,0,2.3-1.8,2.6-.5,0-2.8.1-3.5.1-1.3,0-2,0-2-1.1s.7-1,1.1-1c.7,0,2.4,0,2.7,0s1.4,0,1.4-1.2v-17.1h-9.8ZM213.7,282c0,1.8-.5,2.3-2.3,2.3h-2.8c-1.8,0-2.3-.5-2.3-2.3v-6.4c0-1.8.5-2.3,2.3-2.3h2.8c1.8,0,2.3.5,2.3,2.3v6.4ZM211.9,276c0-.4-.1-.8-.8-.8h-2.3c-.6,0-.8.3-.8.8v5.7c0,.5.2.8.8.8h2.3c.7,0,.8-.5.8-.8v-5.7Z"
              />
              <path
                d="M215.8,329c1.9,0,2.7.6,2.7,2.7v11.2c0,1.1-.2,2.2-1.5,2.6-.4.1-.7.1-3.4.1s-1.4,0-1.4-1.1.7-.9,1.2-.9,1.7,0,1.8,0c.8,0,1.2-.2,1.2-1.1v-10.7c0-.7-.4-1.1-1.1-1.1h-13.7c-.8,0-1.1.4-1.1,1.1v13c0,.3,0,1-1,1s-1.1-.3-1.1-1v-13.2c0-2,.7-2.7,2.7-2.7h6.2v-2.2h-9.5c-.4,0-1.1,0-1.1-1s.5-1,1.1-1h9.5v-1.5c0-.5.2-.9,1-.9s1.1.2,1.1.9v1.5h9.5c.3,0,1,0,1,1s-.6,1-1,1h-9.5v2.2h6.3ZM210.1,334.4c.3-.6.6-1.2,1-2.4.1-.3.2-.7.9-.7s1.1,0,1.1.7-.9,2.3-.9,2.4h2.2c.4,0,.9,0,.9.9s-.6.9-1,.9h-4.8v2.2h4.8c.3,0,1,0,1,.8s-.6.9-1,.9h-4.8v4.1c0,.3,0,1-.9,1s-1.1-.2-1.1-1v-4.1h-4.8c-.2,0-1,0-1-.9s.6-.9,1-.9h4.8v-2.2h-4.8c-.3,0-1,0-1-.9s.3-.9.9-.9h2.1c-.1-.3-.6-1.5-.7-1.7-.1-.3-.2-.5-.2-.7,0-.6.6-.7,1.1-.7s.7.2.9.6c.2.5.7,1.5,1,2.5h3.2Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_3徳島_xFF1A_橙">
          <a @click="sendPointId(23)">
            <g>
              <path
                class="pn_st67"
                d="M144.7,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M144.7,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="161.9" y1="307.9" x2="161.9" y2="307.9" />
              <g>
                <line
                  class="pn_st13"
                  x1="161.9"
                  y1="307.9"
                  x2="164.4"
                  y2="307.9"
                />
                <line class="pn_st3" x1="166.5" y1="307.9" x2="166.5" y2="307.9" />
                <line
                  class="pn_st38"
                  x1="166.5"
                  y1="307.9"
                  x2="188.9"
                  y2="307.9"
                />
                <line
                  class="pn_st13"
                  x1="188.9"
                  y1="307.9"
                  x2="191.4"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M166.2,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st57"
                  d="M181.3,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st57"
                  d="M171.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st57"
                  d="M184.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M135.8,280.8c-.5.5-1.5,1.5-2,1.5s-1-.4-1-1.1,0-.6,1.7-2.1c1-.9,2.4-2.8,2.9-3.8q1.1-2,1.6-2c.5,0,1,.4,1,1s-.8,2.1-2.2,4.1v11.8c0,.4,0,1-1,1s-1-.7-1-1v-9.4ZM139.3,268.8c0,.5-1,2.2-2.7,4.1-.6.7-1.8,2-2.5,2s-1-.6-1-1.2.2-.6.5-.8c1.4-1,2.8-2.7,3.3-3.5.9-1.4,1-1.6,1.5-1.6s1,.4,1,1ZM142.5,284.6c0,.6-.7,2.6-1.4,4-.6,1.3-.8,1.5-1.3,1.5s-1.1-.4-1.1-.9,0-.3.6-1.3c.6-1.1.7-1.6,1.3-3.2.2-.5.3-.9.8-.9s1.1.3,1.1.8ZM146.8,273.4v-1.9h-6.2c-.4,0-1,0-1-.9s.8-.9,1-.9h6.2v-1.1c0-.8.4-.9,1.1-.9s1,.5,1,.9v1.1h6.4c.6,0,1,.2,1,.9s-.5.9-1,.9h-6.4v1.9h4c1.8,0,2.3.5,2.3,2.3v3c0,1.8-.5,2.3-2.3,2.3h-10c-1.8,0-2.3-.5-2.3-2.3v-3c0-1.9.5-2.3,2.3-2.3h3.9ZM144.8,275.1h-1.6c-.7,0-.8.4-.8.8v2.7c0,.5.2.8.8.8h1.6v-4.3ZM145.5,288c0,.8.4.9.8.9h2.6c1,0,1.3,0,1.4-.9.1-1.2.2-1.5.9-1.5s1,.8,1,1,0,1.7-.6,2.5c-.2.3-.5.7-1.7.8-.4,0-2.4,0-2.6,0-2.3,0-2.7,0-3.2-.3-.5-.4-.7-1-.7-2v-3.4c0-.3,0-1,.9-1s1,.6,1,.9v3ZM147.7,284.5c-.6-.5-1.4-1-2.2-1.4-.4-.3-.7-.4-.7-.9s.4-.9.8-.9,2,.9,2.7,1.3c1.5,1,1.5,1.2,1.5,1.5,0,.6-.5,1-.9,1s-.4,0-1.3-.7ZM149,275.1h-2.5v4.3h2.5v-4.3ZM150.8,275.1v4.3h1.8c.5,0,.8-.2.8-.8v-2.7c0-.5-.2-.8-.8-.8h-1.8ZM154.2,284.7c.5.8,2,3.6,2,4.2s-.6.9-1.1.9-.6,0-1.2-1.6c-.5-1.2-1-2-1.7-3.2-.2-.3-.3-.6-.3-.8,0-.6.7-.9.9-.9.5,0,.7,0,1.4,1.4Z"
                />
                <path
                  d="M139.7,343v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM137.6,328.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM151.5,329.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_3徳島_xFF1A_紫" v-if="this.clickedPointId === 23">
          <rect
            class="pn_st61"
            x="127.7"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="161.9" y1="307.9" x2="161.9" y2="307.9" />
            <g>
              <line class="pn_st2" x1="161.9" y1="307.9" x2="164.4" y2="307.9" />
              <line class="pn_st28" x1="166.5" y1="307.9" x2="166.5" y2="307.9" />
              <line class="pn_st34" x1="166.5" y1="307.9" x2="188.9" y2="307.9" />
              <line class="pn_st2" x1="188.9" y1="307.9" x2="191.4" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.2,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M181.3,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M135.8,280.8c-.5.5-1.5,1.5-2,1.5s-1-.4-1-1.1,0-.6,1.7-2.1c1-.9,2.4-2.8,2.9-3.8q1.1-2,1.6-2c.5,0,1,.4,1,1s-.8,2.1-2.2,4.1v11.8c0,.4,0,1-1,1s-1-.7-1-1v-9.4ZM139.3,268.8c0,.5-1,2.2-2.7,4.1-.6.7-1.8,2-2.5,2s-1-.6-1-1.2.2-.6.5-.8c1.4-1,2.8-2.7,3.3-3.5.9-1.4,1-1.6,1.5-1.6s1,.4,1,1ZM142.5,284.6c0,.6-.7,2.6-1.4,4-.6,1.3-.8,1.5-1.3,1.5s-1.1-.4-1.1-.9,0-.3.6-1.3c.6-1.1.7-1.6,1.3-3.2.2-.5.3-.9.8-.9s1.1.3,1.1.8ZM146.8,273.4v-1.9h-6.2c-.4,0-1,0-1-.9s.8-.9,1-.9h6.2v-1.1c0-.8.4-.9,1.1-.9s1,.5,1,.9v1.1h6.4c.6,0,1,.2,1,.9s-.5.9-1,.9h-6.4v1.9h4c1.8,0,2.3.5,2.3,2.3v3c0,1.8-.5,2.3-2.3,2.3h-10c-1.8,0-2.3-.5-2.3-2.3v-3c0-1.9.5-2.3,2.3-2.3h3.9ZM144.8,275.1h-1.6c-.7,0-.8.4-.8.8v2.7c0,.5.2.8.8.8h1.6v-4.3ZM145.5,288c0,.8.4.9.8.9h2.6c1,0,1.3,0,1.4-.9.1-1.2.2-1.5.9-1.5s1,.8,1,1,0,1.7-.6,2.5c-.2.3-.5.7-1.7.8-.4,0-2.4,0-2.6,0-2.3,0-2.7,0-3.2-.3-.5-.4-.7-1-.7-2v-3.4c0-.3,0-1,.9-1s1,.6,1,.9v3ZM147.7,284.5c-.6-.5-1.4-1-2.2-1.4-.4-.3-.7-.4-.7-.9s.4-.9.8-.9,2,.9,2.7,1.3c1.5,1,1.5,1.2,1.5,1.5,0,.6-.5,1-.9,1s-.4,0-1.3-.7ZM149,275.1h-2.5v4.3h2.5v-4.3ZM150.8,275.1v4.3h1.8c.5,0,.8-.2.8-.8v-2.7c0-.5-.2-.8-.8-.8h-1.8ZM154.2,284.7c.5.8,2,3.6,2,4.2s-.6.9-1.1.9-.6,0-1.2-1.6c-.5-1.2-1-2-1.7-3.2-.2-.3-.3-.6-.3-.8,0-.6.7-.9.9-.9.5,0,.7,0,1.4,1.4Z"
              />
              <path
                class="pn_st63"
                d="M139.7,343v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM137.6,328.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM151.5,329.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_3徳島_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(23)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M144.7,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M144.7,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,252.9c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="307.9" x2="161.9" y2="307.9" />
            <g>
              <line class="pn_st2" x1="161.9" y1="307.9" x2="164.4" y2="307.9" />
              <line class="pn_st28" x1="166.5" y1="307.9" x2="166.5" y2="307.9" />
              <line class="pn_st34" x1="166.5" y1="307.9" x2="188.9" y2="307.9" />
              <line class="pn_st2" x1="188.9" y1="307.9" x2="191.4" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M166.2,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M181.3,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M171.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M184.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M135.8,280.8c-.5.5-1.5,1.5-2,1.5s-1-.4-1-1.1,0-.6,1.7-2.1c1-.9,2.4-2.8,2.9-3.8q1.1-2,1.6-2c.5,0,1,.4,1,1s-.8,2.1-2.2,4.1v11.8c0,.4,0,1-1,1s-1-.7-1-1v-9.4ZM139.3,268.8c0,.5-1,2.2-2.7,4.1-.6.7-1.8,2-2.5,2s-1-.6-1-1.2.2-.6.5-.8c1.4-1,2.8-2.7,3.3-3.5.9-1.4,1-1.6,1.5-1.6s1,.4,1,1ZM142.5,284.6c0,.6-.7,2.6-1.4,4-.6,1.3-.8,1.5-1.3,1.5s-1.1-.4-1.1-.9,0-.3.6-1.3c.6-1.1.7-1.6,1.3-3.2.2-.5.3-.9.8-.9s1.1.3,1.1.8ZM146.8,273.4v-1.9h-6.2c-.4,0-1,0-1-.9s.8-.9,1-.9h6.2v-1.1c0-.8.4-.9,1.1-.9s1,.5,1,.9v1.1h6.4c.6,0,1,.2,1,.9s-.5.9-1,.9h-6.4v1.9h4c1.8,0,2.3.5,2.3,2.3v3c0,1.8-.5,2.3-2.3,2.3h-10c-1.8,0-2.3-.5-2.3-2.3v-3c0-1.9.5-2.3,2.3-2.3h3.9ZM144.8,275.1h-1.6c-.7,0-.8.4-.8.8v2.7c0,.5.2.8.8.8h1.6v-4.3ZM145.5,288c0,.8.4.9.8.9h2.6c1,0,1.3,0,1.4-.9.1-1.2.2-1.5.9-1.5s1,.8,1,1,0,1.7-.6,2.5c-.2.3-.5.7-1.7.8-.4,0-2.4,0-2.6,0-2.3,0-2.7,0-3.2-.3-.5-.4-.7-1-.7-2v-3.4c0-.3,0-1,.9-1s1,.6,1,.9v3ZM147.7,284.5c-.6-.5-1.4-1-2.2-1.4-.4-.3-.7-.4-.7-.9s.4-.9.8-.9,2,.9,2.7,1.3c1.5,1,1.5,1.2,1.5,1.5,0,.6-.5,1-.9,1s-.4,0-1.3-.7ZM149,275.1h-2.5v4.3h2.5v-4.3ZM150.8,275.1v4.3h1.8c.5,0,.8-.2.8-.8v-2.7c0-.5-.2-.8-.8-.8h-1.8ZM154.2,284.7c.5.8,2,3.6,2,4.2s-.6.9-1.1.9-.6,0-1.2-1.6c-.5-1.2-1-2-1.7-3.2-.2-.3-.3-.6-.3-.8,0-.6.7-.9.9-.9.5,0,.7,0,1.4,1.4Z"
              />
              <path
                d="M139.7,343v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.2.2,1.2.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9,1-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1,.7,1,1v1.8c0,.5.2.8.8.8h3.3ZM137.6,328.1h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM151.5,329.4h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_2東かがわ_xFF1A_橙">
          <a @click="sendPointId(22)">
            <g>
              <path
                class="pn_st67"
                d="M81,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M81,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="98.2" y1="307.9" x2="98.2" y2="307.9" />
              <g>
                <line class="pn_st10" x1="98.2" y1="307.9" x2="100.7" y2="307.9" />
                <line
                  class="pn_st50"
                  x1="102.8"
                  y1="307.9"
                  x2="102.8"
                  y2="307.9"
                />
                <line
                  class="pn_st55"
                  x1="102.8"
                  y1="307.9"
                  x2="125.2"
                  y2="307.9"
                />
                <line
                  class="pn_st10"
                  x1="125.2"
                  y1="307.9"
                  x2="127.7"
                  y2="307.9"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st58"
                  d="M105.4,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st58"
                  d="M118.7,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.4,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st58"
                  d="M107.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st58"
                  d="M121.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M88.5,269.1c1.6,0,2.3.5,2.3,2.1v4.3c0,1.6-.8,2.1-2.3,2.1h-4.9c3.1,2.8,5.2,3.6,8.2,4.8.4.2.6.4.6.7s-.3,1.1-1.1,1.1-6.6-2.5-9.5-6v5.7c0,.2,0,.9-1,.9s-1.1-.3-1.1-.9v-5.7c-3,3.5-8.7,5.9-9.4,5.9s-1.1-.6-1.1-1.1.2-.6.6-.8c2.5-1,4.1-1.6,6.3-3.2.9-.6,1.5-1.2,1.8-1.5h-4.7c-1.6,0-2.3-.4-2.3-2.1v-4.3c0-1.6.7-2.1,2.3-2.1h6.4v-1.5h-9.6c-.4,0-1,0-1-.8s.2-.9,1-.9h9.6v-1.2c0-.3,0-.8,1-.8s1.1.2,1.1.8v1.2h9.8c.3,0,1,0,1,.8s-.2.9-1,.9h-9.8v1.5h6.5ZM79.9,272.6v-2h-6c-.6,0-.8.3-.8.7v1.2h6.8ZM79.9,274h-6.8v1.3c0,.5.2.7.8.7h6v-2ZM82,272.6h6.9v-1.2c0-.3-.1-.7-.8-.7h-6.1v2ZM82,274v2h6.1c.7,0,.8-.4.8-.7v-1.3h-6.9Z"
                />
                <path
                  d="M74.5,302.7c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s0-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5,0-.6.2-1.1,1.1-1.1s1.2.3,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.6.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90.5,298.7c-.6,0-.9-.3-1.2-.9-.5-1.4-1.5-3-2.7-4.2-.5-.5-.6-.6-.6-1,0-.6.6-1,1.2-1s.8,0,2.5,2.3c1.1,1.4,2,3.1,2,3.8s-.7,1-1.2,1Z"
                />
                <path
                  d="M74.5,323.5c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s.1-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5.1-.7.3-1.1,1.1-1.1s1.2.2,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.5.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90,319.7c-.6,0-.7-.1-1.4-1.3-1.2-2.1-2.3-3.1-3.1-3.8-.2-.2-.4-.5-.4-.7,0-.6.6-1,1.2-1,.8,0,1.9,1.3,2.6,2.1,1.5,1.7,2.4,3.2,2.4,3.6s-.6,1.1-1.2,1.1ZM87.9,310.1c.5,0,2.7,2,2.7,2.5s-.4.7-.8.7-.3,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.1,0-.2-.2-.2-.5s.3-.7.8-.7ZM89.9,308.4c.5,0,2.7,2,2.7,2.5s-.3.7-.8.7-.4,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.2-.2-.2-.3-.2-.5,0-.3.4-.7.8-.7Z"
                />
                <path
                  d="M78.1,338.4c2-1.4,4.3-2.9,7.1-2.9s5.8,1.9,5.8,5.6c0,6.2-7.1,7.5-7.9,7.5s-1.1-.5-1.1-1.1.4-.8,1.3-.9c.8-.2,5.5-1.3,5.5-5.4s-1.8-3.9-3.6-3.9-4.1,1.2-4.8,1.6c-.8.5-1.7,1.1-2.4,1.7,0,1.9,0,2.1,0,3.7s0,3.6,0,4.2,0,1.1-1,1.1-1.2-.6-1.2-1c0-2.1,0-4.7.1-6-.5.6-.9,1-2.3,2.7-.8.9-1,1.2-1.5,1.2s-1.2-.5-1.2-1,.1-.4,1-1.4c.7-.7,2.4-2.6,4.1-5.4,0-.3,0-1.6,0-1.7-1.3.3-3.2.5-3.7.5s-1-.5-1-1c0-.8.4-.9,1.8-.9.5,0,1.8-.1,3-.4,0-.4.2-3.8.2-4,0-.5.4-.7,1-.7s1.1.3,1.1.8-.2,2.8-.2,3.3c.3,0,.4-.1.7-.1.6,0,1,.5,1,1s0,.5-.6,1.1c-.2.2-1.2,1.5-1.3,1.7v.2Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_2東かがわ_xFF1A_紫" v-if="this.clickedPointId === 22">
          <rect
            class="pn_st61"
            x="64"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="98.2" y1="307.9" x2="98.2" y2="307.9" />
            <g>
              <line class="pn_st2" x1="98.2" y1="307.9" x2="100.7" y2="307.9" />
              <line class="pn_st28" x1="102.8" y1="307.9" x2="102.8" y2="307.9" />
              <line class="pn_st34" x1="102.8" y1="307.9" x2="125.2" y2="307.9" />
              <line class="pn_st2" x1="125.2" y1="307.9" x2="127.7" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M105.4,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M118.7,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.4,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M88.5,269.1c1.6,0,2.3.5,2.3,2.1v4.3c0,1.6-.8,2.1-2.3,2.1h-4.9c3.1,2.8,5.2,3.6,8.2,4.8.4.2.6.4.6.7s-.3,1.1-1.1,1.1-6.6-2.5-9.5-6v5.7c0,.2,0,.9-1,.9s-1.1-.3-1.1-.9v-5.7c-3,3.5-8.7,5.9-9.4,5.9s-1.1-.6-1.1-1.1.2-.6.6-.8c2.5-1,4.1-1.6,6.3-3.2.9-.6,1.5-1.2,1.8-1.5h-4.7c-1.6,0-2.3-.4-2.3-2.1v-4.3c0-1.6.7-2.1,2.3-2.1h6.4v-1.5h-9.6c-.4,0-1,0-1-.8s.2-.9,1-.9h9.6v-1.2c0-.3,0-.8,1-.8s1.1.2,1.1.8v1.2h9.8c.3,0,1,0,1,.8s-.2.9-1,.9h-9.8v1.5h6.5ZM79.9,272.6v-2h-6c-.6,0-.8.3-.8.7v1.2h6.8ZM79.9,274h-6.8v1.3c0,.5.2.7.8.7h6v-2ZM82,272.6h6.9v-1.2c0-.3-.1-.7-.8-.7h-6.1v2ZM82,274v2h6.1c.7,0,.8-.4.8-.7v-1.3h-6.9Z"
              />
              <path
                class="pn_st63"
                d="M74.5,302.7c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s0-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5,0-.6.2-1.1,1.1-1.1s1.2.3,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.6.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90.5,298.7c-.6,0-.9-.3-1.2-.9-.5-1.4-1.5-3-2.7-4.2-.5-.5-.6-.6-.6-1,0-.6.6-1,1.2-1s.8,0,2.5,2.3c1.1,1.4,2,3.1,2,3.8s-.7,1-1.2,1Z"
              />
              <path
                class="pn_st63"
                d="M74.5,323.5c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s.1-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5.1-.7.3-1.1,1.1-1.1s1.2.2,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.5.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90,319.7c-.6,0-.7-.1-1.4-1.3-1.2-2.1-2.3-3.1-3.1-3.8-.2-.2-.4-.5-.4-.7,0-.6.6-1,1.2-1,.8,0,1.9,1.3,2.6,2.1,1.5,1.7,2.4,3.2,2.4,3.6s-.6,1.1-1.2,1.1ZM87.9,310.1c.5,0,2.7,2,2.7,2.5s-.4.7-.8.7-.3,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.1,0-.2-.2-.2-.5s.3-.7.8-.7ZM89.9,308.4c.5,0,2.7,2,2.7,2.5s-.3.7-.8.7-.4,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.2-.2-.2-.3-.2-.5,0-.3.4-.7.8-.7Z"
              />
              <path
                class="pn_st63"
                d="M78.1,338.4c2-1.4,4.3-2.9,7.1-2.9s5.8,1.9,5.8,5.6c0,6.2-7.1,7.5-7.9,7.5s-1.1-.5-1.1-1.1.4-.8,1.3-.9c.8-.2,5.5-1.3,5.5-5.4s-1.8-3.9-3.6-3.9-4.1,1.2-4.8,1.6c-.8.5-1.7,1.1-2.4,1.7,0,1.9,0,2.1,0,3.7s0,3.6,0,4.2,0,1.1-1,1.1-1.2-.6-1.2-1c0-2.1,0-4.7.1-6-.5.6-.9,1-2.3,2.7-.8.9-1,1.2-1.5,1.2s-1.2-.5-1.2-1,.1-.4,1-1.4c.7-.7,2.4-2.6,4.1-5.4,0-.3,0-1.6,0-1.7-1.3.3-3.2.5-3.7.5s-1-.5-1-1c0-.8.4-.9,1.8-.9.5,0,1.8-.1,3-.4,0-.4.2-3.8.2-4,0-.5.4-.7,1-.7s1.1.3,1.1.8-.2,2.8-.2,3.3c.3,0,.4-.1.7-.1.6,0,1,.5,1,1s0,.5-.6,1.1c-.2.2-1.2,1.5-1.3,1.7v.2Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_2東かがわ_xFF1A_青紫"
          v-if="!this.arrivedPointIdList.includes(22)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M81,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="98.2" y1="307.9" x2="98.2" y2="307.9" />
            <g>
              <line class="pn_st2" x1="98.2" y1="307.9" x2="100.7" y2="307.9" />
              <line class="pn_st28" x1="102.8" y1="307.9" x2="102.8" y2="307.9" />
              <line class="pn_st34" x1="102.8" y1="307.9" x2="125.2" y2="307.9" />
              <line class="pn_st2" x1="125.2" y1="307.9" x2="127.7" y2="307.9" />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M105.4,279c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st71"
                d="M118.7,276.5c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.4,281.3c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M107.8,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M121.1,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M88.5,269.1c1.6,0,2.3.5,2.3,2.1v4.3c0,1.6-.8,2.1-2.3,2.1h-4.9c3.1,2.8,5.2,3.6,8.2,4.8.4.2.6.4.6.7s-.3,1.1-1.1,1.1-6.6-2.5-9.5-6v5.7c0,.2,0,.9-1,.9s-1.1-.3-1.1-.9v-5.7c-3,3.5-8.7,5.9-9.4,5.9s-1.1-.6-1.1-1.1.2-.6.6-.8c2.5-1,4.1-1.6,6.3-3.2.9-.6,1.5-1.2,1.8-1.5h-4.7c-1.6,0-2.3-.4-2.3-2.1v-4.3c0-1.6.7-2.1,2.3-2.1h6.4v-1.5h-9.6c-.4,0-1,0-1-.8s.2-.9,1-.9h9.6v-1.2c0-.3,0-.8,1-.8s1.1.2,1.1.8v1.2h9.8c.3,0,1,0,1,.8s-.2.9-1,.9h-9.8v1.5h6.5ZM79.9,272.6v-2h-6c-.6,0-.8.3-.8.7v1.2h6.8ZM79.9,274h-6.8v1.3c0,.5.2.7.8.7h6v-2ZM82,272.6h6.9v-1.2c0-.3-.1-.7-.8-.7h-6.1v2ZM82,274v2h6.1c.7,0,.8-.4.8-.7v-1.3h-6.9Z"
              />
              <path
                d="M74.5,302.7c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s0-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5,0-.6.2-1.1,1.1-1.1s1.2.3,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.6.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90.5,298.7c-.6,0-.9-.3-1.2-.9-.5-1.4-1.5-3-2.7-4.2-.5-.5-.6-.6-.6-1,0-.6.6-1,1.2-1s.8,0,2.5,2.3c1.1,1.4,2,3.1,2,3.8s-.7,1-1.2,1Z"
              />
              <path
                d="M74.5,323.5c-1.5,2.2-1.8,2.2-2.2,2.2-.6,0-1.2-.4-1.2-1s.1-.4.8-1.3c.7-.8,2.7-3.4,4.2-7.5-.6,0-3.7.7-3.9.7-.8,0-1-.7-1-1,0-.8.6-.9,1.4-1,1.3-.2,2.5-.4,4.2-.6.5-1.6.6-2.3.8-3.5.1-.7.3-1.1,1.1-1.1s1.2.2,1.2.9-.2,1.6-.8,3.5c.5,0,1,0,1.4,0,3.7,0,3.9,2.3,3.9,3.5,0,1.8-.6,5.2-1.8,7.1-1.1,1.6-2.6,1.6-3.2,1.6s-3-.2-3-1.4.4-1,1-1,.5.1.9.2c.5.2.8.2,1,.2,1.1,0,1.6-.9,2-1.8.6-1.5,1-3.7,1-4.9s-.2-1.8-1.8-1.8-.9,0-1.9.1c-.4,1.1-1.7,4.6-4,7.9ZM90,319.7c-.6,0-.7-.1-1.4-1.3-1.2-2.1-2.3-3.1-3.1-3.8-.2-.2-.4-.5-.4-.7,0-.6.6-1,1.2-1,.8,0,1.9,1.3,2.6,2.1,1.5,1.7,2.4,3.2,2.4,3.6s-.6,1.1-1.2,1.1ZM87.9,310.1c.5,0,2.7,2,2.7,2.5s-.4.7-.8.7-.3,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.1,0-.2-.2-.2-.5s.3-.7.8-.7ZM89.9,308.4c.5,0,2.7,2,2.7,2.5s-.3.7-.8.7-.4,0-1.1-.8c-.2-.2-1.2-1.1-1.4-1.2-.2-.2-.2-.3-.2-.5,0-.3.4-.7.8-.7Z"
              />
              <path
                d="M78.1,338.4c2-1.4,4.3-2.9,7.1-2.9s5.8,1.9,5.8,5.6c0,6.2-7.1,7.5-7.9,7.5s-1.1-.5-1.1-1.1.4-.8,1.3-.9c.8-.2,5.5-1.3,5.5-5.4s-1.8-3.9-3.6-3.9-4.1,1.2-4.8,1.6c-.8.5-1.7,1.1-2.4,1.7,0,1.9,0,2.1,0,3.7s0,3.6,0,4.2,0,1.1-1,1.1-1.2-.6-1.2-1c0-2.1,0-4.7.1-6-.5.6-.9,1-2.3,2.7-.8.9-1,1.2-1.5,1.2s-1.2-.5-1.2-1,.1-.4,1-1.4c.7-.7,2.4-2.6,4.1-5.4,0-.3,0-1.6,0-1.7-1.3.3-3.2.5-3.7.5s-1-.5-1-1c0-.8.4-.9,1.8-.9.5,0,1.8-.1,3-.4,0-.4.2-3.8.2-4,0-.5.4-.7,1-.7s1.1.3,1.1.8-.2,2.8-.2,3.3c.3,0,.4-.1.7-.1.6,0,1,.5,1,1s0,.5-.6,1.1c-.2.2-1.2,1.5-1.3,1.7v.2Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_1さぬき_xFF1A_橙">
          <a @click="sendPointId(21)">
            <g class="pn_st60">
              <path
                class="pn_st58"
                d="M39.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st58"
                d="M51.1,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM55.7,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st58"
                d="M44.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st58"
                d="M57.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="63.9" y1="307.9" x2="63.9" y2="307.9" />
              <g>
                <line class="pn_st10" x1="63.9" y1="307.9" x2="61.4" y2="307.9" />
                <line class="pn_st48" x1="59.3" y1="307.9" x2="59.2" y2="307.9" />
                <line class="pn_st44" x1="59.2" y1="307.9" x2="36.8" y2="307.9" />
                <line class="pn_st10" x1="36.8" y1="307.9" x2="34.3" y2="307.9" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M17.3,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M16.1,273.1c-.4-.5-.6-.7-.6-1.1,0-.7.6-1,1.2-1s.8.3,1.3,1.2c.5.7,1.1,1.8,1.6,2.5.4-.2,1.3-.6,2.1-1,.5-.3.9-.5,1.2-.5.6,0,1,.6,1,1.2s-.3.8-1.2,1.3c-.7.3-1.7.7-2.1.9.9,1.5,4.1,6.8,4.1,7.8s-.6,1.2-1.2,1.2-2.6-.9-3-1c-1.4-.5-3-.8-4.2-.8-2.4,0-3.7,1.2-3.7,2.7,0,2.8,3.9,2.8,5.5,2.8.3,0,1.9-.1,2.2-.1.7,0,1.1.4,1.1,1,0,1.2-1.1,1.2-2.7,1.2s-3.8-.2-5-.7c-2.9-1-3.2-3.4-3.2-4.3,0-2.2,1.8-4.6,5.8-4.6s4.1.7,5.9,1.2c-1.3-2.3-1.4-2.5-3.5-5.9-2.5.7-5.1,1.2-7.8,1.2s-1.5,0-1.5-1.1.8-1,1.1-1c2.4,0,4.2,0,7.1-.8-.5-.7-1.3-1.9-1.5-2.2Z"
                />
                <path
                  d="M16.3,299.8c0-.5,0-2.5,0-2.9,0-.9.8-1,1.1-1,1.2,0,1.2.8,1.2,1.6s0,1.2,0,1.8c.3,0,.7,0,1.2,0,3.1,0,6.8,1.7,6.8,7.7s0,2.3-.8,4.2c.8.5,2.2,1.2,2.2,2.1s-.4,1.1-1,1.1-.6-.2-.9-.5c-.6-.5-.8-.6-1.2-.9-1.4,2.1-3.5,2.5-4.6,2.5-2.2,0-3.5-1.2-3.5-2.9s1.7-3,3.9-3,2.1.2,3.2.7c.4-1.1.5-2.2.5-3.3,0-4.2-2.2-5.7-4.8-5.7s-1,0-1.2,0c-.4,2.8-1.2,5.5-2.5,7.9.2.2.4.4.4.8,0,.5-.4,1.1-1,1.1s-.3,0-.5-.1c-1,1.3-2.6,3.1-4.5,3.1s-2.8-.6-2.8-3.4,1.2-4.7,2.6-6.4c-.1-.3-1.4-3.2-1.4-3.9s.6-1,1.2-1,.8.4,1,1.1c0,.4.4,1.3.7,2.2,2-1.8,3.6-2.5,4.7-2.9ZM11,306.3c-1.1,1.6-1.6,3.2-1.6,4.4s0,1.4.9,1.4,2.4-1.7,2.9-2.4c-.9-1.1-1.7-2.2-2.2-3.3ZM14.4,307.7c1.1-2.3,1.5-4.1,1.7-5.7-1.4.6-2.7,1.6-3.7,2.6.3.6,1,1.9,2,3.1ZM20.4,311.3c-1.1,0-1.9.4-1.9,1.1s.7,1.1,1.6,1.1,1.8,0,2.9-1.6c-.6-.3-1.6-.6-2.5-.6Z"
                />
                <path
                  d="M20.3,327.2c.6-.2,1.5-.6,2.2-.9.7-.3,1-.5,1.3-.5.7,0,1,.6,1,1.1s-.4.9-1.2,1.2c-.7.3-1.2.5-2.3.9,1.2,2.1,1.8,3.2,2.4,4.3.3.6.8,1.5.8,2,0,.8-.5,1.2-1.2,1.2s-.6-.1-1.1-.4c-2.3-1.3-4.3-1.4-5.2-1.4-2.7,0-3.8,1.3-3.8,2.4s1.6,2.5,4.8,2.5,2-.1,2.3-.1,1.2,0,1.2,1-1,1.2-2.9,1.2c-4.4,0-7.6-1.2-7.6-4.6s2.8-4.3,5.8-4.3,3.9.7,5,1.1c-1.2-2.3-2.1-4-2.4-4.4-3.5,1-6.8,1.2-8.2,1.2s-1.2,0-1.2-1.1.6-1,1.2-1c1.6,0,3.8,0,7.2-.9-.5-.8-1.1-1.8-1.4-2.4-2.6.5-4.3.6-4.7.6s-1.2,0-1.2-1.1.7-1,1.1-1c1.7,0,2.6-.1,3.6-.3-.2-.2-.9-1.4-1.1-1.6-.2-.3-.3-.6-.3-.8,0-.6.5-1,1.1-1s.9.3,2.4,2.9c.4,0,1.9-.8,2.2-.8.7,0,1,.6,1,1.1s-.1.9-2.2,1.5l1.3,2.3Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_1さぬき_xFF1A_紫" v-if="this.clickedPointId === 21">
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M39.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M51.1,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM55.7,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="307.9" x2="63.9" y2="307.9" />
            <g>
              <line class="pn_st2" x1="63.9" y1="307.9" x2="61.4" y2="307.9" />
              <line class="pn_st31" x1="59.3" y1="307.9" x2="59.2" y2="307.9" />
              <line class="pn_st43" x1="59.2" y1="307.9" x2="36.8" y2="307.9" />
              <line class="pn_st2" x1="36.8" y1="307.9" x2="34.3" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M16.1,273.1c-.4-.5-.6-.7-.6-1.1,0-.7.6-1,1.2-1s.8.3,1.3,1.2c.5.7,1.1,1.8,1.6,2.5.4-.2,1.3-.6,2.1-1,.5-.3.9-.5,1.2-.5.6,0,1,.6,1,1.2s-.3.8-1.2,1.3c-.7.3-1.7.7-2.1.9.9,1.5,4.1,6.8,4.1,7.8s-.6,1.2-1.2,1.2-2.6-.9-3-1c-1.4-.5-3-.8-4.2-.8-2.4,0-3.7,1.2-3.7,2.7,0,2.8,3.9,2.8,5.5,2.8.3,0,1.9-.1,2.2-.1.7,0,1.1.4,1.1,1,0,1.2-1.1,1.2-2.7,1.2s-3.8-.2-5-.7c-2.9-1-3.2-3.4-3.2-4.3,0-2.2,1.8-4.6,5.8-4.6s4.1.7,5.9,1.2c-1.3-2.3-1.4-2.5-3.5-5.9-2.5.7-5.1,1.2-7.8,1.2s-1.5,0-1.5-1.1.8-1,1.1-1c2.4,0,4.2,0,7.1-.8-.5-.7-1.3-1.9-1.5-2.2Z"
              />
              <path
                class="pn_st63"
                d="M16.3,299.8c0-.5,0-2.5,0-2.9,0-.9.8-1,1.1-1,1.2,0,1.2.8,1.2,1.6s0,1.2,0,1.8c.3,0,.7,0,1.2,0,3.1,0,6.8,1.7,6.8,7.7s0,2.3-.8,4.2c.8.5,2.2,1.2,2.2,2.1s-.4,1.1-1,1.1-.6-.2-.9-.5c-.6-.5-.8-.6-1.2-.9-1.4,2.1-3.5,2.5-4.6,2.5-2.2,0-3.5-1.2-3.5-2.9s1.7-3,3.9-3,2.1.2,3.2.7c.4-1.1.5-2.2.5-3.3,0-4.2-2.2-5.7-4.8-5.7s-1,0-1.2,0c-.4,2.8-1.2,5.5-2.5,7.9.2.2.4.4.4.8,0,.5-.4,1.1-1,1.1s-.3,0-.5-.1c-1,1.3-2.6,3.1-4.5,3.1s-2.8-.6-2.8-3.4,1.2-4.7,2.6-6.4c-.1-.3-1.4-3.2-1.4-3.9s.6-1,1.2-1,.8.4,1,1.1c0,.4.4,1.3.7,2.2,2-1.8,3.6-2.5,4.7-2.9ZM11,306.3c-1.1,1.6-1.6,3.2-1.6,4.4s0,1.4.9,1.4,2.4-1.7,2.9-2.4c-.9-1.1-1.7-2.2-2.2-3.3ZM14.4,307.7c1.1-2.3,1.5-4.1,1.7-5.7-1.4.6-2.7,1.6-3.7,2.6.3.6,1,1.9,2,3.1ZM20.4,311.3c-1.1,0-1.9.4-1.9,1.1s.7,1.1,1.6,1.1,1.8,0,2.9-1.6c-.6-.3-1.6-.6-2.5-.6Z"
              />
              <path
                class="pn_st63"
                d="M20.3,327.2c.6-.2,1.5-.6,2.2-.9.7-.3,1-.5,1.3-.5.7,0,1,.6,1,1.1s-.4.9-1.2,1.2c-.7.3-1.2.5-2.3.9,1.2,2.1,1.8,3.2,2.4,4.3.3.6.8,1.5.8,2,0,.8-.5,1.2-1.2,1.2s-.6-.1-1.1-.4c-2.3-1.3-4.3-1.4-5.2-1.4-2.7,0-3.8,1.3-3.8,2.4s1.6,2.5,4.8,2.5,2-.1,2.3-.1,1.2,0,1.2,1-1,1.2-2.9,1.2c-4.4,0-7.6-1.2-7.6-4.6s2.8-4.3,5.8-4.3,3.9.7,5,1.1c-1.2-2.3-2.1-4-2.4-4.4-3.5,1-6.8,1.2-8.2,1.2s-1.2,0-1.2-1.1.6-1,1.2-1c1.6,0,3.8,0,7.2-.9-.5-.8-1.1-1.8-1.4-2.4-2.6.5-4.3.6-4.7.6s-1.2,0-1.2-1.1.7-1,1.1-1c1.7,0,2.6-.1,3.6-.3-.2-.2-.9-1.4-1.1-1.6-.2-.3-.3-.6-.3-.8,0-.6.5-1,1.1-1s.9.3,2.4,2.9c.4,0,1.9-.8,2.2-.8.7,0,1,.6,1,1.1s-.1.9-2.2,1.5l1.3,2.3Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_1さぬき_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(21)"
          class="cursor_not_allowed"
        >
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M39.5,285.8c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st71"
              d="M51.1,282.5c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM55.7,281v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M44.5,290.4c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9s.1.2.1.3c0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M57.8,297.5c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="307.9" x2="63.9" y2="307.9" />
            <g>
              <line class="pn_st2" x1="63.9" y1="307.9" x2="61.4" y2="307.9" />
              <line class="pn_st31" x1="59.3" y1="307.9" x2="59.2" y2="307.9" />
              <line class="pn_st43" x1="59.2" y1="307.9" x2="36.8" y2="307.9" />
              <line class="pn_st2" x1="36.8" y1="307.9" x2="34.3" y2="307.9" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M17.3,361.4c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,255.9c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,252.9h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M16.1,273.1c-.4-.5-.6-.7-.6-1.1,0-.7.6-1,1.2-1s.8.3,1.3,1.2c.5.7,1.1,1.8,1.6,2.5.4-.2,1.3-.6,2.1-1,.5-.3.9-.5,1.2-.5.6,0,1,.6,1,1.2s-.3.8-1.2,1.3c-.7.3-1.7.7-2.1.9.9,1.5,4.1,6.8,4.1,7.8s-.6,1.2-1.2,1.2-2.6-.9-3-1c-1.4-.5-3-.8-4.2-.8-2.4,0-3.7,1.2-3.7,2.7,0,2.8,3.9,2.8,5.5,2.8.3,0,1.9-.1,2.2-.1.7,0,1.1.4,1.1,1,0,1.2-1.1,1.2-2.7,1.2s-3.8-.2-5-.7c-2.9-1-3.2-3.4-3.2-4.3,0-2.2,1.8-4.6,5.8-4.6s4.1.7,5.9,1.2c-1.3-2.3-1.4-2.5-3.5-5.9-2.5.7-5.1,1.2-7.8,1.2s-1.5,0-1.5-1.1.8-1,1.1-1c2.4,0,4.2,0,7.1-.8-.5-.7-1.3-1.9-1.5-2.2Z"
              />
              <path
                d="M16.3,299.8c0-.5,0-2.5,0-2.9,0-.9.8-1,1.1-1,1.2,0,1.2.8,1.2,1.6s0,1.2,0,1.8c.3,0,.7,0,1.2,0,3.1,0,6.8,1.7,6.8,7.7s0,2.3-.8,4.2c.8.5,2.2,1.2,2.2,2.1s-.4,1.1-1,1.1-.6-.2-.9-.5c-.6-.5-.8-.6-1.2-.9-1.4,2.1-3.5,2.5-4.6,2.5-2.2,0-3.5-1.2-3.5-2.9s1.7-3,3.9-3,2.1.2,3.2.7c.4-1.1.5-2.2.5-3.3,0-4.2-2.2-5.7-4.8-5.7s-1,0-1.2,0c-.4,2.8-1.2,5.5-2.5,7.9.2.2.4.4.4.8,0,.5-.4,1.1-1,1.1s-.3,0-.5-.1c-1,1.3-2.6,3.1-4.5,3.1s-2.8-.6-2.8-3.4,1.2-4.7,2.6-6.4c-.1-.3-1.4-3.2-1.4-3.9s.6-1,1.2-1,.8.4,1,1.1c0,.4.4,1.3.7,2.2,2-1.8,3.6-2.5,4.7-2.9ZM11,306.3c-1.1,1.6-1.6,3.2-1.6,4.4s0,1.4.9,1.4,2.4-1.7,2.9-2.4c-.9-1.1-1.7-2.2-2.2-3.3ZM14.4,307.7c1.1-2.3,1.5-4.1,1.7-5.7-1.4.6-2.7,1.6-3.7,2.6.3.6,1,1.9,2,3.1ZM20.4,311.3c-1.1,0-1.9.4-1.9,1.1s.7,1.1,1.6,1.1,1.8,0,2.9-1.6c-.6-.3-1.6-.6-2.5-.6Z"
              />
              <path
                d="M20.3,327.2c.6-.2,1.5-.6,2.2-.9.7-.3,1-.5,1.3-.5.7,0,1,.6,1,1.1s-.4.9-1.2,1.2c-.7.3-1.2.5-2.3.9,1.2,2.1,1.8,3.2,2.4,4.3.3.6.8,1.5.8,2,0,.8-.5,1.2-1.2,1.2s-.6-.1-1.1-.4c-2.3-1.3-4.3-1.4-5.2-1.4-2.7,0-3.8,1.3-3.8,2.4s1.6,2.5,4.8,2.5,2-.1,2.3-.1,1.2,0,1.2,1-1,1.2-2.9,1.2c-4.4,0-7.6-1.2-7.6-4.6s2.8-4.3,5.8-4.3,3.9.7,5,1.1c-1.2-2.3-2.1-4-2.4-4.4-3.5,1-6.8,1.2-8.2,1.2s-1.2,0-1.2-1.1.6-1,1.2-1c1.6,0,3.8,0,7.2-.9-.5-.8-1.1-1.8-1.4-2.4-2.6.5-4.3.6-4.7.6s-1.2,0-1.2-1.1.7-1,1.1-1c1.7,0,2.6-.1,3.6-.3-.2-.2-.9-1.4-1.1-1.6-.2-.3-.3-.6-.3-.8,0-.6.5-1,1.1-1s.9.3,2.4,2.9c.4,0,1.9-.8,2.2-.8.7,0,1,.6,1,1.1s-.1.9-2.2,1.5l1.3,2.3Z"
              />
            </g>
          </g>
        </g>
        <g id="_x32_0高松_xFF1A_橙">
          <a @click="sendPointId(20)">
            <g>
              <path
                class="pn_st67"
                d="M17.3,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st57"
                d="M17.3,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <line class="pn_st0" x1="17.3" y1="252.7" x2="17.3" y2="252.7" />
              <g>
                <line class="pn_st10" x1="17.3" y1="252.7" x2="17.3" y2="250.2" />
                <line class="pn_st49" x1="17.3" y1="247.5" x2="17.3" y2="247.5" />
                <line class="pn_st8" x1="17.3" y1="247.5" x2="17.3" y2="238.2" />
                <line class="pn_st10" x1="17.3" y1="238.2" x2="17.3" y2="235.7" />
              </g>
            </g>
            <g class="pn_st60">
              <path
                class="pn_st58"
                d="M35,246.3c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM32.6,241.5c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st58"
                d="M48.1,243.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st58"
                d="M61.5,251c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M27.9,143c.2,0,1,0,1,.9s-.6.9-1,.9H6.8c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM10.1,154.6c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,1.9,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM25.1,149.4c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM23,148.3c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM22.9,159.3c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM20.9,158.3c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.4,0,.6-.2.6-.6v-1.1Z"
                />
                <path
                  d="M11.8,218.6c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.5,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c1.9-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM19.6,205.7c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.5-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-1-1.8-1-2.2,0-.6.7-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.7,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM15.4,207.7c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9,1-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM23.1,197.1c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.6-.3-4.5-8.3-4.5-10.8Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x32_0高松_xFF1A_紫" v-if="this.clickedPointId === 20">
          <g>
            <line class="pn_st0" x1="17.3" y1="252.7" x2="17.3" y2="252.7" />
            <g>
              <line class="pn_st2" x1="17.3" y1="252.7" x2="17.3" y2="250.2" />
              <line class="pn_st51" x1="17.3" y1="247.5" x2="17.3" y2="247.5" />
              <line class="pn_st52" x1="17.3" y1="247.5" x2="17.3" y2="238.2" />
              <line class="pn_st2" x1="17.3" y1="238.2" x2="17.3" y2="235.7" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M35,246.3c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM32.6,241.5c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M48.1,243.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M61.5,251c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <rect
            class="pn_st61"
            x=".3"
            y="126.6"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M27.9,143c.2,0,1,0,1,.9s-.6.9-1,.9H6.8c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM10.1,154.6c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,1.9,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM25.1,149.4c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM23,148.3c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM22.9,159.3c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM20.9,158.3c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.4,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                class="pn_st63"
                d="M11.8,218.6c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.5,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c1.9-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM19.6,205.7c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.5-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-1-1.8-1-2.2,0-.6.7-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.7,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM15.4,207.7c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9,1-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM23.1,197.1c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.6-.3-4.5-8.3-4.5-10.8Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x32_0高松_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(20)"
          class="cursor_not_allowed"
        >
          <g>
            <path
              class="pn_st63"
              d="M17.3,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M17.3,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M17.3,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="252.7" x2="17.3" y2="252.7" />
            <g>
              <line class="pn_st2" x1="17.3" y1="252.7" x2="17.3" y2="250.2" />
              <line class="pn_st51" x1="17.3" y1="247.5" x2="17.3" y2="247.5" />
              <line class="pn_st52" x1="17.3" y1="247.5" x2="17.3" y2="238.2" />
              <line class="pn_st2" x1="17.3" y1="238.2" x2="17.3" y2="235.7" />
            </g>
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M35,246.3c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM32.6,241.5c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st71"
              d="M48.1,243.8c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st71"
              d="M61.5,251c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M27.9,143c.2,0,1,0,1,.9s-.6.9-1,.9H6.8c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM10.1,154.6c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,1.9,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.4-1.1-1.1-1.1h-14.5ZM25.1,149.4c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM23,148.3c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.1.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM22.9,159.3c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM20.9,158.3c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.4,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                d="M11.8,218.6c0,.3,0,1-1,1s-1-.7-1-1v-11.2c-.4,1-1.1,3.1-2.2,4.9-.5,1-.7,1.3-1.2,1.3s-1-.6-1-1.2,0-.4,1-1.8c1.9-3,2.8-5.3,3.5-7.7h-3.2c-.2,0-1,0-1-1s.7-1,1-1h3.2v-4c0-.3,0-1,1-1s1,.5,1,1v4h2.5c.3,0,1,0,1,1s-.7,1-1,1h-2.5v1.2c.7,1.8,1.7,3.5,2.5,4.5.8,1,.9,1.1.9,1.5s-.4,1-1,1-.9-.3-2.4-3.5v11ZM19.6,205.7c.1-.4.2-.9.9-.9s1.1,0,1.1.9-1.9,7.2-3.4,10.7c2.1-.2,5.5-.6,7.2-.8-.3-.8-.8-2.1-1.5-3.3-.2-.4-1-1.8-1-2.2,0-.6.7-.9,1.1-.9s.7,0,1.8,2.3c.7,1.4,2.8,5.9,2.8,6.8s-.9,1-1.2,1c-.7,0-.7-.2-1.4-2.1-1.9.3-9.8,1.5-11.1,1.5s-1-.3-1-1.1.4-.9,2.1-1.1c1.8-3.8,2.9-8.3,3.5-10.8ZM15.4,207.7c-.6,0-1.1-.6-1.1-1s0-.3.3-.7c2.2-3,2.9-5.6,3.5-8.8,0-.4.2-.9,1-.9s1,.2,1,.8c0,2.1-2.9,10.6-4.7,10.6ZM23.1,197.1c0-.8.9-.9,1-.9.7,0,.8.5.9.9.6,3,1.5,6.1,3.4,8.6.3.4.5.6.5,1,0,.8-.7,1.2-1.3,1.1-1.6-.3-4.5-8.3-4.5-10.8Z"
              />
            </g>
          </g>
        </g>
        <g id="_x31_9丸亀_xFF1A_橙">
          <a @click="sendPointId(19)">
            <g>
              <line class="pn_st0" x1="34.4" y1="181.6" x2="34.4" y2="181.6" />
              <g>
                <line class="pn_st10" x1="34.4" y1="181.6" x2="36.9" y2="181.6" />
                <line class="pn_st50" x1="39" y1="181.6" x2="39" y2="181.6" />
                <line class="pn_st55" x1="39" y1="181.6" x2="61.5" y2="181.6" />
                <line class="pn_st10" x1="61.5" y1="181.6" x2="64" y2="181.6" />
              </g>
            </g>
            <g>
              <path
                class="pn_st67"
                d="M81,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st58"
                d="M81,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M84.6,145.5c1.9,0,2.8.6,2.8,2.8v12.6c0,1.1.5,1.1,1.9,1.1s1.3-.1,1.4-4.2c0-.6,0-1.2,1-1.2s1.1.8,1.1,1.2c0,1-.2,4.1-.5,5.1-.5,1.1-1.2,1.1-3.9,1.1s-3-.6-3-2.7v-12.8c0-.7-.3-1.1-1.1-1.1h-4.3c-.2,2.2-.3,4.4-.9,6.7,1.2,1,2.3,1.8,3.7,3.1.4.4.5.6.5,1,0,.6-.5,1.2-1.1,1.2s-.6-.2-1-.5c-.3-.3-1.3-1.3-2.9-2.6-1.2,2.7-3,5.1-5.5,6.9-.5.4-1.6,1.1-2.2,1.1s-1.1-.6-1.1-1.2.3-.8.7-1c1.4-.9,4.7-2.9,6.3-7.1-1.6-1.2-2.3-1.6-4.2-2.7-.2-.2-.6-.3-.6-.9s.5-1,1-1,.4,0,.9.3c1.8,1,2.8,1.6,3.5,2.2.2-1.1.5-3.2.6-5.3h-6.9c-.2,0-1,0-1-1s.8-1,1-1h6.9v-3.2c0-.3,0-1,1-1s1.1.7,1.1,1v3.2h4.8Z"
                />
                <path
                  d="M84.8,197.4c.6,0,1.6,0,1.6,1.1s-1.3,1.7-1.6,1.9h3.5c1.8,0,2.4.5,2.4,2.3v2.2c0,1.8-.5,2.3-2.4,2.3h-6.4v1.2h7.1c1.8,0,2.4.5,2.4,2.3v2.7c0,1.8-.5,2.3-2.4,2.3h-7.1v1.2c0,.2,0,.5.4.6.1,0,4.8,0,5.5,0h1.5c1.1,0,1.3,0,1.4-1.2,0-.8.1-1.3,1-1.3s1.1,0,1.1.9-.2,2.4-.9,2.8c-.5.3-1.1.4-2.4.4h-6.8c-2,0-2.8-.2-2.8-2.3v-1.1h-7c-1.8,0-2.4-.5-2.4-2.3v-2.7c0-1.8.5-2.3,2.4-2.3h7v-1.2h-5.8c-1.9,0-2.4-.5-2.4-2.3v-2.2c0-.2,0-1.1.2-1.6-1.2.5-1.5.6-1.7.6-.6,0-.9-.6-.9-1s.1-.6.6-.8c4.4-1.6,4.9-2,7.1-3.8.3-.2.5-.3.8-.3.5,0,1,.4,1,.8s-.2.5-.4.7h6.3ZM72.6,211.5h7.4v-1.6h-6.7c-.4,0-.6.1-.6.6v1ZM80,214.4v-1.7h-7.4v1c0,.5.2.6.6.6h6.7ZM73.8,203.2h6.2v-1.5h-5.6c-.4,0-.6.2-.6.6v.9ZM73.8,204.4v.9c0,.4.2.6.6.6h5.6v-1.5h-6.2ZM76.6,198.8c-.7.5-1.5,1-2.8,1.5h7.9c.5-.3,1.7-1,1.7-1.3s-.2-.3-.3-.3h-6.4ZM88.6,203.2v-.9c0-.4-.2-.6-.6-.6h-6.1v1.5h6.8ZM88.6,204.4h-6.8v1.5h6.1c.4,0,.6-.2.6-.6v-.9ZM89.4,211.5v-1c0-.4-.2-.6-.6-.6h-6.9v1.6h7.5ZM89.4,212.8h-7.5v1.7h6.9c.4,0,.6-.2.6-.6v-1Z"
                />
              </g>
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st58"
                  d="M39.3,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
                />
                <path
                  class="pn_st58"
                  d="M51,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st58"
                  d="M44.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st58"
                  d="M57.8,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
          </a>
        </g>
        <g id="_x31_9丸亀_xFF1A_紫" v-if="this.clickedPointId === 19">
          <g>
            <line class="pn_st0" x1="34.4" y1="181.6" x2="34.4" y2="181.6" />
            <g>
              <line class="pn_st2" x1="34.4" y1="181.6" x2="36.9" y2="181.6" />
              <line class="pn_st28" x1="39" y1="181.6" x2="39" y2="181.6" />
              <line class="pn_st34" x1="39" y1="181.6" x2="61.5" y2="181.6" />
              <line class="pn_st2" x1="61.5" y1="181.6" x2="64" y2="181.6" />
            </g>
          </g>
          <rect
            class="pn_st61"
            x="64"
            y="126.6"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                class="pn_st63"
                d="M84.6,145.5c1.9,0,2.8.6,2.8,2.8v12.6c0,1.1.5,1.1,1.9,1.1s1.3-.1,1.4-4.2c0-.6,0-1.2,1-1.2s1.1.8,1.1,1.2c0,1-.2,4.1-.5,5.1-.5,1.1-1.2,1.1-3.9,1.1s-3-.6-3-2.7v-12.8c0-.7-.3-1.1-1.1-1.1h-4.3c-.2,2.2-.3,4.4-.9,6.7,1.2,1,2.3,1.8,3.7,3.1.4.4.5.6.5,1,0,.6-.5,1.2-1.1,1.2s-.6-.2-1-.5c-.3-.3-1.3-1.3-2.9-2.6-1.2,2.7-3,5.1-5.5,6.9-.5.4-1.6,1.1-2.2,1.1s-1.1-.6-1.1-1.2.3-.8.7-1c1.4-.9,4.7-2.9,6.3-7.1-1.6-1.2-2.3-1.6-4.2-2.7-.2-.2-.6-.3-.6-.9s.5-1,1-1,.4,0,.9.3c1.8,1,2.8,1.6,3.5,2.2.2-1.1.5-3.2.6-5.3h-6.9c-.2,0-1,0-1-1s.8-1,1-1h6.9v-3.2c0-.3,0-1,1-1s1.1.7,1.1,1v3.2h4.8Z"
              />
              <path
                class="pn_st63"
                d="M84.8,197.4c.6,0,1.6,0,1.6,1.1s-1.3,1.7-1.6,1.9h3.5c1.8,0,2.4.5,2.4,2.3v2.2c0,1.8-.5,2.3-2.4,2.3h-6.4v1.2h7.1c1.8,0,2.4.5,2.4,2.3v2.7c0,1.8-.5,2.3-2.4,2.3h-7.1v1.2c0,.2,0,.5.4.6.1,0,4.8,0,5.5,0h1.5c1.1,0,1.3,0,1.4-1.2,0-.8.1-1.3,1-1.3s1.1,0,1.1.9-.2,2.4-.9,2.8c-.5.3-1.1.4-2.4.4h-6.8c-2,0-2.8-.2-2.8-2.3v-1.1h-7c-1.8,0-2.4-.5-2.4-2.3v-2.7c0-1.8.5-2.3,2.4-2.3h7v-1.2h-5.8c-1.9,0-2.4-.5-2.4-2.3v-2.2c0-.2,0-1.1.2-1.6-1.2.5-1.5.6-1.7.6-.6,0-.9-.6-.9-1s.1-.6.6-.8c4.4-1.6,4.9-2,7.1-3.8.3-.2.5-.3.8-.3.5,0,1,.4,1,.8s-.2.5-.4.7h6.3ZM72.6,211.5h7.4v-1.6h-6.7c-.4,0-.6.1-.6.6v1ZM80,214.4v-1.7h-7.4v1c0,.5.2.6.6.6h6.7ZM73.8,203.2h6.2v-1.5h-5.6c-.4,0-.6.2-.6.6v.9ZM73.8,204.4v.9c0,.4.2.6.6.6h5.6v-1.5h-6.2ZM76.6,198.8c-.7.5-1.5,1-2.8,1.5h7.9c.5-.3,1.7-1,1.7-1.3s-.2-.3-.3-.3h-6.4ZM88.6,203.2v-.9c0-.4-.2-.6-.6-.6h-6.1v1.5h6.8ZM88.6,204.4h-6.8v1.5h6.1c.4,0,.6-.2.6-.6v-.9ZM89.4,211.5v-1c0-.4-.2-.6-.6-.6h-6.9v1.6h7.5ZM89.4,212.8h-7.5v1.7h6.9c.4,0,.6-.2.6-.6v-1Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.3,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M51,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g
          id="_x31_9丸亀_xFF1A_青緑"
          v-if="!this.arrivedPointIdList.includes(19)"
          class="cursor_not_allowed"
        >
          <g>
            <line class="pn_st0" x1="34.4" y1="181.6" x2="34.4" y2="181.6" />
            <g>
              <line class="pn_st2" x1="34.4" y1="181.6" x2="36.9" y2="181.6" />
              <line class="pn_st28" x1="39" y1="181.6" x2="39" y2="181.6" />
              <line class="pn_st34" x1="39" y1="181.6" x2="61.5" y2="181.6" />
              <line class="pn_st2" x1="61.5" y1="181.6" x2="64" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st63"
              d="M81,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st71"
              d="M81,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M81,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M84.6,145.5c1.9,0,2.8.6,2.8,2.8v12.6c0,1.1.5,1.1,1.9,1.1s1.3-.1,1.4-4.2c0-.6,0-1.2,1-1.2s1.1.8,1.1,1.2c0,1-.2,4.1-.5,5.1-.5,1.1-1.2,1.1-3.9,1.1s-3-.6-3-2.7v-12.8c0-.7-.3-1.1-1.1-1.1h-4.3c-.2,2.2-.3,4.4-.9,6.7,1.2,1,2.3,1.8,3.7,3.1.4.4.5.6.5,1,0,.6-.5,1.2-1.1,1.2s-.6-.2-1-.5c-.3-.3-1.3-1.3-2.9-2.6-1.2,2.7-3,5.1-5.5,6.9-.5.4-1.6,1.1-2.2,1.1s-1.1-.6-1.1-1.2.3-.8.7-1c1.4-.9,4.7-2.9,6.3-7.1-1.6-1.2-2.3-1.6-4.2-2.7-.2-.2-.6-.3-.6-.9s.5-1,1-1,.4,0,.9.3c1.8,1,2.8,1.6,3.5,2.2.2-1.1.5-3.2.6-5.3h-6.9c-.2,0-1,0-1-1s.8-1,1-1h6.9v-3.2c0-.3,0-1,1-1s1.1.7,1.1,1v3.2h4.8Z"
              />
              <path
                d="M84.8,197.4c.6,0,1.6,0,1.6,1.1s-1.3,1.7-1.6,1.9h3.5c1.8,0,2.4.5,2.4,2.3v2.2c0,1.8-.5,2.3-2.4,2.3h-6.4v1.2h7.1c1.8,0,2.4.5,2.4,2.3v2.7c0,1.8-.5,2.3-2.4,2.3h-7.1v1.2c0,.2,0,.5.4.6.1,0,4.8,0,5.5,0h1.5c1.1,0,1.3,0,1.4-1.2,0-.8.1-1.3,1-1.3s1.1,0,1.1.9-.2,2.4-.9,2.8c-.5.3-1.1.4-2.4.4h-6.8c-2,0-2.8-.2-2.8-2.3v-1.1h-7c-1.8,0-2.4-.5-2.4-2.3v-2.7c0-1.8.5-2.3,2.4-2.3h7v-1.2h-5.8c-1.9,0-2.4-.5-2.4-2.3v-2.2c0-.2,0-1.1.2-1.6-1.2.5-1.5.6-1.7.6-.6,0-.9-.6-.9-1s.1-.6.6-.8c4.4-1.6,4.9-2,7.1-3.8.3-.2.5-.3.8-.3.5,0,1,.4,1,.8s-.2.5-.4.7h6.3ZM72.6,211.5h7.4v-1.6h-6.7c-.4,0-.6.1-.6.6v1ZM80,214.4v-1.7h-7.4v1c0,.5.2.6.6.6h6.7ZM73.8,203.2h6.2v-1.5h-5.6c-.4,0-.6.2-.6.6v.9ZM73.8,204.4v.9c0,.4.2.6.6.6h5.6v-1.5h-6.2ZM76.6,198.8c-.7.5-1.5,1-2.8,1.5h7.9c.5-.3,1.7-1,1.7-1.3s-.2-.3-.3-.3h-6.4ZM88.6,203.2v-.9c0-.4-.2-.6-.6-.6h-6.1v1.5h6.8ZM88.6,204.4h-6.8v1.5h6.1c.4,0,.6-.2.6-.6v-.9ZM89.4,211.5v-1c0-.4-.2-.6-.6-.6h-6.9v1.6h7.5ZM89.4,212.8h-7.5v1.7h6.9c.4,0,.6-.2.6-.6v-1Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M39.3,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st71"
                d="M51,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st71"
                d="M44.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st71"
                d="M57.8,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </g>
        <g id="_第2ルートグレー" data-name="第2ルートグレー" class="pn_st68">
          <rect
            class="pn_st59"
            x="64"
            y="126.6"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="98.1" y1="181.6" x2="98.1" y2="181.6" />
            <g>
              <line class="pn_st1" x1="98.1" y1="181.6" x2="100.6" y2="181.6" />
              <line class="pn_st21" x1="102.8" y1="181.6" x2="102.8" y2="181.6" />
              <line class="pn_st33" x1="102.8" y1="181.6" x2="125.2" y2="181.6" />
              <line class="pn_st1" x1="125.2" y1="181.6" x2="127.7" y2="181.6" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="127.7"
            y="126.6"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="17.3" y1="252.6" x2="17.3" y2="252.6" />
            <g>
              <line class="pn_st1" x1="17.3" y1="252.6" x2="17.3" y2="250.1" />
              <line class="pn_st11" x1="17.3" y1="247.4" x2="17.3" y2="247.4" />
              <line class="pn_st47" x1="17.3" y1="247.4" x2="17.3" y2="238.2" />
              <line class="pn_st1" x1="17.3" y1="238.2" x2="17.3" y2="235.7" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="127.7"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="161.9" y1="307.9" x2="161.9" y2="307.9" />
            <g>
              <line class="pn_st1" x1="161.9" y1="307.9" x2="164.4" y2="307.9" />
              <line class="pn_st21" x1="166.5" y1="307.9" x2="166.5" y2="307.9" />
              <line class="pn_st33" x1="166.5" y1="307.9" x2="188.9" y2="307.9" />
              <line class="pn_st1" x1="188.9" y1="307.9" x2="191.4" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="191.5"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="225.6" y1="307.9" x2="225.6" y2="307.9" />
            <g>
              <line class="pn_st1" x1="225.6" y1="307.9" x2="228.1" y2="307.9" />
              <line class="pn_st21" x1="230.2" y1="307.9" x2="230.2" y2="307.9" />
              <line class="pn_st33" x1="230.2" y1="307.9" x2="252.6" y2="307.9" />
              <line class="pn_st1" x1="252.6" y1="307.9" x2="255.1" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="255.2"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="289.3" y1="307.9" x2="289.3" y2="307.9" />
            <g>
              <line class="pn_st1" x1="289.3" y1="307.9" x2="291.8" y2="307.9" />
              <line class="pn_st21" x1="293.9" y1="307.9" x2="293.9" y2="307.9" />
              <line class="pn_st33" x1="293.9" y1="307.9" x2="316.3" y2="307.9" />
              <line class="pn_st1" x1="316.3" y1="307.9" x2="318.8" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="318.9"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="353" y1="307.9" x2="353" y2="307.9" />
            <g>
              <line class="pn_st1" x1="353" y1="307.9" x2="355.5" y2="307.9" />
              <line class="pn_st21" x1="357.6" y1="307.9" x2="357.6" y2="307.9" />
              <line class="pn_st33" x1="357.6" y1="307.9" x2="380" y2="307.9" />
              <line class="pn_st1" x1="380" y1="307.9" x2="382.5" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="382.5"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="416.7" y1="307.9" x2="416.7" y2="307.9" />
            <g>
              <line class="pn_st1" x1="416.7" y1="307.9" x2="419.2" y2="307.9" />
              <line class="pn_st21" x1="421.3" y1="307.9" x2="421.3" y2="307.9" />
              <line class="pn_st33" x1="421.3" y1="307.9" x2="443.7" y2="307.9" />
              <line class="pn_st1" x1="443.7" y1="307.9" x2="446.2" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="446.2"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="480.3" y1="307.9" x2="480.3" y2="307.9" />
            <g>
              <line class="pn_st1" x1="480.3" y1="307.9" x2="482.8" y2="307.9" />
              <line class="pn_st21" x1="484.9" y1="307.9" x2="484.9" y2="307.9" />
              <line class="pn_st33" x1="484.9" y1="307.9" x2="507.3" y2="307.9" />
              <line class="pn_st1" x1="507.3" y1="307.9" x2="509.8" y2="307.9" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="510"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="573.7"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="126.6"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="34.4" y1="181.6" x2="34.4" y2="181.6" />
            <g>
              <line class="pn_st1" x1="34.4" y1="181.6" x2="36.9" y2="181.6" />
              <line class="pn_st21" x1="39.1" y1="181.6" x2="39.1" y2="181.6" />
              <line class="pn_st33" x1="39.1" y1="181.6" x2="61.5" y2="181.6" />
              <line class="pn_st1" x1="61.5" y1="181.6" x2="64" y2="181.6" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="64"
            y="252.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <g>
            <line class="pn_st0" x1="98.2" y1="307.9" x2="98.2" y2="307.9" />
            <g>
              <line class="pn_st1" x1="98.2" y1="307.9" x2="100.7" y2="307.9" />
              <line class="pn_st21" x1="102.8" y1="307.9" x2="102.8" y2="307.9" />
              <line class="pn_st33" x1="102.8" y1="307.9" x2="125.2" y2="307.9" />
              <line class="pn_st1" x1="125.2" y1="307.9" x2="127.7" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="686.8" x2="353" y2="686.8" />
            <g>
              <line class="pn_st1" x1="353" y1="686.8" x2="355.5" y2="686.8" />
              <line class="pn_st21" x1="357.6" y1="686.8" x2="357.6" y2="686.8" />
              <line class="pn_st33" x1="357.6" y1="686.8" x2="380.1" y2="686.8" />
              <line class="pn_st1" x1="380.1" y1="686.8" x2="382.6" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.3" y1="686.8" x2="289.3" y2="686.8" />
            <g>
              <line class="pn_st1" x1="289.3" y1="686.8" x2="291.8" y2="686.8" />
              <line class="pn_st21" x1="293.9" y1="686.8" x2="294" y2="686.8" />
              <line class="pn_st33" x1="294" y1="686.8" x2="316.4" y2="686.8" />
              <line class="pn_st1" x1="316.4" y1="686.8" x2="318.9" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="686.8" x2="225.6" y2="686.8" />
            <g>
              <line class="pn_st1" x1="225.6" y1="686.8" x2="228.1" y2="686.8" />
              <line class="pn_st21" x1="230.2" y1="686.8" x2="230.2" y2="686.8" />
              <line class="pn_st33" x1="230.2" y1="686.8" x2="252.6" y2="686.8" />
              <line class="pn_st1" x1="252.6" y1="686.8" x2="255.1" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="686.8" x2="161.9" y2="686.8" />
            <g>
              <line class="pn_st1" x1="161.9" y1="686.8" x2="164.4" y2="686.8" />
              <line class="pn_st21" x1="166.5" y1="686.8" x2="166.5" y2="686.8" />
              <line class="pn_st33" x1="166.5" y1="686.8" x2="188.9" y2="686.8" />
              <line class="pn_st1" x1="188.9" y1="686.8" x2="191.4" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.2" y1="686.8" x2="98.2" y2="686.8" />
            <g>
              <line class="pn_st1" x1="98.2" y1="686.8" x2="100.7" y2="686.8" />
              <line class="pn_st21" x1="102.8" y1="686.8" x2="102.8" y2="686.8" />
              <line class="pn_st33" x1="102.8" y1="686.8" x2="125.2" y2="686.8" />
              <line class="pn_st1" x1="125.2" y1="686.8" x2="127.7" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="686.8" x2="63.9" y2="686.8" />
            <g>
              <line class="pn_st1" x1="63.9" y1="686.8" x2="61.4" y2="686.8" />
              <line class="pn_st26" x1="59.3" y1="686.8" x2="59.2" y2="686.8" />
              <line class="pn_st9" x1="59.2" y1="686.8" x2="36.8" y2="686.8" />
              <line class="pn_st1" x1="36.8" y1="686.8" x2="34.3" y2="686.8" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="631.5" x2="17.3" y2="631.5" />
            <g>
              <line class="pn_st1" x1="17.3" y1="631.5" x2="17.3" y2="629" />
              <line class="pn_st20" x1="17.3" y1="626.4" x2="17.3" y2="626.4" />
              <line class="pn_st40" x1="17.3" y1="626.4" x2="17.3" y2="617" />
              <line class="pn_st1" x1="17.3" y1="617" x2="17.3" y2="614.5" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.1" y1="560.4" x2="98.1" y2="560.4" />
            <g>
              <line class="pn_st1" x1="98.1" y1="560.4" x2="100.6" y2="560.4" />
              <line class="pn_st21" x1="102.7" y1="560.4" x2="102.7" y2="560.4" />
              <line class="pn_st33" x1="102.7" y1="560.4" x2="125.1" y2="560.4" />
              <line class="pn_st1" x1="125.1" y1="560.4" x2="127.6" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.8" y1="560.4" x2="161.8" y2="560.4" />
            <g>
              <line class="pn_st1" x1="161.8" y1="560.4" x2="164.3" y2="560.4" />
              <line class="pn_st21" x1="166.4" y1="560.4" x2="166.4" y2="560.4" />
              <line class="pn_st33" x1="166.4" y1="560.4" x2="188.8" y2="560.4" />
              <line class="pn_st1" x1="188.8" y1="560.4" x2="191.3" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.5" y1="560.4" x2="225.5" y2="560.4" />
            <g>
              <line class="pn_st1" x1="225.5" y1="560.4" x2="228" y2="560.4" />
              <line class="pn_st21" x1="230.1" y1="560.4" x2="230.1" y2="560.4" />
              <line class="pn_st33" x1="230.1" y1="560.4" x2="252.5" y2="560.4" />
              <line class="pn_st1" x1="252.5" y1="560.4" x2="255" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.2" y1="560.4" x2="289.2" y2="560.4" />
            <g>
              <line class="pn_st1" x1="289.2" y1="560.4" x2="291.7" y2="560.4" />
              <line class="pn_st21" x1="293.8" y1="560.4" x2="293.8" y2="560.4" />
              <line class="pn_st33" x1="293.8" y1="560.4" x2="316.2" y2="560.4" />
              <line class="pn_st1" x1="316.2" y1="560.4" x2="318.7" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="352.8" y1="560.4" x2="352.8" y2="560.4" />
            <g>
              <line class="pn_st1" x1="352.8" y1="560.4" x2="355.3" y2="560.4" />
              <line class="pn_st21" x1="357.4" y1="560.4" x2="357.4" y2="560.4" />
              <line class="pn_st33" x1="357.4" y1="560.4" x2="379.8" y2="560.4" />
              <line class="pn_st1" x1="379.8" y1="560.4" x2="382.3" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="416.6" y1="560.4" x2="416.6" y2="560.4" />
            <g>
              <line class="pn_st1" x1="416.6" y1="560.4" x2="419.1" y2="560.4" />
              <line class="pn_st21" x1="421.2" y1="560.4" x2="421.2" y2="560.4" />
              <line class="pn_st33" x1="421.2" y1="560.4" x2="443.6" y2="560.4" />
              <line class="pn_st1" x1="443.6" y1="560.4" x2="446.1" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="480.3" y1="560.4" x2="480.3" y2="560.4" />
            <g>
              <line class="pn_st1" x1="480.3" y1="560.4" x2="482.8" y2="560.4" />
              <line class="pn_st21" x1="484.9" y1="560.4" x2="484.9" y2="560.4" />
              <line class="pn_st33" x1="484.9" y1="560.4" x2="507.3" y2="560.4" />
              <line class="pn_st1" x1="507.3" y1="560.4" x2="509.8" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="560.4" x2="573.7" y2="560.4" />
            <g>
              <line class="pn_st1" x1="573.7" y1="560.4" x2="571.2" y2="560.4" />
              <line class="pn_st54" x1="569" y1="560.4" x2="569" y2="560.4" />
              <line class="pn_st39" x1="569" y1="560.4" x2="546.4" y2="560.4" />
              <line class="pn_st1" x1="546.4" y1="560.4" x2="543.9" y2="560.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="544" y1="434.3" x2="544" y2="434.3" />
            <g>
              <line class="pn_st1" x1="544" y1="434.3" x2="546.5" y2="434.3" />
              <line class="pn_st21" x1="548.6" y1="434.3" x2="548.7" y2="434.3" />
              <line class="pn_st33" x1="548.7" y1="434.3" x2="571.1" y2="434.3" />
              <line class="pn_st1" x1="571.1" y1="434.3" x2="573.6" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="480.4" y1="434.3" x2="480.4" y2="434.3" />
            <g>
              <line class="pn_st1" x1="480.4" y1="434.3" x2="482.9" y2="434.3" />
              <line class="pn_st21" x1="485" y1="434.3" x2="485" y2="434.3" />
              <line class="pn_st33" x1="485" y1="434.3" x2="507.4" y2="434.3" />
              <line class="pn_st1" x1="507.4" y1="434.3" x2="509.9" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="416.7" y1="434.3" x2="416.7" y2="434.3" />
            <g>
              <line class="pn_st1" x1="416.7" y1="434.3" x2="419.2" y2="434.3" />
              <line class="pn_st21" x1="421.3" y1="434.3" x2="421.3" y2="434.3" />
              <line class="pn_st33" x1="421.3" y1="434.3" x2="443.8" y2="434.3" />
              <line class="pn_st1" x1="443.8" y1="434.3" x2="446.3" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="434.3" x2="353" y2="434.3" />
            <g>
              <line class="pn_st1" x1="353" y1="434.3" x2="355.5" y2="434.3" />
              <line class="pn_st21" x1="357.6" y1="434.3" x2="357.6" y2="434.3" />
              <line class="pn_st33" x1="357.6" y1="434.3" x2="380.1" y2="434.3" />
              <line class="pn_st1" x1="380.1" y1="434.3" x2="382.6" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="434.3" x2="225.6" y2="434.3" />
            <g>
              <line class="pn_st1" x1="225.6" y1="434.3" x2="228.1" y2="434.3" />
              <line class="pn_st21" x1="230.2" y1="434.3" x2="230.2" y2="434.3" />
              <line class="pn_st33" x1="230.2" y1="434.3" x2="252.6" y2="434.3" />
              <line class="pn_st1" x1="252.6" y1="434.3" x2="255.1" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="434.3" x2="161.9" y2="434.3" />
            <g>
              <line class="pn_st1" x1="161.9" y1="434.3" x2="164.4" y2="434.3" />
              <line class="pn_st21" x1="166.5" y1="434.3" x2="166.5" y2="434.3" />
              <line class="pn_st33" x1="166.5" y1="434.3" x2="188.9" y2="434.3" />
              <line class="pn_st1" x1="188.9" y1="434.3" x2="191.4" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="434.3" x2="63.9" y2="434.3" />
            <g>
              <line class="pn_st1" x1="63.9" y1="434.3" x2="61.4" y2="434.3" />
              <line class="pn_st26" x1="59.3" y1="434.3" x2="59.2" y2="434.3" />
              <line class="pn_st9" x1="59.2" y1="434.3" x2="36.8" y2="434.3" />
              <line class="pn_st1" x1="36.8" y1="434.3" x2="34.3" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="379" x2="17.3" y2="379" />
            <g>
              <line class="pn_st1" x1="17.3" y1="379" x2="17.3" y2="376.5" />
              <line class="pn_st20" x1="17.3" y1="373.8" x2="17.3" y2="373.8" />
              <line class="pn_st40" x1="17.3" y1="373.8" x2="17.3" y2="364.5" />
              <line class="pn_st1" x1="17.3" y1="364.5" x2="17.3" y2="362" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="34.4" y1="307.9" x2="34.4" y2="307.9" />
            <g>
              <line class="pn_st1" x1="34.4" y1="307.9" x2="36.9" y2="307.9" />
              <line class="pn_st21" x1="39" y1="307.9" x2="39" y2="307.9" />
              <line class="pn_st33" x1="39" y1="307.9" x2="61.5" y2="307.9" />
              <line class="pn_st1" x1="61.5" y1="307.9" x2="64" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.1" y1="307.9" x2="98.1" y2="307.9" />
            <g>
              <line class="pn_st1" x1="98.1" y1="307.9" x2="100.6" y2="307.9" />
              <line class="pn_st21" x1="102.7" y1="307.9" x2="102.7" y2="307.9" />
              <line class="pn_st33" x1="102.7" y1="307.9" x2="125.1" y2="307.9" />
              <line class="pn_st1" x1="125.1" y1="307.9" x2="127.6" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.8" y1="307.9" x2="161.8" y2="307.9" />
            <g>
              <line class="pn_st1" x1="161.8" y1="307.9" x2="164.3" y2="307.9" />
              <line class="pn_st21" x1="166.4" y1="307.9" x2="166.4" y2="307.9" />
              <line class="pn_st33" x1="166.4" y1="307.9" x2="188.8" y2="307.9" />
              <line class="pn_st1" x1="188.8" y1="307.9" x2="191.3" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.5" y1="307.9" x2="225.5" y2="307.9" />
            <g>
              <line class="pn_st1" x1="225.5" y1="307.9" x2="228" y2="307.9" />
              <line class="pn_st21" x1="230.1" y1="307.9" x2="230.1" y2="307.9" />
              <line class="pn_st33" x1="230.1" y1="307.9" x2="252.5" y2="307.9" />
              <line class="pn_st1" x1="252.5" y1="307.9" x2="255" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.2" y1="307.9" x2="289.2" y2="307.9" />
            <g>
              <line class="pn_st1" x1="289.2" y1="307.9" x2="291.7" y2="307.9" />
              <line class="pn_st21" x1="293.8" y1="307.9" x2="293.8" y2="307.9" />
              <line class="pn_st33" x1="293.8" y1="307.9" x2="316.2" y2="307.9" />
              <line class="pn_st1" x1="316.2" y1="307.9" x2="318.7" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="352.8" y1="307.9" x2="352.8" y2="307.9" />
            <g>
              <line class="pn_st1" x1="352.8" y1="307.9" x2="355.3" y2="307.9" />
              <line class="pn_st21" x1="357.4" y1="307.9" x2="357.4" y2="307.9" />
              <line class="pn_st33" x1="357.4" y1="307.9" x2="379.8" y2="307.9" />
              <line class="pn_st1" x1="379.8" y1="307.9" x2="382.3" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="416.6" y1="307.9" x2="416.6" y2="307.9" />
            <g>
              <line class="pn_st1" x1="416.6" y1="307.9" x2="419.1" y2="307.9" />
              <line class="pn_st21" x1="421.2" y1="307.9" x2="421.2" y2="307.9" />
              <line class="pn_st33" x1="421.2" y1="307.9" x2="443.6" y2="307.9" />
              <line class="pn_st1" x1="443.6" y1="307.9" x2="446.1" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="480.3" y1="307.9" x2="480.3" y2="307.9" />
            <g>
              <line class="pn_st1" x1="480.3" y1="307.9" x2="482.8" y2="307.9" />
              <line class="pn_st21" x1="484.9" y1="307.9" x2="484.9" y2="307.9" />
              <line class="pn_st33" x1="484.9" y1="307.9" x2="507.3" y2="307.9" />
              <line class="pn_st1" x1="507.3" y1="307.9" x2="509.8" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="307.9" x2="573.7" y2="307.9" />
            <g>
              <line class="pn_st1" x1="573.7" y1="307.9" x2="571.2" y2="307.9" />
              <line class="pn_st54" x1="569" y1="307.9" x2="569" y2="307.9" />
              <line class="pn_st39" x1="569" y1="307.9" x2="546.4" y2="307.9" />
              <line class="pn_st1" x1="546.4" y1="307.9" x2="543.9" y2="307.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="353" y1="813.3" x2="353" y2="813.3" />
            <g>
              <line class="pn_st1" x1="353" y1="813.3" x2="355.5" y2="813.3" />
              <line class="pn_st21" x1="357.6" y1="813.3" x2="357.6" y2="813.3" />
              <line class="pn_st33" x1="357.6" y1="813.3" x2="380.1" y2="813.3" />
              <line class="pn_st1" x1="380.1" y1="813.3" x2="382.6" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.3" y1="813.3" x2="289.3" y2="813.3" />
            <g>
              <line class="pn_st1" x1="289.3" y1="813.3" x2="291.8" y2="813.3" />
              <line class="pn_st21" x1="293.9" y1="813.3" x2="294" y2="813.3" />
              <line class="pn_st33" x1="294" y1="813.3" x2="316.4" y2="813.3" />
              <line class="pn_st1" x1="316.4" y1="813.3" x2="318.9" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.6" y1="813.3" x2="225.6" y2="813.3" />
            <g>
              <line class="pn_st1" x1="225.6" y1="813.3" x2="228.1" y2="813.3" />
              <line class="pn_st21" x1="230.2" y1="813.3" x2="230.2" y2="813.3" />
              <line class="pn_st33" x1="230.2" y1="813.3" x2="252.6" y2="813.3" />
              <line class="pn_st1" x1="252.6" y1="813.3" x2="255.1" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.9" y1="813.3" x2="161.9" y2="813.3" />
            <g>
              <line class="pn_st1" x1="161.9" y1="813.3" x2="164.4" y2="813.3" />
              <line class="pn_st21" x1="166.5" y1="813.3" x2="166.5" y2="813.3" />
              <line class="pn_st33" x1="166.5" y1="813.3" x2="188.9" y2="813.3" />
              <line class="pn_st1" x1="188.9" y1="813.3" x2="191.4" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.2" y1="813.3" x2="98.2" y2="813.3" />
            <g>
              <line class="pn_st1" x1="98.2" y1="813.3" x2="100.7" y2="813.3" />
              <line class="pn_st21" x1="102.8" y1="813.3" x2="102.8" y2="813.3" />
              <line class="pn_st33" x1="102.8" y1="813.3" x2="125.2" y2="813.3" />
              <line class="pn_st1" x1="125.2" y1="813.3" x2="127.7" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="813.3" x2="63.9" y2="813.3" />
            <g>
              <line class="pn_st1" x1="63.9" y1="813.3" x2="61.4" y2="813.3" />
              <line class="pn_st26" x1="59.3" y1="813.3" x2="59.2" y2="813.3" />
              <line class="pn_st9" x1="59.2" y1="813.3" x2="36.8" y2="813.3" />
              <line class="pn_st1" x1="36.8" y1="813.3" x2="34.3" y2="813.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="758" x2="17.3" y2="758" />
            <g>
              <line class="pn_st1" x1="17.3" y1="758" x2="17.3" y2="755.5" />
              <line class="pn_st20" x1="17.3" y1="752.8" x2="17.3" y2="752.8" />
              <line class="pn_st40" x1="17.3" y1="752.8" x2="17.3" y2="743.5" />
              <line class="pn_st1" x1="17.3" y1="743.5" x2="17.3" y2="741" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="416.6" y1="686.9" x2="416.6" y2="686.9" />
            <g>
              <line class="pn_st1" x1="416.6" y1="686.9" x2="419.1" y2="686.9" />
              <line class="pn_st21" x1="421.2" y1="686.9" x2="421.2" y2="686.9" />
              <line class="pn_st33" x1="421.2" y1="686.9" x2="443.6" y2="686.9" />
              <line class="pn_st1" x1="443.6" y1="686.9" x2="446.1" y2="686.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="480.3" y1="686.9" x2="480.3" y2="686.9" />
            <g>
              <line class="pn_st1" x1="480.3" y1="686.9" x2="482.8" y2="686.9" />
              <line class="pn_st21" x1="484.9" y1="686.9" x2="484.9" y2="686.9" />
              <line class="pn_st33" x1="484.9" y1="686.9" x2="507.3" y2="686.9" />
              <line class="pn_st1" x1="507.3" y1="686.9" x2="509.8" y2="686.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="686.9" x2="573.7" y2="686.9" />
            <g>
              <line class="pn_st1" x1="573.7" y1="686.9" x2="571.2" y2="686.9" />
              <line class="pn_st54" x1="569" y1="686.9" x2="569" y2="686.9" />
              <line class="pn_st39" x1="569" y1="686.9" x2="546.4" y2="686.9" />
              <line class="pn_st1" x1="546.4" y1="686.9" x2="543.9" y2="686.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="615.5" x2="590.7" y2="615.5" />
            <g>
              <line class="pn_st1" x1="590.7" y1="615.5" x2="590.7" y2="618" />
              <line class="pn_st35" x1="590.7" y1="620.6" x2="590.7" y2="620.6" />
              <line class="pn_st32" x1="590.7" y1="620.6" x2="590.7" y2="629.9" />
              <line class="pn_st1" x1="590.7" y1="629.9" x2="590.7" y2="632.4" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="63.9" y1="560.7" x2="63.9" y2="560.7" />
            <g>
              <line class="pn_st1" x1="63.9" y1="560.7" x2="61.4" y2="560.7" />
              <line class="pn_st26" x1="59.3" y1="560.7" x2="59.2" y2="560.7" />
              <line class="pn_st9" x1="59.2" y1="560.7" x2="36.8" y2="560.7" />
              <line class="pn_st1" x1="36.8" y1="560.7" x2="34.3" y2="560.7" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="17.3" y1="505.5" x2="17.3" y2="505.5" />
            <g>
              <line class="pn_st1" x1="17.3" y1="505.5" x2="17.3" y2="503" />
              <line class="pn_st20" x1="17.3" y1="500.3" x2="17.3" y2="500.3" />
              <line class="pn_st40" x1="17.3" y1="500.3" x2="17.3" y2="491" />
              <line class="pn_st1" x1="17.3" y1="491" x2="17.3" y2="488.5" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.1" y1="434.3" x2="98.1" y2="434.3" />
            <g>
              <line class="pn_st1" x1="98.1" y1="434.3" x2="100.6" y2="434.3" />
              <line class="pn_st21" x1="102.7" y1="434.3" x2="102.7" y2="434.3" />
              <line class="pn_st33" x1="102.7" y1="434.3" x2="125.1" y2="434.3" />
              <line class="pn_st1" x1="125.1" y1="434.3" x2="127.6" y2="434.3" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="362.9" x2="590.7" y2="362.9" />
            <g>
              <line class="pn_st1" x1="590.7" y1="362.9" x2="590.7" y2="365.4" />
              <line class="pn_st35" x1="590.7" y1="368.1" x2="590.7" y2="368.1" />
              <line class="pn_st32" x1="590.7" y1="368.1" x2="590.7" y2="377.4" />
              <line class="pn_st1" x1="590.7" y1="377.4" x2="590.7" y2="379.9" />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.2" y1="434.3" x2="289.2" y2="434.3" />
            <g>
              <line class="pn_st1" x1="289.2" y1="434.3" x2="291.7" y2="434.3" />
              <line class="pn_st21" x1="293.8" y1="434.3" x2="293.8" y2="434.3" />
              <line class="pn_st33" x1="293.8" y1="434.3" x2="316.2" y2="434.3" />
              <line class="pn_st1" x1="316.2" y1="434.3" x2="318.7" y2="434.3" />
            </g>
          </g>
          <rect
            class="pn_st59"
            x="382.5"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="318.9"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="255.2"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="191.5"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="127.7"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="64"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="758.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="64"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="127.7"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="191.5"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="255.2"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="318.8"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="382.5"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="446.2"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="510"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="573.7"
            y="631.9"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="573.7"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="510"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="446.2"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="382.5"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="318.9"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="255.2"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="191.5"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="127.7"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="64"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="505.7"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x=".3"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="64"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="127.7"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="191.5"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="255.2"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="318.8"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="382.5"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="446.2"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="510"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
          <rect
            class="pn_st59"
            x="573.7"
            y="379.3"
            width="34"
            height="110"
            rx="17"
            ry="17"
          />
        </g>
      </template>
      <g id="_x31_8坂出_xFF1A_赤">
        <a @click="sendPointId(18)">
          <template v-if="isSecondGoalEnabled">
            <g>
              <line class="pn_st0" x1="98.1" y1="181.6" x2="98.1" y2="181.6" />
              <g>
                <line class="pn_st45" x1="98.1" y1="181.6" x2="100.6" y2="181.6" />
                <line
                  class="pn_st24"
                  x1="102.7"
                  y1="181.6"
                  x2="102.7"
                  y2="181.6"
                />
                <line
                  class="pn_st29"
                  x1="102.7"
                  y1="181.6"
                  x2="125.1"
                  y2="181.6"
                />
                <line
                  class="pn_st45"
                  x1="125.1"
                  y1="181.6"
                  x2="127.6"
                  y2="181.6"
                />
              </g>
            </g>
            <g>
              <path
                class="pn_st69"
                d="M144.7,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
              />
              <path
                class="pn_st66"
                d="M144.7,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
              />
            </g>
            <g>
              <g class="pn_st60">
                <path
                  class="pn_st65"
                  d="M105.9,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
                />
                <path
                  class="pn_st65"
                  d="M119.1,150.1c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM115.8,155c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
                />
              </g>
              <g class="pn_st60">
                <path
                  class="pn_st65"
                  d="M108.2,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
                />
                <path
                  class="pn_st65"
                  d="M121.6,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
                />
              </g>
            </g>
            <g class="pn_st60">
              <g class="pn_st60">
                <path
                  d="M136.4,149.4h-2.4c-.4,0-1,0-1-1s.5-1,1-1h2.4v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h2.1c.2,0,1,0,1,1s-.7,1-1,1h-2.1v8.4c.2,0,1.4-.4,1.6-.5s.7-.2.8-.2c.6,0,.7.4.7.9s-.1.8-1.9,1.4c-.7.2-5,1.6-5.9,1.6s-.9-.6-.9-1.2.3-.8.6-.8c.5-.2,2.5-.6,2.9-.7v-8.9ZM144.5,152.6c0,3.4-.6,8-3.6,11.4-.2.2-.5.4-.8.4-.6,0-1.2-.5-1.2-1s0-.4.3-.8c1.4-1.7,3.2-4.1,3.2-10.1v-7.8c0-2,.7-2.7,2.7-2.7h10.1c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-9.6c-.8,0-1.1.4-1.1,1.1v3h7.8c1.2,0,2.7.1,2.7,2s-1,5.5-3.6,8.9c.5.5,1.5,1.6,4.3,3.2.5.3.6.5.6.8,0,.5-.4,1.3-1.1,1.3s-3-1.5-5.2-3.7c-2.5,2.6-5.2,3.9-5.7,3.9s-1-.7-1-1.1.4-.7.7-.9c2.2-1.2,3.2-1.8,4.8-3.3-2.2-2.9-3.2-6.7-3.2-7.3s.7-.8,1.1-.8.7.4.8.8c.3,1,1,3.5,2.7,5.8,2.4-3.4,2.8-6.4,2.8-6.7,0-.8-.5-.8-1-.8h-7.4v2.6Z"
                />
                <path
                  d="M143.7,207.5h-5.6c-2,0-2.8-.7-2.8-2.8v-5.7c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.4c0,.9.5,1.2,1.2,1.2h5.1v-8.3c0-.3,0-1,1-1s1.1.2,1.1,1v8.3h5.2c.8,0,1.2-.4,1.2-1.2v-5.4c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.7c0,2.1-.8,2.8-2.8,2.8h-5.7v9.5h6.2c.7,0,1.2-.3,1.2-1.2v-5c0-.3,0-1,1-1s1.1.2,1.1,1v5.4c0,2.1-.8,2.8-2.8,2.8h-15.5c-2,0-2.8-.6-2.8-2.8v-5.4c0-.3,0-1,1-1s1.1.3,1.1,1v5c0,.9.5,1.2,1.2,1.2h6.2v-9.5Z"
                />
              </g>
            </g>
          </template>
        </a>
      </g>
      <g id="_x31_8坂出_xFF1A_青" v-if="this.clickedPointId === 18">
        <g>
          <line class="pn_st0" x1="98.1" y1="181.6" x2="98.1" y2="181.6" />
          <g>
            <line class="pn_st1" x1="98.1" y1="181.6" x2="100.6" y2="181.6" />
            <line class="pn_st21" x1="102.7" y1="181.6" x2="102.7" y2="181.6" />
            <line class="pn_st33" x1="102.7" y1="181.6" x2="125.1" y2="181.6" />
            <line class="pn_st1" x1="125.1" y1="181.6" x2="127.6" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="127.7"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M136.4,149.4h-2.4c-.4,0-1,0-1-1s.5-1,1-1h2.4v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h2.1c.2,0,1,0,1,1s-.7,1-1,1h-2.1v8.4c.2,0,1.4-.4,1.6-.5s.7-.2.8-.2c.6,0,.7.4.7.9s-.1.8-1.9,1.4c-.7.2-5,1.6-5.9,1.6s-.9-.6-.9-1.2.3-.8.6-.8c.5-.2,2.5-.6,2.9-.7v-8.9ZM144.5,152.6c0,3.4-.6,8-3.6,11.4-.2.2-.5.4-.8.4-.6,0-1.2-.5-1.2-1s0-.4.3-.8c1.4-1.7,3.2-4.1,3.2-10.1v-7.8c0-2,.7-2.7,2.7-2.7h10.1c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-9.6c-.8,0-1.1.4-1.1,1.1v3h7.8c1.2,0,2.7.1,2.7,2s-1,5.5-3.6,8.9c.5.5,1.5,1.6,4.3,3.2.5.3.6.5.6.8,0,.5-.4,1.3-1.1,1.3s-3-1.5-5.2-3.7c-2.5,2.6-5.2,3.9-5.7,3.9s-1-.7-1-1.1.4-.7.7-.9c2.2-1.2,3.2-1.8,4.8-3.3-2.2-2.9-3.2-6.7-3.2-7.3s.7-.8,1.1-.8.7.4.8.8c.3,1,1,3.5,2.7,5.8,2.4-3.4,2.8-6.4,2.8-6.7,0-.8-.5-.8-1-.8h-7.4v2.6Z"
            />
            <path
              class="pn_st63"
              d="M143.7,207.5h-5.6c-2,0-2.8-.7-2.8-2.8v-5.7c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.4c0,.9.5,1.2,1.2,1.2h5.1v-8.3c0-.3,0-1,1-1s1.1.2,1.1,1v8.3h5.2c.8,0,1.2-.4,1.2-1.2v-5.4c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.7c0,2.1-.8,2.8-2.8,2.8h-5.7v9.5h6.2c.7,0,1.2-.3,1.2-1.2v-5c0-.3,0-1,1-1s1.1.2,1.1,1v5.4c0,2.1-.8,2.8-2.8,2.8h-15.5c-2,0-2.8-.6-2.8-2.8v-5.4c0-.3,0-1,1-1s1.1.3,1.1,1v5c0,.9.5,1.2,1.2,1.2h6.2v-9.5Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_8坂出_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(18)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="98.1" y1="181.6" x2="98.1" y2="181.6" />
          <g>
            <line class="pn_st1" x1="98.1" y1="181.6" x2="100.6" y2="181.6" />
            <line class="pn_st21" x1="102.7" y1="181.6" x2="102.7" y2="181.6" />
            <line class="pn_st33" x1="102.7" y1="181.6" x2="125.1" y2="181.6" />
            <line class="pn_st1" x1="125.1" y1="181.6" x2="127.6" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M144.7,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M144.7,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M144.7,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M136.4,149.4h-2.4c-.4,0-1,0-1-1s.5-1,1-1h2.4v-5.2c0-.3,0-1,1-1s1.1.3,1.1,1v5.2h2.1c.2,0,1,0,1,1s-.7,1-1,1h-2.1v8.4c.2,0,1.4-.4,1.6-.5s.7-.2.8-.2c.6,0,.7.4.7.9s-.1.8-1.9,1.4c-.7.2-5,1.6-5.9,1.6s-.9-.6-.9-1.2.3-.8.6-.8c.5-.2,2.5-.6,2.9-.7v-8.9ZM144.5,152.6c0,3.4-.6,8-3.6,11.4-.2.2-.5.4-.8.4-.6,0-1.2-.5-1.2-1s0-.4.3-.8c1.4-1.7,3.2-4.1,3.2-10.1v-7.8c0-2,.7-2.7,2.7-2.7h10.1c.2,0,1.1,0,1.1,1s-.8,1-1.1,1h-9.6c-.8,0-1.1.4-1.1,1.1v3h7.8c1.2,0,2.7.1,2.7,2s-1,5.5-3.6,8.9c.5.5,1.5,1.6,4.3,3.2.5.3.6.5.6.8,0,.5-.4,1.3-1.1,1.3s-3-1.5-5.2-3.7c-2.5,2.6-5.2,3.9-5.7,3.9s-1-.7-1-1.1.4-.7.7-.9c2.2-1.2,3.2-1.8,4.8-3.3-2.2-2.9-3.2-6.7-3.2-7.3s.7-.8,1.1-.8.7.4.8.8c.3,1,1,3.5,2.7,5.8,2.4-3.4,2.8-6.4,2.8-6.7,0-.8-.5-.8-1-.8h-7.4v2.6Z"
            />
            <path
              d="M143.7,207.5h-5.6c-2,0-2.8-.7-2.8-2.8v-5.7c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.4c0,.9.5,1.2,1.2,1.2h5.1v-8.3c0-.3,0-1,1-1s1.1.2,1.1,1v8.3h5.2c.8,0,1.2-.4,1.2-1.2v-5.4c0-.3,0-1.1,1-1.1s1.1.3,1.1,1.1v5.7c0,2.1-.8,2.8-2.8,2.8h-5.7v9.5h6.2c.7,0,1.2-.3,1.2-1.2v-5c0-.3,0-1,1-1s1.1.2,1.1,1v5.4c0,2.1-.8,2.8-2.8,2.8h-15.5c-2,0-2.8-.6-2.8-2.8v-5.4c0-.3,0-1,1-1s1.1.3,1.1,1v5c0,.9.5,1.2,1.2,1.2h6.2v-9.5Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_7児島_xFF1A_赤">
        <a @click="sendPointId(17)">
          <g>
            <line class="pn_st0" x1="161.8" y1="181.6" x2="161.8" y2="181.6" />
            <g>
              <line class="pn_st45" x1="161.8" y1="181.6" x2="164.3" y2="181.6" />
              <line class="pn_st24" x1="166.4" y1="181.6" x2="166.4" y2="181.6" />
              <line class="pn_st29" x1="166.4" y1="181.6" x2="188.8" y2="181.6" />
              <line class="pn_st45" x1="188.8" y1="181.6" x2="191.3" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M208.5,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M208.5,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M167.4,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M177.9,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M171.9,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M185.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M197.8,162.2c2.9-.8,5.3-1.8,6.1-5.8,0-.2.3-1.4.3-1.6.1-.4.3-.8,1-.8s1,.3,1,.9-.2,1.8-.6,3c-.7,2.3-2,4.6-5.9,6.1-.4.1-1.4.5-1.8.5-1,0-1-1.1-1-1.2,0-.6.1-.8.9-1ZM200.6,153.2c0,.3,0,1-1,1s-1.2-.4-1.2-1v-10.9c0-.3,0-1,1.1-1s1.1.5,1.1,1v10.9ZM218.5,150.7c0,2-.8,2.7-2.7,2.7h-9c-1.8,0-2.7-.6-2.7-2.7v-6.1c0-2,.8-2.7,2.7-2.7h9c1.8,0,2.7.6,2.7,2.7v6.1ZM206.2,146.7h10.2v-1.9c0-.7-.4-1.1-1.1-1.1h-8.1c-.8,0-1,.5-1,1.1v1.9ZM206.2,148.4v2.2c0,.6.2,1.1,1,1.1h8.1c.7,0,1.1-.3,1.1-1.1v-2.2h-10.2ZM212.1,160.9c0,1.1.7,1.1,1.4,1.1,3.1,0,3.4,0,3.7-.2.4-.2.6-.6.7-1.9,0-.5.2-1.3.2-1.5,0-.1.2-.5.8-.5,1.2,0,1.2.8,1.2,1,0,1-.3,3.3-1,4.2-.5.7-.8.7-4.4.7s-2.2,0-2.7,0c-2-.2-2-1.9-2-2.6v-6.5c0-.2,0-1,1-1s1.1.5,1.1,1v6Z"
              />
              <path
                d="M203.5,216.4v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.3ZM201.4,201.5h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM215.2,202.8h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_7児島_xFF1A_青" v-if="this.clickedPointId === 17">
        <g>
          <line class="pn_st0" x1="161.8" y1="181.6" x2="161.8" y2="181.6" />
          <g>
            <line class="pn_st23" x1="161.8" y1="181.6" x2="164.3" y2="181.6" />
            <line class="pn_st30" x1="166.4" y1="181.6" x2="166.4" y2="181.6" />
            <line class="pn_st16" x1="166.4" y1="181.6" x2="188.8" y2="181.6" />
            <line class="pn_st23" x1="188.8" y1="181.6" x2="191.3" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="191.5"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M167.4,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M177.9,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M171.9,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M185.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M197.8,162.2c2.9-.8,5.3-1.8,6.1-5.8,0-.2.3-1.4.3-1.6.1-.4.3-.8,1-.8s1,.3,1,.9-.2,1.8-.6,3c-.7,2.3-2,4.6-5.9,6.1-.4.1-1.4.5-1.8.5-1,0-1-1.1-1-1.2,0-.6.1-.8.9-1ZM200.6,153.2c0,.3,0,1-1,1s-1.2-.4-1.2-1v-10.9c0-.3,0-1,1.1-1s1.1.5,1.1,1v10.9ZM218.5,150.7c0,2-.8,2.7-2.7,2.7h-9c-1.8,0-2.7-.6-2.7-2.7v-6.1c0-2,.8-2.7,2.7-2.7h9c1.8,0,2.7.6,2.7,2.7v6.1ZM206.2,146.7h10.2v-1.9c0-.7-.4-1.1-1.1-1.1h-8.1c-.8,0-1,.5-1,1.1v1.9ZM206.2,148.4v2.2c0,.6.2,1.1,1,1.1h8.1c.7,0,1.1-.3,1.1-1.1v-2.2h-10.2ZM212.1,160.9c0,1.1.7,1.1,1.4,1.1,3.1,0,3.4,0,3.7-.2.4-.2.6-.6.7-1.9,0-.5.2-1.3.2-1.5,0-.1.2-.5.8-.5,1.2,0,1.2.8,1.2,1,0,1-.3,3.3-1,4.2-.5.7-.8.7-4.4.7s-2.2,0-2.7,0c-2-.2-2-1.9-2-2.6v-6.5c0-.2,0-1,1-1s1.1.5,1.1,1v6Z"
            />
            <path
              class="pn_st63"
              d="M203.5,216.4v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.3ZM201.4,201.5h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM215.2,202.8h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_7児島_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(17)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="161.8" y1="181.6" x2="161.8" y2="181.6" />
          <g>
            <line class="pn_st23" x1="161.8" y1="181.6" x2="164.3" y2="181.6" />
            <line class="pn_st30" x1="166.4" y1="181.6" x2="166.4" y2="181.6" />
            <line class="pn_st16" x1="166.4" y1="181.6" x2="188.8" y2="181.6" />
            <line class="pn_st23" x1="188.8" y1="181.6" x2="191.3" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M208.5,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M208.5,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M208.5,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M167.4,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M177.9,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M171.9,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M185.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M197.8,162.2c2.9-.8,5.3-1.8,6.1-5.8,0-.2.3-1.4.3-1.6.1-.4.3-.8,1-.8s1,.3,1,.9-.2,1.8-.6,3c-.7,2.3-2,4.6-5.9,6.1-.4.1-1.4.5-1.8.5-1,0-1-1.1-1-1.2,0-.6.1-.8.9-1ZM200.6,153.2c0,.3,0,1-1,1s-1.2-.4-1.2-1v-10.9c0-.3,0-1,1.1-1s1.1.5,1.1,1v10.9ZM218.5,150.7c0,2-.8,2.7-2.7,2.7h-9c-1.8,0-2.7-.6-2.7-2.7v-6.1c0-2,.8-2.7,2.7-2.7h9c1.8,0,2.7.6,2.7,2.7v6.1ZM206.2,146.7h10.2v-1.9c0-.7-.4-1.1-1.1-1.1h-8.1c-.8,0-1,.5-1,1.1v1.9ZM206.2,148.4v2.2c0,.6.2,1.1,1,1.1h8.1c.7,0,1.1-.3,1.1-1.1v-2.2h-10.2ZM212.1,160.9c0,1.1.7,1.1,1.4,1.1,3.1,0,3.4,0,3.7-.2.4-.2.6-.6.7-1.9,0-.5.2-1.3.2-1.5,0-.1.2-.5.8-.5,1.2,0,1.2.8,1.2,1,0,1-.3,3.3-1,4.2-.5.7-.8.7-4.4.7s-2.2,0-2.7,0c-2-.2-2-1.9-2-2.6v-6.5c0-.2,0-1,1-1s1.1.5,1.1,1v6Z"
            />
            <path
              d="M203.5,216.4v-4.1h-1.9c-1.7,0-2.3-.6-2.3-2.3v-9.6c0-1.7.7-2.3,2.3-2.3h4.9c0-.2.4-1.3.5-1.5,0-.2.2-.5.9-.5s1.1.2,1.1.7-.2.8-.5,1.4h6.4c1.6,0,2.3.5,2.3,2.3v3.3c0,1.7-.7,2.3-2.3,2.3h-13.6v1.5h17.9c.6,0,.9.3.9.8s-.5.8-.9.8h-17.9v.7c0,.6.2.8.8.8h14.3c1.5,0,2.8,0,2.8,2s-.2,2-.3,2.8c-.3,1.6-.6,2.4-1,2.9-.8.9-1.5.9-3.6.9s-1.5,0-1.8,0c-.5-.1-.6-.7-.6-1,0-.9.7-.9.9-.9.3,0,1.9,0,2.2,0s1.3,0,1.7-1c.3-.9.5-2.8.5-3,0-.9-.4-.9-1.2-.9h-10.6v4.1h3.3c.5,0,.8-.2.8-.8v-1.7c0-.7.3-1,1.1-1s1,.7,1,1v1.9c0,1.9-.9,2.3-2.3,2.3h-9.8c-1.6,0-2.3-.5-2.3-2.3v-2c0-.4,0-1,1-1s1.1.7,1.1,1v1.8c0,.5.2.8.8.8h3.3ZM201.4,201.5h13.9v-.9c0-.5-.2-.8-.8-.8h-12.3c-.5,0-.8.3-.8.8v.9ZM215.2,202.8h-13.9v1.8h13.1c.5,0,.8-.3.8-.8v-.9Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_6倉敷_xFF1A_赤">
        <a @click="sendPointId(16)">
          <g>
            <line class="pn_st0" x1="225.5" y1="181.6" x2="225.5" y2="181.6" />
            <g>
              <line class="pn_st45" x1="225.5" y1="181.6" x2="228" y2="181.6" />
              <line class="pn_st24" x1="230.1" y1="181.6" x2="230.1" y2="181.6" />
              <line class="pn_st29" x1="230.1" y1="181.6" x2="252.5" y2="181.6" />
              <line class="pn_st45" x1="252.5" y1="181.6" x2="255" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M272.2,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M272.2,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M230.2,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M242.4,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M235.6,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M249,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M263,151.1c0-1.8.5-2.3,2.3-2.3h13.5c1.8,0,2.3.5,2.3,2.3v2.7c0,1.8-.5,2.3-2.3,2.3h-13.8c0,.9-.2,3.5-1.6,6.4-.2.5-.9,1.8-1.7,1.8s-1.2-.5-1.2-1.1.1-.5,1.1-2c.3-.5,1.5-2.5,1.5-5.9v-4.2ZM267.3,147.6c-1,0-.9-.7-.9-1-.9.4-3.7,1.9-4.9,1.9s-1-.6-1-1.1.4-.8.8-1c3.2-1.2,5.5-2,8.5-4.4,1-.7,1.4-1.1,2.3-1.1s.8,0,1.8.7c2.6,2,4.4,3.1,7.6,4.2,2.2.8,2.3.8,2.3,1.4s-.4,1.2-1.1,1.2c-1.1,0-4.4-1.7-4.9-2,0,.3.2,1.1-.9,1.1h-9.6ZM265,151.7h14.1v-.7c0-.5-.2-.8-.8-.8h-12.5c-.6,0-.8.3-.8.8v.7ZM279.1,153.1h-14.1v1.6h13.3c.6,0,.8-.4.8-.8v-.8ZM281.9,161.7c0,1.8-.6,2.3-2.3,2.3h-11.3c-1.7,0-2.3-.4-2.3-2.3v-2.1c0-1.8.6-2.3,2.3-2.3h11.3c1.8,0,2.3.4,2.3,2.3v2.1ZM276.9,146c-1.8-1.1-3.1-2-4-2.7-.5-.4-.6-.5-.8-.5s-.2,0-.8.6c-1.5,1.2-2.9,2.1-3.8,2.6h9.3ZM279.9,159.8c0-.5-.2-.8-.8-.8h-10.3c-.5,0-.8.3-.8.8v1.7c0,.5.2.8.8.8h10.3c.5,0,.8-.3.8-.8v-1.7Z"
              />
              <path
                d="M282.2,202.2c0,3.4-.6,7.5-2.7,11.2,1.3,1.8,2.5,2.9,3.8,3.8.3.2.5.4.5.9s-.5,1.2-1.1,1.2-.5,0-1.6-1c-.8-.7-1.8-1.7-2.7-3.1-.7.9-1.5,2-2.8,3-.6.5-1.5,1.2-2.1,1.2s-1-.6-1-1.2.2-.6.6-.9c1.3-.9,2.9-1.9,4.2-3.8-1.8-3.4-2.2-6-2.4-7.1-.5.8-1,.8-1,.8-.2,0-.5,0-.8-.4-.1,1.3-.5,1.9-2.4,1.9h-2.5v1.4h4.8c.8,0,1,.4,1,.9s-.2.9-1,.9h-6.2c0,.6-.1.9-.2,1.4h3.4c1.2,0,2.1.2,2.1,1.7s-.2,3.3-1,4c-.5.4-1,.4-2.7.4s-1.8,0-1.8-.9.2-.8.7-.8c.2,0,1.4,0,1.7,0,.4,0,.7,0,.9-.4.2-.3.4-1.4.4-1.7,0-.7-.6-.7-1-.7h-3.2c-.3.6-.9,1.8-2.1,3.1-.5.5-1.5,1.5-2.1,1.5s-1-.5-1-1.1.2-.6.5-.8c.9-.6,3.1-2.2,3.6-5.8h-3.5c-.8,0-1-.4-1-.9s.4-.8,1-.8h4.9v-1.4h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.5c0-1.8.5-2.3,2.3-2.3h2.5v-1.4h-4.9c-.5,0-.9-.2-.9-.8s.7-.8.9-.8h4.9v-1.4c0-.5.2-1,1-1s1,.6,1,1v1.4h4.9c.7,0,.9.3.9.8s-.4.8-.9.8h-4.9v1.4h2.5c1.9,0,2.4.5,2.4,2.3v1.6c.8-1.3.9-1.5,1-1.8,1.3-2.8,1.7-4.8,2-6.2.2-.8.3-1.2,1-1.2s1.1.1,1.1.9-.3,2.1-.6,3.2h5.2c.7,0,1,.4,1,1s-.3,1-.9,1h-.6ZM266.3,202.7h-2.2c-.5,0-.8.3-.8.8v.6h3v-1.4ZM266.3,207.2v-1.6h-3v.8c0,.5.2.8.8.8h2.2ZM268.2,202.7v1.4h3.1v-.6c0-.4-.2-.8-.8-.8h-2.3ZM268.2,207.2h2.3c.7,0,.8-.4.8-.8v-.8h-3.1v1.6ZM271.7,198.3c-.2,0-.3,0-.6-.2-.2-.1-1.2-.5-1.4-.6-.2,0-.3-.3-.3-.5,0-.4.4-.8.8-.8s2.3.6,2.3,1.3-.3.8-.8.8ZM276.8,202.2c-.1.4-.3.8-.7,1.7.2,1.8.5,4.4,2.2,7.7,1.5-2.9,1.9-6.7,2-9.3h-3.6Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_6倉敷_xFF1A_青" v-if="this.clickedPointId === 16">
        <g>
          <line class="pn_st0" x1="225.5" y1="181.6" x2="225.5" y2="181.6" />
          <g>
            <line class="pn_st23" x1="225.5" y1="181.6" x2="228" y2="181.6" />
            <line class="pn_st30" x1="230.1" y1="181.6" x2="230.1" y2="181.6" />
            <line class="pn_st16" x1="230.1" y1="181.6" x2="252.5" y2="181.6" />
            <line class="pn_st23" x1="252.5" y1="181.6" x2="255" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="255.2"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M230.2,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M242.4,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M235.6,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M249,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M263,151.1c0-1.8.5-2.3,2.3-2.3h13.5c1.8,0,2.3.5,2.3,2.3v2.7c0,1.8-.5,2.3-2.3,2.3h-13.8c0,.9-.2,3.5-1.6,6.4-.2.5-.9,1.8-1.7,1.8s-1.2-.5-1.2-1.1.1-.5,1.1-2c.3-.5,1.5-2.5,1.5-5.9v-4.2ZM267.3,147.6c-1,0-.9-.7-.9-1-.9.4-3.7,1.9-4.9,1.9s-1-.6-1-1.1.4-.8.8-1c3.2-1.2,5.5-2,8.5-4.4,1-.7,1.4-1.1,2.3-1.1s.8,0,1.8.7c2.6,2,4.4,3.1,7.6,4.2,2.2.8,2.3.8,2.3,1.4s-.4,1.2-1.1,1.2c-1.1,0-4.4-1.7-4.9-2,0,.3.2,1.1-.9,1.1h-9.6ZM265,151.7h14.1v-.7c0-.5-.2-.8-.8-.8h-12.5c-.6,0-.8.3-.8.8v.7ZM279.1,153.1h-14.1v1.6h13.3c.6,0,.8-.4.8-.8v-.8ZM281.9,161.7c0,1.8-.6,2.3-2.3,2.3h-11.3c-1.7,0-2.3-.4-2.3-2.3v-2.1c0-1.8.6-2.3,2.3-2.3h11.3c1.8,0,2.3.4,2.3,2.3v2.1ZM276.9,146c-1.8-1.1-3.1-2-4-2.7-.5-.4-.6-.5-.8-.5s-.2,0-.8.6c-1.5,1.2-2.9,2.1-3.8,2.6h9.3ZM279.9,159.8c0-.5-.2-.8-.8-.8h-10.3c-.5,0-.8.3-.8.8v1.7c0,.5.2.8.8.8h10.3c.5,0,.8-.3.8-.8v-1.7Z"
            />
            <path
              class="pn_st63"
              d="M282.2,202.2c0,3.4-.6,7.5-2.7,11.2,1.3,1.8,2.5,2.9,3.8,3.8.3.2.5.4.5.9s-.5,1.2-1.1,1.2-.5,0-1.6-1c-.8-.7-1.8-1.7-2.7-3.1-.7.9-1.5,2-2.8,3-.6.5-1.5,1.2-2.1,1.2s-1-.6-1-1.2.2-.6.6-.9c1.3-.9,2.9-1.9,4.2-3.8-1.8-3.4-2.2-6-2.4-7.1-.5.8-1,.8-1,.8-.2,0-.5,0-.8-.4-.1,1.3-.5,1.9-2.4,1.9h-2.5v1.4h4.8c.8,0,1,.4,1,.9s-.2.9-1,.9h-6.2c0,.6-.1.9-.2,1.4h3.4c1.2,0,2.1.2,2.1,1.7s-.2,3.3-1,4c-.5.4-1,.4-2.7.4s-1.8,0-1.8-.9.2-.8.7-.8c.2,0,1.4,0,1.7,0,.4,0,.7,0,.9-.4.2-.3.4-1.4.4-1.7,0-.7-.6-.7-1-.7h-3.2c-.3.6-.9,1.8-2.1,3.1-.5.5-1.5,1.5-2.1,1.5s-1-.5-1-1.1.2-.6.5-.8c.9-.6,3.1-2.2,3.6-5.8h-3.5c-.8,0-1-.4-1-.9s.4-.8,1-.8h4.9v-1.4h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.5c0-1.8.5-2.3,2.3-2.3h2.5v-1.4h-4.9c-.5,0-.9-.2-.9-.8s.7-.8.9-.8h4.9v-1.4c0-.5.2-1,1-1s1,.6,1,1v1.4h4.9c.7,0,.9.3.9.8s-.4.8-.9.8h-4.9v1.4h2.5c1.9,0,2.4.5,2.4,2.3v1.6c.8-1.3.9-1.5,1-1.8,1.3-2.8,1.7-4.8,2-6.2.2-.8.3-1.2,1-1.2s1.1.1,1.1.9-.3,2.1-.6,3.2h5.2c.7,0,1,.4,1,1s-.3,1-.9,1h-.6ZM266.3,202.7h-2.2c-.5,0-.8.3-.8.8v.6h3v-1.4ZM266.3,207.2v-1.6h-3v.8c0,.5.2.8.8.8h2.2ZM268.2,202.7v1.4h3.1v-.6c0-.4-.2-.8-.8-.8h-2.3ZM268.2,207.2h2.3c.7,0,.8-.4.8-.8v-.8h-3.1v1.6ZM271.7,198.3c-.2,0-.3,0-.6-.2-.2-.1-1.2-.5-1.4-.6-.2,0-.3-.3-.3-.5,0-.4.4-.8.8-.8s2.3.6,2.3,1.3-.3.8-.8.8ZM276.8,202.2c-.1.4-.3.8-.7,1.7.2,1.8.5,4.4,2.2,7.7,1.5-2.9,1.9-6.7,2-9.3h-3.6Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_6倉敷_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(16)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="225.5" y1="181.6" x2="225.5" y2="181.6" />
          <g>
            <line class="pn_st23" x1="225.5" y1="181.6" x2="228" y2="181.6" />
            <line class="pn_st30" x1="230.1" y1="181.6" x2="230.1" y2="181.6" />
            <line class="pn_st16" x1="230.1" y1="181.6" x2="252.5" y2="181.6" />
            <line class="pn_st23" x1="252.5" y1="181.6" x2="255" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M272.2,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M272.2,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M272.2,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M230.2,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M242.4,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M235.6,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M249,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M263,151.1c0-1.8.5-2.3,2.3-2.3h13.5c1.8,0,2.3.5,2.3,2.3v2.7c0,1.8-.5,2.3-2.3,2.3h-13.8c0,.9-.2,3.5-1.6,6.4-.2.5-.9,1.8-1.7,1.8s-1.2-.5-1.2-1.1.1-.5,1.1-2c.3-.5,1.5-2.5,1.5-5.9v-4.2ZM267.3,147.6c-1,0-.9-.7-.9-1-.9.4-3.7,1.9-4.9,1.9s-1-.6-1-1.1.4-.8.8-1c3.2-1.2,5.5-2,8.5-4.4,1-.7,1.4-1.1,2.3-1.1s.8,0,1.8.7c2.6,2,4.4,3.1,7.6,4.2,2.2.8,2.3.8,2.3,1.4s-.4,1.2-1.1,1.2c-1.1,0-4.4-1.7-4.9-2,0,.3.2,1.1-.9,1.1h-9.6ZM265,151.7h14.1v-.7c0-.5-.2-.8-.8-.8h-12.5c-.6,0-.8.3-.8.8v.7ZM279.1,153.1h-14.1v1.6h13.3c.6,0,.8-.4.8-.8v-.8ZM281.9,161.7c0,1.8-.6,2.3-2.3,2.3h-11.3c-1.7,0-2.3-.4-2.3-2.3v-2.1c0-1.8.6-2.3,2.3-2.3h11.3c1.8,0,2.3.4,2.3,2.3v2.1ZM276.9,146c-1.8-1.1-3.1-2-4-2.7-.5-.4-.6-.5-.8-.5s-.2,0-.8.6c-1.5,1.2-2.9,2.1-3.8,2.6h9.3ZM279.9,159.8c0-.5-.2-.8-.8-.8h-10.3c-.5,0-.8.3-.8.8v1.7c0,.5.2.8.8.8h10.3c.5,0,.8-.3.8-.8v-1.7Z"
            />
            <path
              d="M282.2,202.2c0,3.4-.6,7.5-2.7,11.2,1.3,1.8,2.5,2.9,3.8,3.8.3.2.5.4.5.9s-.5,1.2-1.1,1.2-.5,0-1.6-1c-.8-.7-1.8-1.7-2.7-3.1-.7.9-1.5,2-2.8,3-.6.5-1.5,1.2-2.1,1.2s-1-.6-1-1.2.2-.6.6-.9c1.3-.9,2.9-1.9,4.2-3.8-1.8-3.4-2.2-6-2.4-7.1-.5.8-1,.8-1,.8-.2,0-.5,0-.8-.4-.1,1.3-.5,1.9-2.4,1.9h-2.5v1.4h4.8c.8,0,1,.4,1,.9s-.2.9-1,.9h-6.2c0,.6-.1.9-.2,1.4h3.4c1.2,0,2.1.2,2.1,1.7s-.2,3.3-1,4c-.5.4-1,.4-2.7.4s-1.8,0-1.8-.9.2-.8.7-.8c.2,0,1.4,0,1.7,0,.4,0,.7,0,.9-.4.2-.3.4-1.4.4-1.7,0-.7-.6-.7-1-.7h-3.2c-.3.6-.9,1.8-2.1,3.1-.5.5-1.5,1.5-2.1,1.5s-1-.5-1-1.1.2-.6.5-.8c.9-.6,3.1-2.2,3.6-5.8h-3.5c-.8,0-1-.4-1-.9s.4-.8,1-.8h4.9v-1.4h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.5c0-1.8.5-2.3,2.3-2.3h2.5v-1.4h-4.9c-.5,0-.9-.2-.9-.8s.7-.8.9-.8h4.9v-1.4c0-.5.2-1,1-1s1,.6,1,1v1.4h4.9c.7,0,.9.3.9.8s-.4.8-.9.8h-4.9v1.4h2.5c1.9,0,2.4.5,2.4,2.3v1.6c.8-1.3.9-1.5,1-1.8,1.3-2.8,1.7-4.8,2-6.2.2-.8.3-1.2,1-1.2s1.1.1,1.1.9-.3,2.1-.6,3.2h5.2c.7,0,1,.4,1,1s-.3,1-.9,1h-.6ZM266.3,202.7h-2.2c-.5,0-.8.3-.8.8v.6h3v-1.4ZM266.3,207.2v-1.6h-3v.8c0,.5.2.8.8.8h2.2ZM268.2,202.7v1.4h3.1v-.6c0-.4-.2-.8-.8-.8h-2.3ZM268.2,207.2h2.3c.7,0,.8-.4.8-.8v-.8h-3.1v1.6ZM271.7,198.3c-.2,0-.3,0-.6-.2-.2-.1-1.2-.5-1.4-.6-.2,0-.3-.3-.3-.5,0-.4.4-.8.8-.8s2.3.6,2.3,1.3-.3.8-.8.8ZM276.8,202.2c-.1.4-.3.8-.7,1.7.2,1.8.5,4.4,2.2,7.7,1.5-2.9,1.9-6.7,2-9.3h-3.6Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_5岡山_xFF1A_赤">
        <a @click="sendPointId(15)">
          <g>
            <line class="pn_st0" x1="289.2" y1="181.6" x2="289.2" y2="181.6" />
            <g>
              <line class="pn_st45" x1="289.2" y1="181.6" x2="291.7" y2="181.6" />
              <line class="pn_st24" x1="293.8" y1="181.6" x2="293.8" y2="181.6" />
              <line class="pn_st29" x1="293.8" y1="181.6" x2="316.2" y2="181.6" />
              <line class="pn_st45" x1="316.2" y1="181.6" x2="318.7" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M335.8,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M335.8,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M327.2,164.6c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1-.6-.3-.6-1c0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM336.7,160.1h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.8.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.3,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
              />
              <path
                d="M334.7,198.4c0-.3,0-1,1.1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M294,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M306,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M299.3,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M312.6,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_5岡山_xFF1A_青" v-if="this.clickedPointId === 15">
        <g>
          <line class="pn_st0" x1="289.2" y1="181.6" x2="289.2" y2="181.6" />
          <g>
            <line class="pn_st23" x1="289.2" y1="181.6" x2="291.7" y2="181.6" />
            <line class="pn_st30" x1="293.8" y1="181.6" x2="293.8" y2="181.6" />
            <line class="pn_st16" x1="293.8" y1="181.6" x2="316.2" y2="181.6" />
            <line class="pn_st23" x1="316.2" y1="181.6" x2="318.7" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="318.8"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M327.2,164.6c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1-.6-.3-.6-1c0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM336.7,160.1h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.8.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.3,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
            />
            <path
              class="pn_st63"
              d="M334.7,198.4c0-.3,0-1,1.1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
            />
          </g>
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M294,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M306,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M299.3,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M312.6,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_5岡山_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(15)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="289.2" y1="181.6" x2="289.2" y2="181.6" />
          <g>
            <line class="pn_st23" x1="289.2" y1="181.6" x2="291.7" y2="181.6" />
            <line class="pn_st30" x1="293.8" y1="181.6" x2="293.8" y2="181.6" />
            <line class="pn_st16" x1="293.8" y1="181.6" x2="316.2" y2="181.6" />
            <line class="pn_st23" x1="316.2" y1="181.6" x2="318.7" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M335.8,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M335.8,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M335.8,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M327.2,164.6c0,.3,0,1-1,1s-1-.6-1-1v-18c0-2.4.9-3.2,3.2-3.2h14.9c2.3,0,3.2.8,3.2,3.2v15.8c0,3.2-1.5,3.2-4.3,3.2s-1.4,0-1.7-.1-.6-.3-.6-1c0-1,.7-1,1.4-1s1.7,0,1.9,0c1.1,0,1.2-1,1.2-1.5v-15.2c0-1.1-.6-1.5-1.5-1.5h-14.4c-1.1,0-1.5.5-1.5,1.5v17.9ZM336.7,160.1h2.4c.8,0,1.1-.3,1.1-1.1v-4.8c0-.3,0-1,1-1s1,.6,1,1v5c0,2-.7,2.7-2.7,2.7h-7.3c-1.9,0-2.7-.6-2.7-2.7v-5c0-.3,0-1,1-1s1,.6,1,1v4.8c0,.7.3,1.1,1.1,1.1h2.3v-8.4h-5.8c-.2,0-1,0-1-.9s.5-.9,1-.9h3c-.3-.9-.4-1-1-2.8,0-.2,0-.3,0-.4,0-.6.6-.8,1.1-.8s.8.3.8.5c.3.6.9,2.2,1.3,3.5h3.3c.6-1.2.8-1.8,1.2-3.2.1-.4.3-.9,1-.9s1.1.3,1.1.9-1,2.6-1.2,3.2h3.2c.3,0,.9,0,.9.9s-.6.9-1,.9h-5.9v8.4Z"
            />
            <path
              d="M334.7,198.4c0-.3,0-1,1.1-1s1.2.4,1.2,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.1.4,1.1,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
            />
          </g>
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M294,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M306,149.1c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M299.3,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M312.6,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_4瀬戸内_xFF1A_赤">
        <a @click="sendPointId(14)">
          <g>
            <line class="pn_st0" x1="352.8" y1="181.6" x2="352.8" y2="181.6" />
            <g>
              <line class="pn_st45" x1="352.8" y1="181.6" x2="355.3" y2="181.6" />
              <line class="pn_st24" x1="357.4" y1="181.6" x2="357.4" y2="181.6" />
              <line class="pn_st29" x1="357.4" y1="181.6" x2="379.8" y2="181.6" />
              <line class="pn_st45" x1="379.8" y1="181.6" x2="382.3" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M399.5,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M399.5,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M360.8,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st65"
                d="M369.7,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M363,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M376.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M389.8,151c-.2-.1-1.4-.9-1.6-1-.2-.2-.4-.3-.4-.7s.4-1.1,1-1.1,1.7.8,2.2,1.2c1,.7,1.1.9,1.1,1.2s-.4,1-.9,1.1c-.3,0-.4,0-1.5-.8ZM392.3,156c0,.5-.6,2.7-1.8,5.9-.7,2-.9,2.2-1.5,2.2s-1.1-.4-1.1-1,0-.4.2-.8c1.2-2.5,1.5-3.8,2.1-6.1.1-.5.3-1.1,1-1.1s1.1.2,1.1.9ZM391.6,145.2c-.3,0-.4,0-1.5-.9-.2-.1-1.2-.9-1.4-1-.2-.2-.3-.5-.3-.6,0-.5.4-1.1,1-1.1s.7.2,1.7,1c.8.5.9.7,1.1.8.2.2.3.3.3.5,0,.6-.5,1.3-1,1.3ZM396.5,157.6c-1.2,2.2-2,3.3-2.6,4-1,1.2-1.1,1.2-1.4,1.2-.5,0-1-.5-1-1s.1-.5.4-.8c1.8-1.8,3.3-4,4.4-6.3h-.8c-1.9,0-2.3-.6-2.3-2.4v-2.3c0-1.8.5-2.3,2.3-2.3h1v-2.1h-2.7c-.3,0-1,0-1-.9s.7-.9,1-.9h2.7v-1.8c0-.7.3-.9.9-.9s.9.4.9.9v1.8h2.7c.6,0,1,.2,1,.9s-.6.9-1,.9h-2.7v2.1h1c1.9,0,2.4.5,2.4,2.3v2.3c0,1.9-.5,2.4-2.4,2.4h-.8c.6.9,1.4,2.2,2.8,3.5.8.8.9.8.9,1.1,0,.5-.5,1-.9,1s-.5-.2-1-.8c-.4-.5-1.1-1.4-1.9-2.6v6.6c0,.3,0,1-.9,1s-.9-.7-.9-.9v-6ZM396.5,149.3h-1.3c-.4,0-.6.2-.6.6v2.5c0,.4.2.6.6.6h1.3v-3.8ZM398.2,149.3v3.8h1.3c.4,0,.6-.2.6-.6v-2.5c0-.4-.2-.6-.6-.6h-1.3ZM403.8,162.9c-.5.5-1.5,1.5-2.1,1.5s-.9-.4-.9-1,0-.5,1.1-1.2c.8-.6,1.3-1.2,2-1.8.2-.2.4-.3.6-.3.4,0,.9.3.9,1s-1.1,1.5-1.6,1.9ZM402.7,143.9c-.3,0-1,0-1-.9s.7-.9,1-.9h7.5c.2,0,.9,0,.9.9s-.6.9-.9.9h-2.7c-.1.6-.4,1.4-.5,2.1h1.2c1.7,0,2.2.5,2.2,2.3v8.8c0,1.8-.4,2.3-2.2,2.3h-3.1c-1.7,0-2.2-.5-2.2-2.3v-8.8c0-2,.6-2.3,2.3-2.3.2-1,.3-1.2.4-2.1h-3ZM404.6,149.9h4v-1.6c0-.5-.2-.8-.8-.8h-2.4c-.6,0-.8.3-.8.8v1.6ZM408.6,151.4h-4v2.3h4v-2.3ZM404.6,155.3v1.7c0,.5.2.8.8.8h2.4c.6,0,.8-.3.8-.8v-1.7h-4ZM407.9,160c.3,0,.4,0,1,.8.6.7,1.1,1.1,1.7,1.7.2.2.5.5.5.8,0,.5-.4,1-.9,1s-1.1-.7-2-1.6c-.7-.7-1.3-1.4-1.3-1.8s.5-.9,1-.9Z"
              />
              <path
                d="M390.2,177c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM410.2,169.6c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM392.4,181.4h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
              />
              <path
                d="M392.4,201.9c-.9,0-1.3.5-1.3,1.2v15.2c0,.3,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-15c0-2.8.8-3.5,3.5-3.5h5.9v-2.7c0-.3,0-1,1-1s1.2.2,1.2,1v2.7h5.9c2.6,0,3.5.7,3.5,3.5v12.4c0,3.3-1.6,3.5-3.7,3.5s-2.5,0-2.8-.1c-.3-.1-.5-.5-.5-1,0-.9.7-1,1.3-1s2.2,0,2.6,0c.7,0,1-.6,1-1.2v-12.7c0-.8-.5-1.2-1.3-1.2h-5.9c.8,5.2,4.4,8.2,6.1,9.7.4.3.5.5.5.9,0,.6-.5,1.2-1.1,1.2s-.6,0-1.6-1c-3.5-3.1-4.7-6.3-5.1-7.5-.8,2.5-1.8,4.3-3.2,5.8-1,1.1-3,2.7-3.8,2.7s-1.1-.7-1.1-1.2.3-.8.7-1c2-1.3,3.8-2.6,5.1-6.1.4-1.1.7-2.2.9-3.4h-5.9Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_4瀬戸内_xFF1A_青" v-if="this.clickedPointId === 14">
        <g>
          <line class="pn_st0" x1="352.8" y1="181.6" x2="352.8" y2="181.6" />
          <g>
            <line class="pn_st23" x1="352.8" y1="181.6" x2="355.3" y2="181.6" />
            <line class="pn_st30" x1="357.4" y1="181.6" x2="357.4" y2="181.6" />
            <line class="pn_st16" x1="357.4" y1="181.6" x2="379.8" y2="181.6" />
            <line class="pn_st23" x1="379.8" y1="181.6" x2="382.3" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="382.5"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M360.8,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st70"
              d="M369.7,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M363,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M376.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M389.8,151c-.2-.1-1.4-.9-1.6-1-.2-.2-.4-.3-.4-.7s.4-1.1,1-1.1,1.7.8,2.2,1.2c1,.7,1.1.9,1.1,1.2s-.4,1-.9,1.1c-.3,0-.4,0-1.5-.8ZM392.3,156c0,.5-.6,2.7-1.8,5.9-.7,2-.9,2.2-1.5,2.2s-1.1-.4-1.1-1,0-.4.2-.8c1.2-2.5,1.5-3.8,2.1-6.1.1-.5.3-1.1,1-1.1s1.1.2,1.1.9ZM391.6,145.2c-.3,0-.4,0-1.5-.9-.2-.1-1.2-.9-1.4-1-.2-.2-.3-.5-.3-.6,0-.5.4-1.1,1-1.1s.7.2,1.7,1c.8.5.9.7,1.1.8.2.2.3.3.3.5,0,.6-.5,1.3-1,1.3ZM396.5,157.6c-1.2,2.2-2,3.3-2.6,4-1,1.2-1.1,1.2-1.4,1.2-.5,0-1-.5-1-1s.1-.5.4-.8c1.8-1.8,3.3-4,4.4-6.3h-.8c-1.9,0-2.3-.6-2.3-2.4v-2.3c0-1.8.5-2.3,2.3-2.3h1v-2.1h-2.7c-.3,0-1,0-1-.9s.7-.9,1-.9h2.7v-1.8c0-.7.3-.9.9-.9s.9.4.9.9v1.8h2.7c.6,0,1,.2,1,.9s-.6.9-1,.9h-2.7v2.1h1c1.9,0,2.4.5,2.4,2.3v2.3c0,1.9-.5,2.4-2.4,2.4h-.8c.6.9,1.4,2.2,2.8,3.5.8.8.9.8.9,1.1,0,.5-.5,1-.9,1s-.5-.2-1-.8c-.4-.5-1.1-1.4-1.9-2.6v6.6c0,.3,0,1-.9,1s-.9-.7-.9-.9v-6ZM396.5,149.3h-1.3c-.4,0-.6.2-.6.6v2.5c0,.4.2.6.6.6h1.3v-3.8ZM398.2,149.3v3.8h1.3c.4,0,.6-.2.6-.6v-2.5c0-.4-.2-.6-.6-.6h-1.3ZM403.8,162.9c-.5.5-1.5,1.5-2.1,1.5s-.9-.4-.9-1,0-.5,1.1-1.2c.8-.6,1.3-1.2,2-1.8.2-.2.4-.3.6-.3.4,0,.9.3.9,1s-1.1,1.5-1.6,1.9ZM402.7,143.9c-.3,0-1,0-1-.9s.7-.9,1-.9h7.5c.2,0,.9,0,.9.9s-.6.9-.9.9h-2.7c-.1.6-.4,1.4-.5,2.1h1.2c1.7,0,2.2.5,2.2,2.3v8.8c0,1.8-.4,2.3-2.2,2.3h-3.1c-1.7,0-2.2-.5-2.2-2.3v-8.8c0-2,.6-2.3,2.3-2.3.2-1,.3-1.2.4-2.1h-3ZM404.6,149.9h4v-1.6c0-.5-.2-.8-.8-.8h-2.4c-.6,0-.8.3-.8.8v1.6ZM408.6,151.4h-4v2.3h4v-2.3ZM404.6,155.3v1.7c0,.5.2.8.8.8h2.4c.6,0,.8-.3.8-.8v-1.7h-4ZM407.9,160c.3,0,.4,0,1,.8.6.7,1.1,1.1,1.7,1.7.2.2.5.5.5.8,0,.5-.4,1-.9,1s-1.1-.7-2-1.6c-.7-.7-1.3-1.4-1.3-1.8s.5-.9,1-.9Z"
            />
            <path
              class="pn_st63"
              d="M390.2,177c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM410.2,169.6c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM392.4,181.4h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
            />
            <path
              class="pn_st63"
              d="M392.4,201.9c-.9,0-1.3.5-1.3,1.2v15.2c0,.3,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-15c0-2.8.8-3.5,3.5-3.5h5.9v-2.7c0-.3,0-1,1-1s1.2.2,1.2,1v2.7h5.9c2.6,0,3.5.7,3.5,3.5v12.4c0,3.3-1.6,3.5-3.7,3.5s-2.5,0-2.8-.1c-.3-.1-.5-.5-.5-1,0-.9.7-1,1.3-1s2.2,0,2.6,0c.7,0,1-.6,1-1.2v-12.7c0-.8-.5-1.2-1.3-1.2h-5.9c.8,5.2,4.4,8.2,6.1,9.7.4.3.5.5.5.9,0,.6-.5,1.2-1.1,1.2s-.6,0-1.6-1c-3.5-3.1-4.7-6.3-5.1-7.5-.8,2.5-1.8,4.3-3.2,5.8-1,1.1-3,2.7-3.8,2.7s-1.1-.7-1.1-1.2.3-.8.7-1c2-1.3,3.8-2.6,5.1-6.1.4-1.1.7-2.2.9-3.4h-5.9Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_4瀬戸内_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(14)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="352.8" y1="181.6" x2="352.8" y2="181.6" />
          <g>
            <line class="pn_st23" x1="352.8" y1="181.6" x2="355.3" y2="181.6" />
            <line class="pn_st30" x1="357.4" y1="181.6" x2="357.4" y2="181.6" />
            <line class="pn_st16" x1="357.4" y1="181.6" x2="379.8" y2="181.6" />
            <line class="pn_st23" x1="379.8" y1="181.6" x2="382.3" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M399.5,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M399.5,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M399.5,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M360.8,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st70"
              d="M369.7,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M363,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M376.3,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M389.8,151c-.2-.1-1.4-.9-1.6-1-.2-.2-.4-.3-.4-.7s.4-1.1,1-1.1,1.7.8,2.2,1.2c1,.7,1.1.9,1.1,1.2s-.4,1-.9,1.1c-.3,0-.4,0-1.5-.8ZM392.3,156c0,.5-.6,2.7-1.8,5.9-.7,2-.9,2.2-1.5,2.2s-1.1-.4-1.1-1,0-.4.2-.8c1.2-2.5,1.5-3.8,2.1-6.1.1-.5.3-1.1,1-1.1s1.1.2,1.1.9ZM391.6,145.2c-.3,0-.4,0-1.5-.9-.2-.1-1.2-.9-1.4-1-.2-.2-.3-.5-.3-.6,0-.5.4-1.1,1-1.1s.7.2,1.7,1c.8.5.9.7,1.1.8.2.2.3.3.3.5,0,.6-.5,1.3-1,1.3ZM396.5,157.6c-1.2,2.2-2,3.3-2.6,4-1,1.2-1.1,1.2-1.4,1.2-.5,0-1-.5-1-1s.1-.5.4-.8c1.8-1.8,3.3-4,4.4-6.3h-.8c-1.9,0-2.3-.6-2.3-2.4v-2.3c0-1.8.5-2.3,2.3-2.3h1v-2.1h-2.7c-.3,0-1,0-1-.9s.7-.9,1-.9h2.7v-1.8c0-.7.3-.9.9-.9s.9.4.9.9v1.8h2.7c.6,0,1,.2,1,.9s-.6.9-1,.9h-2.7v2.1h1c1.9,0,2.4.5,2.4,2.3v2.3c0,1.9-.5,2.4-2.4,2.4h-.8c.6.9,1.4,2.2,2.8,3.5.8.8.9.8.9,1.1,0,.5-.5,1-.9,1s-.5-.2-1-.8c-.4-.5-1.1-1.4-1.9-2.6v6.6c0,.3,0,1-.9,1s-.9-.7-.9-.9v-6ZM396.5,149.3h-1.3c-.4,0-.6.2-.6.6v2.5c0,.4.2.6.6.6h1.3v-3.8ZM398.2,149.3v3.8h1.3c.4,0,.6-.2.6-.6v-2.5c0-.4-.2-.6-.6-.6h-1.3ZM403.8,162.9c-.5.5-1.5,1.5-2.1,1.5s-.9-.4-.9-1,0-.5,1.1-1.2c.8-.6,1.3-1.2,2-1.8.2-.2.4-.3.6-.3.4,0,.9.3.9,1s-1.1,1.5-1.6,1.9ZM402.7,143.9c-.3,0-1,0-1-.9s.7-.9,1-.9h7.5c.2,0,.9,0,.9.9s-.6.9-.9.9h-2.7c-.1.6-.4,1.4-.5,2.1h1.2c1.7,0,2.2.5,2.2,2.3v8.8c0,1.8-.4,2.3-2.2,2.3h-3.1c-1.7,0-2.2-.5-2.2-2.3v-8.8c0-2,.6-2.3,2.3-2.3.2-1,.3-1.2.4-2.1h-3ZM404.6,149.9h4v-1.6c0-.5-.2-.8-.8-.8h-2.4c-.6,0-.8.3-.8.8v1.6ZM408.6,151.4h-4v2.3h4v-2.3ZM404.6,155.3v1.7c0,.5.2.8.8.8h2.4c.6,0,.8-.3.8-.8v-1.7h-4ZM407.9,160c.3,0,.4,0,1,.8.6.7,1.1,1.1,1.7,1.7.2.2.5.5.5.8,0,.5-.4,1-.9,1s-1.1-.7-2-1.6c-.7-.7-1.3-1.4-1.3-1.8s.5-.9,1-.9Z"
            />
            <path
              d="M390.2,177c0-2.1.8-2.8,2.8-2.8h13.6c1.9,0,2.8.6,2.8,2.8v3.7c0,2-.8,2.7-2.7,2.7h-14.3c-.2,3.9-1.6,6.5-2,7.2-.7,1.2-1,1.2-1.3,1.2-.6,0-1.3-.5-1.3-1.1s.1-.5.3-.8c.7-1.1,1.4-2.2,1.8-4.2.2-1.3.3-2.8.3-3.1v-5.6ZM410.2,169.6c.2,0,1,0,1,1s-.7,1-1,1h-21.4c-.2,0-1,0-1-1s.7-1,1-1h21.4ZM392.4,181.4h13.7c.8,0,1.1-.4,1.1-1.1v-3c0-.8-.4-1.1-1.1-1.1h-12.5c-.8,0-1.1.3-1.1,1.1v4.1Z"
            />
            <path
              d="M392.4,201.9c-.9,0-1.3.5-1.3,1.2v15.2c0,.3,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-15c0-2.8.8-3.5,3.5-3.5h5.9v-2.7c0-.3,0-1,1-1s1.2.2,1.2,1v2.7h5.9c2.6,0,3.5.7,3.5,3.5v12.4c0,3.3-1.6,3.5-3.7,3.5s-2.5,0-2.8-.1c-.3-.1-.5-.5-.5-1,0-.9.7-1,1.3-1s2.2,0,2.6,0c.7,0,1-.6,1-1.2v-12.7c0-.8-.5-1.2-1.3-1.2h-5.9c.8,5.2,4.4,8.2,6.1,9.7.4.3.5.5.5.9,0,.6-.5,1.2-1.1,1.2s-.6,0-1.6-1c-3.5-3.1-4.7-6.3-5.1-7.5-.8,2.5-1.8,4.3-3.2,5.8-1,1.1-3,2.7-3.8,2.7s-1.1-.7-1.1-1.2.3-.8.7-1c2-1.3,3.8-2.6,5.1-6.1.4-1.1.7-2.2.9-3.4h-5.9Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_3備前_xFF1A_赤">
        <a @click="sendPointId(13)">
          <g>
            <line class="pn_st0" x1="416.6" y1="181.6" x2="416.6" y2="181.6" />
            <g>
              <line class="pn_st45" x1="416.6" y1="181.6" x2="419.1" y2="181.6" />
              <line class="pn_st24" x1="421.2" y1="181.6" x2="421.2" y2="181.6" />
              <line class="pn_st29" x1="421.2" y1="181.6" x2="443.6" y2="181.6" />
              <line class="pn_st45" x1="443.6" y1="181.6" x2="446.1" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M463.2,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M463.2,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M421.5,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M433.2,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M426.7,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M440,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M455.7,163.6c0,.3,0,1-.9,1s-1-.6-1-1v-12c-.8,1.4-1,1.5-1.5,1.5s-1-.7-1-1.2.1-.6.3-1c1.5-2.5,2.4-3.9,3.6-9.1,0-.4.2-.8.9-.8s1.1.2,1.1.9-.5,2.6-1.5,5.4v16.2ZM468.2,143.4v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h3c.2,0,1,0,1,.8s-.5.8-1,.8h-3v2.4h3.7c.2,0,1,0,1,.8s-.7.9-1,.9h-13.6v4.9c0,2.6-.4,6-1.4,8.4-.5,1.4-.7,1.5-1.2,1.5s-1.1-.2-1.1-.9.9-2.4,1-2.9c.2-.7.8-2.9.8-6.1v-5h-.9c-.6,0-.8-.3-.8-.8,0-.8.6-.9,1-.9h3.9v-2.4h-2.9c-.2,0-1,0-1-.8s.5-.8,1-.8h2.9v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h4.5ZM463.3,163.6c0,.3,0,.9-.9.9s-.9-.5-.9-.9v-10.7c0-1.8.7-2.3,2.3-2.3h7.6c1.5,0,2.3.5,2.3,2.3v9.1c0,2.2-1.1,2.2-2.7,2.2s-1.5,0-1.5-1,.2-.8.8-.8h1c.4,0,.6-.3.6-.9v-2.2h-3.5v3.9c0,.3,0,.9-.8.9s-.8-.6-.8-.9v-3.9h-3.4v4.3ZM466.7,154.3v-2.1h-2.5c-.3,0-.9,0-.9.8v1.3h3.4ZM466.7,155.8h-3.4v2.1h3.4v-2.1ZM468.2,145.1h-4.5v2.4h4.5v-2.4ZM468.4,154.3h3.4v-1.3c0-.6-.3-.8-.8-.8h-2.6v2.1ZM468.4,155.8v2.1h3.4v-2.1h-3.4Z"
              />
              <path
                d="M466,199.3c.3-.5.4-.7,1.1-2.1.3-.7.5-1,1.2-1s1.3.1,1.3.9-.1.6-1.1,2.2h5.5c.2,0,1,0,1,.9s-.7.9-1,.9h-21.6c-.2,0-1,0-1-.9s.7-.9,1-.9h5.8c-.1-.3-.8-1.5-.9-1.7-.1-.3-.1-.6-.1-.6,0-.5.8-.8,1.2-.8s.8.2,1.1.7c.3.5,1,1.5,1.3,2.4h5.2ZM455.1,213.4v5c0,.5,0,1-1,1s-1-.4-1-1v-12.9c0-1.8.5-2.3,2.3-2.3h4.7c1.8,0,2.3.5,2.3,2.3v11.4c0,.8,0,1.8-1,2.2-.4.2-.5.2-2.8.2s-1.3,0-1.3-1.1.6-1,1-1,1.3,0,1.5,0c.7,0,.7-.6.7-.8v-3h-5.4ZM455.1,207.4h5.4v-1.6c0-.5-.2-.8-.8-.8h-3.8c-.6,0-.8.3-.8.8v1.6ZM460.5,209.1h-5.4v2.5h5.4v-2.5ZM467.4,214c0,.3,0,1-1,1s-1.1-.3-1.1-1v-9.9c0-.3,0-1,1-1s1.1.2,1.1,1v9.9ZM473.4,216.5c0,.7,0,1.8-.9,2.3-.6.4-1.2.4-3.2.4s-1.8,0-2.1-.1c-.5-.2-.5-.8-.5-1,0-1,.6-1,1-1s2.1,0,2.4,0c.5,0,1.2,0,1.2-1.1v-12.5c0-.4,0-1,1-1s1.1.2,1.1,1v13Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_3備前_xFF1A_青" v-if="this.clickedPointId === 13">
        <g>
          <line class="pn_st0" x1="416.6" y1="181.6" x2="416.6" y2="181.6" />
          <g>
            <line class="pn_st23" x1="416.6" y1="181.6" x2="419.1" y2="181.6" />
            <line class="pn_st30" x1="421.2" y1="181.6" x2="421.2" y2="181.6" />
            <line class="pn_st16" x1="421.2" y1="181.6" x2="443.6" y2="181.6" />
            <line class="pn_st23" x1="443.6" y1="181.6" x2="446.1" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="446.2"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M421.5,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M433.2,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M426.7,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M440,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M455.7,163.6c0,.3,0,1-.9,1s-1-.6-1-1v-12c-.8,1.4-1,1.5-1.5,1.5s-1-.7-1-1.2.1-.6.3-1c1.5-2.5,2.4-3.9,3.6-9.1,0-.4.2-.8.9-.8s1.1.2,1.1.9-.5,2.6-1.5,5.4v16.2ZM468.2,143.4v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h3c.2,0,1,0,1,.8s-.5.8-1,.8h-3v2.4h3.7c.2,0,1,0,1,.8s-.7.9-1,.9h-13.6v4.9c0,2.6-.4,6-1.4,8.4-.5,1.4-.7,1.5-1.2,1.5s-1.1-.2-1.1-.9.9-2.4,1-2.9c.2-.7.8-2.9.8-6.1v-5h-.9c-.6,0-.8-.3-.8-.8,0-.8.6-.9,1-.9h3.9v-2.4h-2.9c-.2,0-1,0-1-.8s.5-.8,1-.8h2.9v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h4.5ZM463.3,163.6c0,.3,0,.9-.9.9s-.9-.5-.9-.9v-10.7c0-1.8.7-2.3,2.3-2.3h7.6c1.5,0,2.3.5,2.3,2.3v9.1c0,2.2-1.1,2.2-2.7,2.2s-1.5,0-1.5-1,.2-.8.8-.8h1c.4,0,.6-.3.6-.9v-2.2h-3.5v3.9c0,.3,0,.9-.8.9s-.8-.6-.8-.9v-3.9h-3.4v4.3ZM466.7,154.3v-2.1h-2.5c-.3,0-.9,0-.9.8v1.3h3.4ZM466.7,155.8h-3.4v2.1h3.4v-2.1ZM468.2,145.1h-4.5v2.4h4.5v-2.4ZM468.4,154.3h3.4v-1.3c0-.6-.3-.8-.8-.8h-2.6v2.1ZM468.4,155.8v2.1h3.4v-2.1h-3.4Z"
            />
            <path
              class="pn_st63"
              d="M466,199.3c.3-.5.4-.7,1.1-2.1.3-.7.5-1,1.2-1s1.3.1,1.3.9-.1.6-1.1,2.2h5.5c.2,0,1,0,1,.9s-.7.9-1,.9h-21.6c-.2,0-1,0-1-.9s.7-.9,1-.9h5.8c-.1-.3-.8-1.5-.9-1.7-.1-.3-.1-.6-.1-.6,0-.5.8-.8,1.2-.8s.8.2,1.1.7c.3.5,1,1.5,1.3,2.4h5.2ZM455.1,213.4v5c0,.5,0,1-1,1s-1-.4-1-1v-12.9c0-1.8.5-2.3,2.3-2.3h4.7c1.8,0,2.3.5,2.3,2.3v11.4c0,.8,0,1.8-1,2.2-.4.2-.5.2-2.8.2s-1.3,0-1.3-1.1.6-1,1-1,1.3,0,1.5,0c.7,0,.7-.6.7-.8v-3h-5.4ZM455.1,207.4h5.4v-1.6c0-.5-.2-.8-.8-.8h-3.8c-.6,0-.8.3-.8.8v1.6ZM460.5,209.1h-5.4v2.5h5.4v-2.5ZM467.4,214c0,.3,0,1-1,1s-1.1-.3-1.1-1v-9.9c0-.3,0-1,1-1s1.1.2,1.1,1v9.9ZM473.4,216.5c0,.7,0,1.8-.9,2.3-.6.4-1.2.4-3.2.4s-1.8,0-2.1-.1c-.5-.2-.5-.8-.5-1,0-1,.6-1,1-1s2.1,0,2.4,0c.5,0,1.2,0,1.2-1.1v-12.5c0-.4,0-1,1-1s1.1.2,1.1,1v13Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_3備前_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(13)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="416.6" y1="181.6" x2="416.6" y2="181.6" />
          <g>
            <line class="pn_st23" x1="416.6" y1="181.6" x2="419.1" y2="181.6" />
            <line class="pn_st30" x1="421.2" y1="181.6" x2="421.2" y2="181.6" />
            <line class="pn_st16" x1="421.2" y1="181.6" x2="443.6" y2="181.6" />
            <line class="pn_st23" x1="443.6" y1="181.6" x2="446.1" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M463.2,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M463.2,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M463.2,126.6h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M421.5,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M433.2,146.7c.1-1.5,1.1-1.6,1.9-1.6h5c.7,0,.8.5.8.7s0,.8-.8.8h-4.5c-.4,0-.8,0-.9.8l-.3,3.7c.5-.4,1.2-1,2.7-1s4.5,1.4,4.5,4.9-2.3,4.8-4.8,4.8-4.6-2.6-4.6-3.7.6-.8.8-.8c.6,0,.8.3,1,1,.3,1,1.4,1.9,2.8,1.9s3.1-1,3.1-3.4-1.8-3.4-3.1-3.4-1.4,0-2.2.8c-.6.6-.7.7-1.1.7-.8,0-.8-.7-.8-1l.5-5.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M426.7,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M440,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M455.7,163.6c0,.3,0,1-.9,1s-1-.6-1-1v-12c-.8,1.4-1,1.5-1.5,1.5s-1-.7-1-1.2.1-.6.3-1c1.5-2.5,2.4-3.9,3.6-9.1,0-.4.2-.8.9-.8s1.1.2,1.1.9-.5,2.6-1.5,5.4v16.2ZM468.2,143.4v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h3c.2,0,1,0,1,.8s-.5.8-1,.8h-3v2.4h3.7c.2,0,1,0,1,.8s-.7.9-1,.9h-13.6v4.9c0,2.6-.4,6-1.4,8.4-.5,1.4-.7,1.5-1.2,1.5s-1.1-.2-1.1-.9.9-2.4,1-2.9c.2-.7.8-2.9.8-6.1v-5h-.9c-.6,0-.8-.3-.8-.8,0-.8.6-.9,1-.9h3.9v-2.4h-2.9c-.2,0-1,0-1-.8s.5-.8,1-.8h2.9v-1.4c0-.2,0-.9,1-.9s1.1.2,1.1.9v1.4h4.5ZM463.3,163.6c0,.3,0,.9-.9.9s-.9-.5-.9-.9v-10.7c0-1.8.7-2.3,2.3-2.3h7.6c1.5,0,2.3.5,2.3,2.3v9.1c0,2.2-1.1,2.2-2.7,2.2s-1.5,0-1.5-1,.2-.8.8-.8h1c.4,0,.6-.3.6-.9v-2.2h-3.5v3.9c0,.3,0,.9-.8.9s-.8-.6-.8-.9v-3.9h-3.4v4.3ZM466.7,154.3v-2.1h-2.5c-.3,0-.9,0-.9.8v1.3h3.4ZM466.7,155.8h-3.4v2.1h3.4v-2.1ZM468.2,145.1h-4.5v2.4h4.5v-2.4ZM468.4,154.3h3.4v-1.3c0-.6-.3-.8-.8-.8h-2.6v2.1ZM468.4,155.8v2.1h3.4v-2.1h-3.4Z"
            />
            <path
              d="M466,199.3c.3-.5.4-.7,1.1-2.1.3-.7.5-1,1.2-1s1.3.1,1.3.9-.1.6-1.1,2.2h5.5c.2,0,1,0,1,.9s-.7.9-1,.9h-21.6c-.2,0-1,0-1-.9s.7-.9,1-.9h5.8c-.1-.3-.8-1.5-.9-1.7-.1-.3-.1-.6-.1-.6,0-.5.8-.8,1.2-.8s.8.2,1.1.7c.3.5,1,1.5,1.3,2.4h5.2ZM455.1,213.4v5c0,.5,0,1-1,1s-1-.4-1-1v-12.9c0-1.8.5-2.3,2.3-2.3h4.7c1.8,0,2.3.5,2.3,2.3v11.4c0,.8,0,1.8-1,2.2-.4.2-.5.2-2.8.2s-1.3,0-1.3-1.1.6-1,1-1,1.3,0,1.5,0c.7,0,.7-.6.7-.8v-3h-5.4ZM455.1,207.4h5.4v-1.6c0-.5-.2-.8-.8-.8h-3.8c-.6,0-.8.3-.8.8v1.6ZM460.5,209.1h-5.4v2.5h5.4v-2.5ZM467.4,214c0,.3,0,1-1,1s-1.1-.3-1.1-1v-9.9c0-.3,0-1,1-1s1.1.2,1.1,1v9.9ZM473.4,216.5c0,.7,0,1.8-.9,2.3-.6.4-1.2.4-3.2.4s-1.8,0-2.1-.1c-.5-.2-.5-.8-.5-1,0-1,.6-1,1-1s2.1,0,2.4,0c.5,0,1.2,0,1.2-1.1v-12.5c0-.4,0-1,1-1s1.1.2,1.1,1v13Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_2赤穂_xFF1A_赤">
        <a @click="sendPointId(12)">
          <g>
            <line class="pn_st0" x1="480.3" y1="181.6" x2="480.3" y2="181.6" />
            <g>
              <line class="pn_st45" x1="480.3" y1="181.6" x2="482.8" y2="181.6" />
              <line class="pn_st24" x1="484.9" y1="181.6" x2="484.9" y2="181.6" />
              <line class="pn_st29" x1="484.9" y1="181.6" x2="507.3" y2="181.6" />
              <line class="pn_st45" x1="507.3" y1="181.6" x2="509.8" y2="181.6" />
            </g>
          </g>
          <g>
            <path
              class="pn_st69"
              d="M527,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M527,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M485,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M501.2,150.1c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM497.8,155c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M490.4,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M503.7,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M530.7,162c0,2.2-1.1,2.2-3.4,2.2s-1.8,0-2,0c-.5-.2-.6-.7-.6-1.1,0-1,.8-1,1-1s1.8,0,2.1,0c.7,0,.9-.4.9-.9v-10h-3.2c0,7-2,9.8-4.1,11.6-.8.8-2.3,1.7-3,1.7s-1-.6-1-1.2.3-.7.8-1c3.7-2,5.2-5,5.2-11.1h-7.1c-.3,0-1,0-1-.9s.8-1,1-1h9.5v-3.4h-8c-.2,0-1,0-1-1s.8-1,1-1h8v-1.8c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v1.8h8.2c.2,0,1,0,1,1s-.8,1-1,1h-8.2v3.4h9.4c.4,0,1.2,0,1.2,1s-.8,1-1,1h-6.8v10.9ZM520.7,153.6c0,.5-1,3.2-2.4,5.4-1.1,1.6-1.3,1.7-1.7,1.7-.5,0-1.1-.5-1.1-1.1s0-.3.9-1.4c1.2-1.7,1.8-3.2,2.3-4.8,0-.2.2-.7.8-.7s1.1.3,1.1.9ZM535.2,154.6c.7,2,1.7,3.4,2.7,4.9.2.3.5.7.5,1,0,.6-.7,1-1.2,1s-.6-.2-1.5-1.6c-2.5-3.9-2.8-6.2-2.8-6.5,0-.5.4-.9,1.2-.9s.6.2,1.2,2Z"
              />
              <path
                d="M520.8,202.6h2c.2,0,.9,0,.9,1s-.7.9-.9.9h-2v.4c.5,1.2,1.3,2.8,2,3.7,1,1.3,1,1.3,1,1.7,0,.5-.4.9-.9.9s-.5-.3-1-1.1c-.4-.6-.7-1.3-1.1-2.3v10.8c0,.2,0,1-.9,1s-.9-.7-.9-1v-9.2c-.7,1.9-1.4,3.2-1.8,3.8-.5.8-.7,1.1-1.1,1.1s-1-.6-1-1.1.1-.5.4-.8c2.5-3.6,3.5-7.6,3.5-7.7h-2.5c-.2,0-1,0-1-.9s.8-1,1-1h2.5v-3.6c-1.5.2-2.4.3-2.6.3-.9,0-.9-.9-.9-1,0-.7.5-.9.8-.9,1.2-.2,3.2-.4,4.6-.8.6-.2,1.6-.5,1.8-.5.6,0,.9.6.9,1,0,.8-.6.9-2.8,1.5v4ZM525.8,213.3c0,.4-.3,1.7-.8,3.2-.7,1.9-1,2-1.4,2s-1.1,0-1.1-.9,0-.3.5-1.3c.4-1,.7-1.8,1-3.1,0-.2.2-.6.7-.6.8,0,1.1.4,1.1.8ZM529.9,200h-5.5c-.3,0-1,0-1-.9s.6-.9,1-.9h5.5v-1.3c0-.2,0-.9.9-.9s1,.2,1,.9v1.3h5.6c.2,0,1,0,1,.9s-.8.9-1,.9h-5.6v1.7h3.3c1.6,0,2.3.6,2.3,2.3v3.7c0,1.7-.6,2.3-2.3,2.3h-8.6c-1.7,0-2.3-.6-2.3-2.3v-3.7c0-1.7.7-2.3,2.3-2.3h3.3v-1.7ZM526.2,205.2h3.7v-1.9h-2.9c-.5,0-.8.2-.8.8v1.1ZM526.2,206.5v1.1c0,.5.2.8.8.8h2.9v-1.9h-3.7ZM528.9,216.5c0,.2,0,.7.4.8.2,0,1,0,1.6,0h.6c1.2,0,1.4,0,1.5-1,.2-1.2.2-1.5.9-1.5s1,.6,1,1,0,2.2-.8,2.8c-.5.5-1.4.5-3.2.5s-2.6,0-3.1-.4c-.6-.4-.6-1.1-.6-2v-3.1c0-.3,0-1,.9-1s.9.6.9,1v2.8ZM531.6,213.5c-.2,0-.3,0-1.1-.6-.2-.1-1.7-.9-2.2-1.1-.2-.1-.4-.3-.4-.7s.2-1,.8-1,1.8.7,2.3,1c1.1.6,1.4.8,1.5,1.2,0,.4-.3,1.1-.9,1.1ZM535.6,205.2v-1.1c0-.5-.3-.8-.8-.8h-3v1.9h3.8ZM535.6,206.5h-3.8v1.9h3c.5,0,.8-.3.8-.8v-1.1ZM537.4,213.9c.4.8.9,2.1,1,2.4,0,.3.2.6.2.8,0,.7-.8.9-1.1.9-.5,0-.6-.1-1.1-1.5-.4-1-.8-1.8-1.3-2.9-.1-.2-.2-.5-.2-.8,0-.6.7-.8,1-.8.5,0,.6,0,1.5,1.9Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_2赤穂_xFF1A_青" v-if="this.clickedPointId === 12">
        <g>
          <line class="pn_st0" x1="480.3" y1="181.6" x2="480.3" y2="181.6" />
          <g>
            <line class="pn_st23" x1="480.3" y1="181.6" x2="482.8" y2="181.6" />
            <line class="pn_st30" x1="484.9" y1="181.6" x2="484.9" y2="181.6" />
            <line class="pn_st16" x1="484.9" y1="181.6" x2="507.3" y2="181.6" />
            <line class="pn_st23" x1="507.3" y1="181.6" x2="509.8" y2="181.6" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="510"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M485,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M501.2,150.1c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM497.8,155c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M490.4,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M503.7,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M530.7,162c0,2.2-1.1,2.2-3.4,2.2s-1.8,0-2,0c-.5-.2-.6-.7-.6-1.1,0-1,.8-1,1-1s1.8,0,2.1,0c.7,0,.9-.4.9-.9v-10h-3.2c0,7-2,9.8-4.1,11.6-.8.8-2.3,1.7-3,1.7s-1-.6-1-1.2.3-.7.8-1c3.7-2,5.2-5,5.2-11.1h-7.1c-.3,0-1,0-1-.9s.8-1,1-1h9.5v-3.4h-8c-.2,0-1,0-1-1s.8-1,1-1h8v-1.8c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v1.8h8.2c.2,0,1,0,1,1s-.8,1-1,1h-8.2v3.4h9.4c.4,0,1.2,0,1.2,1s-.8,1-1,1h-6.8v10.9ZM520.7,153.6c0,.5-1,3.2-2.4,5.4-1.1,1.6-1.3,1.7-1.7,1.7-.5,0-1.1-.5-1.1-1.1s0-.3.9-1.4c1.2-1.7,1.8-3.2,2.3-4.8,0-.2.2-.7.8-.7s1.1.3,1.1.9ZM535.2,154.6c.7,2,1.7,3.4,2.7,4.9.2.3.5.7.5,1,0,.6-.7,1-1.2,1s-.6-.2-1.5-1.6c-2.5-3.9-2.8-6.2-2.8-6.5,0-.5.4-.9,1.2-.9s.6.2,1.2,2Z"
            />
            <path
              class="pn_st63"
              d="M520.8,202.6h2c.2,0,.9,0,.9,1s-.7.9-.9.9h-2v.4c.5,1.2,1.3,2.8,2,3.7,1,1.3,1,1.3,1,1.7,0,.5-.4.9-.9.9s-.5-.3-1-1.1c-.4-.6-.7-1.3-1.1-2.3v10.8c0,.2,0,1-.9,1s-.9-.7-.9-1v-9.2c-.7,1.9-1.4,3.2-1.8,3.8-.5.8-.7,1.1-1.1,1.1s-1-.6-1-1.1.1-.5.4-.8c2.5-3.6,3.5-7.6,3.5-7.7h-2.5c-.2,0-1,0-1-.9s.8-1,1-1h2.5v-3.6c-1.5.2-2.4.3-2.6.3-.9,0-.9-.9-.9-1,0-.7.5-.9.8-.9,1.2-.2,3.2-.4,4.6-.8.6-.2,1.6-.5,1.8-.5.6,0,.9.6.9,1,0,.8-.6.9-2.8,1.5v4ZM525.8,213.3c0,.4-.3,1.7-.8,3.2-.7,1.9-1,2-1.4,2s-1.1,0-1.1-.9,0-.3.5-1.3c.4-1,.7-1.8,1-3.1,0-.2.2-.6.7-.6.8,0,1.1.4,1.1.8ZM529.9,200h-5.5c-.3,0-1,0-1-.9s.6-.9,1-.9h5.5v-1.3c0-.2,0-.9.9-.9s1,.2,1,.9v1.3h5.6c.2,0,1,0,1,.9s-.8.9-1,.9h-5.6v1.7h3.3c1.6,0,2.3.6,2.3,2.3v3.7c0,1.7-.6,2.3-2.3,2.3h-8.6c-1.7,0-2.3-.6-2.3-2.3v-3.7c0-1.7.7-2.3,2.3-2.3h3.3v-1.7ZM526.2,205.2h3.7v-1.9h-2.9c-.5,0-.8.2-.8.8v1.1ZM526.2,206.5v1.1c0,.5.2.8.8.8h2.9v-1.9h-3.7ZM528.9,216.5c0,.2,0,.7.4.8.2,0,1,0,1.6,0h.6c1.2,0,1.4,0,1.5-1,.2-1.2.2-1.5.9-1.5s1,.6,1,1,0,2.2-.8,2.8c-.5.5-1.4.5-3.2.5s-2.6,0-3.1-.4c-.6-.4-.6-1.1-.6-2v-3.1c0-.3,0-1,.9-1s.9.6.9,1v2.8ZM531.6,213.5c-.2,0-.3,0-1.1-.6-.2-.1-1.7-.9-2.2-1.1-.2-.1-.4-.3-.4-.7s.2-1,.8-1,1.8.7,2.3,1c1.1.6,1.4.8,1.5,1.2,0,.4-.3,1.1-.9,1.1ZM535.6,205.2v-1.1c0-.5-.3-.8-.8-.8h-3v1.9h3.8ZM535.6,206.5h-3.8v1.9h3c.5,0,.8-.3.8-.8v-1.1ZM537.4,213.9c.4.8.9,2.1,1,2.4,0,.3.2.6.2.8,0,.7-.8.9-1.1.9-.5,0-.6-.1-1.1-1.5-.4-1-.8-1.8-1.3-2.9-.1-.2-.2-.5-.2-.8,0-.6.7-.8,1-.8.5,0,.6,0,1.5,1.9Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_2赤穂_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(12)"
        class="cursor_not_allowed"
      >
        <g>
          <line class="pn_st0" x1="480.3" y1="181.6" x2="480.3" y2="181.6" />
          <g>
            <line class="pn_st23" x1="480.3" y1="181.6" x2="482.8" y2="181.6" />
            <line class="pn_st30" x1="484.9" y1="181.6" x2="484.9" y2="181.6" />
            <line class="pn_st16" x1="484.9" y1="181.6" x2="507.3" y2="181.6" />
            <line class="pn_st23" x1="507.3" y1="181.6" x2="509.8" y2="181.6" />
          </g>
        </g>
        <g>
          <path
            class="pn_st63"
            d="M527,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M527,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M527,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M485,159.5c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M501.2,150.1c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM497.8,155c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M490.4,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M503.7,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M530.7,162c0,2.2-1.1,2.2-3.4,2.2s-1.8,0-2,0c-.5-.2-.6-.7-.6-1.1,0-1,.8-1,1-1s1.8,0,2.1,0c.7,0,.9-.4.9-.9v-10h-3.2c0,7-2,9.8-4.1,11.6-.8.8-2.3,1.7-3,1.7s-1-.6-1-1.2.3-.7.8-1c3.7-2,5.2-5,5.2-11.1h-7.1c-.3,0-1,0-1-.9s.8-1,1-1h9.5v-3.4h-8c-.2,0-1,0-1-1s.8-1,1-1h8v-1.8c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v1.8h8.2c.2,0,1,0,1,1s-.8,1-1,1h-8.2v3.4h9.4c.4,0,1.2,0,1.2,1s-.8,1-1,1h-6.8v10.9ZM520.7,153.6c0,.5-1,3.2-2.4,5.4-1.1,1.6-1.3,1.7-1.7,1.7-.5,0-1.1-.5-1.1-1.1s0-.3.9-1.4c1.2-1.7,1.8-3.2,2.3-4.8,0-.2.2-.7.8-.7s1.1.3,1.1.9ZM535.2,154.6c.7,2,1.7,3.4,2.7,4.9.2.3.5.7.5,1,0,.6-.7,1-1.2,1s-.6-.2-1.5-1.6c-2.5-3.9-2.8-6.2-2.8-6.5,0-.5.4-.9,1.2-.9s.6.2,1.2,2Z"
            />
            <path
              d="M520.8,202.6h2c.2,0,.9,0,.9,1s-.7.9-.9.9h-2v.4c.5,1.2,1.3,2.8,2,3.7,1,1.3,1,1.3,1,1.7,0,.5-.4.9-.9.9s-.5-.3-1-1.1c-.4-.6-.7-1.3-1.1-2.3v10.8c0,.2,0,1-.9,1s-.9-.7-.9-1v-9.2c-.7,1.9-1.4,3.2-1.8,3.8-.5.8-.7,1.1-1.1,1.1s-1-.6-1-1.1.1-.5.4-.8c2.5-3.6,3.5-7.6,3.5-7.7h-2.5c-.2,0-1,0-1-.9s.8-1,1-1h2.5v-3.6c-1.5.2-2.4.3-2.6.3-.9,0-.9-.9-.9-1,0-.7.5-.9.8-.9,1.2-.2,3.2-.4,4.6-.8.6-.2,1.6-.5,1.8-.5.6,0,.9.6.9,1,0,.8-.6.9-2.8,1.5v4ZM525.8,213.3c0,.4-.3,1.7-.8,3.2-.7,1.9-1,2-1.4,2s-1.1,0-1.1-.9,0-.3.5-1.3c.4-1,.7-1.8,1-3.1,0-.2.2-.6.7-.6.8,0,1.1.4,1.1.8ZM529.9,200h-5.5c-.3,0-1,0-1-.9s.6-.9,1-.9h5.5v-1.3c0-.2,0-.9.9-.9s1,.2,1,.9v1.3h5.6c.2,0,1,0,1,.9s-.8.9-1,.9h-5.6v1.7h3.3c1.6,0,2.3.6,2.3,2.3v3.7c0,1.7-.6,2.3-2.3,2.3h-8.6c-1.7,0-2.3-.6-2.3-2.3v-3.7c0-1.7.7-2.3,2.3-2.3h3.3v-1.7ZM526.2,205.2h3.7v-1.9h-2.9c-.5,0-.8.2-.8.8v1.1ZM526.2,206.5v1.1c0,.5.2.8.8.8h2.9v-1.9h-3.7ZM528.9,216.5c0,.2,0,.7.4.8.2,0,1,0,1.6,0h.6c1.2,0,1.4,0,1.5-1,.2-1.2.2-1.5.9-1.5s1,.6,1,1,0,2.2-.8,2.8c-.5.5-1.4.5-3.2.5s-2.6,0-3.1-.4c-.6-.4-.6-1.1-.6-2v-3.1c0-.3,0-1,.9-1s.9.6.9,1v2.8ZM531.6,213.5c-.2,0-.3,0-1.1-.6-.2-.1-1.7-.9-2.2-1.1-.2-.1-.4-.3-.4-.7s.2-1,.8-1,1.8.7,2.3,1c1.1.6,1.4.8,1.5,1.2,0,.4-.3,1.1-.9,1.1ZM535.6,205.2v-1.1c0-.5-.3-.8-.8-.8h-3v1.9h3.8ZM535.6,206.5h-3.8v1.9h3c.5,0,.8-.3.8-.8v-1.1ZM537.4,213.9c.4.8.9,2.1,1,2.4,0,.3.2.6.2.8,0,.7-.8.9-1.1.9-.5,0-.6-.1-1.1-1.5-.4-1-.8-1.8-1.3-2.9-.1-.2-.2-.5-.2-.8,0-.6.7-.8,1-.8.5,0,.6,0,1.5,1.9Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_1姫路2_xFF1A_赤">
        <a @click="sendPointId(11)">
          <g class="pn_st60">
            <path
              class="pn_st65"
              d="M552.6,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st65"
              d="M568,145.1c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st65"
              d="M554.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st65"
              d="M568.1,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <path
              class="pn_st69"
              d="M590.7,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M590.7,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M585.2,145.8c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.6-.9c2.6-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.3c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,147.7c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.1.5.5.8.6.4,1.7.9,2.3,1.3.9-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,162h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,148.3v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,150.1v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,157.1h-4v3.8c0,.8.4,1.1,1.1,1.1h2.9v-4.9Z"
              />
              <path
                d="M580.1,180.3c0-.3,0-1,.9-1s.9.5.9,1v8.5c.2,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.3-.5-2.3-2.4v-3.4c0-1.8.5-2.3,2.3-2.3h3.5c1.8,0,2.3.5,2.3,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.3,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-.9-.8-.9-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,175c0,.6.2.8.8.8h2.9c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.9c-.6,0-.8.3-.8.8v3ZM598.5,170.7c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.6.2-.5,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.9-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,188.7c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,185.1c0-.7-.3-1.1-1.1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1.1-.4,1.1-1.1v-3.5ZM592.8,172.5c-.1.2-.3.4-.5.6.9,1.2,1.9,2.2,3.1,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
              />
              <path
                d="M602.5,207.8c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM579.6,207.8c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM594.7,212.9c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="573.7" y1="181.6" x2="573.7" y2="181.6" />
            <g>
              <line class="pn_st45" x1="573.7" y1="181.6" x2="571.2" y2="181.6" />
              <line class="pn_st41" x1="569" y1="181.6" x2="569" y2="181.6" />
              <line class="pn_st37" x1="569" y1="181.6" x2="546.4" y2="181.6" />
              <line class="pn_st45" x1="546.4" y1="181.6" x2="543.9" y2="181.6" />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_1姫路2_xFF1A_青" v-if="this.clickedPointId === 11">
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M552.6,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
          />
          <path
            class="pn_st70"
            d="M568,145.1c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
          />
        </g>
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M554.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
          />
          <path
            class="pn_st70"
            d="M568.1,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
          />
        </g>
        <rect
          class="pn_st62"
          x="573.7"
          y="126.6"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M585.2,145.8c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.6-.9c2.6-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.3c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,147.7c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.1.5.5.8.6.4,1.7.9,2.3,1.3.9-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,162h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,148.3v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,150.1v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,157.1h-4v3.8c0,.8.4,1.1,1.1,1.1h2.9v-4.9Z"
            />
            <path
              class="pn_st63"
              d="M580.1,180.3c0-.3,0-1,.9-1s.9.5.9,1v8.5c.2,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.3-.5-2.3-2.4v-3.4c0-1.8.5-2.3,2.3-2.3h3.5c1.8,0,2.3.5,2.3,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.3,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-.9-.8-.9-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,175c0,.6.2.8.8.8h2.9c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.9c-.6,0-.8.3-.8.8v3ZM598.5,170.7c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.6.2-.5,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.9-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,188.7c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,185.1c0-.7-.3-1.1-1.1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1.1-.4,1.1-1.1v-3.5ZM592.8,172.5c-.1.2-.3.4-.5.6.9,1.2,1.9,2.2,3.1,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
            />
            <path
              class="pn_st63"
              d="M602.5,207.8c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM579.6,207.8c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM594.7,212.9c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="573.7" y1="181.6" x2="573.7" y2="181.6" />
          <g>
            <line class="pn_st23" x1="573.7" y1="181.6" x2="571.2" y2="181.6" />
            <line class="pn_st14" x1="569" y1="181.6" x2="569" y2="181.6" />
            <line class="pn_st46" x1="569" y1="181.6" x2="546.4" y2="181.6" />
            <line class="pn_st23" x1="546.4" y1="181.6" x2="543.9" y2="181.6" />
          </g>
        </g>
      </g>
      <g
        id="_x31_1姫路2_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(11)"
        class="cursor_not_allowed"
      >
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M552.6,152.7c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
          />
          <path
            class="pn_st70"
            d="M568,145.1c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
          />
        </g>
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M554.5,164c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
          />
          <path
            class="pn_st70"
            d="M568.1,171.2c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
          />
        </g>
        <g>
          <path
            class="pn_st63"
            d="M590.7,235.1c-8.5,0-15.5-7-15.5-15.5v-76c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M590.7,129.6c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14v-76c0-7.7,6.3-14,14-14M590.7,126.6c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17v-76c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M585.2,145.8c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.6-.9c2.6-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.3c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,147.7c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.1.5.5.8.6.4,1.7.9,2.3,1.3.9-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,162h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,148.3v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,150.1v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,157.1h-4v3.8c0,.8.4,1.1,1.1,1.1h2.9v-4.9Z"
            />
            <path
              d="M580.1,180.3c0-.3,0-1,.9-1s.9.5.9,1v8.5c.2,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.3-.5-2.3-2.4v-3.4c0-1.8.5-2.3,2.3-2.3h3.5c1.8,0,2.3.5,2.3,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.3,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-.9-.8-.9-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,175c0,.6.2.8.8.8h2.9c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.9c-.6,0-.8.3-.8.8v3ZM598.5,170.7c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.6.2-.5,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.9-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,188.7c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,185.1c0-.7-.3-1.1-1.1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1.1-.4,1.1-1.1v-3.5ZM592.8,172.5c-.1.2-.3.4-.5.6.9,1.2,1.9,2.2,3.1,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
            />
            <path
              d="M602.5,207.8c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM579.6,207.8c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM594.7,212.9c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.9c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.7-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="573.7" y1="181.6" x2="573.7" y2="181.6" />
          <g>
            <line class="pn_st23" x1="573.7" y1="181.6" x2="571.2" y2="181.6" />
            <line class="pn_st14" x1="569" y1="181.6" x2="569" y2="181.6" />
            <line class="pn_st46" x1="569" y1="181.6" x2="546.4" y2="181.6" />
            <line class="pn_st23" x1="546.4" y1="181.6" x2="543.9" y2="181.6" />
          </g>
        </g>
      </g>
      <g id="_x31_0姫路1_xFF1A_赤">
        <a @click="sendPointId(10)">
          <g>
            <path
              class="pn_st69"
              d="M590.7,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M590.7,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M590.7.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st65"
              d="M543.9,114.6c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st65"
              d="M562.9,117.8c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM555.2,117.8c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st65"
              d="M570.7,117.5c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st65"
              d="M584.1,124.7c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
          <g>
            <line class="pn_st0" x1="590.7" y1="109.8" x2="590.7" y2="109.8" />
            <g>
              <line class="pn_st45" x1="590.7" y1="109.8" x2="590.7" y2="112.3" />
              <line class="pn_st42" x1="590.7" y1="115" x2="590.7" y2="115" />
              <line class="pn_st19" x1="590.7" y1="115" x2="590.7" y2="124.3" />
              <line class="pn_st45" x1="590.7" y1="124.3" x2="590.7" y2="126.8" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M585.2,19.3c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.5-.9c2.7-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.4c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,21.3c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.2.5.5.8.6.4,1.7.9,2.3,1.3.8-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,35.6h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,21.9v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,23.7v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,30.7h-4v3.8c0,.8.3,1.1,1.1,1.1h2.9v-4.9Z"
              />
              <path
                d="M580.1,53.9c0-.3,0-1,.9-1s.9.5.9,1v8.5c.3,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.4-.5-2.4-2.4v-3.4c0-1.8.5-2.3,2.4-2.3h3.5c1.8,0,2.4.5,2.4,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.4,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-1-.8-1-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,48.6c0,.6.2.8.8.8h2.8c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.8c-.6,0-.8.3-.8.8v3ZM598.5,44.3c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.5.2-.6,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.8-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,62.3c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,58.6c0-.7-.3-1.1-1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1-.4,1-1.1v-3.5ZM592.8,46.1c-.2.2-.3.4-.5.6.9,1.2,1.9,2.2,3,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
              />
              <path
                d="M602.5,81.4c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM579.6,81.4c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM588.6,77.6c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_0姫路1_xFF1A_青" v-if="this.clickedPointId === 10">
        <rect
          class="pn_st62"
          x="573.7"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M543.9,114.6c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
          />
          <path
            class="pn_st70"
            d="M562.9,117.8c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM555.2,117.8c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
          />
        </g>
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M570.7,117.5c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
          />
          <path
            class="pn_st70"
            d="M584.1,124.7c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
          />
        </g>
        <g>
          <line class="pn_st0" x1="590.7" y1="109.8" x2="590.7" y2="109.8" />
          <g>
            <line class="pn_st23" x1="590.7" y1="109.8" x2="590.7" y2="112.3" />
            <line class="pn_st15" x1="590.7" y1="115" x2="590.7" y2="115" />
            <line class="pn_st18" x1="590.7" y1="115" x2="590.7" y2="124.3" />
            <line class="pn_st23" x1="590.7" y1="124.3" x2="590.7" y2="126.8" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M585.2,19.3c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.5-.9c2.7-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.4c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,21.3c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.2.5.5.8.6.4,1.7.9,2.3,1.3.8-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,35.6h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,21.9v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,23.7v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,30.7h-4v3.8c0,.8.3,1.1,1.1,1.1h2.9v-4.9Z"
            />
            <path
              class="pn_st63"
              d="M580.1,53.9c0-.3,0-1,.9-1s.9.5.9,1v8.5c.3,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.4-.5-2.4-2.4v-3.4c0-1.8.5-2.3,2.4-2.3h3.5c1.8,0,2.4.5,2.4,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.4,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-1-.8-1-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,48.6c0,.6.2.8.8.8h2.8c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.8c-.6,0-.8.3-.8.8v3ZM598.5,44.3c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.5.2-.6,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.8-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,62.3c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,58.6c0-.7-.3-1.1-1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1-.4,1-1.1v-3.5ZM592.8,46.1c-.2.2-.3.4-.5.6.9,1.2,1.9,2.2,3,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
            />
            <path
              class="pn_st63"
              d="M602.5,81.4c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM579.6,81.4c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM588.6,77.6c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_0姫路1_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(10)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M590.7,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M590.7,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M590.7.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M543.9,114.6c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
          />
          <path
            class="pn_st70"
            d="M562.9,117.8c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM555.2,117.8c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
          />
        </g>
        <g class="pn_st60">
          <path
            class="pn_st70"
            d="M570.7,117.5c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
          />
          <path
            class="pn_st70"
            d="M584.1,124.7c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
          />
        </g>
        <g>
          <line class="pn_st0" x1="590.7" y1="109.8" x2="590.7" y2="109.8" />
          <g>
            <line class="pn_st23" x1="590.7" y1="109.8" x2="590.7" y2="112.3" />
            <line class="pn_st15" x1="590.7" y1="115" x2="590.7" y2="115" />
            <line class="pn_st18" x1="590.7" y1="115" x2="590.7" y2="124.3" />
            <line class="pn_st23" x1="590.7" y1="124.3" x2="590.7" y2="126.8" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M585.2,19.3c1.2,0,2.5,0,2.5,2.2s0,1-.2,2.8c-.3,2.8-.7,4.8-1.5,6.6.6.5,1.3.9,1.9,1.5.3.3.4.5.4.8,0,.5-.5,1.2-1.1,1.2s-.4,0-.7-.4c-.4-.4-1.2-1.2-1.3-1.3-1,1.8-2.3,3.2-2.9,3.7-.6.6-1.5,1.5-2.1,1.5s-1.1-.7-1.1-1.1.3-.7.5-.9c2.7-2.3,3.5-3.5,4-4.3-.6-.4-.8-.5-3-1.8-.6-.3-1-.7-1-1.5s0-.7.2-1.1c.6-2.2,1-3.5,1.3-5.8h-1.1c-.2,0-1,0-1-1s.8-1,1-1h1.4c.1-1,.2-2.5.3-3.6,0-.4,0-1,1-1s1,.7,1,1c0,.5-.2,2.6-.4,3.7h1.9ZM583,21.3c-.3,1.9-.8,4.1-1.2,5.5-.2.5-.2.7-.2.9,0,.3.2.5.5.8.6.4,1.7.9,2.3,1.3.8-2,1.4-5.3,1.4-7.5s-.3-1-1-1h-1.9ZM597.2,35.6h4c.2,0,1,0,1,.9s-.8.9-1,.9h-9.3c-1.9,0-2.6-.6-2.6-2.6v-16.7c0-2,.7-2.7,2.6-2.7h9.2c.3,0,1,0,1,.9s-.8.9-1,.9h-3.9v4.5h1.9c2,0,2.2,1.1,2.2,2.3v4.1c0,1.2-.2,2.3-2.2,2.3h-1.9v4.9ZM595.3,21.9v-4.5h-2.9c-.7,0-1.1.3-1.1,1.1v3.3h4ZM591.3,23.7v5.1h7.1c.7,0,.9-.4.9-.9v-3.4c0-.5-.2-.9-.9-.9h-7.1ZM595.3,30.7h-4v3.8c0,.8.3,1.1,1.1,1.1h2.9v-4.9Z"
            />
            <path
              d="M580.1,53.9c0-.3,0-1,.9-1s.9.5.9,1v8.5c.3,0,1.4-.3,1.6-.4v-10.9h-1.4c-1.8,0-2.4-.5-2.4-2.4v-3.4c0-1.8.5-2.3,2.4-2.3h3.5c1.8,0,2.4.5,2.4,2.3v3.4c0,2.1-.8,2.4-2.6,2.4v3.6h2.2c.4,0,.9,0,.9.9s-.3,1-.9,1h-2.2v5c.5-.1,2.4-.7,2.7-.7.7,0,.8.7.8.9,0,.8-.4.9-1.6,1.2-2.3.7-6.5,1.8-7.3,1.8s-1-.8-1-1.2c0-.7.4-.8,1.1-1v-8.9ZM581.6,48.6c0,.6.2.8.8.8h2.8c.6,0,.8-.3.8-.8v-3c0-.5-.2-.8-.8-.8h-2.8c-.6,0-.8.3-.8.8v3ZM598.5,44.3c.8,0,2.2,0,2.2,1.6s-.2,1-.8,1.9c-1,1.4-2.2,2.5-3,3.2,1.5,1,2.7,1.5,4.7,2.2.4.1.8.3.8.9s-.3,1.2-1,1.2-3.2-1.1-6-3.1c-3.2,2.3-5.7,3.2-6.1,3.2-.7,0-1-.7-1-1.1s.4-.8.8-.9c2-.7,3.2-1.2,4.9-2.4-.9-.8-1.7-1.6-2.8-3-.5.5-1.1,1-1.3,1.1-.2.1-.3.2-.5.2-.6,0-1-.5-1-1.1s.2-.5.5-.8c1.2-.9,2.7-2.2,3.9-4.6.1-.2.3-.6.8-.6s1,.2,1,.9-.1.5-.5,1.2h4.5ZM600.7,62.3c0,2.1-.6,2.7-2.7,2.7h-5.3c-2.1,0-2.7-.6-2.7-2.7v-3.8c0-2.1.6-2.7,2.7-2.7h5.3c2,0,2.7.6,2.7,2.7v3.8ZM598.8,58.6c0-.7-.3-1.1-1-1.1h-4.8c-.9,0-1.1.5-1.1,1.1v3.5c0,.6.2,1.1,1.1,1.1h4.8c.7,0,1-.4,1-1.1v-3.5ZM592.8,46.1c-.2.2-.3.4-.5.6.9,1.2,1.9,2.2,3,3.2,1.1-.9,3-2.8,3-3.5s-.2-.3-.5-.3h-5.1Z"
            />
            <path
              d="M602.5,81.4c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM579.6,81.4c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM588.6,77.6c-.1,0-.3.2-.6.2-.4,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.4-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
            />
          </g>
        </g>
      </g>
      <g id="_x39_高砂_xFF1A_赤">
        <a @click="sendPointId(9)">
          <g>
            <path
              class="pn_st69"
              d="M527,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M527,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M527,.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M549.5,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M564.3,23.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM560.9,28.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M554.1,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M567.5,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="544" y1="55.1" x2="544" y2="55.1" />
            <g>
              <line class="pn_st45" x1="544" y1="55.1" x2="546.5" y2="55.1" />
              <line class="pn_st24" x1="548.7" y1="55.1" x2="548.7" y2="55.1" />
              <line class="pn_st29" x1="548.7" y1="55.1" x2="571.1" y2="55.1" />
              <line class="pn_st45" x1="571.1" y1="55.1" x2="573.6" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M537.5,16.6c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM519.7,28.2c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM534.7,23c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM532.6,21.9c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM532.5,32.9c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM530.5,31.8c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
              />
              <path
                d="M522.2,78.3c1.7,0,2.3.6,2.3,2.3v9.1c0,1.7-.6,2.3-2.3,2.3h-2.5c-1.6,0-2.3-.6-2.3-2.3v-7.1c-.9,1.3-1.1,1.4-1.4,1.4-.5,0-.9-.7-.9-1.1s.1-.6,1.4-2.3c.4-.5,1.8-3,2.5-7.8h-2.6c-.2,0-1,0-1-1s.8-1,1-1h8.5c.2,0,1,0,1,.9s-.8,1-1,1h-4c-.3,1.7-.7,3.8-1.3,5.6h2.6ZM522.6,80.7c0-.4-.2-.6-.6-.6h-2c-.5,0-.6.3-.6.6v8.8c0,.3.1.6.6.6h2c.4,0,.6-.2.6-.6v-8.8ZM528.8,73.5c0,.8-.8,4.7-1.8,7-.4,1-.7,1.2-1.1,1.2s-1.1-.4-1.1-1,0-.2.2-.6c1.2-2.7,1.5-4.1,2-6.7,0-.3.2-.8.8-.8s1,.2,1,.8ZM537.7,82.8c0,.7-2,4.3-4.8,6.7-2.6,2.2-6.1,3.4-6.8,3.4s-1-.8-1-1.2.3-.7.8-.9c2.9-1,4.9-1.7,7.2-4.2.8-1,1.7-2.2,2.6-4,.3-.6.5-.7.9-.7s1,.2,1,1ZM532.7,82.9c0,2.3-.8,2.3-3.7,2.3s-1.5,0-1.5-1.1.6-1,1.1-1,1.1,0,1.3,0c.6,0,.7-.4.7-.9v-11.5c0-.3,0-1,1-1s1,.6,1,1v12.2ZM536.4,73.2c.2.9.9,3.5,1.6,5,.8,1.6.8,1.6.8,1.9,0,.5-.6.9-1.1.9s-.6-.2-1.1-1.2c-1.2-2.3-2.1-6-2.1-6.5s.7-.9,1.1-.9.7.4.8.8Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x39_高砂_xFF1A_青" v-if="this.clickedPointId === 9">
        <rect
          class="pn_st62"
          x="510"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M549.5,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M564.3,23.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM560.9,28.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M554.1,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M567.5,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="544" y1="55.1" x2="544" y2="55.1" />
          <g>
            <line class="pn_st23" x1="544" y1="55.1" x2="546.5" y2="55.1" />
            <line class="pn_st30" x1="548.7" y1="55.1" x2="548.7" y2="55.1" />
            <line class="pn_st16" x1="548.7" y1="55.1" x2="571.1" y2="55.1" />
            <line class="pn_st23" x1="571.1" y1="55.1" x2="573.6" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M537.5,16.6c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM519.7,28.2c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM534.7,23c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM532.6,21.9c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM532.5,32.9c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM530.5,31.8c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
            />
            <path
              class="pn_st63"
              d="M522.2,78.3c1.7,0,2.3.6,2.3,2.3v9.1c0,1.7-.6,2.3-2.3,2.3h-2.5c-1.6,0-2.3-.6-2.3-2.3v-7.1c-.9,1.3-1.1,1.4-1.4,1.4-.5,0-.9-.7-.9-1.1s.1-.6,1.4-2.3c.4-.5,1.8-3,2.5-7.8h-2.6c-.2,0-1,0-1-1s.8-1,1-1h8.5c.2,0,1,0,1,.9s-.8,1-1,1h-4c-.3,1.7-.7,3.8-1.3,5.6h2.6ZM522.6,80.7c0-.4-.2-.6-.6-.6h-2c-.5,0-.6.3-.6.6v8.8c0,.3.1.6.6.6h2c.4,0,.6-.2.6-.6v-8.8ZM528.8,73.5c0,.8-.8,4.7-1.8,7-.4,1-.7,1.2-1.1,1.2s-1.1-.4-1.1-1,0-.2.2-.6c1.2-2.7,1.5-4.1,2-6.7,0-.3.2-.8.8-.8s1,.2,1,.8ZM537.7,82.8c0,.7-2,4.3-4.8,6.7-2.6,2.2-6.1,3.4-6.8,3.4s-1-.8-1-1.2.3-.7.8-.9c2.9-1,4.9-1.7,7.2-4.2.8-1,1.7-2.2,2.6-4,.3-.6.5-.7.9-.7s1,.2,1,1ZM532.7,82.9c0,2.3-.8,2.3-3.7,2.3s-1.5,0-1.5-1.1.6-1,1.1-1,1.1,0,1.3,0c.6,0,.7-.4.7-.9v-11.5c0-.3,0-1,1-1s1,.6,1,1v12.2ZM536.4,73.2c.2.9.9,3.5,1.6,5,.8,1.6.8,1.6.8,1.9,0,.5-.6.9-1.1.9s-.6-.2-1.1-1.2c-1.2-2.3-2.1-6-2.1-6.5s.7-.9,1.1-.9.7.4.8.8Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x39_高砂_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(9)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M527,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M527,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M527,.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M549.5,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M564.3,23.8c.9,0,4.2.4,4.2,4.8s-2,4.9-4.5,4.9c-4.3,0-5-3.8-5-7.1s.9-5.4,1.5-6.2c.7-.9,2-1.7,3.6-1.7,3,0,4.1,2.3,4.1,3.2s-.5.8-.8.8c-.6,0-.8-.4-.8-.6-.2-.6-.6-1.9-2.4-1.9-3.3,0-3.3,4.4-3.3,5.5,1.3-1.7,3.1-1.7,3.4-1.7ZM560.9,28.6c0,1.9,1,3.4,3,3.4s2.8-2.7,2.8-3.4,0-3.4-2.8-3.4-3,1.5-3,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M554.1,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M567.5,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="544" y1="55.1" x2="544" y2="55.1" />
          <g>
            <line class="pn_st23" x1="544" y1="55.1" x2="546.5" y2="55.1" />
            <line class="pn_st30" x1="548.7" y1="55.1" x2="548.7" y2="55.1" />
            <line class="pn_st16" x1="548.7" y1="55.1" x2="571.1" y2="55.1" />
            <line class="pn_st23" x1="571.1" y1="55.1" x2="573.6" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M537.5,16.6c.2,0,1,0,1,.9s-.6.9-1,.9h-21.1c-.2,0-1,0-1-.9s.8-.9,1-.9h9.4v-1.1c0-.2,0-1,1-1s1.2.4,1.2,1v1.1h9.4ZM519.7,28.2c-.8,0-1.1.4-1.1,1.1v7.8c0,.4,0,1.1-1,1.1s-1.1-.2-1.1-1.1v-7.9c0-2,.7-2.6,2.7-2.6h15.7c1.8,0,2.7.6,2.7,2.6v6c0,2.7-1.1,2.7-3.8,2.7s-1.5,0-1.7-.1c-.4-.2-.5-.7-.5-1,0-1,.7-1,1-1s1.7,0,2,0c.6,0,1-.4,1-1.1v-5.3c0-.8-.3-1.1-1.1-1.1h-14.5ZM534.7,23c0,1.5-.5,2.1-2.1,2.1h-11.4c-1.6,0-2.1-.6-2.1-2.1v-1.1c0-1.5.5-2.1,2.1-2.1h11.4c1.6,0,2.1.6,2.1,2.1v1.1ZM532.6,21.9c0-.4-.2-.6-.6-.6h-10.2c-.5,0-.6.2-.6.6v1.1c0,.3.2.6.6.6h10.2c.4,0,.6-.2.6-.6v-1.1ZM532.5,32.9c0,1.7-.5,2.3-2.3,2.3h-6.6c-1.7,0-2.2-.5-2.2-2.3v-.9c0-1.7.5-2.3,2.2-2.3h6.6c1.7,0,2.3.5,2.3,2.3v.9ZM530.5,31.8c0-.4-.2-.6-.6-.6h-6c-.4,0-.6.2-.6.6v1.1c0,.4.2.6.6.6h6c.5,0,.6-.2.6-.6v-1.1Z"
            />
            <path
              d="M522.2,78.3c1.7,0,2.3.6,2.3,2.3v9.1c0,1.7-.6,2.3-2.3,2.3h-2.5c-1.6,0-2.3-.6-2.3-2.3v-7.1c-.9,1.3-1.1,1.4-1.4,1.4-.5,0-.9-.7-.9-1.1s.1-.6,1.4-2.3c.4-.5,1.8-3,2.5-7.8h-2.6c-.2,0-1,0-1-1s.8-1,1-1h8.5c.2,0,1,0,1,.9s-.8,1-1,1h-4c-.3,1.7-.7,3.8-1.3,5.6h2.6ZM522.6,80.7c0-.4-.2-.6-.6-.6h-2c-.5,0-.6.3-.6.6v8.8c0,.3.1.6.6.6h2c.4,0,.6-.2.6-.6v-8.8ZM528.8,73.5c0,.8-.8,4.7-1.8,7-.4,1-.7,1.2-1.1,1.2s-1.1-.4-1.1-1,0-.2.2-.6c1.2-2.7,1.5-4.1,2-6.7,0-.3.2-.8.8-.8s1,.2,1,.8ZM537.7,82.8c0,.7-2,4.3-4.8,6.7-2.6,2.2-6.1,3.4-6.8,3.4s-1-.8-1-1.2.3-.7.8-.9c2.9-1,4.9-1.7,7.2-4.2.8-1,1.7-2.2,2.6-4,.3-.6.5-.7.9-.7s1,.2,1,1ZM532.7,82.9c0,2.3-.8,2.3-3.7,2.3s-1.5,0-1.5-1.1.6-1,1.1-1,1.1,0,1.3,0c.6,0,.7-.4.7-.9v-11.5c0-.3,0-1,1-1s1,.6,1,1v12.2ZM536.4,73.2c.2.9.9,3.5,1.6,5,.8,1.6.8,1.6.8,1.9,0,.5-.6.9-1.1.9s-.6-.2-1.1-1.2c-1.2-2.3-2.1-6-2.1-6.5s.7-.9,1.1-.9.7.4.8.8Z"
            />
          </g>
        </g>
      </g>
      <g id="_x38_明石_xFF1A_赤">
        <a @click="sendPointId(8)">
          <g>
            <path
              class="pn_st69"
              d="M463.2,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M463.2,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M463.2.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M485,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M500.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM497.8,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M490.4,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M503.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="480.3" y1="55.1" x2="480.3" y2="55.1" />
            <g>
              <line class="pn_st45" x1="480.3" y1="55.1" x2="482.8" y2="55.1" />
              <line class="pn_st24" x1="484.9" y1="55.1" x2="484.9" y2="55.1" />
              <line class="pn_st29" x1="484.9" y1="55.1" x2="507.3" y2="55.1" />
              <line class="pn_st45" x1="507.3" y1="55.1" x2="509.8" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M460.7,30.9c0,2.1-.8,2.7-2.7,2.7h-3c-1.8,0-2.7-.5-2.7-2.7v-12.4c0-2,.8-2.6,2.7-2.6h3c1.9,0,2.7.6,2.7,2.6v12.4ZM458.8,23.6v-4.9c0-.6-.2-1.1-1.1-1.1h-2.4c-.7,0-1.1.3-1.1,1.1v4.9h4.6ZM458.8,25.4h-4.6v5.1c0,.8.4,1.1,1.1,1.1h2.4c.8,0,1.1-.5,1.1-1.1v-5.1ZM464.9,29.8c-.4,2.5-1.5,4.8-3.2,6.5-.3.3-1.8,1.7-2.5,1.7s-1.1-.6-1.1-1.1.2-.6.6-.9c.9-.6,2.6-1.7,3.7-4.3.6-1.3.8-2.7.8-4.1v-9.5c0-2,.8-2.7,2.7-2.7h5.7c1.8,0,2.6.6,2.6,2.7v17c0,.7,0,1.8-.9,2.3-.6.4-1.1.4-3.1.4s-1.6,0-1.8,0c-.5-.2-.6-.8-.6-1,0-.9.6-1,1-1s2.2,0,2.5,0c.8,0,.9-.7.9-1.2v-4.6h-7.2ZM465.1,21.6h7v-3.2c0-.7-.3-1.1-1.1-1.1h-4.7c-.8,0-1.1.4-1.1,1.1v3.2ZM472.1,23.4h-7v4.6h7v-4.6Z"
              />
              <path
                d="M470.4,79.4c1.9,0,2.8.7,2.8,2.8v7.6c0,2.1-.8,2.8-2.8,2.8h-11.3c-1.9,0-2.8-.6-2.8-2.8v-6.4c-1,1.1-2.9,2.9-3.8,2.9s-1.1-.7-1.1-1.2.3-.7.7-1c5.3-3.7,6.6-8.3,7.5-11.3h-7c-.4,0-1,0-1-1s.5-1,1-1h21.2c.5,0,1,0,1,1s-.4,1-1,1h-11.9c-.5,2.3-1.5,4.6-2.7,6.7h11.2ZM471,82.4c0-.8-.4-1.2-1.1-1.2h-10.2c-.8,0-1.2.3-1.2,1.2v7c0,.8.4,1.2,1.2,1.2h10.2c.8,0,1.1-.4,1.1-1.2v-7Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x38_明石_xFF1A_青" v-if="this.clickedPointId === 8">
        <rect
          class="pn_st62"
          x="446.2"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M485,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M500.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM497.8,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M490.4,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M503.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="480.3" y1="55.1" x2="480.3" y2="55.1" />
          <g>
            <line class="pn_st23" x1="480.3" y1="55.1" x2="482.8" y2="55.1" />
            <line class="pn_st30" x1="484.9" y1="55.1" x2="484.9" y2="55.1" />
            <line class="pn_st16" x1="484.9" y1="55.1" x2="507.3" y2="55.1" />
            <line class="pn_st23" x1="507.3" y1="55.1" x2="509.8" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M460.7,30.9c0,2.1-.8,2.7-2.7,2.7h-3c-1.8,0-2.7-.5-2.7-2.7v-12.4c0-2,.8-2.6,2.7-2.6h3c1.9,0,2.7.6,2.7,2.6v12.4ZM458.8,23.6v-4.9c0-.6-.2-1.1-1.1-1.1h-2.4c-.7,0-1.1.3-1.1,1.1v4.9h4.6ZM458.8,25.4h-4.6v5.1c0,.8.4,1.1,1.1,1.1h2.4c.8,0,1.1-.5,1.1-1.1v-5.1ZM464.9,29.8c-.4,2.5-1.5,4.8-3.2,6.5-.3.3-1.8,1.7-2.5,1.7s-1.1-.6-1.1-1.1.2-.6.6-.9c.9-.6,2.6-1.7,3.7-4.3.6-1.3.8-2.7.8-4.1v-9.5c0-2,.8-2.7,2.7-2.7h5.7c1.8,0,2.6.6,2.6,2.7v17c0,.7,0,1.8-.9,2.3-.6.4-1.1.4-3.1.4s-1.6,0-1.8,0c-.5-.2-.6-.8-.6-1,0-.9.6-1,1-1s2.2,0,2.5,0c.8,0,.9-.7.9-1.2v-4.6h-7.2ZM465.1,21.6h7v-3.2c0-.7-.3-1.1-1.1-1.1h-4.7c-.8,0-1.1.4-1.1,1.1v3.2ZM472.1,23.4h-7v4.6h7v-4.6Z"
            />
            <path
              class="pn_st63"
              d="M470.4,79.4c1.9,0,2.8.7,2.8,2.8v7.6c0,2.1-.8,2.8-2.8,2.8h-11.3c-1.9,0-2.8-.6-2.8-2.8v-6.4c-1,1.1-2.9,2.9-3.8,2.9s-1.1-.7-1.1-1.2.3-.7.7-1c5.3-3.7,6.6-8.3,7.5-11.3h-7c-.4,0-1,0-1-1s.5-1,1-1h21.2c.5,0,1,0,1,1s-.4,1-1,1h-11.9c-.5,2.3-1.5,4.6-2.7,6.7h11.2ZM471,82.4c0-.8-.4-1.2-1.1-1.2h-10.2c-.8,0-1.2.3-1.2,1.2v7c0,.8.4,1.2,1.2,1.2h10.2c.8,0,1.1-.4,1.1-1.2v-7Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x38_明石_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(8)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M463.2,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M463.2,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M463.2.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M485,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M500.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM497.8,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M490.4,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M503.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="480.3" y1="55.1" x2="480.3" y2="55.1" />
          <g>
            <line class="pn_st23" x1="480.3" y1="55.1" x2="482.8" y2="55.1" />
            <line class="pn_st30" x1="484.9" y1="55.1" x2="484.9" y2="55.1" />
            <line class="pn_st16" x1="484.9" y1="55.1" x2="507.3" y2="55.1" />
            <line class="pn_st23" x1="507.3" y1="55.1" x2="509.8" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M460.7,30.9c0,2.1-.8,2.7-2.7,2.7h-3c-1.8,0-2.7-.5-2.7-2.7v-12.4c0-2,.8-2.6,2.7-2.6h3c1.9,0,2.7.6,2.7,2.6v12.4ZM458.8,23.6v-4.9c0-.6-.2-1.1-1.1-1.1h-2.4c-.7,0-1.1.3-1.1,1.1v4.9h4.6ZM458.8,25.4h-4.6v5.1c0,.8.4,1.1,1.1,1.1h2.4c.8,0,1.1-.5,1.1-1.1v-5.1ZM464.9,29.8c-.4,2.5-1.5,4.8-3.2,6.5-.3.3-1.8,1.7-2.5,1.7s-1.1-.6-1.1-1.1.2-.6.6-.9c.9-.6,2.6-1.7,3.7-4.3.6-1.3.8-2.7.8-4.1v-9.5c0-2,.8-2.7,2.7-2.7h5.7c1.8,0,2.6.6,2.6,2.7v17c0,.7,0,1.8-.9,2.3-.6.4-1.1.4-3.1.4s-1.6,0-1.8,0c-.5-.2-.6-.8-.6-1,0-.9.6-1,1-1s2.2,0,2.5,0c.8,0,.9-.7.9-1.2v-4.6h-7.2ZM465.1,21.6h7v-3.2c0-.7-.3-1.1-1.1-1.1h-4.7c-.8,0-1.1.4-1.1,1.1v3.2ZM472.1,23.4h-7v4.6h7v-4.6Z"
            />
            <path
              d="M470.4,79.4c1.9,0,2.8.7,2.8,2.8v7.6c0,2.1-.8,2.8-2.8,2.8h-11.3c-1.9,0-2.8-.6-2.8-2.8v-6.4c-1,1.1-2.9,2.9-3.8,2.9s-1.1-.7-1.1-1.2.3-.7.7-1c5.3-3.7,6.6-8.3,7.5-11.3h-7c-.4,0-1,0-1-1s.5-1,1-1h21.2c.5,0,1,0,1,1s-.4,1-1,1h-11.9c-.5,2.3-1.5,4.6-2.7,6.7h11.2ZM471,82.4c0-.8-.4-1.2-1.1-1.2h-10.2c-.8,0-1.2.3-1.2,1.2v7c0,.8.4,1.2,1.2,1.2h10.2c.8,0,1.1-.4,1.1-1.2v-7Z"
            />
          </g>
        </g>
      </g>
      <g id="_x37_三宮_xFF1A_赤">
        <a @click="sendPointId(7)">
          <g>
            <path
              class="pn_st69"
              d="M399.5,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M399.5,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M399.5.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M422.3,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M439.5,18.8c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M426.7,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M440.1,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="416.7" y1="55.1" x2="416.7" y2="55.1" />
            <g>
              <line class="pn_st45" x1="416.7" y1="55.1" x2="419.2" y2="55.1" />
              <line class="pn_st24" x1="421.3" y1="55.1" x2="421.3" y2="55.1" />
              <line class="pn_st29" x1="421.3" y1="55.1" x2="443.7" y2="55.1" />
              <line class="pn_st45" x1="443.7" y1="55.1" x2="446.2" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M410.1,34.2c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM408.9,16.5c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM407.6,25c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
              />
              <path
                d="M407.9,71.6c1.9,0,2.7.6,2.7,2.6v2.2c0,.3,0,1-1,1s-1-.6-1-1v-1.8c0-.7-.3-1.1-1.1-1.1h-15.7c-.8,0-1.1.4-1.1,1.1v1.8c0,.3,0,1-1,1s-1-.6-1-1v-2.2c0-2,.8-2.6,2.7-2.6h7.2v-1.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.2h7.3ZM394.7,82.4c-2,0-2.7-.5-2.7-2.7v-1.5c0-2.1.6-2.7,2.7-2.7h9.6c2.1,0,2.7.6,2.7,2.7v1.5c0,2.1-.6,2.7-2.7,2.7h-3.9c-.3.9-.5,1.7-.9,2.4h7c1.9,0,2.7.6,2.7,2.7v2.2c0,2-.8,2.7-2.7,2.7h-14.1c-1.8,0-2.7-.6-2.7-2.7v-2.2c0-2,.8-2.7,2.7-2.7h4.9c.4-.9.7-2,.8-2.4h-3.5ZM407.2,87.5c0-.6-.2-1.1-1.1-1.1h-13.1c-.8,0-1.1.3-1.1,1.1v2c0,.7.3,1.1,1.1,1.1h13.1c.9,0,1.1-.5,1.1-1.1v-2ZM405.1,78.2c0-.6-.2-1.1-1.1-1.1h-9c-.7,0-1.1.4-1.1,1.1v1.4c0,.7.3,1.1,1.1,1.1h9c.9,0,1.1-.5,1.1-1.1v-1.4Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x37_三宮_xFF1A_青" v-if="this.clickedPointId === 7">
        <rect
          class="pn_st62"
          x="382.5"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M422.3,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M439.5,18.8c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M426.7,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M440.1,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="416.7" y1="55.1" x2="416.7" y2="55.1" />
          <g>
            <line class="pn_st23" x1="416.7" y1="55.1" x2="419.2" y2="55.1" />
            <line class="pn_st30" x1="421.3" y1="55.1" x2="421.3" y2="55.1" />
            <line class="pn_st16" x1="421.3" y1="55.1" x2="443.7" y2="55.1" />
            <line class="pn_st23" x1="443.7" y1="55.1" x2="446.2" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M410.1,34.2c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM408.9,16.5c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM407.6,25c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
            />
            <path
              class="pn_st63"
              d="M407.9,71.6c1.9,0,2.7.6,2.7,2.6v2.2c0,.3,0,1-1,1s-1-.6-1-1v-1.8c0-.7-.3-1.1-1.1-1.1h-15.7c-.8,0-1.1.4-1.1,1.1v1.8c0,.3,0,1-1,1s-1-.6-1-1v-2.2c0-2,.8-2.6,2.7-2.6h7.2v-1.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.2h7.3ZM394.7,82.4c-2,0-2.7-.5-2.7-2.7v-1.5c0-2.1.6-2.7,2.7-2.7h9.6c2.1,0,2.7.6,2.7,2.7v1.5c0,2.1-.6,2.7-2.7,2.7h-3.9c-.3.9-.5,1.7-.9,2.4h7c1.9,0,2.7.6,2.7,2.7v2.2c0,2-.8,2.7-2.7,2.7h-14.1c-1.8,0-2.7-.6-2.7-2.7v-2.2c0-2,.8-2.7,2.7-2.7h4.9c.4-.9.7-2,.8-2.4h-3.5ZM407.2,87.5c0-.6-.2-1.1-1.1-1.1h-13.1c-.8,0-1.1.3-1.1,1.1v2c0,.7.3,1.1,1.1,1.1h13.1c.9,0,1.1-.5,1.1-1.1v-2ZM405.1,78.2c0-.6-.2-1.1-1.1-1.1h-9c-.7,0-1.1.4-1.1,1.1v1.4c0,.7.3,1.1,1.1,1.1h9c.9,0,1.1-.5,1.1-1.1v-1.4Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x37_三宮_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(7)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M399.5,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M399.5,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M399.5.1c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M422.3,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M439.5,18.8c.3,0,1.3,0,1.3,1.1s0,.6-1,1.5c-2.5,2.6-4.4,8.7-4.6,10.9,0,.6,0,1.2-.9,1.2s-.9-.5-.9-.9c0-2.3,2.1-8.2,4.8-11.5.3-.3.4-.4.4-.6s-.2-.2-.4-.2h-5.9c-.7,0-.8-.5-.8-.7s0-.8.8-.8h7.2Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M426.7,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M440.1,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="416.7" y1="55.1" x2="416.7" y2="55.1" />
          <g>
            <line class="pn_st23" x1="416.7" y1="55.1" x2="419.2" y2="55.1" />
            <line class="pn_st30" x1="421.3" y1="55.1" x2="421.3" y2="55.1" />
            <line class="pn_st16" x1="421.3" y1="55.1" x2="443.7" y2="55.1" />
            <line class="pn_st23" x1="443.7" y1="55.1" x2="446.2" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M410.1,34.2c.3,0,1.1,0,1.1,1s-.7,1-1.1,1h-21c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h21ZM408.9,16.5c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-18.7c-.3,0-1.1,0-1.1-1s.7-1,1.1-1h18.7ZM407.6,25c.3,0,1.1,0,1.1,1s-.8,1-1.1,1h-16.1c-.3,0-1.1,0-1.1-1s.8-1,1.1-1h16.1Z"
            />
            <path
              d="M407.9,71.6c1.9,0,2.7.6,2.7,2.6v2.2c0,.3,0,1-1,1s-1-.6-1-1v-1.8c0-.7-.3-1.1-1.1-1.1h-15.7c-.8,0-1.1.4-1.1,1.1v1.8c0,.3,0,1-1,1s-1-.6-1-1v-2.2c0-2,.8-2.6,2.7-2.6h7.2v-1.2c0-.3,0-1,1-1s1.1.2,1.1,1v1.2h7.3ZM394.7,82.4c-2,0-2.7-.5-2.7-2.7v-1.5c0-2.1.6-2.7,2.7-2.7h9.6c2.1,0,2.7.6,2.7,2.7v1.5c0,2.1-.6,2.7-2.7,2.7h-3.9c-.3.9-.5,1.7-.9,2.4h7c1.9,0,2.7.6,2.7,2.7v2.2c0,2-.8,2.7-2.7,2.7h-14.1c-1.8,0-2.7-.6-2.7-2.7v-2.2c0-2,.8-2.7,2.7-2.7h4.9c.4-.9.7-2,.8-2.4h-3.5ZM407.2,87.5c0-.6-.2-1.1-1.1-1.1h-13.1c-.8,0-1.1.3-1.1,1.1v2c0,.7.3,1.1,1.1,1.1h13.1c.9,0,1.1-.5,1.1-1.1v-2ZM405.1,78.2c0-.6-.2-1.1-1.1-1.1h-9c-.7,0-1.1.4-1.1,1.1v1.4c0,.7.3,1.1,1.1,1.1h9c.9,0,1.1-.5,1.1-1.1v-1.4Z"
            />
          </g>
        </g>
      </g>
      <g id="_x36_尼崎_xFF1A_赤">
        <a @click="sendPointId(6)">
          <g>
            <path
              class="pn_st69"
              d="M335.9,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M335.9,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M335.9.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M357.7,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
              <path
                class="pn_st65"
                d="M372.8,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M363,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M376.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="352.9" y1="55.1" x2="352.9" y2="55.1" />
            <g>
              <line class="pn_st45" x1="352.9" y1="55.1" x2="355.4" y2="55.1" />
              <line class="pn_st24" x1="357.5" y1="55.1" x2="357.5" y2="55.1" />
              <line class="pn_st29" x1="357.5" y1="55.1" x2="380" y2="55.1" />
              <line class="pn_st45" x1="380" y1="55.1" x2="382.5" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M328.8,25.4c0,2.6-.3,7.1-1.8,11-.5,1.4-.8,1.7-1.4,1.7s-1.3-.5-1.3-1.2.1-.6.3-1c.6-1.3,2-4.8,2-10.7v-6.9c0-2,.8-2.7,2.7-2.7h14.3c1.7,0,2.3.6,2.3,2.3v3.2c0,1.7-.6,2.3-2.3,2.3h-14.8v2ZM328.8,21.6h14.1c.6,0,.9-.3.9-.8v-2.2c0-.6-.3-.9-.9-.9h-13c-.8,0-1.1.4-1.1,1.1v2.8ZM333.9,28.9c1.2-.2,2.5-.6,3.7-1,3-.9,4-1.4,6-2.4.4-.2.6-.3,1-.3.6,0,1.1.5,1.1,1.1s-.4.8-1.9,1.5c-4.1,1.8-8.8,2.8-9.9,2.9v3.9c0,.4,0,1.1.9,1.2.2,0,2.2,0,2.6,0h6.1c.7,0,.9-.2,1-.5.2-.4.3-1.1.5-2.7,0-1.1.1-1.5,1-1.5s1.2.3,1.2,1.2-.2,2.5-.5,3.7c-.5,1.8-1.8,1.9-3.4,1.9-8.4,0-9.3,0-9.8,0-1.8-.2-1.8-2.1-1.8-2.6v-9.9c0-.6.2-1.1,1.1-1.1s1,.8,1,1.1v3.5Z"
              />
              <path
                d="M328,70.9c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.4,91c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,72.1c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.2,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.3,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.1-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,1,.6,1,1s0,.7-.1,1.2h5.1ZM341.6,87.7c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,85.7c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.5,0,.8-.3.8-.8v-1.9Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x36_尼崎_xFF1A_青" v-if="this.clickedPointId === 6">
        <rect
          class="pn_st62"
          x="318.9"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M357.7,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M372.8,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M363,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M376.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="352.9" y1="55.1" x2="352.9" y2="55.1" />
          <g>
            <line class="pn_st23" x1="352.9" y1="55.1" x2="355.4" y2="55.1" />
            <line class="pn_st30" x1="357.5" y1="55.1" x2="357.5" y2="55.1" />
            <line class="pn_st16" x1="357.5" y1="55.1" x2="380" y2="55.1" />
            <line class="pn_st23" x1="380" y1="55.1" x2="382.5" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M328.8,25.4c0,2.6-.3,7.1-1.8,11-.5,1.4-.8,1.7-1.4,1.7s-1.3-.5-1.3-1.2.1-.6.3-1c.6-1.3,2-4.8,2-10.7v-6.9c0-2,.8-2.7,2.7-2.7h14.3c1.7,0,2.3.6,2.3,2.3v3.2c0,1.7-.6,2.3-2.3,2.3h-14.8v2ZM328.8,21.6h14.1c.6,0,.9-.3.9-.8v-2.2c0-.6-.3-.9-.9-.9h-13c-.8,0-1.1.4-1.1,1.1v2.8ZM333.9,28.9c1.2-.2,2.5-.6,3.7-1,3-.9,4-1.4,6-2.4.4-.2.6-.3,1-.3.6,0,1.1.5,1.1,1.1s-.4.8-1.9,1.5c-4.1,1.8-8.8,2.8-9.9,2.9v3.9c0,.4,0,1.1.9,1.2.2,0,2.2,0,2.6,0h6.1c.7,0,.9-.2,1-.5.2-.4.3-1.1.5-2.7,0-1.1.1-1.5,1-1.5s1.2.3,1.2,1.2-.2,2.5-.5,3.7c-.5,1.8-1.8,1.9-3.4,1.9-8.4,0-9.3,0-9.8,0-1.8-.2-1.8-2.1-1.8-2.6v-9.9c0-.6.2-1.1,1.1-1.1s1,.8,1,1.1v3.5Z"
            />
            <path
              class="pn_st63"
              d="M328,70.9c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.4,91c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,72.1c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.2,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.3,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.1-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,1,.6,1,1s0,.7-.1,1.2h5.1ZM341.6,87.7c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,85.7c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.5,0,.8-.3.8-.8v-1.9Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x36_尼崎_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(6)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M335.9,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M335.9,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M335.9.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M357.7,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
            <path
              class="pn_st70"
              d="M372.8,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M363,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M376.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="352.9" y1="55.1" x2="352.9" y2="55.1" />
          <g>
            <line class="pn_st23" x1="352.9" y1="55.1" x2="355.4" y2="55.1" />
            <line class="pn_st30" x1="357.5" y1="55.1" x2="357.5" y2="55.1" />
            <line class="pn_st16" x1="357.5" y1="55.1" x2="380" y2="55.1" />
            <line class="pn_st23" x1="380" y1="55.1" x2="382.5" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M328.8,25.4c0,2.6-.3,7.1-1.8,11-.5,1.4-.8,1.7-1.4,1.7s-1.3-.5-1.3-1.2.1-.6.3-1c.6-1.3,2-4.8,2-10.7v-6.9c0-2,.8-2.7,2.7-2.7h14.3c1.7,0,2.3.6,2.3,2.3v3.2c0,1.7-.6,2.3-2.3,2.3h-14.8v2ZM328.8,21.6h14.1c.6,0,.9-.3.9-.8v-2.2c0-.6-.3-.9-.9-.9h-13c-.8,0-1.1.4-1.1,1.1v2.8ZM333.9,28.9c1.2-.2,2.5-.6,3.7-1,3-.9,4-1.4,6-2.4.4-.2.6-.3,1-.3.6,0,1.1.5,1.1,1.1s-.4.8-1.9,1.5c-4.1,1.8-8.8,2.8-9.9,2.9v3.9c0,.4,0,1.1.9,1.2.2,0,2.2,0,2.6,0h6.1c.7,0,.9-.2,1-.5.2-.4.3-1.1.5-2.7,0-1.1.1-1.5,1-1.5s1.2.3,1.2,1.2-.2,2.5-.5,3.7c-.5,1.8-1.8,1.9-3.4,1.9-8.4,0-9.3,0-9.8,0-1.8-.2-1.8-2.1-1.8-2.6v-9.9c0-.6.2-1.1,1.1-1.1s1,.8,1,1.1v3.5Z"
            />
            <path
              d="M328,70.9c0-.2,0-1,.8-1s.8.7.8,1v18.7h.7c.6,0,.8-.3.8-.8v-14.5c0-.2,0-.9.8-.9s.8.6.8.9v15c0,1.8-.4,2.3-2.3,2.3h-3.3c-1.8,0-2.3-.5-2.3-2.3v-15c0-.3,0-.9.8-.9s.8.5.8.9v14.5c0,.6.3.8.8.8h.7v-18.7ZM345.4,91c0,1.3-.3,2-1.1,2.2-.4.1-.8.1-3.2.1s-1.8,0-1.8-1.1.7-1,1.2-1,1.7,0,2,0c.5,0,.9-.1.9-.9v-8.7h-9.4c-.3,0-1,0-1-.9s.7-.9,1-.9h12.4c.3,0,1,0,1,.9s-.4.9-.9.9h-1.1v9.3ZM345.9,72.1c.2,0,1,0,1,.9s-.7.9-1,.9h-4c.9,2,2.8,2.9,3,3,1.8.8,1.8.8,1.8,1.4s-.2,1-.9,1-3.8-1.2-5.7-4.9c-.5,1.1-1.1,2.3-2.8,3.5-1,.7-2.3,1.3-2.8,1.3s-.9-.8-.9-1.1c0-.5.4-.7.7-.8,1.7-.7,3.2-1.4,4.2-3.6h-4c-.3,0-1,0-1-.9s.7-.9,1-.9h4.5c0-.2.1-1.5.2-1.7,0-.3.3-.5.8-.5.9,0,1,.6,1,1s0,.7-.1,1.2h5.1ZM341.6,87.7c0,1.8-.5,2.3-2.3,2.3h-2.5c-1.8,0-2.3-.5-2.3-2.3v-2.1c0-1.7.4-2.3,2.3-2.3h2.5c1.8,0,2.3.6,2.3,2.3v2.1ZM339.9,85.7c0-.6-.2-.8-.8-.8h-2.1c-.5,0-.8.3-.8.8v1.9c0,.5.2.8.8.8h2.1c.5,0,.8-.3.8-.8v-1.9Z"
            />
          </g>
        </g>
      </g>
      <g id="_x35_大阪2_xFF1A_赤">
        <a @click="sendPointId(5)">
          <g>
            <path
              class="pn_st69"
              d="M272.2,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M272.2,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M272.2.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M294.7,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M313.7,25.9c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306,25.9c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M299.3,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M312.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="289.2" y1="55.1" x2="289.2" y2="55.1" />
            <g>
              <line class="pn_st45" x1="289.2" y1="55.1" x2="291.7" y2="55.1" />
              <line class="pn_st24" x1="293.8" y1="55.1" x2="293.9" y2="55.1" />
              <line class="pn_st29" x1="293.9" y1="55.1" x2="316.3" y2="55.1" />
              <line class="pn_st45" x1="316.3" y1="55.1" x2="318.8" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M261.5,23.4c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.3,12.4.5.2.8.5.8,1s-.5,1.2-1.2,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.8,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
              />
              <path
                d="M261.3,45.7c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s0,.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1.1-.8.5-.9h1.2c.5,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s0-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM279.6,49.6c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.1-1.7,4.7-3.2-.7-1-1.5-2.4-2.3-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.9.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.2-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
              />
              <path
                d="M284,81.7c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM261.1,81.7c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM276.3,86.8c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.8c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x35_大阪2_xFF1A_青" v-if="this.clickedPointId === 5">
        <rect
          class="pn_st62"
          x="255.2"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M294.7,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M313.7,25.9c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306,25.9c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M299.3,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M312.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="289.2" y1="55.1" x2="289.2" y2="55.1" />
          <g>
            <line class="pn_st23" x1="289.2" y1="55.1" x2="291.7" y2="55.1" />
            <line class="pn_st30" x1="293.8" y1="55.1" x2="293.9" y2="55.1" />
            <line class="pn_st16" x1="293.9" y1="55.1" x2="316.3" y2="55.1" />
            <line class="pn_st23" x1="316.3" y1="55.1" x2="318.8" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M261.5,23.4c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.3,12.4.5.2.8.5.8,1s-.5,1.2-1.2,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.8,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
            />
            <path
              class="pn_st63"
              d="M261.3,45.7c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s0,.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1.1-.8.5-.9h1.2c.5,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s0-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM279.6,49.6c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.1-1.7,4.7-3.2-.7-1-1.5-2.4-2.3-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.9.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.2-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
            />
            <path
              class="pn_st63"
              d="M284,81.7c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM261.1,81.7c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM276.3,86.8c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.8c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x35_大阪2_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(5)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M272.2,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M272.2,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M272.2.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M294.7,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M313.7,25.9c0,2.4-.2,7.5-4.7,7.5s-4.7-5.2-4.7-7.5.3-7.5,4.7-7.5,4.7,5,4.7,7.5ZM306,25.9c0,2.4.1,6,3,6s3-3.7,3-6-.1-6-3-6-3,3.6-3,6Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M299.3,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M312.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="289.2" y1="55.1" x2="289.2" y2="55.1" />
          <g>
            <line class="pn_st23" x1="289.2" y1="55.1" x2="291.7" y2="55.1" />
            <line class="pn_st30" x1="293.8" y1="55.1" x2="293.9" y2="55.1" />
            <line class="pn_st16" x1="293.9" y1="55.1" x2="316.3" y2="55.1" />
            <line class="pn_st23" x1="316.3" y1="55.1" x2="318.8" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M261.5,23.4c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.3,12.4.5.2.8.5.8,1s-.5,1.2-1.2,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.8,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
            />
            <path
              d="M261.3,45.7c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s0,.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1.1-.8.5-.9h1.2c.5,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s0-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM279.6,49.6c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.1-1.7,4.7-3.2-.7-1-1.5-2.4-2.3-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.9.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.2-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
            />
            <path
              d="M284,81.7c0,6.5-5.3,11.8-11.9,11.8s-11.8-5.3-11.8-11.8,5.3-11.8,11.8-11.8,11.9,5.2,11.9,11.8ZM261.1,81.7c0,6.1,5,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM276.3,86.8c.8,0,.8.6.8.8,0,.5-.3.8-.8.8h-6.8c-1.1,0-2.1,0-2.1-1.2s.2-.8,1.7-2c5.5-4.6,5.5-5.8,5.5-6.7s-.8-2.3-2.4-2.3-2.2.8-2.6,1.1c-.4.3-.5.5-.8.5-.5,0-.8-.4-.8-.8s1.6-2.4,4.2-2.4,4.2,1.5,4.2,3.9-1.9,4.2-6.7,8.4h6.6Z"
            />
          </g>
        </g>
      </g>
      <g id="_x34_大阪1_xFF1A_赤">
        <a @click="sendPointId(4)">
          <g>
            <path
              class="pn_st69"
              d="M208.5,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M208.5,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M208.5.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M236.3,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M235.6,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M249,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="225.5" y1="55.1" x2="225.5" y2="55.1" />
            <g>
              <line class="pn_st45" x1="225.5" y1="55.1" x2="228" y2="55.1" />
              <line class="pn_st24" x1="230.2" y1="55.1" x2="230.2" y2="55.1" />
              <line class="pn_st29" x1="230.2" y1="55.1" x2="252.6" y2="55.1" />
              <line class="pn_st45" x1="252.6" y1="55.1" x2="255.1" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M197.8,23.1c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.4,12.4.4.2.8.5.8,1s-.5,1.2-1.1,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.9,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
              />
              <path
                d="M197.6,45.4c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s.1.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1,0-.8.5-.9h1.2c.6,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s.1-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM215.9,49.3c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.2-1.7,4.7-3.2-.7-1-1.5-2.4-2.2-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.8.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.3-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
              />
              <path
                d="M220.3,81.4c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,81.4c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,77.6c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x34_大阪1_xFF1A_青" v-if="this.clickedPointId === 4">
        <rect
          class="pn_st62"
          x="191.5"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M236.3,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M235.6,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M249,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="225.5" y1="55.1" x2="225.5" y2="55.1" />
          <g>
            <line class="pn_st23" x1="225.5" y1="55.1" x2="228" y2="55.1" />
            <line class="pn_st30" x1="230.2" y1="55.1" x2="230.2" y2="55.1" />
            <line class="pn_st16" x1="230.2" y1="55.1" x2="252.6" y2="55.1" />
            <line class="pn_st23" x1="252.6" y1="55.1" x2="255.1" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M197.8,23.1c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.4,12.4.4.2.8.5.8,1s-.5,1.2-1.1,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.9,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
            />
            <path
              class="pn_st63"
              d="M197.6,45.4c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s.1.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1,0-.8.5-.9h1.2c.6,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s.1-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM215.9,49.3c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.2-1.7,4.7-3.2-.7-1-1.5-2.4-2.2-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.8.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.3-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
            />
            <path
              class="pn_st63"
              d="M220.3,81.4c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,81.4c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,77.6c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x34_大阪1_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(4)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M208.5,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M208.5,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M208.5.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M236.3,33.1c-.9,0-1.2-.8-1.2-1.2,0-2.1,2.9-4.1,3.6-4.6,3.3-2.3,4-2.8,4-4.6s-1.2-2.8-2.7-2.8-2.7,1.1-2.8,2.9c0,.3,0,.9-.9.9s-.9,0-.9-.9c0-1.6,1.2-4.4,4.6-4.4s4.4,1,4.4,4.4-1,3.2-4.3,5.5c-.6.4-3,2-3,3.1s.3.3.5.3h5.9c.7,0,.8.5.8.7s0,.8-.8.8h-7.3Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M235.6,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M249,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="225.5" y1="55.1" x2="225.5" y2="55.1" />
          <g>
            <line class="pn_st23" x1="225.5" y1="55.1" x2="228" y2="55.1" />
            <line class="pn_st30" x1="230.2" y1="55.1" x2="230.2" y2="55.1" />
            <line class="pn_st16" x1="230.2" y1="55.1" x2="252.6" y2="55.1" />
            <line class="pn_st23" x1="252.6" y1="55.1" x2="255.1" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M197.8,23.1c-.3,0-1.1,0-1.1-1s.6-1,1.1-1h9.4v-5.2c0-.3,0-1,1-1s1.2.3,1.2,1v5.2h9.7c.3,0,1.1,0,1.1,1s-.6,1-1.1,1h-9.3c1,4.3,2.5,8.9,9.4,12.4.4.2.8.5.8,1s-.5,1.2-1.1,1.2-3.2-1.6-5-3.2c-3.3-3-4.5-6.2-5.2-8.4-.9,2.9-2.5,5.9-5.1,8.3-2,1.8-4.7,3.3-5.4,3.3s-1.1-.7-1.1-1.2.3-.8.8-1c7-3.3,8.6-8.4,9.3-12.5h-9.3Z"
            />
            <path
              d="M197.6,45.4c0-1.9.5-2.3,2.3-2.3h3c1,0,2.3,0,2.3,1.6s-.4,1.9-2.1,5.4c-.2.3-.3.7-.3.9s.1.4,1,1.4c0,0,1.7,2,1.7,4.6s0,2.2-1.1,3.2c-.6.6-1.4.6-2.8.6s-1.4,0-1.4-1.1,0-.8.5-.9h1.2c.6,0,1.5,0,1.5-2.2s-.7-2.8-1.7-3.9c-.8-.9-.9-1-.9-1.5s.1-.6.9-2.3c.3-.6,1.3-2.8,1.3-3.3s-.4-.5-.9-.5h-1.8c-.5,0-.8.2-.8.8v18.8c0,.5-.1,1-1,1s-1-.6-1-1v-19.2ZM215.9,49.3c1.4,0,2.9,0,2.9,2s-.4,5-3.2,8.9c.6.6,1.8,1.9,3.8,3,.3.2.7.4.7.9s-.4,1.2-1.1,1.2-2.3-.8-4.8-3.7c-1.9,1.9-4.8,3.7-5.5,3.7s-1-.5-1-1.2.3-.7.7-.9c1.5-.7,3.2-1.7,4.7-3.2-.7-1-1.5-2.4-2.2-4.5-.3-.8-.8-2.5-.8-2.9s.7-.8,1.1-.8c.6,0,.8.5.8.8.5,1.9,1,3.7,2.5,5.8,2.3-3.3,2.5-6.6,2.5-6.7,0-.8-.7-.8-1.3-.8h-6.7v1.5c0,7.7-2.4,10.9-3.4,12.2-.2.3-.4.5-.7.5-.5,0-1.2-.4-1.2-1s0-.4.1-.5c.3-.6,1-1.5,1.3-2,1.5-2.2,1.9-6.2,1.9-9.1v-7c0-2,.8-2.7,2.7-2.7h9.3c.7,0,1,.3,1,1s-.8.9-1,.9h-9c-.8,0-1.1.4-1.1,1.1v3.2h7.1Z"
            />
            <path
              d="M220.3,81.4c0,6.5-5.3,11.8-11.8,11.8s-11.9-5.3-11.9-11.8,5.4-11.8,11.9-11.8,11.8,5.2,11.8,11.8ZM197.4,81.4c0,6.1,4.9,11,11,11s11-5,11-11-5-11-11-11-11,4.9-11,11ZM206.4,77.6c-.1,0-.3.2-.5.2-.5,0-.8-.4-.8-.9s.2-.5.5-.7l2.4-1.6c.3-.2.6-.4,1-.4.9,0,.9.7.9,1.2v12.2c0,.6-.3.9-.9.9s-.9-.2-.9-.9v-11.1l-1.6,1.1Z"
            />
          </g>
        </g>
      </g>
      <g id="_x33_堺_xFF1A_赤">
        <a @click="sendPointId(3)">
          <g>
            <path
              class="pn_st69"
              d="M144.7,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M144.7,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M144.7.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
            />
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M136,50.6h-2.2c-.2,0-1,0-1-1s.7-1,1-1h2.2v-5.5c0-.2,0-1,1-1s1,.8,1,1v5.5h1.7c.6,0,.9.4.9,1s-.2,1-.9,1h-1.7v8.8c.5-.1,1.3-.3,1.9-.5.1,0,.3,0,.5,0,.7,0,.8.8.8,1,0,.7-.4.8-2,1.2-3.1.9-4.8,1.4-5.4,1.4s-.9-.8-.9-1.1.1-.7.5-.8c.2-.1,2.3-.5,2.8-.6v-9.3ZM152.4,64.5c0,.4,0,1-1,1s-1-.6-1-1v-7.7c0-.6.2-1,1-1s.3,0,.4,0c-1-1.1-1.6-1.9-2-2.6h-2.9c-2.1,3.5-6.2,5.7-6.8,5.7s-1-.6-1-1.1.2-.6.6-.8c1.4-.7,3.4-1.8,5-3.8h-1.4c-1.6,0-2.3-.5-2.3-2.3v-5.7c0-1.8.7-2.3,2.3-2.3h9.8c1.6,0,2.3.6,2.3,2.3v5.7c0,1.7-.6,2.3-2.3,2.3h-1.4c1.2,1.5,2.5,2.6,3.1,2.9,1.5,1,1.6,1,1.6,1.5s-.5,1-1,1c-.7,0-2.4-1.5-3.1-2.2,0,.2,0,.2,0,.4v7.7ZM146.4,56.8c0,6.6-4.8,8.7-5.6,8.7s-1-.8-1-1.1c0-.5.3-.7.7-.8,3.4-1.8,3.9-4,4-6.6,0-.5,0-1.1,1-1.1s1,.7,1,1ZM147.2,47.4v-2.7h-3.4c-.6,0-.8.3-.8.8v1.9h4.3ZM147.2,48.9h-4.3v1.9c0,.5.2.8.8.8h3.4v-2.7ZM149.1,47.4h4.4v-1.9c0-.5-.2-.8-.8-.8h-3.6v2.7ZM149.1,48.9v2.7h3.6c.6,0,.8-.3.8-.8v-1.9h-4.4Z"
              />
            </g>
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M167.4,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M178.1,29.7c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM182.7,28.2v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M171.9,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M185.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="161.8" y1="55.1" x2="161.8" y2="55.1" />
            <g>
              <line class="pn_st45" x1="161.8" y1="55.1" x2="164.3" y2="55.1" />
              <line class="pn_st24" x1="166.5" y1="55.1" x2="166.5" y2="55.1" />
              <line class="pn_st29" x1="166.5" y1="55.1" x2="188.9" y2="55.1" />
              <line class="pn_st45" x1="188.9" y1="55.1" x2="191.4" y2="55.1" />
            </g>
          </g>
        </a>
      </g>
      <g id="_x33_堺_xFF1A_青" v-if="this.clickedPointId === 3">
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M167.4,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M178.1,29.7c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM182.7,28.2v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M171.9,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M185.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="161.8" y1="55.1" x2="161.8" y2="55.1" />
          <g>
            <line class="pn_st23" x1="161.8" y1="55.1" x2="164.3" y2="55.1" />
            <line class="pn_st30" x1="166.5" y1="55.1" x2="166.5" y2="55.1" />
            <line class="pn_st16" x1="166.5" y1="55.1" x2="188.9" y2="55.1" />
            <line class="pn_st23" x1="188.9" y1="55.1" x2="191.4" y2="55.1" />
          </g>
        </g>
        <rect
          class="pn_st62"
          x="127.7"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M136,50.6h-2.2c-.2,0-1,0-1-1s.7-1,1-1h2.2v-5.5c0-.2,0-1,1-1s1,.8,1,1v5.5h1.7c.6,0,.9.4.9,1s-.2,1-.9,1h-1.7v8.8c.5-.1,1.3-.3,1.9-.5.1,0,.3,0,.5,0,.7,0,.8.8.8,1,0,.7-.4.8-2,1.2-3.1.9-4.8,1.4-5.4,1.4s-.9-.8-.9-1.1.1-.7.5-.8c.2-.1,2.3-.5,2.8-.6v-9.3ZM152.4,64.5c0,.4,0,1-1,1s-1-.6-1-1v-7.7c0-.6.2-1,1-1s.3,0,.4,0c-1-1.1-1.6-1.9-2-2.6h-2.9c-2.1,3.5-6.2,5.7-6.8,5.7s-1-.6-1-1.1.2-.6.6-.8c1.4-.7,3.4-1.8,5-3.8h-1.4c-1.6,0-2.3-.5-2.3-2.3v-5.7c0-1.8.7-2.3,2.3-2.3h9.8c1.6,0,2.3.6,2.3,2.3v5.7c0,1.7-.6,2.3-2.3,2.3h-1.4c1.2,1.5,2.5,2.6,3.1,2.9,1.5,1,1.6,1,1.6,1.5s-.5,1-1,1c-.7,0-2.4-1.5-3.1-2.2,0,.2,0,.2,0,.4v7.7ZM146.4,56.8c0,6.6-4.8,8.7-5.6,8.7s-1-.8-1-1.1c0-.5.3-.7.7-.8,3.4-1.8,3.9-4,4-6.6,0-.5,0-1.1,1-1.1s1,.7,1,1ZM147.2,47.4v-2.7h-3.4c-.6,0-.8.3-.8.8v1.9h4.3ZM147.2,48.9h-4.3v1.9c0,.5.2.8.8.8h3.4v-2.7ZM149.1,47.4h4.4v-1.9c0-.5-.2-.8-.8-.8h-3.6v2.7ZM149.1,48.9v2.7h3.6c.6,0,.8-.3.8-.8v-1.9h-4.4Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x33_堺_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(3)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M144.7,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M144.7,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M144.7.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1c0-9.4-7.6-17-17-17h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M167.4,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M178.1,29.7c-1,0-1.5-.7-1.5-1.4s0-.5.4-1.1l4.5-7.7c.6-1,1.3-1.1,1.6-1.1,1.1,0,1.5.8,1.5,1.5v8.4h1c.7,0,.8.5.8.7s0,.8-.8.8h-1v2.9c0,.6-.5.8-.9.8s-.9-.3-.9-.8v-2.9h-4.6ZM182.7,28.2v-7.3c0,0,0-.4-.3-.4s-.3,0-.3.2l-4,6.9c0,0,0,.2,0,.3,0,.2.1.3.3.3h4.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M171.9,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M185.3,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.4,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="161.8" y1="55.1" x2="161.8" y2="55.1" />
          <g>
            <line class="pn_st23" x1="161.8" y1="55.1" x2="164.3" y2="55.1" />
            <line class="pn_st30" x1="166.5" y1="55.1" x2="166.5" y2="55.1" />
            <line class="pn_st16" x1="166.5" y1="55.1" x2="188.9" y2="55.1" />
            <line class="pn_st23" x1="188.9" y1="55.1" x2="191.4" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M136,50.6h-2.2c-.2,0-1,0-1-1s.7-1,1-1h2.2v-5.5c0-.2,0-1,1-1s1,.8,1,1v5.5h1.7c.6,0,.9.4.9,1s-.2,1-.9,1h-1.7v8.8c.5-.1,1.3-.3,1.9-.5.1,0,.3,0,.5,0,.7,0,.8.8.8,1,0,.7-.4.8-2,1.2-3.1.9-4.8,1.4-5.4,1.4s-.9-.8-.9-1.1.1-.7.5-.8c.2-.1,2.3-.5,2.8-.6v-9.3ZM152.4,64.5c0,.4,0,1-1,1s-1-.6-1-1v-7.7c0-.6.2-1,1-1s.3,0,.4,0c-1-1.1-1.6-1.9-2-2.6h-2.9c-2.1,3.5-6.2,5.7-6.8,5.7s-1-.6-1-1.1.2-.6.6-.8c1.4-.7,3.4-1.8,5-3.8h-1.4c-1.6,0-2.3-.5-2.3-2.3v-5.7c0-1.8.7-2.3,2.3-2.3h9.8c1.6,0,2.3.6,2.3,2.3v5.7c0,1.7-.6,2.3-2.3,2.3h-1.4c1.2,1.5,2.5,2.6,3.1,2.9,1.5,1,1.6,1,1.6,1.5s-.5,1-1,1c-.7,0-2.4-1.5-3.1-2.2,0,.2,0,.2,0,.4v7.7ZM146.4,56.8c0,6.6-4.8,8.7-5.6,8.7s-1-.8-1-1.1c0-.5.3-.7.7-.8,3.4-1.8,3.9-4,4-6.6,0-.5,0-1.1,1-1.1s1,.7,1,1ZM147.2,47.4v-2.7h-3.4c-.6,0-.8.3-.8.8v1.9h4.3ZM147.2,48.9h-4.3v1.9c0,.5.2.8.8.8h3.4v-2.7ZM149.1,47.4h4.4v-1.9c0-.5-.2-.8-.8-.8h-3.6v2.7ZM149.1,48.9v2.7h3.6c.6,0,.8-.3.8-.8v-1.9h-4.4Z"
            />
          </g>
        </g>
      </g>
      <g id="_x32_岸和田_xFF1A_赤">
        <a @click="sendPointId(2)">
          <g>
            <path
              class="pn_st69"
              d="M81,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M81,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M81,.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1C98,7.8,90.4.1,81,.1h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M103.6,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
              />
              <path
                class="pn_st65"
                d="M117.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM114.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M108.2,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M121.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="98.1" y1="55.1" x2="98.1" y2="55.1" />
            <g>
              <line class="pn_st45" x1="98.1" y1="55.1" x2="100.6" y2="55.1" />
              <line class="pn_st24" x1="102.8" y1="55.1" x2="102.8" y2="55.1" />
              <line class="pn_st29" x1="102.8" y1="55.1" x2="125.2" y2="55.1" />
              <line class="pn_st45" x1="125.2" y1="55.1" x2="127.7" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M71,24.6c0-2,.8-2.7,2.7-2.7h17.9c.2,0,1,0,1,.9s-.6.9-1,.9h-17.4c-.7,0-1.1.3-1.1,1.1v3.4c0,1.6,0,4-1,7.2-.4,1.6-.8,2.3-1.5,2.3s-1.2-.3-1.2-1.1,0-.4.7-2c.3-.8,1-2.8,1-6.4v-3.7ZM79.9,15.6c0-.3,0-1,1-1s1.1.3,1.1,1v2.6h6.4c.5,0,.8-.3.8-.8v-1.3c0-.4,0-.9,1-.9s1,.5,1,1v1.6c0,1.7-.5,2.2-2.2,2.2h-16.1c-1.7,0-2.2-.5-2.2-2.2v-1.6c0-.5,0-1,1-1s1,.4,1,1v1.3c0,.5.2.8.8.8h6.3v-2.6ZM83.7,30.6h7.8c.2,0,1,0,1,.9s-.8,1-1,1h-7.8v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-7.4c-.2,0-1,0-1-.9s.7-.9,1-.9h7.4v-2.9h-6.5c-.2,0-1,0-1-.9s.6-.9,1-.9h15c.3,0,1,0,1,.9s-.6.9-1,.9h-6.4v2.9Z"
              />
              <path
                d="M76.3,48.8h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.7-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.5.8-.8,1-1.2,1s-1.2-.5-1.2-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.8c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.4-.2,4.2-.3,6.3-.8.4,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM91.7,62.2c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM89.6,46.9c0-.9-.5-1.1-1.1-1.1h-4.2c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.2c.7,0,1.1-.3,1.1-1.2v-15Z"
              />
              <path
                d="M91.6,88.9c0,2.5-.9,3.2-3.2,3.2h-14.7c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h14.7c2.3,0,3.2.8,3.2,3.2v15ZM79.9,80.2v-7.6h-5.9c-1.1,0-1.5.6-1.5,1.5v6.1h7.4ZM79.9,82.1h-7.4v6.6c0,1,.4,1.5,1.5,1.5h5.9v-8.1ZM82,80.2h7.5v-6.1c0-.9-.4-1.5-1.5-1.5h-6v7.6ZM82,82.1v8.1h6c1.1,0,1.5-.6,1.5-1.5v-6.6h-7.5Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x32_岸和田_xFF1A_青" v-if="this.clickedPointId === 2">
        <rect
          class="pn_st62"
          x="64"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M103.6,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M117.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM114.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M108.2,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M121.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="98.1" y1="55.1" x2="98.1" y2="55.1" />
          <g>
            <line class="pn_st23" x1="98.1" y1="55.1" x2="100.6" y2="55.1" />
            <line class="pn_st30" x1="102.8" y1="55.1" x2="102.8" y2="55.1" />
            <line class="pn_st16" x1="102.8" y1="55.1" x2="125.2" y2="55.1" />
            <line class="pn_st23" x1="125.2" y1="55.1" x2="127.7" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M71,24.6c0-2,.8-2.7,2.7-2.7h17.9c.2,0,1,0,1,.9s-.6.9-1,.9h-17.4c-.7,0-1.1.3-1.1,1.1v3.4c0,1.6,0,4-1,7.2-.4,1.6-.8,2.3-1.5,2.3s-1.2-.3-1.2-1.1,0-.4.7-2c.3-.8,1-2.8,1-6.4v-3.7ZM79.9,15.6c0-.3,0-1,1-1s1.1.3,1.1,1v2.6h6.4c.5,0,.8-.3.8-.8v-1.3c0-.4,0-.9,1-.9s1,.5,1,1v1.6c0,1.7-.5,2.2-2.2,2.2h-16.1c-1.7,0-2.2-.5-2.2-2.2v-1.6c0-.5,0-1,1-1s1,.4,1,1v1.3c0,.5.2.8.8.8h6.3v-2.6ZM83.7,30.6h7.8c.2,0,1,0,1,.9s-.8,1-1,1h-7.8v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-7.4c-.2,0-1,0-1-.9s.7-.9,1-.9h7.4v-2.9h-6.5c-.2,0-1,0-1-.9s.6-.9,1-.9h15c.3,0,1,0,1,.9s-.6.9-1,.9h-6.4v2.9Z"
            />
            <path
              class="pn_st63"
              d="M76.3,48.8h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.7-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.5.8-.8,1-1.2,1s-1.2-.5-1.2-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.8c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.4-.2,4.2-.3,6.3-.8.4,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM91.7,62.2c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM89.6,46.9c0-.9-.5-1.1-1.1-1.1h-4.2c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.2c.7,0,1.1-.3,1.1-1.2v-15Z"
            />
            <path
              class="pn_st63"
              d="M91.6,88.9c0,2.5-.9,3.2-3.2,3.2h-14.7c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h14.7c2.3,0,3.2.8,3.2,3.2v15ZM79.9,80.2v-7.6h-5.9c-1.1,0-1.5.6-1.5,1.5v6.1h7.4ZM79.9,82.1h-7.4v6.6c0,1,.4,1.5,1.5,1.5h5.9v-8.1ZM82,80.2h7.5v-6.1c0-.9-.4-1.5-1.5-1.5h-6v7.6ZM82,82.1v8.1h6c1.1,0,1.5-.6,1.5-1.5v-6.6h-7.5Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x32_岸和田_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(2)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M81,108.6c-8.5,0-15.5-7-15.5-15.5V17.1c0-8.5,7-15.5,15.5-15.5s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M81,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M81,.1h0c-9.4,0-17,7.6-17,17v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1C98,7.8,90.4.1,81,.1h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M103.6,22.7c-.2,0-.6-.2-.6-.6s.2-.6,1.4-.8c1.5-.3,2-1.1,2.3-2.2,0-.3.2-.7.8-.7s.7.3.7.6v13.6c0,.7-.5.8-.9.8-.6,0-.9-.3-.9-.8v-9.9h-2.9Z"
            />
            <path
              class="pn_st70"
              d="M117.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM114.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M108.2,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M121.6,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="98.1" y1="55.1" x2="98.1" y2="55.1" />
          <g>
            <line class="pn_st23" x1="98.1" y1="55.1" x2="100.6" y2="55.1" />
            <line class="pn_st30" x1="102.8" y1="55.1" x2="102.8" y2="55.1" />
            <line class="pn_st16" x1="102.8" y1="55.1" x2="125.2" y2="55.1" />
            <line class="pn_st23" x1="125.2" y1="55.1" x2="127.7" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M71,24.6c0-2,.8-2.7,2.7-2.7h17.9c.2,0,1,0,1,.9s-.6.9-1,.9h-17.4c-.7,0-1.1.3-1.1,1.1v3.4c0,1.6,0,4-1,7.2-.4,1.6-.8,2.3-1.5,2.3s-1.2-.3-1.2-1.1,0-.4.7-2c.3-.8,1-2.8,1-6.4v-3.7ZM79.9,15.6c0-.3,0-1,1-1s1.1.3,1.1,1v2.6h6.4c.5,0,.8-.3.8-.8v-1.3c0-.4,0-.9,1-.9s1,.5,1,1v1.6c0,1.7-.5,2.2-2.2,2.2h-16.1c-1.7,0-2.2-.5-2.2-2.2v-1.6c0-.5,0-1,1-1s1,.4,1,1v1.3c0,.5.2.8.8.8h6.3v-2.6ZM83.7,30.6h7.8c.2,0,1,0,1,.9s-.8,1-1,1h-7.8v4.6c0,.3,0,1-1,1s-1.1-.4-1.1-1v-4.6h-7.4c-.2,0-1,0-1-.9s.7-.9,1-.9h7.4v-2.9h-6.5c-.2,0-1,0-1-.9s.6-.9,1-.9h15c.3,0,1,0,1,.9s-.6.9-1,.9h-6.4v2.9Z"
            />
            <path
              d="M76.3,48.8h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.7-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.5.8-.8,1-1.2,1s-1.2-.5-1.2-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.8c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.4-.2,4.2-.3,6.3-.8.4,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM91.7,62.2c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM89.6,46.9c0-.9-.5-1.1-1.1-1.1h-4.2c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.2c.7,0,1.1-.3,1.1-1.2v-15Z"
            />
            <path
              d="M91.6,88.9c0,2.5-.9,3.2-3.2,3.2h-14.7c-2.3,0-3.2-.8-3.2-3.2v-15c0-2.4.9-3.2,3.2-3.2h14.7c2.3,0,3.2.8,3.2,3.2v15ZM79.9,80.2v-7.6h-5.9c-1.1,0-1.5.6-1.5,1.5v6.1h7.4ZM79.9,82.1h-7.4v6.6c0,1,.4,1.5,1.5,1.5h5.9v-8.1ZM82,80.2h7.5v-6.1c0-.9-.4-1.5-1.5-1.5h-6v7.6ZM82,82.1v8.1h6c1.1,0,1.5-.6,1.5-1.5v-6.6h-7.5Z"
            />
          </g>
        </g>
      </g>
      <g id="_x31_和歌山_xFF1A_赤">
        <a @click="sendPointId(1)">
          <g>
            <path
              class="pn_st69"
              d="M17.3,108.6c-8.5,0-15.5-7-15.5-15.5V17.1C1.8,8.6,8.8,1.6,17.3,1.6s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
            />
            <path
              class="pn_st66"
              d="M17.3,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M17.3.1C7.9.1.3,7.8.3,17.1v76c0,9.4,7.6,17,17,17s17-7.6,17-17V17.1C34.3,7.8,26.7.1,17.3.1h0Z"
            />
          </g>
          <g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M42.2,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
              />
              <path
                class="pn_st65"
                d="M54.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM51.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
              />
            </g>
            <g class="pn_st60">
              <path
                class="pn_st65"
                d="M44.5,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
              />
              <path
                class="pn_st65"
                d="M57.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
              />
            </g>
          </g>
          <g>
            <line class="pn_st0" x1="34.3" y1="55.1" x2="34.3" y2="55.1" />
            <g>
              <line class="pn_st45" x1="34.3" y1="55.1" x2="36.8" y2="55.1" />
              <line class="pn_st24" x1="39" y1="55.1" x2="39" y2="55.1" />
              <line class="pn_st29" x1="39" y1="55.1" x2="61.4" y2="55.1" />
              <line class="pn_st45" x1="61.4" y1="55.1" x2="63.9" y2="55.1" />
            </g>
          </g>
          <g class="pn_st60">
            <g class="pn_st60">
              <path
                d="M12.6,21.3h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.6-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.6.8-.8,1-1.2,1s-1.1-.5-1.1-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.9c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.5-.2,4.2-.3,6.3-.8.3,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM28,34.7c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM26,19.4c0-.9-.5-1.1-1.2-1.1h-4.1c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.1c.7,0,1.2-.3,1.2-1.2v-15Z"
              />
              <path
                d="M6.7,44.6c-.5,0-1-.2-1-.8s.4-.8.9-.8h11.2c.2,0,1,0,1,.8s-.4.8-1,.8h-.8v6.4c0,2.3-.9,2.3-3,2.3h-.5c-.5,0-1.2,0-1.2-.9s.7-.8,1-.8h1.3c.5,0,.6-.5.6-.8v-6.1H6.7ZM6.6,55.4c-.5,0-.9-.2-.9-.8s.3-.8.9-.8h11.2c.4,0,1,0,1,.8s-.3.8-1,.8h-.8v7.6c0,2.3-.8,2.4-3.3,2.4h-.7c-.7,0-1.4,0-1.4-1.1s.7-.8,1-.8,1.7,0,1.8,0c.4,0,.7-.2.7-.9v-7.1H6.6ZM13.6,49.1c0,1.7-.5,2.2-2.2,2.2h-2.5c-1.7,0-2.2-.5-2.2-2.2v-1.2c0-1.7.4-2.2,2.2-2.2h2.5c1.6,0,2.2.4,2.2,2.2v1.2ZM13.6,60.6c0,1.7-.5,2.3-2.3,2.3h-2.4c-1.8,0-2.3-.5-2.3-2.3v-1.7c0-1.7.5-2.3,2.3-2.3h2.4c1.7,0,2.3.5,2.3,2.3v1.7ZM11.9,47.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.3c0,.4.1.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.3ZM11.9,58.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.8c0,.4.2.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.8ZM21.9,50.6c0-.4,0-1.1.9-1.1s1,.3,1,1.1v1.7c0,.9,0,4,1.8,7.4.9,1.8,1.4,2.3,2.9,3.9.3.4.4.6.4.8,0,.5-.5,1.1-1.2,1.1s-.6-.2-1.5-1.2c-2.4-2.8-3-5.8-3.3-7-.3,1.3-1,4.5-3.5,7.3-.8.8-.9.9-1.2.9-.6,0-1.1-.5-1.1-1.1s.1-.5.4-.8c1.1-1.2,2.4-2.6,3.4-5.6.2-.7.9-2.8.9-5.4v-1.9ZM21.3,48.2c-.5,1.2-.9,2.2-1.8,3.7-.1.2-.4.5-.9.5s-1-.3-1-1,0-.3.2-.7c1.6-2.9,1.9-3.7,2.8-7.6.2-.7.4-1,.9-1s1,.1,1,.8-.5,2.5-.7,3.2h4c1,0,2.6,0,2.6,1.8s-.2,1.7-1,3.7c-.7,2-1,2-1.4,2s-1.1-.3-1.1-.8.2-.7.5-1.4c.2-.4,1-2.3,1-2.8s-.5-.5-1-.5h-4.3Z"
              />
              <path
                d="M16.2,70.7c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
              />
            </g>
          </g>
        </a>
      </g>
      <g id="_x31_和歌山_xFF1A_青" v-if="this.clickedPointId === 1">
        <rect
          class="pn_st62"
          x=".3"
          y=".1"
          width="34"
          height="110"
          rx="17"
          ry="17"
        />
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M42.2,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st70"
              d="M54.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM51.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M44.5,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M57.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="34.3" y1="55.1" x2="34.3" y2="55.1" />
          <g>
            <line class="pn_st23" x1="34.3" y1="55.1" x2="36.8" y2="55.1" />
            <line class="pn_st30" x1="39" y1="55.1" x2="39" y2="55.1" />
            <line class="pn_st16" x1="39" y1="55.1" x2="61.4" y2="55.1" />
            <line class="pn_st23" x1="61.4" y1="55.1" x2="63.9" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              class="pn_st63"
              d="M12.6,21.3h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.6-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.6.8-.8,1-1.2,1s-1.1-.5-1.1-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.9c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.5-.2,4.2-.3,6.3-.8.3,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM28,34.7c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM26,19.4c0-.9-.5-1.1-1.2-1.1h-4.1c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.1c.7,0,1.2-.3,1.2-1.2v-15Z"
            />
            <path
              class="pn_st63"
              d="M6.7,44.6c-.5,0-1-.2-1-.8s.4-.8.9-.8h11.2c.2,0,1,0,1,.8s-.4.8-1,.8h-.8v6.4c0,2.3-.9,2.3-3,2.3h-.5c-.5,0-1.2,0-1.2-.9s.7-.8,1-.8h1.3c.5,0,.6-.5.6-.8v-6.1H6.7ZM6.6,55.4c-.5,0-.9-.2-.9-.8s.3-.8.9-.8h11.2c.4,0,1,0,1,.8s-.3.8-1,.8h-.8v7.6c0,2.3-.8,2.4-3.3,2.4h-.7c-.7,0-1.4,0-1.4-1.1s.7-.8,1-.8,1.7,0,1.8,0c.4,0,.7-.2.7-.9v-7.1H6.6ZM13.6,49.1c0,1.7-.5,2.2-2.2,2.2h-2.5c-1.7,0-2.2-.5-2.2-2.2v-1.2c0-1.7.4-2.2,2.2-2.2h2.5c1.6,0,2.2.4,2.2,2.2v1.2ZM13.6,60.6c0,1.7-.5,2.3-2.3,2.3h-2.4c-1.8,0-2.3-.5-2.3-2.3v-1.7c0-1.7.5-2.3,2.3-2.3h2.4c1.7,0,2.3.5,2.3,2.3v1.7ZM11.9,47.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.3c0,.4.1.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.3ZM11.9,58.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.8c0,.4.2.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.8ZM21.9,50.6c0-.4,0-1.1.9-1.1s1,.3,1,1.1v1.7c0,.9,0,4,1.8,7.4.9,1.8,1.4,2.3,2.9,3.9.3.4.4.6.4.8,0,.5-.5,1.1-1.2,1.1s-.6-.2-1.5-1.2c-2.4-2.8-3-5.8-3.3-7-.3,1.3-1,4.5-3.5,7.3-.8.8-.9.9-1.2.9-.6,0-1.1-.5-1.1-1.1s.1-.5.4-.8c1.1-1.2,2.4-2.6,3.4-5.6.2-.7.9-2.8.9-5.4v-1.9ZM21.3,48.2c-.5,1.2-.9,2.2-1.8,3.7-.1.2-.4.5-.9.5s-1-.3-1-1,0-.3.2-.7c1.6-2.9,1.9-3.7,2.8-7.6.2-.7.4-1,.9-1s1,.1,1,.8-.5,2.5-.7,3.2h4c1,0,2.6,0,2.6,1.8s-.2,1.7-1,3.7c-.7,2-1,2-1.4,2s-1.1-.3-1.1-.8.2-.7.5-1.4c.2-.4,1-2.3,1-2.8s-.5-.5-1-.5h-4.3Z"
            />
            <path
              class="pn_st63"
              d="M16.2,70.7c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
            />
          </g>
        </g>
      </g>
      <g
        id="_x31_和歌山_xFF1A_緑"
        v-if="!this.arrivedPointIdList.includes(1)"
        class="cursor_not_allowed"
      >
        <g>
          <path
            class="pn_st63"
            d="M17.3,108.6c-8.5,0-15.5-7-15.5-15.5V17.1C1.8,8.6,8.8,1.6,17.3,1.6s15.5,7,15.5,15.5v76c0,8.5-7,15.5-15.5,15.5Z"
          />
          <path
            class="pn_st70"
            d="M17.3,3.1c7.7,0,14,6.3,14,14v76c0,7.7-6.3,14-14,14s-14-6.3-14-14V17.1c0-7.7,6.3-14,14-14M17.3.1h0C7.9.1.3,7.8.3,17.1v76c0,9.4,7.6,17,17,17h0c9.4,0,17-7.6,17-17V17.1C34.3,7.8,26.7.1,17.3.1h0Z"
          />
        </g>
        <g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M42.2,26.3c-.7,0-.7-.5-.7-.7,0-.5.3-.7.7-.7h.4c.6,0,2.5-.2,2.5-2.5s-1.2-2.4-2.4-2.4c-2.1,0-2.5,1.8-2.6,2.3,0,.4-.2.9-.9.9s-.9-.2-.9-.8c0-1,.9-3.9,4.4-3.9s4.1,1.6,4.1,3.9-1.4,2.8-1.9,3.1c1.1.6,2.4,1.3,2.4,3.7s-2,4.4-4.6,4.4c-4.3,0-4.8-3.7-4.8-4,0-.6.4-.9.8-.9.8,0,.8.4,1,1.1.2,1.4,1.6,2.3,2.9,2.3s3-.3,3-2.9-1.4-2.8-2.9-2.8h-.5Z"
            />
            <path
              class="pn_st70"
              d="M54.3,28.1c-.9,0-4.2-.4-4.2-4.8s2-4.9,4.5-4.9c4.3,0,5,3.8,5,7.1s-.9,5.4-1.5,6.2c-.7.9-2,1.7-3.6,1.7-2.9,0-4-2.3-4-3.2s.5-.8.8-.8c.6,0,.8.4.8.6.2.6.6,1.9,2.4,1.9,3.3,0,3.3-4.4,3.3-5.5-1.3,1.7-3.1,1.7-3.4,1.7ZM51.9,23.2c0,.7,0,3.4,2.8,3.4s2.9-1.3,2.9-3.4-.8-3.4-3-3.4-2.8,2.8-2.8,3.4Z"
            />
          </g>
          <g class="pn_st60">
            <path
              class="pn_st70"
              d="M44.5,37.6c.1-.1.2-.2.4-.2.4,0,.6.4.6.6s0,.2-.2.4l-2.2,2.1,2.6,3.9c0,0,.1.2.1.3,0,.3-.3.6-.7.6s-.3,0-.5-.3l-2.5-3.7-1.4,1.4v2c0,.4-.3.6-.6.6-.4,0-.6-.2-.6-.6v-9.4c0-.4.3-.6.6-.6s.6.2.6.6v5.8l3.7-3.5Z"
            />
            <path
              class="pn_st70"
              d="M57.8,44.8c0,.4-.3.6-.6.6s-.6-.2-.6-.6v-4.9c0-1-.7-1.4-1.4-1.4s-1.8.8-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-4.8c0-1.2-.9-1.5-1.4-1.5-1.5,0-1.8,1.6-1.8,2v4.3c0,.4-.3.6-.6.6-.5,0-.6-.3-.6-.6v-6.8c0-.4.3-.6.6-.6s.6.2.6.6v.7c.3-.4.8-1.3,2.1-1.3s1.8,1,2,1.4c.3-.5.8-1.4,2.2-1.4s2.3,1,2.3,2.2v5.1Z"
            />
          </g>
        </g>
        <g>
          <line class="pn_st0" x1="34.4" y1="55.1" x2="34.4" y2="55.1" />
          <g>
            <line class="pn_st23" x1="34.4" y1="55.1" x2="36.9" y2="55.1" />
            <line class="pn_st30" x1="39.1" y1="55.1" x2="39.1" y2="55.1" />
            <line class="pn_st16" x1="39.1" y1="55.1" x2="61.5" y2="55.1" />
            <line class="pn_st23" x1="61.5" y1="55.1" x2="64" y2="55.1" />
          </g>
        </g>
        <g class="pn_st60">
          <g class="pn_st60">
            <path
              d="M12.6,21.3h3.1c.2,0,1,0,1,1s-.8,1-1,1h-3.1v.3c.5.9,1.7,3.1,3.5,4.9.3.3.4.5.4.8,0,.6-.5,1.2-1,1.2s-.5-.1-1.3-1.1c-.5-.7-1.1-1.7-1.6-2.7v10.7c0,.3,0,1-1,1s-1-.5-1-1v-10.1c-.8,1.7-1.6,3.3-2.7,4.8-.6.8-.8,1-1.2,1s-1.1-.5-1.1-1.1.2-.7.5-1c2.1-2.3,3.5-4.8,4.5-7.6h-3.9c-.2,0-1,0-1-.9s.5-1,1-1h3.9v-3.6c-1,.1-2.8.3-3.8.3s-1,0-1-1,.6-.8.9-.9c2.5-.2,4.2-.3,6.3-.8.3,0,1.9-.5,2.2-.5.6,0,.8.6.8,1s0,.9-3.5,1.5v3.9ZM28,34.7c0,2.1-.9,2.8-2.8,2.8h-4.9c-1.9,0-2.8-.6-2.8-2.8v-15.7c0-2.1.8-2.8,2.8-2.8h4.9c2,0,2.8.7,2.8,2.8v15.7ZM26,19.4c0-.9-.5-1.1-1.2-1.1h-4.1c-.8,0-1.1.4-1.1,1.1v15c0,.8.3,1.2,1.1,1.2h4.1c.7,0,1.2-.3,1.2-1.2v-15Z"
            />
            <path
              d="M6.7,44.6c-.5,0-1-.2-1-.8s.4-.8.9-.8h11.2c.2,0,1,0,1,.8s-.4.8-1,.8h-.8v6.4c0,2.3-.9,2.3-3,2.3h-.5c-.5,0-1.2,0-1.2-.9s.7-.8,1-.8h1.3c.5,0,.6-.5.6-.8v-6.1H6.7ZM6.6,55.4c-.5,0-.9-.2-.9-.8s.3-.8.9-.8h11.2c.4,0,1,0,1,.8s-.3.8-1,.8h-.8v7.6c0,2.3-.8,2.4-3.3,2.4h-.7c-.7,0-1.4,0-1.4-1.1s.7-.8,1-.8,1.7,0,1.8,0c.4,0,.7-.2.7-.9v-7.1H6.6ZM13.6,49.1c0,1.7-.5,2.2-2.2,2.2h-2.5c-1.7,0-2.2-.5-2.2-2.2v-1.2c0-1.7.4-2.2,2.2-2.2h2.5c1.6,0,2.2.4,2.2,2.2v1.2ZM13.6,60.6c0,1.7-.5,2.3-2.3,2.3h-2.4c-1.8,0-2.3-.5-2.3-2.3v-1.7c0-1.7.5-2.3,2.3-2.3h2.4c1.7,0,2.3.5,2.3,2.3v1.7ZM11.9,47.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.3c0,.4.1.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.3ZM11.9,58.8c0-.4-.2-.6-.6-.6h-2.3c-.4,0-.6.2-.6.6v1.8c0,.4.2.6.6.6h2.3c.4,0,.6-.2.6-.6v-1.8ZM21.9,50.6c0-.4,0-1.1.9-1.1s1,.3,1,1.1v1.7c0,.9,0,4,1.8,7.4.9,1.8,1.4,2.3,2.9,3.9.3.4.4.6.4.8,0,.5-.5,1.1-1.2,1.1s-.6-.2-1.5-1.2c-2.4-2.8-3-5.8-3.3-7-.3,1.3-1,4.5-3.5,7.3-.8.8-.9.9-1.2.9-.6,0-1.1-.5-1.1-1.1s.1-.5.4-.8c1.1-1.2,2.4-2.6,3.4-5.6.2-.7.9-2.8.9-5.4v-1.9ZM21.3,48.2c-.5,1.2-.9,2.2-1.8,3.7-.1.2-.4.5-.9.5s-1-.3-1-1,0-.3.2-.7c1.6-2.9,1.9-3.7,2.8-7.6.2-.7.4-1,.9-1s1,.1,1,.8-.5,2.5-.7,3.2h4c1,0,2.6,0,2.6,1.8s-.2,1.7-1,3.7c-.7,2-1,2-1.4,2s-1.1-.3-1.1-.8.2-.7.5-1.4c.2-.4,1-2.3,1-2.8s-.5-.5-1-.5h-4.3Z"
            />
            <path
              d="M16.2,70.7c0-.3,0-1,1.1-1s1.1.4,1.1,1v19.8h6.2c.8,0,1.2-.4,1.2-1.1v-14.5c0-.3,0-1.1,1-1.1s1.2.4,1.2,1.1v14.9c0,2.1-.8,2.8-2.8,2.8h-15.8c-2,0-2.8-.7-2.8-2.8v-14.9c0-.3,0-1,1-1s1.2.4,1.2,1v14.5c0,.7.3,1.1,1.1,1.1h6.2v-19.8Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'HanshinshikokusetouchiMap',
  data () {
    return {
      dialog: false,
      clickedPointId: null
    }
  },
  props: [
    'arrivedPointIdList',
    'isDetail',
    'currentPointSequence',
    'isSecondGoalEnabled'
  ],
  watch: {
    currentPointSequence: {
      handler (newValue) {
        this.clickedPointId = this.currentPointSequence
      }
    }
  },
  async created () {
    this.clickedPointId = this.currentPointSequence
  },
  methods: {
    sendPointId (pointId) {
      this.clickedPointId = pointId
      this.$emit('clickedPointId', pointId)
    }
  }
}
</script>

<style type="text/css">
      .st0 {
        filter: url(#drop-shadow-157);
      }

      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st28, .st29, .st30, .st31, .st32, .st33, .st34, .st35, .st36, .st37, .st38, .st39, .st40, .st41, .st42, .st43, .st44, .st45, .st46, .st47, .st48, .st49, .st50, .st51, .st52, .st53, .st54, .st55, .st56, .st57, .st58, .st59, .st60, .st61, .st62, .st63, .st64, .st65, .st66, .st67, .st68, .st69, .st70, .st71, .st72, .st73, .st74, .st75, .st76, .st77, .st78, .st79, .st80, .st81, .st82, .st83, .st84, .st85, .st86, .st87, .st88, .st89, .st90, .st91, .st92, .st93, .st94, .st95, .st96, .st97, .st98, .st99, .st100, .st101, .st102, .st103, .st104, .st105, .st106, .st107, .st108, .st109, .st110, .st111, .st112, .st113, .st114, .st115, .st116, .st117, .st118, .st119, .st120, .st121, .st122, .st123, .st124, .st125, .st126, .st127, .st128, .st129, .st130, .st131, .st132, .st133, .st134, .st135, .st136, .st137, .st138, .st139, .st140, .st141, .st142, .st143, .st144, .st145, .st146, .st147, .st148, .st149, .st150, .st151, .st152, .st153, .st154, .st155, .st156, .st157, .st158, .st159, .st160, .st161, .st162, .st163, .st164, .st165, .st166, .st167, .st168, .st169, .st170, .st171, .st172, .st173, .st174, .st175, .st176, .st177, .st178, .st179, .st180, .st181, .st182, .st183, .st184, .st185, .st186, .st187, .st188, .st189, .st190, .st191, .st192, .st193, .st194, .st195, .st196, .st197, .st198, .st199, .st200, .st201, .st202, .st203, .st204, .st205, .st206, .st207, .st208, .st209, .st210, .st211, .st212, .st213, .st214, .st215, .st216, .st217, .st218, .st219, .st220, .st221, .st222, .st223, .st224, .st225, .st226, .st227, .st228, .st229, .st230, .st231, .st232, .st233, .st234, .st235, .st236, .st237, .st238, .st239, .st240, .st241, .st242, .st243, .st244, .st245, .st246, .st247, .st248, .st249, .st250, .st251, .st252, .st253, .st254, .st255, .st256, .st257, .st258, .st259, .st260, .st261, .st262, .st263, .st264, .st265, .st266, .st267, .st268, .st269, .st270, .st271, .st272, .st273, .st274, .st275, .st276, .st277, .st278, .st279, .st280, .st281, .st282, .st283, .st284, .st285, .st286, .st287, .st288, .st289, .st290, .st291, .st292, .st293, .st294, .st295, .st296, .st297, .st298, .st299, .st300, .st301, .st302, .st303, .st304, .st305, .st306, .st307, .st308, .st309, .st310, .st311, .st312, .st313, .st314, .st315, .st316, .st317, .st318, .st319, .st320, .st321, .st322, .st323, .st324, .st325, .st326, .st327, .st328, .st329, .st330, .st331, .st332, .st333, .st334, .st335, .st336, .st337, .st338, .st339, .st340 {
        stroke-width: 2px;
      }

      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st28, .st29, .st30, .st31, .st32, .st33, .st34, .st35, .st36, .st37, .st38, .st39, .st40, .st41, .st42, .st43, .st44, .st45, .st46, .st47, .st48, .st49, .st100, .st101, .st102, .st103, .st104, .st105, .st106, .st107, .st108, .st109, .st110, .st111, .st112, .st113, .st114, .st115, .st116, .st117, .st118, .st119, .st120, .st121, .st122, .st123, .st124, .st125, .st126, .st127, .st128, .st129, .st130, .st131, .st132, .st133, .st134, .st135, .st136, .st137, .st138, .st139, .st159, .st160, .st161, .st162, .st163, .st164, .st165, .st166, .st167, .st168, .st169, .st170, .st171, .st172, .st173, .st174, .st175, .st176, .st177, .st178, .st179, .st180, .st181, .st182, .st183, .st184, .st185, .st186, .st187, .st188, .st189, .st190, .st191, .st192, .st193, .st194, .st195, .st196, .st197, .st198, .st199, .st200, .st201, .st202, .st203, .st204, .st205, .st206, .st207, .st208, .st209, .st210, .st211, .st212, .st213, .st214, .st215, .st216, .st217, .st218, .st219, .st220, .st221, .st222, .st223, .st224, .st225, .st226, .st227, .st228, .st229, .st230, .st231, .st232, .st233, .st234, .st235, .st236, .st237, .st238, .st239, .st240, .st241, .st242, .st243, .st292, .st293, .st294, .st295, .st296, .st297, .st298, .st299, .st300, .st301, .st302, .st303, .st304, .st305, .st306, .st307, .st308, .st309, .st310, .st311, .st312, .st313, .st314, .st331, .st332, .st333, .st334, .st335, .st336, .st337, .st338, .st339, .st340 {
        stroke: #fff;
      }

      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st28, .st29, .st30, .st31, .st32, .st33, .st34, .st35, .st36, .st37, .st38, .st39, .st40, .st41, .st42, .st43, .st44, .st45, .st46, .st47, .st48, .st341 {
        fill: #ff641a;
      }

      .st0, .st1, .st2, .st3, .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15, .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st28, .st29, .st30, .st31, .st32, .st33, .st34, .st35, .st36, .st37, .st38, .st39, .st40, .st41, .st42, .st43, .st44, .st45, .st46, .st47, .st48, .st51, .st52, .st53, .st54, .st55, .st56, .st57, .st58, .st59, .st60, .st61, .st62, .st63, .st64, .st65, .st66, .st67, .st68, .st69, .st70, .st71, .st72, .st73, .st74, .st75, .st76, .st77, .st78, .st79, .st80, .st81, .st82, .st83, .st84, .st85, .st86, .st87, .st88, .st89, .st90, .st91, .st92, .st93, .st94, .st95, .st96, .st97, .st98, .st99, .st140, .st141, .st142, .st143, .st144, .st145, .st146, .st147, .st148, .st149, .st150, .st151, .st152, .st153, .st154, .st155, .st156, .st157, .st159, .st160, .st161, .st162, .st163, .st164, .st165, .st166, .st167, .st168, .st169, .st170, .st171, .st172, .st173, .st174, .st175, .st176, .st177, .st178, .st179, .st180, .st181, .st182, .st183, .st184, .st185, .st186, .st187, .st188, .st189, .st190, .st191, .st192, .st193, .st194, .st195, .st196, .st197, .st198, .st199, .st200, .st201, .st202, .st203, .st204, .st205, .st206, .st207, .st208, .st209, .st210, .st211, .st212, .st213, .st214, .st215, .st216, .st217, .st218, .st219, .st220, .st221, .st222, .st223, .st224, .st225, .st226, .st227, .st228, .st229, .st230, .st231, .st232, .st233, .st234, .st235, .st236, .st237, .st238, .st239, .st240, .st241, .st242, .st243 {
        stroke-miterlimit: 10;
      }

      .st1 {
        filter: url(#drop-shadow-154);
      }

      .st2 {
        filter: url(#drop-shadow-151);
      }

      .st3 {
        filter: url(#drop-shadow-184);
      }

      .st4 {
        filter: url(#drop-shadow-163);
      }

      .st5 {
        filter: url(#drop-shadow-178);
      }

      .st6 {
        filter: url(#drop-shadow-169);
      }

      .st7 {
        filter: url(#drop-shadow-160);
      }

      .st8 {
        filter: url(#drop-shadow-166);
      }

      .st9 {
        filter: url(#drop-shadow-172);
      }

      .st10 {
        filter: url(#drop-shadow-181);
      }

      .st11 {
        filter: url(#drop-shadow-187);
      }

      .st12 {
        filter: url(#drop-shadow-133);
      }

      .st13 {
        filter: url(#drop-shadow-136);
      }

      .st14 {
        filter: url(#drop-shadow-139);
      }

      .st15 {
        filter: url(#drop-shadow-130);
      }

      .st16 {
        filter: url(#drop-shadow-175);
      }

      .st17 {
        filter: url(#drop-shadow-112);
      }

      .st18 {
        filter: url(#drop-shadow-199);
      }

      .st19 {
        filter: url(#drop-shadow-103);
      }

      .st20 {
        filter: url(#drop-shadow-106);
      }

      .st21 {
        filter: url(#drop-shadow-100);
      }

      .st22 {
        filter: url(#drop-shadow-142);
      }

      .st23 {
        filter: url(#drop-shadow-148);
      }

      .st24 {
        filter: url(#drop-shadow-109);
      }

      .st25 {
        filter: url(#drop-shadow-196);
      }

      .st26 {
        filter: url(#drop-shadow-145);
      }

      .st27 {
        filter: url(#drop-shadow-193);
      }

      .st28 {
        filter: url(#drop-shadow-124);
      }

      .st29 {
        filter: url(#drop-shadow-127);
      }

      .st30 {
        filter: url(#drop-shadow-121);
      }

      .st31 {
        filter: url(#drop-shadow-115);
      }

      .st32 {
        filter: url(#drop-shadow-118);
      }

      .st33 {
        filter: url(#drop-shadow-190);
      }

      .st342 {
        fill: #e7e8e6;
      }

      .st34 {
        filter: url(#drop-shadow-241);
      }

      .st35 {
        filter: url(#drop-shadow-244);
      }

      .st36 {
        filter: url(#drop-shadow-232);
      }

      .st37 {
        filter: url(#drop-shadow-235);
      }

      .st38 {
        filter: url(#drop-shadow-238);
      }

      .st39 {
        filter: url(#drop-shadow-217);
      }

      .st40 {
        filter: url(#drop-shadow-214);
      }

      .st41 {
        filter: url(#drop-shadow-220);
      }

      .st42 {
        filter: url(#drop-shadow-223);
      }

      .st43 {
        filter: url(#drop-shadow-229);
      }

      .st44 {
        filter: url(#drop-shadow-226);
      }

      .st45 {
        filter: url(#drop-shadow-202);
      }

      .st46 {
        filter: url(#drop-shadow-208);
      }

      .st47 {
        filter: url(#drop-shadow-205);
      }

      .st48 {
        filter: url(#drop-shadow-211);
      }

      .st343 {
        fill: #b9d546;
      }

      .st49 {
        stroke-dasharray: 4.47 1.11 .01 0;
      }

      .st49, .st50, .st100, .st101, .st102, .st103, .st104, .st105, .st106, .st107, .st108, .st109, .st110, .st111, .st112, .st113, .st114, .st115, .st116, .st117, .st118, .st119, .st120, .st121, .st122, .st123, .st124, .st125, .st126, .st127, .st128, .st129, .st130, .st131, .st132, .st133, .st134, .st135, .st136, .st137, .st138, .st139, .st158, .st244, .st245, .st246, .st247, .st248, .st249, .st250, .st251, .st252, .st253, .st254, .st255, .st256, .st257, .st258, .st259, .st260, .st261, .st262, .st263, .st264, .st265, .st266, .st267, .st268, .st269, .st270, .st271, .st272, .st273, .st274, .st275, .st276, .st277, .st278, .st279, .st280, .st281, .st282, .st283, .st284, .st285, .st286, .st287, .st288, .st289, .st290, .st291, .st292, .st293, .st294, .st295, .st296, .st297, .st298, .st299, .st300, .st301, .st302, .st303, .st304, .st305, .st306, .st307, .st308, .st309, .st310, .st311, .st312, .st313, .st314, .st315, .st316, .st317, .st318, .st319, .st320, .st321, .st322, .st323, .st324, .st325, .st326, .st327, .st328, .st329, .st330, .st344, .st331, .st332, .st333, .st334, .st335, .st336, .st337, .st338, .st339, .st340 {
        fill: none;
        stroke-linejoin: round;
      }

      .st345 {
        fill: #c7d65a;
      }

      .st346 {
        fill: #8d6828;
      }

      .st347 {
        fill: #97ca6b;
      }

      .st50 {
        filter: url(#drop-shadow-99);
      }

      .st50, .st244, .st245, .st246, .st247, .st248, .st249, .st250, .st251, .st252, .st253, .st254, .st255, .st256, .st257, .st258, .st259, .st260, .st261, .st262, .st263, .st264, .st265, .st266, .st267, .st268, .st269, .st270, .st271, .st272, .st273, .st274, .st275, .st276, .st277, .st278, .st279, .st280, .st281, .st282, .st283, .st284, .st285, .st286, .st287, .st288, .st289, .st290, .st291 {
        stroke: #ff641a;
      }

      .st51 {
        filter: url(#drop-shadow-224);
      }

      .st51, .st52, .st53, .st54, .st55, .st56, .st57, .st58, .st59, .st60, .st61, .st62, .st63, .st64, .st65, .st66, .st67, .st68, .st69, .st70, .st71, .st72, .st73, .st74, .st75, .st76, .st77, .st78, .st79, .st80, .st81, .st82, .st83, .st84, .st85, .st86, .st87, .st88, .st89, .st90, .st91, .st92, .st93, .st94, .st95, .st96, .st97, .st98, .st99 {
        stroke: #639;
      }

      .st51, .st52, .st53, .st54, .st55, .st56, .st57, .st58, .st59, .st60, .st61, .st62, .st63, .st64, .st65, .st66, .st67, .st68, .st69, .st70, .st71, .st72, .st73, .st74, .st75, .st76, .st77, .st78, .st79, .st80, .st81, .st82, .st83, .st84, .st85, .st86, .st87, .st88, .st89, .st90, .st91, .st92, .st93, .st94, .st95, .st96, .st97, .st98, .st99, .st140, .st141, .st142, .st143, .st144, .st145, .st146, .st147, .st148, .st149, .st150, .st151, .st152, .st153, .st154, .st155, .st156, .st157, .st348 {
        fill: #fff;
      }

      .st52 {
        filter: url(#drop-shadow-221);
      }

      .st53 {
        filter: url(#drop-shadow-215);
      }

      .st54 {
        filter: url(#drop-shadow-212);
      }

      .st55 {
        filter: url(#drop-shadow-218);
      }

      .st56 {
        filter: url(#drop-shadow-227);
      }

      .st57 {
        filter: url(#drop-shadow-200);
      }

      .st58 {
        filter: url(#drop-shadow-206);
      }

      .st59 {
        filter: url(#drop-shadow-209);
      }

      .st60 {
        filter: url(#drop-shadow-203);
      }

      .st61 {
        filter: url(#drop-shadow-239);
      }

      .st62 {
        filter: url(#drop-shadow-230);
      }

      .st63 {
        filter: url(#drop-shadow-233);
      }

      .st64 {
        filter: url(#drop-shadow-236);
      }

      .st65 {
        filter: url(#drop-shadow-242);
      }

      .st66 {
        filter: url(#drop-shadow-245);
      }

      .st67 {
        filter: url(#drop-shadow-110);
      }

      .st68 {
        filter: url(#drop-shadow-113);
      }

      .st69 {
        filter: url(#drop-shadow-107);
      }

      .st70 {
        filter: url(#drop-shadow-104);
      }

      .st71 {
        filter: url(#drop-shadow-101);
      }

      .st72 {
        filter: url(#drop-shadow-116);
      }

      .st73 {
        filter: url(#drop-shadow-119);
      }

      .st74 {
        filter: url(#drop-shadow-122);
      }

      .st75 {
        filter: url(#drop-shadow-125);
      }

      .st76 {
        filter: url(#drop-shadow-128);
      }

      .st77 {
        filter: url(#drop-shadow-197);
      }

      .st78 {
        filter: url(#drop-shadow-140);
      }

      .st79 {
        filter: url(#drop-shadow-146);
      }

      .st80 {
        filter: url(#drop-shadow-143);
      }

      .st81 {
        filter: url(#drop-shadow-149);
      }

      .st82 {
        filter: url(#drop-shadow-185);
      }

      .st83 {
        filter: url(#drop-shadow-182);
      }

      .st84 {
        filter: url(#drop-shadow-188);
      }

      .st85 {
        filter: url(#drop-shadow-176);
      }

      .st86 {
        filter: url(#drop-shadow-170);
      }

      .st87 {
        filter: url(#drop-shadow-167);
      }

      .st88 {
        filter: url(#drop-shadow-164);
      }

      .st89 {
        filter: url(#drop-shadow-161);
      }

      .st90 {
        filter: url(#drop-shadow-152);
      }

      .st91 {
        filter: url(#drop-shadow-158);
      }

      .st92 {
        filter: url(#drop-shadow-155);
      }

      .st93 {
        filter: url(#drop-shadow-131);
      }

      .st94 {
        filter: url(#drop-shadow-137);
      }

      .st95 {
        filter: url(#drop-shadow-191);
      }

      .st96 {
        filter: url(#drop-shadow-194);
      }

      .st97 {
        filter: url(#drop-shadow-179);
      }

      .st98 {
        filter: url(#drop-shadow-173);
      }

      .st99 {
        filter: url(#drop-shadow-134);
      }

      .st100 {
        filter: url(#drop-shadow-47);
      }

      .st100, .st101, .st102, .st103, .st104, .st105, .st106, .st107, .st108, .st109, .st110, .st111, .st112, .st113, .st114, .st115, .st116, .st117, .st118, .st119, .st120, .st121, .st122, .st123, .st124, .st125, .st126, .st127, .st128, .st129, .st130, .st131, .st132, .st133, .st134, .st135, .st136, .st137, .st138, .st139, .st293, .st294, .st295, .st296, .st297, .st298, .st299, .st300, .st301, .st302, .st303, .st304, .st305, .st306, .st307, .st308, .st309, .st310, .st311, .st312, .st313, .st314, .st331, .st332, .st333, .st334, .st335, .st336, .st337, .st338, .st339 {
        stroke-dasharray: 4 1 0 0;
      }

      .st101 {
        filter: url(#drop-shadow-49);
      }

      .st102 {
        filter: url(#drop-shadow-48);
      }

      .st103 {
        filter: url(#drop-shadow-43);
      }

      .st104 {
        filter: url(#drop-shadow-44);
      }

      .st105 {
        filter: url(#drop-shadow-42);
      }

      .st106 {
        filter: url(#drop-shadow-46);
      }

      .st107 {
        filter: url(#drop-shadow-45);
      }

      .st108 {
        filter: url(#drop-shadow-41);
      }

      .st109 {
        filter: url(#drop-shadow-40);
      }

      .st110 {
        filter: url(#drop-shadow-36);
      }

      .st111 {
        filter: url(#drop-shadow-25);
      }

      .st112 {
        filter: url(#drop-shadow-33);
      }

      .st113 {
        filter: url(#drop-shadow-20);
      }

      .st114 {
        filter: url(#drop-shadow-24);
      }

      .st115 {
        filter: url(#drop-shadow-26);
      }

      .st116 {
        filter: url(#drop-shadow-21);
      }

      .st117 {
        filter: url(#drop-shadow-23);
      }

      .st118 {
        filter: url(#drop-shadow-35);
      }

      .st119 {
        filter: url(#drop-shadow-34);
      }

      .st120 {
        filter: url(#drop-shadow-38);
      }

      .st121 {
        filter: url(#drop-shadow-37);
      }

      .st122 {
        filter: url(#drop-shadow-22);
      }

      .st123 {
        filter: url(#drop-shadow-39);
      }

      .st124 {
        filter: url(#drop-shadow-27);
      }

      .st125 {
        filter: url(#drop-shadow-29);
      }

      .st126 {
        filter: url(#drop-shadow-28);
      }

      .st127 {
        filter: url(#drop-shadow-17);
      }

      .st128 {
        filter: url(#drop-shadow-11);
      }

      .st129 {
        filter: url(#drop-shadow-10);
      }

      .st130 {
        filter: url(#drop-shadow-12);
      }

      .st131 {
        filter: url(#drop-shadow-16);
      }

      .st132 {
        filter: url(#drop-shadow-14);
      }

      .st133 {
        filter: url(#drop-shadow-19);
      }

      .st134 {
        filter: url(#drop-shadow-18);
      }

      .st135 {
        filter: url(#drop-shadow-13);
      }

      .st136 {
        filter: url(#drop-shadow-30);
      }

      .st137 {
        filter: url(#drop-shadow-32);
      }

      .st138 {
        filter: url(#drop-shadow-31);
      }

      .st139 {
        filter: url(#drop-shadow-15);
      }

      .st140 {
        filter: url(#drop-shadow-283);
      }

      .st140, .st141, .st142, .st143, .st144, .st145, .st146, .st147, .st148, .st149, .st150, .st151, .st152, .st153, .st154, .st155, .st156, .st157 {
        stroke: #0066bd;
      }

      .st141 {
        filter: url(#drop-shadow-298);
      }

      .st142 {
        filter: url(#drop-shadow-286);
      }

      .st143 {
        filter: url(#drop-shadow-289);
      }

      .st144 {
        filter: url(#drop-shadow-307);
      }

      .st145 {
        filter: url(#drop-shadow-301);
      }

      .st146 {
        filter: url(#drop-shadow-304);
      }

      .st147 {
        filter: url(#drop-shadow-316);
      }

      .st148 {
        filter: url(#drop-shadow-313);
      }

      .st149 {
        filter: url(#drop-shadow-310);
      }

      .st150 {
        filter: url(#drop-shadow-328);
      }

      .st151 {
        filter: url(#drop-shadow-319);
      }

      .st152 {
        filter: url(#drop-shadow-324);
      }

      .st153 {
        filter: url(#drop-shadow-295);
      }

      .st154 {
        filter: url(#drop-shadow-292);
      }

      .st155 {
        filter: url(#drop-shadow-335);
      }

      .st156 {
        filter: url(#drop-shadow-337);
      }

      .st157 {
        filter: url(#drop-shadow-332);
      }

      .st158, .st315, .st316, .st317, .st318, .st319, .st320, .st321, .st322, .st323, .st324, .st325, .st326, .st327, .st328, .st329, .st330 {
        stroke: #c39;
      }

      .st159 {
        filter: url(#drop-shadow-334);
      }

      .st159, .st160, .st161, .st162, .st163, .st164, .st165, .st166, .st167, .st168, .st169, .st170, .st171, .st172, .st173, .st174, .st175, .st176, .st349 {
        fill: #c39;
      }

      .st160 {
        filter: url(#drop-shadow-331);
      }

      .st161 {
        filter: url(#drop-shadow-336);
      }

      .st162 {
        filter: url(#drop-shadow-306);
      }

      .st163 {
        filter: url(#drop-shadow-300);
      }

      .st164 {
        filter: url(#drop-shadow-303);
      }

      .st165 {
        filter: url(#drop-shadow-282);
      }

      .st166 {
        filter: url(#drop-shadow-285);
      }

      .st167 {
        filter: url(#drop-shadow-288);
      }

      .st168 {
        filter: url(#drop-shadow-297);
      }

      .st169 {
        filter: url(#drop-shadow-294);
      }

      .st170 {
        filter: url(#drop-shadow-291);
      }

      .st171 {
        filter: url(#drop-shadow-322);
      }

      .st172 {
        filter: url(#drop-shadow-315);
      }

      .st173 {
        filter: url(#drop-shadow-318);
      }

      .st174 {
        filter: url(#drop-shadow-312);
      }

      .st175 {
        filter: url(#drop-shadow-309);
      }

      .st176 {
        filter: url(#drop-shadow-327);
      }

      .st177 {
        filter: url(#drop-shadow-262);
      }

      .st177, .st178, .st179, .st180, .st181, .st182, .st183, .st184, .st185, .st186, .st187, .st188, .st189, .st190, .st191, .st192, .st193, .st194 {
        fill: #22ac38;
      }

      .st178 {
        filter: url(#drop-shadow-264);
      }

      .st179 {
        filter: url(#drop-shadow-261);
      }

      .st180 {
        filter: url(#drop-shadow-266);
      }

      .st181 {
        filter: url(#drop-shadow-265);
      }

      .st182 {
        filter: url(#drop-shadow-268);
      }

      .st183 {
        filter: url(#drop-shadow-269);
      }

      .st184 {
        filter: url(#drop-shadow-263);
      }

      .st185 {
        filter: url(#drop-shadow-267);
      }

      .st186 {
        filter: url(#drop-shadow-279);
      }

      .st187 {
        filter: url(#drop-shadow-278);
      }

      .st188 {
        filter: url(#drop-shadow-274);
      }

      .st189 {
        filter: url(#drop-shadow-273);
      }

      .st190 {
        filter: url(#drop-shadow-272);
      }

      .st191 {
        filter: url(#drop-shadow-270);
      }

      .st192 {
        filter: url(#drop-shadow-275);
      }

      .st193 {
        filter: url(#drop-shadow-280);
      }

      .st194 {
        filter: url(#drop-shadow-271);
      }

      .st350 {
        fill: #dcdddd;
      }

      .st351 {
        fill: #cb5520;
      }

      .st195 {
        filter: url(#drop-shadow-63);
      }

      .st195, .st196, .st197, .st198, .st199, .st200, .st201, .st202, .st203, .st204, .st205, .st206, .st207, .st208, .st209, .st210, .st211, .st212, .st213, .st214, .st215, .st216, .st217, .st218, .st219, .st220, .st221, .st222, .st223, .st224, .st225, .st226, .st227, .st228, .st229, .st230, .st231, .st232, .st233, .st234, .st235, .st236, .st237, .st238, .st239, .st240, .st241, .st242, .st243 {
        fill: #099;
      }

      .st196 {
        filter: url(#drop-shadow-62);
      }

      .st197 {
        filter: url(#drop-shadow-75);
      }

      .st198 {
        filter: url(#drop-shadow-74);
      }

      .st199 {
        filter: url(#drop-shadow-66);
      }

      .st200 {
        filter: url(#drop-shadow-61);
      }

      .st201 {
        filter: url(#drop-shadow-67);
      }

      .st202 {
        filter: url(#drop-shadow-78);
      }

      .st203 {
        filter: url(#drop-shadow-80);
      }

      .st204 {
        filter: url(#drop-shadow-83);
      }

      .st205 {
        filter: url(#drop-shadow-98);
      }

      .st206 {
        filter: url(#drop-shadow-97);
      }

      .st207 {
        filter: url(#drop-shadow-86);
      }

      .st208 {
        filter: url(#drop-shadow-89);
      }

      .st209 {
        filter: url(#drop-shadow-84);
      }

      .st210 {
        filter: url(#drop-shadow-81);
      }

      .st211 {
        filter: url(#drop-shadow-93);
      }

      .st212 {
        filter: url(#drop-shadow-91);
      }

      .st213 {
        filter: url(#drop-shadow-68);
      }

      .st214 {
        filter: url(#drop-shadow-90);
      }

      .st215 {
        filter: url(#drop-shadow-92);
      }

      .st216 {
        filter: url(#drop-shadow-95);
      }

      .st217 {
        filter: url(#drop-shadow-82);
      }

      .st218 {
        filter: url(#drop-shadow-69);
      }

      .st219 {
        filter: url(#drop-shadow-96);
      }

      .st220 {
        filter: url(#drop-shadow-94);
      }

      .st221 {
        filter: url(#drop-shadow-64);
      }

      .st222 {
        filter: url(#drop-shadow-73);
      }

      .st223 {
        filter: url(#drop-shadow-77);
      }

      .st224 {
        filter: url(#drop-shadow-72);
      }

      .st225 {
        filter: url(#drop-shadow-76);
      }

      .st226 {
        filter: url(#drop-shadow-71);
      }

      .st227 {
        filter: url(#drop-shadow-79);
      }

      .st228 {
        filter: url(#drop-shadow-70);
      }

      .st229 {
        filter: url(#drop-shadow-65);
      }

      .st230 {
        filter: url(#drop-shadow-60);
      }

      .st231 {
        filter: url(#drop-shadow-87);
      }

      .st232 {
        filter: url(#drop-shadow-88);
      }

      .st233 {
        filter: url(#drop-shadow-85);
      }

      .st234 {
        filter: url(#drop-shadow-55);
      }

      .st235 {
        filter: url(#drop-shadow-51);
      }

      .st236 {
        filter: url(#drop-shadow-52);
      }

      .st237 {
        filter: url(#drop-shadow-54);
      }

      .st238 {
        filter: url(#drop-shadow-53);
      }

      .st239 {
        filter: url(#drop-shadow-50);
      }

      .st240 {
        filter: url(#drop-shadow-59);
      }

      .st241 {
        filter: url(#drop-shadow-56);
      }

      .st242 {
        filter: url(#drop-shadow-58);
      }

      .st243 {
        filter: url(#drop-shadow-57);
      }

      .st244 {
        filter: url(#drop-shadow-153);
      }

      .st245 {
        filter: url(#drop-shadow-150);
      }

      .st246 {
        filter: url(#drop-shadow-156);
      }

      .st247 {
        filter: url(#drop-shadow-168);
      }

      .st248 {
        filter: url(#drop-shadow-162);
      }

      .st249 {
        filter: url(#drop-shadow-165);
      }

      .st250 {
        filter: url(#drop-shadow-159);
      }

      .st251 {
        filter: url(#drop-shadow-189);
      }

      .st252 {
        filter: url(#drop-shadow-186);
      }

      .st253 {
        filter: url(#drop-shadow-183);
      }

      .st254 {
        filter: url(#drop-shadow-180);
      }

      .st255 {
        filter: url(#drop-shadow-177);
      }

      .st256 {
        filter: url(#drop-shadow-174);
      }

      .st257 {
        filter: url(#drop-shadow-171);
      }

      .st258 {
        filter: url(#drop-shadow-120);
      }

      .st259 {
        filter: url(#drop-shadow-129);
      }

      .st260 {
        filter: url(#drop-shadow-114);
      }

      .st261 {
        filter: url(#drop-shadow-123);
      }

      .st262 {
        filter: url(#drop-shadow-117);
      }

      .st263 {
        filter: url(#drop-shadow-126);
      }

      .st264 {
        filter: url(#drop-shadow-111);
      }

      .st265 {
        filter: url(#drop-shadow-108);
      }

      .st266 {
        filter: url(#drop-shadow-198);
      }

      .st267 {
        filter: url(#drop-shadow-102);
      }

      .st268 {
        filter: url(#drop-shadow-105);
      }

      .st269 {
        filter: url(#drop-shadow-138);
      }

      .st270 {
        filter: url(#drop-shadow-132);
      }

      .st271 {
        filter: url(#drop-shadow-195);
      }

      .st272 {
        filter: url(#drop-shadow-192);
      }

      .st273 {
        filter: url(#drop-shadow-141);
      }

      .st274 {
        filter: url(#drop-shadow-144);
      }

      .st275 {
        filter: url(#drop-shadow-135);
      }

      .st276 {
        filter: url(#drop-shadow-147);
      }

      .st277 {
        filter: url(#drop-shadow-210);
      }

      .st278 {
        filter: url(#drop-shadow-204);
      }

      .st279 {
        filter: url(#drop-shadow-213);
      }

      .st280 {
        filter: url(#drop-shadow-219);
      }

      .st281 {
        filter: url(#drop-shadow-228);
      }

      .st282 {
        filter: url(#drop-shadow-225);
      }

      .st283 {
        filter: url(#drop-shadow-216);
      }

      .st284 {
        filter: url(#drop-shadow-222);
      }

      .st285 {
        filter: url(#drop-shadow-240);
      }

      .st286 {
        filter: url(#drop-shadow-243);
      }

      .st287 {
        filter: url(#drop-shadow-237);
      }

      .st288 {
        filter: url(#drop-shadow-234);
      }

      .st289 {
        filter: url(#drop-shadow-231);
      }

      .st290 {
        filter: url(#drop-shadow-207);
      }

      .st291 {
        filter: url(#drop-shadow-201);
      }

      .st293 {
        filter: url(#drop-shadow-249);
      }

      .st294 {
        filter: url(#drop-shadow-246);
      }

      .st295 {
        filter: url(#drop-shadow-248);
      }

      .st296 {
        filter: url(#drop-shadow-247);
      }

      .st297 {
        filter: url(#drop-shadow-320);
      }

      .st298 {
        filter: url(#drop-shadow-323);
      }

      .st299 {
        filter: url(#drop-shadow-321);
      }

      .st300 {
        filter: url(#drop-shadow-326);
      }

      .st301 {
        filter: url(#drop-shadow-253);
      }

      .st302 {
        filter: url(#drop-shadow-259);
      }

      .st303 {
        filter: url(#drop-shadow-254);
      }

      .st304 {
        filter: url(#drop-shadow-252);
      }

      .st305 {
        filter: url(#drop-shadow-257);
      }

      .st306 {
        filter: url(#drop-shadow-251);
      }

      .st307 {
        filter: url(#drop-shadow-255);
      }

      .st308 {
        filter: url(#drop-shadow-258);
      }

      .st309 {
        filter: url(#drop-shadow-256);
      }

      .st310 {
        filter: url(#drop-shadow-250);
      }

      .st311 {
        filter: url(#drop-shadow-260);
      }

      .st312 {
        filter: url(#drop-shadow-276);
      }

      .st313 {
        filter: url(#drop-shadow-277);
      }

      .st314 {
        filter: url(#drop-shadow-330);
      }

      .st352 {
        fill: #ffef00;
      }

      .st315 {
        filter: url(#drop-shadow-305);
      }

      .st316 {
        filter: url(#drop-shadow-302);
      }

      .st317 {
        filter: url(#drop-shadow-325);
      }

      .st318 {
        filter: url(#drop-shadow-314);
      }

      .st319 {
        filter: url(#drop-shadow-317);
      }

      .st320 {
        filter: url(#drop-shadow-308);
      }

      .st321 {
        filter: url(#drop-shadow-311);
      }

      .st322 {
        filter: url(#drop-shadow-329);
      }

      .st323 {
        filter: url(#drop-shadow-333);
      }

      .st324 {
        filter: url(#drop-shadow-293);
      }

      .st325 {
        filter: url(#drop-shadow-290);
      }

      .st326 {
        filter: url(#drop-shadow-284);
      }

      .st327 {
        filter: url(#drop-shadow-296);
      }

      .st328 {
        filter: url(#drop-shadow-299);
      }

      .st329 {
        filter: url(#drop-shadow-281);
      }

      .st330 {
        filter: url(#drop-shadow-287);
      }

      .st344 {
        stroke: #f39800;
        stroke-linecap: round;
        stroke-width: .71px;
      }

      .st331 {
        filter: url(#drop-shadow-2);
      }

      .st332 {
        filter: url(#drop-shadow-1);
      }

      .st333 {
        filter: url(#drop-shadow-3);
      }

      .st334 {
        filter: url(#drop-shadow-9);
      }

      .st335 {
        filter: url(#drop-shadow-5);
      }

      .st336 {
        filter: url(#drop-shadow-7);
      }

      .st337 {
        filter: url(#drop-shadow-8);
      }

      .st338 {
        filter: url(#drop-shadow-6);
      }

      .st339 {
        filter: url(#drop-shadow-4);
      }

      .st353 {
        fill: #dcda5e;
      }

      .st340 {
        stroke-dasharray: .01 0;
      }

      .pn_st0, .pn_st1, .pn_st2, .pn_st3, .pn_st4, .pn_st5, .pn_st6, .pn_st7, .pn_st8, .pn_st9, .pn_st10, .pn_st11, .pn_st12, .pn_st13, .pn_st14, .pn_st15, .pn_st16, .pn_st17, .pn_st18, .pn_st19, .pn_st20, .pn_st21, .pn_st22, .pn_st23, .pn_st24, .pn_st25, .pn_st26, .pn_st27, .pn_st28, .pn_st29, .pn_st30, .pn_st31, .pn_st32, .pn_st33, .pn_st34, .pn_st35, .pn_st36, .pn_st37, .pn_st38, .pn_st39, .pn_st40, .pn_st41, .pn_st42, .pn_st43, .pn_st44, .pn_st45, .pn_st46, .pn_st47, .pn_st48, .pn_st49, .pn_st50, .pn_st51, .pn_st52, .pn_st53, .pn_st54, .pn_st55, .pn_st56 {
        fill: none;
      }

      .pn_st1, .pn_st2, .pn_st3, .pn_st4, .pn_st5, .pn_st6, .pn_st7, .pn_st8, .pn_st9, .pn_st10, .pn_st11, .pn_st12, .pn_st13, .pn_st14, .pn_st15, .pn_st16, .pn_st17, .pn_st18, .pn_st19, .pn_st20, .pn_st21, .pn_st22, .pn_st23, .pn_st24, .pn_st25, .pn_st26, .pn_st27, .pn_st28, .pn_st29, .pn_st30, .pn_st31, .pn_st32, .pn_st33, .pn_st34, .pn_st35, .pn_st36, .pn_st37, .pn_st38, .pn_st39, .pn_st40, .pn_st41, .pn_st42, .pn_st43, .pn_st44, .pn_st45, .pn_st46, .pn_st47, .pn_st48, .pn_st49, .pn_st50, .pn_st51, .pn_st52, .pn_st53, .pn_st54, .pn_st55, .pn_st56 {
        stroke-linejoin: round;
        stroke-width: 4px;
      }

      .pn_st1, .pn_st9, .pn_st11, .pn_st20, .pn_st21, .pn_st26, .pn_st32, .pn_st33, .pn_st35, .pn_st39, .pn_st40, .pn_st47, .pn_st54 {
        stroke: #ccc;
      }

      .pn_st2, .pn_st5, .pn_st12, .pn_st25, .pn_st28, .pn_st31, .pn_st34, .pn_st36, .pn_st43, .pn_st51, .pn_st52 {
        stroke: #099;
      }

      .pn_st3, .pn_st4, .pn_st6, .pn_st7, .pn_st13, .pn_st17, .pn_st22, .pn_st27, .pn_st38, .pn_st53, .pn_st56 {
        stroke: #ff641a;
      }

      .pn_st3, .pn_st21, .pn_st24, .pn_st28, .pn_st30, .pn_st50 {
        stroke-dasharray: 0 0;
      }

      .pn_st4, .pn_st12, .pn_st14, .pn_st41, .pn_st54 {
        stroke-dasharray: 0 0;
      }

      .pn_st5, .pn_st37, .pn_st39, .pn_st46, .pn_st53 {
        stroke-dasharray: 5.4 2.1 0 0;
      }

      .pn_st6, .pn_st20, .pn_st49, .pn_st51 {
        stroke-dasharray: 0 0;
      }

      .pn_st7, .pn_st18, .pn_st19, .pn_st32, .pn_st36 {
        stroke-dasharray: 6.6 2.6 0 0;
      }

      .pn_st8, .pn_st10, .pn_st44, .pn_st48, .pn_st49, .pn_st50, .pn_st55 {
        stroke: #ff641a;
      }

      .pn_st8, .pn_st27, .pn_st40, .pn_st52 {
        stroke-dasharray: 6.7 2.7 0 0;
      }

      .pn_st9, .pn_st22, .pn_st43, .pn_st44 {
        stroke-dasharray: 5.3 2.1 0 0;
      }

      .pn_st11 {
        stroke-dasharray: 0 0;
      }

      .pn_st14, .pn_st15, .pn_st16, .pn_st18, .pn_st23, .pn_st30, .pn_st46 {
        stroke: #22ac38;
      }

      .pn_st15, .pn_st25, .pn_st35, .pn_st42, .pn_st56 {
        stroke-dasharray: 0 0;
      }

      .pn_st16, .pn_st29, .pn_st33, .pn_st34, .pn_st38, .pn_st55 {
        stroke-dasharray: 5.3 2.1 0 0;
      }

      .pn_st57 {
        fill: #ff641a;
      }

      .pn_st17, .pn_st26, .pn_st31, .pn_st48 {
        stroke-dasharray: 0 0;
      }

      .pn_st58 {
        fill: #ff641a;
      }

      .pn_st19, .pn_st24, .pn_st29, .pn_st37, .pn_st41, .pn_st42, .pn_st45 {
        stroke: #c39;
      }

      .pn_st59 {
        fill: #ccc;
      }

      .pn_st60 {
        isolation: isolate;
      }

      .pn_st61 {
        fill: #639;
      }

      .pn_st62 {
        fill: #0066bd;
      }

      .pn_st63 {
        fill: #fff;
      }

      .pn_st64 {
        fill: #099;
      }

      .pn_st65 {
        fill: #c39;
      }

      .pn_st66 {
        fill: #c39;
      }

      .pn_st67 {
        fill: #ffe0d1;
      }

      .pn_st47 {
        stroke-dasharray: 6.6 2.6 0 0;
      }

      .pn_st68 {
        display: none;
      }

      .pn_st69 {
        fill: #f5d6eb;
      }

      .pn_st70 {
        fill: #22ac38;
      }

      .pn_st71 {
        fill: #099;
      }

      .cursor_not_allowed{
        cursor: not-allowed;
      }
  </style>
